/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 150);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(157);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(168);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives__ = __webpack_require__(172);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getDirectiveInfoFromField", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shouldInclude", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flattenSelections", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getDirectiveNames", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hasDirectives", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fragments__ = __webpack_require__(174);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getFragmentQueryDocument", function() { return __WEBPACK_IMPORTED_MODULE_1__fragments__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getFromAST__ = __webpack_require__(85);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMutationDefinition", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "checkDocument", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getOperationDefinition", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getOperationDefinitionOrDie", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getOperationName", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getFragmentDefinitions", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getQueryDefinition", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getFragmentDefinition", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMainDefinition", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createFragmentMap", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getDefaultValues", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "variablesInOperation", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transform__ = __webpack_require__(175);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "removeDirectivesFromDocument", function() { return __WEBPACK_IMPORTED_MODULE_3__transform__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addTypenameToDocument", function() { return __WEBPACK_IMPORTED_MODULE_3__transform__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "removeConnectionDirectiveFromDocument", function() { return __WEBPACK_IMPORTED_MODULE_3__transform__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getDirectivesFromDocument", function() { return __WEBPACK_IMPORTED_MODULE_3__transform__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storeUtils__ = __webpack_require__(58);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isScalarValue", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNumberValue", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "valueToObjectRepresentation", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "storeKeyNameFromField", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getStoreKeyName", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "argumentsObjectFromField", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "resultKeyNameFromField", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isField", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isInlineFragment", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isIdValue", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toIdValue", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isJsonValue", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "valueFromNode", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_assign__ = __webpack_require__(86);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return __WEBPACK_IMPORTED_MODULE_5__util_assign__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_cloneDeep__ = __webpack_require__(87);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cloneDeep", function() { return __WEBPACK_IMPORTED_MODULE_6__util_cloneDeep__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_environment__ = __webpack_require__(59);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getEnv", function() { return __WEBPACK_IMPORTED_MODULE_7__util_environment__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEnv", function() { return __WEBPACK_IMPORTED_MODULE_7__util_environment__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isProduction", function() { return __WEBPACK_IMPORTED_MODULE_7__util_environment__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isDevelopment", function() { return __WEBPACK_IMPORTED_MODULE_7__util_environment__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isTest", function() { return __WEBPACK_IMPORTED_MODULE_7__util_environment__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__ = __webpack_require__(176);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tryFunctionOrLogError", function() { return __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "graphQLResultHasError", function() { return __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_isEqual__ = __webpack_require__(177);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_9__util_isEqual__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_maybeDeepFreeze__ = __webpack_require__(178);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "maybeDeepFreeze", function() { return __WEBPACK_IMPORTED_MODULE_10__util_maybeDeepFreeze__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_warnOnce__ = __webpack_require__(179);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "warnOnceInDevelopment", function() { return __WEBPACK_IMPORTED_MODULE_11__util_warnOnce__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_stripSymbols__ = __webpack_require__(180);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stripSymbols", function() { return __WEBPACK_IMPORTED_MODULE_12__util_stripSymbols__["a"]; });













//# sourceMappingURL=index.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports, __webpack_require__(0), __webpack_require__(7), __webpack_require__(56)) :
    typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'apollo-client'], factory) :
    (factory((global['react-apollo'] = {}),global.React,global.PropTypes,global.apolloClient));
}(this, (function (exports,React,PropTypes,apolloClient) { 'use strict';

    function getProps(element) {
        return element.props || element.attributes;
    }
    function isReactElement(element) {
        return !!element.type;
    }
    function isComponentClass(Comp) {
        return Comp.prototype && (Comp.prototype.render || Comp.prototype.isReactComponent);
    }
    function providesChildContext(instance) {
        return !!instance.getChildContext;
    }
    function walkTree(element, context, visitor) {
        if (Array.isArray(element)) {
            element.forEach(function (item) { return walkTree(item, context, visitor); });
            return;
        }
        if (!element) {
            return;
        }
        if (isReactElement(element)) {
            if (typeof element.type === 'function') {
                var Comp = element.type;
                var props = Object.assign({}, Comp.defaultProps, getProps(element));
                var childContext_1 = context;
                var child = void 0;
                if (isComponentClass(Comp)) {
                    var instance_1 = new Comp(props, context);
                    Object.defineProperty(instance_1, 'props', {
                        value: instance_1.props || props,
                    });
                    instance_1.context = instance_1.context || context;
                    instance_1.state = instance_1.state || null;
                    instance_1.setState = function (newState) {
                        if (typeof newState === 'function') {
                            newState = newState(instance_1.state, instance_1.props, instance_1.context);
                        }
                        instance_1.state = Object.assign({}, instance_1.state, newState);
                    };
                    if (Comp.getDerivedStateFromProps) {
                        var result = Comp.getDerivedStateFromProps(instance_1.props, instance_1.state);
                        if (result !== null) {
                            instance_1.state = Object.assign({}, instance_1.state, result);
                        }
                    }
                    else if (instance_1.UNSAFE_componentWillMount) {
                        instance_1.UNSAFE_componentWillMount();
                    }
                    else if (instance_1.componentWillMount) {
                        instance_1.componentWillMount();
                    }
                    if (providesChildContext(instance_1)) {
                        childContext_1 = Object.assign({}, context, instance_1.getChildContext());
                    }
                    if (visitor(element, instance_1, context, childContext_1) === false) {
                        return;
                    }
                    child = instance_1.render();
                }
                else {
                    if (visitor(element, null, context) === false) {
                        return;
                    }
                    child = Comp(props, context);
                }
                if (child) {
                    if (Array.isArray(child)) {
                        child.forEach(function (item) { return walkTree(item, childContext_1, visitor); });
                    }
                    else {
                        walkTree(child, childContext_1, visitor);
                    }
                }
            }
            else if (element.type._context || element.type.Consumer) {
                if (visitor(element, null, context) === false) {
                    return;
                }
                var child = void 0;
                if (element.type._context) {
                    element.type._context._currentValue = element.props.value;
                    child = element.props.children;
                }
                else {
                    child = element.props.children(element.type._currentValue);
                }
                if (child) {
                    if (Array.isArray(child)) {
                        child.forEach(function (item) { return walkTree(item, context, visitor); });
                    }
                    else {
                        walkTree(child, context, visitor);
                    }
                }
            }
            else {
                if (visitor(element, null, context) === false) {
                    return;
                }
                if (element.props && element.props.children) {
                    React.Children.forEach(element.props.children, function (child) {
                        if (child) {
                            walkTree(child, context, visitor);
                        }
                    });
                }
            }
        }
        else if (typeof element === 'string' || typeof element === 'number') {
            visitor(element, null, context);
        }
    }
    function hasFetchDataFunction(instance) {
        return typeof instance.fetchData === 'function';
    }
    function isPromise(promise) {
        return typeof promise.then === 'function';
    }
    function getPromisesFromTree(_a) {
        var rootElement = _a.rootElement, _b = _a.rootContext, rootContext = _b === void 0 ? {} : _b;
        var promises = [];
        walkTree(rootElement, rootContext, function (_, instance, context, childContext) {
            if (instance && hasFetchDataFunction(instance)) {
                var promise = instance.fetchData();
                if (isPromise(promise)) {
                    promises.push({ promise: promise, context: childContext || context, instance: instance });
                    return false;
                }
            }
        });
        return promises;
    }
    function getDataFromTree(rootElement, rootContext) {
        if (rootContext === void 0) { rootContext = {}; }
        var promises = getPromisesFromTree({ rootElement: rootElement, rootContext: rootContext });
        if (!promises.length) {
            return Promise.resolve();
        }
        var errors = [];
        var mappedPromises = promises.map(function (_a) {
            var promise = _a.promise, context = _a.context, instance = _a.instance;
            return promise
                .then(function (_) { return getDataFromTree(instance.render(), context); })
                .catch(function (e) { return errors.push(e); });
        });
        return Promise.all(mappedPromises).then(function (_) {
            if (errors.length > 0) {
                var error = errors.length === 1
                    ? errors[0]
                    : new Error(errors.length + " errors were thrown when executing your fetchData functions.");
                error.queryErrors = errors;
                throw error;
            }
        });
    }

    var invariant = __webpack_require__(1);
    var ApolloConsumer = function (props, context) {
        invariant(!!context.client, "Could not find \"client\" in the context of ApolloConsumer. Wrap the root component in an <ApolloProvider>");
        return props.children(context.client);
    };
    ApolloConsumer.contextTypes = {
        client: PropTypes.object.isRequired,
    };
    ApolloConsumer.propTypes = {
        children: PropTypes.func.isRequired,
    };

    var __extends = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var invariant$1 = __webpack_require__(1);
    var ApolloProvider = (function (_super) {
        __extends(ApolloProvider, _super);
        function ApolloProvider(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.operations = new Map();
            invariant$1(props.client, 'ApolloProvider was not passed a client instance. Make ' +
                'sure you pass in your client via the "client" prop.');
            if (!props.client.__operations_cache__) {
                props.client.__operations_cache__ = _this.operations;
            }
            return _this;
        }
        ApolloProvider.prototype.getChildContext = function () {
            return {
                client: this.props.client,
                operations: this.props.client.__operations_cache__,
            };
        };
        ApolloProvider.prototype.render = function () {
            return this.props.children;
        };
        ApolloProvider.propTypes = {
            client: PropTypes.object.isRequired,
            children: PropTypes.node.isRequired,
        };
        ApolloProvider.childContextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        return ApolloProvider;
    }(React.Component));

    var invariant$2 = __webpack_require__(1);
    var DocumentType;
    (function (DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })(DocumentType || (DocumentType = {}));
    var cache = new Map();
    function parser(document) {
        var cached = cache.get(document);
        if (cached)
            return cached;
        var variables, type, name;
        invariant$2(!!document && !!document.kind, "Argument of " + document + " passed to parser was not a valid GraphQL " +
            "DocumentNode. You may need to use 'graphql-tag' or another method " +
            "to convert your operation into a document");
        var fragments = document.definitions.filter(function (x) { return x.kind === 'FragmentDefinition'; });
        var queries = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'query'; });
        var mutations = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'mutation'; });
        var subscriptions = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'subscription'; });
        invariant$2(!fragments.length || (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
            "You must include a query, subscription or mutation as well");
        invariant$2(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
            (document + " had " + queries.length + " queries, " + subscriptions.length + " ") +
            ("subscriptions and " + mutations.length + " mutations. ") +
            "You can use 'compose' to join multiple operation types to a component");
        type = queries.length ? DocumentType.Query : DocumentType.Mutation;
        if (!queries.length && !mutations.length)
            type = DocumentType.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        invariant$2(definitions.length === 1, "react-apollo only supports one defintion per HOC. " + document + " had " +
            (definitions.length + " definitions. ") +
            "You can use 'compose' to join multiple operation types to a component");
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') {
            name = definition.name.value;
        }
        else {
            name = 'data';
        }
        var payload = { name: name, type: type, variables: variables };
        cache.set(document, payload);
        return payload;
    }

    var __extends$1 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var shallowEqual = __webpack_require__(38);
    var invariant$3 = __webpack_require__(1);
    function compact(obj) {
        return Object.keys(obj).reduce(function (acc, key) {
            if (obj[key] !== undefined) {
                acc[key] = obj[key];
            }
            return acc;
        }, {});
    }
    function observableQueryFields(observable) {
        var fields = {
            variables: observable.variables,
            refetch: observable.refetch.bind(observable),
            fetchMore: observable.fetchMore.bind(observable),
            updateQuery: observable.updateQuery.bind(observable),
            startPolling: observable.startPolling.bind(observable),
            stopPolling: observable.stopPolling.bind(observable),
            subscribeToMore: observable.subscribeToMore.bind(observable),
        };
        return fields;
    }
    var Query = (function (_super) {
        __extends$1(Query, _super);
        function Query(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.previousData = {};
            _this.hasMounted = false;
            _this.startQuerySubscription = function () {
                if (_this.querySubscription)
                    return;
                var current = _this.getQueryResult();
                _this.querySubscription = _this.queryObservable.subscribe({
                    next: function () {
                        if (current && current.networkStatus === 7) {
                            current = undefined;
                            return;
                        }
                        _this.updateCurrentData();
                    },
                    error: function (error) {
                        _this.resubscribeToQuery();
                        if (!error.hasOwnProperty('graphQLErrors'))
                            throw error;
                        _this.updateCurrentData();
                    },
                });
            };
            _this.removeQuerySubscription = function () {
                if (_this.querySubscription) {
                    _this.querySubscription.unsubscribe();
                    delete _this.querySubscription;
                }
            };
            _this.updateCurrentData = function () {
                var _a = _this.props, onCompleted = _a.onCompleted, onError = _a.onError;
                if (onCompleted || onError) {
                    var currentResult = _this.queryObservable.currentResult();
                    var loading = currentResult.loading, error = currentResult.error, data = currentResult.data;
                    if (onCompleted && !loading && !error) {
                        onCompleted(data);
                    }
                    else if (onError && !loading && error) {
                        onError(error);
                    }
                }
                if (_this.hasMounted)
                    _this.forceUpdate();
            };
            _this.getQueryResult = function () {
                var data = { data: Object.create(null) };
                Object.assign(data, observableQueryFields(_this.queryObservable));
                var currentResult = _this.queryObservable.currentResult();
                var loading = currentResult.loading, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error;
                if (errors && errors.length > 0) {
                    error = new apolloClient.ApolloError({ graphQLErrors: errors });
                }
                Object.assign(data, { loading: loading, networkStatus: networkStatus, error: error });
                if (loading) {
                    Object.assign(data.data, _this.previousData, currentResult.data);
                }
                else if (error) {
                    Object.assign(data, {
                        data: (_this.queryObservable.getLastResult() || {}).data,
                    });
                }
                else {
                    Object.assign(data.data, currentResult.data);
                    _this.previousData = currentResult.data;
                }
                if (!_this.querySubscription) {
                    var oldRefetch_1 = data.refetch;
                    data.refetch = function (args) {
                        if (_this.querySubscription) {
                            return oldRefetch_1(args);
                        }
                        else {
                            return new Promise(function (r, f) {
                                _this.refetcherQueue = { resolve: r, reject: f, args: args };
                            });
                        }
                    };
                }
                data.client = _this.client;
                return data;
            };
            _this.client = props.client || context.client;
            invariant$3(!!_this.client, "Could not find \"client\" in the context of Query or as passed props. Wrap the root component in an <ApolloProvider>");
            _this.initializeQueryObservable(props);
            return _this;
        }
        Query.prototype.fetchData = function () {
            if (this.props.skip)
                return false;
            var _a = this.props, children = _a.children, ssr = _a.ssr, displayName = _a.displayName, skip = _a.skip, client = _a.client, onCompleted = _a.onCompleted, onError = _a.onError, opts = __rest(_a, ["children", "ssr", "displayName", "skip", "client", "onCompleted", "onError"]);
            var fetchPolicy = opts.fetchPolicy;
            if (ssr === false)
                return false;
            if (fetchPolicy === 'network-only' || fetchPolicy === 'cache-and-network') {
                fetchPolicy = 'cache-first';
            }
            var observable = this.client.watchQuery(__assign({}, opts, { fetchPolicy: fetchPolicy }));
            var result = this.queryObservable.currentResult();
            return result.loading ? observable.result() : false;
        };
        Query.prototype.componentDidMount = function () {
            this.hasMounted = true;
            if (this.props.skip)
                return;
            this.startQuerySubscription();
            if (this.refetcherQueue) {
                var _a = this.refetcherQueue, args = _a.args, resolve = _a.resolve, reject = _a.reject;
                this.queryObservable.refetch(args)
                    .then(resolve)
                    .catch(reject);
            }
        };
        Query.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (nextProps.skip && !this.props.skip) {
                this.removeQuerySubscription();
                return;
            }
            var client = nextProps.client;
            if (shallowEqual(this.props, nextProps) &&
                (this.client === client || this.client === nextContext.client)) {
                return;
            }
            if (this.client !== client && this.client !== nextContext.client) {
                if (client) {
                    this.client = client;
                }
                else {
                    this.client = nextContext.client;
                }
                this.removeQuerySubscription();
                this.queryObservable = null;
                this.previousData = {};
                this.updateQuery(nextProps);
            }
            if (this.props.query !== nextProps.query) {
                this.removeQuerySubscription();
            }
            this.updateQuery(nextProps);
            if (nextProps.skip)
                return;
            this.startQuerySubscription();
        };
        Query.prototype.componentWillUnmount = function () {
            this.removeQuerySubscription();
            this.hasMounted = false;
        };
        Query.prototype.render = function () {
            var children = this.props.children;
            var queryResult = this.getQueryResult();
            return children(queryResult);
        };
        Query.prototype.extractOptsFromProps = function (props) {
            var variables = props.variables, pollInterval = props.pollInterval, fetchPolicy = props.fetchPolicy, errorPolicy = props.errorPolicy, notifyOnNetworkStatusChange = props.notifyOnNetworkStatusChange, query = props.query, _a = props.displayName, displayName = _a === void 0 ? 'Query' : _a, _b = props.context, context = _b === void 0 ? {} : _b;
            this.operation = parser(query);
            invariant$3(this.operation.type === DocumentType.Query, "The <Query /> component requires a graphql query, but got a " + (this.operation.type === DocumentType.Mutation ? 'mutation' : 'subscription') + ".");
            return compact({
                variables: variables,
                pollInterval: pollInterval,
                query: query,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy,
                notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
                metadata: { reactComponent: { displayName: displayName } },
                context: context,
            });
        };
        Query.prototype.initializeQueryObservable = function (props) {
            var opts = this.extractOptsFromProps(props);
            if (this.context.operations) {
                this.context.operations.set(this.operation.name, {
                    query: opts.query,
                    variables: opts.variables,
                });
            }
            this.queryObservable = this.client.watchQuery(opts);
        };
        Query.prototype.updateQuery = function (props) {
            if (!this.queryObservable)
                this.initializeQueryObservable(props);
            this.queryObservable.setOptions(this.extractOptsFromProps(props))
                .catch(function () { return null; });
        };
        Query.prototype.resubscribeToQuery = function () {
            this.removeQuerySubscription();
            var lastError = this.queryObservable.getLastError();
            var lastResult = this.queryObservable.getLastResult();
            this.queryObservable.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.queryObservable, { lastError: lastError, lastResult: lastResult });
        };
        Query.contextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        Query.propTypes = {
            children: PropTypes.func.isRequired,
            fetchPolicy: PropTypes.string,
            notifyOnNetworkStatusChange: PropTypes.bool,
            onCompleted: PropTypes.func,
            onError: PropTypes.func,
            pollInterval: PropTypes.number,
            query: PropTypes.object.isRequired,
            variables: PropTypes.object,
            ssr: PropTypes.bool,
        };
        return Query;
    }(React.Component));

    var __extends$2 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$1 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var invariant$4 = __webpack_require__(1);
    var shallowEqual$1 = __webpack_require__(38);
    var initialState = {
        loading: false,
        called: false,
        error: undefined,
        data: undefined,
    };
    var Mutation = (function (_super) {
        __extends$2(Mutation, _super);
        function Mutation(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.hasMounted = false;
            _this.runMutation = function (options) {
                if (options === void 0) { options = {}; }
                _this.onStartMutation();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(options)
                    .then(function (response) {
                    _this.onCompletedMutation(response, mutationId);
                    return response;
                })
                    .catch(function (e) {
                    _this.onMutationError(e, mutationId);
                    if (!_this.props.onError)
                        throw e;
                });
            };
            _this.mutate = function (options) {
                var _a = _this.props, mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, context = _b === void 0 ? {} : _b;
                var refetchQueries = options.refetchQueries || _this.props.refetchQueries;
                if (refetchQueries && refetchQueries.length && Array.isArray(refetchQueries)) {
                    refetchQueries = refetchQueries.map(function (x) {
                        if (typeof x === 'string' && _this.context.operations)
                            return _this.context.operations.get(x) || x;
                        return x;
                    });
                    delete options.refetchQueries;
                }
                return _this.client.mutate(__assign$1({ mutation: mutation,
                    variables: variables,
                    optimisticResponse: optimisticResponse,
                    refetchQueries: refetchQueries,
                    update: update,
                    context: context }, options));
            };
            _this.onStartMutation = function () {
                if (!_this.state.loading && !_this.props.ignoreResults) {
                    _this.setState({
                        loading: true,
                        error: undefined,
                        data: undefined,
                        called: true,
                    });
                }
            };
            _this.onCompletedMutation = function (response, mutationId) {
                if (_this.hasMounted === false) {
                    return;
                }
                var _a = _this.props, onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
                var data = response.data;
                var callOncomplete = function () { return (onCompleted ? onCompleted(data) : null); };
                if (_this.isMostRecentMutation(mutationId) && !ignoreResults) {
                    _this.setState({ loading: false, data: data }, callOncomplete);
                }
                else {
                    callOncomplete();
                }
            };
            _this.onMutationError = function (error, mutationId) {
                if (_this.hasMounted === false) {
                    return;
                }
                var onError = _this.props.onError;
                var callOnError = function () { return (onError ? onError(error) : null); };
                if (_this.isMostRecentMutation(mutationId)) {
                    _this.setState({ loading: false, error: error }, callOnError);
                }
                else {
                    callOnError();
                }
            };
            _this.generateNewMutationId = function () {
                _this.mostRecentMutationId = _this.mostRecentMutationId + 1;
                return _this.mostRecentMutationId;
            };
            _this.isMostRecentMutation = function (mutationId) {
                return _this.mostRecentMutationId === mutationId;
            };
            _this.verifyDocumentIsMutation = function (mutation) {
                var operation = parser(mutation);
                invariant$4(operation.type === DocumentType.Mutation, "The <Mutation /> component requires a graphql mutation, but got a " + (operation.type === DocumentType.Query ? 'query' : 'subscription') + ".");
            };
            _this.client = props.client || context.client;
            invariant$4(!!_this.client, 'Could not find "client" in the context or props of Mutation. Wrap ' +
                'the root component in an <ApolloProvider>, or pass an ApolloClient ' +
                'instance in via props.');
            _this.verifyDocumentIsMutation(props.mutation);
            _this.mostRecentMutationId = 0;
            _this.state = initialState;
            return _this;
        }
        Mutation.prototype.componentDidMount = function () {
            this.hasMounted = true;
        };
        Mutation.prototype.componentWillUnmount = function () {
            this.hasMounted = false;
        };
        Mutation.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            var client = nextProps.client;
            if (shallowEqual$1(this.props, nextProps) &&
                (this.client === client || this.client === nextContext.client)) {
                return;
            }
            if (this.props.mutation !== nextProps.mutation) {
                this.verifyDocumentIsMutation(nextProps.mutation);
            }
            if (this.client !== client && this.client !== nextContext.client) {
                this.client = client || nextContext.client;
                this.setState(initialState);
            }
        };
        Mutation.prototype.render = function () {
            var children = this.props.children;
            var _a = this.state, loading = _a.loading, data = _a.data, error = _a.error, called = _a.called;
            var result = {
                called: called,
                loading: loading,
                data: data,
                error: error,
                client: this.client,
            };
            return children(this.runMutation, result);
        };
        Mutation.contextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        Mutation.propTypes = {
            mutation: PropTypes.object.isRequired,
            variables: PropTypes.object,
            optimisticResponse: PropTypes.object,
            refetchQueries: PropTypes.oneOfType([
                PropTypes.arrayOf(PropTypes.string),
                PropTypes.arrayOf(PropTypes.object),
                PropTypes.func,
            ]),
            update: PropTypes.func,
            children: PropTypes.func.isRequired,
            onCompleted: PropTypes.func,
            onError: PropTypes.func,
        };
        return Mutation;
    }(React.Component));

    var __extends$3 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var shallowEqual$2 = __webpack_require__(38);
    var invariant$5 = __webpack_require__(1);
    var Subscription = (function (_super) {
        __extends$3(Subscription, _super);
        function Subscription(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.initialize = function (props) {
                if (_this.queryObservable)
                    return;
                _this.queryObservable = _this.client.subscribe({
                    query: props.subscription,
                    variables: props.variables,
                });
            };
            _this.startSubscription = function () {
                if (_this.querySubscription)
                    return;
                _this.querySubscription = _this.queryObservable.subscribe({
                    next: _this.updateCurrentData,
                    error: _this.updateError,
                });
            };
            _this.getInitialState = function () { return ({
                loading: true,
                error: undefined,
                data: undefined,
            }); };
            _this.updateCurrentData = function (result) {
                _this.setState({
                    data: result.data,
                    loading: false,
                    error: undefined,
                });
            };
            _this.updateError = function (error) {
                _this.setState({
                    error: error,
                    loading: false,
                });
            };
            _this.endSubscription = function () {
                if (_this.querySubscription) {
                    _this.querySubscription.unsubscribe();
                    delete _this.querySubscription;
                }
            };
            invariant$5(!!context.client, "Could not find \"client\" in the context of Subscription. Wrap the root component in an <ApolloProvider>");
            _this.client = context.client;
            _this.initialize(props);
            _this.state = _this.getInitialState();
            return _this;
        }
        Subscription.prototype.componentDidMount = function () {
            this.startSubscription();
        };
        Subscription.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (shallowEqual$2(this.props.variables, nextProps.variables) &&
                this.client === nextContext.client &&
                this.props.subscription === nextProps.subscription) {
                return;
            }
            var shouldResubscribe = nextProps.shouldResubscribe;
            if (typeof shouldResubscribe === 'function') {
                shouldResubscribe = !!shouldResubscribe(this.props, nextProps);
            }
            var shouldNotResubscribe = shouldResubscribe === false;
            if (this.client !== nextContext.client) {
                this.client = nextContext.client;
            }
            if (!shouldNotResubscribe) {
                this.endSubscription();
                delete this.queryObservable;
                this.initialize(nextProps);
                this.startSubscription();
                this.setState(this.getInitialState());
                return;
            }
            this.initialize(nextProps);
            this.startSubscription();
        };
        Subscription.prototype.componentWillUnmount = function () {
            this.endSubscription();
        };
        Subscription.prototype.render = function () {
            var result = Object.assign({}, this.state, {
                variables: this.props.variables,
            });
            return this.props.children(result);
        };
        Subscription.contextTypes = {
            client: PropTypes.object.isRequired,
        };
        Subscription.propTypes = {
            subscription: PropTypes.object.isRequired,
            variables: PropTypes.object,
            children: PropTypes.func.isRequired,
            shouldResubscribe: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
        };
        return Subscription;
    }(React.Component));

    var __extends$4 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var invariant$6 = __webpack_require__(1);
    var defaultMapPropsToOptions = function () { return ({}); };
    var defaultMapPropsToSkip = function () { return false; };
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    function calculateVariablesFromProps(operation, props, graphQLDisplayName, wrapperName) {
        var variables = {};
        for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
            var _b = _a[_i], variable = _b.variable, type = _b.type;
            if (!variable.name || !variable.name.value)
                continue;
            var variableName = variable.name.value;
            var variableProp = props[variableName];
            if (typeof variableProp !== 'undefined') {
                variables[variableName] = variableProp;
                continue;
            }
            if (type.kind !== 'NonNullType') {
                variables[variableName] = null;
                continue;
            }
            if (operation.type === DocumentType.Mutation)
                return;
            invariant$6(typeof variableProp !== 'undefined', "The operation '" + operation.name + "' wrapping '" + wrapperName + "' " +
                ("is expecting a variable: '" + variable.name.value + "' but it was not found in the props ") +
                ("passed to '" + graphQLDisplayName + "'"));
        }
        return variables;
    }
    var GraphQLBase = (function (_super) {
        __extends$4(GraphQLBase, _super);
        function GraphQLBase(props) {
            var _this = _super.call(this, props) || this;
            _this.withRef = false;
            _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
            return _this;
        }
        GraphQLBase.prototype.getWrappedInstance = function () {
            invariant$6(this.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
            return this.wrappedInstance;
        };
        GraphQLBase.prototype.setWrappedInstance = function (ref) {
            this.wrappedInstance = ref;
        };
        return GraphQLBase;
    }(React.Component));

    var __extends$5 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$2 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var hoistNonReactStatics = __webpack_require__(27);
    function query(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        var mapPropsToSkip = skip;
        if (typeof mapPropsToSkip !== 'function')
            mapPropsToSkip = function () { return skip; };
        var lastResultProps;
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$5(GraphQL, _super);
                function GraphQL() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                GraphQL.prototype.render = function () {
                    var _this = this;
                    var props = this.props;
                    var shouldSkip = mapPropsToSkip(props);
                    var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
                    if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Query, __assign$2({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, query: document, warnUnhandledError: true }), function (_a) {
                        var _ = _a.client, data = _a.data, r = __rest$1(_a, ["client", "data"]);
                        var _b, _c;
                        if (operationOptions.withRef) {
                            _this.withRef = true;
                            props = Object.assign({}, props, {
                                ref: _this.setWrappedInstance,
                            });
                        }
                        if (shouldSkip)
                            return React.createElement(WrappedComponent, __assign$2({}, props));
                        var result = Object.assign(r, data || {});
                        var name = operationOptions.name || 'data';
                        var childProps = (_b = {}, _b[name] = result, _b);
                        if (operationOptions.props) {
                            var newResult = (_c = {},
                                _c[name] = result,
                                _c.ownProps = props,
                                _c);
                            lastResultProps = operationOptions.props(newResult, lastResultProps);
                            childProps = lastResultProps;
                        }
                        return React.createElement(WrappedComponent, __assign$2({}, props, childProps));
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics(GraphQL, WrappedComponent, {});
        };
    }

    var __extends$6 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$3 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var hoistNonReactStatics$1 = __webpack_require__(27);
    function mutation(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.alias, alias = _b === void 0 ? 'Apollo' : _b;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$6(GraphQL, _super);
                function GraphQL() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                GraphQL.prototype.render = function () {
                    var props = this.props;
                    var opts = mapPropsToOptions(props);
                    if (operationOptions.withRef) {
                        this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: this.setWrappedInstance,
                        });
                    }
                    if (!opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Mutation, __assign$3({}, opts, { mutation: document, ignoreResults: true }), function (mutate, _result) {
                        var _a, _b;
                        var name = operationOptions.name || 'mutate';
                        var childProps = (_a = {}, _a[name] = mutate, _a);
                        if (operationOptions.props) {
                            var newResult = (_b = {},
                                _b[name] = mutate,
                                _b.ownProps = props,
                                _b);
                            childProps = operationOptions.props(newResult);
                        }
                        return React.createElement(WrappedComponent, __assign$3({}, props, childProps));
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics$1(GraphQL, WrappedComponent, {});
        };
    }

    var __extends$7 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$4 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest$2 = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var hoistNonReactStatics$2 = __webpack_require__(27);
    function subscribe(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c, shouldResubscribe = operationOptions.shouldResubscribe;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        var mapPropsToSkip = skip;
        if (typeof mapPropsToSkip !== 'function')
            mapPropsToSkip = function () { return skip; };
        var lastResultProps;
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$7(GraphQL, _super);
                function GraphQL(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = { resubscribe: false };
                    return _this;
                }
                GraphQL.prototype.componentWillReceiveProps = function (nextProps) {
                    if (!shouldResubscribe)
                        return;
                    this.setState({
                        resubscribe: shouldResubscribe(this.props, nextProps),
                    });
                };
                GraphQL.prototype.render = function () {
                    var _this = this;
                    var props = this.props;
                    var shouldSkip = mapPropsToSkip(props);
                    var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
                    if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Subscription, __assign$4({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, subscription: document, shouldResubscribe: this.state.resubscribe }), function (_a) {
                        var data = _a.data, r = __rest$2(_a, ["data"]);
                        var _b, _c;
                        if (operationOptions.withRef) {
                            _this.withRef = true;
                            props = Object.assign({}, props, {
                                ref: _this.setWrappedInstance,
                            });
                        }
                        if (shouldSkip)
                            return React.createElement(WrappedComponent, __assign$4({}, props));
                        var result = Object.assign(r, data || {});
                        var name = operationOptions.name || 'data';
                        var childProps = (_b = {}, _b[name] = result, _b);
                        if (operationOptions.props) {
                            var newResult = (_c = {},
                                _c[name] = result,
                                _c.ownProps = props,
                                _c);
                            lastResultProps = operationOptions.props(newResult, lastResultProps);
                            childProps = lastResultProps;
                        }
                        return React.createElement(WrappedComponent, __assign$4({}, props, childProps));
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics$2(GraphQL, WrappedComponent, {});
        };
    }

    function graphql(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        switch (parser(document).type) {
            case DocumentType.Mutation:
                return mutation(document, operationOptions);
            case DocumentType.Subscription:
                return subscribe(document, operationOptions);
            case DocumentType.Query:
            default:
                return query(document, operationOptions);
        }
    }

    var __extends$8 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$5 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var invariant$7 = __webpack_require__(1);
    var hoistNonReactStatics$3 = __webpack_require__(27);
    function getDisplayName$1(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    function withApollo(WrappedComponent, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var withDisplayName = "withApollo(" + getDisplayName$1(WrappedComponent) + ")";
        var WithApollo = (function (_super) {
            __extends$8(WithApollo, _super);
            function WithApollo(props) {
                var _this = _super.call(this, props) || this;
                _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
                return _this;
            }
            WithApollo.prototype.getWrappedInstance = function () {
                invariant$7(operationOptions.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
                return this.wrappedInstance;
            };
            WithApollo.prototype.setWrappedInstance = function (ref) {
                this.wrappedInstance = ref;
            };
            WithApollo.prototype.render = function () {
                var _this = this;
                return (React.createElement(ApolloConsumer, null, function (client) {
                    var props = Object.assign({}, _this.props, {
                        client: client,
                        ref: operationOptions.withRef ? _this.setWrappedInstance : undefined,
                    });
                    return React.createElement(WrappedComponent, __assign$5({}, props));
                }));
            };
            WithApollo.displayName = withDisplayName;
            WithApollo.WrappedComponent = WrappedComponent;
            return WithApollo;
        }(React.Component));
        return hoistNonReactStatics$3(WithApollo, WrappedComponent, {});
    }

    var compose = __webpack_require__(196);

    exports.compose = compose;
    exports.getDataFromTree = getDataFromTree;
    exports.ApolloConsumer = ApolloConsumer;
    exports.ApolloProvider = ApolloProvider;
    exports.Query = Query;
    exports.Mutation = Mutation;
    exports.Subscription = Subscription;
    exports.graphql = graphql;
    exports.withApollo = withApollo;
    exports.walkTree = walkTree;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=react-apollo.browser.umd.js.map


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(170)();
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var parser = __webpack_require__(382);

var parse = parser.parse;

// Strip insignificant whitespace
// Note that this could do a lot more, such as reorder fields etc.
function normalize(string) {
  return string.replace(/[\s,]+/g, ' ').trim();
}

// A map docString -> graphql document
var docCache = {};

// A map fragmentName -> [normalized source]
var fragmentSourceMap = {};

function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}

// For testing.
function resetCaches() {
  docCache = {};
  fragmentSourceMap = {};
}

// Take a unstripped parsed document (query/mutation or even fragment), and
// check all fragment definitions, checking for name->source uniqueness.
// We also want to make sure only unique fragments exist in the document.
var printFragmentWarnings = true;
function processFragments(ast) {
  var astFragmentMap = {};
  var definitions = [];

  for (var i = 0; i < ast.definitions.length; i++) {
    var fragmentDefinition = ast.definitions[i];

    if (fragmentDefinition.kind === 'FragmentDefinition') {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);

      // We know something about this fragment
      if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {

        // this is a problem because the app developer is trying to register another fragment with
        // the same name as one previously registered. So, we tell them about it.
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
            + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
            + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }

        fragmentSourceMap[fragmentName][sourceKey] = true;

      } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
        fragmentSourceMap[fragmentName] = {};
        fragmentSourceMap[fragmentName][sourceKey] = true;
      }

      if (!astFragmentMap[sourceKey]) {
        astFragmentMap[sourceKey] = true;
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  }

  ast.definitions = definitions;
  return ast;
}

function disableFragmentWarnings() {
  printFragmentWarnings = false;
}

function stripLoc(doc, removeLocAtThisLevel) {
  var docType = Object.prototype.toString.call(doc);

  if (docType === '[object Array]') {
    return doc.map(function (d) {
      return stripLoc(d, removeLocAtThisLevel);
    });
  }

  if (docType !== '[object Object]') {
    throw new Error('Unexpected input.');
  }

  // We don't want to remove the root loc field so we can use it
  // for fragment substitution (see below)
  if (removeLocAtThisLevel && doc.loc) {
    delete doc.loc;
  }

  // https://github.com/apollographql/graphql-tag/issues/40
  if (doc.loc) {
    delete doc.loc.startToken;
    delete doc.loc.endToken;
  }

  var keys = Object.keys(doc);
  var key;
  var value;
  var valueType;

  for (key in keys) {
    if (keys.hasOwnProperty(key)) {
      value = doc[keys[key]];
      valueType = Object.prototype.toString.call(value);

      if (valueType === '[object Object]' || valueType === '[object Array]') {
        doc[keys[key]] = stripLoc(value, true);
      }
    }
  }

  return doc;
}

var experimentalFragmentVariables = false;
function parseDocument(doc) {
  var cacheKey = normalize(doc);

  if (docCache[cacheKey]) {
    return docCache[cacheKey];
  }

  var parsed = parse(doc, { experimentalFragmentVariables: experimentalFragmentVariables });
  if (!parsed || parsed.kind !== 'Document') {
    throw new Error('Not a valid GraphQL document.');
  }

  // check that all "new" fragments inside the documents are consistent with
  // existing fragments of the same name
  parsed = processFragments(parsed);
  parsed = stripLoc(parsed, false);
  docCache[cacheKey] = parsed;

  return parsed;
}

function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}

function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}

// XXX This should eventually disallow arbitrary string interpolation, like Relay does
function gql(/* arguments */) {
  var args = Array.prototype.slice.call(arguments);

  var literals = args[0];

  // We always get literals[0] and then matching post literals for each arg given
  var result = (typeof(literals) === "string") ? literals : literals[0];

  for (var i = 1; i < args.length; i++) {
    if (args[i] && args[i].kind && args[i].kind === 'Document') {
      result += args[i].loc.source.body;
    } else {
      result += args[i];
    }

    result += literals[i];
  }

  return parseDocument(result);
}

// Support typescript, which isn't as nice as Babel about default exports
gql.default = gql;
gql.resetCaches = resetCaches;
gql.disableFragmentWarnings = disableFragmentWarnings;
gql.enableExperimentalFragmentVariables = enableExperimentalFragmentVariables;
gql.disableExperimentalFragmentVariables = disableExperimentalFragmentVariables;

module.exports = gql;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(139);
var isBuffer = __webpack_require__(403);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link__ = __webpack_require__(181);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "from", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "split", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ApolloLink", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "execute", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkUtils__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createOperation", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "makePromise", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toPromise", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fromPromise", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fromError", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zen_observable_ts__ = __webpack_require__(60);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Observable", function() { return __WEBPACK_IMPORTED_MODULE_2_zen_observable_ts__["a"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(94);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(28),
    getRawTag = __webpack_require__(203),
    objectToString = __webpack_require__(204);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(208),
    getValue = __webpack_require__(211);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(359);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_11__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(380);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = print;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visitor__ = __webpack_require__(171);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
function print(ast) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__visitor__["a" /* visit */])(ast, { leave: printDocASTReducer });
}

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },

  // Document

  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },

  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet;
    // Anonymous queries with no directives or variable definitions can use
    // the query short form.
    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },


  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue;
    return variable + ': ' + type + wrap(' = ', defaultValue);
  },

  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },

  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
  },

  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },

  // Fragments

  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },

  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },

  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      'fragment ' + name + wrap('(', join(variableDefinitions, ', '), ')') + ' ' + ('on ' + typeCondition + ' ' + wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },

  // Value

  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },

  // Directive

  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },

  // Type

  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },

  // Type System Definitions

  SchemaDefinition: function SchemaDefinition(_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  },

  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },

  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),

  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),

  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + wrap('(', join(args, ', '), ')') + ': ' + type + wrap(' ', join(directives, ' '));
  }),

  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),

  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
  }),

  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),

  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),

  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),

  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),

  ScalarTypeExtension: function ScalarTypeExtension(_ref31) {
    var name = _ref31.name,
        directives = _ref31.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },

  ObjectTypeExtension: function ObjectTypeExtension(_ref32) {
    var name = _ref32.name,
        interfaces = _ref32.interfaces,
        directives = _ref32.directives,
        fields = _ref32.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },

  InterfaceTypeExtension: function InterfaceTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives,
        fields = _ref33.fields;
    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
  },

  UnionTypeExtension: function UnionTypeExtension(_ref34) {
    var name = _ref34.name,
        directives = _ref34.directives,
        types = _ref34.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },

  EnumTypeExtension: function EnumTypeExtension(_ref35) {
    var name = _ref35.name,
        directives = _ref35.directives,
        values = _ref35.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },

  InputObjectTypeExtension: function InputObjectTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        fields = _ref36.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  },

  DirectiveDefinition: addDescription(function (_ref37) {
    var name = _ref37.name,
        args = _ref37.arguments,
        locations = _ref37.locations;
    return 'directive @' + name + wrap('(', join(args, ', '), ')') + ' on ' + join(locations, ' | ');
  })
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}

/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */
function join(maybeArray, separator) {
  return maybeArray ? maybeArray.filter(function (x) {
    return x;
  }).join(separator || '') : '';
}

/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */
function block(array) {
  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
}

/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */
function wrap(start, maybeString, end) {
  return maybeString ? start + maybeString + (end || '') : '';
}

function indent(maybeString) {
  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}

/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */
function printBlockString(value, isDescription) {
  var escaped = value.replace(/"""/g, '\\"""');
  return (value[0] === ' ' || value[0] === '\t') && value.indexOf('\n') === -1 ? '"""' + escaped.replace(/"$/, '"\n') + '"""' : '"""\n' + (isDescription ? escaped : indent(escaped)) + '\n"""';
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)(module)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(15);

var ReactCurrentOwner = __webpack_require__(106);

var warning = __webpack_require__(44);
var canDefineProperty = __webpack_require__(105);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(107);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(360);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(363);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(53);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(33);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NetworkStatus; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isNetworkRequestInFlight;
/**
 * The current status of a query’s execution in our system.
 */
var NetworkStatus;
(function (NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
/**
 * Returns true if there is currently a network request in flight according to a given network
 * status.
 */
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(13);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dropdown=function(_Component){_inherits(Dropdown,_Component);function Dropdown(props){_classCallCheck(this,Dropdown);var _this=_possibleConstructorReturn(this,(Dropdown.__proto__||Object.getPrototypeOf(Dropdown)).call(this,props));console.log('DROPDOWN STATE');_this.state={selection:props.options&&props.options.length?props.options[0].value:'',hide:true};return _this;}// componentDidMount() {
// 	if (this.state.selection && this.state.selection.length > 0 && this.props.onSelect)
// 		this.props.onSelect(this.state.selection)
// }
_createClass(Dropdown,[{key:'render',value:function render(){var _this2=this;var _props=this.props,label=_props.label,onSelect=_props.onSelect,options=_props.options,top=_props.top,hidden=_props.hidden,children=_props.children;var _state=this.state,selection=_state.selection,hide=_state.hide;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.container)},label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.label,onClick:function onClick(){return _this2.setState({hide:!hide});}},label),children,(!hide||hidden===false)&&options&&options.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.dropdown,top&&__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.top)},options.map(function(_ref,key){var label=_ref.label,value=_ref.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.option,selection===value&&__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.active),key:key,onClick:function onClick(){_this2.setState({selection:value,hide:true});onSelect(value);}},label);})));}}]);return Dropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(21);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(14);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(233);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(250);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxSection = undefined;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssModules = __webpack_require__(4);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _styles = __webpack_require__(16);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoxSection = exports.BoxSection = function BoxSection(_ref) {
  var children = _ref.children,
      title = _ref.title;

  return _react2.default.createElement(
    'div',
    { styleName: 'box-section' },
    title && _react2.default.createElement(
      'h2',
      null,
      title
    ),
    children
  );
};

exports.default = (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true })(BoxSection);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssModules = __webpack_require__(4);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _styles = __webpack_require__(17);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = exports.Button = function Button(_ref) {
  var children = _ref.children,
      noPadding = _ref.noPadding,
      center = _ref.center,
      noMaxWidth = _ref.noMaxWidth,
      inline = _ref.inline;

  return _react2.default.createElement(
    'div',
    { styleName: (0, _classnames2.default)("box", noPadding && 'no-padding', center && 'center', noMaxWidth && 'no-max-width', inline && 'inline') },
    children
  );
};

exports.default = (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true })(Button);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Button = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssModules = __webpack_require__(4);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _styles = __webpack_require__(18);

var _styles2 = _interopRequireDefault(_styles);

var _reactRouterDom = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
//import Loader from 'components/Loader'


var Button = function Button(_ref) {
	var color = _ref.color,
	    children = _ref.children,
	    loading = _ref.loading,
	    inline = _ref.inline,
	    fullWidth = _ref.fullWidth,
	    outline = _ref.outline,
	    small = _ref.small,
	    large = _ref.large,
	    isLink = _ref.isLink,
	    isAnchor = _ref.isAnchor,
	    rest = _objectWithoutProperties(_ref, ['color', 'children', 'loading', 'inline', 'fullWidth', 'outline', 'small', 'large', 'isLink', 'isAnchor']);

	var ButtonElement = function (isLink, isAnchor) {
		if (isLink) return isLink;
		if (isAnchor) return 'a';
		return 'button';
	}(isLink, isAnchor);

	return _react2.default.createElement(
		ButtonElement,
		_extends({
			type: 'button'
		}, rest, {
			styleName: (0, _classnames2.default)("btn", !fullWidth && 'auto', color, inline && 'inline', outline && 'outline', small && 'small', large && 'large') }),
		_react2.default.createElement(
			'div',
			{ styleName: 'content' },
			loading && _react2.default.createElement('div', { styleName: 'loader' }),
			children
		)
	);
};

exports.Button = Button;
exports.default = (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true })(Button);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectField = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssModules = __webpack_require__(4);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _styles = __webpack_require__(19);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SelectField = function SelectField(_ref) {
  var input = _ref.input,
      values = _ref.values,
      children = _ref.children,
      label = _ref.label,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      active = _ref$meta.active,
      rest = _objectWithoutProperties(_ref, ['input', 'values', 'children', 'label', 'meta']);

  var hasError = touched && error && !active;
  return _react2.default.createElement(
    'div',
    { styleName: (0, _classnames2.default)('field', hasError && ' has-error') },
    label && _react2.default.createElement(
      'label',
      { styleName: 'field_label' },
      label
    ),
    _react2.default.createElement(
      'select',
      _extends({ styleName: 'input' }, input, rest),
      values && values.map(function (_ref2, index) {
        var name = _ref2.name,
            value = _ref2.value;
        return _react2.default.createElement(
          'option',
          { value: value, key: index },
          name
        );
      }),
      children
    ),
    hasError && _react2.default.createElement(
      'span',
      { styleName: 'field_message' },
      error
    )
  );
};

exports.SelectField = SelectField;
exports.default = (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true })(SelectField);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssModules = __webpack_require__(4);

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _styles = __webpack_require__(20);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TextField = function TextField(_ref) {
  var input = _ref.input,
      children = _ref.children,
      label = _ref.label,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      active = _ref$meta.active,
      multiline = _ref.multiline,
      rest = _objectWithoutProperties(_ref, ['input', 'children', 'label', 'meta', 'multiline']);

  var hasError = touched && error && !active;
  return _react2.default.createElement(
    'div',
    { styleName: (0, _classnames2.default)('field', hasError && ' has-error') },
    label && _react2.default.createElement(
      'label',
      { styleName: 'field_label' },
      label
    ),
    !multiline && _react2.default.createElement('input', _extends({ styleName: 'input' }, input, rest)),
    multiline && _react2.default.createElement('textarea', _extends({ styleName: 'input' }, input, rest)),
    children,
    hasError && _react2.default.createElement(
      'span',
      { styleName: 'field_message' },
      error
    )
  );
};

exports.TextField = TextField;
exports.default = (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true })(TextField);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.SelectField = exports.TextField = exports.BoxSection = exports.Box = exports.Button = undefined;

var _Button = __webpack_require__(7);

var _Button2 = _interopRequireDefault(_Button);

var _Box = __webpack_require__(6);

var _Box2 = _interopRequireDefault(_Box);

var _BoxSection = __webpack_require__(5);

var _BoxSection2 = _interopRequireDefault(_BoxSection);

var _TextField = __webpack_require__(9);

var _TextField2 = _interopRequireDefault(_TextField);

var _SelectField = __webpack_require__(8);

var _SelectField2 = _interopRequireDefault(_SelectField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = exports.Button = _Button2.default;
var Box = exports.Box = _Box2.default;
var BoxSection = exports.BoxSection = _BoxSection2.default;
var TextField = exports.TextField = _TextField2.default;
var SelectField = exports.SelectField = _SelectField2.default;

exports.default = {
	Button: Button,
	Box: Box,
	BoxSection: BoxSection
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "html, body {\n  margin: 0;\n  padding: 0; }\n\nbody {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  color: #0A090C;\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden; }\n\n* {\n  box-sizing: border-box; }\n\nh1, h2 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 900;\n  margin: 5px 0 20px; }\n\nh1 {\n  font-size: 48px; }\n\nh2 {\n  font-size: 36px; }\n\nh3 {\n  font-size: 32px;\n  margin: 5px 0 10px; }\n\nh4 {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 900;\n  font-size: 24px;\n  margin: 5px 0 10px; }\n\na {\n  color: #0A090C;\n  text-decoration: none;\n  transition: all ease 0.3s; }\n  a:hover {\n    opacity: 0.6; }\n\n.styles_title-with-subtitle---ipfj2 {\n  margin-bottom: 10px; }\n\n.styles_subtitle---1ng0k {\n  font-size: 24px;\n  font-weight: 300;\n  max-width: 720px;\n  margin: 0 auto 30px; }\n\np {\n  margin: 5px 0 10px; }\n  p.styles_big---1keHj {\n    font-size: 24px;\n    font-weight: 300; }\n  p.styles_small---m0udW {\n    font-size: 16px;\n    font-weight: 300; }\n\n.styles_text-centered---1BA2U {\n  text-align: center; }\n\n.styles_left-align---2duBY {\n  text-align: left; }\n\n.styles_centered---3PZOH {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.styles_inline-wrap---2es5R {\n  display: flex;\n  align-items: stretch;\n  flex-wrap: wrap;\n  justify-content: space-between; }\n\n.styles_fade-enter---sIA0q {\n  opacity: 0.01; }\n\n.styles_fade-enter---sIA0q.styles_fade-enter-active---DaQ5k {\n  opacity: 1;\n  transition: opacity 1000ms ease-in; }\n\n.styles_fade-exit---10JM1 {\n  opacity: 1; }\n\n.styles_fade-exit---10JM1.styles_fade-exit-active---3ZLom {\n  opacity: 0.01;\n  transition: opacity 800ms ease-in; }\n\n.styles_box-section---3B1qO {\n  margin-bottom: 26px; }\n  .styles_box-section---3B1qO h2 {\n    font-size: 28px;\n    margin: 0 0 10px; }\n", ""]);

// exports
exports.locals = {
	"title-with-subtitle": "styles_title-with-subtitle---ipfj2",
	"subtitle": "styles_subtitle---1ng0k",
	"big": "styles_big---1keHj",
	"small": "styles_small---m0udW",
	"text-centered": "styles_text-centered---1BA2U",
	"left-align": "styles_left-align---2duBY",
	"centered": "styles_centered---3PZOH",
	"inline-wrap": "styles_inline-wrap---2es5R",
	"fade-enter": "styles_fade-enter---sIA0q",
	"fade-enter-active": "styles_fade-enter-active---DaQ5k",
	"fade-exit": "styles_fade-exit---10JM1",
	"fade-exit-active": "styles_fade-exit-active---3ZLom",
	"box-section": "styles_box-section---3B1qO"
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "html, body {\n  margin: 0;\n  padding: 0; }\n\nbody {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  color: #0A090C;\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden; }\n\n* {\n  box-sizing: border-box; }\n\nh1, h2 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 900;\n  margin: 5px 0 20px; }\n\nh1 {\n  font-size: 48px; }\n\nh2 {\n  font-size: 36px; }\n\nh3 {\n  font-size: 32px;\n  margin: 5px 0 10px; }\n\nh4 {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 900;\n  font-size: 24px;\n  margin: 5px 0 10px; }\n\na {\n  color: #0A090C;\n  text-decoration: none;\n  transition: all ease 0.3s; }\n  a:hover {\n    opacity: 0.6; }\n\n.styles_title-with-subtitle---3diqU {\n  margin-bottom: 10px; }\n\n.styles_subtitle---3CFz4 {\n  font-size: 24px;\n  font-weight: 300;\n  max-width: 720px;\n  margin: 0 auto 30px; }\n\np {\n  margin: 5px 0 10px; }\n  p.styles_big---JhuGo {\n    font-size: 24px;\n    font-weight: 300; }\n  p.styles_small---1Kf7x {\n    font-size: 16px;\n    font-weight: 300; }\n\n.styles_text-centered---2L8nX {\n  text-align: center; }\n\n.styles_left-align---PIX7i {\n  text-align: left; }\n\n.styles_centered---2o7vb {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.styles_inline-wrap---13ePy {\n  display: flex;\n  align-items: stretch;\n  flex-wrap: wrap;\n  justify-content: space-between; }\n\n.styles_fade-enter---3sgh6 {\n  opacity: 0.01; }\n\n.styles_fade-enter---3sgh6.styles_fade-enter-active---3a-3Z {\n  opacity: 1;\n  transition: opacity 1000ms ease-in; }\n\n.styles_fade-exit---22ZIy {\n  opacity: 1; }\n\n.styles_fade-exit---22ZIy.styles_fade-exit-active---2qQL6 {\n  opacity: 0.01;\n  transition: opacity 800ms ease-in; }\n\n.styles_inline-boxes---m9Q2z {\n  display: flex; }\n  .styles_inline-boxes---m9Q2z .styles_box---18SWz {\n    margin-right: 16px; }\n\n.styles_box---18SWz {\n  background-color: #fff;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);\n  padding: 16px 28px;\n  border-radius: 3px;\n  margin: 10px 0;\n  max-width: 720px; }\n  .styles_box---18SWz h5, .styles_box---18SWz h6 {\n    font-size: 14px;\n    font-weight: 300;\n    text-transform: uppercase;\n    margin: 10px 0; }\n  .styles_box---18SWz h3 {\n    font-size: 18px;\n    margin: 20px 0 10px; }\n  .styles_box---18SWz .styles_box-section---vro_m {\n    background-color: #fafafa;\n    border-top: 1px solid #f1f1f1; }\n  .styles_box---18SWz .styles_inline-content---Y4p2_ {\n    display: flex;\n    justify-content: space-between;\n    align-items: center; }\n  .styles_box---18SWz.styles_inline---1vl1M {\n    width: auto; }\n  .styles_box---18SWz.styles_no-padding---QzkVI {\n    padding: 0; }\n  .styles_box---18SWz .styles_inside-padding---21ra8 {\n    padding: 16px 28px; }\n  .styles_box---18SWz.styles_center---2oT-l {\n    text-align: center; }\n  .styles_box---18SWz.styles_no-max-width---MfTGM {\n    max-width: auto; }\n", ""]);

// exports
exports.locals = {
	"title-with-subtitle": "styles_title-with-subtitle---3diqU",
	"subtitle": "styles_subtitle---3CFz4",
	"big": "styles_big---JhuGo",
	"small": "styles_small---1Kf7x",
	"text-centered": "styles_text-centered---2L8nX",
	"left-align": "styles_left-align---PIX7i",
	"centered": "styles_centered---2o7vb",
	"inline-wrap": "styles_inline-wrap---13ePy",
	"fade-enter": "styles_fade-enter---3sgh6",
	"fade-enter-active": "styles_fade-enter-active---3a-3Z",
	"fade-exit": "styles_fade-exit---22ZIy",
	"fade-exit-active": "styles_fade-exit-active---2qQL6",
	"inline-boxes": "styles_inline-boxes---m9Q2z",
	"box": "styles_box---18SWz",
	"box-section": "styles_box-section---vro_m",
	"inline-content": "styles_inline-content---Y4p2_",
	"inline": "styles_inline---1vl1M",
	"no-padding": "styles_no-padding---QzkVI",
	"inside-padding": "styles_inside-padding---21ra8",
	"center": "styles_center---2oT-l",
	"no-max-width": "styles_no-max-width---MfTGM"
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "html, body {\n  margin: 0;\n  padding: 0; }\n\nbody {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  color: #0A090C;\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden; }\n\n* {\n  box-sizing: border-box; }\n\nh1, h2 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 900;\n  margin: 5px 0 20px; }\n\nh1 {\n  font-size: 48px; }\n\nh2 {\n  font-size: 36px; }\n\nh3 {\n  font-size: 32px;\n  margin: 5px 0 10px; }\n\nh4 {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 900;\n  font-size: 24px;\n  margin: 5px 0 10px; }\n\na {\n  color: #0A090C;\n  text-decoration: none;\n  transition: all ease 0.3s; }\n  a:hover {\n    opacity: 0.6; }\n\n.styles_title-with-subtitle---1ydPz {\n  margin-bottom: 10px; }\n\n.styles_subtitle---10SP1 {\n  font-size: 24px;\n  font-weight: 300;\n  max-width: 720px;\n  margin: 0 auto 30px; }\n\np {\n  margin: 5px 0 10px; }\n  p.styles_big---2ZKaU {\n    font-size: 24px;\n    font-weight: 300; }\n  p.styles_small---10rme {\n    font-size: 16px;\n    font-weight: 300; }\n\n.styles_text-centered---2ka55 {\n  text-align: center; }\n\n.styles_left-align---uY_WW {\n  text-align: left; }\n\n.styles_centered---kw9og {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.styles_inline-wrap---25k8P {\n  display: flex;\n  align-items: stretch;\n  flex-wrap: wrap;\n  justify-content: space-between; }\n\n.styles_fade-enter---2km_W {\n  opacity: 0.01; }\n\n.styles_fade-enter---2km_W.styles_fade-enter-active---35vbS {\n  opacity: 1;\n  transition: opacity 1000ms ease-in; }\n\n.styles_fade-exit---3VX5z {\n  opacity: 1; }\n\n.styles_fade-exit---3VX5z.styles_fade-exit-active---1YHGG {\n  opacity: 0.01;\n  transition: opacity 800ms ease-in; }\n\n.styles_btn---2klEr {\n  font-family: 'Roboto', sans-serif;\n  border: none;\n  color: #fff;\n  font-size: 0.85em;\n  font-weight: 300;\n  padding: 15px 20px;\n  text-transform: uppercase;\n  width: 100%;\n  display: inline-block;\n  cursor: pointer;\n  background: #FFC837;\n  border-radius: 25px;\n  transition: all ease 0.3s; }\n  .styles_btn---2klEr:hover {\n    background-color: #ffba04; }\n  .styles_btn---2klEr.styles_white---3Qo6m {\n    background-color: #fff;\n    color: #222 !important; }\n    .styles_btn---2klEr.styles_white---3Qo6m:hover {\n      background-color: whitesmoke; }\n  .styles_btn---2klEr.styles_red---3tOGI {\n    background-color: #e53935;\n    color: #fff !important; }\n    .styles_btn---2klEr.styles_red---3tOGI:hover {\n      background-color: #cd1e1a; }\n  .styles_btn---2klEr.styles_green---tRl6t {\n    background-color: #03CEA4;\n    color: #fff !important; }\n    .styles_btn---2klEr.styles_green---tRl6t:hover {\n      background-color: #03b590; }\n  .styles_btn---2klEr.styles_blue---3Ieqz {\n    background-color: #345995;\n    color: #fff !important; }\n    .styles_btn---2klEr.styles_blue---3Ieqz:hover {\n      background-color: #2d4e82; }\n  .styles_btn---2klEr.styles_dark---1SRAZ {\n    background-color: #5D5D5D;\n    color: #fff !important; }\n    .styles_btn---2klEr.styles_dark---1SRAZ:hover {\n      background-color: #444444; }\n  .styles_btn---2klEr.styles_black---3aq0A {\n    background-color: #0A090C;\n    color: #fff !important; }\n    .styles_btn---2klEr.styles_black---3aq0A:hover {\n      background-color: #3b3546; }\n  .styles_btn---2klEr .styles_content---jQvg1 {\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .styles_btn---2klEr .styles_loader---isRud {\n    margin-right: 6px; }\n  .styles_btn---2klEr.styles_transparent---3PlS8 {\n    background-color: transparent;\n    color: #6F7A87 !important; }\n    .styles_btn---2klEr.styles_transparent---3PlS8:hover {\n      color: #0A090C; }\n  .styles_btn---2klEr.styles_outline---12SNF {\n    background-color: transparent;\n    border: 2px solid #FFC837;\n    color: #FFC837; }\n    .styles_btn---2klEr.styles_outline---12SNF:hover {\n      background-color: transparent; }\n    .styles_btn---2klEr.styles_outline---12SNF.styles_red---3tOGI {\n      border-color: #e53935;\n      color: #e53935 !important; }\n      .styles_btn---2klEr.styles_outline---12SNF.styles_red---3tOGI:hover {\n        border-color: #9f1815;\n        color: #9f1815 !important; }\n    .styles_btn---2klEr.styles_outline---12SNF.styles_green---tRl6t {\n      border-color: #03CEA4;\n      color: #03CEA4 !important; }\n      .styles_btn---2klEr.styles_outline---12SNF.styles_green---tRl6t:hover {\n        border-color: #03b08c;\n        color: #03b08c !important; }\n    .styles_btn---2klEr.styles_outline---12SNF.styles_dark---1SRAZ {\n      border-color: #222;\n      color: #222 !important; }\n      .styles_btn---2klEr.styles_outline---12SNF.styles_dark---1SRAZ:hover {\n        border-color: black;\n        color: #555555 !important; }\n  .styles_btn---2klEr.styles_inline---1kc7y {\n    margin-right: 10px; }\n  .styles_btn---2klEr.styles_auto---RHElF {\n    width: auto; }\n  .styles_btn---2klEr:focus {\n    outline: none; }\n  .styles_btn---2klEr:disabled {\n    opacity: 0.6; }\n  .styles_btn---2klEr.styles_tag---HFSlr {\n    width: auto;\n    border: 1px solid #6F7A87;\n    color: #6F7A87;\n    background-color: transparent;\n    font-size: 14px;\n    padding: 6px 18px;\n    border-radius: 18px;\n    margin-right: 6px;\n    margin-bottom: 6px;\n    transition: all ease 0.4s; }\n    .styles_btn---2klEr.styles_tag---HFSlr.styles_is-selected---3PwvS {\n      color: #fff;\n      background-color: #6F7A87; }\n  .styles_btn---2klEr.styles_round---uUMto {\n    height: 56px;\n    width: 56px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 0 16px -4px #ddd; }\n    .styles_btn---2klEr.styles_round---uUMto:hover {\n      box-shadow: 0 0 24px 0 #aaa; }\n  .styles_btn---2klEr.styles_small---10rme {\n    font-size: 10px;\n    padding: 8px 12px;\n    border-radius: 15px; }\n    .styles_btn---2klEr.styles_small---10rme .styles_icons---1l988 {\n      font-size: 16px;\n      margin-right: 5px; }\n  .styles_btn---2klEr.styles_lg---2_U7n, .styles_btn---2klEr.styles_large---1lMeo {\n    font-size: 20px;\n    padding: 20px 36px;\n    border-radius: 32px; }\n  .styles_btn---2klEr.styles_facebook---3dRAO {\n    background-color: #3B5998; }\n    .styles_btn---2klEr.styles_facebook---3dRAO:hover {\n      background-color: #2d4373; }\n  .styles_btn---2klEr.styles_twitter---31Q7E {\n    background-color: #1DA1F3; }\n    .styles_btn---2klEr.styles_twitter---31Q7E:hover {\n      background-color: #0b86d2; }\n  .styles_btn---2klEr.styles_google-plus---HOl05 {\n    background-color: #DB4437; }\n    .styles_btn---2klEr.styles_google-plus---HOl05:hover {\n      background-color: #bd2e22; }\n", ""]);

// exports
exports.locals = {
	"title-with-subtitle": "styles_title-with-subtitle---1ydPz",
	"subtitle": "styles_subtitle---10SP1",
	"big": "styles_big---2ZKaU",
	"small": "styles_small---10rme",
	"text-centered": "styles_text-centered---2ka55",
	"left-align": "styles_left-align---uY_WW",
	"centered": "styles_centered---kw9og",
	"inline-wrap": "styles_inline-wrap---25k8P",
	"fade-enter": "styles_fade-enter---2km_W",
	"fade-enter-active": "styles_fade-enter-active---35vbS",
	"fade-exit": "styles_fade-exit---3VX5z",
	"fade-exit-active": "styles_fade-exit-active---1YHGG",
	"btn": "styles_btn---2klEr",
	"white": "styles_white---3Qo6m",
	"red": "styles_red---3tOGI",
	"green": "styles_green---tRl6t",
	"blue": "styles_blue---3Ieqz",
	"dark": "styles_dark---1SRAZ",
	"black": "styles_black---3aq0A",
	"content": "styles_content---jQvg1",
	"loader": "styles_loader---isRud",
	"transparent": "styles_transparent---3PlS8",
	"outline": "styles_outline---12SNF",
	"inline": "styles_inline---1kc7y",
	"auto": "styles_auto---RHElF",
	"tag": "styles_tag---HFSlr",
	"is-selected": "styles_is-selected---3PwvS",
	"round": "styles_round---uUMto",
	"icons": "styles_icons---1l988",
	"lg": "styles_lg---2_U7n",
	"large": "styles_large---1lMeo",
	"facebook": "styles_facebook---3dRAO",
	"twitter": "styles_twitter---31Q7E",
	"google-plus": "styles_google-plus---HOl05"
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "html, body {\n  margin: 0;\n  padding: 0; }\n\nbody {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  color: #0A090C;\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden; }\n\n* {\n  box-sizing: border-box; }\n\nh1, h2 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 900;\n  margin: 5px 0 20px; }\n\nh1 {\n  font-size: 48px; }\n\nh2 {\n  font-size: 36px; }\n\nh3 {\n  font-size: 32px;\n  margin: 5px 0 10px; }\n\nh4 {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 900;\n  font-size: 24px;\n  margin: 5px 0 10px; }\n\na {\n  color: #0A090C;\n  text-decoration: none;\n  transition: all ease 0.3s; }\n  a:hover {\n    opacity: 0.6; }\n\n.styles_title-with-subtitle---1qpgX {\n  margin-bottom: 10px; }\n\n.styles_subtitle---2HRki {\n  font-size: 24px;\n  font-weight: 300;\n  max-width: 720px;\n  margin: 0 auto 30px; }\n\np {\n  margin: 5px 0 10px; }\n  p.styles_big---3Ug7O {\n    font-size: 24px;\n    font-weight: 300; }\n  p.styles_small---oLl-l {\n    font-size: 16px;\n    font-weight: 300; }\n\n.styles_text-centered---1lScY {\n  text-align: center; }\n\n.styles_left-align---3zqPJ {\n  text-align: left; }\n\n.styles_centered---1z3x8 {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.styles_inline-wrap---1a53- {\n  display: flex;\n  align-items: stretch;\n  flex-wrap: wrap;\n  justify-content: space-between; }\n\n.styles_fade-enter---3VCZI {\n  opacity: 0.01; }\n\n.styles_fade-enter---3VCZI.styles_fade-enter-active---1Rgoh {\n  opacity: 1;\n  transition: opacity 1000ms ease-in; }\n\n.styles_fade-exit---1_bAQ {\n  opacity: 1; }\n\n.styles_fade-exit---1_bAQ.styles_fade-exit-active---3uVD0 {\n  opacity: 0.01;\n  transition: opacity 800ms ease-in; }\n\n.styles_placeholder-style---Wkegf, .styles_field---1fzxe .styles_input---1gEOV::placeholder, .styles_field---1fzxe input::placeholder, .styles_field---1fzxe select::placeholder, .styles_field---1fzxe textarea::placeholder {\n  font-weight: 100;\n  color: #a6adb6; }\n\n.styles_field---1fzxe {\n  max-width: 680px;\n  margin-bottom: 10px; }\n  .styles_field---1fzxe .styles_field_label---13H7A {\n    font-size: 15px;\n    color: #6F7A87; }\n  .styles_field---1fzxe .styles_input---1gEOV, .styles_field---1fzxe input, .styles_field---1fzxe select, .styles_field---1fzxe textarea {\n    position: relative;\n    width: 100%;\n    padding: 12px 18px;\n    border-radius: 4px;\n    border: 2px solid #D5D9DE;\n    font-size: 14px;\n    margin: 6px 0;\n    background-color: transparent;\n    height: 45px;\n    background-color: #fff; }\n    .styles_field---1fzxe .styles_input---1gEOV:focus, .styles_field---1fzxe input:focus, .styles_field---1fzxe select:focus, .styles_field---1fzxe textarea:focus {\n      outline: none;\n      border-color: #FFC837; }\n    .styles_field---1fzxe .styles_input---1gEOV::placeholder, .styles_field---1fzxe input::placeholder, .styles_field---1fzxe select::placeholder, .styles_field---1fzxe textarea::placeholder {\n      /* Firefox 18- */ }\n  .styles_field---1fzxe select {\n    background-image: url(\"/static/dropdown.svg\");\n    background-repeat: no-repeat;\n    background-position: center right 10px; }\n  .styles_field---1fzxe .styles_select-buttons---14oHp {\n    margin: 5px 0 10px;\n    display: flex;\n    flex-wrap: wrap; }\n    .styles_field---1fzxe .styles_select-buttons---14oHp .styles_select-button---2D_yo {\n      display: flex;\n      align-items: center;\n      padding: 8px 14px;\n      border-radius: 4px;\n      border: 1px solid #D5D9DE;\n      font-size: 15px;\n      color: #6F7A87;\n      margin: 5px 10px 5px 0px;\n      cursor: pointer; }\n      .styles_field---1fzxe .styles_select-buttons---14oHp .styles_select-button---2D_yo:hover, .styles_field---1fzxe .styles_select-buttons---14oHp .styles_select-button---2D_yo.styles_active---A8l0c {\n        background-color: #D5D9DE;\n        color: #fff; }\n      .styles_field---1fzxe .styles_select-buttons---14oHp .styles_select-button---2D_yo .styles_material-icons---26lf3 {\n        margin-left: 6px;\n        font-size: 18px; }\n\n.styles_field---1fzxe.styles_has-error---1Hmwp input, .styles_field---1fzxe.styles_has-error---1Hmwp select, .styles_field---1fzxe.styles_has-error---1Hmwp textarea {\n  border-color: #e53935; }\n\n.styles_field---1fzxe.styles_has-error---1Hmwp label {\n  color: #e53935; }\n\n.styles_field---1fzxe.styles_has-error---1Hmwp .styles_field_message---1xsj7 {\n  color: #e53935;\n  font-size: 14px;\n  font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"title-with-subtitle": "styles_title-with-subtitle---1qpgX",
	"subtitle": "styles_subtitle---2HRki",
	"big": "styles_big---3Ug7O",
	"small": "styles_small---oLl-l",
	"text-centered": "styles_text-centered---1lScY",
	"left-align": "styles_left-align---3zqPJ",
	"centered": "styles_centered---1z3x8",
	"inline-wrap": "styles_inline-wrap---1a53-",
	"fade-enter": "styles_fade-enter---3VCZI",
	"fade-enter-active": "styles_fade-enter-active---1Rgoh",
	"fade-exit": "styles_fade-exit---1_bAQ",
	"fade-exit-active": "styles_fade-exit-active---3uVD0",
	"placeholder-style": "styles_placeholder-style---Wkegf",
	"field": "styles_field---1fzxe",
	"input": "styles_input---1gEOV",
	"field_label": "styles_field_label---13H7A",
	"select-buttons": "styles_select-buttons---14oHp",
	"select-button": "styles_select-button---2D_yo",
	"active": "styles_active---A8l0c",
	"material-icons": "styles_material-icons---26lf3",
	"has-error": "styles_has-error---1Hmwp",
	"field_message": "styles_field_message---1xsj7"
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "html, body {\n  margin: 0;\n  padding: 0; }\n\nbody {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  color: #0A090C;\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden; }\n\n* {\n  box-sizing: border-box; }\n\nh1, h2 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 900;\n  margin: 5px 0 20px; }\n\nh1 {\n  font-size: 48px; }\n\nh2 {\n  font-size: 36px; }\n\nh3 {\n  font-size: 32px;\n  margin: 5px 0 10px; }\n\nh4 {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 900;\n  font-size: 24px;\n  margin: 5px 0 10px; }\n\na {\n  color: #0A090C;\n  text-decoration: none;\n  transition: all ease 0.3s; }\n  a:hover {\n    opacity: 0.6; }\n\n.styles_title-with-subtitle---3Ne97 {\n  margin-bottom: 10px; }\n\n.styles_subtitle---13tVg {\n  font-size: 24px;\n  font-weight: 300;\n  max-width: 720px;\n  margin: 0 auto 30px; }\n\np {\n  margin: 5px 0 10px; }\n  p.styles_big---3qZJ4 {\n    font-size: 24px;\n    font-weight: 300; }\n  p.styles_small---2fX4G {\n    font-size: 16px;\n    font-weight: 300; }\n\n.styles_text-centered---q8Ltf {\n  text-align: center; }\n\n.styles_left-align---3Cdh2 {\n  text-align: left; }\n\n.styles_centered---vLq5i {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.styles_inline-wrap---M-puq {\n  display: flex;\n  align-items: stretch;\n  flex-wrap: wrap;\n  justify-content: space-between; }\n\n.styles_fade-enter---KvKbP {\n  opacity: 0.01; }\n\n.styles_fade-enter---KvKbP.styles_fade-enter-active---kwAFR {\n  opacity: 1;\n  transition: opacity 1000ms ease-in; }\n\n.styles_fade-exit---kCsaa {\n  opacity: 1; }\n\n.styles_fade-exit---kCsaa.styles_fade-exit-active---1U5vP {\n  opacity: 0.01;\n  transition: opacity 800ms ease-in; }\n\n.styles_placeholder-style---kbFNe, .styles_field---231ym .styles_input---IXOcv::placeholder, .styles_field---231ym input::placeholder, .styles_field---231ym select::placeholder, .styles_field---231ym textarea::placeholder {\n  font-weight: 100;\n  color: #a6adb6; }\n\n.styles_field---231ym {\n  max-width: 680px;\n  margin-bottom: 10px; }\n  .styles_field---231ym .styles_field_label---1eLtC {\n    font-size: 15px;\n    color: #6F7A87; }\n  .styles_field---231ym .styles_input---IXOcv, .styles_field---231ym input, .styles_field---231ym select, .styles_field---231ym textarea {\n    position: relative;\n    width: 100%;\n    padding: 14px 18px;\n    border-radius: 4px;\n    border: 2px solid #D5D9DE;\n    font-size: 14px;\n    margin: 6px 0;\n    background-color: transparent;\n    -webkit-appearance: none;\n    background-color: #fff; }\n    .styles_field---231ym .styles_input---IXOcv:focus, .styles_field---231ym input:focus, .styles_field---231ym select:focus, .styles_field---231ym textarea:focus {\n      outline: none;\n      border-color: #FFC837; }\n    .styles_field---231ym .styles_input---IXOcv::placeholder, .styles_field---231ym input::placeholder, .styles_field---231ym select::placeholder, .styles_field---231ym textarea::placeholder {\n      /* Firefox 18- */ }\n  .styles_field---231ym select {\n    background-image: url(\"/static/dropdown.svg\");\n    background-repeat: no-repeat;\n    background-position: center right 10px; }\n  .styles_field---231ym .styles_select-buttons---w8WTq {\n    margin: 5px 0 10px;\n    display: flex;\n    flex-wrap: wrap; }\n    .styles_field---231ym .styles_select-buttons---w8WTq .styles_select-button---8h_U_ {\n      display: flex;\n      align-items: center;\n      padding: 8px 14px;\n      border-radius: 4px;\n      border: 1px solid #D5D9DE;\n      font-size: 15px;\n      color: #6F7A87;\n      margin: 5px 10px 5px 0px;\n      cursor: pointer; }\n      .styles_field---231ym .styles_select-buttons---w8WTq .styles_select-button---8h_U_:hover, .styles_field---231ym .styles_select-buttons---w8WTq .styles_select-button---8h_U_.styles_active---M8SHj {\n        background-color: #D5D9DE;\n        color: #fff; }\n      .styles_field---231ym .styles_select-buttons---w8WTq .styles_select-button---8h_U_ .styles_material-icons---3nVAR {\n        margin-left: 6px;\n        font-size: 18px; }\n\n.styles_field---231ym.styles_has-error---17-HQ input, .styles_field---231ym.styles_has-error---17-HQ select, .styles_field---231ym.styles_has-error---17-HQ textarea {\n  border-color: #e53935; }\n\n.styles_field---231ym.styles_has-error---17-HQ label {\n  color: #e53935; }\n\n.styles_field---231ym.styles_has-error---17-HQ .styles_field_message---d5txT {\n  color: #e53935;\n  font-size: 14px;\n  font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"title-with-subtitle": "styles_title-with-subtitle---3Ne97",
	"subtitle": "styles_subtitle---13tVg",
	"big": "styles_big---3qZJ4",
	"small": "styles_small---2fX4G",
	"text-centered": "styles_text-centered---q8Ltf",
	"left-align": "styles_left-align---3Cdh2",
	"centered": "styles_centered---vLq5i",
	"inline-wrap": "styles_inline-wrap---M-puq",
	"fade-enter": "styles_fade-enter---KvKbP",
	"fade-enter-active": "styles_fade-enter-active---kwAFR",
	"fade-exit": "styles_fade-exit---kCsaa",
	"fade-exit-active": "styles_fade-exit-active---1U5vP",
	"placeholder-style": "styles_placeholder-style---kbFNe",
	"field": "styles_field---231ym",
	"input": "styles_input---IXOcv",
	"field_label": "styles_field_label---1eLtC",
	"select-buttons": "styles_select-buttons---w8WTq",
	"select-button": "styles_select-button---8h_U_",
	"active": "styles_active---M8SHj",
	"material-icons": "styles_material-icons---3nVAR",
	"has-error": "styles_has-error---17-HQ",
	"field_message": "styles_field_message---d5txT"
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(11);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&-minimize&localIdentName=[name]_[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js?sourceMap!../../node_modules/sass-loader/lib/loader.js?sourceMap!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&-minimize&localIdentName=[name]_[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js?sourceMap!../../node_modules/sass-loader/lib/loader.js?sourceMap!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(12);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&-minimize&localIdentName=[name]_[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js?sourceMap!../../node_modules/sass-loader/lib/loader.js?sourceMap!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&-minimize&localIdentName=[name]_[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js?sourceMap!../../node_modules/sass-loader/lib/loader.js?sourceMap!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(13);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&-minimize&localIdentName=[name]_[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js?sourceMap!../../node_modules/sass-loader/lib/loader.js?sourceMap!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&-minimize&localIdentName=[name]_[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js?sourceMap!../../node_modules/sass-loader/lib/loader.js?sourceMap!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(14);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&-minimize&localIdentName=[name]_[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js?sourceMap!../../node_modules/sass-loader/lib/loader.js?sourceMap!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&-minimize&localIdentName=[name]_[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js?sourceMap!../../node_modules/sass-loader/lib/loader.js?sourceMap!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(15);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&-minimize&localIdentName=[name]_[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js?sourceMap!../../node_modules/sass-loader/lib/loader.js?sourceMap!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&-minimize&localIdentName=[name]_[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js?sourceMap!../../node_modules/sass-loader/lib/loader.js?sourceMap!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 21 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(19);

/***/ })
/******/ ]);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(257),
    baseKeys = __webpack_require__(263),
    isArrayLike = __webpack_require__(32);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(40),
    isLength = __webpack_require__(67);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var config={env:"production"||'development'};config.development={api:'http://localhost:8500/',auth:'http://localhost:3000/',app:'http://localhost:8080/',home:'http://localhost:4040/'};config.staging={api:'https://staging-api.stapp.ca/',auth:'https://staging-auth.stapp.ca/',app:'https://staging-app.stapp.ca/',home:'https://staging-home.stapp.ca/'};config.production={api:'https://api.sofiatutors.com/',auth:'https://auth.sofiatutors.com/',app:'https://app.sofiatutors.com/',home:'https://sofiatutors.com/'};console.log('NODE ENV',config.env);module.exports=config[config.env];

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.10';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(42)(module)))

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchType; });
var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));
//# sourceMappingURL=types.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(17),
    isObject = __webpack_require__(10);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(20);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(276),
    listCacheDelete = __webpack_require__(277),
    listCacheGet = __webpack_require__(278),
    listCacheHas = __webpack_require__(279),
    listCacheSet = __webpack_require__(280);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(47);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(294);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(17),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(50);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(33);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(392);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(440);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "printAST", function() { return __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__ = __webpack_require__(57);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableQuery", function() { return __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__ = __webpack_require__(26);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NetworkStatus", function() { return __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_types__ = __webpack_require__(39);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FetchType", function() { return __WEBPACK_IMPORTED_MODULE_3__core_types__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors_ApolloError__ = __webpack_require__(61);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloError", function() { return __WEBPACK_IMPORTED_MODULE_4__errors_ApolloError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApolloClient__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloClient", function() { return __WEBPACK_IMPORTED_MODULE_5__ApolloClient__["a"]; });






// export the client as both default and named

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_5__ApolloClient__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObservableQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__networkStatus__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Observable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errors_ApolloError__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(39);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var hasError = function (storeValue, policy) {
    if (policy === void 0) { policy = 'none'; }
    return storeValue &&
        ((storeValue.graphQLErrors &&
            storeValue.graphQLErrors.length > 0 &&
            policy === 'none') ||
            storeValue.networkError);
};
var ObservableQuery = /** @class */ (function (_super) {
    __extends(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var scheduler = _a.scheduler, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function (observer) {
            return _this.onSubscribe(observer);
        }) || this;
        // active state
        _this.isCurrentlyPolling = false;
        _this.isTornDown = false;
        // query information
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = scheduler.queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        // related classes
        _this.scheduler = scheduler;
        _this.queryManager = scheduler.queryManager;
        // interal data stores
        _this.observers = [];
        _this.subscriptionHandles = [];
        return _this;
    }
    ObservableQuery.prototype.result = function () {
        var that = this;
        return new Promise(function (resolve, reject) {
            var subscription;
            var observer = {
                next: function (result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    if (!that.observers.some(function (obs) { return obs !== observer; })) {
                        that.queryManager.removeQuery(that.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: function (error) {
                    reject(error);
                },
            };
            subscription = that.subscribe(observer);
        });
    };
    /**
     * Return the result of the query from the local cache as well as some fetching status
     * `loading` and `networkStatus` allow to know if a request is in flight
     * `partial` lets you know if the result from the local cache is complete or partial
     * @return {data: Object, error: ApolloError, loading: boolean, networkStatus: number, partial: boolean}
     */
    ObservableQuery.prototype.currentResult = function () {
        if (this.isTornDown) {
            return {
                data: this.lastError ? {} : this.lastResult ? this.lastResult.data : {},
                error: this.lastError,
                loading: false,
                networkStatus: __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].error,
            };
        }
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        if (hasError(queryStoreValue, this.options.errorPolicy)) {
            return {
                data: {},
                loading: false,
                networkStatus: queryStoreValue.networkStatus,
                error: new __WEBPACK_IMPORTED_MODULE_3__errors_ApolloError__["a" /* ApolloError */]({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError,
                }),
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryLoading = !queryStoreValue ||
            queryStoreValue.networkStatus === __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].loading;
        // We need to be careful about the loading state we show to the user, to try
        // and be vaguely in line with what the user would have seen from .subscribe()
        // but to still provide useful information synchronously when the query
        // will not end up hitting the server.
        // See more: https://github.com/apollostack/apollo-client/issues/707
        // Basically: is there a query in flight right now (modolo the next tick)?
        var loading = (this.options.fetchPolicy === 'network-only' && queryLoading) ||
            (partial && this.options.fetchPolicy !== 'cache-only');
        // if there is nothing in the query store, it means this query hasn't fired yet or it has been cleaned up. Therefore the
        // network status is dependent on queryLoading.
        var networkStatus;
        if (queryStoreValue) {
            networkStatus = queryStoreValue.networkStatus;
        }
        else {
            networkStatus = loading ? __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].loading : __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].ready;
        }
        var result = {
            data: data,
            loading: Object(__WEBPACK_IMPORTED_MODULE_1__networkStatus__["b" /* isNetworkRequestInFlight */])(networkStatus),
            networkStatus: networkStatus,
        };
        if (queryStoreValue &&
            queryStoreValue.graphQLErrors &&
            this.options.errorPolicy === 'all') {
            result.errors = queryStoreValue.graphQLErrors;
        }
        if (!partial) {
            var stale = false;
            this.lastResult = __assign({}, result, { stale: stale });
        }
        return __assign({}, result, { partial: partial });
    };
    // Returns the last result that observer.next was called with. This is not the same as
    // currentResult! If you're not sure which you need, then you probably need currentResult.
    ObservableQuery.prototype.getLastResult = function () {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function () {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.lastResult;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var fetchPolicy = this.options.fetchPolicy;
        // early return if trying to read from cache during refetch
        if (fetchPolicy === 'cache-only') {
            return Promise.reject(new Error('cache-only fetchPolicy option should not be used together with query refetch.'));
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["isEqual"])(this.variables, variables)) {
            // update observable variables
            this.variables = Object.assign({}, this.variables, variables);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["isEqual"])(this.options.variables, this.variables)) {
            // Update the existing options with new variables
            this.options.variables = Object.assign({}, this.options.variables, this.variables);
        }
        // Override fetchPolicy for this call only
        // only network-only and no-cache are safe to use
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        var combinedOptions = __assign({}, this.options, { fetchPolicy: isNetworkFetchPolicy ? fetchPolicy : 'network-only' });
        return this.queryManager
            .fetchQuery(this.queryId, combinedOptions, __WEBPACK_IMPORTED_MODULE_4__types__["a" /* FetchType */].refetch)
            .then(function (result) { return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["maybeDeepFreeze"])(result); });
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        // early return if no update Query
        if (!fetchMoreOptions.updateQuery) {
            throw new Error('updateQuery option is required. This function defines how to update the query data with the new results.');
        }
        var combinedOptions;
        return Promise.resolve()
            .then(function () {
            var qid = _this.queryManager.generateQueryId();
            if (fetchMoreOptions.query) {
                // fetch a new query
                combinedOptions = fetchMoreOptions;
            }
            else {
                // fetch the same query with a possibly new variables
                combinedOptions = __assign({}, _this.options, fetchMoreOptions, { variables: Object.assign({}, _this.variables, fetchMoreOptions.variables) });
            }
            combinedOptions.fetchPolicy = 'network-only';
            return _this.queryManager.fetchQuery(qid, combinedOptions, __WEBPACK_IMPORTED_MODULE_4__types__["a" /* FetchType */].normal, _this.queryId);
        })
            .then(function (fetchMoreResult) {
            _this.updateQuery(function (previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables,
                });
            });
            return fetchMoreResult;
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
        })
            .subscribe({
            next: function (data) {
                if (options.updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return options.updateQuery(previous, {
                            subscriptionData: data,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                console.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptionHandles.push(subscription);
        return function () {
            var i = _this.subscriptionHandles.indexOf(subscription);
            if (i >= 0) {
                _this.subscriptionHandles.splice(i, 1);
                subscription.unsubscribe();
            }
        };
    };
    // Note: if the query is not active (there are no subscribers), the promise
    // will return null immediately.
    ObservableQuery.prototype.setOptions = function (opts) {
        var oldOptions = this.options;
        this.options = Object.assign({}, this.options, opts);
        if (opts.pollInterval) {
            this.startPolling(opts.pollInterval);
        }
        else if (opts.pollInterval === 0) {
            this.stopPolling();
        }
        // If fetchPolicy went from cache-only to something else, or from something else to network-only
        var tryFetch = (oldOptions.fetchPolicy !== 'network-only' &&
            opts.fetchPolicy === 'network-only') ||
            (oldOptions.fetchPolicy === 'cache-only' &&
                opts.fetchPolicy !== 'cache-only') ||
            (oldOptions.fetchPolicy === 'standby' &&
                opts.fetchPolicy !== 'standby') ||
            false;
        return this.setVariables(this.options.variables, tryFetch, opts.fetchResults);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. If you want to force new results, use `refetch`.
     *
     * Note: if the variables have not changed, the promise will return the old
     * results immediately, and the `next` callback will *not* fire.
     *
     * Note: if the query is not active (there are no subscribers), the promise
     * will return null immediately.
     *
     * @param variables: The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     *
     * @param tryFetch: Try and fetch new results even if the variables haven't
     * changed (we may still just hit the store, but if there's nothing in there
     * this will refetch)
     *
     * @param fetchResults: Option to ignore fetching results when updating variables
     *
     */
    ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) { tryFetch = false; }
        if (fetchResults === void 0) { fetchResults = true; }
        // since setVariables restarts the subscription, we reset the tornDown status
        this.isTornDown = false;
        var newVariables = variables ? variables : this.variables;
        if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["isEqual"])(newVariables, this.variables) && !tryFetch) {
            // If we have no observers, then we don't actually want to make a network
            // request. As soon as someone observes the query, the request will kick
            // off. For now, we just store any changes. (See #1077)
            if (this.observers.length === 0 || !fetchResults) {
                return new Promise(function (resolve) { return resolve(); });
            }
            return this.result();
        }
        else {
            this.variables = newVariables;
            this.options.variables = newVariables;
            // See comment above
            if (this.observers.length === 0) {
                return new Promise(function (resolve) { return resolve(); });
            }
            // Use the same options as before, but with new variables
            return this.queryManager
                .fetchQuery(this.queryId, __assign({}, this.options, { variables: this.variables }))
                .then(function (result) { return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["maybeDeepFreeze"])(result); });
        }
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var _a = this.queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["tryFunctionOrLogError"])(function () {
            return mapFn(previousResult, { variables: variables });
        });
        if (newResult) {
            this.queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            this.queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function () {
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.options.pollInterval = undefined;
            this.isCurrentlyPolling = false;
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        if (this.options.fetchPolicy === 'cache-first' ||
            this.options.fetchPolicy === 'cache-only') {
            throw new Error('Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
        }
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.isCurrentlyPolling = false;
        }
        this.options.pollInterval = pollInterval;
        this.isCurrentlyPolling = true;
        this.scheduler.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.onSubscribe = function (observer) {
        var _this = this;
        // Zen Observable has its own error function, in order to log correctly
        // we need to declare a custom error if nothing is passed
        if (observer._subscription &&
            observer._subscription._observer &&
            !observer._subscription._observer.error) {
            observer._subscription._observer.error = function (error) {
                console.error('Unhandled error', error.message, error.stack);
            };
        }
        this.observers.push(observer);
        // Deliver initial result
        if (observer.next && this.lastResult)
            observer.next(this.lastResult);
        if (observer.error && this.lastError)
            observer.error(this.lastError);
        // setup the query if it hasn't been done before
        if (this.observers.length === 1)
            this.setUpQuery();
        return function () {
            _this.observers = _this.observers.filter(function (obs) { return obs !== observer; });
            if (_this.observers.length === 0) {
                _this.tearDownQuery();
            }
        };
    };
    ObservableQuery.prototype.setUpQuery = function () {
        var _this = this;
        if (this.shouldSubscribe) {
            this.queryManager.addObservableQuery(this.queryId, this);
        }
        if (!!this.options.pollInterval) {
            if (this.options.fetchPolicy === 'cache-first' ||
                this.options.fetchPolicy === 'cache-only') {
                throw new Error('Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
            }
            this.isCurrentlyPolling = true;
            this.scheduler.startPollingQuery(this.options, this.queryId);
        }
        var observer = {
            next: function (result) {
                _this.lastResult = result;
                _this.observers.forEach(function (obs) { return obs.next && obs.next(result); });
            },
            error: function (error) {
                _this.lastError = error;
                _this.observers.forEach(function (obs) { return obs.error && obs.error(error); });
            },
        };
        this.queryManager.startQuery(this.queryId, this.options, this.queryManager.queryListenerForObserver(this.queryId, this.options, observer));
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        this.isTornDown = true;
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.isCurrentlyPolling = false;
        }
        // stop all active GraphQL subscriptions
        this.subscriptionHandles.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptionHandles = [];
        this.queryManager.removeObservableQuery(this.queryId);
        this.queryManager.stopQuery(this.queryId);
        this.observers = [];
    };
    return ObservableQuery;
}(__WEBPACK_IMPORTED_MODULE_2__util_Observable__["a" /* Observable */]));

//# sourceMappingURL=ObservableQuery.js.map

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = isScalarValue;
/* harmony export (immutable) */ __webpack_exports__["g"] = isNumberValue;
/* harmony export (immutable) */ __webpack_exports__["m"] = valueToObjectRepresentation;
/* harmony export (immutable) */ __webpack_exports__["j"] = storeKeyNameFromField;
/* harmony export (immutable) */ __webpack_exports__["b"] = getStoreKeyName;
/* harmony export (immutable) */ __webpack_exports__["a"] = argumentsObjectFromField;
/* harmony export (immutable) */ __webpack_exports__["i"] = resultKeyNameFromField;
/* harmony export (immutable) */ __webpack_exports__["c"] = isField;
/* harmony export (immutable) */ __webpack_exports__["e"] = isInlineFragment;
/* harmony export (immutable) */ __webpack_exports__["d"] = isIdValue;
/* harmony export (immutable) */ __webpack_exports__["k"] = toIdValue;
/* harmony export (immutable) */ __webpack_exports__["f"] = isJsonValue;
/* harmony export (immutable) */ __webpack_exports__["l"] = valueFromNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_json_stable_stringify__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_json_stable_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_json_stable_stringify__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw new Error("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\"" +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.');
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = __WEBPACK_IMPORTED_MODULE_0_fast_json_stable_stringify___default()(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject && idObject.type === 'id';
}
function toIdValue(idConfig, generated) {
    if (generated === void 0) { generated = false; }
    return __assign({ type: 'id', generated: generated }, (typeof idConfig === 'string'
        ? { id: idConfig, typename: undefined }
        : idConfig));
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw new Error("Variable nodes are not supported by valueFromNode");
}
/**
 * Evaluate a ValueNode and yield its value in its natural JS form.
 */
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}
//# sourceMappingURL=storeUtils.js.map

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["a"] = getEnv;
/* harmony export (immutable) */ __webpack_exports__["c"] = isEnv;
/* harmony export (immutable) */ __webpack_exports__["d"] = isProduction;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDevelopment;
/* harmony export (immutable) */ __webpack_exports__["e"] = isTest;
function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    // default environment
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}
//# sourceMappingURL=environment.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(88)))

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zenObservable__ = __webpack_require__(90);
/* unused harmony namespace reexport */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__zenObservable__["a" /* Observable */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isApolloError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloError; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var generateErrorMessage = function (err) {
    var message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) {
        err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError
                ? graphQLError.message
                : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
    }
    if (err.networkError) {
        message += 'Network error: ' + err.networkError.message + '\n';
    }
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = /** @class */ (function (_super) {
    __extends(ApolloError, _super);
    // Constructs an instance of ApolloError given a GraphQLError
    // or a network error. Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) {
            _this.message = generateErrorMessage(_this);
        }
        else {
            _this.message = errorMessage;
        }
        _this.extraInfo = extraInfo;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=ApolloError.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(92),
    baseLodash = __webpack_require__(63);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(202),
    isObjectLike = __webpack_require__(16);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(92),
    baseLodash = __webpack_require__(63);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18),
    root = __webpack_require__(13);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(286),
    mapCacheDelete = __webpack_require__(293),
    mapCacheGet = __webpack_require__(295),
    mapCacheHas = __webpack_require__(296),
    mapCacheSet = __webpack_require__(297);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(5),
    isSymbol = __webpack_require__(50);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(333),
    baseIsNaN = __webpack_require__(334),
    strictIndexOf = __webpack_require__(335);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(74);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GraphQLError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__printError__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_location__ = __webpack_require__(138);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */


function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined;

  // Compute locations in the source for the given nodes/positions.
  var _source = source;
  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;
  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }
      return list;
    }, []);
  }
  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations = void 0;
  if (positions && source) {
    _locations = positions.map(function (pos) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__language_location__["a" /* getLocation */])(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(Object(__WEBPACK_IMPORTED_MODULE_1__language_location__["a" /* getLocation */])(node.loc.source, node.loc.start));
      }
      return list;
    }, []);
  }

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      value: extensions || originalError && originalError.extensions
    }
  });

  // Include (non-enumerable) stack trace.
  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}

GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: { value: GraphQLError },
  name: { value: 'GraphQLError' },
  toString: {
    value: function toString() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__printError__["a" /* printError */])(this);
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_Component){_inherits(Modal,_Component);function Modal(props){_classCallCheck(this,Modal);var _this=_possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).call(this,props));_this.state={hide:false};return _this;}_createClass(Modal,[{key:'render',value:function render(){var _props=this.props,children=_props.children,hide=_props.hide,title=_props.title,close=_props.close,large=_props.large;if(hide)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.container)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.content,large&&__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.large)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.header},title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.close},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-times',onClick:close}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.main},children)));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configs_urls__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configs_urls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__configs_urls__);
var instance=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({baseURL:__WEBPACK_IMPORTED_MODULE_1__configs_urls___default.a.api,withCredentials:true});/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(9);
var normalizeHeaderName = __webpack_require__(405);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(140);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(140);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_Component){_inherits(Modal,_Component);function Modal(props){_classCallCheck(this,Modal);var _this=_possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).call(this,props));_this.state={hide:false};return _this;}_createClass(Modal,[{key:'render',value:function render(){var _props=this.props,header=_props.header,list=_props.list;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.menu},header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,list.map(function(_ref,key){var link=_ref.link,title=_ref.title,body=_ref.body,footer=_ref.footer,active=_ref.active;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:link,key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.box,active&&__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.active)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,body),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.tags},footer)));})));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inMemoryCache__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InMemoryCache", function() { return __WEBPACK_IMPORTED_MODULE_0__inMemoryCache__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultDataIdFromObject", function() { return __WEBPACK_IMPORTED_MODULE_0__inMemoryCache__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__readFromStore__ = __webpack_require__(147);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ID_KEY", function() { return __WEBPACK_IMPORTED_MODULE_1__readFromStore__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "readQueryFromStore", function() { return __WEBPACK_IMPORTED_MODULE_1__readFromStore__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "diffQueryAgainstStore", function() { return __WEBPACK_IMPORTED_MODULE_1__readFromStore__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "assertIdValue", function() { return __WEBPACK_IMPORTED_MODULE_1__readFromStore__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__writeToStore__ = __webpack_require__(146);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "WriteError", function() { return __WEBPACK_IMPORTED_MODULE_2__writeToStore__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "enhanceErrorWithDocument", function() { return __WEBPACK_IMPORTED_MODULE_2__writeToStore__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "writeQueryToStore", function() { return __WEBPACK_IMPORTED_MODULE_2__writeToStore__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "writeResultToStore", function() { return __WEBPACK_IMPORTED_MODULE_2__writeToStore__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "writeSelectionSetToStore", function() { return __WEBPACK_IMPORTED_MODULE_2__writeToStore__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fragmentMatcher__ = __webpack_require__(145);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "HeuristicFragmentMatcher", function() { return __WEBPACK_IMPORTED_MODULE_3__fragmentMatcher__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "IntrospectionFragmentMatcher", function() { return __WEBPACK_IMPORTED_MODULE_3__fragmentMatcher__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objectCache__ = __webpack_require__(82);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ObjectCache", function() { return __WEBPACK_IMPORTED_MODULE_4__objectCache__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaultNormalizedCacheFactory", function() { return __WEBPACK_IMPORTED_MODULE_4__objectCache__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recordingCache__ = __webpack_require__(149);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RecordingCache", function() { return __WEBPACK_IMPORTED_MODULE_5__recordingCache__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "record", function() { return __WEBPACK_IMPORTED_MODULE_5__recordingCache__["b"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjectCache; });
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultNormalizedCacheFactory;
var ObjectCache = /** @class */ (function () {
    function ObjectCache(data) {
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
    }
    ObjectCache.prototype.toObject = function () {
        return this.data;
    };
    ObjectCache.prototype.get = function (dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function (dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function (dataId) {
        this.data[dataId] = undefined;
    };
    ObjectCache.prototype.clear = function () {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function (newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}());

function defaultNormalizedCacheFactory(seed) {
    return new ObjectCache(seed);
}
//# sourceMappingURL=objectCache.js.map

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(153);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = getMutationDefinition;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkDocument;
/* harmony export (immutable) */ __webpack_exports__["h"] = getOperationDefinition;
/* harmony export (immutable) */ __webpack_exports__["i"] = getOperationDefinitionOrDie;
/* harmony export (immutable) */ __webpack_exports__["j"] = getOperationName;
/* harmony export (immutable) */ __webpack_exports__["e"] = getFragmentDefinitions;
/* harmony export (immutable) */ __webpack_exports__["k"] = getQueryDefinition;
/* harmony export (immutable) */ __webpack_exports__["d"] = getFragmentDefinition;
/* harmony export (immutable) */ __webpack_exports__["f"] = getMainDefinition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createFragmentMap;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDefaultValues;
/* harmony export (immutable) */ __webpack_exports__["l"] = variablesInOperation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_assign__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storeUtils__ = __webpack_require__(58);


function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
    if (!mutationDef) {
        throw new Error('Must contain a mutation definition.');
    }
    return mutationDef;
}
// Checks the document for errors and throws an exception if there is an error.
function checkDocument(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw new Error("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
        }
        return definition;
    });
    if (operations.length > 1) {
        throw new Error("Ambiguous GraphQL document: contains " + operations.length + " operations");
    }
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
    if (!def) {
        throw new Error("GraphQL document is missing an operation");
    }
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
// Returns the FragmentDefinitions from a particular document as an array
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    if (!queryDef || queryDef.operation !== 'query') {
        throw new Error('Must contain a query definition.');
    }
    return queryDef;
}
function getFragmentDefinition(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    if (doc.definitions.length > 1) {
        throw new Error('Fragment must have exactly one definition.');
    }
    var fragmentDef = doc.definitions[0];
    if (fragmentDef.kind !== 'FragmentDefinition') {
        throw new Error('Must be a fragment definition.');
    }
    return fragmentDef;
}
/**
 * Returns the first operation definition found in this document.
 * If no operation definition is found, the first fragment definition will be returned.
 * If no definitions are found, an error will be thrown.
 */
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            // we do this because we want to allow multiple fragment definitions
            // to precede an operation definition.
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw new Error('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
}
// Utility function that takes a list of fragment definitions and makes a hash out of them
// that maps the name of the fragment to the fragment definition.
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            Object(__WEBPACK_IMPORTED_MODULE_1__storeUtils__["m" /* valueToObjectRepresentation */])(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return __WEBPACK_IMPORTED_MODULE_0__util_assign__["a" /* assign */].apply(void 0, [{}].concat(defaultValues));
    }
    return {};
}
/**
 * Returns the names of all variables declared by the operation.
 */
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}
//# sourceMappingURL=getFromAST.js.map

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}
//# sourceMappingURL=assign.js.map

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneDeep;
/**
 * Deeply clones a value to create a new instance.
 */
function cloneDeep(value) {
    // If the value is an array, create a new array where every item has been cloned.
    if (Array.isArray(value)) {
        return value.map(function (item) { return cloneDeep(item); });
    }
    // If the value is an object, go through all of the object’s properties and add them to a new
    // object.
    if (value !== null && typeof value === 'object') {
        var nextValue = {};
        for (var key in value) {
            if (value.hasOwnProperty(key)) {
                nextValue[key] = cloneDeep(value[key]);
            }
        }
        return nextValue;
    }
    // Otherwise this is some primitive value and it is therefore immutable so we can just return it
    // directly.
    return value;
}
//# sourceMappingURL=cloneDeep.js.map

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(184);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// This simplified polyfill attempts to follow the ECMAScript Observable proposal.
// See https://github.com/zenparsing/es-observable


// rxjs interopt
var Observable = /** @class */ (function (_super) {
    __extends(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
        return this;
    };
    Observable.prototype['@@observable'] = function () {
        return this;
    };
    return Observable;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"]));

//# sourceMappingURL=Observable.js.map

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_zen_observable__);

var Observable = __WEBPACK_IMPORTED_MODULE_0_zen_observable___default.a;
//# sourceMappingURL=zenObservable.js.map

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = validateOperation;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkError; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isTerminating;
/* harmony export (immutable) */ __webpack_exports__["g"] = toPromise;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makePromise; });
/* harmony export (immutable) */ __webpack_exports__["d"] = fromPromise;
/* harmony export (immutable) */ __webpack_exports__["c"] = fromError;
/* harmony export (immutable) */ __webpack_exports__["h"] = transformOperation;
/* harmony export (immutable) */ __webpack_exports__["b"] = createOperation;
/* unused harmony export getKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_language_printer__ = __webpack_require__(21);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw new Error("illegal argument: " + key);
        }
    }
    return operation;
}
var LinkError = /** @class */ (function (_super) {
    __extends(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));

function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    console.warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
// backwards compat
var makePromise = toPromise;
function fromPromise(promise) {
    return new __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__["a" /* default */](function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__["a" /* default */](function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    // best guess at an operation name
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["getOperationName"])(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = __assign({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = __assign({}, context, next(context));
        }
        else {
            context = __assign({}, context, next);
        }
    };
    var getContext = function () { return (__assign({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    // XXX we're assuming here that variables will be serialized in the same order.
    // that might not always be true
    return Object(__WEBPACK_IMPORTED_MODULE_2_graphql_language_printer__["a" /* print */])(operation.query) + "|" + JSON.stringify(operation.variables) + "|" + operation.operationName;
}
//# sourceMappingURL=linkUtils.js.map

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(205);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(206),
    shortOut = __webpack_require__(212);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(213),
    noop = __webpack_require__(214);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18),
    root = __webpack_require__(13);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(215);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getConvoName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return channelLogo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var getConvoName=function getConvoName(users){if(!users.length||!users[0].user)return"";var _users$0$user=users[0].user,first_name=_users$0$user.first_name,last_name=_users$0$user.last_name,phone_number=_users$0$user.phone_number,email=_users$0$user.email;if(first_name)return first_name+" "+last_name;else if(email)return email;else if(phone_number)phone_number;else return"";};var channelLogo=function channelLogo(channel){switch(channel){case"EMAIL":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"far fa-envelope"});case"SMS":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-mobile-alt"});case"MESSENGER":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-facebook-messenger"});case"WEBSITE":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-globe-americas"});default:return null;}};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(43),
    _assign = __webpack_require__(15);

var ReactNoopUpdateQueue = __webpack_require__(104);

var canDefineProperty = __webpack_require__(105);
var emptyObject = __webpack_require__(37);
var invariant = __webpack_require__(11);
var lowPriorityWarning = __webpack_require__(235);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(44);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject2 = __webpack_require__(10);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isArray2 = __webpack_require__(5);

var _isArray3 = _interopRequireDefault(_isArray2);

var _forEach2 = __webpack_require__(109);

var _forEach3 = _interopRequireDefault(_forEach2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectUnfreeze = __webpack_require__(268);

var _objectUnfreeze2 = _interopRequireDefault(_objectUnfreeze);

var _isIterable = __webpack_require__(269);

var _isIterable2 = _interopRequireDefault(_isIterable);

var _parseStyleName = __webpack_require__(270);

var _parseStyleName2 = _interopRequireDefault(_parseStyleName);

var _generateAppendClassName = __webpack_require__(341);

var _generateAppendClassName2 = _interopRequireDefault(_generateAppendClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var linkArray = function linkArray(array, styles, configuration) {
  (0, _forEach3.default)(array, function (value, index) {
    if (_react2.default.isValidElement(value)) {
      // eslint-disable-next-line no-use-before-define
      array[index] = linkElement(_react2.default.Children.only(value), styles, configuration);
    } else if ((0, _isArray3.default)(value)) {
      array[index] = linkArray(value, styles, configuration);
    }
  });

  return array;
};

var linkElement = function linkElement(element, styles, configuration) {
  var appendClassName = void 0;
  var elementShallowCopy = void 0;

  elementShallowCopy = element;

  if (Array.isArray(elementShallowCopy)) {
    return elementShallowCopy.map(function (arrayElement) {
      return linkElement(arrayElement, styles, configuration);
    });
  }

  var elementIsFrozen = Object.isFrozen && Object.isFrozen(elementShallowCopy);
  var propsFrozen = Object.isFrozen && Object.isFrozen(elementShallowCopy.props);
  var propsNotExtensible = Object.isExtensible && !Object.isExtensible(elementShallowCopy.props);

  if (elementIsFrozen) {
    // https://github.com/facebook/react/blob/v0.13.3/src/classic/element/ReactElement.js#L131
    elementShallowCopy = (0, _objectUnfreeze2.default)(elementShallowCopy);
    elementShallowCopy.props = (0, _objectUnfreeze2.default)(elementShallowCopy.props);
  } else if (propsFrozen || propsNotExtensible) {
    elementShallowCopy.props = (0, _objectUnfreeze2.default)(elementShallowCopy.props);
  }

  var styleNames = (0, _parseStyleName2.default)(elementShallowCopy.props.styleName || '', configuration.allowMultiple);

  var _elementShallowCopy$p = elementShallowCopy.props,
      children = _elementShallowCopy$p.children,
      restProps = _objectWithoutProperties(_elementShallowCopy$p, ['children']);

  if (_react2.default.isValidElement(children)) {
    elementShallowCopy.props.children = linkElement(_react2.default.Children.only(children), styles, configuration);
  } else if ((0, _isArray3.default)(children) || (0, _isIterable2.default)(children)) {
    elementShallowCopy.props.children = _react2.default.Children.map(children, function (node) {
      if (_react2.default.isValidElement(node)) {
        // eslint-disable-next-line no-use-before-define
        return linkElement(_react2.default.Children.only(node), styles, configuration);
      } else {
        return node;
      }
    });
  }

  (0, _forEach3.default)(restProps, function (propValue, propName) {
    if (_react2.default.isValidElement(propValue)) {
      elementShallowCopy.props[propName] = linkElement(_react2.default.Children.only(propValue), styles, configuration);
    } else if ((0, _isArray3.default)(propValue)) {
      elementShallowCopy.props[propName] = linkArray(propValue, styles, configuration);
    }
  });

  if (styleNames.length) {
    appendClassName = (0, _generateAppendClassName2.default)(styles, styleNames, configuration.handleNotFoundStyleName);

    if (appendClassName) {
      if (elementShallowCopy.props.className) {
        appendClassName = elementShallowCopy.props.className + ' ' + appendClassName;
      }

      elementShallowCopy.props.className = appendClassName;
    }
  }

  delete elementShallowCopy.props.styleName;

  if (elementIsFrozen) {
    Object.freeze(elementShallowCopy.props);
    Object.freeze(elementShallowCopy);
  } else if (propsFrozen) {
    Object.freeze(elementShallowCopy.props);
  }

  if (propsNotExtensible) {
    Object.preventExtensions(elementShallowCopy.props);
  }

  return elementShallowCopy;
};

/**
 * @param {ReactElement} element
 * @param {Object} styles CSS modules class map.
 * @param {CSSModules~Options} configuration
 */

exports.default = function (element) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var configuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // @see https://github.com/gajus/react-css-modules/pull/30
  if (!(0, _isObject3.default)(element)) {
    return element;
  }

  return linkElement(element, styles, configuration);
};

module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(253),
    baseEach = __webpack_require__(110),
    castFunction = __webpack_require__(267),
    isArray = __webpack_require__(5);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(254),
    createBaseEach = __webpack_require__(266);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(13),
    stubFalse = __webpack_require__(259);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)(module)))

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(260),
    baseUnary = __webpack_require__(261),
    nodeUtil = __webpack_require__(262);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(45),
    stackClear = __webpack_require__(281),
    stackDelete = __webpack_require__(282),
    stackGet = __webpack_require__(283),
    stackHas = __webpack_require__(284),
    stackSet = __webpack_require__(285);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(298),
    isObjectLike = __webpack_require__(16);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(299),
    arraySome = __webpack_require__(302),
    cacheHas = __webpack_require__(303);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(121),
    toKey = __webpack_require__(51);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(5),
    isKey = __webpack_require__(70),
    stringToPath = __webpack_require__(320),
    toString = __webpack_require__(122);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(123);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(28),
    arrayMap = __webpack_require__(124),
    isArray = __webpack_require__(5),
    isSymbol = __webpack_require__(50);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (version) {
  var major = version.split('.')[0];

  return parseInt(major, 10) < 15 ? _react2.default.createElement('noscript') : null;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(127),
    eq = __webpack_require__(47);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(97);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(24);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(132);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(75);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(369)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invariant;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function invariant(condition, message) {
  /* istanbul ignore else */
  if (!condition) {
    throw new Error(message);
  }
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(76);
/* unused harmony reexport GraphQLError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syntaxError__ = __webpack_require__(384);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__syntaxError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locatedError__ = __webpack_require__(385);
/* unused harmony reexport locatedError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__printError__ = __webpack_require__(137);
/* unused harmony reexport printError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatError__ = __webpack_require__(386);
/* unused harmony reexport formatError */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */







/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = printError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_location__ = __webpack_require__(138);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */
function printError(error) {
  var printedLocations = [];
  if (error.nodes) {
    error.nodes.forEach(function (node) {
      if (node.loc) {
        printedLocations.push(highlightSourceAtLocation(node.loc.source, Object(__WEBPACK_IMPORTED_MODULE_0__language_location__["a" /* getLocation */])(node.loc.source, node.loc.start)));
      }
    });
  } else if (error.source && error.locations) {
    var source = error.source;
    error.locations.forEach(function (location) {
      printedLocations.push(highlightSourceAtLocation(source, location));
    });
  }
  return printedLocations.length === 0 ? error.message : [error.message].concat(printedLocations).join('\n\n') + '\n';
}

/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */
function highlightSourceAtLocation(source, location) {
  var line = location.line;
  var lineOffset = source.locationOffset.line - 1;
  var columnOffset = getColumnOffset(source, location);
  var contextLine = line + lineOffset;
  var contextColumn = location.column + columnOffset;
  var prevLineNum = (contextLine - 1).toString();
  var lineNum = contextLine.toString();
  var nextLineNum = (contextLine + 1).toString();
  var padLen = nextLineNum.length;
  var lines = source.body.split(/\r\n|[\n\r]/g);
  lines[0] = whitespace(source.locationOffset.column - 1) + lines[0];
  var outputLines = [source.name + ' (' + contextLine + ':' + contextColumn + ')', line >= 2 && lpad(padLen, prevLineNum) + ': ' + lines[line - 2], lpad(padLen, lineNum) + ': ' + lines[line - 1], whitespace(2 + padLen + contextColumn - 1) + '^', line < lines.length && lpad(padLen, nextLineNum) + ': ' + lines[line]];
  return outputLines.filter(Boolean).join('\n');
}

function getColumnOffset(source, location) {
  return location.line === 1 ? source.locationOffset.column - 1 : 0;
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocation;


/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match = void 0;
  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }
  return { line: line, column: column };
}

/**
 * Represents a location in a Source.
 */

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var settle = __webpack_require__(406);
var buildURL = __webpack_require__(408);
var parseHeaders = __webpack_require__(409);
var isURLSameOrigin = __webpack_require__(410);
var createError = __webpack_require__(141);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(411);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(412);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(407);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_Component){_inherits(Modal,_Component);function Modal(props){_classCallCheck(this,Modal);var _this=_possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).call(this,props));_this.state={index:0};return _this;}_createClass(Modal,[{key:'render',value:function render(){var _this2=this;var tabs=this.props.tabs;var index=this.state.index;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.tabs},tabs.map(function(_ref,i){var name=_ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.tab,i===index&&__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.active),key:i,onClick:function onClick(){return _this2.setState({index:i});}},name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.content},tabs[index].content));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeuristicFragmentMatcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntrospectionFragmentMatcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(4);

var haveWarned = false;
/**
 * This fragment matcher is very basic and unable to match union or interface type conditions
 */
var HeuristicFragmentMatcher = /** @class */ (function () {
    function HeuristicFragmentMatcher() {
        // do nothing
    }
    HeuristicFragmentMatcher.prototype.ensureReady = function () {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function () {
        return true; // we don't need to initialize this fragment matcher.
    };
    HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        if (!obj && idValue.id === 'ROOT_QUERY') {
            return true;
        }
        if (!obj) {
            return false;
        }
        if (!obj.__typename) {
            if (!haveWarned) {
                console.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
                console.warn('Could not find __typename on Fragment ', typeCondition, obj);
                console.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior " +
                    "and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
                /* istanbul ignore if */
                if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["isTest"])()) {
                    // When running tests, we want to print the warning every time
                    haveWarned = true;
                }
            }
            context.returnPartialData = true;
            return true;
        }
        if (obj.__typename === typeCondition) {
            return true;
        }
        // XXX here we reach an issue - we don't know if this fragment should match or not. It's either:
        // 1. A fragment on a non-matching concrete type or interface or union
        // 2. A fragment on a matching interface or union
        // If it's 1, we don't want to return anything, if it's 2 we want to match. We can't tell the
        // difference, so we warn the user, but still try to match it (backcompat).
        Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["warnOnceInDevelopment"])("You are using the simple (heuristic) fragment matcher, but your queries contain union or interface types.\n     Apollo Client will not be able to able to accurately map fragments." +
            "To make this error go away, use the IntrospectionFragmentMatcher as described in the docs: " +
            "https://www.apollographql.com/docs/react/recipes/fragment-matching.html", 'error');
        context.returnPartialData = true;
        return true;
    };
    return HeuristicFragmentMatcher;
}());

var IntrospectionFragmentMatcher = /** @class */ (function () {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        }
        else {
            this.isReady = false;
        }
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        if (!this.isReady) {
            // this should basically never happen in proper use.
            throw new Error('FragmentMatcher.match() was called before FragmentMatcher.init()');
        }
        var obj = context.store.get(idValue.id);
        if (!obj) {
            return false;
        }
        if (!obj.__typename) {
            throw new Error("Cannot match fragment because __typename property is missing: " + JSON.stringify(obj));
        }
        if (obj.__typename === typeCondition) {
            return true;
        }
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (implementingTypes && implementingTypes.indexOf(obj.__typename) > -1) {
            return true;
        }
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function (type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
                typeMap[type.name] = type.possibleTypes.map(function (implementingType) { return implementingType.name; });
            }
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}());

//# sourceMappingURL=fragmentMatcher.js.map

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WriteError; });
/* harmony export (immutable) */ __webpack_exports__["b"] = enhanceErrorWithDocument;
/* harmony export (immutable) */ __webpack_exports__["c"] = writeQueryToStore;
/* harmony export (immutable) */ __webpack_exports__["d"] = writeResultToStore;
/* harmony export (immutable) */ __webpack_exports__["e"] = writeSelectionSetToStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectCache__ = __webpack_require__(82);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var WriteError = /** @class */ (function (_super) {
    __extends(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error));

function enhanceErrorWithDocument(error, document) {
    // XXX A bit hacky maybe ...
    var enhancedError = new WriteError("Error writing result to store for query:\n " + Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
/**
 * Writes the result of a query to the store.
 *
 * @param result The result object returned for the query document.
 *
 * @param query The query document whose result we are writing to the store.
 *
 * @param store The {@link NormalizedCache} used by Apollo for the `data` portion of the store.
 *
 * @param variables A map from the name of a variable to its value. These variables can be
 * referenced by the query document.
 *
 * @param dataIdFromObject A function that returns an object identifier given a particular result
 * object. See the store documentation for details and an example of this function.
 *
 * @param fragmentMap A map from the name of a fragment to its fragment definition. These fragments
 * can be referenced within the query document.
 *
 * @param fragmentMatcherFunction A function to use for matching fragment conditions in GraphQL documents
 */
function writeQueryToStore(_a) {
    var result = _a.result, query = _a.query, _b = _a.storeFactory, storeFactory = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__objectCache__["b" /* defaultNormalizedCacheFactory */] : _b, _c = _a.store, store = _c === void 0 ? storeFactory() : _c, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, _d = _a.fragmentMap, fragmentMap = _d === void 0 ? {} : _d, fragmentMatcherFunction = _a.fragmentMatcherFunction;
    var queryDefinition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getQueryDefinition"])(query);
    variables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["assign"])({}, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getDefaultValues"])(queryDefinition), variables);
    try {
        return writeSelectionSetToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            selectionSet: queryDefinition.selectionSet,
            context: {
                store: store,
                storeFactory: storeFactory,
                processedData: {},
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMap: fragmentMap,
                fragmentMatcherFunction: fragmentMatcherFunction,
            },
        });
    }
    catch (e) {
        throw enhanceErrorWithDocument(e, query);
    }
}
function writeResultToStore(_a) {
    var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.storeFactory, storeFactory = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__objectCache__["b" /* defaultNormalizedCacheFactory */] : _b, _c = _a.store, store = _c === void 0 ? storeFactory() : _c, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
    // XXX TODO REFACTOR: this is a temporary workaround until query normalization is made to work with documents.
    var operationDefinition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getOperationDefinition"])(document);
    var selectionSet = operationDefinition.selectionSet;
    var fragmentMap = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["createFragmentMap"])(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getFragmentDefinitions"])(document));
    variables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["assign"])({}, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getDefaultValues"])(operationDefinition), variables);
    try {
        return writeSelectionSetToStore({
            result: result,
            dataId: dataId,
            selectionSet: selectionSet,
            context: {
                store: store,
                storeFactory: storeFactory,
                processedData: {},
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMap: fragmentMap,
                fragmentMatcherFunction: fragmentMatcherFunction,
            },
        });
    }
    catch (e) {
        throw enhanceErrorWithDocument(e, document);
    }
}
function writeSelectionSetToStore(_a) {
    var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
    var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
    selectionSet.selections.forEach(function (selection) {
        var included = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["shouldInclude"])(selection, variables);
        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isField"])(selection)) {
            var resultFieldKey = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["resultKeyNameFromField"])(selection);
            var value = result[resultFieldKey];
            if (included) {
                if (typeof value !== 'undefined') {
                    writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context,
                    });
                }
                else {
                    // if this is a defered field we don't need to throw / warn
                    var isDefered = selection.directives &&
                        selection.directives.length &&
                        selection.directives.some(function (directive) { return directive.name && directive.name.value === 'defer'; });
                    if (!isDefered && context.fragmentMatcherFunction) {
                        // XXX We'd like to throw an error, but for backwards compatibility's sake
                        // we just print a warning for the time being.
                        //throw new WriteError(`Missing field ${resultFieldKey} in ${JSON.stringify(result, null, 2).substring(0, 100)}`);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isProduction"])()) {
                            console.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
                        }
                    }
                }
            }
        }
        else {
            // This is not a field, so it must be a fragment, either inline or named
            var fragment = void 0;
            if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isInlineFragment"])(selection)) {
                fragment = selection;
            }
            else {
                // Named fragment
                fragment = (fragmentMap || {})[selection.name.value];
                if (!fragment) {
                    throw new Error("No fragment named " + selection.name.value + ".");
                }
            }
            var matches = true;
            if (context.fragmentMatcherFunction && fragment.typeCondition) {
                // TODO we need to rewrite the fragment matchers for this to work properly and efficiently
                // Right now we have to pretend that we're passing in an idValue and that there's a store
                // on the context.
                var idValue = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["toIdValue"])({ id: 'self', typename: undefined });
                var fakeContext = {
                    // NOTE: fakeContext always uses ObjectCache
                    // since this is only to ensure the return value of 'matches'
                    store: new __WEBPACK_IMPORTED_MODULE_2__objectCache__["a" /* ObjectCache */]({ self: result }),
                    returnPartialData: false,
                    hasMissingField: false,
                    cacheRedirects: {},
                };
                matches = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isProduction"])() && fakeContext.returnPartialData) {
                    console.error('WARNING: heuristic fragment matching going on!');
                }
            }
            if (included && matches) {
                writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context,
                });
            }
        }
    });
    return store;
}
// Checks if the id given is an id that was generated by Apollo
// rather than by dataIdFromObject.
function isGeneratedId(id) {
    return id[0] === '$';
}
function mergeWithGenerated(generatedKey, realKey, cache) {
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    Object.keys(generated).forEach(function (key) {
        var value = generated[key];
        var realValue = real[key];
        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isIdValue"])(value) && isGeneratedId(value.id) && Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isIdValue"])(realValue)) {
            mergeWithGenerated(value.id, realValue.id, cache);
        }
        cache.delete(generatedKey);
        cache.set(realKey, __assign({}, generated, real));
    });
}
function isDataProcessed(dataId, field, processedData) {
    if (!processedData) {
        return false;
    }
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) {
            return true;
        }
        else {
            processedData[dataId].push(field);
        }
    }
    else {
        processedData[dataId] = [field];
    }
    return false;
}
function writeFieldToStore(_a) {
    var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
    var _b;
    var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
    var storeValue;
    var storeObject;
    var storeFieldName = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["storeKeyNameFromField"])(field, variables);
    // specifies if we need to merge existing keys in the store
    var shouldMerge = false;
    // If we merge, this will be the generatedKey
    var generatedKey = '';
    // If this is a scalar value...
    if (!field.selectionSet || value === null) {
        storeValue =
            value != null && typeof value === 'object'
                ? // If the scalar value is a JSON blob, we have to "escape" it so it can’t pretend to be
                    // an id.
                    { type: 'json', json: value }
                : // Otherwise, just store the scalar directly in the store.
                    value;
    }
    else if (Array.isArray(value)) {
        var generatedId = dataId + "." + storeFieldName;
        storeValue = processArrayValue(value, generatedId, field.selectionSet, context);
    }
    else {
        // It's an object
        var valueDataId = dataId + "." + storeFieldName;
        var generated = true;
        // We only prepend the '$' if the valueDataId isn't already a generated
        // id.
        if (!isGeneratedId(valueDataId)) {
            valueDataId = '$' + valueDataId;
        }
        if (dataIdFromObject) {
            var semanticId = dataIdFromObject(value);
            // We throw an error if the first character of the id is '$. This is
            // because we use that character to designate an Apollo-generated id
            // and we use the distinction between user-desiginated and application-provided
            // ids when managing overwrites.
            if (semanticId && isGeneratedId(semanticId)) {
                throw new Error('IDs returned by dataIdFromObject cannot begin with the "$" character.');
            }
            if (semanticId || (typeof semanticId === 'number' && semanticId === 0)) {
                valueDataId = semanticId;
                generated = false;
            }
        }
        if (!isDataProcessed(valueDataId, field, context.processedData)) {
            writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context,
            });
        }
        // We take the id and escape it (i.e. wrap it with an enclosing object).
        // This allows us to distinguish IDs from normal scalars.
        var typename = value.__typename;
        storeValue = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["toIdValue"])({ id: valueDataId, typename: typename }, generated);
        // check if there was a generated id at the location where we're
        // about to place this new id. If there was, we have to merge the
        // data from that id with the data we're about to write in the store.
        storeObject = store.get(dataId);
        var escapedId = storeObject && storeObject[storeFieldName];
        if (escapedId !== storeValue && Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isIdValue"])(escapedId)) {
            var hadTypename = escapedId.typename !== undefined;
            var hasTypename = typename !== undefined;
            var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
            // If there is already a real id in the store and the current id we
            // are dealing with is generated, we throw an error.
            // One exception we allow is when the typename has changed, which occurs
            // when schema defines a union, both with and without an ID in the same place.
            // checks if we "lost" the read id
            if (generated && !escapedId.generated && !typenameChanged) {
                throw new Error("Store error: the application attempted to write an object with no provided id" +
                    (" but the store already contains an id of " + escapedId.id + " for this object. The selectionSet") +
                    " that was trying to be written is:\n" +
                    Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(field));
            }
            // checks if we "lost" the typename
            if (hadTypename && !hasTypename) {
                throw new Error("Store error: the application attempted to write an object with no provided typename" +
                    (" but the store already contains an object with typename of " + escapedId.typename + " for the object of id " + escapedId.id + ". The selectionSet") +
                    " that was trying to be written is:\n" +
                    Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(field));
            }
            if (escapedId.generated) {
                generatedKey = escapedId.id;
                // We should only merge if it's an object of the same type,
                // otherwise we should delete the generated object
                if (typenameChanged) {
                    // Only delete the generated object when the old object was
                    // inlined, and the new object is not. This is indicated by
                    // the old id being generated, and the new id being real.
                    if (!generated) {
                        store.delete(generatedKey);
                    }
                }
                else {
                    shouldMerge = true;
                }
            }
        }
    }
    var newStoreObj = __assign({}, store.get(dataId), (_b = {}, _b[storeFieldName] = storeValue, _b));
    if (shouldMerge) {
        mergeWithGenerated(generatedKey, storeValue.id, store);
    }
    storeObject = store.get(dataId);
    if (!storeObject || storeValue !== storeObject[storeFieldName]) {
        store.set(dataId, newStoreObj);
    }
}
function processArrayValue(value, generatedId, selectionSet, context) {
    return value.map(function (item, index) {
        if (item === null) {
            return null;
        }
        var itemDataId = generatedId + "." + index;
        if (Array.isArray(item)) {
            return processArrayValue(item, itemDataId, selectionSet, context);
        }
        var generated = true;
        if (context.dataIdFromObject) {
            var semanticId = context.dataIdFromObject(item);
            if (semanticId) {
                itemDataId = semanticId;
                generated = false;
            }
        }
        if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
            writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context,
            });
        }
        return Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["toIdValue"])({ id: itemDataId, typename: item.__typename }, generated);
    });
}
//# sourceMappingURL=writeToStore.js.map

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_KEY; });
/* harmony export (immutable) */ __webpack_exports__["d"] = readQueryFromStore;
/* harmony export (immutable) */ __webpack_exports__["c"] = diffQueryAgainstStore;
/* harmony export (immutable) */ __webpack_exports__["b"] = assertIdValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_anywhere__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(4);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


/**
 * The key which the cache id for a given value is stored in the result object. This key is private
 * and should not be used by Apollo client users.
 *
 * Uses a symbol if available in the environment.
 *
 * @private
 */
var ID_KEY = typeof Symbol !== 'undefined' ? Symbol('id') : '@@id';
/**
 * Resolves the result of a query solely from the store (i.e. never hits the server).
 *
 * @param {Store} store The {@link NormalizedCache} used by Apollo for the `data` portion of the
 * store.
 *
 * @param {DocumentNode} query The query document to resolve from the data available in the store.
 *
 * @param {Object} [variables] A map from the name of a variable to its value. These variables can
 * be referenced by the query document.
 *
 * @param {any} previousResult The previous result returned by this function for the same query.
 * If nothing in the store changed since that previous result then values from the previous result
 * will be returned to preserve referential equality.
 */
function readQueryFromStore(options) {
    var optsPatch = { returnPartialData: false };
    return diffQueryAgainstStore(__assign({}, options, optsPatch)).result;
}
var readStoreResolver = function (fieldName, idValue, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    assertIdValue(idValue);
    var objId = idValue.id;
    var obj = context.store.get(objId);
    var storeKeyName = fieldName;
    if (args || directives) {
        // We happen to know here that getStoreKeyName returns its first
        // argument unmodified if there are no args or directives, so we can
        // avoid calling the function at all in that case, as a small but
        // important optimization to this frequently executed code.
        storeKeyName = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getStoreKeyName"])(storeKeyName, args, directives);
    }
    var fieldValue = void 0;
    if (obj) {
        fieldValue = obj[storeKeyName];
        if (typeof fieldValue === 'undefined' &&
            context.cacheRedirects &&
            (obj.__typename || objId === 'ROOT_QUERY')) {
            var typename = obj.__typename || 'Query';
            // Look for the type in the custom resolver map
            var type = context.cacheRedirects[typename];
            if (type) {
                // Look for the field in the custom resolver map
                var resolver = type[fieldName];
                if (resolver) {
                    fieldValue = resolver(obj, args, {
                        getCacheKey: function (storeObj) {
                            return Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["toIdValue"])({
                                id: context.dataIdFromObject(storeObj),
                                typename: storeObj.__typename,
                            });
                        },
                    });
                }
            }
        }
    }
    if (typeof fieldValue === 'undefined') {
        if (!context.returnPartialData) {
            throw new Error("Can't find field " + storeKeyName + " on object (" + objId + ") " + JSON.stringify(obj, null, 2) + ".");
        }
        context.hasMissingField = true;
        return fieldValue;
    }
    // if this is an object scalar, it must be a json blob and we have to unescape it
    if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isJsonValue"])(fieldValue)) {
        // If the JSON blob is the same now as in the previous result, return the previous result to
        // maintain referential equality.
        //
        // `isEqual` will first perform a referential equality check (with `===`) in case the JSON
        // value has not changed in the store, and then a deep equality check if that fails in case a
        // new JSON object was returned by the API but that object may still be the same.
        if (idValue.previousResult &&
            Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isEqual"])(idValue.previousResult[resultKey], fieldValue.json)) {
            return idValue.previousResult[resultKey];
        }
        return fieldValue.json;
    }
    // If we had a previous result, try adding that previous result value for this field to our field
    // value. This will create a new value without mutating the old one.
    if (idValue.previousResult) {
        fieldValue = addPreviousResultToIdValues(fieldValue, idValue.previousResult[resultKey]);
    }
    return fieldValue;
};
/**
 * Given a store and a query, return as much of the result as possible and
 * identify if any data was missing from the store.
 * @param  {DocumentNode} query A parsed GraphQL query document
 * @param  {Store} store The Apollo Client store object
 * @param  {any} previousResult The previous result returned by this function for the same query
 * @return {result: Object, complete: [boolean]}
 */
function diffQueryAgainstStore(_a) {
    var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
    // Throw the right validation error by trying to find a query in the document
    var queryDefinition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getQueryDefinition"])(query);
    variables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["assign"])({}, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getDefaultValues"])(queryDefinition), variables);
    var context = {
        // Global settings
        store: store,
        returnPartialData: returnPartialData,
        dataIdFromObject: (config && config.dataIdFromObject) || null,
        cacheRedirects: (config && config.cacheRedirects) || {},
        // Flag set during execution
        hasMissingField: false,
    };
    var rootIdValue = {
        type: 'id',
        id: rootId,
        previousResult: previousResult,
    };
    var result = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_anywhere__["a" /* default */])(readStoreResolver, query, rootIdValue, context, variables, {
        fragmentMatcher: fragmentMatcherFunction,
        resultMapper: resultMapper,
    });
    return {
        result: result,
        complete: !context.hasMissingField,
    };
}
function assertIdValue(idValue) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isIdValue"])(idValue)) {
        throw new Error("Encountered a sub-selection on the query, but the store doesn't have an object reference. This should never happen during normal use unless you have custom code that is directly manipulating the store; please file an issue.");
    }
}
/**
 * Adds a previous result value to id values in a nested array. For a single id value and a single
 * previous result then the previous value is added directly.
 *
 * For arrays we put all of the ids from the previous result array in a map and add them to id
 * values with the same id.
 *
 * This function does not mutate. Instead it returns new instances of modified values.
 *
 * @private
 */
function addPreviousResultToIdValues(value, previousResult) {
    // If the value is an `IdValue`, add the previous result to it whether or not that
    // `previousResult` is undefined.
    //
    // If the value is an array, recurse over each item trying to add the `previousResult` for that
    // item.
    if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isIdValue"])(value)) {
        return __assign({}, value, { previousResult: previousResult });
    }
    else if (Array.isArray(value)) {
        var idToPreviousResult_1 = new Map();
        // If the previous result was an array, we want to build up our map of ids to previous results
        // using the private `ID_KEY` property that is added in `resultMapper`.
        if (Array.isArray(previousResult)) {
            previousResult.forEach(function (item) {
                // item can be null
                if (item && item[ID_KEY]) {
                    idToPreviousResult_1.set(item[ID_KEY], item);
                    // idToPreviousResult[item[ID_KEY]] = item;
                }
            });
        }
        // For every value we want to add the previous result.
        return value.map(function (item, i) {
            // By default the previous result for this item will be in the same array position as this
            // item.
            var itemPreviousResult = previousResult && previousResult[i];
            // If the item is an id value, we should check to see if there is a previous result for this
            // specific id. If there is, that will be the value for `itemPreviousResult`.
            if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isIdValue"])(item)) {
                itemPreviousResult =
                    idToPreviousResult_1.get(item.id) || itemPreviousResult;
            }
            return addPreviousResultToIdValues(item, itemPreviousResult);
        });
    }
    // Return the value, nothing changed.
    return value;
}
/**
 * Maps a result from `graphql-anywhere` to a final result value.
 *
 * If the result and the previous result from the `idValue` pass a shallow equality test, we just
 * return the `previousResult` to maintain referential equality.
 *
 * We also add a private id property to the result that we can use later on.
 *
 * @private
 */
function resultMapper(resultFields, idValue) {
    // If we had a previous result, we may be able to return that and preserve referential equality
    if (idValue.previousResult) {
        var currentResultKeys_1 = Object.keys(resultFields);
        var sameAsPreviousResult = 
        // Confirm that we have the same keys in both the current result and the previous result.
        Object.keys(idValue.previousResult).every(function (key) { return currentResultKeys_1.indexOf(key) > -1; }) &&
            // Perform a shallow comparison of the result fields with the previous result. If all of
            // the shallow fields are referentially equal to the fields of the previous result we can
            // just return the previous result.
            //
            // While we do a shallow comparison of objects, but we do a deep comparison of arrays.
            currentResultKeys_1.every(function (key) {
                return areNestedArrayItemsStrictlyEqual(resultFields[key], idValue.previousResult[key]);
            });
        if (sameAsPreviousResult) {
            return idValue.previousResult;
        }
    }
    Object.defineProperty(resultFields, ID_KEY, {
        enumerable: false,
        configurable: true,
        writable: false,
        value: idValue.id,
    });
    return resultFields;
}
/**
 * Compare all the items to see if they are all referentially equal in two arrays no matter how
 * deeply nested the arrays are.
 *
 * @private
 */
function areNestedArrayItemsStrictlyEqual(a, b) {
    // If `a` and `b` are referentially equal, return true.
    if (a === b) {
        return true;
    }
    // If either `a` or `b` are not an array or not of the same length return false. `a` and `b` are
    // known to not be equal here, we checked above.
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
        return false;
    }
    // Otherwise let us compare all of the array items (which are potentially nested arrays!) to see
    // if they are equal.
    return a.every(function (item, i) { return areNestedArrayItemsStrictlyEqual(item, b[i]); });
}
//# sourceMappingURL=readFromStore.js.map

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = graphql;
/* unused harmony export merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(4);

/* Based on graphql function from graphql-js:
 *
 * graphql(
 *   schema: GraphQLSchema,
 *   requestString: string,
 *   rootValue?: ?any,
 *   contextValue?: ?any,
 *   variableValues?: ?{[key: string]: any},
 *   operationName?: ?string
 * ): Promise<GraphQLResult>
 *
 * The default export as of graphql-anywhere is sync as of 4.0,
 * but below is an exported alternative that is async.
 * In the 5.0 version, this will be the only export again
 * and it will be async
 *
 */
function graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) { execOptions = {}; }
    var mainDefinition = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["getMainDefinition"])(document);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["getFragmentDefinitions"])(document);
    var fragmentMap = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["createFragmentMap"])(fragments);
    var resultMapper = execOptions.resultMapper;
    // Default matcher always matches all fragments
    var fragmentMatcher = execOptions.fragmentMatcher || (function () { return true; });
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher,
    };
    return executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
function executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function (selection) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["shouldInclude"])(selection, variables)) {
            // Skip this entirely
            return;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["isField"])(selection)) {
            var fieldResult = executeField(selection, rootValue, execContext);
            var resultFieldKey = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["resultKeyNameFromField"])(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) {
                    result[resultFieldKey] = fieldResult;
                }
                else {
                    merge(result[resultFieldKey], fieldResult);
                }
            }
        }
        else {
            var fragment = void 0;
            if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["isInlineFragment"])(selection)) {
                fragment = selection;
            }
            else {
                // This is a named fragment
                fragment = fragmentMap[selection.name.value];
                if (!fragment) {
                    throw new Error("No fragment named " + selection.name.value);
                }
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) {
        return execContext.resultMapper(result, rootValue);
    }
    return result;
}
function executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["argumentsObjectFromField"])(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["resultKeyNameFromField"])(field),
        directives: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["getDirectiveInfoFromField"])(field, variables),
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    // Handle all scalar types here
    if (!field.selectionSet) {
        return result;
    }
    // From here down, the field has a selection set, which means it's trying to
    // query a GraphQLObjectType
    if (result == null) {
        // Basically any field in a GraphQL response can be null, or missing
        return result;
    }
    if (Array.isArray(result)) {
        return executeSubSelectedArray(field, result, execContext);
    }
    // Returned value is an object, and the query has a sub-selection. Recurse.
    return executeSelectionSet(field.selectionSet, result, execContext);
}
function executeSubSelectedArray(field, result, execContext) {
    return result.map(function (item) {
        // null value in array
        if (item === null) {
            return null;
        }
        // This is a nested array, recurse
        if (Array.isArray(item)) {
            return executeSubSelectedArray(field, item, execContext);
        }
        // This is an object, run the selection set on it
        return executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var hasOwn = Object.prototype.hasOwnProperty;
function merge(dest, src) {
    if (src !== null && typeof src === 'object') {
        Object.keys(src).forEach(function (key) {
            var srcVal = src[key];
            if (!hasOwn.call(dest, key)) {
                dest[key] = srcVal;
            }
            else {
                merge(dest[key], srcVal);
            }
        });
    }
}
//# sourceMappingURL=graphql.js.map

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RecordingCache; });
/* harmony export (immutable) */ __webpack_exports__["b"] = record;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var RecordingCache = /** @class */ (function () {
    function RecordingCache(data) {
        if (data === void 0) { data = {}; }
        this.data = data;
        this.recordedData = {};
    }
    RecordingCache.prototype.record = function (transaction) {
        transaction(this);
        var recordedData = this.recordedData;
        this.recordedData = {};
        return recordedData;
    };
    RecordingCache.prototype.toObject = function () {
        return __assign({}, this.data, this.recordedData);
    };
    RecordingCache.prototype.get = function (dataId) {
        if (this.recordedData.hasOwnProperty(dataId)) {
            // recording always takes precedence:
            return this.recordedData[dataId];
        }
        return this.data[dataId];
    };
    RecordingCache.prototype.set = function (dataId, value) {
        if (this.get(dataId) !== value) {
            this.recordedData[dataId] = value;
        }
    };
    RecordingCache.prototype.delete = function (dataId) {
        this.recordedData[dataId] = undefined;
    };
    RecordingCache.prototype.clear = function () {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) { return _this.delete(dataId); });
        this.recordedData = {};
    };
    RecordingCache.prototype.replace = function (newData) {
        this.clear();
        this.recordedData = __assign({}, newData);
    };
    return RecordingCache;
}());

function record(startingState, transaction) {
    var recordingCache = new RecordingCache(startingState);
    return recordingCache.record(transaction);
}
//# sourceMappingURL=recordingCache.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(151);
module.exports = __webpack_require__(156);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(152).enable();
  window.Promise = __webpack_require__(154);
}

// fetch() polyfill for making API calls.
__webpack_require__(155);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(15);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(83);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(83);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__ = __webpack_require__(477);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(15),n=__webpack_require__(11),p=__webpack_require__(37),q=__webpack_require__(20),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(159);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(11),ba=__webpack_require__(0),m=__webpack_require__(160),p=__webpack_require__(15),v=__webpack_require__(20),da=__webpack_require__(161),ea=__webpack_require__(38),fa=__webpack_require__(162),ha=__webpack_require__(37);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc=Object.prototype.hasOwnProperty,zc={},Ac={};
function Bc(a){if(xc.call(Ac,a))return!0;if(xc.call(zc,a))return!1;if(wc.test(a))return Ac[a]=!0;zc[a]=!0;return!1}function Cc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Dc(a,b,c,d){if(null===b||"undefined"===typeof b||Cc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Ec=/[\-:]([a-z])/g;function Fc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ec,
Fc);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Gc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Dc(b,c,e,d)&&(c=null),d||null===e?Bc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Hc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Ic(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Jc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Kc(a,b){b=b.checked;null!=b&&Gc(a,"checked",b,!1)}
function Lc(a,b){Kc(a,b);var c=Jc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Mc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Mc(a,b.type,Jc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Nc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Mc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Jc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Oc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Pc(a,b,c){a=H.getPooled(Oc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Qc=null,Rc=null;function Sc(a){Ia(a,!1)}function Tc(a){var b=Oa(a);if(dc(b))return a}
function Uc(a,b){if("change"===a)return b}var Vc=!1;m.canUseDOM&&(Vc=$b("input")&&(!document.documentMode||9<document.documentMode));function Wc(){Qc&&(Qc.detachEvent("onpropertychange",Xc),Rc=Qc=null)}function Xc(a){"value"===a.propertyName&&Tc(Rc)&&(a=Pc(Rc,a,Zb(a)),Wb(Sc,a))}function Yc(a,b,c){"focus"===a?(Wc(),Qc=b,Rc=c,Qc.attachEvent("onpropertychange",Xc)):"blur"===a&&Wc()}function Zc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Tc(Rc)}
function $c(a,b){if("click"===a)return Tc(b)}function ad(a,b){if("input"===a||"change"===a)return Tc(b)}
var bd={eventTypes:Oc,_isInputEventSupported:Vc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Uc:Yb(e)?Vc?f=ad:(f=Zc,g=Yc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=$c);if(f&&(f=f(a,b)))return Pc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Mc(e,"number",e.value)}},cd=H.extend({view:null,detail:null}),dd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function ed(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=dd[a])?!!b[a]:!1}function fd(){return ed}
var gd=cd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:fd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),hd=gd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),id={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},jd={eventTypes:id,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=gd,h=id.mouseLeave,k=id.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=hd,h=id.pointerLeave,k=id.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?A("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function od(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var pd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),qd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),rd=cd.extend({relatedTarget:null});
function sd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var td={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ud={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},vd=cd.extend({key:function(a){if(a.key){var b=td[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=sd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?ud[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:fd,charCode:function(a){return"keypress"===
a.type?sd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?sd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),wd=gd.extend({dataTransfer:null}),xd=cd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:fd}),yd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),zd=gd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Ad=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Bd={},Cd={};function Dd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Bd[a]=b;Cd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Dd(a,!0)});Ad.forEach(function(a){Dd(a,!1)});
var Ed={eventTypes:Bd,isInteractiveTopLevelEventType:function(a){a=Cd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Cd[a];if(!e)return null;switch(a){case "keypress":if(0===sd(c))return null;case "keydown":case "keyup":a=vd;break;case "blur":case "focus":a=rd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=gd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
wd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=xd;break;case fb:case gb:case hb:a=pd;break;case ib:a=yd;break;case "scroll":a=cd;break;case "wheel":a=zd;break;case "copy":case "cut":case "paste":a=qd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=hd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Fd=Ed.isInteractiveTopLevelEventType,
Gd=[];function Hd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Id=!0;function Kd(a){Id=!!a}function K(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!1)}
function Nd(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!0)}function Ld(a,b){Tb(Md,a,b)}function Md(a,b){if(Id){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Gd.length){var d=Gd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Hd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Gd.length&&Gd.push(a)}}}
var Od={get _enabled(){return Id},setEnabled:Kd,isEnabled:function(){return Id},trapBubbledEvent:K,trapCapturedEvent:Nd,dispatchEvent:Md},Pd={},Qd=0,Rd="_reactListenersID"+(""+Math.random()).slice(2);function Sd(a){Object.prototype.hasOwnProperty.call(a,Rd)||(a[Rd]=Qd++,Pd[a[Rd]]={});return Pd[a[Rd]]}function Td(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ud(a,b){var c=Td(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Td(c)}}function Vd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Wd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Xd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Yd=null,Zd=null,$d=null,ae=!1;
function be(a,b){if(ae||null==Yd||Yd!==da())return null;var c=Yd;"selectionStart"in c&&Vd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $d&&ea($d,c)?null:($d=c,a=H.getPooled(Xd.select,Zd,a,b),a.type="select",a.target=Yd,Ya(a),a)}
var ce={eventTypes:Xd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Sd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Yd=e,Zd=b,$d=null;break;case "blur":$d=Zd=Yd=null;break;case "mousedown":ae=!0;break;case "contextmenu":case "mouseup":return ae=!1,be(c,d);case "selectionchange":if(Wd)break;
case "keydown":case "keyup":return be(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:jd,ChangeEventPlugin:bd,SelectEventPlugin:ce,BeforeInputEventPlugin:Ib});
var de="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,ee=Date,fe=setTimeout,ge=clearTimeout,he=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var ie=performance;he=function(){return ie.now()}}else he=function(){return ee.now()};var je=void 0,ke=void 0;
if(m.canUseDOM){var le="function"===typeof de?de:function(){A("276")},L=null,me=null,ne=-1,oe=!1,pe=!1,qe=0,re=33,se=33,te={didTimeout:!1,timeRemaining:function(){var a=qe-he();return 0<a?a:0}},ve=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{ke(a),d||(oe=!0,window.postMessage(ue,"*"))}},ue="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===ue&&(oe=!1,null!==L)){if(null!==L){var b=he();if(!(-1===
ne||ne>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(te.didTimeout=!0,b=0,d=c.length;b<d;b++)ve(c[b],te);ne=a}}for(a=he();0<qe-a&&null!==L;)a=L,te.didTimeout=!1,ve(a,te),a=he();null===L||pe||(pe=!0,le(we))}},!1);var we=function(a){pe=!1;var b=a-qe+se;b<se&&re<se?(8>b&&(b=8),se=b<re?re:b):re=b;qe=a+se;oe||(oe=!0,window.postMessage(ue,"*"))};je=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=he()+
b.timeout);if(-1===ne||-1!==c&&c<ne)ne=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=me,null!==b&&(b.next=a));me=a;pe||(pe=!0,le(we));return a};ke=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,me=c):me=L=null}}}else{var xe=new Map;je=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=fe(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});xe.set(a,c);return b};ke=function(a){var b=xe.get(a.scheduledCallback);xe.delete(a);ge(b)}}function ye(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ze(a,b){a=p({children:void 0},b);if(b=ye(b.children))a.children=b;return a}
function Ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Be(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Ce(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function De(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Ee(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Fe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Ge={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function He(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ie(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?He(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Je=void 0,Ke=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ge.svg||"innerHTML"in a)a.innerHTML=b;else{Je=Je||document.createElement("div");Je.innerHTML="<svg>"+b+"</svg>";for(b=Je.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Le(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Me={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ne=["Webkit","ms","Moz","O"];Object.keys(Me).forEach(function(a){Ne.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Me[b]=Me[a]})});
function Oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Me.hasOwnProperty(e)&&Me[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Pe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Qe(a,b,c){b&&(Pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Se=v.thatReturns("");
function Te(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Sd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Nd("scroll",a);break;case "focus":case "blur":Nd("focus",a);Nd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Nd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Ue(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Ge.html&&(d=He(a));d===Ge.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ve(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function We(a,b,c,d){var e=Re(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Ic(a,c);f=Hc(a,c);K("invalid",a);Te(d,"onChange");break;case "option":f=ze(a,c);break;case "select":Be(a,c);f=p({},c,{value:void 0});
K("invalid",a);Te(d,"onChange");break;case "textarea":De(a,c);f=Ce(a,c);K("invalid",a);Te(d,"onChange");break;default:f=c}Qe(b,f,Se);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Oe(a,k,Se):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Ke(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Le(a,k):"number"===typeof k&&Le(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Te(d,
h):null!=k&&Gc(a,h,k,e))}switch(b){case "input":cc(a);Nc(a,c,!1);break;case "textarea":cc(a);Fe(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Ae(a,!!c.multiple,b,!1):null!=c.defaultValue&&Ae(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Xe(a,b,c,d,e){var f=null;switch(b){case "input":c=Hc(a,c);d=Hc(a,d);f=[];break;case "option":c=ze(a,c);d=ze(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Ce(a,c);d=Ce(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Qe(b,d,Se);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Te(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Ye(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Kc(a,e);Re(c,d);d=Re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Oe(a,h,Se):"dangerouslySetInnerHTML"===g?Ke(a,h):"children"===g?Le(a,h):Gc(a,g,h,d)}switch(c){case "input":Lc(a,e);break;case "textarea":Ee(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Ae(a,!!e.multiple,e.defaultValue,!0):Ae(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ze(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Ic(a,c);K("invalid",a);Te(e,"onChange");break;case "select":Be(a,c);K("invalid",a);Te(e,"onChange");break;case "textarea":De(a,c),K("invalid",a),Te(e,"onChange")}Qe(b,
c,Se);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Te(e,f)}switch(b){case "input":cc(a);Nc(a,c,!0);break;case "textarea":cc(a);Fe(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function $e(a,b){return a.nodeValue!==b}
var af={createElement:Ue,createTextNode:Ve,setInitialProperties:We,diffProperties:Xe,updateProperties:Ye,diffHydratedProperties:Ze,diffHydratedText:$e,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Lc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Lc(d,e)}}}break;case "textarea":Ee(a,c);break;case "select":b=c.value,null!=b&&Ae(a,!!c.multiple,b,!1)}}},bf=null,cf=null;function df(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function ef(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ff=he,gf=je,hf=ke;function jf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function kf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var lf=[],mf=-1;function nf(a){return{current:a}}
function M(a){0>mf||(a.current=lf[mf],lf[mf]=null,mf--)}function N(a,b){mf++;lf[mf]=a.current;a.current=b}var of=nf(ha),O=nf(!1),pf=ha;function qf(a){return rf(a)?pf:of.current}
function sf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function rf(a){return 2===a.tag&&null!=a.type.childContextTypes}function tf(a){rf(a)&&(M(O,a),M(of,a))}function uf(a){M(O,a);M(of,a)}
function vf(a,b,c){of.current!==ha?A("168"):void 0;N(of,b,a);N(O,c,a)}function wf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function xf(a){if(!rf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;pf=of.current;N(of,b,a);N(O,O.current,a);return!0}
function yf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=wf(a,pf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(of,a);N(of,d,a)}else M(O,a);N(O,b,a)}
function zf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function Af(a,b,c){var d=a.alternate;null===d?(d=new zf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Bf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Cf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new zf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new zf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Cf(a,b,c,d){a=new zf(10,a,d,b);a.expirationTime=c;return a}function Df(a,b,c){a=new zf(6,a,null,b);a.expirationTime=c;return a}function Ef(a,b,c){b=new zf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ff(a,b,c){b=new zf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Gf=null,Hf=null;function If(a){return function(b){try{return a(b)}catch(c){}}}
function Jf(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Gf=If(function(a){return b.onCommitFiberRoot(c,a)});Hf=If(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Kf(a){"function"===typeof Gf&&Gf(a)}function Lf(a){"function"===typeof Hf&&Hf(a)}var Mf=!1;
function Nf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Of(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Pf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Qf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Rf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Nf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Nf(a.memoizedState),f=d.updateQueue=Nf(d.memoizedState)):e=a.updateQueue=Of(f):null===f&&(f=d.updateQueue=Of(e));null===f||e===f?Qf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Qf(e,b,c),Qf(f,b,c)):(Qf(e,b,c),f.lastUpdate=b)}
function Sf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Nf(a.memoizedState):Tf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Tf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Of(b));return b}
function Uf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Mf=!0}return d}
function Vf(a,b,c,d,e){Mf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Tf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Wf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Xf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Wf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Wf(b,c)),a=a.nextEffect}
function Yf(a,b){return{value:a,source:b,stack:vc(b)}}var Zf=nf(null),$f=nf(null),ag=nf(0);function bg(a){var b=a.type._context;N(ag,b._changedBits,a);N($f,b._currentValue,a);N(Zf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function cg(a){var b=ag.current,c=$f.current;M(Zf,a);M($f,a);M(ag,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var dg={},eg=nf(dg),fg=nf(dg),gg=nf(dg);function hg(a){a===dg?A("174"):void 0;return a}
function jg(a,b){N(gg,b,a);N(fg,a,a);N(eg,dg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ie(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Ie(b,c)}M(eg,a);N(eg,b,a)}function kg(a){M(eg,a);M(fg,a);M(gg,a)}function lg(a){fg.current===a&&(M(eg,a),M(fg,a))}function mg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var qg={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ng();c=og(c,a);var d=Pf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Rf(a,d,c);pg(a,c)}};function rg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function sg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&qg.enqueueReplaceState(b,b.state,null)}
function tg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=qf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=sf(a,f);f=a.updateQueue;null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(mg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&qg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var ug=Array.isArray;
function vg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function wg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function xg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Af(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Df(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=vg(a,b,c),d.return=a,d;d=Bf(c,a.mode,d);d.ref=vg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ef(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Cf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Df(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Bf(b,a.mode,c),c.ref=vg(a,null,b),c.return=a,c;case hc:return b=Ef(b,a.mode,c),b.return=a,b}if(ug(b)||tc(b))return b=Cf(b,a.mode,c,null),b.return=
a,b;wg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(ug(c)||tc(c))return null!==e?null:r(a,b,c,d,null);wg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(ug(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);wg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=vg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Cf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Bf(f,a.mode,h),h.ref=vg(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ef(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Df(f,a.mode,h),d.return=a,a=d),g(a);if(ug(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&wg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var yg=xg(!0),zg=xg(!1),Ag=null,Bg=null,Cg=!1;function Dg(a,b){var c=new zf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Eg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Fg(a){if(Cg){var b=Bg;if(b){var c=b;if(!Eg(a,b)){b=jf(c);if(!b||!Eg(a,b)){a.effectTag|=2;Cg=!1;Ag=a;return}Dg(Ag,c)}Ag=a;Bg=kf(b)}else a.effectTag|=2,Cg=!1,Ag=a}}
function Gg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Ag=a}function Hg(a){if(a!==Ag)return!1;if(!Cg)return Gg(a),Cg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!ef(b,a.memoizedProps))for(b=Bg;b;)Dg(a,b),b=jf(b);Gg(a);Bg=Ag?jf(a.stateNode):null;return!0}function Ig(){Bg=Ag=null;Cg=!1}function Q(a,b,c){Jg(a,b,c,b.expirationTime)}function Jg(a,b,c,d){b.child=null===a?zg(b,null,c,d):yg(b,a.child,c,d)}
function Kg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Lg(a,b,c,d,e){Kg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&yf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Jg(a,b,null,e),b.child=null);Jg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&yf(b,!0);return b.child}
function Mg(a){var b=a.stateNode;b.pendingContext?vf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&vf(a,b.context,!1);jg(a,b.containerInfo)}
function Ng(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Rg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,bg(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b)}else Ng(b,d,h,c)}b.stateNode=h;bg(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=Af(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Af(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Sg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Mg(b);break;case 2:xf(b);break;case 4:jg(b,b.stateNode.containerInfo);break;case 13:bg(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=qf(b);f=sf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&mg(b,f,e),e=xf(b),d.updater=qg,b.stateNode=d,d._reactInternalFiber=b,tg(b,c),a=Lg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=qf(b),d=sf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=xf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=qf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?sf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=qg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);tg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=qf(b);g=sf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&sg(b,d,f,g);Mf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Vf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Mf?("function"===typeof r&&(mg(b,r,f),n=b.memoizedState),(k=Mf||rg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=qf(b),g=sf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&sg(b,d,k,g),Mf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Vf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Mf?("function"===typeof r&&(mg(b,r,k),w=b.memoizedState),(r=Mf||rg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Lg(a,b,d,e,c);case 3:Mg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Vf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Ig(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Bg=kf(b.stateNode.containerInfo),Ag=b,d=Cg=!0;d?(b.effectTag|=2,b.child=zg(b,null,e,c)):(Ig(),Q(a,b,e));a=b.child}else Ig(),a=R(a,b);return a;case 5:a:{hg(gg.current);e=hg(eg.current);d=Ie(e,
b.type);e!==d&&(N(fg,b,b),N(eg,d,b));null===a&&Fg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;ef(e,d)?k=null:f&&ef(e,f)&&(b.effectTag|=16);Kg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Fg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return jg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=yg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Rg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ng(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Tg(a){a.effectTag|=4}var Ug=void 0,Vg=void 0,Wg=void 0;Ug=function(){};Vg=function(a,b,c){(b.updateQueue=c)&&Tg(b)};Wg=function(a,b,c,d){c!==d&&Tg(b)};
function Xg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return tf(b),null;case 3:kg(b);uf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Hg(b),b.effectTag&=-3;Ug(b);return null;case 5:lg(b);d=hg(gg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=hg(eg.current);g=Xe(g,e,f,c,d);Vg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=hg(eg.current);if(Hg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ze(c,e,f,a,d),b.updateQueue=d,null!==d&&Tg(b);else{a=Ue(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}We(a,e,c,d);df(e,c)&&Tg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Wg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=hg(gg.current);hg(eg.current);Hg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,$e(d,c)&&Tg(b)):(d=Ve(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return kg(b),Ug(b),null;case 13:return cg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Yg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Zg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){$g(a,c)}else b.current=null}
function ah(a){"function"===typeof Lf&&Lf(a);switch(a.tag){case 2:Zg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){$g(a,c)}break;case 5:Zg(a);break;case 4:bh(a)}}function ch(a){return 5===a.tag||3===a.tag||4===a.tag}
function dh(a){a:{for(var b=a.return;null!==b;){if(ch(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Le(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ch(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function bh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(ah(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:ah(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function eh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Ye(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function fh(a,b,c){c=Pf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gh(d);Yg(a,b)};return c}
function hh(a,b,c){c=Pf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===ih?ih=new Set([this]):ih.add(this);var c=b.value,d=b.stack;Yg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function jh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Yf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=fh(a,d,f);Sf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===ih||!ih.has(c))){a.effectTag|=1024;d=hh(a,b,f);Sf(a,d,f);return}}a=a.return}while(null!==a)}
function kh(a){switch(a.tag){case 2:tf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return kg(a),uf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return lg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return kg(a),null;case 13:return cg(a),null;default:return null}}var lh=ff(),mh=2,nh=lh,oh=0,ph=0,qh=!1,S=null,rh=null,T=0,sh=-1,th=!1,U=null,uh=!1,vh=!1,ih=null;
function wh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:tf(b);break;case 3:kg(b);uf(b);break;case 5:lg(b);break;case 4:kg(b);break;case 13:cg(b)}a=a.return}rh=null;T=0;sh=-1;th=!1;S=null;vh=!1}
function xh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Xg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{vh=!0;break}}else{a=kh(a,th,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function yh(a){var b=Sg(a.alternate,a,T);null===b&&(b=xh(a));ec.current=null;return b}
function zh(a,b,c){qh?A("243"):void 0;qh=!0;if(b!==T||a!==rh||null===S)wh(),rh=a,T=b,sh=-1,S=Af(rh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;th=!c||T<=mh;do{try{if(c)for(;null!==S&&!Ah();)S=yh(S);else for(;null!==S;)S=yh(S)}catch(f){if(null===S)d=!0,gh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;gh(f);break}jh(a,e,c,f,th,T,nh);S=xh(c)}}break}while(1);qh=!1;if(d)return null;if(null===S){if(vh)return a.pendingCommitExpirationTime=b,a.current.alternate;th?A("262"):
void 0;0<=sh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Bh(a,b)},sh);Ch(a.current.expirationTime)}return null}
function $g(a,b){var c;a:{qh&&!uh?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===ih||!ih.has(d))){a=Yf(b,a);a=hh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}break;case 3:a=Yf(b,a);a=fh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Yf(b,a),c=fh(a,c,1),Rf(a,c,1),pg(a,1));c=void 0}return c}
function Dh(){var a=2+25*(((ng()-2+500)/25|0)+1);a<=oh&&(a=oh+1);return oh=a}function og(a,b){a=0!==ph?ph:qh?uh?1:T:b.mode&1?Eh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Eh&&(0===Fh||a>Fh)&&(Fh=a);return a}
function pg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!qh&&0!==T&&b<T&&wh();var d=c.current.expirationTime;qh&&!uh&&rh===c||Bh(c,d);Gh>Hh&&A("185")}else break;a=a.return}}function ng(){nh=ff()-lh;return mh=(nh/10|0)+2}
function Ih(a){var b=ph;ph=2+25*(((ng()-2+500)/25|0)+1);try{return a()}finally{ph=b}}function Jh(a,b,c,d,e){var f=ph;ph=1;try{return a(b,c,d,e)}finally{ph=f}}var Kh=null,V=null,Lh=0,Mh=void 0,W=!1,X=null,Y=0,Fh=0,Nh=!1,Oh=!1,Ph=null,Qh=null,Z=!1,Rh=!1,Eh=!1,Sh=null,Hh=1E3,Gh=0,Th=1;function Uh(a){if(0!==Lh){if(a>Lh)return;null!==Mh&&hf(Mh)}var b=ff()-lh;Lh=a;Mh=gf(Vh,{timeout:10*(a-2)-b})}
function Bh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Kh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Kh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Rh&&(X=a,Y=1,Wh(a,1,!1)):1===b?Xh():Uh(b))}
function Yh(){var a=0,b=null;if(null!==V)for(var c=V,d=Kh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Kh=V=d.nextScheduledRoot=null;break}else if(d===Kh)Kh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Kh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Gh++:Gh=0;X=b;Y=a}function Vh(a){Zh(0,!0,a)}function Xh(){Zh(1,!1,null)}function Zh(a,b,c){Qh=c;Yh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Nh||ng()>=Y);)ng(),Wh(X,Y,!Nh),Yh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Wh(X,Y,!1),Yh();null!==Qh&&(Lh=0,Mh=null);0!==Y&&Uh(Y);Qh=null;Nh=!1;$h()}function ai(a,b){W?A("253"):void 0;X=a;Y=b;Wh(a,b,!1);Xh();$h()}
function $h(){Gh=0;if(null!==Sh){var a=Sh;Sh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Oh||(Oh=!0,Ph=d)}}}if(Oh)throw a=Ph,Ph=null,Oh=!1,a;}function Wh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!0),null!==c&&(Ah()?a.finishedWork=c:bi(a,c,b)))):(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!1),null!==c&&bi(a,c,b)));W=!1}
function bi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Sh?Sh=[d]:Sh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;uh=qh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ng();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;bf=Id;var f=da();if(Vd(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;cf={focusedElem:f,selectionRange:g};Kd(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var ni=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=ni}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,$g(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Le(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:dh(U);U.effectTag&=-3;break;case 6:dh(U);U.effectTag&=-3;eh(U.alternate,
U);break;case 4:eh(U.alternate,U);break;case 8:D=U,bh(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,$g(U,y),null!==U&&(U=U.nextEffect))}l=cf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Vd(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Ud(q,l),D=Ud(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}cf=null;Kd(bf);bf=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var ig=U.effectTag;if(ig&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var xi=oc.memoizedProps,yi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(xi,yi,ca.__reactInternalSnapshotBeforeUpdate)}var Og=l.updateQueue;null!==Og&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Xf(l,Og,ca,u));break;case 3:var Pg=l.updateQueue;if(null!==Pg){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Xf(l,Pg,y,u)}break;case 5:var zi=l.stateNode;null===oc&&l.effectTag&4&&df(l.type,l.memoizedProps)&&zi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(ig&128){l=void 0;var yc=U.ref;if(null!==yc){var Qg=U.stateNode;switch(U.tag){case 5:l=Qg;break;default:l=Qg}"function"===typeof yc?yc(l):yc.current=l}}var Ai=U.nextEffect;U.nextEffect=null;U=Ai}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,$g(U,q),null!==U&&(U=U.nextEffect))}qh=uh=!1;"function"===typeof Kf&&Kf(b.stateNode);b=c.current.expirationTime;0===b&&(ih=null);a.remainingExpirationTime=b}function Ah(){return null===Qh||Qh.timeRemaining()>Th?!1:Nh=!0}
function gh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Oh||(Oh=!0,Ph=a)}function Ch(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function ci(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Xh()}}function di(a,b){if(Z&&!Rh){Rh=!0;try{return a(b)}finally{Rh=!1}}return a(b)}function ei(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Jh(a,b)}finally{Z=c,Xh()}}
function fi(a,b,c){if(Eh)return a(b,c);Z||W||0===Fh||(Zh(Fh,!1,null),Fh=0);var d=Eh,e=Z;Z=Eh=!0;try{return a(b,c)}finally{Eh=d,(Z=e)||W||Xh()}}function gi(a){var b=Z;Z=!0;try{Jh(a)}finally{(Z=b)||W||Zh(1,!1,null)}}
function hi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===kd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(rf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=rf(c)?wf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Pf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Rf(f,e,d);pg(f,d);return d}
function ii(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=nd(b);return null===a?null:a.stateNode}function ji(a,b,c,d){var e=b.current,f=ng();e=og(f,e);return hi(a,b,c,e,d)}function ki(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function li(a){var b=a.findFiberByHostInstance;return Jf(p({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var mi={updateContainerAtExpirationTime:hi,createContainer:function(a,b,c){return Ff(a,b,c)},updateContainer:ji,flushRoot:ai,requestWork:Bh,computeUniqueAsyncExpiration:Dh,batchedUpdates:ci,unbatchedUpdates:di,deferredUpdates:Ih,syncUpdates:Jh,interactiveUpdates:fi,flushInteractiveUpdates:function(){W||0===Fh||(Zh(Fh,!1,null),Fh=0)},flushControlled:gi,flushSync:ei,getPublicRootInstance:ki,findHostInstance:ii,findHostInstanceWithNoPortals:function(a){a=od(a);return null===a?null:a.stateNode},injectIntoDevTools:li};
function oi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(af);function pi(a){this._expirationTime=Dh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
pi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new qi;hi(a,b,null,c,d._onCommit);return d};pi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;ai(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};pi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function qi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}qi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
qi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function ri(a,b,c){this._internalRoot=Ff(a,b,c)}ri.prototype.render=function(a,b){var c=this._internalRoot,d=new qi;b=void 0===b?null:b;null!==b&&d.then(b);ji(a,c,null,d._onCommit);return d};
ri.prototype.unmount=function(a){var b=this._internalRoot,c=new qi;a=void 0===a?null:a;null!==a&&c.then(a);ji(null,b,null,c._onCommit);return c};ri.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new qi;c=void 0===c?null:c;null!==c&&e.then(c);ji(b,d,a,e._onCommit);return e};
ri.prototype.createBatch=function(){var a=new pi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function si(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=mi.batchedUpdates;Tb=mi.interactiveUpdates;Ub=mi.flushInteractiveUpdates;
function ti(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new ri(a,!1,b)}
function ui(a,b,c,d,e){si(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ki(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ti(c,d);if("function"===typeof e){var h=e;e=function(){var a=ki(f._internalRoot);h.call(a)}}di(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ki(f._internalRoot)}
function vi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;si(b)?void 0:A("200");return oi(a,b,null,c)}
var wi={createPortal:vi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ii(a)},hydrate:function(a,b,c){return ui(null,a,b,!0,c)},render:function(a,b,c){return ui(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ui(a,b,c,!1,d)},unmountComponentAtNode:function(a){si(a)?void 0:A("40");return a._reactRootContainer?(di(function(){ui(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return vi.apply(void 0,
arguments)},unstable_batchedUpdates:ci,unstable_deferredUpdates:Ih,unstable_interactiveUpdates:fi,flushSync:ei,unstable_flushControlled:gi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Od},unstable_createRoot:function(a,b){return new ri(a,!0,null!=b&&!0===b.hydrate)}};li({findFiberByHostInstance:Na,bundleType:0,version:"16.4.2",rendererPackageName:"react-dom"});
var Bi={default:wi},Ci=Bi&&wi||Bi;module.exports=Ci.default?Ci.default:Ci;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(163);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(164);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_scss__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layouts_BaseLayout__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_graphql_index__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["ApolloProvider"],{client:__WEBPACK_IMPORTED_MODULE_5__store_graphql_index__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["BrowserRouter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layouts_BaseLayout__["a" /* default */],null)));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(167);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./App.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./App.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 168 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(20);
var invariant = __webpack_require__(11);
var ReactPropTypesSecret = __webpack_require__(84);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QueryDocumentKeys */
/* unused harmony export BREAK */
/* harmony export (immutable) */ __webpack_exports__["a"] = visit;
/* unused harmony export visitInParallel */
/* unused harmony export visitWithTypeInfo */
/* unused harmony export getVisitFn */


/**
 * A visitor is comprised of visit functions, which are called on each node
 * during the visitor's traversal.
 */


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

var QueryDocumentKeys = {
  Name: [],

  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],

  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name',
  // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],

  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],

  Directive: ['name', 'arguments'],

  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],

  SchemaDefinition: ['directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],

  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],

  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],

  DirectiveDefinition: ['description', 'name', 'arguments', 'locations']
};

/**
 * A KeyMap describes each the traversable properties of each kind of node.
 */


var BREAK = {};

/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */
function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;
    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();
      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};
          for (var k in node) {
            if (node.hasOwnProperty(k)) {
              clone[k] = node[k];
            }
          }
          node = clone;
        }
        var editOffset = 0;
        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];
          if (inArray) {
            editKey -= editOffset;
          }
          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }
      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;
      if (node === null || node === undefined) {
        continue;
      }
      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;
    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error('Invalid AST Node: ' + JSON.stringify(node));
      }
      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);
          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      stack = { inArray: inArray, index: index, keys: keys, edits: edits, prev: stack };
      inArray = Array.isArray(node);
      keys = inArray ? node : visitorKeys[node.kind] || [];
      index = -1;
      edits = [];
      if (parent) {
        ancestors.push(parent);
      }
      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}

function isNode(maybeNode) {
  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}

/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */
function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);

  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */false);
          if (fn) {
            var result = fn.apply(visitors[i], arguments);
            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */true);
          if (fn) {
            var result = fn.apply(visitors[i], arguments);
            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}

/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */
function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = getVisitFn(visitor, node.kind, /* isLeaving */false);
      if (fn) {
        var result = fn.apply(visitor, arguments);
        if (result !== undefined) {
          typeInfo.leave(node);
          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }
        return result;
      }
    },
    leave: function leave(node) {
      var fn = getVisitFn(visitor, node.kind, /* isLeaving */true);
      var result = void 0;
      if (fn) {
        result = fn.apply(visitor, arguments);
      }
      typeInfo.leave(node);
      return result;
    }
  };
}

/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */
function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];
  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }
    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }
      var specificKindVisitor = specificVisitor[kind];
      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getDirectiveInfoFromField;
/* harmony export (immutable) */ __webpack_exports__["e"] = shouldInclude;
/* harmony export (immutable) */ __webpack_exports__["a"] = flattenSelections;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDirectiveNames;
/* harmony export (immutable) */ __webpack_exports__["d"] = hasDirectives;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storeUtils__ = __webpack_require__(58);

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = Object(__WEBPACK_IMPORTED_MODULE_0__storeUtils__["a" /* argumentsObjectFromField */])(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    if (!selection.directives) {
        return true;
    }
    var res = true;
    selection.directives.forEach(function (directive) {
        // TODO should move this validation to GraphQL validation once that's implemented.
        if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
            // Just don't worry about directives we don't understand
            return;
        }
        //evaluate the "if" argument and skip (i.e. return undefined) if it evaluates to true.
        var directiveArguments = directive.arguments || [];
        var directiveName = directive.name.value;
        if (directiveArguments.length !== 1) {
            throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
        }
        var ifArgument = directiveArguments[0];
        if (!ifArgument.name || ifArgument.name.value !== 'if') {
            throw new Error("Invalid argument for the @" + directiveName + " directive.");
        }
        var ifValue = directiveArguments[0].value;
        var evaledValue = false;
        if (!ifValue || ifValue.kind !== 'BooleanValue') {
            // means it has to be a variable value if this is a valid @skip or @include directive
            if (ifValue.kind !== 'Variable') {
                throw new Error("Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
            }
            else {
                evaledValue = variables[ifValue.name.value];
                if (evaledValue === undefined) {
                    throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
                }
            }
        }
        else {
            evaledValue = ifValue.value;
        }
        if (directiveName === 'skip') {
            evaledValue = !evaledValue;
        }
        if (!evaledValue) {
            res = false;
        }
    });
    return res;
}
function flattenSelections(selection) {
    if (!selection.selectionSet ||
        !(selection.selectionSet.selections.length > 0))
        return [selection];
    return [selection].concat(selection.selectionSet.selections
        .map(function (selectionNode) {
        return [selectionNode].concat(flattenSelections(selectionNode));
    })
        .reduce(function (selections, selected) { return selections.concat(selected); }, []));
}
function getDirectiveNames(doc) {
    // operation => [names of directives];
    var directiveNames = doc.definitions
        .filter(function (definition) {
        return definition.selectionSet && definition.selectionSet.selections;
    })
        // operation => [[Selection]]
        .map(function (x) { return flattenSelections(x); })
        // [[Selection]] => [Selection]
        .reduce(function (selections, selected) { return selections.concat(selected); }, [])
        // [Selection] => [Selection with Directives]
        .filter(function (selection) {
        return selection.directives && selection.directives.length > 0;
    })
        // [Selection with Directives] => [[Directives]]
        .map(function (selection) { return selection.directives; })
        // [[Directives]] => [Directives]
        .reduce(function (directives, directive) { return directives.concat(directive); }, [])
        // [Directives] => [Name]
        .map(function (directive) { return directive.name.value; });
    return directiveNames;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
//# sourceMappingURL=directives.js.map

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFragmentQueryDocument;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/**
 * Returns a query document which adds a single query operation that only
 * spreads the target fragment inside of it.
 *
 * So for example a document of:
 *
 * ```graphql
 * fragment foo on Foo { a b c }
 * ```
 *
 * Turns into:
 *
 * ```graphql
 * { ...foo }
 *
 * fragment foo on Foo { a b c }
 * ```
 *
 * The target fragment will either be the only fragment in the document, or a
 * fragment specified by the provided `fragmentName`. If there is more then one
 * fragment, but a `fragmentName` was not defined then an error will be thrown.
 */
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function (definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === 'OperationDefinition') {
            throw new Error("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === 'undefined') {
        if (fragments.length !== 1) {
            throw new Error("Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        }
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = __assign({}, document, { definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ].concat(document.definitions) });
    return query;
}
//# sourceMappingURL=fragments.js.map

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = removeDirectivesFromDocument;
/* harmony export (immutable) */ __webpack_exports__["a"] = addTypenameToDocument;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeConnectionDirectiveFromDocument;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDirectivesFromDocument;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getFromAST__ = __webpack_require__(85);


var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isNotEmpty(op, fragments) {
    // keep selections that are still valid
    return (op.selectionSet.selections.filter(function (selectionSet) {
        // anything that doesn't match the compound filter is okay
        return !(selectionSet &&
            // look into fragments to verify they should stay
            selectionSet.kind === 'FragmentSpread' &&
            // see if the fragment in the map is valid (recursively)
            !isNotEmpty(fragments[selectionSet.name.value], fragments));
    }).length > 0);
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            if (dir.name && dir.name === directive.name.value)
                return true;
            if (dir.test && dir.test(directive))
                return true;
            return false;
        });
    };
}
function addTypenameToSelectionSet(selectionSet, isRoot) {
    if (isRoot === void 0) { isRoot = false; }
    if (selectionSet.selections) {
        if (!isRoot) {
            var alreadyHasThisField = selectionSet.selections.some(function (selection) {
                return (selection.kind === 'Field' &&
                    selection.name.value === '__typename');
            });
            if (!alreadyHasThisField) {
                selectionSet.selections.push(TYPENAME_FIELD);
            }
        }
        selectionSet.selections.forEach(function (selection) {
            // Must not add __typename if we're inside an introspection query
            if (selection.kind === 'Field') {
                if (selection.name.value.lastIndexOf('__', 0) !== 0 &&
                    selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
            else if (selection.kind === 'InlineFragment') {
                if (selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
        });
    }
}
function removeDirectivesFromSelectionSet(directives, selectionSet) {
    if (!selectionSet.selections)
        return selectionSet;
    // if any of the directives are set to remove this selectionSet, remove it
    var agressiveRemove = directives.some(function (dir) { return dir.remove; });
    selectionSet.selections = selectionSet.selections
        .map(function (selection) {
        if (selection.kind !== 'Field' ||
            !selection ||
            !selection.directives)
            return selection;
        var directiveMatcher = getDirectiveMatcher(directives);
        var remove;
        selection.directives = selection.directives.filter(function (directive) {
            var shouldKeep = !directiveMatcher(directive);
            if (!remove && !shouldKeep && agressiveRemove)
                remove = true;
            return shouldKeep;
        });
        return remove ? null : selection;
    })
        .filter(function (x) { return !!x; });
    selectionSet.selections.forEach(function (selection) {
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            removeDirectivesFromSelectionSet(directives, selection.selectionSet);
        }
    });
    return selectionSet;
}
function removeDirectivesFromDocument(directives, doc) {
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions.forEach(function (definition) {
        removeDirectivesFromSelectionSet(directives, definition.selectionSet);
    });
    var operation = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["i" /* getOperationDefinitionOrDie */])(docClone);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["b" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["e" /* getFragmentDefinitions */])(docClone));
    return isNotEmpty(operation, fragments) ? docClone : null;
}
function addTypenameToDocument(doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions.forEach(function (definition) {
        var isRoot = definition.kind === 'OperationDefinition';
        addTypenameToSelectionSet(definition.selectionSet, isRoot);
    });
    return docClone;
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                console.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    return removeDirectivesFromDocument([connectionRemoveConfig], doc);
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!(selectionSet && selectionSet.selections)) {
        return false;
    }
    var matchedSelections = selectionSet.selections.filter(function (selection) {
        return hasDirectivesInSelection(directives, selection, nestedCheck);
    });
    return matchedSelections.length > 0;
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (selection.kind !== 'Field' || !selection) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    var directiveMatcher = getDirectiveMatcher(directives);
    var matchedDirectives = selection.directives.filter(directiveMatcher);
    return (matchedDirectives.length > 0 ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getDirectivesFromSelectionSet(directives, selectionSet) {
    selectionSet.selections = selectionSet.selections
        .filter(function (selection) {
        return hasDirectivesInSelection(directives, selection, true);
    })
        .map(function (selection) {
        if (hasDirectivesInSelection(directives, selection, false)) {
            return selection;
        }
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            selection.selectionSet = getDirectivesFromSelectionSet(directives, selection.selectionSet);
        }
        return selection;
    });
    return selectionSet;
}
function getDirectivesFromDocument(directives, doc, includeAllFragments) {
    if (includeAllFragments === void 0) { includeAllFragments = false; }
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions = docClone.definitions.map(function (definition) {
        if ((definition.kind === 'OperationDefinition' ||
            (definition.kind === 'FragmentDefinition' && !includeAllFragments)) &&
            definition.selectionSet) {
            definition.selectionSet = getDirectivesFromSelectionSet(directives, definition.selectionSet);
        }
        return definition;
    });
    var operation = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["i" /* getOperationDefinitionOrDie */])(docClone);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["b" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["e" /* getFragmentDefinitions */])(docClone));
    return isNotEmpty(operation, fragments) ? docClone : null;
}
//# sourceMappingURL=transform.js.map

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tryFunctionOrLogError;
/* harmony export (immutable) */ __webpack_exports__["a"] = graphQLResultHasError;
function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}
//# sourceMappingURL=errorHandling.js.map

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEqual;
/**
 * Performs a deep equality check on two JavaScript values.
 */
function isEqual(a, b) {
    // If the two values are strictly equal, we are good.
    if (a === b) {
        return true;
    }
    // Dates are equivalent if their time values are equal.
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    }
    // If a and b are both objects, we will compare their properties. This will compare arrays as
    // well.
    if (a != null &&
        typeof a === 'object' &&
        b != null &&
        typeof b === 'object') {
        // Compare all of the keys in `a`. If one of the keys has a different value, or that key does
        // not exist in `b` return false immediately.
        for (var key in a) {
            if (Object.prototype.hasOwnProperty.call(a, key)) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                    return false;
                }
                if (!isEqual(a[key], b[key])) {
                    return false;
                }
            }
        }
        // Look through all the keys in `b`. If `b` has a key that `a` does not, return false.
        for (var key in b) {
            if (!Object.prototype.hasOwnProperty.call(a, key)) {
                return false;
            }
        }
        // If we made it this far the objects are equal!
        return true;
    }
    // Otherwise the values are not equal.
    return false;
}
//# sourceMappingURL=isEqual.js.map

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = maybeDeepFreeze;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(59);

// Taken (mostly) from https://github.com/substack/deep-freeze to avoid
// import hassles with rollup.
function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__environment__["b" /* isDevelopment */])() || Object(__WEBPACK_IMPORTED_MODULE_0__environment__["e" /* isTest */])()) {
        // Polyfilled Symbols potentially cause infinite / very deep recursion while deep freezing
        // which is known to crash IE11 (https://github.com/apollographql/apollo-client/issues/3043).
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) {
            return deepFreeze(obj);
        }
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warnOnceInDevelopment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(59);

var haveWarned = Object.create({});
/**
 * Print a warning only once in development.
 * In production no warnings are printed.
 * In test all warnings are printed.
 *
 * @param msg The warning message
 * @param type warn or error (will call console.warn or console.error)
 */
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__environment__["d" /* isProduction */])()) {
        return;
    }
    if (!haveWarned[msg]) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__environment__["e" /* isTest */])()) {
            haveWarned[msg] = true;
        }
        switch (type) {
            case 'error':
                console.error(msg);
                break;
            default:
                console.warn(msg);
        }
    }
}
//# sourceMappingURL=warnOnce.js.map

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stripSymbols;
/**
 * In order to make assertions easier, this function strips `symbol`'s from
 * the incoming data.
 *
 * This can be handy when running tests against `apollo-client` for example,
 * since it adds `symbol`'s to the data in the store. Jest's `toEqual`
 * function now covers `symbol`'s (https://github.com/facebook/jest/pull/3437),
 * which means all test data used in a `toEqual` comparison would also have to
 * include `symbol`'s, to pass. By stripping `symbol`'s from the cache data
 * we can compare against more simplified test data.
 */
function stripSymbols(data) {
    return JSON.parse(JSON.stringify(data));
}
//# sourceMappingURL=stripSymbols.js.map

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return from; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return split; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return concat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloLink; });
/* harmony export (immutable) */ __webpack_exports__["d"] = execute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkUtils__ = __webpack_require__(91);


var passthrough = function (op, forward) { return (forward ? forward(op) : __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()); };
var toLink = function (handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
};
var empty = function () {
    return new ApolloLink(function (op, forward) { return __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of(); });
};
var from = function (links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
};
var split = function (test, left, right) {
    if (right === void 0) { right = new ApolloLink(passthrough); }
    var leftLink = toLink(left);
    var rightLink = toLink(right);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["e" /* isTerminating */])(leftLink) && Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["e" /* isTerminating */])(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()
                : rightLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()
                : rightLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
};
// join two Links together
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["e" /* isTerminating */])(firstLink)) {
        console.warn(new __WEBPACK_IMPORTED_MODULE_1__linkUtils__["a" /* LinkError */]("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["e" /* isTerminating */])(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of(); }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
            }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of());
        });
    }
};
var ApolloLink = /** @class */ (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        if (right === void 0) { right = new ApolloLink(passthrough); }
        return this.concat(split(test, left, right));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw new Error('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());

function execute(link, operation) {
    return (link.request(Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["b" /* createOperation */])(operation.context, Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["h" /* transformOperation */])(Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["i" /* validateOperation */])(operation)))) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of());
}
//# sourceMappingURL=link.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(183).Observable;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// === Symbol Support ===

var hasSymbols = function () {
  return typeof Symbol === 'function';
};
var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};
var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

// === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];

  if (value == null) return undefined;

  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');

  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;
  if (ctor !== undefined) {
    ctor = ctor[getSymbol('species')];
    if (ctor === null) {
      ctor = undefined;
    }
  }
  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;

  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');
      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;
  if (!queue) {
    return;
  }
  subscription._queue = undefined;
  subscription._state = 'ready';
  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';

  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);
    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;
      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;
      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({ type: type, value: value });
    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{ type: type, value: value }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = function () {
  function Subscription(observer, subscriber) {
    _classCallCheck(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable

    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';

    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass(Subscription, [{
    key: 'unsubscribe',
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: 'closed',
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass(SubscriptionObserver, [{
    key: 'next',
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: 'error',
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: 'complete',
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: 'closed',
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = exports.Observable = function () {
  function Observable(subscriber) {
    _classCallCheck(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');

    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');

    this._subscriber = subscriber;
  }

  _createClass(Observable, [{
    key: 'subscribe',
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }
      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: 'forEach',
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },

          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: 'map',
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'filter',
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }
            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'reduce',
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;

      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));

            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'concat',
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);

      return new C(function (observer) {
        var subscription = void 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (sources.length === 0) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources.shift()));
              }
            }
          });
        }

        startNext(_this5);

        return function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        };
      });
    }
  }, {
    key: 'flatMap',
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });

            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: getSymbol('observable'),
    value: function () {
      return this;
    }
  }], [{
    key: 'from',
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;

      if (x == null) throw new TypeError(x + ' is not an object');

      var method = getMethod(x, getSymbol('observable'));
      if (method) {
        var observable = method.call(x);

        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');

        if (isObservable(observable) && observable.constructor === C) return observable;

        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, getSymbol('iterator'));
        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var item = _step.value;

                  observer.next(item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;
            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }
            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: 'of',
    value: function of() {
      for (var _len2 = arguments.length, items = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;

      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;
          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }
          observer.complete();
        });
      });
    }
  }, {
    key: getSymbol('species'),
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: getSymbol('observable'),
      hostReportError: hostReportError
    },
    configurabe: true
  });
}

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(186);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36), __webpack_require__(185)(module)))

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_QueryManager__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_store__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__version__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var hasSuggestedDevtools = false;
var supportedDirectives = new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"](function (operation, forward) {
    operation.query = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["removeConnectionDirectiveFromDocument"])(operation.query);
    return forward(operation);
});
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over a {@link NetworkInterface} instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through {@link Observable} instances.
 */
var ApolloClient = /** @class */ (function () {
    /**
     * Constructs an instance of {@link ApolloClient}.
     *
     * @param link The {@link ApolloLink} over which GraphQL documents will be resolved into a response.
     *
     * @param cache The initial cache to use in the data store.
     *
     * @param ssrMode Determines whether this is being run in Server Side Rendering (SSR) mode.
     *
     * @param ssrForceFetchDelay Determines the time interval before we force fetch queries for a
     * server side render.
     *
     * @param queryDeduplication If set to false, a query will still be sent to the server even if a query
     * with identical parameters (query, variables, operationName) is already in flight.
     *
     */
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        var link = options.link, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions;
        if (!link || !cache) {
            throw new Error("\n        In order to initialize Apollo Client, you must specify link & cache properties on the config object.\n        This is part of the required upgrade when migrating from Apollo Client 1.0 to Apollo Client 2.0.\n        For more information, please visit:\n          https://www.apollographql.com/docs/react/basics/setup.html\n        to help you get started.\n      ");
        }
        // remove apollo-client supported directives
        this.link = supportedDirectives.concat(link);
        this.cache = cache;
        this.store = new __WEBPACK_IMPORTED_MODULE_3__data_store__["a" /* DataStore */](cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.ssrMode = ssrMode;
        this.defaultOptions = defaultOptions || {};
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        // Attach the client instance to window to let us be found by chrome devtools, but only in
        // development mode
        var defaultConnectToDevTools = !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isProduction"])() &&
            typeof window !== 'undefined' &&
            !window.__APOLLO_CLIENT__;
        if (typeof connectToDevTools === 'undefined'
            ? defaultConnectToDevTools
            : connectToDevTools && typeof window !== 'undefined') {
            window.__APOLLO_CLIENT__ = this;
        }
        /**
         * Suggest installing the devtools for developers who don't have them
         */
        if (!hasSuggestedDevtools && !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isProduction"])()) {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self) {
                // First check if devtools is not installed
                if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                    // Only for Chrome
                    if (window.navigator &&
                        window.navigator.userAgent.indexOf('Chrome') > -1) {
                        // tslint:disable-next-line
                        console.debug('Download the Apollo DevTools ' +
                            'for a better development experience: ' +
                            'https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm');
                    }
                }
            }
        }
        this.version = __WEBPACK_IMPORTED_MODULE_4__version__["version"];
    }
    /**
     * This watches the results of the query according to the options specified and
     * returns an {@link ObservableQuery}. We can subscribe to this {@link ObservableQuery} and
     * receive updated results through a GraphQL observer.
     * <p /><p />
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     * <p /><p />
     * For example, suppose you call watchQuery on a GraphQL query that fetches an person's
     * first name and last name and this person has a particular object identifer, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and his/her first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     * <p /><p />
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     *
     */
    ApolloClient.prototype.watchQuery = function (options) {
        this.initQueryManager();
        if (this.defaultOptions.watchQuery) {
            options = __assign({}, this.defaultOptions.watchQuery, options);
        }
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = __assign({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a {@link Promise} which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options An object of type {@link QueryOptions} that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */
    ApolloClient.prototype.query = function (options) {
        this.initQueryManager();
        if (this.defaultOptions.query) {
            options = __assign({}, this.defaultOptions.query, options);
        }
        if (options.fetchPolicy === 'cache-and-network') {
            throw new Error('cache-and-network fetchPolicy can only be used with watchQuery');
        }
        // XXX Overwriting options is probably not the best way to do this long
        // term...
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = __assign({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * {@link Promise} which is either resolved with the resulting data or rejected with an
     * error.
     *
     * It takes options as an object with the following keys and values:
     */
    ApolloClient.prototype.mutate = function (options) {
        this.initQueryManager();
        if (this.defaultOptions.mutate) {
            options = __assign({}, this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * {@link Observable} which either emits received data or an error.
     */
    ApolloClient.prototype.subscribe = function (options) {
        this.initQueryManager();
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     */
    ApolloClient.prototype.readQuery = function (options) {
        return this.initProxy().readQuery(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */
    ApolloClient.prototype.readFragment = function (options) {
        return this.initProxy().readFragment(options);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */
    ApolloClient.prototype.writeQuery = function (options) {
        var result = this.initProxy().writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */
    ApolloClient.prototype.writeFragment = function (options) {
        var result = this.initProxy().writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    /**
     * Sugar for writeQuery & writeFragment
     * This method will construct a query from the data object passed in.
     * If no id is supplied, writeData will write the data to the root.
     * If an id is supplied, writeData will write a fragment to the object
     * specified by the id in the store.
     *
     * Since you aren't passing in a query to check the shape of the data,
     * you must pass in an object that conforms to the shape of valid GraphQL data.
     */
    ApolloClient.prototype.writeData = function (options) {
        var result = this.initProxy().writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["execute"])(this.link, payload);
    };
    /**
     * This initializes the query manager that tracks queries and the cache
     */
    ApolloClient.prototype.initQueryManager = function () {
        var _this = this;
        if (this.queryManager)
            return;
        this.queryManager = new __WEBPACK_IMPORTED_MODULE_2__core_QueryManager__["a" /* QueryManager */]({
            link: this.link,
            store: this.store,
            queryDeduplication: this.queryDeduplication,
            ssrMode: this.ssrMode,
            onBroadcast: function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore(),
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            },
        });
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.queryManager
                ? _this.queryManager.clearStore()
                : Promise.resolve(null);
        })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () {
            return _this.queryManager && _this.queryManager.reFetchObservableQueries
                ? _this.queryManager.reFetchObservableQueries()
                : Promise.resolve(null);
        });
    };
    /**
     * Allows callbacks to be registered that are executed with the store is reset.
     * onResetStore returns an unsubscribe function for removing your registered callbacks.
     */
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager
            ? this.queryManager.reFetchObservableQueries(includeStandby)
            : Promise.resolve(null);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */
    ApolloClient.prototype.extract = function (optimistic) {
        return this.initProxy().extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */
    ApolloClient.prototype.restore = function (serializedState) {
        return this.initProxy().restore(serializedState);
    };
    /**
     * Initializes a data proxy for this client instance if one does not already
     * exist and returns either a previously initialized proxy instance or the
     * newly initialized instance.
     */
    ApolloClient.prototype.initProxy = function () {
        if (!this.proxy) {
            this.initQueryManager();
            this.proxy = this.cache;
        }
        return this.proxy;
    };
    return ApolloClient;
}());
/* harmony default export */ __webpack_exports__["a"] = (ApolloClient);
//# sourceMappingURL=ApolloClient.js.map

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_dedup__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_utilities__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scheduler_scheduler__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Observable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_mutations__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_queries__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ObservableQuery__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__networkStatus__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types__ = __webpack_require__(39);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};













var defaultQueryInfo = {
    listeners: [],
    invalidated: false,
    document: null,
    newData: null,
    lastRequestId: null,
    observableQuery: null,
    subscriptions: [],
};
var QueryManager = /** @class */ (function () {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function () { return undefined; } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d;
        this.mutationStore = new __WEBPACK_IMPORTED_MODULE_7__data_mutations__["a" /* MutationStore */]();
        this.queryStore = new __WEBPACK_IMPORTED_MODULE_8__data_queries__["a" /* QueryStore */]();
        // let's not start at zero to avoid pain with bad checks
        this.idCounter = 1;
        // XXX merge with ObservableQuery but that needs to be expanded to support mutations and
        // subscriptions as well
        this.queries = new Map();
        // A map going from a requestId to a promise that has not yet been resolved. We use this to keep
        // track of queries that are inflight and reject them in case some
        // destabalizing action occurs (e.g. reset of the Apollo store).
        this.fetchQueryPromises = new Map();
        // A map going from the name of a query to an observer issued for it by watchQuery. This is
        // generally used to refetches for refetchQueries and to update mutation results through
        // updateQueries.
        this.queryIdsByName = {};
        this.link = link;
        this.deduplicator = __WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"].from([new __WEBPACK_IMPORTED_MODULE_2_apollo_link_dedup__["a" /* DedupLink */](), link]);
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.scheduler = new __WEBPACK_IMPORTED_MODULE_4__scheduler_scheduler__["a" /* QueryScheduler */]({ queryManager: this, ssrMode: ssrMode });
    }
    QueryManager.prototype.mutate = function (_a) {
        var _this = this;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        if (!mutation) {
            throw new Error('mutation option is required. You must specify your GraphQL document in the mutation option.');
        }
        if (fetchPolicy && fetchPolicy !== 'no-cache') {
            throw new Error("fetchPolicy for mutations currently only supports the 'no-cache' policy");
        }
        var mutationId = this.generateQueryId();
        var cache = this.dataStore.getCache();
        (mutation = cache.transformDocument(mutation)),
            (variables = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["assign"])({}, Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["getDefaultValues"])(Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["getMutationDefinition"])(mutation)), variables));
        var mutationString = Object(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["a" /* print */])(mutation);
        this.setQuery(mutationId, function () { return ({ document: mutation }); });
        // Create a map of update queries by id to the query instead of by name.
        var generateUpdateQueriesInfo = function () {
            var ret = {};
            if (updateQueriesByName) {
                Object.keys(updateQueriesByName).forEach(function (queryName) {
                    return (_this.queryIdsByName[queryName] || []).forEach(function (queryId) {
                        ret[queryId] = {
                            updater: updateQueriesByName[queryName],
                            query: _this.queryStore.get(queryId),
                        };
                    });
                });
            }
            return ret;
        };
        this.mutationStore.initMutation(mutationId, mutationString, variables);
        this.dataStore.markMutationInit({
            mutationId: mutationId,
            document: mutation,
            variables: variables || {},
            updateQueries: generateUpdateQueriesInfo(),
            update: updateWithProxyFn,
            optimisticResponse: optimisticResponse,
        });
        this.broadcastQueries();
        return new Promise(function (resolve, reject) {
            var storeResult;
            var error;
            var operation = _this.buildOperationForLink(mutation, variables, __assign({}, context, { optimisticResponse: optimisticResponse }));
            var completeMutation = function () { return __awaiter(_this, void 0, void 0, function () {
                var refetchQueryPromises, _i, refetchQueries_1, refetchQuery, promise;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (error) {
                                this.mutationStore.markMutationError(mutationId, error);
                            }
                            this.dataStore.markMutationComplete({
                                mutationId: mutationId,
                                optimisticResponse: optimisticResponse,
                            });
                            this.broadcastQueries();
                            if (error) {
                                throw error;
                            }
                            // allow for conditional refetches
                            // XXX do we want to make this the only API one day?
                            if (typeof refetchQueries === 'function') {
                                refetchQueries = refetchQueries(storeResult);
                            }
                            refetchQueryPromises = [];
                            for (_i = 0, refetchQueries_1 = refetchQueries; _i < refetchQueries_1.length; _i++) {
                                refetchQuery = refetchQueries_1[_i];
                                if (typeof refetchQuery === 'string') {
                                    promise = this.refetchQueryByName(refetchQuery);
                                    if (promise) {
                                        refetchQueryPromises.push(promise);
                                    }
                                    continue;
                                }
                                refetchQueryPromises.push(this.query({
                                    query: refetchQuery.query,
                                    variables: refetchQuery.variables,
                                    fetchPolicy: 'network-only',
                                }));
                            }
                            if (!awaitRefetchQueries) return [3 /*break*/, 2];
                            return [4 /*yield*/, Promise.all(refetchQueryPromises)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            this.setQuery(mutationId, function () { return ({ document: undefined }); });
                            if (errorPolicy === 'ignore' &&
                                storeResult &&
                                Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["graphQLResultHasError"])(storeResult)) {
                                delete storeResult.errors;
                            }
                            return [2 /*return*/, storeResult];
                    }
                });
            }); };
            Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["execute"])(_this.link, operation).subscribe({
                next: function (result) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["graphQLResultHasError"])(result) && errorPolicy === 'none') {
                        error = new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                            graphQLErrors: result.errors,
                        });
                        return;
                    }
                    _this.mutationStore.markMutationResult(mutationId);
                    if (fetchPolicy !== 'no-cache') {
                        _this.dataStore.markMutationResult({
                            mutationId: mutationId,
                            result: result,
                            document: mutation,
                            variables: variables || {},
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                        });
                    }
                    storeResult = result;
                },
                error: function (err) {
                    _this.mutationStore.markMutationError(mutationId, err);
                    _this.dataStore.markMutationComplete({
                        mutationId: mutationId,
                        optimisticResponse: optimisticResponse,
                    });
                    _this.broadcastQueries();
                    _this.setQuery(mutationId, function () { return ({ document: undefined }); });
                    reject(new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                        networkError: err,
                    }));
                },
                complete: function () { return completeMutation().then(resolve, reject); },
            });
        });
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, 
    // This allows us to track if this is a query spawned by a `fetchMore`
    // call for another query. We need this data to compute the `fetchMore`
    // network status for the query this is fetching for.
    fetchMoreForQueryId) {
        var _this = this;
        var _a = options.variables, variables = _a === void 0 ? {} : _a, _b = options.metadata, metadata = _b === void 0 ? null : _b, _c = options.fetchPolicy, fetchPolicy = _c === void 0 ? 'cache-first' : _c;
        var cache = this.dataStore.getCache();
        var query = cache.transformDocument(options.query);
        var storeResult;
        var needToFetch = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        // If this is not a force fetch, we want to diff the query against the
        // store before we fetch it from the network interface.
        // TODO we hit the cache even if the policy is network-first. This could be unnecessary if the network is up.
        if (fetchType !== __WEBPACK_IMPORTED_MODULE_11__types__["a" /* FetchType */].refetch &&
            fetchPolicy !== 'network-only' &&
            fetchPolicy !== 'no-cache') {
            var _d = this.dataStore.getCache().diff({
                query: query,
                variables: variables,
                returnPartialData: true,
                optimistic: false,
            }), complete = _d.complete, result = _d.result;
            // If we're in here, only fetch if we have missing fields
            needToFetch = !complete || fetchPolicy === 'cache-and-network';
            storeResult = result;
        }
        var shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
        // we need to check to see if this is an operation that uses the @live directive
        if (Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["hasDirectives"])(['live'], query))
            shouldFetch = true;
        var requestId = this.generateRequestId();
        // set up a watcher to listen to cache updates
        var cancel = this.updateQueryWatch(queryId, query, options);
        // Initialize query in store with unique requestId
        this.setQuery(queryId, function () { return ({
            document: query,
            lastRequestId: requestId,
            invalidated: true,
            cancel: cancel,
        }); });
        this.invalidate(true, fetchMoreForQueryId);
        this.queryStore.initQuery({
            queryId: queryId,
            document: query,
            storePreviousVariables: shouldFetch,
            variables: variables,
            isPoll: fetchType === __WEBPACK_IMPORTED_MODULE_11__types__["a" /* FetchType */].poll,
            isRefetch: fetchType === __WEBPACK_IMPORTED_MODULE_11__types__["a" /* FetchType */].refetch,
            metadata: metadata,
            fetchMoreForQueryId: fetchMoreForQueryId,
        });
        this.broadcastQueries();
        // If there is no part of the query we need to fetch from the server (or,
        // fetchPolicy is cache-only), we just write the store result as the final result.
        var shouldDispatchClientResult = !shouldFetch || fetchPolicy === 'cache-and-network';
        if (shouldDispatchClientResult) {
            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
            this.invalidate(true, queryId, fetchMoreForQueryId);
            this.broadcastQueries();
        }
        if (shouldFetch) {
            var networkResult = this.fetchRequest({
                requestId: requestId,
                queryId: queryId,
                document: query,
                options: options,
                fetchMoreForQueryId: fetchMoreForQueryId,
            }).catch(function (error) {
                // This is for the benefit of `refetch` promises, which currently don't get their errors
                // through the store like watchQuery observers do
                if (Object(__WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["b" /* isApolloError */])(error)) {
                    throw error;
                }
                else {
                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                    if (requestId >= (lastRequestId || 1)) {
                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                        _this.invalidate(true, queryId, fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    _this.removeFetchQueryPromise(requestId);
                    throw new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({ networkError: error });
                }
            });
            // we don't return the promise for cache-and-network since it is already
            // returned below from the cache
            if (fetchPolicy !== 'cache-and-network') {
                return networkResult;
            }
            else {
                // however we need to catch the error so it isn't unhandled in case of
                // network error
                networkResult.catch(function () { });
            }
        }
        // If we have no query to send to the server, we should return the result
        // found within the store.
        return Promise.resolve({ data: storeResult });
    };
    // Returns a query listener that will update the given observer based on the
    // results (or lack thereof) for a particular query.
    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
        var _this = this;
        var previouslyHadError = false;
        return function (queryStoreValue, newData) {
            // we're going to take a look at the data, so the query is no longer invalidated
            _this.invalidate(false, queryId);
            // The query store value can be undefined in the event of a store
            // reset.
            if (!queryStoreValue)
                return;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            var fetchPolicy = observableQuery
                ? observableQuery.options.fetchPolicy
                : options.fetchPolicy;
            // don't watch the store for queries on standby
            if (fetchPolicy === 'standby')
                return;
            var errorPolicy = observableQuery
                ? observableQuery.options.errorPolicy
                : options.errorPolicy;
            var lastResult = observableQuery
                ? observableQuery.getLastResult()
                : null;
            var lastError = observableQuery ? observableQuery.getLastError() : null;
            var shouldNotifyIfLoading = (!newData && queryStoreValue.previousVariables != null) ||
                fetchPolicy === 'cache-only' ||
                fetchPolicy === 'cache-and-network';
            // if this caused by a cache broadcast but the query is still in flight
            // don't notify the observer
            // if (
            //   isCacheBroadcast &&
            //   isNetworkRequestInFlight(queryStoreValue.networkStatus)
            // ) {
            //   shouldNotifyIfLoading = false;
            // }
            var networkStatusChanged = Boolean(lastResult &&
                queryStoreValue.networkStatus !== lastResult.networkStatus);
            var errorStatusChanged = errorPolicy &&
                (lastError && lastError.graphQLErrors) !==
                    queryStoreValue.graphQLErrors &&
                errorPolicy !== 'none';
            if (!Object(__WEBPACK_IMPORTED_MODULE_10__networkStatus__["b" /* isNetworkRequestInFlight */])(queryStoreValue.networkStatus) ||
                (networkStatusChanged && options.notifyOnNetworkStatusChange) ||
                shouldNotifyIfLoading) {
                // If we have either a GraphQL error or a network error, we create
                // an error and tell the observer about it.
                if (((!errorPolicy || errorPolicy === 'none') &&
                    queryStoreValue.graphQLErrors &&
                    queryStoreValue.graphQLErrors.length > 0) ||
                    queryStoreValue.networkError) {
                    var apolloError_1 = new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError,
                    });
                    previouslyHadError = true;
                    if (observer.error) {
                        try {
                            observer.error(apolloError_1);
                        }
                        catch (e) {
                            // Throw error outside this control flow to avoid breaking Apollo's state
                            setTimeout(function () {
                                throw e;
                            }, 0);
                        }
                    }
                    else {
                        // Throw error outside this control flow to avoid breaking Apollo's state
                        setTimeout(function () {
                            throw apolloError_1;
                        }, 0);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["isProduction"])()) {
                            /* tslint:disable-next-line */
                            console.info('An unhandled error was thrown because no error handler is registered ' +
                                'for the query ' +
                                Object(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["a" /* print */])(queryStoreValue.document));
                        }
                    }
                    return;
                }
                try {
                    var data = void 0;
                    var isMissing = void 0;
                    if (newData) {
                        // clear out the latest new data, since we're now using it
                        _this.setQuery(queryId, function () { return ({ newData: null }); });
                        data = newData.result;
                        isMissing = !newData.complete || false;
                    }
                    else {
                        if (lastResult && lastResult.data && !errorStatusChanged) {
                            data = lastResult.data;
                            isMissing = false;
                        }
                        else {
                            var document_1 = _this.getQuery(queryId).document;
                            var readResult = _this.dataStore.getCache().diff({
                                query: document_1,
                                variables: queryStoreValue.previousVariables ||
                                    queryStoreValue.variables,
                                optimistic: true,
                            });
                            data = readResult.result;
                            isMissing = !readResult.complete;
                        }
                    }
                    var resultFromStore = void 0;
                    // If there is some data missing and the user has told us that they
                    // do not tolerate partial data then we want to return the previous
                    // result and mark it as stale.
                    if (isMissing && fetchPolicy !== 'cache-only') {
                        resultFromStore = {
                            data: lastResult && lastResult.data,
                            loading: Object(__WEBPACK_IMPORTED_MODULE_10__networkStatus__["b" /* isNetworkRequestInFlight */])(queryStoreValue.networkStatus),
                            networkStatus: queryStoreValue.networkStatus,
                            stale: true,
                        };
                    }
                    else {
                        resultFromStore = {
                            data: data,
                            loading: Object(__WEBPACK_IMPORTED_MODULE_10__networkStatus__["b" /* isNetworkRequestInFlight */])(queryStoreValue.networkStatus),
                            networkStatus: queryStoreValue.networkStatus,
                            stale: false,
                        };
                    }
                    // if the query wants updates on errors we need to add it to the result
                    if (errorPolicy === 'all' &&
                        queryStoreValue.graphQLErrors &&
                        queryStoreValue.graphQLErrors.length > 0) {
                        resultFromStore.errors = queryStoreValue.graphQLErrors;
                    }
                    if (observer.next) {
                        var isDifferentResult = !(lastResult &&
                            resultFromStore &&
                            lastResult.networkStatus === resultFromStore.networkStatus &&
                            lastResult.stale === resultFromStore.stale &&
                            // We can do a strict equality check here because we include a `previousResult`
                            // with `readQueryFromStore`. So if the results are the same they will be
                            // referentially equal.
                            lastResult.data === resultFromStore.data);
                        if (isDifferentResult || previouslyHadError) {
                            try {
                                observer.next(Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["maybeDeepFreeze"])(resultFromStore));
                            }
                            catch (e) {
                                // Throw error outside this control flow to avoid breaking Apollo's state
                                setTimeout(function () {
                                    throw e;
                                }, 0);
                            }
                        }
                    }
                    previouslyHadError = false;
                }
                catch (error) {
                    previouslyHadError = true;
                    if (observer.error)
                        observer.error(new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({ networkError: error }));
                    return;
                }
            }
        };
    };
    // The shouldSubscribe option is a temporary fix that tells us whether watchQuery was called
    // directly (i.e. through ApolloClient) or through the query method within QueryManager.
    // Currently, the query method uses watchQuery in order to handle non-network errors correctly
    // but we don't want to keep track observables issued for the query method since those aren't
    // supposed to be refetched in the event of a store reset. Once we unify error handling for
    // network errors and non-network errors, the shouldSubscribe option will go away.
    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
        if (shouldSubscribe === void 0) { shouldSubscribe = true; }
        if (options.fetchPolicy === 'standby') {
            throw new Error('client.watchQuery cannot be called with fetchPolicy set to "standby"');
        }
        // get errors synchronously
        var queryDefinition = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["getQueryDefinition"])(options.query);
        // assign variable default values if supplied
        if (queryDefinition.variableDefinitions &&
            queryDefinition.variableDefinitions.length) {
            var defaultValues = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["getDefaultValues"])(queryDefinition);
            options.variables = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["assign"])({}, defaultValues, options.variables);
        }
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var transformedOptions = __assign({}, options);
        return new __WEBPACK_IMPORTED_MODULE_9__ObservableQuery__["a" /* ObservableQuery */]({
            scheduler: this.scheduler,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe,
        });
    };
    QueryManager.prototype.query = function (options) {
        var _this = this;
        if (!options.query) {
            throw new Error('query option is required. You must specify your GraphQL document ' +
                'in the query option.');
        }
        if (options.query.kind !== 'Document') {
            throw new Error('You must wrap the query string in a "gql" tag.');
        }
        if (options.returnPartialData) {
            throw new Error('returnPartialData option only supported on watchQuery.');
        }
        if (options.pollInterval) {
            throw new Error('pollInterval option only supported on watchQuery.');
        }
        var requestId = this.idCounter;
        return new Promise(function (resolve, reject) {
            _this.addFetchQueryPromise(requestId, resolve, reject);
            return _this.watchQuery(options, false)
                .result()
                .then(function (result) {
                _this.removeFetchQueryPromise(requestId);
                resolve(result);
            })
                .catch(function (error) {
                _this.removeFetchQueryPromise(requestId);
                reject(error);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function () {
        var queryId = this.idCounter.toString();
        this.idCounter++;
        return queryId;
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.queryStore.stopQuery(queryId);
        this.invalidate(true, queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.addQueryListener = function (queryId, listener) {
        this.setQuery(queryId, function (_a) {
            var _b = _a.listeners, listeners = _b === void 0 ? [] : _b;
            return ({
                listeners: listeners.concat([listener]),
                invalidate: false,
            });
        });
    };
    QueryManager.prototype.updateQueryWatch = function (queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel)
            cancel();
        var previousResult = function () {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) {
                    previousResult = lastResult.data;
                }
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function (newData) {
                _this.setQuery(queryId, function () { return ({ invalidated: true, newData: newData }); });
            },
        });
    };
    // Adds a promise to this.fetchQueryPromises for a given request ID.
    QueryManager.prototype.addFetchQueryPromise = function (requestId, resolve, reject) {
        this.fetchQueryPromises.set(requestId.toString(), {
            resolve: resolve,
            reject: reject,
        });
    };
    // Removes the promise in this.fetchQueryPromises for a particular request ID.
    QueryManager.prototype.removeFetchQueryPromise = function (requestId) {
        this.fetchQueryPromises.delete(requestId.toString());
    };
    // Adds an ObservableQuery to this.observableQueries and to this.observableQueriesByName.
    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
        this.setQuery(queryId, function () { return ({ observableQuery: observableQuery }); });
        // Insert the ObservableQuery into this.observableQueriesByName if the query has a name
        var queryDef = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["getQueryDefinition"])(observableQuery.options.query);
        if (queryDef.name && queryDef.name.value) {
            var queryName = queryDef.name.value;
            // XXX we may we want to warn the user about query name conflicts in the future
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName] || [];
            this.queryIdsByName[queryName].push(observableQuery.queryId);
        }
    };
    QueryManager.prototype.removeObservableQuery = function (queryId) {
        var _a = this.getQuery(queryId), observableQuery = _a.observableQuery, cancel = _a.cancel;
        if (cancel)
            cancel();
        if (!observableQuery)
            return;
        var definition = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["getQueryDefinition"])(observableQuery.options.query);
        var queryName = definition.name ? definition.name.value : null;
        this.setQuery(queryId, function () { return ({ observableQuery: null }); });
        if (queryName) {
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName].filter(function (val) {
                return !(observableQuery.queryId === val);
            });
        }
    };
    QueryManager.prototype.clearStore = function () {
        // Before we have sent the reset action to the store,
        // we can no longer rely on the results returned by in-flight
        // requests since these may depend on values that previously existed
        // in the data portion of the store. So, we cancel the promises and observers
        // that we have issued so far and not yet resolved (in the case of
        // queries).
        this.fetchQueryPromises.forEach(function (_a) {
            var reject = _a.reject;
            reject(new Error('Store reset while query was in flight(not completed in link chain)'));
        });
        var resetIds = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery)
                resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        // begin removing data from the store
        var reset = this.dataStore.reset();
        return reset;
    };
    QueryManager.prototype.resetStore = function () {
        var _this = this;
        // Similarly, we have to have to refetch each of the queries currently being
        // observed. We refetch instead of error'ing on these since the assumption is that
        // resetting the store doesn't eliminate the need for the queries currently being
        // watched. If there is an existing query in flight when the store is reset,
        // the promise for it will be rejected and its results will not be written to the
        // store.
        return this.clearStore().then(function () {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.getObservableQueryPromises = function (includeStandby) {
        var _this = this;
        var observableQueryPromises = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (!observableQuery)
                return;
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (fetchPolicy !== 'cache-only' &&
                (includeStandby || fetchPolicy !== 'standby')) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.setQuery(queryId, function () { return ({ newData: null }); });
            _this.invalidate(true, queryId);
        });
        return observableQueryPromises;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var observableQueryPromises = this.getObservableQueryPromises(includeStandby);
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.startQuery = function (queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options)
            // `fetchQuery` returns a Promise. In case of a failure it should be caucht or else the
            // console will show an `Uncaught (in promise)` message. Ignore the error for now.
            .catch(function () { return undefined; });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function (options) {
        var _this = this;
        var query = options.query;
        var cache = this.dataStore.getCache();
        var transformedDoc = cache.transformDocument(query);
        var variables = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["assign"])({}, Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["getDefaultValues"])(Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["getOperationDefinition"])(query)), options.variables);
        var sub;
        var observers = [];
        return new __WEBPACK_IMPORTED_MODULE_6__util_Observable__["a" /* Observable */](function (observer) {
            observers.push(observer);
            // If this is the first observer, actually initiate the network subscription
            if (observers.length === 1) {
                var handler = {
                    next: function (result) {
                        _this.dataStore.markSubscriptionResult(result, transformedDoc, variables);
                        _this.broadcastQueries();
                        // It's slightly awkward that the data for subscriptions doesn't come from the store.
                        observers.forEach(function (obs) {
                            // XXX I'd prefer a different way to handle errors for subscriptions
                            if (obs.next)
                                obs.next(result);
                        });
                    },
                    error: function (error) {
                        observers.forEach(function (obs) {
                            if (obs.error)
                                obs.error(error);
                        });
                    },
                };
                // TODO: Should subscriptions also accept a `context` option to pass
                // through to links?
                var operation = _this.buildOperationForLink(transformedDoc, variables);
                sub = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["execute"])(_this.link, operation).subscribe(handler);
            }
            return function () {
                observers = observers.filter(function (obs) { return obs !== observer; });
                // If we removed the last observer, tear down the network subscription
                if (observers.length === 0 && sub) {
                    sub.unsubscribe();
                }
            };
        });
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryInStore(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        var subscriptions = this.getQuery(queryId).subscriptions;
        // teardown all links
        subscriptions.forEach(function (x) { return x.unsubscribe(); });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function (observableQuery, optimistic) {
        if (optimistic === void 0) { optimistic = true; }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        // XXX test this
        if (newData) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["maybeDeepFreeze"])({ data: newData.result, partial: false });
        }
        else {
            try {
                // the query is brand new, so we read from the store to see if anything is there
                var data = this.dataStore.getCache().read({
                    query: query,
                    variables: variables,
                    previousResult: lastResult ? lastResult.data : undefined,
                    optimistic: optimistic,
                });
                return Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["maybeDeepFreeze"])({ data: data, partial: false });
            }
            catch (e) {
                return Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["maybeDeepFreeze"])({ data: {}, partial: true });
            }
        }
    };
    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            if (!foundObserveableQuery) {
                throw new Error("ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
            }
            observableQuery = foundObserveableQuery;
        }
        else {
            observableQuery = queryIdOrObservable;
        }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        var data = this.getCurrentQueryResult(observableQuery, false).data;
        return {
            previousResult: data,
            variables: variables,
            document: query,
        };
    };
    QueryManager.prototype.broadcastQueries = function () {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function (info, id) {
            if (!info.invalidated || !info.listeners)
                return;
            info.listeners
                // it's possible for the listener to be undefined if the query is being stopped
                // See here for more detail: https://github.com/apollostack/apollo-client/issues/231
                .filter(function (x) { return !!x; })
                .forEach(function (listener) {
                listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    // Takes a request id, query id, a query document and information associated with the query
    // and send it to the network interface. Returns
    // a promise for the result associated with that request.
    QueryManager.prototype.fetchRequest = function (_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, context = options.context, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var operation = this.buildOperationForLink(document, variables, __assign({}, context, { 
            // TODO: Should this be included for all entry points via
            // buildOperationForLink?
            forceFetch: !this.queryDeduplication }));
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function (resolve, reject) {
            _this.addFetchQueryPromise(requestId, resolve, reject);
            var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["execute"])(_this.deduplicator, operation).subscribe({
                next: function (result) {
                    // default the lastRequestId to 1
                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                    if (requestId >= (lastRequestId || 1)) {
                        if (fetchPolicy !== 'no-cache') {
                            try {
                                _this.dataStore.markQueryResult(result, document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
                            }
                            catch (e) {
                                reject(e);
                                return;
                            }
                        }
                        else {
                            _this.setQuery(queryId, function () { return ({
                                newData: { result: result.data, complete: true },
                            }); });
                        }
                        _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                        _this.invalidate(true, queryId, fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    if (result.errors && errorPolicy === 'none') {
                        reject(new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                            graphQLErrors: result.errors,
                        }));
                        return;
                    }
                    else if (errorPolicy === 'all') {
                        errorsFromStore = result.errors;
                    }
                    if (fetchMoreForQueryId || fetchPolicy === 'no-cache') {
                        // We don't write fetchMore results to the store because this would overwrite
                        // the original result in case an @connection directive is used.
                        resultFromStore = result.data;
                    }
                    else {
                        try {
                            // ensure result is combined with data already in store
                            resultFromStore = _this.dataStore.getCache().read({
                                variables: variables,
                                query: document,
                                optimistic: false,
                            });
                            // this will throw an error if there are missing fields in
                            // the results which can happen with errors from the server.
                            // tslint:disable-next-line
                        }
                        catch (e) { }
                    }
                },
                error: function (error) {
                    _this.removeFetchQueryPromise(requestId);
                    _this.setQuery(queryId, function (_a) {
                        var subscriptions = _a.subscriptions;
                        return ({
                            subscriptions: subscriptions.filter(function (x) { return x !== subscription; }),
                        });
                    });
                    reject(error);
                },
                complete: function () {
                    _this.removeFetchQueryPromise(requestId);
                    _this.setQuery(queryId, function (_a) {
                        var subscriptions = _a.subscriptions;
                        return ({
                            subscriptions: subscriptions.filter(function (x) { return x !== subscription; }),
                        });
                    });
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: __WEBPACK_IMPORTED_MODULE_10__networkStatus__["a" /* NetworkStatus */].ready,
                        stale: false,
                    });
                },
            });
            _this.setQuery(queryId, function (_a) {
                var subscriptions = _a.subscriptions;
                return ({
                    subscriptions: subscriptions.concat([subscription]),
                });
            });
        });
    };
    // Refetches a query given that query's name. Refetches
    // all ObservableQuery instances associated with the query name.
    QueryManager.prototype.refetchQueryByName = function (queryName) {
        var _this = this;
        var refetchedQueries = this.queryIdsByName[queryName];
        // early return if the query named does not exist (not yet fetched)
        // this used to warn but it may be inteneded behavoir to try and refetch
        // un called queries because they could be on different routes
        if (refetchedQueries === undefined)
            return;
        return Promise.all(refetchedQueries
            .map(function (id) { return _this.getQuery(id).observableQuery; })
            .filter(function (x) { return !!x; })
            .map(function (x) { return x.refetch(); }));
    };
    QueryManager.prototype.generateRequestId = function () {
        var requestId = this.idCounter;
        this.idCounter++;
        return requestId;
    };
    QueryManager.prototype.getQuery = function (queryId) {
        return this.queries.get(queryId) || __assign({}, defaultQueryInfo);
    };
    QueryManager.prototype.setQuery = function (queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = __assign({}, prev, updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function (invalidated, queryId, fetchMoreForQueryId) {
        if (queryId)
            this.setQuery(queryId, function () { return ({ invalidated: invalidated }); });
        if (fetchMoreForQueryId) {
            this.setQuery(fetchMoreForQueryId, function () { return ({ invalidated: invalidated }); });
        }
    };
    QueryManager.prototype.buildOperationForLink = function (document, variables, extraContext) {
        var cache = this.dataStore.getCache();
        return {
            query: cache.transformForLink
                ? cache.transformForLink(document)
                : document,
            variables: variables,
            operationName: Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["getOperationName"])(document) || undefined,
            context: __assign({}, extraContext, { cache: cache, 
                // getting an entry's cache key is useful for cacheResolvers & state-link
                getCacheKey: function (obj) {
                    if (cache.config) {
                        // on the link, we just want the id string, not the full id value from toIdValue
                        return cache.config.dataIdFromObject(obj);
                    }
                    else {
                        throw new Error('To use context.getCacheKey, you need to use a cache that has a configurable dataIdFromObject, like apollo-cache-inmemory.');
                    }
                } }),
        };
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dedupLink__ = __webpack_require__(190);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dedupLink__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DedupLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/*
 * Expects context to contain the forceFetch field if no dedup
 */
var DedupLink = /** @class */ (function (_super) {
    __extends(DedupLink, _super);
    function DedupLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inFlightRequestObservables = new Map();
        _this.subscribers = new Map();
        return _this;
    }
    DedupLink.prototype.request = function (operation, forward) {
        var _this = this;
        // sometimes we might not want to deduplicate a request, for example when we want to force fetch it.
        if (operation.getContext().forceFetch) {
            return forward(operation);
        }
        var key = operation.toKey();
        var cleanup = function (key) {
            _this.inFlightRequestObservables.delete(key);
            var prev = _this.subscribers.get(key);
            return prev;
        };
        if (!this.inFlightRequestObservables.get(key)) {
            // this is a new request, i.e. we haven't deduplicated it yet
            // call the next link
            var singleObserver_1 = forward(operation);
            var subscription_1;
            var sharedObserver = new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"](function (observer) {
                // this will still be called by each subscriber regardless of
                // deduplication status
                var prev = _this.subscribers.get(key);
                if (!prev)
                    prev = { next: [], error: [], complete: [] };
                _this.subscribers.set(key, {
                    next: prev.next.concat([observer.next.bind(observer)]),
                    error: prev.error.concat([observer.error.bind(observer)]),
                    complete: prev.complete.concat([observer.complete.bind(observer)]),
                });
                if (!subscription_1) {
                    subscription_1 = singleObserver_1.subscribe({
                        next: function (result) {
                            var prev = cleanup(key);
                            _this.subscribers.delete(key);
                            if (prev) {
                                prev.next.forEach(function (next) { return next(result); });
                                prev.complete.forEach(function (complete) { return complete(); });
                            }
                        },
                        error: function (error) {
                            var prev = cleanup(key);
                            _this.subscribers.delete(key);
                            if (prev)
                                prev.error.forEach(function (err) { return err(error); });
                        },
                    });
                }
                return function () {
                    if (subscription_1)
                        subscription_1.unsubscribe();
                    _this.inFlightRequestObservables.delete(key);
                };
            });
            this.inFlightRequestObservables.set(key, sharedObserver);
        }
        // return shared Observable
        return this.inFlightRequestObservables.get(key);
    };
    return DedupLink;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"]));

//# sourceMappingURL=dedupLink.js.map

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_types__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__ = __webpack_require__(26);
// The QueryScheduler is supposed to be a mechanism that schedules polling queries such that
// they are clustered into the time slots of the QueryBatcher and are batched together. It
// also makes sure that for a given polling query, if one instance of the query is inflight,
// another instance will not be fired until the query returns or times out. We do this because
// another query fires while one is already in flight, the data will stay in the "loading" state
// even after the first query has returned.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var QueryScheduler = /** @class */ (function () {
    function QueryScheduler(_a) {
        var queryManager = _a.queryManager, ssrMode = _a.ssrMode;
        // Map going from queryIds to query options that are in flight.
        this.inFlightQueries = {};
        // Map going from query ids to the query options associated with those queries. Contains all of
        // the queries, both in flight and not in flight.
        this.registeredQueries = {};
        // Map going from polling interval with to the query ids that fire on that interval.
        // These query ids are associated with a set of options in the this.registeredQueries.
        this.intervalQueries = {};
        // Map going from polling interval widths to polling timers.
        this.pollingTimers = {};
        this.ssrMode = false;
        this.queryManager = queryManager;
        this.ssrMode = ssrMode || false;
    }
    QueryScheduler.prototype.checkInFlight = function (queryId) {
        var query = this.queryManager.queryStore.get(queryId);
        return (query &&
            query.networkStatus !== __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].ready &&
            query.networkStatus !== __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].error);
    };
    QueryScheduler.prototype.fetchQuery = function (queryId, options, fetchType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.queryManager
                .fetchQuery(queryId, options, fetchType)
                .then(function (result) {
                resolve(result);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    QueryScheduler.prototype.startPollingQuery = function (options, queryId, listener) {
        if (!options.pollInterval) {
            throw new Error('Attempted to start a polling query without a polling interval.');
        }
        // Do not poll in SSR mode
        if (this.ssrMode)
            return queryId;
        this.registeredQueries[queryId] = options;
        if (listener) {
            this.queryManager.addQueryListener(queryId, listener);
        }
        this.addQueryOnInterval(queryId, options);
        return queryId;
    };
    QueryScheduler.prototype.stopPollingQuery = function (queryId) {
        // Remove the query options from one of the registered queries.
        // The polling function will then take care of not firing it anymore.
        delete this.registeredQueries[queryId];
    };
    // Fires the all of the queries on a particular interval. Called on a setInterval.
    QueryScheduler.prototype.fetchQueriesOnInterval = function (interval) {
        var _this = this;
        // XXX this "filter" here is nasty, because it does two things at the same time.
        // 1. remove queries that have stopped polling
        // 2. call fetchQueries for queries that are polling and not in flight.
        // TODO: refactor this to make it cleaner
        this.intervalQueries[interval] = this.intervalQueries[interval].filter(function (queryId) {
            // If queryOptions can't be found from registeredQueries or if it has a
            // different interval, it means that this queryId is no longer registered
            // and should be removed from the list of queries firing on this interval.
            //
            // We don't remove queries from intervalQueries immediately in
            // stopPollingQuery so that we can keep the timer consistent when queries
            // are removed and replaced, and to avoid quadratic behavior when stopping
            // many queries.
            if (!(_this.registeredQueries.hasOwnProperty(queryId) &&
                _this.registeredQueries[queryId].pollInterval === interval)) {
                return false;
            }
            // Don't fire this instance of the polling query is one of the instances is already in
            // flight.
            if (_this.checkInFlight(queryId)) {
                return true;
            }
            var queryOptions = _this.registeredQueries[queryId];
            var pollingOptions = __assign({}, queryOptions);
            pollingOptions.fetchPolicy = 'network-only';
            // don't let unhandled rejections happen
            _this.fetchQuery(queryId, pollingOptions, __WEBPACK_IMPORTED_MODULE_0__core_types__["a" /* FetchType */].poll).catch(function () { });
            return true;
        });
        if (this.intervalQueries[interval].length === 0) {
            clearInterval(this.pollingTimers[interval]);
            delete this.intervalQueries[interval];
        }
    };
    // Adds a query on a particular interval to this.intervalQueries and then fires
    // that query with all the other queries executing on that interval. Note that the query id
    // and query options must have been added to this.registeredQueries before this function is called.
    QueryScheduler.prototype.addQueryOnInterval = function (queryId, queryOptions) {
        var _this = this;
        var interval = queryOptions.pollInterval;
        if (!interval) {
            throw new Error("A poll interval is required to start polling query with id '" + queryId + "'.");
        }
        // If there are other queries on this interval, this query will just fire with those
        // and we don't need to create a new timer.
        if (this.intervalQueries.hasOwnProperty(interval.toString()) &&
            this.intervalQueries[interval].length > 0) {
            this.intervalQueries[interval].push(queryId);
        }
        else {
            this.intervalQueries[interval] = [queryId];
            // set up the timer for the function that will handle this interval
            this.pollingTimers[interval] = setInterval(function () {
                _this.fetchQueriesOnInterval(interval);
            }, interval);
        }
    };
    // Used only for unit testing.
    QueryScheduler.prototype.registerPollingQuery = function (queryOptions) {
        if (!queryOptions.pollInterval) {
            throw new Error('Attempted to register a non-polling query with the scheduler.');
        }
        return new __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__["a" /* ObservableQuery */]({
            scheduler: this,
            options: queryOptions,
        });
    };
    return QueryScheduler;
}());

//# sourceMappingURL=scheduler.js.map

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MutationStore; });
var MutationStore = /** @class */ (function () {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function () {
        return this.store;
    };
    MutationStore.prototype.get = function (mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function (mutationId, mutationString, variables) {
        this.store[mutationId] = {
            mutationString: mutationString,
            variables: variables || {},
            loading: true,
            error: null,
        };
    };
    MutationStore.prototype.markMutationError = function (mutationId, error) {
        var mutation = this.store[mutationId];
        if (!mutation) {
            return;
        }
        mutation.loading = false;
        mutation.error = error;
    };
    MutationStore.prototype.markMutationResult = function (mutationId) {
        var mutation = this.store[mutationId];
        if (!mutation) {
            return;
        }
        mutation.loading = false;
        mutation.error = null;
    };
    MutationStore.prototype.reset = function () {
        this.store = {};
    };
    return MutationStore;
}());

//# sourceMappingURL=mutations.js.map

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__ = __webpack_require__(26);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var QueryStore = /** @class */ (function () {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function () {
        return this.store;
    };
    QueryStore.prototype.get = function (queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function (query) {
        var previousQuery = this.store[query.queryId];
        if (previousQuery &&
            previousQuery.document !== query.document &&
            Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(previousQuery.document) !== Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(query.document)) {
            // XXX we're throwing an error here to catch bugs where a query gets overwritten by a new one.
            // we should implement a separate action for refetching so that QUERY_INIT may never overwrite
            // an existing query (see also: https://github.com/apollostack/apollo-client/issues/732)
            throw new Error('Internal Error: may not update existing query string in store');
        }
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables &&
            previousQuery &&
            previousQuery.networkStatus !== __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].loading
        // if the previous query was still loading, we don't want to remember it at all.
        ) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["isEqual"])(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        // TODO break this out into a separate function
        var networkStatus;
        if (isSetVariables) {
            networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].setVariables;
        }
        else if (query.isPoll) {
            networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].poll;
        }
        else if (query.isRefetch) {
            networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].refetch;
            // TODO: can we determine setVariables here if it's a refetch and the variables have changed?
        }
        else {
            networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].loading;
        }
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) {
            graphQLErrors = previousQuery.graphQLErrors;
        }
        // XXX right now if QUERY_INIT is fired twice, like in a refetch situation, we just overwrite
        // the store. We probably want a refetch action instead, because I suspect that if you refetch
        // before the initial fetch is done, you'll get an error.
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata,
        };
        // If the action had a `moreForQueryId` property then we need to set the
        // network status on that query as well to `fetchMore`.
        //
        // We have a complement to this if statement in the query result and query
        // error action branch, but importantly *not* in the client result branch.
        // This is because the implementation of `fetchMore` *always* sets
        // `fetchPolicy` to `network-only` so we would never have a client result.
        if (typeof query.fetchMoreForQueryId === 'string' &&
            this.store[query.fetchMoreForQueryId]) {
            this.store[query.fetchMoreForQueryId].networkStatus =
                __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].fetchMore;
        }
    };
    QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
        if (!this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors =
            result.errors && result.errors.length ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].ready;
        // If we have a `fetchMoreForQueryId` then we need to update the network
        // status for that query. See the branch for query initialization for more
        // explanation about this process.
        if (typeof fetchMoreForQueryId === 'string' &&
            this.store[fetchMoreForQueryId]) {
            this.store[fetchMoreForQueryId].networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].ready;
        }
    };
    QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
        if (!this.store[queryId])
            return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].error;
        // If we have a `fetchMoreForQueryId` then we need to update the network
        // status for that query. See the branch for query initialization for more
        // explanation about this process.
        if (typeof fetchMoreForQueryId === 'string') {
            this.markQueryResultClient(fetchMoreForQueryId, true);
        }
    };
    QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
        if (!this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = complete
            ? __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].ready
            : __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].loading;
    };
    QueryStore.prototype.stopQuery = function (queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function (observableQueryIds) {
        var _this = this;
        // keep only the queries with query ids that are associated with observables
        this.store = Object.keys(this.store)
            .filter(function (queryId) {
            return observableQueryIds.indexOf(queryId) > -1;
        })
            .reduce(function (res, key) {
            // XXX set loading to true so listeners don't trigger unless they want results with partial data
            res[key] = __assign({}, _this.store[key], { networkStatus: __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].loading });
            return res;
        }, {});
    };
    return QueryStore;
}());

//# sourceMappingURL=queries.js.map

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(4);

var DataStore = /** @class */ (function () {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function () {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function (result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) { ignoreErrors = false; }
        var writeWithErrors = !Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["graphQLResultHasError"])(result);
        if (ignoreErrors && Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["graphQLResultHasError"])(result) && result.data) {
            writeWithErrors = true;
        }
        if (!fetchMoreForQueryId && writeWithErrors) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markSubscriptionResult = function (result, document, variables) {
        // the subscription interface should handle not sending us results we no longer subscribe to.
        // XXX I don't think we ever send in an object with errors, but we might in the future...
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["graphQLResultHasError"])(result)) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markMutationInit = function (mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') {
                optimistic_1 = mutation.optimisticResponse(mutation.variables);
            }
            else {
                optimistic_1 = mutation.optimisticResponse;
            }
            var changeFn_1 = function () {
                _this.markMutationResult({
                    mutationId: mutation.mutationId,
                    result: { data: optimistic_1 },
                    document: mutation.document,
                    variables: mutation.variables,
                    updateQueries: mutation.updateQueries,
                    update: mutation.update,
                });
            };
            this.cache.recordOptimisticTransaction(function (c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    changeFn_1();
                }
                finally {
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function (mutation) {
        var _this = this;
        // Incorporate the result from this mutation into the store
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["graphQLResultHasError"])(mutation.result)) {
            var cacheWrites_1 = [];
            cacheWrites_1.push({
                result: mutation.result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables,
            });
            if (mutation.updateQueries) {
                Object.keys(mutation.updateQueries)
                    .filter(function (id) { return mutation.updateQueries[id]; })
                    .forEach(function (queryId) {
                    var _a = mutation.updateQueries[queryId], query = _a.query, updater = _a.updater;
                    // Read the current query result from the store.
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (!complete) {
                        return;
                    }
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["tryFunctionOrLogError"])(function () {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["getOperationName"])(query.document) || undefined,
                            queryVariables: query.variables,
                        });
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) {
                        cacheWrites_1.push({
                            result: nextQueryResult,
                            dataId: 'ROOT_QUERY',
                            query: query.document,
                            variables: query.variables,
                        });
                    }
                });
            }
            this.cache.performTransaction(function (c) {
                cacheWrites_1.forEach(function (write) { return c.write(write); });
            });
            // If the mutation has some writes associated with it then we need to
            // apply those writes to the store by running this reducer again with a
            // write action.
            var update_1 = mutation.update;
            if (update_1) {
                this.cache.performTransaction(function (c) {
                    Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["tryFunctionOrLogError"])(function () { return update_1(c, mutation.result); });
                });
            }
        }
    };
    DataStore.prototype.markMutationComplete = function (_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (!optimisticResponse)
            return;
        this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function (document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document,
        });
    };
    DataStore.prototype.reset = function () {
        return this.cache.reset();
    };
    return DataStore;
}());

//# sourceMappingURL=store.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports) {

exports.version = "2.3.7"

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(197);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(62),
    flatRest = __webpack_require__(198),
    getData = __webpack_require__(99),
    getFuncName = __webpack_require__(101),
    isArray = __webpack_require__(5),
    isLaziable = __webpack_require__(216);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(199),
    overRest = __webpack_require__(95),
    setToString = __webpack_require__(96);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(200);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(93),
    isFlattenable = __webpack_require__(201);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(28),
    isArguments = __webpack_require__(64),
    isArray = __webpack_require__(5);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(17),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(28);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(207),
    defineProperty = __webpack_require__(97),
    identity = __webpack_require__(41);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(40),
    isMasked = __webpack_require__(209),
    isObject = __webpack_require__(10),
    toSource = __webpack_require__(98);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(210);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(13);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(100);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 214 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 215 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(65),
    getData = __webpack_require__(99),
    getFuncName = __webpack_require__(101),
    lodash = __webpack_require__(217);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(65),
    LodashWrapper = __webpack_require__(62),
    baseLodash = __webpack_require__(63),
    isArray = __webpack_require__(5),
    isObjectLike = __webpack_require__(16),
    wrapperClone = __webpack_require__(218);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(65),
    LodashWrapper = __webpack_require__(62),
    copyArray = __webpack_require__(219);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_scss_vanilla_index_scss__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_scss_vanilla_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_scss_vanilla_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Messages__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Auth__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Home__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Settings__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Requests__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Users__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseLayout=function(_Component){_inherits(BaseLayout,_Component);function BaseLayout(){_classCallCheck(this,BaseLayout);return _possibleConstructorReturn(this,(BaseLayout.__proto__||Object.getPrototypeOf(BaseLayout)).apply(this,arguments));}_createClass(BaseLayout,[{key:'render',value:function render(){if(!document.cookie.length||document.cookie.indexOf('stva')===-1)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__views_Auth__["a" /* default */],null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.header},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.title},'Tutorat Sofia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.nav},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Link"],{to:'/home'},'Home'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Link"],{to:'/messages'},'Messages'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Link"],{to:'/requests'},'Requests'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Link"],{to:'/users/client'},'Clients'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Link"],{to:'/users/tutor'},'Tutors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Link"],{to:'/settings'},'Settings'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Switch"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Route"],{path:'/home',component:__WEBPACK_IMPORTED_MODULE_5__views_Home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Route"],{path:'/messages/:uuid',component:__WEBPACK_IMPORTED_MODULE_3__views_Messages__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Route"],{path:'/messages',component:__WEBPACK_IMPORTED_MODULE_3__views_Messages__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Route"],{path:'/requests/:uuid',component:__WEBPACK_IMPORTED_MODULE_7__views_Requests__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Route"],{path:'/requests',component:__WEBPACK_IMPORTED_MODULE_7__views_Requests__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Route"],{path:'/users/:role/:uuid',component:__WEBPACK_IMPORTED_MODULE_8__views_Users__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Route"],{path:'/users/:role/',component:__WEBPACK_IMPORTED_MODULE_8__views_Users__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Route"],{path:'/settings',component:__WEBPACK_IMPORTED_MODULE_6__views_Settings__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Redirect"],{from:'/',to:'/home'})));}}]);return BaseLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BaseLayout);

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(222);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-layouts-BaseLayout-___style__header___wsCZ9 {\n  background-color: #ffc837;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 700;\n  box-shadow: 0 0 6px -1px rgba(0, 0, 0, 0.4);\n  z-index: 100; }\n\n.src-layouts-BaseLayout-___style__header___wsCZ9 .src-layouts-BaseLayout-___style__nav___310Xe a {\n  margin: 0 6px;\n  font-weight: 900;\n  color: #000;\n  text-transform: none;\n  text-decoration: none;\n  opacity: 0.8; }\n\n.src-layouts-BaseLayout-___style__header___wsCZ9 .src-layouts-BaseLayout-___style__nav___310Xe a:hover {\n  opacity: 1; }\n", ""]);

// exports
exports.locals = {
	"header": "src-layouts-BaseLayout-___style__header___wsCZ9",
	"nav": "src-layouts-BaseLayout-___style__nav___310Xe"
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(224);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../sass-loader/lib/loader.js??ref--1-oneOf-3-2!./index.scss", function() {
			var newContent = require("!!../../../css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../sass-loader/lib/loader.js??ref--1-oneOf-3-2!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: 'Work Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: local(\"Work Sans Light\"), local(\"WorkSans-Light\"), url(\"https://fonts.gstatic.com/s/worksans/v2/FD_Udbezj8EHXbdsqLUplxampu5_7CjHW5spxoeN3Vs.woff2\") format(\"woff2\"); }\n\n@font-face {\n  font-family: 'Work Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local(\"Work Sans\"), local(\"WorkSans-Regular\"), url(\"https://fonts.gstatic.com/s/worksans/v2//ElUAY9q6T0Ayx4zWzW63VJBw1xU1rKptJj_0jans920.woff2\") format(\"woff2\"); }\n\n@font-face {\n  font-family: 'Work Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: local(\"Work Sans Medium\"), local(\"WorkSans-Medium\"), url(\"https://fonts.gstatic.com/s/worksans/v2/Nbre-U_bp6Xktt8cpgwaJBampu5_7CjHW5spxoeN3Vs.woff2\") format(\"woff2\"); }\n\n@font-face {\n  font-family: 'Work Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: local(\"Work Sans SemiBold\"), local(\"WorkSans-SemiBold\"), url(\"https://fonts.gstatic.com/s/worksans/v2/z9rX03Xuz9ZNHTMg1_ghGRampu5_7CjHW5spxoeN3Vs.woff2\") format(\"woff2\"); }\n\n@font-face {\n  font-family: 'Work Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: local(\"Work Sans Bold\"), local(\"WorkSans-Bold\"), url(\"https://fonts.gstatic.com/s/worksans/v2/4udXuXg54JlPEP5iKO5AmRampu5_7CjHW5spxoeN3Vs.woff2\") format(\"woff2\"); }\n\n/*!\n * inuitcss, by @csswizardry\n *\n * github.com/inuitcss | inuitcss.com\n */\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__fadein___3i-GT {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__fadein___3i-GT {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */\n/**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Prevent adjustments of font size after orientation changes in IE and iOS.\n */\nhtml {\n  font-family: sans-serif;\n  /* 1 */\n  -ms-text-size-adjust: 100%;\n  /* 2 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */ }\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\nbody {\n  margin: 0; }\n\n/* HTML5 display definitions\n   ========================================================================== */\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  /* 1 */\n  display: block; }\n\n/**\n * Add the correct display in IE 9-.\n */\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block; }\n\n/**\n * Add the correct display in iOS 4-7.\n */\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\nprogress {\n  vertical-align: baseline; }\n\n/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */\ntemplate,\n[hidden] {\n  display: none; }\n\n/* Links\n   ========================================================================== */\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\na {\n  background-color: transparent;\n  /* 1 */\n  -webkit-text-decoration-skip: objects;\n  /* 2 */ }\n\n/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */\na:active,\na:hover {\n  outline-width: 0; }\n\n/* Text-level semantics\n   ========================================================================== */\n/**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\nabbr[title] {\n  border-bottom: none;\n  /* 1 */\n  text-decoration: underline;\n  /* 2 */\n  text-decoration: underline dotted;\n  /* 2 */ }\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\nb,\nstrong {\n  font-weight: inherit; }\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\nb,\nstrong {\n  font-weight: bolder; }\n\n/**\n * Add the correct font style in Android 4.3-.\n */\ndfn {\n  font-style: italic; }\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\n\n/**\n * Add the correct background and color in IE 9-.\n */\nmark {\n  background-color: #ff0;\n  color: #000; }\n\n/**\n * Add the correct font size in all browsers.\n */\nsmall {\n  font-size: 80%; }\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\n\nsub {\n  bottom: -0.25em; }\n\nsup {\n  top: -0.5em; }\n\n/* Embedded content\n   ========================================================================== */\n/**\n * Remove the border on images inside links in IE 10-.\n */\nimg {\n  border-style: none; }\n\n/**\n * Hide the overflow in IE.\n */\nsvg:not(:root) {\n  overflow: hidden; }\n\n/* Grouping content\n   ========================================================================== */\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  /* 1 */\n  font-size: 1em;\n  /* 2 */ }\n\n/**\n * Add the correct margin in IE 8.\n */\nfigure {\n  margin: 1em 40px; }\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\nhr {\n  box-sizing: content-box;\n  /* 1 */\n  height: 0;\n  /* 1 */\n  overflow: visible;\n  /* 2 */ }\n\n/* Forms\n   ========================================================================== */\n/**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit;\n  /* 1 */\n  margin: 0;\n  /* 2 */ }\n\n/**\n * Restore the font weight unset by the previous rule.\n */\noptgroup {\n  font-weight: bold; }\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\nbutton,\ninput {\n  /* 1 */\n  overflow: visible; }\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\nbutton,\nselect {\n  /* 1 */\n  text-transform: none; }\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n  /* 2 */ }\n\n/**\n * Remove the inner border and padding in Firefox.\n */\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0; }\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText; }\n\n/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\nlegend {\n  box-sizing: border-box;\n  /* 1 */\n  color: inherit;\n  /* 2 */\n  display: table;\n  /* 1 */\n  max-width: 100%;\n  /* 1 */\n  padding: 0;\n  /* 3 */\n  white-space: normal;\n  /* 1 */ }\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\ntextarea {\n  overflow: auto; }\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box;\n  /* 1 */\n  padding: 0;\n  /* 2 */ }\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */ }\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\n\n/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */\n::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54; }\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */ }\n\n/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * As well as using normalize.css, it is often advantageous to remove all\n * margins from certain elements.\n */\nbody,\nh1, h2, h3, h4, h5, h6,\np, blockquote, pre,\ndl, dd, ol, ul,\nform, fieldset, legend,\nfigure,\ntable, th, td, caption,\nhr {\n  margin: 0;\n  padding: 0; }\n\n/**\n * Give a help cursor to elements that give extra info on `:hover`.\n */\nabbr[title],\ndfn[title] {\n  cursor: help; }\n\n/**\n * Remove underlines from potentially troublesome elements.\n */\nu,\nins {\n  text-decoration: none; }\n\n/**\n * Apply faux underlines to inserted text via `border-bottom`.\n */\nins {\n  border-bottom: 1px solid; }\n\n/*------------------------------------*\\\n    #SHARED\n\\*------------------------------------*/\n/**\n * Where `margin-bottom` is concerned,this value will be the same as the\n * base line-height. This allows us to keep a consistent vertical rhythm.\n * As per: csswizardry.com/2012/06/single-direction-margin-declarations\n */\nh1, h2, h3, h4, h5, h6,\nul, ol, dl,\nblockquote, p, address,\nhr,\ntable,\nfieldset, figure,\npre {\n  margin-bottom: 24px;\n  margin-bottom: 1.5rem; }\n\n/**\n * Where `margin-left` is concerned we want to try and indent certain elements\n * by a consistent amount. Define that amount once,here.\n */\nul, ol, dd {\n  margin-left: 48px;\n  margin-left: 3rem; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV,\n.node_modules-grommet-scss-vanilla-___index__brand-font___2JXMh {\n  font-family: \"Work Sans\", Arial, sans-serif; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV {\n  box-sizing: border-box;\n  font-size: 1em;\n  line-height: 1.5;\n  background-color: #fff;\n  color: #333;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV * {\n    box-sizing: inherit; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M {\n    direction: rtl; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__large-number-font___kxpuQ {\n    font-family: \"Work Sans\", Arial, sans-serif; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__secondary___231_M {\n    color: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    color: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__secondary___231_M, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__secondary___231_M {\n    color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__error___1IV6T, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    color: #F59F9F; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__secondary___231_M, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__secondary___231_M {\n    color: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__error___1IV6T, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    color: #FF324D; }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h1:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) {\n    font-size: 48px;\n    font-size: 3rem;\n    line-height: 1.125; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h1:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) {\n    font-size: 36px;\n    font-size: 2.25rem;\n    line-height: 1.125; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h2:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) {\n    font-size: 36px;\n    font-size: 2.25rem;\n    line-height: 1.23; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h2:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) {\n    font-size: 30px;\n    font-size: 1.875rem;\n    line-height: 1.23; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h3:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) {\n  font-size: 24px;\n  line-height: 1.333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h4:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) {\n  font-size: 18px;\n  line-height: 1.333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h5:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) {\n  font-size: 16px;\n  line-height: 1.375; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) {\n  font-size: 16px;\n  line-height: 1.375; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h1:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT),\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h2:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT),\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h3:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT),\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h4:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT),\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h5:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT),\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) {\n  font-weight: 300;\n  max-width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h1:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h1:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h2:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h2:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h3:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h3:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h4:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h4:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h5:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h5:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm {\n    color: inherit;\n    text-decoration: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h1:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h1:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h2:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h2:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h3:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h3:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h4:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h4:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h5:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h5:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) a:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV h6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT) .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover {\n      text-decoration: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV dd,\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV li:not([class^=\"grommetux-\"]) {\n  max-width: 576px;\n  margin-left: 0px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.375;\n  color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV dd {\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.375;\n  margin-bottom: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV p:not(.node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK) {\n  max-width: 576px;\n  margin-left: 0px;\n  margin-top: 24px;\n  margin-bottom: 24px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.375;\n  color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV blockquote {\n  font-size: 36px;\n  font-size: 2.25rem;\n  line-height: 1.33333;\n  margin-top: 24px;\n  margin-bottom: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV b,\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV strong {\n  font-weight: 500; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV code {\n  font-family: Consolas, Menlo, \"DejaVu Sans Mono\", \"Liberation Mono\", monospace; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh p:not(.node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK),\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh dd, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh p:not(.node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK),\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh dd {\n  color: rgba(255, 255, 255, 0.85); }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo p:not(.node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK),\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo dd, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo p:not(.node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK),\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo dd {\n  color: #333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n  color: #865CD6;\n  text-decoration: none;\n  cursor: pointer; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__plain___1tQU1 .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n    text-decoration: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__plain___1tQU1 .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover {\n      text-decoration: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited {\n    color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd {\n    color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover {\n    color: #6b37cd;\n    text-decoration: underline; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n    color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited {\n      color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover {\n      color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n    color: #865CD6; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited {\n      color: #865CD6; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover {\n      color: #6b37cd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n    color: transparent; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover {\n      color: transparent; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n  color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited {\n    color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover {\n    color: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n  color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited {\n    color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover {\n    color: #6b37cd; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n  color: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover {\n    color: transparent; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input:not(.node_modules-grommet-scss-vanilla-___index__grommetux-input___2GiHB):not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA),\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select,\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV textarea {\n  font-size: 16px;\n  font-size: 1rem;\n  line-height: 1.5;\n  padding: 11px 23px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  outline: none;\n  background-color: transparent;\n  color: inherit;\n  font: inherit;\n  margin: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input:not(.node_modules-grommet-scss-vanilla-___index__grommetux-input___2GiHB):not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA):focus,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select:focus,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV textarea:focus {\n    border-width: 2px;\n    border-color: #00CCEB;\n    padding: 10px 22px; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input:not(.node_modules-grommet-scss-vanilla-___index__grommetux-input___2GiHB):not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA)::-moz-focus-inner,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select::-moz-focus-inner,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV textarea::-moz-focus-inner {\n    border: none;\n    outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input:not(.node_modules-grommet-scss-vanilla-___index__grommetux-input___2GiHB):not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA)::-webkit-input-placeholder,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select::-webkit-input-placeholder,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV textarea::-webkit-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input:not(.node_modules-grommet-scss-vanilla-___index__grommetux-input___2GiHB):not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA)::-moz-placeholder,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select::-moz-placeholder,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV textarea::-moz-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input:not(.node_modules-grommet-scss-vanilla-___index__grommetux-input___2GiHB):not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA):-ms-input-placeholder,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select:-ms-input-placeholder,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV textarea:-ms-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input:not(.node_modules-grommet-scss-vanilla-___index__grommetux-input___2GiHB):not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA).node_modules-grommet-scss-vanilla-___index__error___1IV6T,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select.node_modules-grommet-scss-vanilla-___index__error___1IV6T,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV textarea.node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    border-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"button\"],\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"submit\"] {\n  text-align: center;\n  line-height: inherit; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"button\"],\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"submit\"],\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV button:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n  background-color: transparent;\n  border: 2px solid #865CD6;\n  border-radius: 4px;\n  color: #333;\n  font-size: 19px;\n  font-size: 1.1875rem;\n  line-height: 24px;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n  min-width: 120px;\n  max-width: 384px; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"button\"]:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--box___2mqjv),\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"submit\"]:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--box___2mqjv),\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV button:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--box___2mqjv) {\n    padding: 6px 22px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"button\"],\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"submit\"],\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV button:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n      transition: 0.1s ease-in-out; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"button\"], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"button\"], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"submit\"], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"submit\"], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV button:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV button:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n    border-color: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"button\"], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"button\"], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"submit\"], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"submit\"], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV button:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV button:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n    border-color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"button\"]:focus,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=\"submit\"]:focus,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV button:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):focus {\n    border-color: #00CCEB;\n    box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n  text-decoration: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV a.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover {\n    text-decoration: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select {\n  border-color: rgba(0, 0, 0, 0.15);\n  padding-right: 48px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAOhJREFUSA3tksENgzAMRUmrrlApuTAAxxw6QvfojYmYKtw6QpUDI1Rq6o8MStsAMT1UlbAUcMB+33FcFJttHfifDlhrT7QO31YMBlgDZw8HH5RSF3JLY0zrvX8MAZI3F1gT66y17ohz2zGgDSFc6UdF+5oDJWwUidMDXoFFfgtAfwJUjMppX7KI6CQJeOOcu48CcNaKzMFfBNaILME/BCQiOfCkQI5ILhwshceUpUAcG0/LeKEpzqwAEhIiRTSKs3Dk92MKZ8rep4vgR57zRTiYiwIIikVo29HKgiNXZGgXt0yUtwX/tgNPQqatJ1aBLFMAAAAASUVORK5CYII=) no-repeat center right 12px;\n  cursor: pointer; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select::-moz-focus-inner {\n    border: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select.node_modules-grommet-scss-vanilla-___index__plain___1tQU1 {\n    border: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV select:focus {\n    padding-right: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range] {\n  position: relative;\n  -webkit-appearance: none;\n  border-color: transparent;\n  height: 24px;\n  padding: 0px;\n  cursor: pointer;\n  overflow-x: hidden; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]:focus {\n    outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-moz-focus-inner {\n    border: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-moz-focus-outer {\n    border: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 2px;\n    background-color: rgba(51, 51, 51, 0.2); }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    position: relative;\n    height: 24px;\n    width: 24px;\n    overflow: visible;\n    margin-top: -11px;\n    border: 2px solid #865CD6;\n    border-radius: 24px;\n    background-color: #fff;\n    cursor: pointer; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-webkit-slider-thumb:hover {\n      border-color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-moz-range-track {\n    width: 100%;\n    height: 2px;\n    background-color: rgba(51, 51, 51, 0.2); }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-moz-range-thumb {\n    position: relative;\n    height: 24px;\n    width: 24px;\n    overflow: visible;\n    border: 2px solid #865CD6;\n    height: 20px;\n    width: 20px;\n    border-radius: 24px;\n    background-color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]:hover::-moz-range-thumb {\n    border-color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-ms-track {\n    width: 100%;\n    height: 2px;\n    background-color: rgba(51, 51, 51, 0.2);\n    border-color: transparent;\n    color: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-ms-fill-lower {\n    background: #865CD6;\n    border-color: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-ms-fill-upper {\n    background: rgba(51, 51, 51, 0.2);\n    border-color: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]::-ms-thumb {\n    position: relative;\n    height: 24px;\n    width: 24px;\n    overflow: visible;\n    position: relative;\n    top: 6px;\n    border: 2px solid #666;\n    height: 20px;\n    width: 20px;\n    border-radius: 24px;\n    background-color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV input[type=range]:hover::-ms-thumb {\n    border-color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-webkit-slider-runnable-track, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-webkit-slider-runnable-track {\n  background-color: rgba(255, 255, 255, 0.2); }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-webkit-slider-thumb, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-webkit-slider-thumb {\n  background-color: #fff;\n  border: 2px solid #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-moz-range-thumb, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-moz-range-thumb {\n  background-color: #fff;\n  border: 2px solid #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-ms-fill-lower, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-ms-fill-lower {\n  background: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-ms-fill-upper, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-ms-fill-upper {\n  background: rgba(255, 255, 255, 0.2); }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-ms-thumb, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]::-ms-thumb {\n  border-color: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]:hover::-ms-thumb, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input[type=range]:hover::-ms-thumb {\n  border-color: #fff;\n  background-color: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-webkit-slider-runnable-track, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-webkit-slider-runnable-track {\n  background-color: rgba(51, 51, 51, 0.2); }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-webkit-slider-thumb, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-webkit-slider-thumb {\n  background-color: #000;\n  border: 2px solid #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-moz-range-thumb, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-moz-range-thumb {\n  background-color: #000;\n  border: 2px solid #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-ms-fill-lower, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-ms-fill-lower {\n  background: #865CD6; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-ms-fill-upper, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-ms-fill-upper {\n  background: rgba(51, 51, 51, 0.2); }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-ms-thumb, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]::-ms-thumb {\n  border-color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]:hover::-ms-thumb, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input[type=range]:hover::-ms-thumb {\n  border-color: #000;\n  background-color: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV li > ul,\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV li > ol {\n  margin-bottom: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV img {\n  max-width: 100%;\n  font-style: italic;\n  vertical-align: middle; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel___2V06l {\n  margin: 3px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW {\n  color: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW {\n    color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW {\n    color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW:hover {\n  color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW:hover {\n    color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW:hover {\n    color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel--active___CAwbw .node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__control___2h5eG {\n  transform: rotate(90deg); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm {\n  color: #865CD6;\n  text-decoration: none;\n  cursor: pointer; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__plain___1tQU1 .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n    text-decoration: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__plain___1tQU1 .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover {\n      text-decoration: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:visited {\n    color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd {\n    color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover {\n    color: #6b37cd;\n    text-decoration: underline; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm {\n    color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:visited {\n      color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover {\n      color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm {\n    color: #865CD6; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:visited {\n      color: #865CD6; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover {\n      color: #6b37cd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm {\n    color: transparent; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover {\n      color: transparent; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS {\n  display: inline-block;\n  height: 48px;\n  padding: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #666;\n    stroke: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #000;\n    stroke: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS {\n    color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:visited {\n      color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:hover {\n      color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS {\n    color: #666; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:visited {\n      color: #666; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:hover {\n      color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS {\n    color: transparent; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:hover {\n      color: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: rgba(255, 255, 255, 0.7);\n    stroke: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #fff;\n    stroke: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #666;\n    stroke: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #000;\n    stroke: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--animate-icon___12b0a:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n  transform: scale(1.1); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon___19BSv {\n  flex: 0 0 auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz,\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB {\n  font-size: 19px;\n  font-size: 1.1875rem;\n  line-height: 24px;\n  font-weight: 600;\n  text-decoration: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    vertical-align: middle;\n    margin-right: 12px; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M\n    .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n      margin-right: 0;\n      margin-left: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz > span,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB > span {\n    vertical-align: middle; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--reverse___3ilIu .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n  margin-right: 0;\n  margin-left: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz) {\n  color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):visited {\n    color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz) .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #666;\n    stroke: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6) {\n    color: #000;\n    text-decoration: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz) {\n    color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):visited {\n      color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):hover {\n      color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz) {\n    color: #666; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):visited {\n      color: #666; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):hover {\n      color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz) {\n    color: transparent; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):hover {\n      color: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz) .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz) .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: rgba(255, 255, 255, 0.7);\n    stroke: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #fff;\n    stroke: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz) .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz) .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #666;\n    stroke: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz):hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #000;\n    stroke: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz {\n  color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #865CD6;\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz.node_modules-grommet-scss-vanilla-___index__active___3wnBd {\n    color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--animate-icon___12b0a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6):hover {\n    text-decoration: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--animate-icon___12b0a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6):hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n      transform: translateX(3px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz {\n    color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:visited {\n      color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:hover {\n      color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz {\n    color: #865CD6; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:visited {\n      color: #865CD6; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:hover {\n      color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz {\n    color: transparent; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:hover {\n      color: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: rgba(255, 255, 255, 0.7);\n    stroke: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #fff;\n    stroke: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #865CD6;\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #865CD6;\n    stroke: #865CD6; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6 {\n  opacity: 0.3;\n  cursor: default; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6 .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    cursor: default; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover {\n  color: inherit;\n  text-decoration: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz {\n    color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover.node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz) {\n    color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover {\n    fill: rgba(255, 255, 255, 0.7);\n    stroke: rgba(255, 255, 255, 0.7); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz {\n      color: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover {\n    fill: #865CD6;\n    stroke: #865CD6; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6:hover.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz {\n      color: #865CD6; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--align-start___1w3FJ {\n  text-align: left; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--align-center___FH67j {\n  text-align: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--align-end___2N2aE {\n  text-align: right; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-animate___2kqa3 {\n  max-width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-animate___2kqa3 .node_modules-grommet-scss-vanilla-___index__grommetux-animate__child___3b_RB {\n  transition: all 1s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--inactive___1BUe8 {\n  pointer-events: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--fade___2xKvQ.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--inactive___1BUe8, .node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--fade___2xKvQ.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--leave___31UBL {\n  opacity: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-up___37w4G.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--inactive___1BUe8, .node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-up___37w4G.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--leave___31UBL {\n  opacity: 0;\n  transform: translateY(50%); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-down___cOfKS.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--inactive___1BUe8, .node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-down___cOfKS.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--leave___31UBL {\n  opacity: 0;\n  transform: translateY(-50%); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-left___GqUV-.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--inactive___1BUe8, .node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-left___GqUV-.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--leave___31UBL {\n  opacity: 0;\n  transform: translateX(50%); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-right___2EX3Q.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--inactive___1BUe8, .node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-right___2EX3Q.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--leave___31UBL {\n  opacity: 0;\n  transform: translateX(-50%); }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__jiggle___19nPx {\n  0%,\n  100% {\n    transform: translateX(0%); }\n  25% {\n    transform: translateX(-0.2%); }\n  75% {\n    transform: translateX(0.2%); } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--jiggle___1ts35.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--enter___3Vh87, .node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--jiggle___1ts35.node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--leave___31UBL {\n  animation: node_modules-grommet-scss-vanilla-___index__jiggle___19nPx 0.2s infinite alternate ease-in-out; }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__grommetux-app___1JU9n {\n    top: 0px;\n    bottom: 0px;\n    left: 0px;\n    right: 0px;\n    height: 100%;\n    width: 100%;\n    overflow: visible; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__grommetux-app--hidden___wpWno {\n  position: fixed; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__grommetux-app--inline___2Ake7 {\n  position: relative; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__grommetux-app--centered___3b8tp {\n  width: 100%;\n  max-width: 1152px;\n  margin-left: auto;\n  margin-right: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__grommetux-app___1JU9n .node_modules-grommet-scss-vanilla-___index__grommetux-app__announcer___pUKfb {\n  left: -100%;\n  right: 100%;\n  z-index: -1;\n  position: fixed; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-article___3d3Qx {\n  position: relative; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-article___3d3Qx > * {\n    flex: 0 0 auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-article--scroll-step___2VT4Z {\n  text-align: center;\n  height: 100vh;\n  width: 100vw;\n  max-width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-article--scroll-step___2VT4Z.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY {\n    overflow-x: hidden;\n    overflow-y: auto; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-article--scroll-step___2VT4Z.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY .node_modules-grommet-scss-vanilla-___index__grommetux-article__control-carousel___l-VTH {\n      top: 50%;\n      left: 24px;\n      transform: translateY(-50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-article--scroll-step___2VT4Z.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 {\n    overflow-x: auto;\n    overflow-y: hidden; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-article--scroll-step___2VT4Z.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-article__controls___2SdMd) {\n      overflow-y: auto; }\n      @media screen and (max-width: 44.9375em) {\n        .node_modules-grommet-scss-vanilla-___index__grommetux-article--scroll-step___2VT4Z.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-article__controls___2SdMd) {\n          overflow-y: scroll;\n          -webkit-overflow-scrolling: touch; } }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-article--scroll-step___2VT4Z.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 .node_modules-grommet-scss-vanilla-___index__grommetux-article__control-carousel___l-VTH {\n      top: 24px;\n      left: 50%;\n      transform: translateX(-50%); }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-article--scroll-step___2VT4Z.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 {\n      flex-direction: row; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-article__control___31WJu {\n  position: fixed;\n  z-index: 10;\n  margin: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-article__control___31WJu.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc.node_modules-grommet-scss-vanilla-___index__grommetux-button--icon___2GeB8 {\n    overflow: hidden; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-article__control___31WJu .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz {\n    padding: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-article__control-up___26WDU {\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-article__control-down___zm35R {\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%); }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-article__control-left___8HVmH {\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%); } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-article__control-left___8HVmH {\n    left: 0;\n    bottom: 0; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-article__control-right___3YQ5b {\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-article__control-right___3YQ5b {\n    right: 0;\n    bottom: 0; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV article:not(.node_modules-grommet-scss-vanilla-___index__grommetux-article___3d3Qx) {\n  width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE {\n  display: flex;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-none___WhL55 {\n    padding: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-small___9HTrM {\n      padding: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-medium___2CaW3 {\n      padding: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-large___2H8Sh {\n      padding: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-xlarge___2gnsW {\n      padding: 192px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-small___9HTrM {\n      padding: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-medium___2CaW3 {\n      padding: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-large___2H8Sh {\n      padding: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-xlarge___2gnsW {\n      padding: 48px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-none___14Nye {\n    padding-left: 0px;\n    padding-right: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-small___ZTQox {\n      padding-left: 12px;\n      padding-right: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-medium___mWDSL {\n      padding-left: 24px;\n      padding-right: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-large___2noOk {\n      padding-left: 48px;\n      padding-right: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-xlarge___2gs1S {\n      padding-left: 192px;\n      padding-right: 192px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-small___ZTQox {\n      padding-left: 6px;\n      padding-right: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-medium___mWDSL {\n      padding-left: 12px;\n      padding-right: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-large___2noOk {\n      padding-left: 24px;\n      padding-right: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-xlarge___2gs1S {\n      padding-left: 48px;\n      padding-right: 48px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-none___2E7q7 {\n    padding-top: 0px;\n    padding-bottom: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-small___1DTEb {\n      padding-top: 12px;\n      padding-bottom: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-medium___1NShl {\n      padding-top: 24px;\n      padding-bottom: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-large___3tKMi {\n      padding-top: 48px;\n      padding-bottom: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-xlarge___23bDx {\n      padding-top: 192px;\n      padding-bottom: 192px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-small___1DTEb {\n      padding-top: 6px;\n      padding-bottom: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-medium___1NShl {\n      padding-top: 12px;\n      padding-bottom: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-large___3tKMi {\n      padding-top: 24px;\n      padding-bottom: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-xlarge___23bDx {\n      padding-top: 48px;\n      padding-bottom: 48px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-none___1AP4t {\n    margin: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-small___nOST6 {\n    margin: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-medium___3XmxR {\n    margin: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-large___23XVG {\n    margin: 48px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-small___nOST6 {\n      margin: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-medium___3XmxR {\n      margin: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-large___23XVG {\n      margin: 24px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-none___18bIB {\n    margin-left: 0px;\n    margin-right: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-small___YHCWk {\n    margin-left: 12px;\n    margin-right: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-medium___37i-B {\n    margin-left: 24px;\n    margin-right: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-large___2fh34 {\n    margin-left: 48px;\n    margin-right: 48px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-small___YHCWk {\n      margin-left: 6px;\n      margin-right: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-medium___37i-B {\n      margin-left: 12px;\n      margin-right: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-large___2fh34 {\n      margin-left: 24px;\n      margin-right: 24px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-none___2JhZL {\n    margin-top: 0px;\n    margin-bottom: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-small___lqR3W {\n    margin-top: 12px;\n    margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-medium___26WMX {\n    margin-top: 24px;\n    margin-bottom: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-large___3YDnj {\n    margin-top: 48px;\n    margin-bottom: 48px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-small___lqR3W {\n      margin-top: 6px;\n      margin-bottom: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-medium___26WMX {\n      margin-top: 12px;\n      margin-bottom: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-large___3YDnj {\n      margin-top: 24px;\n      margin-bottom: 24px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-none___1ML-L {\n    margin-left: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-small___2J3b1 {\n    margin-left: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-medium___oq98D {\n    margin-left: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-large___xTVXM {\n    margin-left: 48px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-small___2J3b1 {\n      margin-left: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-medium___oq98D {\n      margin-left: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-large___xTVXM {\n      margin-left: 24px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-none___1j3Fo {\n    margin-right: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-small___1Tm2- {\n    margin-right: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-medium___23cjg {\n    margin-right: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-large___2XA-I {\n    margin-right: 48px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-small___1Tm2- {\n      margin-right: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-medium___23cjg {\n      margin-right: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-large___2XA-I {\n      margin-right: 24px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-none___c35af {\n    margin-top: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-small___1WG3y {\n    margin-top: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-medium___2RPjl {\n    margin-top: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-large___jW4Ay {\n    margin-top: 48px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-small___1WG3y {\n      margin-top: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-medium___2RPjl {\n      margin-top: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-large___jW4Ay {\n      margin-top: 24px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-none___26MBn {\n    margin-bottom: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-small___3aTRc {\n    margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-medium___Kx0bE {\n    margin-bottom: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-large___221OT {\n    margin-bottom: 48px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-small___3aTRc {\n      margin-bottom: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-medium___Kx0bE {\n      margin-bottom: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-large___221OT {\n      margin-bottom: 24px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box__texture___2DZRq {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  overflow: hidden; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-top___2x5Mu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-horizontal___37tvS,\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx {\n  border-top: 1px solid rgba(0, 0, 0, 0.15); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-bottom___3FHY5,\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-horizontal___37tvS,\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-left____0mVA,\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H,\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx {\n  border-left: 1px solid rgba(0, 0, 0, 0.15); }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 .node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-left____0mVA, .node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H, .node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx {\n      border-left: none;\n      border-top: 1px solid rgba(0, 0, 0, 0.15); } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-right___2U-kl,\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H,\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx {\n  border-right: 1px solid rgba(0, 0, 0, 0.15); }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 .node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-right___2U-kl, .node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H, .node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx {\n      border-right: none;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.15); } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE[class*=\"grommetux-box--separator\"], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE[class*=\"grommetux-box--separator\"] {\n  border-color: rgba(255, 255, 255, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE[class*=\"grommetux-box--separator\"], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE[class*=\"grommetux-box--separator\"] {\n  border-color: rgba(0, 0, 0, 0.15); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--clickable___1m8TH {\n  cursor: pointer;\n  outline: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--focus___3EE0K {\n  border-color: #00CCEB;\n  box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box__container___3Nh2J {\n  padding-left: 24px;\n  padding-right: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-app--centered___3b8tp .node_modules-grommet-scss-vanilla-___index__grommetux-box__container___3Nh2J >\n.node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE {\n  width: 100%;\n  max-width: 1152px;\n  margin-left: auto;\n  margin-right: auto; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-app--centered___3b8tp .node_modules-grommet-scss-vanilla-___index__grommetux-box__container___3Nh2J >\n.node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE {\n      padding-left: 0px;\n      padding-right: 0px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box__container--full___1BGE_ {\n  max-width: 100%;\n  width: 100vw; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box__container--full-horizontal___wQ2wL {\n  max-width: 100%;\n  width: 100vw; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--flex___EH90- {\n  flex: 1 1;\n  min-width: 0;\n  overflow: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--flex-off___2I2MH {\n  flex: 0 0 auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--flex-grow___2Y4pf {\n  flex: 1 0;\n  min-width: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--flex-grow___2Y4pf:not([class^=\".grommetux-box--basis\"]) {\n    flex-basis: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--flex-shrink___O8BcS {\n  flex: 0 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-xsmall___37T3t {\n  flex-basis: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-small___ckFqx {\n  flex-basis: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-medium___gHBOj {\n  flex-basis: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-large___uOWk0 {\n  flex-basis: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-xlarge____9d2W {\n  flex-basis: 720px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-xxlarge___pceEt {\n  flex-basis: 960px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-full___27EVQ {\n  flex-basis: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he {\n  flex-basis: 50%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H {\n    flex-basis: calc(50% - 2px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-right___2U-kl, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-left____0mVA {\n    flex-basis: calc(50% - 1px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA {\n  flex-basis: 33.33%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H {\n    flex-basis: calc(33.33% - 2px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-right___2U-kl, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-left____0mVA {\n    flex-basis: calc(33.33% - 1px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP {\n  flex-basis: 66.66%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H {\n    flex-basis: calc(66.66% - 2px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-right___2U-kl, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-left____0mVA {\n    flex-basis: calc(66.66% - 1px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg {\n  flex-basis: 25%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H {\n    flex-basis: calc(25% - 2px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-right___2U-kl, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-left____0mVA {\n    flex-basis: calc(25% - 1px); }\n  @media screen and (max-width: 63.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg {\n      flex-basis: 50%; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H {\n        flex-basis: calc(50% - 2px); }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-right___2U-kl, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-left____0mVA {\n        flex-basis: calc(50% - 1px); } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F {\n  flex-basis: 75%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H {\n    flex-basis: calc(75% - 2px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-right___2U-kl, .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-left____0mVA {\n    flex-basis: calc(75% - 1px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-xsmall___2XU0e {\n  width: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-small___2jXug {\n  width: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-medium___n7d-J {\n  width: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-large___hNo7P {\n  width: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-xlarge___39uIL {\n  width: 720px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-xxlarge___XtiQx {\n  width: 960px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-xsmall___1iAyR {\n  height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-small___1LXC0 {\n  height: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-medium___1HNxK {\n  height: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-large___WP-Gi {\n  height: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-xlarge___PBDCr {\n  height: 720px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-xxlarge___2C4wn {\n  height: 960px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-xsmall___2vIXA {\n  min-width: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-small___Dg5R0 {\n  min-width: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-medium___3m06f {\n  min-width: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-large___2IZ29 {\n  min-width: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-xlarge___1zbq1 {\n  min-width: 720px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-xxlarge___2dE6q {\n  min-width: 960px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-xsmall___EsAch {\n  max-width: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-small___2e_6D {\n  max-width: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-medium___UPJBO {\n  max-width: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-large___1vEh8 {\n  max-width: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-xlarge___BGB0s {\n  max-width: 720px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-xxlarge___thMwt {\n  max-width: 960px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-xsmall___3whiT {\n  max-height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-small___2OAIU {\n  max-height: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-medium___vkySM {\n  max-height: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-large___tXcwR {\n  max-height: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-xlarge___1kkLL {\n  max-height: 720px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-xxlarge___3v2-u {\n  max-height: 960px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-xsmall___3IL_R {\n  min-height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-small___-_4YQ {\n  min-height: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-medium___2JwUy {\n  min-height: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-large___1mBY1 {\n  min-height: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-xlarge___2wYHm {\n  min-height: 720px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-xxlarge___3P-g- {\n  min-height: 960px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--full___3HxaS {\n  position: relative;\n  max-width: 100%;\n  width: 100vw;\n  height: 100vh;\n  max-height: 100%;\n  overflow: auto; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--full___3HxaS.node_modules-grommet-scss-vanilla-___index__grommetux-box--full-responsive___3Hq8D {\n      min-height: 100vh;\n      height: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--full-horizontal___jeIRC {\n  max-width: 100%;\n  width: 100vw; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--full-vertical___1Tgo1 {\n  height: 100vh;\n  max-height: 100%;\n  overflow: auto; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--full-vertical___1Tgo1.node_modules-grommet-scss-vanilla-___index__grommetux-box--full-responsive___3Hq8D {\n      min-height: 100vh;\n      height: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--size___vrPE3 {\n  max-width: 100%;\n  max-height: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--size___vrPE3 .node_modules-grommet-scss-vanilla-___index__grommet-namespaceparagraph___1e4N0 {\n    width: 100%;\n    max-width: 100%;\n    flex: 0 0 auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--size-xsmall___2nAlv {\n  width: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--size-small___1_mei {\n  width: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--size-medium___1hh1W {\n  width: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--size-large___qpMId {\n  width: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--size-xlarge___37Hxy {\n  width: 720px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--size-xxlarge___2ZrO_ {\n  width: 960px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--size-auto___25Fua {\n  width: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--text-align-left___2twSb {\n  text-align: left; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--text-align-center___2tJUj {\n  text-align: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--text-align-right___WlJ0z {\n  text-align: right; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--wrap___yEl4n {\n  flex-wrap: wrap; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 {\n  flex-direction: row; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--reverse___Am_kG {\n  flex-direction: row-reverse; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr {\n    flex-direction: column; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-center___2p-7h) {\n      align-items: stretch; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--reverse___Am_kG {\n      flex-direction: column-reverse; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr > .node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE {\n      flex-basis: auto; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY {\n  flex-direction: column; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY.node_modules-grommet-scss-vanilla-___index__grommetux-box--reverse___Am_kG {\n  flex-direction: column-reverse; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-start___1n6Ey {\n  justify-content: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-center___2p-7h {\n  justify-content: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-between___1uom- {\n  justify-content: space-between; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-around___2e7zC {\n  justify-content: space-around; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-end___2yPeZ {\n  justify-content: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-start___S2sIS {\n  align-items: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-center___3vH0y {\n  align-items: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-end___uF0AX {\n  align-items: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-baseline___28mNd {\n  align-items: baseline; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-stretch___2xsGT {\n  align-items: stretch; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-start___3Bsx2 {\n  align-content: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-end___2xPWh {\n  align-content: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-center___3H-6A {\n  align-content: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-between___1dKMK {\n  align-content: space-between; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-around___3tbFj {\n  align-content: space-around; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-stretch___2mZqq {\n  align-content: stretch; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-self-start___1vkT- {\n  align-self: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-self-end___fa4Q1 {\n  align-self: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-self-center___1eZ6F {\n  align-self: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--align-self-stretch___WZ8oN {\n  align-self: stretch; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-thirds___2bUsi > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA {\n  flex-basis: calc(33.33% - 8px); }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-thirds___2bUsi > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA {\n      flex-basis: auto;\n      max-width: none;\n      width: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he {\n  flex-basis: calc(50% - 6px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA {\n  flex-basis: calc(33.33% - 6px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP {\n  flex-basis: calc(66.66% - 6px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg {\n  flex-basis: calc(25% - 9px); }\n  @media screen and (max-width: 63.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg {\n      flex-basis: calc(50% - 6px); }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg:nth-of-type(2) {\n        margin-right: 0px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F {\n  flex-basis: calc(75% - 9px); }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F {\n    flex-basis: auto;\n    max-width: none;\n    width: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > *:not(:last-child) {\n  margin-right: 12px; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > *:not(:last-child) {\n    margin-right: 0;\n    margin-left: 12px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > *:not(:last-child) {\n    margin-right: 6px; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > *:not(:last-child) {\n      margin-right: 0;\n      margin-left: 6px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-thirds___2bUsi > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA {\n  flex-basis: calc(33.33% - 16px); }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-thirds___2bUsi > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA {\n      flex-basis: auto;\n      max-width: none;\n      width: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he {\n  flex-basis: calc(50% - 12px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA {\n  flex-basis: calc(33.33% - 12px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP {\n  flex-basis: calc(66.66% - 12px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg {\n  flex-basis: calc(25% - 18px); }\n  @media screen and (max-width: 63.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg {\n      flex-basis: calc(50% - 12px); }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg:nth-of-type(2) {\n        margin-right: 0px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F {\n  flex-basis: calc(75% - 18px); }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F {\n    flex-basis: auto;\n    max-width: none;\n    width: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > *:not(:last-child) {\n  margin-right: 24px; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > *:not(:last-child) {\n    margin-right: 0;\n    margin-left: 24px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > *:not(:last-child) {\n    margin-right: 12px; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > *:not(:last-child) {\n      margin-right: 0;\n      margin-left: 12px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-thirds___2bUsi > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA {\n  flex-basis: calc(33.33% - 32px); }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-thirds___2bUsi > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA {\n      flex-basis: auto;\n      max-width: none;\n      width: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he {\n  flex-basis: calc(50% - 24px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA {\n  flex-basis: calc(33.33% - 24px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP {\n  flex-basis: calc(66.66% - 24px); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg {\n  flex-basis: calc(25% - 36px); }\n  @media screen and (max-width: 63.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg {\n      flex-basis: calc(50% - 24px); }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg:nth-of-type(2) {\n        margin-right: 0px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F {\n  flex-basis: calc(75% - 36px); }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > .node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F {\n    flex-basis: auto;\n    max-width: none;\n    width: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > *:not(:last-child) {\n  margin-right: 48px; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > *:not(:last-child) {\n    margin-right: 0;\n    margin-left: 48px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > *:not(:last-child) {\n    margin-right: 24px; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > *:not(:last-child) {\n      margin-right: 0;\n      margin-left: 24px; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > *:not(:last-child) {\n    margin-left: 0;\n    margin-right: 0;\n    margin-bottom: 6px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > *:not(:last-child) {\n    margin-left: 0;\n    margin-right: 0;\n    margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > *:not(:last-child) {\n    margin-left: 0;\n    margin-right: 0;\n    margin-bottom: 24px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > *:not(:last-child) {\n  margin-bottom: 12px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_ > *:not(:last-child) {\n    margin-bottom: 6px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > *:not(:last-child) {\n  margin-bottom: 24px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq > *:not(:last-child) {\n    margin-bottom: 12px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > *:not(:last-child) {\n  margin-bottom: 48px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY.node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ > *:not(:last-child) {\n    margin-bottom: 24px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n  background-color: transparent;\n  border: 2px solid #865CD6;\n  border-radius: 4px;\n  color: #333;\n  font-size: 19px;\n  font-size: 1.1875rem;\n  line-height: 24px;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n  min-width: 120px;\n  max-width: 384px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--box___2mqjv) {\n    padding: 6px 22px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n      transition: 0.1s ease-in-out; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n    border-color: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n    border-color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button--focus___m2-7z {\n    border: 2px solid #00CCEB;\n    box-shadow: 0 0 1px 1px #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n    color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:visited {\n      color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover {\n      color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n    color: #333; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:visited {\n      color: #333; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover {\n      color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n    color: transparent; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover {\n      color: transparent; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--hover-background___19o2_:hover {\n  background-color: rgba(221, 221, 221, 0.5);\n  color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--hover-background___19o2_:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--hover-background___19o2_:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--hover-background___19o2_:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--hover-background___19o2_:hover {\n    background-color: rgba(221, 221, 221, 0.5);\n    color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n  fill: #000;\n  stroke: #000;\n  transition: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n  fill: #fff;\n  stroke: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n  fill: #000;\n  stroke: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz {\n  display: inline-block; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    vertical-align: bottom; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--secondary___axUJo:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--focus___m2-7z) {\n  border-color: #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--accent___4ZYZJ:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--focus___m2-7z) {\n  border-color: #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--critical___Y1RQw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--focus___m2-7z) {\n  border-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--align-start___2jUOL {\n  text-align: left; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-button--align-start___2jUOL {\n    text-align: right; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--box___2mqjv) {\n  padding: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc {\n  width: auto;\n  height: auto;\n  min-width: 0;\n  max-width: none;\n  text-align: inherit;\n  font-weight: inherit; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc .node_modules-grommet-scss-vanilla-___index__grommetux-button__label___3JwZq {\n    margin: 0 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz {\n    padding: 10px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz + .node_modules-grommet-scss-vanilla-___index__grommetux-button__label___3JwZq {\n      margin-left: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--focus___m2-7z) {\n  border: 2px solid transparent; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc) .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz + .node_modules-grommet-scss-vanilla-___index__grommetux-button__label___3JwZq {\n  margin-left: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb {\n  background-color: #865CD6;\n  color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--focus___m2-7z) {\n    border-color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h) {\n    color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h) .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n      fill: #fff;\n      stroke: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #fff;\n    stroke: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb {\n    color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:visited {\n      color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover {\n      color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb {\n    color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:visited {\n      color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover {\n      color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb {\n    color: transparent; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:visited, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover {\n      color: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: rgba(255, 255, 255, 0.7);\n    stroke: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #fff;\n    stroke: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #fff;\n    stroke: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:active .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #fff;\n    stroke: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h {\n  opacity: 0.3;\n  cursor: default; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu) {\n  flex: 0 0 auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu {\n  width: 100%;\n  max-width: none;\n  flex-grow: 1; }\n\na.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n  text-decoration: none; }\n  a.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:hover {\n    text-decoration: none; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-card___CSqE6 {\n    padding: 0; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-card___CSqE6:not(:last-child) {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.15); } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-card___CSqE6.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr {\n    width: auto;\n    margin: 0; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-card___CSqE6 div:focus,\n.node_modules-grommet-scss-vanilla-___index__grommetux-card___CSqE6 a:focus {\n  outline: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-card__thumbnail___33rcB {\n  min-height: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK {\n  max-width: none;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 8;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n  position: relative;\n  max-height: 176px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK::after {\n    margin-top: 154px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK {\n      max-height: 110px; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK::after {\n        margin-top: 88px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK::after {\n    content: '...';\n    text-align: right;\n    top: 0;\n    right: 0;\n    display: block;\n    position: absolute;\n    background: linear-gradient(to right, transparent, #fff 50%);\n    width: 24px; }\n  @supports (-webkit-line-clamp: 1) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK::after {\n      display: none; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK {\n      -webkit-line-clamp: 4; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--small___3NGjw {\n  max-height: 160.16px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--small___3NGjw::after {\n    margin-top: 140.14px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--small___3NGjw {\n      max-height: 100.1px; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--small___3NGjw::after {\n        margin-top: 80.08px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--large___1OYzn {\n  max-height: 224.064px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--large___1OYzn::after {\n    margin-top: 196.056px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--large___1OYzn {\n      max-height: 140.04px; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--large___1OYzn::after {\n        margin-top: 112.032px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--xlarge___3fjzU {\n  max-height: 304px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--xlarge___3fjzU::after {\n    margin-top: 266px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--xlarge___3fjzU {\n      max-height: 190px; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--xlarge___3fjzU::after {\n        margin-top: 152px; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-card--direction-row___3a7Dm .node_modules-grommet-scss-vanilla-___index__grommetux-card__thumbnail___33rcB {\n    flex-basis: 192px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-card--selectable___3fB2R:hover > div {\n  background-color: #EBEBEB;\n  color: #000;\n  cursor: pointer; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-card--selectable___3fB2R:hover > div .node_modules-grommet-scss-vanilla-___index__grommetux-card__content___19dtA .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK::after {\n    background: linear-gradient(to right, transparent, #EBEBEB 50%); }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__carousel-reveal___1lYPu {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__carousel-reveal___1lYPu {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__carousel-hide___6fxWp {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__carousel-hide___6fxWp {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel___2RTh2 {\n  position: relative;\n  max-width: 100%;\n  overflow: hidden; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-carousel___2RTh2 .node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__item___2SHuf {\n    flex: 1 1 100%;\n    box-sizing: border-box; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-carousel___2RTh2 .node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__item___2SHuf > * {\n      width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-carousel___2RTh2 .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-next___2Vb_j {\n    right: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-carousel___2RTh2 .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-previous___1W2jK {\n    left: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-carousel___2RTh2 img {\n    -webkit-user-drag: none;\n    -khtml-user-drag: none;\n    -moz-user-drag: none;\n    -o-user-drag: none;\n    user-drag: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel-controls__control___2c3dH {\n  width: 36px;\n  height: 36px;\n  stroke: #fff;\n  fill: transparent;\n  cursor: pointer;\n  filter: drop-shadow(1px 1px 1px rgba(170, 170, 170, 0.5));\n  -webkit-filter: drop-shadow(1px 1px 1px rgba(170, 170, 170, 0.5)); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel-controls__control___2c3dH:hover {\n  stroke-width: 2px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel-controls__control--active___YXzMe {\n  stroke: #865CD6;\n  fill: #865CD6; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__track___1r5Kd {\n  display: flex;\n  max-width: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__track--animate___7XgVn {\n  transition: all 0.8s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__arrow___2w0Hp {\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__carousel-reveal___1lYPu 1s;\n  animation: node_modules-grommet-scss-vanilla-___index__carousel-reveal___1lYPu 1s;\n  z-index: 1;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-carousel__arrow___2w0Hp .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    filter: drop-shadow(1px 1px 1px rgba(170, 170, 170, 0.5));\n    -webkit-filter: drop-shadow(1px 1px 1px rgba(170, 170, 170, 0.5)); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-carousel__arrow___2w0Hp .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n polyline {\n      stroke: rgba(255, 255, 255, 0.7);\n      stroke-width: 1px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__arrow___2w0Hp:hover .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n polyline {\n  stroke: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__arrow--next___3Q1_8 {\n  right: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__arrow--prev___1xbcc {\n  left: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__controls___3S5vw {\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__carousel-reveal___1lYPu 1s;\n  animation: node_modules-grommet-scss-vanilla-___index__carousel-reveal___1lYPu 1s;\n  margin-left: 50%;\n  transform: translateX(-50%);\n  position: absolute;\n  bottom: 12px;\n  text-align: center;\n  z-index: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__control___Eyr8n {\n  display: inline-block;\n  width: 36px;\n  height: 36px;\n  stroke: rgba(255, 255, 255, 0.7);\n  fill: transparent;\n  cursor: pointer;\n  filter: drop-shadow(1px 1px 1px rgba(170, 170, 170, 0.5));\n  -webkit-filter: drop-shadow(1px 1px 1px rgba(170, 170, 170, 0.5)); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__control--active___Z_imi {\n  stroke: #865CD6;\n  fill: #865CD6; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel--hide-controls___2Goza .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-previous___1W2jK,\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel--hide-controls___2Goza .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-next___2Vb_j,\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel--hide-controls___2Goza .node_modules-grommet-scss-vanilla-___index__grommetux-carousel__controls___3S5vw {\n  opacity: 0;\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__carousel-hide___6fxWp 1s;\n  animation: node_modules-grommet-scss-vanilla-___index__carousel-hide___6fxWp 1s; }\n\n_::-webkit-:not(:root:root),\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__control___Eyr8n,\n.node_modules-grommet-scss-vanilla-___index__grommetux-carousel__arrow___2w0Hp .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n  -webkit-filter: none;\n  -webkit-svg-shadow: 1px 1px 1px rgba(170, 170, 170, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1 .node_modules-grommet-scss-vanilla-___index__grommetux-carousel___2RTh2 {\n  width: 100vw; }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__fade-in-chart___2CndH {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__fade-in-chart___2CndH {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart___J6xYl {\n  position: relative;\n  display: flex; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart___J6xYl .node_modules-grommet-scss-vanilla-___index__grommetux-chart___J6xYl {\n    min-width: 0;\n    max-width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart--full___3rTwx {\n  width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart--vertical___1WwUH {\n  flex-direction: column; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart___J6xYl:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart--vertical___1WwUH) {\n  flex-direction: row; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base___MEHK_ {\n  display: flex; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--vertical___jeqOL {\n  flex-direction: column; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base___MEHK_:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--vertical___jeqOL) {\n  flex-direction: row; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-base___MEHK_:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--vertical___jeqOL) > * {\n    flex: 0 0 auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-small___1EOmU {\n  width: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-medium___3qdLQ {\n  width: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-large___hZs0V {\n  width: 576px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-large___hZs0V {\n      max-width: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-full___1i7oc {\n  width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-xxsmall___2hoEj {\n  height: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-xsmall___3o-4v {\n  height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-small___aHEPI {\n  height: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-medium___2cXoR {\n  height: 384px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-medium___2cXoR {\n      height: 192px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-large___GpCcT {\n  height: 576px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-large___GpCcT {\n      height: 384px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-sparkline____z01a {\n  height: 24px;\n  width: 96px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-sparkline____z01a.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-xsmall___3We-J {\n    width: 96px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-sparkline____z01a.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-small___1EOmU {\n    width: 192px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-sparkline____z01a.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-medium___3qdLQ {\n    width: 384px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-sparkline____z01a.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-large___hZs0V {\n    width: 576px; }\n    @media screen and (max-width: 44.9375em) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-sparkline____z01a.node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-large___hZs0V {\n        max-width: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n  flex: 0 0;\n  display: flex;\n  flex-direction: column;\n  -webkit-transform: translateZ(0); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::before, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::after {\n  background-color: rgba(0, 0, 0, 0.15); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::before, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::before, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::after {\n  background-color: rgba(255, 255, 255, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::before, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::before, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::after {\n  background-color: rgba(0, 0, 0, 0.15); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB {\n  flex-direction: column-reverse;\n  margin-left: 12px;\n  margin-right: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n    min-width: 1em;\n    justify-content: flex-start; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV:first-child {\n      flex-direction: column-reverse; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--align-start___17z7R {\n    align-items: flex-start; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--align-start___17z7R .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n      align-items: flex-start; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--align-end___1-7gj {\n    align-items: flex-end; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--align-end___1-7gj .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n      align-items: flex-end; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot--placeholder___q4Y3h)::before {\n    display: block;\n    content: \"\";\n    height: 1px;\n    width: 6px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks--start___magXf .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n    align-items: flex-start; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks--end___2N22i .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n    align-items: flex-end; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_ {\n    flex-direction: column; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_ .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n      justify-content: flex-start;\n      flex-direction: column-reverse; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_ .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV:first-child {\n        flex-direction: column;\n        justify-content: flex-start; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_ .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV:last-child {\n        justify-content: flex-start; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks--start___magXf .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n      align-items: flex-start; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks--end___2N22i .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n      align-items: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB) {\n  flex-direction: row;\n  margin-top: 12px;\n  margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB) .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n    min-height: 24px;\n    align-items: flex-start;\n    justify-content: flex-end;\n    flex-direction: row; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB) .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV:first-child {\n      align-items: flex-start;\n      flex-direction: row-reverse;\n      padding-left: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--align-start___17z7R {\n    align-items: flex-start; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--align-end___1-7gj {\n    align-items: flex-end; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--align-end___1-7gj .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n      justify-content: flex-end; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV::after {\n    display: block;\n    content: \"\";\n    height: 6px;\n    width: 1px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks--end___2N22i .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot--placeholder___q4Y3h) {\n    align-items: flex-end; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks--start___magXf .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot--placeholder___q4Y3h) {\n    align-items: flex-start; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot--placeholder___q4Y3h) > span {\n    padding: 0 6px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_ {\n    flex-direction: row-reverse; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_ .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n      align-items: flex-start; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV {\n      align-items: flex-start;\n      justify-content: flex-end;\n      flex-direction: row-reverse; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB).node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_.node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r .node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV:first-child {\n        flex-direction: row; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label___2rzO6 {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH {\n  flex: 0 0;\n  display: flex;\n  flex-direction: column;\n  -webkit-transform: translateZ(0); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH {\n  flex-direction: column-reverse;\n  margin-left: 12px;\n  margin-right: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH {\n    min-width: 1em;\n    justify-content: flex-start; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot--flip___cgAI0 {\n      justify-content: flex-end; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--align-start___3rCP0 {\n    align-items: flex-start; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--align-start___3rCP0 .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH {\n      align-items: flex-start; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--align-end___BSvIY {\n    align-items: flex-end; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--align-end___BSvIY .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH {\n      align-items: flex-end; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--reverse___-5jl8 {\n    flex-direction: column; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--reverse___-5jl8 .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH {\n      justify-content: flex-end; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--reverse___-5jl8 .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot--flip___cgAI0 {\n        justify-content: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label___2rzO6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH) {\n  flex-direction: row;\n  margin-top: 12px;\n  margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label___2rzO6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH) .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH {\n    min-height: 24px;\n    align-items: flex-end; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label___2rzO6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH) .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot--flip___cgAI0 {\n      align-items: flex-start; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label___2rzO6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH).node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--align-start___3rCP0 {\n    align-items: flex-start; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label___2rzO6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH).node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--align-start___3rCP0 .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH {\n      justify-content: flex-start; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label___2rzO6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH).node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--align-end___BSvIY {\n    align-items: flex-end; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label___2rzO6:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH).node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--align-end___BSvIY .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH {\n      justify-content: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-layers___6L8gB {\n  position: absolute;\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__fade-in-chart___2CndH 0.5s;\n  animation: node_modules-grommet-scss-vanilla-___index__fade-in-chart___2CndH 0.5s; }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__stretch-up-chart___2fF_s {\n  0% {\n    max-height: 0; }\n  100% {\n    max-height: 100%; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__stretch-up-chart___2fF_s {\n  0% {\n    max-height: 0; }\n  100% {\n    max-height: 100%; } }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__stretch-right-chart___3xf_9 {\n  0% {\n    max-width: 0; }\n  100% {\n    max-width: 100%; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__stretch-right-chart___3xf_9 {\n  0% {\n    max-width: 0; }\n  100% {\n    max-width: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO,\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-grid___gxonE,\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX,\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g,\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f,\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-hot-spots___3b-Hw,\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range___2gQ6v,\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-loading___YdVpQ {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-loading___YdVpQ {\n  top: 0;\n  stroke-width: 24px;\n  stroke: #ddd;\n  stroke-dasharray: 1 24px;\n  stroke-dashoffset: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-hot-spots___3b-Hw {\n  display: flex;\n  width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-hot-spots___3b-Hw > * {\n    flex: 0 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-hot-spots--vertical___1m1T3 {\n  flex-direction: column; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-hot-spots___3b-Hw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-hot-spots--vertical___1m1T3) {\n  flex-direction: row; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-hot-spots--clickable___1U2MG {\n  cursor: pointer; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range___2gQ6v {\n  display: flex;\n  flex-direction: row; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__active___qtDKx {\n  position: relative;\n  height: 100%;\n  flex: 1 1;\n  cursor: ew-resize; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before___p0M-4,\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__after___23v_9 {\n  position: relative;\n  flex: 0 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 1; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before___p0M-4, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before___p0M-4, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__after___23v_9, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__after___23v_9 {\n    background-color: rgba(0, 0, 0, 0.4); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before___p0M-4, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before___p0M-4, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__after___23v_9, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__after___23v_9 {\n    background-color: rgba(255, 255, 255, 0.7); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before___p0M-4 {\n  justify-content: flex-end;\n  border-color: rgba(0, 0, 0, 0.15);\n  border-width: 1px;\n  border-style: none solid none none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before--end___3ue0I {\n  z-index: 2; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__after___23v_9 {\n  justify-content: flex-start;\n  border-color: rgba(0, 0, 0, 0.15);\n  border-width: 1px;\n  border-style: none none none solid; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD,\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  flex: 0 1 24px;\n  background-color: rgba(255, 255, 255, 0.7);\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  padding: 6px 0;\n  height: 36px;\n  cursor: col-resize;\n  outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h {\n    background-color: rgba(0, 0, 0, 0.5);\n    border-color: rgba(255, 255, 255, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h {\n    background-color: rgba(255, 255, 255, 0.7);\n    border-color: rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD:hover,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h:hover {\n    background-color: #fff;\n    border-color: #000; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h:hover {\n      background-color: rgba(0, 0, 0, 0.5);\n      border-color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n    .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h:hover {\n      background-color: #fff;\n      border-color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD svg,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h svg {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD {\n  right: -1px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start--edge___1HvJy {\n  right: -26px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h {\n  left: -1px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end--edge___qLGdW {\n  left: -26px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start--focus___1hnJr,\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end--focus___dKTJ5 {\n  border-color: #00CCEB;\n  box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle {\n  flex-direction: column; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__active___qtDKx {\n    width: 100%;\n    cursor: ns-resize; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before___p0M-4,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__after___23v_9 {\n    flex-direction: column; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before___p0M-4 {\n    border-style: none none solid; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__after___23v_9 {\n    border-style: solid none none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h {\n    top: auto;\n    transform: none;\n    padding: 0 6px;\n    height: 26px;\n    cursor: row-resize; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD {\n    right: auto;\n    bottom: -1px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start--edge___1HvJy {\n    bottom: -26px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h {\n    left: auto;\n    top: -1px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end--edge___qLGdW {\n    top: -26px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle svg {\n    transform: rotate(90deg); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-grid___gxonE path {\n  stroke: rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-grid___gxonE path, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-grid___gxonE path {\n    stroke: rgba(255, 255, 255, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-grid___gxonE path, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-grid___gxonE path {\n    stroke: rgba(0, 0, 0, 0.15); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO {\n  stroke: rgba(0, 0, 0, 0.15);\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__fade-in-chart___2CndH 1s;\n  animation: node_modules-grommet-scss-vanilla-___index__fade-in-chart___2CndH 1s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: rgba(221, 221, 221, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: rgba(134, 92, 214, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: rgba(255, 50, 77, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: rgba(255, 50, 77, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: rgba(255, 214, 2, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: rgba(140, 200, 0, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: rgba(168, 168, 168, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: rgba(168, 168, 168, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: rgba(10, 100, 160, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: rgba(220, 40, 120, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: rgba(80, 30, 180, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: rgba(73, 81, 111, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: rgba(0, 204, 235, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: rgba(255, 125, 40, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI {\n    stroke: rgba(0, 0, 1, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM {\n    stroke: rgba(51, 51, 51, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5 {\n    stroke: rgba(59, 59, 59, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN {\n    stroke: rgba(67, 67, 67, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F {\n    stroke: rgba(102, 102, 102, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n    stroke: #ddd;\n    stroke-dasharray: 1px 10px;\n    stroke-dashoffset: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    stroke: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    stroke: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    stroke: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    stroke: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    stroke: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n    stroke: #ffffff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n    stroke: #f5f5f5; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: rgba(221, 221, 221, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: rgba(134, 92, 214, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: rgba(255, 50, 77, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: rgba(255, 50, 77, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: rgba(255, 214, 2, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: rgba(140, 200, 0, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: rgba(168, 168, 168, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: rgba(168, 168, 168, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: rgba(10, 100, 160, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: rgba(220, 40, 120, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: rgba(80, 30, 180, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: rgba(73, 81, 111, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: rgba(0, 204, 235, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: rgba(255, 125, 40, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI {\n    stroke: rgba(0, 0, 1, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM {\n    stroke: rgba(51, 51, 51, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5 {\n    stroke: rgba(59, 59, 59, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN {\n    stroke: rgba(67, 67, 67, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F {\n    stroke: rgba(102, 102, 102, 0.7); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX {\n  stroke-width: 3px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: rgba(221, 221, 221, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: rgba(134, 92, 214, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: rgba(255, 50, 77, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: rgba(255, 50, 77, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: rgba(255, 214, 2, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: rgba(140, 200, 0, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: rgba(168, 168, 168, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: rgba(168, 168, 168, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: rgba(10, 100, 160, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: rgba(220, 40, 120, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: rgba(80, 30, 180, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: rgba(73, 81, 111, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: rgba(0, 204, 235, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: rgba(255, 125, 40, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI {\n    stroke: rgba(0, 0, 1, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM {\n    stroke: rgba(51, 51, 51, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5 {\n    stroke: rgba(59, 59, 59, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN {\n    stroke: rgba(67, 67, 67, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F {\n    stroke: rgba(102, 102, 102, 0.7); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f {\n  stroke-width: 4px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: rgba(221, 221, 221, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: rgba(134, 92, 214, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: rgba(255, 50, 77, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: rgba(255, 50, 77, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: rgba(255, 214, 2, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: rgba(140, 200, 0, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: rgba(168, 168, 168, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: rgba(168, 168, 168, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: rgba(10, 100, 160, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: rgba(220, 40, 120, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: rgba(80, 30, 180, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: rgba(73, 81, 111, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: rgba(0, 204, 235, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: rgba(255, 125, 40, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI {\n    stroke: rgba(0, 0, 1, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM {\n    stroke: rgba(51, 51, 51, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5 {\n    stroke: rgba(59, 59, 59, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN {\n    stroke: rgba(67, 67, 67, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F {\n    stroke: rgba(102, 102, 102, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--vertical___1GjDD {\n    -webkit-animation: node_modules-grommet-scss-vanilla-___index__stretch-right-chart___3xf_9 1.5s;\n    animation: node_modules-grommet-scss-vanilla-___index__stretch-right-chart___3xf_9 1.5s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--vertical___1GjDD) {\n    bottom: 0;\n    -webkit-animation: node_modules-grommet-scss-vanilla-___index__stretch-up-chart___2fF_s 1.5s;\n    animation: node_modules-grommet-scss-vanilla-___index__stretch-up-chart___2fF_s 1.5s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g {\n  stroke-width: 3px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    fill: rgba(221, 221, 221, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    fill: rgba(134, 92, 214, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    fill: rgba(255, 50, 77, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    fill: rgba(255, 50, 77, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    fill: rgba(255, 214, 2, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    fill: rgba(140, 200, 0, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    fill: rgba(168, 168, 168, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    fill: rgba(168, 168, 168, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    fill: rgba(10, 100, 160, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    fill: rgba(220, 40, 120, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    fill: rgba(80, 30, 180, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    fill: rgba(73, 81, 111, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    fill: rgba(0, 204, 235, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    fill: rgba(255, 125, 40, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI {\n    fill: rgba(0, 0, 1, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM {\n    fill: rgba(51, 51, 51, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5 {\n    fill: rgba(59, 59, 59, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN {\n    fill: rgba(67, 67, 67, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F {\n    fill: rgba(102, 102, 102, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--vertical___1GjDD {\n    -webkit-animation: node_modules-grommet-scss-vanilla-___index__stretch-right-chart___3xf_9 1.5s;\n    animation: node_modules-grommet-scss-vanilla-___index__stretch-right-chart___3xf_9 1.5s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g:not(.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--vertical___1GjDD) {\n    bottom: 0;\n    -webkit-animation: node_modules-grommet-scss-vanilla-___index__stretch-up-chart___2fF_s 1.5s;\n    animation: node_modules-grommet-scss-vanilla-___index__stretch-up-chart___2fF_s 1.5s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_ {\n    stroke: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_ {\n  stroke: none;\n  transition: r 0.3s;\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__fade-in-chart___2CndH 0.3s;\n  animation: node_modules-grommet-scss-vanilla-___index__fade-in-chart___2CndH 0.3s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    fill: rgba(221, 221, 221, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    fill: rgba(134, 92, 214, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    fill: rgba(255, 50, 77, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    fill: rgba(255, 50, 77, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    fill: rgba(255, 214, 2, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    fill: rgba(140, 200, 0, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    fill: rgba(168, 168, 168, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    fill: rgba(168, 168, 168, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    fill: rgba(10, 100, 160, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    fill: rgba(220, 40, 120, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    fill: rgba(80, 30, 180, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    fill: rgba(73, 81, 111, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    fill: rgba(0, 204, 235, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    fill: rgba(255, 125, 40, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI {\n    fill: rgba(0, 0, 1, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM {\n    fill: rgba(51, 51, 51, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5 {\n    fill: rgba(59, 59, 59, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN {\n    fill: rgba(67, 67, 67, 0.9); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F {\n    fill: rgba(102, 102, 102, 0.9); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv {\n  stroke: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    fill: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    fill: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    fill: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    fill: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    fill: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    fill: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    fill: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    fill: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    fill: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    fill: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    fill: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    fill: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    fill: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    fill: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    fill: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    fill: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    fill: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    fill: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    fill: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv {\n    stroke: rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv {\n    stroke: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT {\n  margin-right: 12px;\n  white-space: nowrap; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT {\n    margin-right: 24px;\n    margin-left: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) {\n  cursor: pointer; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n  border-color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    border-color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    border-color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked +\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n  border-color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked +\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked +\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    border-color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked +\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked +\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    border-color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck {\n  color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck {\n    color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA {\n  opacity: 0;\n  width: 0;\n  height: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    border-color: #865CD6; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n      border-color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n      border-color: #865CD6; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control-check___1J67N {\n      display: block; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck {\n      color: #333; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck {\n        color: #fff; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck {\n        color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:focus + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    border-color: #00CCEB;\n    box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n  vertical-align: middle;\n  background-color: inherit;\n  border: 2px solid #666;\n  border-radius: 4px; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    margin-right: 0;\n    margin-left: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    border-color: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    border-color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control-check___1J67N {\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  display: none;\n  width: 24px;\n  height: 24px;\n  stroke-width: 4px;\n  stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control-check___1J67N, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control-check___1J67N {\n    stroke: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control-check___1J67N, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control-check___1J67N {\n    stroke: #865CD6; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck {\n  display: inline-block;\n  vertical-align: middle;\n  color: #666;\n  white-space: normal;\n  margin-right: 24px;\n  word-break: break-word; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck {\n    color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck {\n    color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n  opacity: 0.5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--reverse___23DAX .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n  margin-right: 0;\n  margin-left: 12px; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--reverse___23DAX .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    margin-left: 0;\n    margin-right: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n  content: \"\";\n  border-color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n    background-color: #fff;\n    border-color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n    background-color: none;\n    border-color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n  content: \"\";\n  border-color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n    background-color: #fff;\n    border-color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt) .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n    background-color: none;\n    border-color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n  width: 48px;\n  height: 24px;\n  border-radius: 24px;\n  background-color: rgba(51, 51, 51, 0.2);\n  border: none;\n  transition: background-color 0.3s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    background-color: rgba(255, 255, 255, 0.2); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    background-color: rgba(51, 51, 51, 0.2); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    top: -2px;\n    left: 0px;\n    width: 28px;\n    height: 28px;\n    background-color: #fff;\n    border: 2px solid #666;\n    border-radius: 24px;\n    transition: margin-left 0.3s;\n    box-sizing: border-box; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n      background-color: #fff;\n      border-color: rgba(255, 255, 255, 0.7); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n      border-color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n  background-color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    background-color: rgba(255, 255, 255, 0.2); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control-check___1J67N, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control-check___1J67N {\n      stroke: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK {\n    background-color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n    content: \"\";\n    background-color: #fff;\n    border-color: #865CD6;\n    margin-left: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n      background-color: #fff;\n      border-color: rgba(255, 255, 255, 0.7); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK:after {\n      border-color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK .node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control-check___1J67N {\n    display: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-collapsible___3n7Al {\n  overflow: hidden; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-collapsible__wrapper___3KVxH {\n  width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-collapsible___3n7Al.node_modules-grommet-scss-vanilla-___index__animate___1UFGz {\n  transition: height 0.5s ease-out; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju {\n  color: transparent; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh {\n  color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input::-webkit-input-placeholder, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input::-webkit-input-placeholder {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input::-moz-placeholder, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input::-moz-placeholder {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input:-ms-input-placeholder, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh input:-ms-input-placeholder {\n    color: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo {\n  color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input::-webkit-input-placeholder, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input::-webkit-input-placeholder {\n    color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input::-moz-placeholder, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input::-moz-placeholder {\n    color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input:-ms-input-placeholder, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo input:-ms-input-placeholder {\n    color: #333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-brand___M7atr {\n  background-color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-brand-a___lmDRf {\n    background-color: rgba(134, 92, 214, 0.94); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-brand___3CXKg {\n  border-color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-brand-a___2Nu1M {\n    border-color: rgba(134, 92, 214, 0.94); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-1____EVmv,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-5___nm_Dz {\n  background-color: #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-1-t___1pw7S,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-5-t___tEbGp {\n  background-color: #166ca5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-1-a___olVOw,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-5-a___2f-vS {\n  background-color: rgba(10, 100, 160, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-1___smFoS,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-5___2eNLC {\n  border-color: #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-1-t___CWieV,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-5-t___tsBEs {\n  border-color: #166ca5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n  color: #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1-t___2MM_1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5-t___1TLOC {\n  color: #166ca5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-1___RbSih:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-5___2K19F:hover {\n  background-color: rgba(10, 100, 160, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-1___183Lb:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-5___IEs54:hover {\n  box-shadow: 0 0 0 1px #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-1___3JGGi:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-5___ALJuV:hover {\n  box-shadow: 0 0 0 12px #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-1___3F8eK:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-5___1qLTe:hover {\n  box-shadow: 0 0 0 24px #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-2___gqtzK,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-6___3IDfk {\n  background-color: #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-2-t___2J8wX,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-6-t___1TamA {\n  background-color: #de337f; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-2-a___2i3rg,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-6-a___7cMv- {\n  background-color: rgba(220, 40, 120, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-2___t5-0Q,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-6___1NLvh {\n  border-color: #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-2-t___2EsXm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-6-t___1XS6b {\n  border-color: #de337f; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n  color: #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2-t___1SV73,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6-t___3UdnK {\n  color: #de337f; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-2___1GBzt:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-6___e7Qtj:hover {\n  background-color: rgba(220, 40, 120, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-2___2ZC_t:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-6___1m_EG:hover {\n  box-shadow: 0 0 0 1px #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-2___3jsu9:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-6___2W4_n:hover {\n  box-shadow: 0 0 0 12px #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-2___1Aro3:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-6___2nIbd:hover {\n  box-shadow: 0 0 0 24px #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-3___1Gopf,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-7___3jToB {\n  background-color: #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-3-t___nJdVi,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-7-t___1FClX {\n  background-color: #5929b8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-3-a___dqj0T,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-7-a___2ccln {\n  background-color: rgba(80, 30, 180, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-3___2a5Bh,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-7___2nADy {\n  border-color: #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-3-t___2HE8H,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-7-t___3G9jq {\n  border-color: #5929b8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n  color: #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3-t___EoDCT,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7-t___A_c35 {\n  color: #5929b8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-3___2vjE6:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-7___2nJoV:hover {\n  background-color: rgba(80, 30, 180, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-3___3CQ_F:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-7___2bo6C:hover {\n  box-shadow: 0 0 0 1px #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-3___3JK0-:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-7___V0Chy:hover {\n  box-shadow: 0 0 0 12px #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-3___2eQC6:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-7___1xIUA:hover {\n  box-shadow: 0 0 0 24px #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-4___299gj,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-8___39Wud {\n  background-color: #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-4-t___QNKDT,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-8-t___2G_8n {\n  background-color: #525a76; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-4-a___8tnsm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-8-a___1hnaG {\n  background-color: rgba(73, 81, 111, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-4___23Eph,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-8___3z8g6 {\n  border-color: #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-4-t___2EyVC,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-8-t___1jfBJ {\n  border-color: #525a76; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n  color: #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4-t___2IB09,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8-t___Zpu7H {\n  color: #525a76; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-4___2tn-B:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-8___1lJPS:hover {\n  background-color: rgba(73, 81, 111, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-4___YnIoz:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-8___3s0my:hover {\n  box-shadow: 0 0 0 1px #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-4___3jWmJ:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-8___35qj_:hover {\n  box-shadow: 0 0 0 12px #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-4___DqRX6:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-8___2D4Hs:hover {\n  box-shadow: 0 0 0 24px #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-1___2CTOB,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-3___2WZ2Y {\n  background-color: #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-1-t___1Qsql,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-3-t___1E3SK {\n  background-color: #0dcfec; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-1-a___3JNMr,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-3-a___3M8Sb {\n  background-color: rgba(0, 204, 235, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-1___2RmrS,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-3___1iF8J {\n  border-color: #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-1-t___3CFO8,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-3-t___p_QT5 {\n  border-color: #0dcfec; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n  color: #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1-t___3MjdI,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3-t___3V6zO {\n  color: #0dcfec; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-accent-1___3Qp8M:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-accent-3___2L8aJ:hover {\n  background-color: rgba(0, 204, 235, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-accent-1___uBeNy:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-accent-3___2bmAB:hover {\n  box-shadow: 0 0 0 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-accent-1___1fB2v:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-accent-3___11ocs:hover {\n  box-shadow: 0 0 0 12px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-accent-1___DlkqZ:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-accent-3___qh2NB:hover {\n  box-shadow: 0 0 0 24px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-2___2wUp8,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-4___1t-Vp {\n  background-color: #FF7D28; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-2-t___YtZqb,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-4-t___1d7UN {\n  background-color: #ff8433; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-2-a___OQZ2m,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-4-a___2c3l2 {\n  background-color: rgba(255, 125, 40, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-2___3tXgD,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-4___3_vFF {\n  border-color: #FF7D28; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-2-t___3o5G5,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-4-t___3pf7b {\n  border-color: #ff8433; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n  color: #FF7D28; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2-t___3KJjU,\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4-t___39yNj {\n  color: #ff8433; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-accent-2___1rQKi:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-accent-4___2f1ec:hover {\n  background-color: rgba(255, 125, 40, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-accent-2___13xNg:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-accent-4___2uFGc:hover {\n  box-shadow: 0 0 0 1px #FF7D28; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-accent-2___32p_2:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-accent-4___1rHA5:hover {\n  box-shadow: 0 0 0 12px #FF7D28; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-accent-2___3ARc3:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-accent-4___yBQ0n:hover {\n  box-shadow: 0 0 0 24px #FF7D28; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-1___2jQyI,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-6___3BwX5 {\n  background-color: #000001; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-1-a___3Wv6o,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-6-a___40MyO {\n  background-color: rgba(0, 0, 1, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-1___309G8,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-6___jnPzW {\n  border-color: #000001; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-1___1KPn_:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-6___2UHdU:hover {\n  background-color: rgba(0, 0, 1, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-1___1jYAa:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-6___2-UH5:hover {\n  box-shadow: 0 0 0 1px #000001; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-1___1LHH1:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-6___1g8iw:hover {\n  box-shadow: 0 0 0 12px #000001; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-1___1N4Qi:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-6___2wrdo:hover {\n  box-shadow: 0 0 0 24px #000001; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-2____L6LH,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-7___LY0Ui {\n  background-color: #333333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-2-a___3emKz,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-7-a___L5-Oo {\n  background-color: rgba(51, 51, 51, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-2___1ADip,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-7___2v_Jn {\n  border-color: #333333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-2___3g7y1:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-7___2i3o8:hover {\n  background-color: rgba(51, 51, 51, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-2___1LL4s:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-7___uzKd1:hover {\n  box-shadow: 0 0 0 1px #333333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-2___1xBiC:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-7___2Is0K:hover {\n  box-shadow: 0 0 0 12px #333333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-2___h7r-V:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-7___1zeZW:hover {\n  box-shadow: 0 0 0 24px #333333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-3___1uGGn,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-8___15Y1R {\n  background-color: #3B3B3B; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-3-a___lpQ8l,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-8-a___295Z9 {\n  background-color: rgba(59, 59, 59, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-3___2HYdG,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-8___2y_AZ {\n  border-color: #3B3B3B; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-3___3D4dI:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-8___2CljE:hover {\n  background-color: rgba(59, 59, 59, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-3___22pxF:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-8___3goFy:hover {\n  box-shadow: 0 0 0 1px #3B3B3B; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-3___36kFa:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-8___1hEa4:hover {\n  box-shadow: 0 0 0 12px #3B3B3B; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-3___3CvYK:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-8___xX0Lg:hover {\n  box-shadow: 0 0 0 24px #3B3B3B; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-4___3JeNA,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-9___2RvJW {\n  background-color: #434343; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-4-a___2IHtt,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-9-a___boRbr {\n  background-color: rgba(67, 67, 67, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-4___U685i,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-9___2ibFN {\n  border-color: #434343; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-4___2qUnu:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-9___28Ioh:hover {\n  background-color: rgba(67, 67, 67, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-4___1WYQb:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-9___2mGpX:hover {\n  box-shadow: 0 0 0 1px #434343; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-4___1fq0n:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-9___lq9zL:hover {\n  box-shadow: 0 0 0 12px #434343; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-4___121eW:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-9___Px7oL:hover {\n  box-shadow: 0 0 0 24px #434343; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-5___2ZOjy,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-10___3eJvZ {\n  background-color: #666666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-5-a___3AEqu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-10-a___2G4J_ {\n  background-color: rgba(102, 102, 102, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-5___1BomX,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-10___1y0JJ {\n  border-color: #666666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-5___2Vf57:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-10___2n4vs:hover {\n  background-color: rgba(102, 102, 102, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-5___1kEjl:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-10___2Prxk:hover {\n  box-shadow: 0 0 0 1px #666666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-5___2kcj1:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-10___2HGcR:hover {\n  box-shadow: 0 0 0 12px #666666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-5___2LID9:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-10___2bSzN:hover {\n  box-shadow: 0 0 0 24px #666666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-1___1MD3-,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-5___2YWV2 {\n  background-color: #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-1___rclx6,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-5___zNILe {\n  border-color: #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-2___kQKyc,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-6___3MFdB {\n  background-color: #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-2___WpAA1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-6___2A6t8 {\n  border-color: #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-3___gtgaO,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-7___3_xkW {\n  background-color: #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-3___3b4tu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-7___arqZH {\n  border-color: #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-4___2ENd4,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-8___3WCEw {\n  background-color: #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-4___2ofd7,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-8___2iiI_ {\n  border-color: #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-critical___4HBBh {\n  background-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-critical___2FMT1 {\n  border-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n  color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-critical___370Ct:hover {\n  background-color: rgba(255, 50, 77, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-critical___33UZM:hover {\n  box-shadow: 0 0 0 1px #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-critical___2wMUN:hover {\n  box-shadow: 0 0 0 12px #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-critical___1___F:hover {\n  box-shadow: 0 0 0 24px #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-error___2elT5 {\n  background-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-error___OfENz {\n  border-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n  color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-error___3JCaZ:hover {\n  background-color: rgba(255, 50, 77, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-error___3Xkex:hover {\n  box-shadow: 0 0 0 1px #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-error___2oRvW:hover {\n  box-shadow: 0 0 0 12px #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-error___2KY_x:hover {\n  box-shadow: 0 0 0 24px #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-warning___3tjiI {\n  background-color: #FFD602; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-warning___3FQUS {\n  border-color: #FFD602; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n  color: #FFD602; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-warning___23woq:hover {\n  background-color: rgba(255, 214, 2, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-warning___2kJ3S:hover {\n  box-shadow: 0 0 0 1px #FFD602; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-warning___3VpOF:hover {\n  box-shadow: 0 0 0 12px #FFD602; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-warning___3M_4-:hover {\n  box-shadow: 0 0 0 24px #FFD602; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-ok___JpX0P {\n  background-color: #8CC800; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-ok___2asDN {\n  border-color: #8CC800; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n  color: #8CC800; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-ok___1PCaU:hover {\n  background-color: rgba(140, 200, 0, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-ok___3Q-TK:hover {\n  box-shadow: 0 0 0 1px #8CC800; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-ok___73P-6:hover {\n  box-shadow: 0 0 0 12px #8CC800; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-ok___1eDXx:hover {\n  box-shadow: 0 0 0 24px #8CC800; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-unknown___2DQJ5 {\n  background-color: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-unknown___1r3a_ {\n  border-color: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n  color: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-unknown____fKCh:hover {\n  background-color: rgba(168, 168, 168, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-unknown___5_hUa:hover {\n  box-shadow: 0 0 0 1px #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-unknown___1Rz9A:hover {\n  box-shadow: 0 0 0 12px #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-unknown___4_2wG:hover {\n  box-shadow: 0 0 0 24px #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-disabled___5xXfP {\n  background-color: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-disabled___2xT4b {\n  border-color: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n  color: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-disabled___DQaSb:hover {\n  background-color: rgba(168, 168, 168, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-disabled___1E413:hover {\n  box-shadow: 0 0 0 1px #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-disabled___2UOm9:hover {\n  box-shadow: 0 0 0 12px #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-disabled___3WOSN:hover {\n  box-shadow: 0 0 0 24px #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-1___3NBfe,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-3___2ReJ6 {\n  background-color: #ffffff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-1-a___1tRDQ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-3-a___B6zko {\n  background-color: rgba(255, 255, 255, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-light-1___3qCeu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-light-3___36BZP {\n  border-color: #ffffff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-light-1___19HPm:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-light-3____SymO:hover {\n  background-color: rgba(255, 255, 255, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-light-1___30gZy:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-light-3___yAFj0:hover {\n  box-shadow: 0 0 0 1px #ffffff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-light-1___9ZbEn:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-light-3___AFHEp:hover {\n  box-shadow: 0 0 0 12px #ffffff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-light-1___2eCVZ:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-light-3___1_aC0:hover {\n  box-shadow: 0 0 0 24px #ffffff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-2___1qFCr,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-4___33mft {\n  background-color: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-2-a___1mEIo,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-4-a___1kbSZ {\n  background-color: rgba(245, 245, 245, 0.8); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-light-2___2XCvD,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-light-4___3JCj9 {\n  border-color: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-light-2___MhZno:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-light-4___3gDS7:hover {\n  background-color: rgba(245, 245, 245, 0.3); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-light-2___37h-4:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-light-4___umaMc:hover {\n  box-shadow: 0 0 0 1px #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-light-2___3SZo4:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-light-4___3dze6:hover {\n  box-shadow: 0 0 0 12px #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-light-2___318u0:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-light-4___3c-vs:hover {\n  box-shadow: 0 0 0 24px #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-unset___Eslix {\n  background-color: #ddd; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-columns___h1LAl {\n  display: flex;\n  flex-direction: row;\n  width: 100%; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-columns___h1LAl > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n      flex-basis: calc(384px); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-columns___h1LAl.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-small___1D1VR > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n      flex-basis: calc(384px + 12px); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-columns___h1LAl.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-medium___37Bbp > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n      flex-basis: calc(384px + 24px); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-columns___h1LAl.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-large___1-OhB > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n      flex-basis: calc(384px + 48px); } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-columns___h1LAl {\n      flex-direction: column; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n  flex: 0 0 384px;\n  display: flex;\n  flex-direction: column; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n      flex-basis: auto; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--responsive___1QCYd > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex: 0 1 auto; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--responsive___1QCYd.node_modules-grommet-scss-vanilla-___index__grommetux-columns--small___KlzKo > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K, .node_modules-grommet-scss-vanilla-___index__grommetux-columns--responsive___1QCYd.node_modules-grommet-scss-vanilla-___index__grommetux-columns--medium___2aDQp > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K, .node_modules-grommet-scss-vanilla-___index__grommetux-columns--responsive___1QCYd.node_modules-grommet-scss-vanilla-___index__grommetux-columns--large___qHWZU > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex: 0 1 auto; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--small___KlzKo > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(192px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--small___KlzKo.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-small___1D1VR > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(192px + 12px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--small___KlzKo.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-medium___37Bbp > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(192px + 24px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--small___KlzKo.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-large___1-OhB > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(192px + 48px); } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--medium___2aDQp > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(384px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--medium___2aDQp.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-small___1D1VR > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(384px + 12px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--medium___2aDQp.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-medium___37Bbp > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(384px + 24px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--medium___2aDQp.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-large___1-OhB > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(384px + 48px); } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--large___qHWZU > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(576px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--large___qHWZU.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-small___1D1VR > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(576px + 12px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--large___qHWZU.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-medium___37Bbp > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(576px + 24px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-columns--large___qHWZU.node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-large___1-OhB > .node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K {\n    flex-basis: calc(576px + 48px); } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-columns--justify-start___27Z7m {\n  justify-content: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-columns--justify-center___1L1-O {\n  justify-content: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-columns--justify-between___fX6AH {\n  justify-content: space-between; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-columns--justify-end___1hZIB {\n  justify-content: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po {\n  position: relative;\n  display: inline-block; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time__input___2hWqU {\n  padding: 11px 23px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  outline: none;\n  background-color: transparent;\n  color: inherit;\n  font: inherit;\n  margin: 0;\n  padding-right: 60px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__input___2hWqU:focus {\n    border-width: 2px;\n    border-color: #00CCEB;\n    padding: 10px 22px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__input___2hWqU::-moz-focus-inner {\n    border: none;\n    outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__input___2hWqU::-webkit-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__input___2hWqU::-moz-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__input___2hWqU:-ms-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__input___2hWqU.node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    border-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time__input___2hWqU:focus {\n  padding-right: 58px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time__input___2hWqU::-ms-clear {\n  display: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop___34nei {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__title___P3CTW {\n  text-align: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__grid___j_-k_ {\n  width: 100%;\n  padding: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__grid___j_-k_ table {\n    width: 100%;\n    margin-bottom: 0;\n    outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__grid___j_-k_ th,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__grid___j_-k_ td {\n    text-align: center; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__grid___j_-k_ th {\n    color: #666;\n    font-weight: normal;\n    padding: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__grid--focus___2CsQN table {\n  border-color: #00CCEB;\n  box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__day___9IZjZ {\n  display: inline-block;\n  cursor: pointer;\n  outline: none;\n  width: 36px;\n  height: 36px;\n  padding: 6px;\n  transition: background-color 0.3s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__day___9IZjZ:hover,\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__day--hover___1XH4_ {\n  background-color: rgba(221, 221, 221, 0.5);\n  color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__day--other-month___27Npl {\n  color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__day--active___3t57B {\n  background-color: #865CD6;\n  color: rgba(255, 255, 255, 0.85);\n  font-weight: 700; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__time___1kjA- {\n  font-size: 18px;\n  font-size: 1.125rem;\n  line-height: 1.33333;\n  font-weight: 700; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution___25g5l {\n  position: relative;\n  width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__graphic___3P4h- {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  outline: none;\n  max-width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__graphic--focus___2lakM {\n  border-color: #00CCEB;\n  box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__background___2YYmG {\n  fill: #f5f5f5; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__background___2YYmG, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__background___2YYmG {\n    fill: rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__background___2YYmG, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__background___2YYmG {\n    fill: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item--clickable___yNaxf {\n  cursor: pointer;\n  outline: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q {\n  transition: all 0.2s ease; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    fill: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    fill: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    fill: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    fill: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    fill: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    fill: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    fill: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    fill: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    fill: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    fill: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    fill: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    fill: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    fill: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    fill: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    fill: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    fill: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    fill: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    fill: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    fill: #666666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n  stroke: #ddd;\n  stroke-dasharray: 1px 10px;\n  stroke-dashoffset: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n  stroke: #ddd; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n  stroke: #865CD6; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n  stroke: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n  stroke: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n  stroke: #FFD602; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n  stroke: #8CC800; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n  stroke: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n  stroke: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n  stroke: #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n  stroke: #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n  stroke: #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n  stroke: #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n  stroke: #000001; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n  stroke: #333333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n  stroke: #3B3B3B; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n  stroke: #434343; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n  stroke: #666666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n  stroke: #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n  stroke: #FF7D28; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n  stroke: #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n  stroke: #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n  stroke: #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n  stroke: #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n  stroke: #ffffff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n  stroke: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx {\n  position: absolute;\n  background-color: transparent;\n  padding: 6px 12px;\n  font-family: \"Work Sans\", Arial, sans-serif;\n  overflow: hidden;\n  text-align: left;\n  pointer-events: none;\n  transition: all 0.2s ease; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-brand___M7atr {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-critical___4HBBh {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-error___2elT5 {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-warning___3tjiI {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-ok___JpX0P {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-1____EVmv, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-5___nm_Dz {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-2___gqtzK, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-6___3IDfk {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-3___1Gopf, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-7___3jToB {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-4___299gj, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-8___39Wud {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-1___1MD3-, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-5___2YWV2 {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-2___kQKyc, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-6___3MFdB {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-3___gtgaO, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-7___3_xkW {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-4___2ENd4, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-8___3WCEw {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-1___2CTOB, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-3___2WZ2Y {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-2___2wUp8, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-4___1t-Vp {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-1___2jQyI, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-6___3BwX5 {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-2____L6LH, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-7___LY0Ui {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-3___1uGGn, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-8___15Y1R {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-4___3JeNA, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-9___2RvJW {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-5___2ZOjy, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-10___3eJvZ {\n    color: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-value___2maO1 {\n  display: block;\n  font-size: 36px;\n  font-size: 2.25rem;\n  line-height: 1.33333;\n  font-weight: 500; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-units___Wfb23 {\n  font-size: 24px;\n  font-size: 1.5rem;\n  line-height: inherit;\n  margin-left: 6px;\n  font-weight: 300; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-label___1DHvv {\n  display: block; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--active___3isf9 {\n  z-index: 10;\n  color: #333;\n  border-right: 2px solid #f5f5f5;\n  border-left: 2px solid #f5f5f5;\n  opacity: 0.9; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--thin___HtDiK .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-value___2maO1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--thin___HtDiK .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-label___1DHvv {\n  display: inline-block; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--small___34lS1 .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-value___2maO1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--small___34lS1 .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-units___Wfb23 {\n  font-size: 20px;\n  font-size: 1.25rem;\n  line-height: 1;\n  margin-right: 4px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--icons___2BINb {\n  padding: 0 12px 12px 0;\n  background-color: rgba(255, 255, 255, 0.8);\n  color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--icons___2BINb, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--icons___2BINb {\n    background-color: rgba(0, 0, 0, 0.15);\n    color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--icons___2BINb, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--icons___2BINb {\n    background-color: rgba(255, 255, 255, 0.8);\n    color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--icons___2BINb .node_modules-grommet-scss-vanilla-___index__label-value___4zZxr {\n    line-height: 1; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--icons___2BINb .node_modules-grommet-scss-vanilla-___index__label-units___2Pl6h {\n    color: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--icons___2BINb .node_modules-grommet-scss-vanilla-___index__label-label___3uvp0 {\n    display: block; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F {\n  stroke-width: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n    stroke: #ddd;\n    stroke-dasharray: 1px 10px;\n    stroke-dashoffset: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    stroke: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    stroke: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    stroke: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    stroke: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    stroke: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n    stroke: #ffffff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n    stroke: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution--icons___3_K_e .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx {\n  padding: 0 12px 12px 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution--icons___3_K_e .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-value___2maO1 {\n  line-height: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution--small___2SkcS {\n  height: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution--medium___12c8l {\n  height: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution--large___2NBsx {\n  height: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-distribution--full___3tQpZ {\n  height: 100%;\n  flex: 1 1; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-distribution--full___3tQpZ .node_modules-grommet-scss-vanilla-___index__grommetux-distribution__graphic___3P4h- {\n    width: auto;\n    height: auto;\n    max-height: 100%;\n    max-width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__grommetux-drop___7sOOe {\n  position: fixed;\n  z-index: 20;\n  border-radius: 4px;\n  overflow: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__grommetux-drop___7sOOe:not([class*=\"background-color-index-\"]) {\n  background-color: rgba(248, 248, 248, 0.95);\n  border: none;\n  box-shadow: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer_____cz1 {\n  min-height: 36px;\n  width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--small___1eTcp {\n  min-height: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--large___Wfnju {\n  min-height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer__content___8nthb {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding-left: 24px;\n  padding-right: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-footer__content___8nthb > * {\n    margin-right: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-footer__content___8nthb > *:last-child {\n      margin-right: 0px;\n      text-align: left; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--primary___3jBJD {\n  height: auto;\n  padding: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-footer--primary___3jBJD .node_modules-grommet-scss-vanilla-___index__grommetux-footer__content___8nthb {\n    position: relative;\n    color: #666;\n    display: block; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--centered___2K-8N .node_modules-grommet-scss-vanilla-___index__grommetux-footer__content___8nthb {\n  display: block;\n  text-align: center; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-footer--centered___2K-8N .node_modules-grommet-scss-vanilla-___index__grommetux-footer__content___8nthb > * {\n    margin-right: auto;\n    margin-left: auto;\n    text-align: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--flush___23BSa .node_modules-grommet-scss-vanilla-___index__grommetux-footer__content___8nthb,\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--flush___23BSa .node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper___1l_ka {\n  padding-left: 0px;\n  padding-right: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--fixed___21A7S .node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper___1l_ka {\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  z-index: 3; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--fixed___21A7S .node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper--fill___3VhxL .node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper___1l_ka {\n  background-color: rgba(255, 255, 255, 0.9); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--fixed___21A7S.node_modules-grommet-scss-vanilla-___index__grommetux-footer--primary___3jBJD .node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper___1l_ka {\n  position: fixed; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--fixed___21A7S.node_modules-grommet-scss-vanilla-___index__grommetux-footer--primary___3jBJD .node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper--fill___3VhxL .node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper___1l_ka {\n  background-color: rgba(255, 255, 255, 0.9); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer--fixed___21A7S.node_modules-grommet-scss-vanilla-___index__grommetux-footer--primary___3jBJD .node_modules-grommet-scss-vanilla-___index__grommetux-footer__content___8nthb {\n  position: static;\n  background-color: transparent; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer__container___3rrvZ {\n  flex-shrink: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer__container--float___3f27T {\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  right: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer__container--fill___oPgyX .node_modules-grommet-scss-vanilla-___index__grommetux-footer_____cz1 {\n  background-color: rgba(255, 255, 255, 0.9); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer__container--fixed___33EOT {\n  position: relative;\n  width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-footer__container--fixed___33EOT .node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper___1l_ka {\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    right: 0px;\n    z-index: 3; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper___1l_ka {\n  height: 36px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper--large___3wuux {\n  height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper--small___2bGk0 {\n  height: 24px; }\n\n*:not(.node_modules-grommet-scss-vanilla-___index__grommetux-footer__container--float___3f27T) > .node_modules-grommet-scss-vanilla-___index__grommetux-footer--float___3XHBn {\n  position: fixed;\n  bottom: 0px;\n  left: 0px;\n  right: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F {\n  position: relative;\n  max-width: 100%; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk .node_modules-grommet-scss-vanilla-___index__grommetux-tiles__container___2GJM- {\n      max-width: 480px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-none___3rCam {\n    padding: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-small___1E9mD {\n      padding: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-medium___3HXQx {\n      padding: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-large___95BWW {\n      padding: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-xlarge___2644j {\n      padding: 192px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-small___1E9mD {\n      padding: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-medium___3HXQx {\n      padding: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-large___95BWW {\n      padding: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-xlarge___2644j {\n      padding: 48px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-none___fxW_E {\n    padding-left: 0px;\n    padding-right: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-small___AWL-u {\n      padding-left: 12px;\n      padding-right: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-medium___20BsG {\n      padding-left: 24px;\n      padding-right: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-large___25SUR {\n      padding-left: 48px;\n      padding-right: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-xlarge___3q-7j {\n      padding-left: 192px;\n      padding-right: 192px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-small___AWL-u {\n      padding-left: 6px;\n      padding-right: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-medium___20BsG {\n      padding-left: 12px;\n      padding-right: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-large___25SUR {\n      padding-left: 24px;\n      padding-right: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-xlarge___3q-7j {\n      padding-left: 48px;\n      padding-right: 48px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-none___1Hg2q {\n    padding-top: 0px;\n    padding-bottom: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-small___ZpdM8 {\n      padding-top: 12px;\n      padding-bottom: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-medium___xChdk {\n      padding-top: 24px;\n      padding-bottom: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-large___1ghzn {\n      padding-top: 48px;\n      padding-bottom: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-xlarge___3kQCl {\n      padding-top: 192px;\n      padding-bottom: 192px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-small___ZpdM8 {\n      padding-top: 6px;\n      padding-bottom: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-medium___xChdk {\n      padding-top: 12px;\n      padding-bottom: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-large___1ghzn {\n      padding-top: 24px;\n      padding-bottom: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-xlarge___3kQCl {\n      padding-top: 48px;\n      padding-bottom: 48px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F > .node_modules-grommet-scss-vanilla-___index__grommetux-header___F29w4 .node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper___2YD-k {\n    background-color: inherit; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F fieldset {\n    min-width: 0;\n    border: none;\n    margin: 0px;\n    margin-bottom: 2rem;\n    margin-top: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F fieldset:first-child {\n      margin-top: 0px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F fieldset:last-child {\n      margin-bottom: 0px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F fieldset > legend {\n      font-size: 24px;\n      font-size: 1.5rem;\n      line-height: 1;\n      font-weight: 500;\n      margin-bottom: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F fieldset > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk) + .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk {\n      margin-top: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F fieldset > .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk + *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk):not(.node_modules-grommet-scss-vanilla-___index__grommetux-form-fields___2X8JP) {\n      margin-top: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F fieldset > .node_modules-grommet-scss-vanilla-___index__grommetux-form-fields___2X8JP {\n      display: flex;\n      flex-direction: row; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F fieldset > .node_modules-grommet-scss-vanilla-___index__grommetux-form-fields___2X8JP .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk {\n        margin-bottom: -1px; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F fieldset > .node_modules-grommet-scss-vanilla-___index__grommetux-form-fields___2X8JP > .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n        flex: 0 0 auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F:not(.node_modules-grommet-scss-vanilla-___index__grommetux-form--plain___3ot7M) {\n  width: 480px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form--fill___3NM0Z {\n  min-width: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form--compact___2jinq {\n  max-width: 288px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk {\n  position: relative;\n  padding: 5px 24px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  margin-bottom: -1px;\n  background-color: #fff;\n  color: #333;\n  opacity: 1; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk {\n      width: 100%;\n      overflow: auto;\n      transition: all 0.4s, padding-top 0.3s 0.1s, padding-bottom 0.3s 0.1s; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk {\n      display: block; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk {\n    background-color: transparent;\n    color: rgba(255, 255, 255, 0.85);\n    border-color: rgba(255, 255, 255, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk {\n    background-color: #fff;\n    color: #333;\n    border-color: rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form--fill___3NM0Z .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk {\n    width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk:last-child {\n    margin-bottom: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field__label___3HAcp {\n  display: block;\n  font-size: 14px;\n  font-size: 0.875rem;\n  line-height: 24px;\n  color: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__label___3HAcp, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__label___3HAcp {\n    color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__label___3HAcp, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__label___3HAcp {\n    color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz {\n  display: block;\n  margin-left: -24px;\n  margin-right: -24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE input {\n    border: none;\n    padding: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm {\n    color: #865CD6;\n    text-decoration: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input:not([type]), .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=text], .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=range], .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=email], .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=tel], .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=url], .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=password], .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=number], .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=file], .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=color], .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > textarea {\n    display: block;\n    width: 100%;\n    border: none;\n    border-radius: 0px;\n    font-size: 16px;\n    font-size: 1rem;\n    line-height: 1.5;\n    padding: 6px 24px 11px;\n    margin-bottom: -5px; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input:not([type]):focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=text]:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=range]:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=email]:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=tel]:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=url]:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=password]:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=number]:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=file]:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=color]:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > textarea:focus {\n      padding: 6px 24px 11px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input:not([type]), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input:not([type]), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=text], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=text], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=range], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=range], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=email], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=email], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=tel], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=tel], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=url], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=url], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=password], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=password], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=number], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=number], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=file], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=file], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=color], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=color], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > textarea, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > textarea {\n      color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input:not([type]), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input:not([type]), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=text], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=text], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=range], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=range], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=email], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=email], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=tel], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=tel], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=url], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=url], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=password], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=password], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=number], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=number], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=file], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=file], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=color], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=color], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > textarea, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > textarea {\n      color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih input, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa input, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po input, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P:not(.node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz) input, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF input {\n    display: block;\n    width: 100%;\n    border: none;\n    border-radius: 0px;\n    font-size: 16px;\n    font-size: 1rem;\n    line-height: 1.5;\n    padding: 6px 24px 11px;\n    margin-bottom: -5px;\n    padding-left: 24px;\n    padding-bottom: 11px; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih input:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa input:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po input:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P:not(.node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz) input:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF input:focus {\n      padding: 6px 24px 11px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P:not(.node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz) input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P:not(.node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz) input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF input {\n      color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P:not(.node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz) input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P:not(.node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz) input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF input, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF input {\n      color: #333; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih input:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa input:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po input:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P:not(.node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz) input:focus, .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF input:focus {\n      padding-bottom: 11px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P:not(.node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz) .node_modules-grommet-scss-vanilla-___index__grommetux-select__value___1DVAG {\n    border: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input:not([type]),\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=text],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=range],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=email],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=tel],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=url],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=password],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=number],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=file],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=color],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih input,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa input,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po input,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-text-input___ZcDLG,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P:not(.node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz) input,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF input {\n    height: 41px; }\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input:not([type]),\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=text],\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=range],\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=email],\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=tel],\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=url],\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=password],\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=number],\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=file],\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=color],\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih input,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa input,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po input,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-text-input___ZcDLG,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P:not(.node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz) input,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF input {\n        line-height: normal; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=range] {\n    width: calc(100% - 48px);\n    margin-left: 24px;\n    margin-right: 24px;\n    padding-left: 0px;\n    padding-right: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input::-ms-clear {\n    display: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select {\n    display: block;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAcBJREFUSA3tUz9IAmEU9+7gNv8MLo7NrXpwYFtLhrQWbQWpoEuRs2MZNYnoUHNES0RNLS0hhxANzkFBLg5Jk4ee/X7iF+d5lyIIBX5wfO99v9/vve/ee5/Pt1iLCvz5CkipVOqu3+8n5nFTSZLuZVVVtxC8MYcEjWAwuCkxcDabXTJN04AZRtazarV6MEtCVOMU1diHtoWLa6VS6VVhIMMwPjVNqwHchhuPxWLv9Xr9mdi0K51O70B/BL6pKMp6uVx+oXaQgAYCviHwB0gb+NaQ8JFnxCatTCazYlnWFXiKLMt7lUrlRmh+EvCAt45GowGYcSRJ6rp+zb8TZLed5e12uw/A/MPyHtt5st2hHYlEDtl9mGH05Tafz/udHOETI4dcaqgVmNjHEhQKBYvdB4GTtdxuty9x5saTiZFDLjXUwh5ZY0KixWLxC1OQhNlCqRLNZvNkRAWHZ8TIIZcaJ4f+SA/shN8my2ti7HphD96BcNx2BsOEnAPj+K2S0+v12FQVE7OLibngmdeamIBC+wMaBpr6Qbr2wHkb+2QB85wYp47+VH9AYi6XC3Q6nSfaoVBI92oq8ZkXHxW/mQP8S+E3ZIDJn85FDg8AAAAASUVORK5CYII=);\n    padding-right: 48px;\n    background-position: center right 18px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select:focus {\n      padding-right: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select _:-moz-tree-row(hover), .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select, .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select:focus {\n      padding-left: 21px; }\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select {\n        padding-left: 22px; }\n        .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select:focus {\n          padding-left: 22px; }\n          .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select:focus option, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select:focus option {\n            color: #333; } }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select {\n      background-position: center left 18px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select {\n      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAASVJREFUSA3tlDGOwjAQRWNKCmoqLpByz0DPFVbcgQ4JiW77LREVNUicg0vsESi2JLwfDcramQQLCWmFsPRDZub/b8ceUxTv8d6Bf78DoaqqFav8eNJKTwOMv8DPEyaQp7yLgq8Ygx04gnmdfOAhrXnIaxxZkCjB3gjTqJgRoJuaVh6lK8kiOUoZgrzFQez+TN+8d3t1yOnYkjiBEVgy4TAl3GKrLY0rjbTRaE0QQrjAuHXWhPcFRi2e5RbUxak7xrSEzWgJVYL4y88anIHuyCdIh3KqibM2Tcrpj1mle3jk73dMv3VTTc26Jm0U8VuIQz/CVJdvBrQdGmqAA9uyqaOeh3sGDv9vZ8nc7RhHl5/iK4bg29DZuvmODhNzXar4P8bhvVbqCvor5P4CpWjxAAAAAElFTkSuQmCC); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select {\n      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAcBJREFUSA3tUz9IAmEU9+7gNv8MLo7NrXpwYFtLhrQWbQWpoEuRs2MZNYnoUHNES0RNLS0hhxANzkFBLg5Jk4ee/X7iF+d5lyIIBX5wfO99v9/vve/ee5/Pt1iLCvz5CkipVOqu3+8n5nFTSZLuZVVVtxC8MYcEjWAwuCkxcDabXTJN04AZRtazarV6MEtCVOMU1diHtoWLa6VS6VVhIMMwPjVNqwHchhuPxWLv9Xr9mdi0K51O70B/BL6pKMp6uVx+oXaQgAYCviHwB0gb+NaQ8JFnxCatTCazYlnWFXiKLMt7lUrlRmh+EvCAt45GowGYcSRJ6rp+zb8TZLed5e12uw/A/MPyHtt5st2hHYlEDtl9mGH05Tafz/udHOETI4dcaqgVmNjHEhQKBYvdB4GTtdxuty9x5saTiZFDLjXUwh5ZY0KixWLxC1OQhNlCqRLNZvNkRAWHZ8TIIZcaJ4f+SA/shN8my2ti7HphD96BcNx2BsOEnAPj+K2S0+v12FQVE7OLibngmdeamIBC+wMaBpr6Qbr2wHkb+2QB85wYp47+VH9AYi6XC3Q6nSfaoVBI92oq8ZkXHxW/mQP8S+E3ZIDJn85FDg8AAAAASUVORK5CYII=); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select::-ms-expand {\n    display: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > select::-ms-value {\n    background: none;\n    color: inherit; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P .node_modules-grommet-scss-vanilla-___index__grommetux-select__options___1kVZk {\n    margin-left: 24px;\n    margin-right: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > textarea {\n    vertical-align: top;\n    height: auto;\n    resize: vertical; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo {\n    display: block;\n    font-size: 16px;\n    font-size: 1rem;\n    line-height: 1.5;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    margin-left: 24px;\n    margin-right: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po {\n    display: block; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih input,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa input,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po input {\n      margin-left: 0px;\n      margin-right: 0px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih .node_modules-grommet-scss-vanilla-___index__grommetux-calendar__control___3kHvh,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa .node_modules-grommet-scss-vanilla-___index__grommetux-calendar__control___3kHvh,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po .node_modules-grommet-scss-vanilla-___index__grommetux-calendar__control___3kHvh,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W {\n      top: auto;\n      right: 6px;\n      transform: none;\n      bottom: 0; }\n      html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw, html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih .node_modules-grommet-scss-vanilla-___index__grommetux-calendar__control___3kHvh, html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W, html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw, html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa .node_modules-grommet-scss-vanilla-___index__grommetux-calendar__control___3kHvh, html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W, html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw, html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po .node_modules-grommet-scss-vanilla-___index__grommetux-calendar__control___3kHvh, html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W {\n        right: auto;\n        left: 6px; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw > .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih .node_modules-grommet-scss-vanilla-___index__grommetux-calendar__control___3kHvh > .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W > .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw > .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa .node_modules-grommet-scss-vanilla-___index__grommetux-calendar__control___3kHvh > .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W > .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw > .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po .node_modules-grommet-scss-vanilla-___index__grommetux-calendar__control___3kHvh > .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po .node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W > .node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz {\n        padding: 9px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-number-input___EFZdZ {\n    display: flex;\n    padding-right: 6px; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-number-input___EFZdZ {\n      padding-right: 0;\n      padding-left: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-number-input___EFZdZ input[type=number] {\n      display: inline-block;\n      flex: 1;\n      flex-basis: inherit;\n      width: 0;\n      border: none;\n      padding: 0 24px; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-number-input___EFZdZ input[type=number]:focus {\n        padding: 0 24px; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form--compact___2jinq .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-number-input___EFZdZ input[type=number] {\n        min-width: 72px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > input[type=file] {\n    display: inline-block; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U {\n    font-size: 16px;\n    font-size: 1rem;\n    line-height: 1.5; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U table {\n      margin-bottom: 0px; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U table td:first-child,\n      .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U table th:first-child {\n        padding-left: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk {\n    width: auto;\n    margin-top: 12px;\n    border: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz > .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk > .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__label___3HAcp {\n      border-top: 1px solid rgba(0, 0, 0, 0.15);\n      padding-top: 5px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents--hidden___OEdNr {\n  margin-top: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field__help___2jbwK {\n  display: block;\n  font-size: 14px;\n  font-size: 0.875rem;\n  line-height: 1.71429;\n  color: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__help___2jbwK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__help___2jbwK {\n    color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__help___2jbwK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__help___2jbwK {\n    color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field__error___3Aj2w {\n  display: block;\n  float: right;\n  color: #FF324D;\n  line-height: 24px; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__error___3Aj2w {\n    float: left; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__error___3Aj2w, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__error___3Aj2w {\n    color: #F59F9F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__error___3Aj2w, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__error___3Aj2w {\n    color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field--text___jgHku {\n  cursor: pointer; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--text___jgHku .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__label___3HAcp {\n    cursor: pointer; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--hidden___22zPW {\n    display: none; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--hidden___22zPW {\n    border: none;\n    margin-bottom: 0px;\n    padding-top: 0px;\n    padding-bottom: 0px;\n    opacity: 0;\n    overflow: hidden;\n    max-height: 0px;\n    transition: max-height 0.2s, all 0.4s; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field--error___3bwJc {\n  z-index: 1;\n  border-color: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--error___3bwJc, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--error___3bwJc {\n    border-color: #F59F9F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--error___3bwJc, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--error___3bwJc {\n    border-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field--focus___2_KP1 {\n  z-index: 2;\n  border-color: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--focus___2_KP1, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--focus___2_KP1 {\n    border-color: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--focus___2_KP1, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--focus___2_KP1 {\n    border-color: #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field--size-large___nNmHG {\n  font-size: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--size-large___nNmHG input:not([type]),\n  .node_modules-grommet-scss-vanilla-___index__grommetux-form-field--size-large___nNmHG input[type=\"text\"] {\n    font-size: 24px;\n    height: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field--strong___UmACo input:not([type]),\n.node_modules-grommet-scss-vanilla-___index__grommetux-form-field--strong___UmACo input[type=\"text\"] {\n  font-weight: 500; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header___F29w4 {\n  min-height: 72px;\n  width: 100%;\n  margin-bottom: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-header___F29w4 .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d {\n    flex-grow: 0;\n    flex-shrink: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header--large___27UBX {\n  min-height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header--small___1qqdQ {\n  min-height: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header--splash___1vlO4 {\n  -webkit-transform: translate(0, 40vh);\n  transform: translate(0, 40vh); }\n\n*:not(.node_modules-grommet-scss-vanilla-___index__grommetux-header__container--float___3JhOu)\n> header.node_modules-grommet-scss-vanilla-___index__grommetux-header--float___-4Khg {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px; }\n\nheader.node_modules-grommet-scss-vanilla-___index__grommetux-header--primary___39fdg .node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper___2YD-k {\n  border-bottom: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header___F29w4:not(header).node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-top___2x5Mu {\n  padding-top: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header___F29w4:not(header).node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-bottom___3FHY5 {\n  padding-bottom: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header__container___194aV {\n  flex-shrink: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header__container--fill___1WHxI .node_modules-grommet-scss-vanilla-___index__grommetux-header___F29w4 {\n  background-color: rgba(255, 255, 255, 0.9); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header__container--fixed___7UzOL {\n  position: relative; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-header__container--fixed___7UzOL .node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper___2YD-k {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    z-index: 50; }\n    @media screen and (min-width: 45em) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-header__container--fixed___7UzOL .node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper___2YD-k .node_modules-grommet-scss-vanilla-___index__grommetux-header___F29w4 {\n        position: fixed; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header__container--float___3JhOu {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper___2YD-k {\n  height: 72px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper--large___2L9V4 {\n  height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper--small___26cYH {\n  height: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header--fixed___3i1i2 .node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper___2YD-k {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  background-color: rgba(255, 255, 255, 0.9);\n  z-index: 3; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header--fixed___3i1i2.node_modules-grommet-scss-vanilla-___index__grommetux-header--primary___39fdg .node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper___2YD-k {\n  position: fixed;\n  background-color: rgba(255, 255, 255, 0.9); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header--fixed___3i1i2.node_modules-grommet-scss-vanilla-___index__grommetux-header--primary___39fdg .node_modules-grommet-scss-vanilla-___index__grommetux-header__content___35ybf {\n  position: static;\n  background-color: transparent; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-header--flush___2CbB4 .node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper___2YD-k {\n  padding-left: 0px;\n  padding-right: 0px; }\n\n@media screen and (min-width: 45em) {\n  h1.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT {\n    font-size: 48px;\n    font-size: 3rem;\n    line-height: 1.125; } }\n\n@media screen and (max-width: 44.9375em) {\n  h1.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT {\n    font-size: 36px;\n    font-size: 2.25rem;\n    line-height: 1.125; } }\n\n@media screen and (min-width: 45em) {\n  h2.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT {\n    font-size: 36px;\n    font-size: 2.25rem;\n    line-height: 1.23; } }\n\n@media screen and (max-width: 44.9375em) {\n  h2.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT {\n    font-size: 30px;\n    font-size: 1.875rem;\n    line-height: 1.23; } }\n\nh3.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT {\n  font-size: 24px;\n  line-height: 1.333; }\n\nh4.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT {\n  font-size: 18px;\n  line-height: 1.333; }\n\nh5.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT {\n  font-size: 16px;\n  line-height: 1.375; }\n\nh6.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT {\n  font-size: 16px;\n  line-height: 1.375; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT {\n  font-weight: 300;\n  max-width: 100%;\n  margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT a,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm {\n    color: inherit;\n    text-decoration: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT a:hover,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover {\n      text-decoration: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-heading--align-start___IYsMv {\n    text-align: left; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-heading--align-start___IYsMv {\n      text-align: right; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-heading--align-center___32rvm {\n    text-align: center; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-heading--align-end___3EW0W {\n    text-align: right; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-heading--align-end___3EW0W {\n      text-align: left; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-heading--margin-none___l0t28 {\n    margin-top: 0;\n    margin-bottom: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-heading--margin-small___3qe0L {\n    margin-top: 12px;\n    margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-heading--margin-medium___35-l2 {\n    margin-top: 24px;\n    margin-bottom: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-heading--margin-large___1nzBv {\n    margin-top: 48px;\n    margin-bottom: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-heading--large___3bytz {\n  font-size: 125%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-heading--small___3H-B6 {\n  font-size: 75%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-heading--strong___3a6WE {\n  font-weight: 500; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-heading--truncate___32uam {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-heading--uppercase___3OXE7 {\n  text-transform: uppercase;\n  letter-spacing: 0.2em; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-headline___3pLlj {\n  font-weight: 300;\n  margin-bottom: 24px;\n  max-width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--align-start___38SEx {\n    text-align: left; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-headline--align-start___38SEx {\n      text-align: right; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--align-center___35vEN {\n    text-align: center; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--align-end___2r1_h {\n    text-align: right; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-headline--align-end___2r1_h {\n      text-align: left; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--margin-none___3XGED {\n    margin-top: 0;\n    margin-bottom: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--margin-small___2CIZF {\n    margin-top: 12px;\n    margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--margin-medium___3M_1l {\n    margin-top: 24px;\n    margin-bottom: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--margin-large___3g9fQ {\n    margin-top: 48px;\n    margin-bottom: 48px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-headline___3pLlj {\n      font-size: 64px;\n      font-size: 4rem;\n      line-height: 1; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-headline___3pLlj {\n      font-size: 48px;\n      font-size: 3rem;\n      line-height: 1; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-headline--small___1XIAu {\n  font-size: 30px;\n  font-size: 1.875rem;\n  line-height: 1; }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--large___7txJD {\n    font-size: 96px;\n    font-size: 6rem;\n    line-height: 1; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--large___7txJD {\n    font-size: 60px;\n    font-size: 3.75rem;\n    line-height: 1; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--xlarge___8BfrX {\n    font-size: 192px;\n    font-size: 12rem;\n    line-height: 1; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-headline--xlarge___8BfrX {\n    font-size: 72px;\n    font-size: 4.5rem;\n    line-height: 1; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-headline--strong___2pnqb {\n  font-weight: 500; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S:not(.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q) {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  align-items: center; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S:not(.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q) .node_modules-grommet-scss-vanilla-___index__grommetux-hero__background___85MvL {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S:not(.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q) .node_modules-grommet-scss-vanilla-___index__grommetux-hero__foreground___1RmP6 {\n    z-index: 1;\n    flex: 1 1; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S:not(.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q).node_modules-grommet-scss-vanilla-___index__grommetux-hero--small___2Z0VD {\n    min-height: 40vh; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S:not(.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q).node_modules-grommet-scss-vanilla-___index__grommetux-hero--small___2Z0VD .node_modules-grommet-scss-vanilla-___index__grommetux-hero__overlay___2N-M9.node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE {\n      height: 60vh; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S:not(.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q).node_modules-grommet-scss-vanilla-___index__grommetux-hero--medium___338vO {\n    min-height: 60vh; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S:not(.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q).node_modules-grommet-scss-vanilla-___index__grommetux-hero--large___3UgnU {\n    min-height: 75vh; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S:not(.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q).node_modules-grommet-scss-vanilla-___index__grommetux-hero--large___3UgnU .node_modules-grommet-scss-vanilla-___index__grommetux-hero__overlay___2N-M9.node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE {\n      height: 75vh; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q .node_modules-grommet-scss-vanilla-___index__grommetux-hero__background___85MvL {\n  position: relative;\n  overflow: hidden; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q .node_modules-grommet-scss-vanilla-___index__grommetux-hero--small___2Z0VD .node_modules-grommet-scss-vanilla-___index__grommetux-hero__background___85MvL {\n  height: 20vh; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q .node_modules-grommet-scss-vanilla-___index__grommetux-hero--small___2Z0VD .node_modules-grommet-scss-vanilla-___index__grommetux-hero__image___1pABM {\n  height: 270px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q.node_modules-grommet-scss-vanilla-___index__grommetux-hero--medium___338vO .node_modules-grommet-scss-vanilla-___index__grommetux-hero__background___85MvL {\n  height: 40vh; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q.node_modules-grommet-scss-vanilla-___index__grommetux-hero--large___3UgnU .node_modules-grommet-scss-vanilla-___index__grommetux-hero__background___85MvL {\n  height: 60vh; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S.node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q.node_modules-grommet-scss-vanilla-___index__grommetux-hero--large___3UgnU .node_modules-grommet-scss-vanilla-___index__grommetux-hero__image___1pABM {\n  height: 300px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-hero__background-video___1CTDE {\n  overflow: hidden; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-hero__background-video___1CTDE .node_modules-grommet-scss-vanilla-___index__grommetux-video___38nQp {\n    min-height: 100%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 50%;\n    transform: translate(0%, -50%); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-hero__background-video___1CTDE .node_modules-grommet-scss-vanilla-___index__grommetux-video___38nQp::before {\n      content: \"\";\n      display: block;\n      height: 0px;\n      padding-bottom: 57%; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-hero__background-video___1CTDE .node_modules-grommet-scss-vanilla-___index__grommetux-video___38nQp video {\n      width: auto;\n      height: 100%;\n      position: absolute;\n      top: 0px;\n      left: 50%;\n      transform: translate(-50%, 0%); }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-hero--bg-left___18ru6 > .node_modules-grommet-scss-vanilla-___index__grommetux-hero__background___85MvL {\n    background-position: top left; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-hero--bg-right___3IaQH > .node_modules-grommet-scss-vanilla-___index__grommetux-hero__background___85MvL {\n    background-position: top right; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-hero__overlay___2N-M9.node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE {\n  z-index: 1; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-hero__overlay___2N-M9.node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE > .node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE {\n    width: 50%; }\n    @media screen and (max-width: 44.9375em) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-hero__overlay___2N-M9.node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE > .node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE {\n        width: 100%; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-hero--mobile-separator___3Q2vl {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    margin-bottom: 24px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  fill: #666;\n  stroke: #666;\n  flex: 0 0 auto; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n g {\n    fill: inherit; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:not([class*=\"color-index-plain\"]) *:not([stroke])[fill=\"none\"] {\n    stroke-width: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:not([class*=\"color-index-plain\"]) *[stroke*=\"#\"],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:not([class*=\"color-index-plain\"]) *[STROKE*=\"#\"] {\n    stroke: inherit; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:not([class*=\"color-index-plain\"]) *[fill*=\"#\"],\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:not([class*=\"color-index-plain\"]) *[FILL*=\"#\"] {\n    fill: inherit; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:not([class*=\"color-index-plain\"]) *[fill-rule] {\n    stroke: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: rgba(255, 255, 255, 0.7);\n    stroke: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    fill: #666;\n    stroke: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n    stroke: #ddd;\n    stroke-dasharray: 1px 10px;\n    stroke-dashoffset: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    stroke: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    stroke: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    stroke: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    stroke: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    stroke: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n    stroke: #ffffff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n    stroke: #f5f5f5; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    fill: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    fill: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    fill: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    fill: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    fill: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    fill: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    fill: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    fill: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    fill: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    fill: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    fill: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    fill: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    fill: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    fill: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    fill: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    fill: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    fill: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    fill: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    fill: #666666; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n      transition: all 0.3s ease-in-out; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon__badge___WgYB3 circle {\n  fill: #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon__badge___WgYB3 text {\n  stroke: #333;\n  fill: #333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--active___3xE5F {\n  fill: #000;\n  stroke: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--xsmall___3IpgX {\n  width: 12px;\n  height: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--medium___23KgX {\n  width: 36px;\n  height: 36px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--large___1zw-Q {\n  width: 48px;\n  height: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--xlarge___3xXFU {\n  width: 144px;\n  height: 144px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--huge___2vPll {\n  width: 288px;\n  height: 288px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--responsive___3md8P.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--large___1zw-Q, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--responsive___3md8P.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--xlarge___3xXFU, .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--responsive___3md8P.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--huge___2vPll {\n    width: 24px;\n    height: 24px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d {\n  width: 24px;\n  height: 24px;\n  vertical-align: middle;\n  flex: 0 0 auto; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR {\n    fill: #a8a8a8; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR {\n      fill: icon-color(rgba(255, 255, 255, 0.9)); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    fill: #fff;\n    stroke: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4 {\n    display: none;\n    stroke: #a8a8a8; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4 {\n      stroke: rgba(255, 255, 255, 0.9); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-label___rFSSf .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR {\n  fill: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-unknown___1Kd1s .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n  fill: #a8a8a8;\n  stroke: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--xsmall___3XqIO {\n  width: 12px;\n  height: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--medium___ultiC {\n  width: 36px;\n  height: 36px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--large___2QMr9 {\n  width: 48px;\n  height: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--xlarge___16jaa {\n  width: 144px;\n  height: 144px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--huge___8wf_p {\n  width: 288px;\n  height: 288px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--small___1kufL {\n  width: 12px;\n  height: 12px;\n  margin-top: 6px;\n  margin-bottom: 6px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--small___1kufL .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR {\n    mask: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--small___1kufL .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--small___1kufL .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__normal___1g9jn {\n    display: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--small___1kufL .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4 {\n    display: block; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-critical___1cJmz .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR {\n  fill: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-error___39azH .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR {\n  fill: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-warning___2dBjH .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR {\n  fill: #FFD602; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-ok___e9-5k .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR {\n  fill: #8CC800; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-unknown___1Kd1s .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR {\n  fill: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-disabled___169fw .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR {\n  fill: #a8a8a8; }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__drawAndReverse___2I5Cc {\n  0% {\n    stroke-dashoffset: 151px; }\n  100% {\n    stroke-dashoffset: -131px; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__drawAndReverse___2I5Cc {\n  0% {\n    stroke-dashoffset: 151px; }\n  100% {\n    stroke-dashoffset: -131px; } }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__fadeOut___2c-WD {\n  0% {\n    opacity: 1;\n    transform: rotate(0deg); }\n  50% {\n    opacity: 0.75; }\n  100% {\n    opacity: 1;\n    transform: rotate(360deg); } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__fadeOut___2c-WD {\n  0% {\n    opacity: 1;\n    transform: rotate(0deg); }\n  50% {\n    opacity: 0.75; }\n  100% {\n    opacity: 1;\n    transform: rotate(360deg); } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning___2isNw {\n  width: 24px;\n  height: 24px;\n  stroke-dasharray: 151px 151px;\n  stroke-dashoffset: 0;\n  transform: rotate(90deg);\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__drawAndReverse___2I5Cc 4s alternate infinite ease-in-out;\n  animation: node_modules-grommet-scss-vanilla-___index__drawAndReverse___2I5Cc 4s alternate infinite ease-in-out; }\n  @media all and (-ms-high-contrast: none) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning___2isNw {\n      transform: rotate(0deg);\n      stroke-dashoffset: 50;\n      -webkit-animation: node_modules-grommet-scss-vanilla-___index__fadeOut___2c-WD 3s infinite linear;\n      animation: node_modules-grommet-scss-vanilla-___index__fadeOut___2c-WD 3s infinite linear; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--xsmall___3Ocep {\n  width: 12px;\n  height: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--medium___2AYWn {\n  width: 36px;\n  height: 36px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--large___2pmkD {\n  width: 48px;\n  height: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--xlarge___3jj9y {\n  width: 144px;\n  height: 144px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--huge___1NPFU {\n  width: 288px;\n  height: 288px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--xlarge___3jj9y.node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--responsive___PNiEm,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--huge___1NPFU.node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--responsive___PNiEm {\n    width: 48px;\n    height: 48px; } }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__draw-logo___2J-FX {\n  0% {\n    stroke-dashoffset: 768px; }\n  100% {\n    stroke-dashoffset: 0; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__draw-logo___2J-FX {\n  0% {\n    stroke-dashoffset: 768px; }\n  100% {\n    stroke-dashoffset: 0; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C {\n  width: 48px;\n  height: 48px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n    stroke: #ddd;\n    stroke-dasharray: 1px 10px;\n    stroke-dashoffset: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    stroke: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    stroke: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    stroke: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    stroke: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    stroke: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n    stroke: #ffffff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n    stroke: #f5f5f5; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C path {\n      stroke-dasharray: 768px 768px;\n      stroke-dashoffset: 0;\n      -webkit-animation: node_modules-grommet-scss-vanilla-___index__draw-logo___2J-FX 2.5s linear;\n      animation: node_modules-grommet-scss-vanilla-___index__draw-logo___2J-FX 2.5s linear; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon--small___33SCK {\n  width: 24px;\n  height: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon--large___2i7_R {\n  width: 96px;\n  height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon--xlarge___wRFtW {\n  width: 192px;\n  height: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon--huge___1Rf0V {\n  width: 384px;\n  height: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__right-left-icon--left___2hCmH {\n  display: none; }\n\nhtml.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__right-left-icon--left___2hCmH {\n  display: inline; }\n\nhtml.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__right-left-icon--right___3kNKl {\n  display: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image___1f8vj {\n  max-width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--small___PAmYJ {\n  width: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--medium___1NZgG {\n  width: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--large___3Y0kY {\n  width: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--thumb___1qz5n {\n  width: 48px;\n  height: 48px;\n  flex: 0 0 auto;\n  object-fit: cover; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--thumb___1qz5n.node_modules-grommet-scss-vanilla-___index__grommetux-image--mask___1019u {\n    border-radius: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--cover___2zU76 {\n  object-fit: cover; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--contain___2vCHM {\n  object-fit: contain; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--full___3bOuo {\n  width: 100%;\n  height: 100%;\n  min-width: 100%;\n  min-height: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx {\n  object-position: 0 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD {\n  object-position: 100% 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD) {\n  object-position: 50% 0%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx {\n  object-position: 0 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD {\n  object-position: 100% 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD) {\n  object-position: 50% 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH) {\n  object-position: 0 50%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH) {\n  object-position: 100% 50%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--full-horizontal___n9QQg {\n  width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image--full-vertical___DslAF {\n  height: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image__container___kadMs {\n  display: flex;\n  flex-direction: column; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image__caption___7uBOP {\n  text-align: center;\n  padding: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image__caption--small___3dPin {\n  max-width: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image__caption--medium___16-3h {\n  max-width: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-image__caption--large___8E0jm {\n  max-width: 576px; }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--full___3bOuo {\n    width: auto;\n    height: auto;\n    max-width: none;\n    position: relative;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx {\n    top: 0%;\n    left: 0%;\n    transform: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD {\n    top: 0%;\n    left: 100%;\n    transform: translate(-100%, 0%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD) {\n    top: 0%;\n    left: 50%;\n    transform: translateX(-50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx {\n    top: 100%;\n    left: 0%;\n    transform: translate(0%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD {\n    top: 100%;\n    left: 100%;\n    transform: translate(-100%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD) {\n    top: 100%;\n    left: 50%;\n    transform: translate(-50%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH) {\n    top: 50%;\n    left: 0%;\n    transform: translate(0%, -50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH) {\n    top: 50%;\n    left: 100%;\n    transform: translate(-100%, -50%); } }\n\n@supports (-ms-ime-align: auto) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--full___3bOuo {\n    width: auto;\n    height: auto;\n    max-width: none;\n    position: relative;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx {\n    top: 0%;\n    left: 0%;\n    transform: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD {\n    top: 0%;\n    left: 100%;\n    transform: translate(-100%, 0%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD) {\n    top: 0%;\n    left: 50%;\n    transform: translateX(-50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx {\n    top: 100%;\n    left: 0%;\n    transform: translate(0%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD {\n    top: 100%;\n    left: 100%;\n    transform: translate(-100%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD) {\n    top: 100%;\n    left: 50%;\n    transform: translate(-50%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH) {\n    top: 50%;\n    left: 0%;\n    transform: translate(0%, -50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD:not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-):not(.node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH) {\n    top: 50%;\n    left: 100%;\n    transform: translate(-100%, -50%); } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-label___2stWG {\n  font-size: 19px;\n  font-size: 1.1875rem;\n  line-height: 1.26316;\n  font-weight: 300;\n  cursor: inherit; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-label--align-start___28GV7 {\n    text-align: left; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-label--align-start___28GV7 {\n      text-align: right; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-label--align-center___3x1AZ {\n    text-align: center; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-label--align-end___Smmys {\n    text-align: right; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-label--align-end___Smmys {\n      text-align: left; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-label--margin-none___1scLk {\n    margin-top: 0;\n    margin-bottom: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-label--margin-small___kWhb6 {\n    margin-top: 12px;\n    margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-label--margin-medium___4P0LZ {\n    margin-top: 24px;\n    margin-bottom: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-label--margin-large___2QmVC {\n    margin-top: 48px;\n    margin-bottom: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-label--truncate___12JAL {\n  display: inline-block;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-label--uppercase___vu3Ju {\n  text-transform: uppercase;\n  letter-spacing: 0.2em; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-label--small___1lMD3 {\n  font-size: 14px;\n  font-size: 0.875rem;\n  line-height: 1.71429;\n  color: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-label--small___1lMD3, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-label--small___1lMD3 {\n    color: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-label--small___1lMD3, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-label--small___1lMD3 {\n    color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-label--large___N018x {\n  font-size: 24px;\n  font-size: 1.5rem;\n  line-height: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1 {\n  position: relative;\n  z-index: 10;\n  background-color: rgba(0, 0, 0, 0.5);\n  height: 100vh;\n  overflow: auto; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1 {\n      position: fixed;\n      top: 0px;\n      left: 0px;\n      right: 0px;\n      bottom: 0px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) + .node_modules-grommet-scss-vanilla-___index__grommetux-app___1JU9n {\n      left: -100%;\n      right: 100%;\n      z-index: -1;\n      position: fixed; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1 .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n    display: flex;\n    flex-direction: column;\n    background-color: #fff; }\n    @media screen and (max-width: 44.9375em) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1 .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n        padding: 0 24px;\n        min-height: 100%;\n        min-width: 100%; } }\n    @media screen and (min-width: 45em) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1 .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n        position: absolute;\n        max-height: 100%;\n        max-width: 100%;\n        overflow: auto;\n        padding: 0 48px;\n        border-radius: 4px;\n        box-shadow: none; } }\n  @media screen and (min-width: 45em) and (-ms-high-contrast: active), screen and (min-width: 45em) and (-ms-high-contrast: none) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1 .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F {\n      max-width: 100vw; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1 .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr .node_modules-grommet-scss-vanilla-___index__grommetux-sidebar___2SHOE .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F {\n      max-width: 100%; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1 .node_modules-grommet-scss-vanilla-___index__grommetux-layer__closer___Ddlw4 {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    z-index: 1; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1 .node_modules-grommet-scss-vanilla-___index__grommetux-layer__closer___Ddlw4 {\n      right: auto;\n      left: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1.node_modules-grommet-scss-vanilla-___index__grommetux-layer--flush___1EB7i .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n  padding: 0px; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1.node_modules-grommet-scss-vanilla-___index__grommetux-layer--flush___1EB7i .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F {\n      max-width: 100vw; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1.node_modules-grommet-scss-vanilla-___index__grommetux-layer--flush___1EB7i .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr .node_modules-grommet-scss-vanilla-___index__grommetux-sidebar___2SHOE .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F {\n      max-width: 100%; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-center___2qK1s:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n    bottom: 50%;\n    right: 50%;\n    max-height: calc(100vh - 48px);\n    max-width: calc(100vw - 48px);\n    transform: translate(50%, 50%); } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-left___8XRVq:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n  top: 0px;\n  bottom: 0px;\n  left: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-left___8XRVq:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n      -webkit-animation: node_modules-grommet-scss-vanilla-___index__slide-right___3VEY_ 0.2s ease-in-out forwards;\n      animation: node_modules-grommet-scss-vanilla-___index__slide-right___3VEY_ 0.2s ease-in-out forwards; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-left___8XRVq:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n  left: auto;\n  right: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-left___8XRVq:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n      -webkit-animation: node_modules-grommet-scss-vanilla-___index__slide-left___2XiLT 0.2s ease-in-out forwards;\n      animation: node_modules-grommet-scss-vanilla-___index__slide-left___2XiLT 0.2s ease-in-out forwards; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-right___2wApr:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n  top: 0px;\n  bottom: 0px;\n  right: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-right___2wApr:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n      -webkit-animation: node_modules-grommet-scss-vanilla-___index__slide-left___2XiLT 0.2s ease-in-out forwards;\n      animation: node_modules-grommet-scss-vanilla-___index__slide-left___2XiLT 0.2s ease-in-out forwards; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-right___2wApr:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n  right: auto;\n  left: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-right___2wApr:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n      -webkit-animation: node_modules-grommet-scss-vanilla-___index__slide-right___3VEY_ 0.2s ease-in-out forwards;\n      animation: node_modules-grommet-scss-vanilla-___index__slide-right___3VEY_ 0.2s ease-in-out forwards; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-top___2KGI0:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n    left: 50%;\n    transform: translateX(-50%); } }\n  @media screen and (min-width: 45em) and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-top___2KGI0:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n      -webkit-animation: node_modules-grommet-scss-vanilla-___index__slide-down___1vw72 0.2s ease-in-out forwards;\n      animation: node_modules-grommet-scss-vanilla-___index__slide-down___1vw72 0.2s ease-in-out forwards; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-bottom___tmVQ2:not(.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP) .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n  bottom: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP {\n  left: -100%;\n  right: 100%;\n  z-index: -1;\n  position: fixed; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP.node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-left___8XRVq {\n    right: auto; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP.node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-left___8XRVq .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n      left: -100vw; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP.node_modules-grommet-scss-vanilla-___index__grommetux-layer--peek___21KBr {\n      left: 0;\n      z-index: 10; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP.node_modules-grommet-scss-vanilla-___index__grommetux-layer--peek___21KBr.node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-left___8XRVq {\n        right: auto; }\n        .node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1.node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP.node_modules-grommet-scss-vanilla-___index__grommetux-layer--peek___21KBr.node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-left___8XRVq .node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr {\n          left: auto;\n          right: -12px;\n          border-right: 10px solid #865CD6;\n          -webkit-animation: node_modules-grommet-scss-vanilla-___index__peek-right___34ej9 0.5s ease-in-out alternate 5;\n          animation: node_modules-grommet-scss-vanilla-___index__peek-right___34ej9 0.5s ease-in-out alternate 5; } }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__peek-right___34ej9 {\n  0% {\n    right: -6px; }\n  100% {\n    right: -12px; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__peek-right___34ej9 {\n  0% {\n    right: -6px; }\n  100% {\n    right: -12px; } }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__slide-right___3VEY_ {\n  0% {\n    left: -100%; }\n  100% {\n    left: 0px; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__slide-right___3VEY_ {\n  0% {\n    left: -100%; }\n  100% {\n    left: 0px; } }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__slide-left___2XiLT {\n  0% {\n    right: -100%; }\n  100% {\n    right: 0px; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__slide-left___2XiLT {\n  0% {\n    right: -100%; }\n  100% {\n    right: 0px; } }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__slide-down___1vw72 {\n  0% {\n    top: -100vh; }\n  100% {\n    top: 0px; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__slide-down___1vw72 {\n  0% {\n    top: -100vh; }\n  100% {\n    top: 0px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list___2Cnvm {\n  list-style-type: none;\n  margin: 0px;\n  padding: 0px;\n  overflow: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list--focus___2zVdA {\n  border-color: #00CCEB;\n  box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list__more___3Cur2,\n.node_modules-grommet-scss-vanilla-___index__grommetux-list__empty___3r0Rp {\n  padding-left: 24px;\n  padding-right: 24px;\n  padding-top: 12px;\n  padding-bottom: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list__empty___3r0Rp {\n  color: #666;\n  font-style: italic; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list-item___3Fww8 {\n  max-width: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list-item___3Fww8:focus {\n  outline: #00CCEB solid 1px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list-item__image___365Q6 {\n  height: 24px;\n  width: 24px;\n  margin-right: 24px;\n  overflow: hidden;\n  flex: 0 0 auto; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-list-item__image___365Q6 img {\n    height: 100%;\n    width: 100%;\n    max-width: none;\n    object-fit: cover; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list-item__label___1Tn9S,\n.node_modules-grommet-scss-vanilla-___index__grommetux-list-item__annotation___1pg7C {\n  flex: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list-item__annotation___1pg7C {\n  margin-left: 24px;\n  color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list-item--selectable___2n1bZ {\n  cursor: pointer;\n  outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-list-item--selectable___2n1bZ:hover {\n    background-color: rgba(221, 221, 221, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list-item--selected___1S_oL {\n  background-color: #ccbaee;\n  color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-list-item--selected___1S_oL, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-list-item--selected___1S_oL {\n    background-color: rgba(0, 0, 0, 0.15);\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-list-item--selected___1S_oL, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-list-item--selected___1S_oL {\n    background-color: #ccbaee;\n    color: #333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list-item--row___1g7jS .node_modules-grommet-scss-vanilla-___index__grommetux-list-item__annotation___1pg7C {\n  text-align: right; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 {\n  outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item___3Fww8 {\n    cursor: pointer;\n    outline: none;\n    transition: background-color 0.2s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item--active___1JqAJ,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item___3Fww8:hover {\n    background-color: rgba(221, 221, 221, 0.5);\n    color: #000; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item--active___1JqAJ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item--active___1JqAJ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n    .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item___3Fww8:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n    .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item___3Fww8:hover {\n      background-color: rgba(0, 0, 0, 0.1);\n      color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item--active___1JqAJ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item--active___1JqAJ, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n    .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item___3Fww8:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n    .node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23 .node_modules-grommet-scss-vanilla-___index__grommetux-list-item___3Fww8:hover {\n      background-color: rgba(221, 221, 221, 0.5);\n      color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list--small___Koj0A .node_modules-grommet-scss-vanilla-___index__grommetux-list-item__image___365Q6,\n.node_modules-grommet-scss-vanilla-___index__grommetux-list--small___Koj0A .node_modules-grommet-scss-vanilla-___index__grommetux-list__more__image___D30RV {\n  height: 12px;\n  width: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-list--large___3ywuF .node_modules-grommet-scss-vanilla-___index__grommetux-list-item__image___365Q6,\n.node_modules-grommet-scss-vanilla-___index__grommetux-list--large___3ywuF .node_modules-grommet-scss-vanilla-___index__grommetux-list__more__image___D30RV {\n  height: 48px;\n  width: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend___2kLZW {\n  text-align: left;\n  white-space: normal;\n  display: inline-block;\n  line-height: 24px; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-legend___2kLZW {\n    text-align: right; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend__item___3MdJn,\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf {\n  color: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item___3MdJn, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item___3MdJn, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf {\n    color: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item___3MdJn, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item___3MdJn, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf {\n    color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-label___T3qcj {\n  margin-right: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-units___boNim,\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend__total-units___2GOMm {\n  display: inline-block;\n  margin-left: 6px; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-units___boNim, html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total-units___2GOMm {\n    margin-left: 0;\n    margin-right: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je {\n  width: 12px;\n  height: 12px;\n  margin-right: 12px;\n  overflow: visible; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n    stroke: #ddd;\n    stroke-dasharray: 1px 10px;\n    stroke-dashoffset: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    stroke: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    stroke: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    stroke: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    stroke: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    stroke: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n    stroke: #ffffff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n    stroke: #f5f5f5; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je {\n    margin-right: 0;\n    margin-left: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je path {\n    stroke-width: 12px;\n    transition-property: stroke-width;\n    transition-duration: 0.3s;\n    transition-timing-function: ease-in-out; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend__item--clickable___1Ljvr {\n  cursor: pointer; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend__item--active___eW0wv {\n  color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item--active___eW0wv svg.node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je path {\n    stroke-width: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item--active___eW0wv, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item--active___eW0wv {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item--active___eW0wv, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item--active___eW0wv {\n    color: #333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf {\n  margin-left: 24px;\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px dotted rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf {\n    border-color: rgba(255, 255, 255, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf {\n    border-color: rgba(0, 0, 0, 0.15); }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf {\n    margin-left: 0;\n    margin-right: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-legend--large___ZoTSv {\n  font-size: 24px;\n  line-height: 32px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend--large___ZoTSv .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item___3MdJn {\n    margin-bottom: 6px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend--large___ZoTSv .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-label___T3qcj {\n    margin-right: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend--large___ZoTSv .node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je {\n    position: relative;\n    top: 3px;\n    width: 24px;\n    height: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-legend--large___ZoTSv .node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf {\n    margin-left: 36px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map___3zAdz {\n  position: relative;\n  z-index: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map__links___5-1SW {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: -1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG {\n  stroke-width: 2px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n    stroke: #ddd;\n    stroke-dasharray: 1px 10px;\n    stroke-dashoffset: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    stroke: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    stroke: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    stroke: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    stroke: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    stroke: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n    stroke: #ffffff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n    stroke: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map__path--active___3aTFo {\n  stroke-width: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map__categories___IlfGJ {\n  margin: 0px;\n  list-style-type: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map__category___lX00n {\n  position: relative;\n  margin-bottom: 12px;\n  max-width: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map__category-label___2tMug {\n  font-size: 14px;\n  font-size: 0.875rem;\n  line-height: 1.71429;\n  margin-bottom: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map__category-items___13JrM {\n  margin: 0px;\n  list-style-type: none;\n  overflow: hidden;\n  text-align: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map__item___3x-SF {\n  display: inline-block;\n  margin-right: 12px;\n  margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-map__item___3x-SF, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-map__item___3x-SF {\n    color: #333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map__item___3x-SF:not(.node_modules-grommet-scss-vanilla-___index__grommetux-map__item--plain___2gcMI) {\n  width: 192px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  padding: 6px 12px;\n  background-color: #fff;\n  font-size: 16px;\n  font-size: 1rem;\n  line-height: 1.5; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__item___3x-SF:not(.node_modules-grommet-scss-vanilla-___index__grommetux-map__item--plain___2gcMI) > a {\n    display: block;\n    padding: 6px 12px;\n    transition: background-color 0.2s; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-map__item___3x-SF:not(.node_modules-grommet-scss-vanilla-___index__grommetux-map__item--plain___2gcMI) > a > * {\n      display: inline-block; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-map__item___3x-SF:not(.node_modules-grommet-scss-vanilla-___index__grommetux-map__item--plain___2gcMI) > a:hover {\n      background-color: rgba(221, 221, 221, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-map__item___3x-SF:not(.node_modules-grommet-scss-vanilla-___index__grommetux-map__item--plain___2gcMI) .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d {\n    margin-right: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map__item--active___QbX6L:not(.node_modules-grommet-scss-vanilla-___index__grommetux-map__item--plain___2gcMI) {\n  border-color: #000;\n  border-width: 2px;\n  padding: 5px 11px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map--vertical___1qq6o .node_modules-grommet-scss-vanilla-___index__grommetux-map__categories___IlfGJ {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: wrap; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map--vertical___1qq6o .node_modules-grommet-scss-vanilla-___index__grommetux-map__category-items___13JrM {\n  text-align: left; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-map--vertical___1qq6o .node_modules-grommet-scss-vanilla-___index__grommetux-map__item___3x-SF {\n  display: block;\n  margin-right: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG {\n  position: relative;\n  white-space: nowrap;\n  font-size: 19px;\n  font-size: 1.1875rem;\n  line-height: 1.26316; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG > * {\n    flex: 0 0 auto; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb),\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm {\n    text-decoration: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover {\n      text-decoration: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG.node_modules-grommet-scss-vanilla-___index__grommetux-menu--controlled___3vAVY {\n    display: inline-block;\n    cursor: pointer; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--fill___27KGq {\n  flex: 1 1 auto;\n  overflow: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__control___3TLvb .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-down___2QH2l {\n  width: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__control___3TLvb .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-down___2QH2l path,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__control___3TLvb .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-down___2QH2l polyline {\n    stroke-width: 4px; }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__control___3TLvb.node_modules-grommet-scss-vanilla-___index__grommetux-menu--labelled___3__-P {\n    line-height: 24px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__control___3TLvb.node_modules-grommet-scss-vanilla-___index__grommetux-menu--labelled___3__-P .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n {\n    transition: none; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL {\n  font-size: 19px;\n  font-size: 1.1875rem;\n  line-height: 1.26316;\n  max-height: 100vh; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL > * {\n    flex-shrink: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6) {\n    text-decoration: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6):hover {\n      text-decoration: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm {\n    padding: 12px 24px;\n    white-space: nowrap;\n    display: block;\n    text-decoration: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:focus {\n      text-decoration: none;\n      color: #6b37cd;\n      background-color: rgba(221, 221, 221, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL .node_modules-grommet-scss-vanilla-___index__grommetux-menu__control___3TLvb {\n    text-align: left; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL .node_modules-grommet-scss-vanilla-___index__grommetux-menu__control___3TLvb {\n      text-align: right; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL .node_modules-grommet-scss-vanilla-___index__grommetux-menu__label___Fbm6Z {\n    padding: 12px 24px;\n    font-weight: 600; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--align-right___hHDnr {\n    text-align: right; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--align-right___hHDnr {\n      text-align: left; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--align-right___hHDnr .node_modules-grommet-scss-vanilla-___index__grommetux-menu__control___3TLvb {\n      text-align: right; }\n      .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--align-right___hHDnr .node_modules-grommet-scss-vanilla-___index__grommetux-menu__control___3TLvb {\n        text-align: left; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--align-right___hHDnr .node_modules-grommet-scss-vanilla-___index__grommetux-menu__contents___LZRg5 {\n      text-align: left; }\n      .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--align-right___hHDnr .node_modules-grommet-scss-vanilla-___index__grommetux-menu__contents___LZRg5 {\n        text-align: right; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS {\n    padding-left: 0;\n    vertical-align: middle;\n    height: inherit; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL .node_modules-grommet-scss-vanilla-___index__grommetux-anchor--reverse___3ilIu .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS {\n    padding-right: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--small___3NA3A {\n    font-size: 16px;\n    font-size: 1rem;\n    line-height: 1.5; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--small___3NA3A .node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS {\n      padding-top: 0;\n      padding-bottom: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--large___2Gdek {\n    font-size: 24px;\n    font-size: 1.5rem;\n    line-height: 1; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd {\n    color: #fff;\n    background-color: rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:focus, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:focus {\n    color: #fff;\n    background-color: rgba(0, 0, 0, 0.1); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:focus, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm.node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm:focus {\n    color: #6b37cd;\n    background-color: rgba(221, 221, 221, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--row___1BumR {\n  line-height: 48px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--row___1BumR.node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-end___2yPeZ > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n) {\n    margin-left: 24px;\n    margin-right: 0; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--row___1BumR.node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-end___2yPeZ > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n):first-child {\n      margin-left: 0; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--row___1BumR.node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-end___2yPeZ > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n) {\n      margin-right: 24px;\n      margin-left: 0; }\n      .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--row___1BumR.node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-end___2yPeZ > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n):first-child {\n        margin-right: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--row___1BumR > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n    margin-left: 0;\n    margin-right: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--row___1BumR > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):last-child {\n      margin-right: 0; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--row___1BumR > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n      margin-right: 0;\n      margin-left: 24px; }\n      .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--row___1BumR > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):last-child {\n        margin-left: 0; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux---direction-row___1Kepi.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr > * {\n    margin-right: 0; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux---direction-row___1Kepi.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr > * {\n      margin-left: 0; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--small___1L8VH {\n  font-size: 16px;\n  font-size: 1rem;\n  line-height: inherit; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu--large___1MG0c {\n  font-size: 24px;\n  font-size: 1.5rem;\n  line-height: inherit; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj {\n  width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG {\n    width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n    padding: 12px 24px 12px 20px;\n    margin-bottom: 0px;\n    width: 100%;\n    border-width: 4px;\n    border-color: transparent;\n    border-left-style: solid; }\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb) {\n      border-right-style: none;\n      border-left-style: solid; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover {\n      text-decoration: none; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover:not(.node_modules-grommet-scss-vanilla-___index__active___3wnBd) {\n        background-color: rgba(221, 221, 221, 0.5);\n        color: #000; }\n        .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover:not(.node_modules-grommet-scss-vanilla-___index__active___3wnBd), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover:not(.node_modules-grommet-scss-vanilla-___index__active___3wnBd) {\n          background-color: rgba(0, 0, 0, 0.1);\n          color: #fff; }\n        .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover:not(.node_modules-grommet-scss-vanilla-___index__active___3wnBd), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb):hover:not(.node_modules-grommet-scss-vanilla-___index__active___3wnBd) {\n          background-color: rgba(221, 221, 221, 0.5);\n          color: #000; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__grommetux-anchor--active___3Lb3p, .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd {\n      border-color: #865CD6; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__grommetux-anchor--active___3Lb3p, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__grommetux-anchor--active___3Lb3p, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd {\n        border-color: transparent;\n        background-color: rgba(0, 0, 0, 0.15);\n        color: #fff; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__grommetux-anchor--active___3Lb3p, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__grommetux-anchor--active___3Lb3p, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb).node_modules-grommet-scss-vanilla-___index__active___3wnBd {\n        border-color: #865CD6; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj.node_modules-grommet-scss-vanilla-___index__grommetux-menu--down___1oIXV {\n      display: block; }\n      .node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj.node_modules-grommet-scss-vanilla-___index__grommetux-menu--down___1oIXV > * {\n        display: block; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40) > hr,\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL > hr {\n  margin: 12px 24px 18px;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.15);\n  border: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40) a,\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL a {\n  text-decoration: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40).node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY > .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(:first-of-type) h2,\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40).node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY > .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(:first-of-type) h3,\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY > .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(:first-of-type) h2,\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY > .node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(:first-of-type) h3 {\n  margin-top: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40).node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-top___2x5Mu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-top___2x5Mu {\n  border-color: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40).node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-top___2x5Mu:before,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE.node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-top___2x5Mu:before {\n    content: '';\n    margin: 12px 24px 18px;\n    height: 1px;\n    background-color: rgba(0, 0, 0, 0.15); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40).node_modules-grommet-scss-vanilla-___index__grommetux-menu--small___1L8VH > a,\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu--small___1L8VH > a {\n  padding: 6px 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40).node_modules-grommet-scss-vanilla-___index__grommetux-menu--small___1L8VH.node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a,\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu--small___1L8VH.node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a {\n  padding: 6px 24px 6px 20px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40).node_modules-grommet-scss-vanilla-___index__grommetux-menu--large___1MG0c > a,\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu--large___1MG0c > a {\n  padding: 24px 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40).node_modules-grommet-scss-vanilla-___index__grommetux-menu--large___1MG0c.node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a,\n.node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-menu--large___1MG0c.node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj > a {\n  padding: 12px 24px 12px 20px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40).node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr > *,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr > * {\n    margin-left: 0px;\n    margin-right: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G.node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40).node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n    width: 100%;\n    margin-bottom: 12px; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL {\n    max-width: 100%; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL.node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n      margin-bottom: 0; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter___mkt5n {\n  display: inline-block;\n  position: relative; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr {\n  stroke-width: 4px;\n  fill: none;\n  stroke: rgba(0, 0, 0, 0.1); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter__hot___1_MSW {\n  cursor: pointer;\n  stroke-width: 24px;\n  stroke: rgba(0, 0, 0, 0.001); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter__threshold___bhb1I {\n  stroke: rgba(51, 51, 51, 0.2); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter__value-container___DmiqC {\n  position: relative;\n  display: inline-block;\n  white-space: nowrap; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic-container___377TJ {\n  white-space: normal; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic-container___377TJ > a {\n    text-decoration: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  max-width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy:focus {\n    outline: #00CCEB solid 1px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy text {\n    fill: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter___mkt5n:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez) .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic-container___377TJ {\n  display: inline-block; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic-container___377TJ {\n  display: inline-block;\n  white-space: nowrap; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--active___3pGgL .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr {\n  stroke-width: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice--active___uPBc2 {\n  stroke-width: 12px; }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__draw-meter-bar-small___1gECh {\n  0% {\n    stroke-dashoffset: 192px; }\n  100% {\n    stroke-dashoffset: 0; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__draw-meter-bar-small___1gECh {\n  0% {\n    stroke-dashoffset: 192px; }\n  100% {\n    stroke-dashoffset: 0; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV {\n  line-height: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr {\n    stroke-linecap: butt; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n    stroke: #ddd;\n    stroke-dasharray: 1px 10px;\n    stroke-dashoffset: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    stroke: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    stroke: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    stroke: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    stroke: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    stroke: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n    stroke: #ffffff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n    stroke: #f5f5f5; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice--clickable___3-8d9 {\n    cursor: pointer; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr {\n      stroke-dasharray: 192px 192px;\n      stroke-dashoffset: 0;\n      transition: stroke-width 0.2s;\n      -webkit-animation: node_modules-grommet-scss-vanilla-___index__draw-meter-bar-small___1gECh 1s ease-in;\n      animation: node_modules-grommet-scss-vanilla-___index__draw-meter-bar-small___1gECh 1s ease-in; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: rgba(221, 221, 221, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: rgba(134, 92, 214, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: rgba(255, 50, 77, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: rgba(255, 50, 77, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: rgba(255, 214, 2, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: rgba(140, 200, 0, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: rgba(168, 168, 168, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: rgba(168, 168, 168, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: rgba(10, 100, 160, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: rgba(220, 40, 120, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: rgba(80, 30, 180, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: rgba(73, 81, 111, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: rgba(0, 204, 235, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: rgba(255, 125, 40, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI {\n    stroke: rgba(0, 0, 1, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM {\n    stroke: rgba(51, 51, 51, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5 {\n    stroke: rgba(59, 59, 59, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN {\n    stroke: rgba(67, 67, 67, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F {\n    stroke: rgba(102, 102, 102, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez {\n    white-space: nowrap; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      height: 192px;\n      width: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 72px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 96px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez .node_modules-grommet-scss-vanilla-___index__grommetux-meter__labeled-graphic___1tiEp {\n      display: inline-block; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      height: 96px;\n      width: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 36px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      height: 192px;\n      width: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 72px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 96px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      height: 384px;\n      width: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 96px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 144px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 192px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      height: 576px;\n      width: 72px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 144px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 216px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 288px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      height: 720px;\n      width: 90px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 180px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 270px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 360px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez) .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 192px;\n  min-width: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 96px;\n  height: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz.node_modules-grommet-scss-vanilla-___index__grommetux-meter--single___15ihN .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 36px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 192px;\n  height: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD.node_modules-grommet-scss-vanilla-___index__grommetux-meter--single___15ihN .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 72px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 48px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 192px; } }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 384px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 144px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 72px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 192px; } }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 576px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 144px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 216px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 288px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 90px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 192px; } }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n      width: 720px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 180px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 270px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL).node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_ .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  height: 360px; }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__draw-meter-circle___3wnZY {\n  0% {\n    stroke-dashoffset: -614px; }\n  100% {\n    stroke-dashoffset: 0; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__draw-meter-circle___3wnZY {\n  0% {\n    stroke-dashoffset: -614px; }\n  100% {\n    stroke-dashoffset: 0; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA {\n    margin: 0px auto; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter___mkt5n.node_modules-grommet-scss-vanilla-___index__series-pre___1HkBv path,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter___mkt5n.node_modules-grommet-scss-vanilla-___index__series-pre___1HkBv path,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter___mkt5n.node_modules-grommet-scss-vanilla-___index__series-pre___1HkBv path {\n  stroke-dashoffset: 768px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr {\n  stroke-linecap: butt; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS {\n  stroke-linecap: square;\n  stroke-width: 4px;\n  stroke: rgba(51, 51, 51, 0.2); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS {\n    stroke: rgba(255, 255, 255, 0.2); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS {\n    stroke: rgba(51, 51, 51, 0.2); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n  stroke: #ddd;\n  stroke-dasharray: 1px 10px;\n  stroke-dashoffset: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n  stroke: #ddd; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n  stroke: #865CD6; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n  stroke: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n  stroke: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n  stroke: #FFD602; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n  stroke: #8CC800; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n  stroke: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n  stroke: #a8a8a8; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n  stroke: #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n  stroke: #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n  stroke: #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n  stroke: #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n  stroke: #000001; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n  stroke: #333333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n  stroke: #3B3B3B; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n  stroke: #434343; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n  stroke: #666666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n  stroke: #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n  stroke: #FF7D28; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n  stroke: #0A64A0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n  stroke: #DC2878; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n  stroke: #501EB4; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n  stroke: #49516F; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n  stroke: #ffffff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n  stroke: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice--clickable___3-8d9,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice--clickable___3-8d9,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice--clickable___3-8d9 {\n  cursor: pointer; }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr {\n    stroke-dasharray: 614px 614px;\n    stroke-dashoffset: 0;\n    transition: stroke-width 0.2s;\n    -webkit-animation: node_modules-grommet-scss-vanilla-___index__draw-meter-circle___3wnZY 1s ease-in;\n    animation: node_modules-grommet-scss-vanilla-___index__draw-meter-circle___3wnZY 1s ease-in; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n  stroke: rgba(221, 221, 221, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n  stroke: rgba(134, 92, 214, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n  stroke: rgba(255, 50, 77, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n  stroke: rgba(255, 50, 77, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n  stroke: rgba(255, 214, 2, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n  stroke: rgba(140, 200, 0, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n  stroke: rgba(168, 168, 168, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n  stroke: rgba(168, 168, 168, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n  stroke: rgba(10, 100, 160, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n  stroke: rgba(220, 40, 120, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n  stroke: rgba(80, 30, 180, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n  stroke: rgba(73, 81, 111, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n  stroke: rgba(0, 204, 235, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n  stroke: rgba(255, 125, 40, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI {\n  stroke: rgba(0, 0, 1, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM {\n  stroke: rgba(51, 51, 51, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5 {\n  stroke: rgba(59, 59, 59, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN {\n  stroke: rgba(67, 67, 67, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_, .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR .node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr.node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F {\n  stroke: rgba(102, 102, 102, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__threshold___bhb1I,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS .node_modules-grommet-scss-vanilla-___index__grommetux-meter__threshold___bhb1I,\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__threshold___bhb1I {\n  stroke-linecap: butt; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 192px;\n  min-width: 96px;\n  height: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04 .node_modules-grommet-scss-vanilla-___index__grommetux-meter__label___3PCo4 {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 96px;\n  height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04.node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 192px;\n  height: 192px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04.node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 192px;\n    height: 192px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04.node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 384px;\n    height: 384px; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04.node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 192px;\n    height: 192px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04.node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 576px;\n    height: 576px; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 192px;\n    height: 192px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 720px;\n    height: 720px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez) .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 192px;\n  min-width: 96px;\n  height: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 96px;\n  height: 72px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 192px;\n  height: 144px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 192px;\n    height: 144px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 384px;\n    height: 288px; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 192px;\n    height: 144px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 576px;\n    height: 432px; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 192px;\n    height: 144px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS:not(.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez).node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 720px;\n    height: 540px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  display: inline;\n  width: 144px;\n  height: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 72px;\n  height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n  width: 144px;\n  height: 192px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 144px;\n    height: 192px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 288px;\n    height: 384px; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 144px;\n    height: 192px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 432px;\n    height: 576px; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 144px;\n    height: 192px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS.node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez.node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy {\n    width: 540px;\n    height: 720px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA .node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic-container___377TJ {\n  vertical-align: top; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-notification____yEc6 {\n  font-size: 19px;\n  font-size: 1.1875rem;\n  line-height: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-critical___3IgRe .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-critical___3IgRe .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4 {\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-critical___3IgRe .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #FF324D;\n    fill: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-critical___3IgRe .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP-.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-unknown___1Kd1s .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-critical___3IgRe .node_modules-grommet-scss-vanilla-___index__grommetux-notification__close___1PFu_ {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-error___13n4G .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-error___13n4G .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4 {\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-error___13n4G .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #FF324D;\n    fill: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-error___13n4G .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP-.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-unknown___1Kd1s .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-error___13n4G .node_modules-grommet-scss-vanilla-___index__grommetux-notification__close___1PFu_ {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-warning___3q47G .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-warning___3q47G .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4 {\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-warning___3q47G .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #FFD602;\n    fill: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-warning___3q47G .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP-.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-unknown___1Kd1s .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-warning___3q47G .node_modules-grommet-scss-vanilla-___index__grommetux-notification__close___1PFu_ {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-ok___2D2G6 .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-ok___2D2G6 .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4 {\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-ok___2D2G6 .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #8CC800;\n    fill: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-ok___2D2G6 .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP-.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-unknown___1Kd1s .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-ok___2D2G6 .node_modules-grommet-scss-vanilla-___index__grommetux-notification__close___1PFu_ {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-unknown___3st_f .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-unknown___3st_f .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4 {\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-unknown___3st_f .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #a8a8a8;\n    fill: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-unknown___3st_f .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP-.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-unknown___1Kd1s .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-unknown___3st_f .node_modules-grommet-scss-vanilla-___index__grommetux-notification__close___1PFu_ {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-disabled___3KL04 .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-disabled___3KL04 .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4 {\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-disabled___3KL04 .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #a8a8a8;\n    fill: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-disabled___3KL04 .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP-.node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-unknown___1Kd1s .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos {\n    stroke: #fff;\n    fill: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-disabled___3KL04 .node_modules-grommet-scss-vanilla-___index__grommetux-notification__close___1PFu_ {\n    stroke: #fff;\n    fill: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-notification__message___1u00D {\n  font-size: 24px;\n  font-size: 1.5rem;\n  line-height: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-notification__message___1u00D + * {\n    margin-top: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- {\n  flex: 0 0 auto;\n  margin-right: 24px; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP- {\n    margin-right: 0;\n    margin-left: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-notification--small___12Bmo .node_modules-grommet-scss-vanilla-___index__grommetux-notification__message___1u00D {\n  font-size: 19px;\n  font-size: 1.1875rem;\n  line-height: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx {\n  padding: 11px 23px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  outline: none;\n  background-color: transparent;\n  color: inherit;\n  font: inherit;\n  margin: 0;\n  -moz-appearance: textfield; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx:focus {\n    border-width: 2px;\n    border-color: #00CCEB;\n    padding: 10px 22px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx::-moz-focus-inner {\n    border: none;\n    outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx::-webkit-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx::-moz-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx:-ms-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx.node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    border-color: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx::-webkit-outer-spin-button, .node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx:invalid {\n    box-shadow: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx::-ms-clear {\n    display: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-object___1cfq5 {\n  overflow: auto; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-object___1cfq5 ul,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-object___1cfq5 ol {\n    margin: 0px;\n    list-style-type: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-object___1cfq5 li {\n    width: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-object__container___2faOl {\n  padding: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute___19UkJ {\n  margin-bottom: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-name___2sQ17 {\n  display: block;\n  color: #666;\n  font-size: 14px;\n  font-size: 0.875rem;\n  line-height: 1.71429; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-value___19qgr {\n  display: block;\n  font-size: 16px;\n  font-size: 1rem;\n  line-height: 1.5; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-value___19qgr ul,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-value___19qgr ol {\n    margin-left: 24px;\n    padding-top: 24px;\n    padding-bottom: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute--container___1tJqk > .node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-name___2sQ17 {\n  font-weight: 500; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute--unset___l3-t9 .node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-value___19qgr {\n  font-style: italic;\n  color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute--array___3cV6F > .node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-value___19qgr > ol > li {\n  border-top: 1px solid rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute--array___3cV6F > .node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-value___19qgr > ol > li:last-child {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute--array___3cV6F > .node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-value___19qgr > ol > li > ul {\n    padding-top: 0px;\n    padding-bottom: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK {\n  max-width: 576px;\n  margin-left: 0px;\n  margin-top: 24px;\n  margin-bottom: 24px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.375;\n  color: #666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--align-start___36TW2 {\n    text-align: left; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--align-start___36TW2 {\n      text-align: right; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--align-center___15so7 {\n    text-align: center; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--align-end___1r0n6 {\n    text-align: right; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--align-end___1r0n6 {\n      text-align: left; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--margin-none___3h8-c {\n    margin-top: 0;\n    margin-bottom: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--margin-small___2oqWN {\n    margin-top: 12px;\n    margin-bottom: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--margin-medium___3v9v8 {\n    margin-top: 24px;\n    margin-bottom: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--margin-large___2VdVw {\n    margin-top: 48px;\n    margin-bottom: 48px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK {\n    color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK {\n    color: #333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--small___3NGjw {\n  font-size: 14px;\n  line-height: 1.43; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--large___1OYzn {\n  font-size: 24px;\n  line-height: 1.167; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--large___1OYzn a {\n    color: #865CD6;\n    font-weight: 500; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--xlarge___3fjzU {\n  font-size: 32px;\n  line-height: 1.1875; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--xlarge___3fjzU a {\n    color: #865CD6;\n    font-weight: 500; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--width-large___1Hhd4 {\n  max-width: 100%; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--width-large___1Hhd4 {\n      width: 720px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF {\n  position: relative;\n  cursor: pointer;\n  overflow: hidden; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-password-input__input___2f8TH {\n  padding: 11px 23px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  outline: none;\n  background-color: transparent;\n  color: inherit;\n  font: inherit;\n  margin: 0;\n  width: 100%;\n  padding-right: 60px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-password-input__input___2f8TH:focus {\n    border-width: 2px;\n    border-color: #00CCEB;\n    padding: 10px 22px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-password-input__input___2f8TH::-moz-focus-inner {\n    border: none;\n    outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-password-input__input___2f8TH::-webkit-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-password-input__input___2f8TH::-moz-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-password-input__input___2f8TH:-ms-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-password-input__input___2f8TH.node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    border-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-password-input__input___2f8TH:focus {\n  padding-right: 58px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-password-input__control___3wsmQ {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 6px; }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__scale-up-fade-out___3ypTj {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 1; }\n  15% {\n    opacity: 1; }\n  100% {\n    -webkit-transform: scale(1.4);\n    transform: scale(1.4);\n    opacity: 0; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-pulse___1Ad3h {\n  display: inline-block;\n  height: 48px;\n  width: 48px;\n  position: relative;\n  line-height: 0;\n  transition: transform 0.25s ease-out;\n  transform-origin: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-pulse___1Ad3h:hover {\n  transform: scale(1.2) rotate(0.0001deg);\n  cursor: pointer; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-pulse___1Ad3h:hover .node_modules-grommet-scss-vanilla-___index__grommetux-pulse__icon-anim___OE2Iz {\n    -webkit-animation: none;\n    animation: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-pulse__icon___1nTMn svg {\n  width: 48px;\n  height: 48px;\n  border-radius: 48px;\n  padding: 12px;\n  background-color: #00CCEB;\n  stroke: #000001; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-pulse__icon-anim___OE2Iz {\n  display: block;\n  width: 48px;\n  height: 48px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  box-sizing: border-box;\n  transform-origin: center;\n  border: 1px solid;\n  border-color: #00CCEB;\n  border-radius: 48px;\n  -webkit-animation-name: node_modules-grommet-scss-vanilla-___index__scale-up-fade-out___3ypTj;\n  -webkit-animation-duration: 1.5s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-delay: 0.2s;\n  animation-name: node_modules-grommet-scss-vanilla-___index__scale-up-fade-out___3ypTj;\n  animation-duration: 1.5s;\n  animation-iteration-count: infinite;\n  animation-delay: 0.2s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-quote___3DqMn {\n  border-width: 24px;\n  border-style: solid;\n  max-width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-quote--small___3Dkle {\n  border-width: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo {\n  margin-right: 24px;\n  white-space: nowrap; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) {\n  cursor: pointer; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n  border-color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n    border-color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n    border-color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n  border-color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n    border-color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n    border-color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z {\n  color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo) .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z {\n    color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan {\n  opacity: 0;\n  position: absolute; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n  border-color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n    border-color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n    border-color: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z {\n    color: #333; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z {\n      color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z {\n      color: #333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  width: 10px;\n  height: 10px;\n  background-color: #865CD6;\n  border-radius: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM:after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM:after {\n    background-color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM:after, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:checked + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM:after {\n    background-color: #865CD6; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan:focus + .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n  content: \"\";\n  border-color: #00CCEB;\n  box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n  position: relative;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n  vertical-align: middle;\n  background-color: inherit;\n  color: #6b37cd;\n  border: 2px solid #666;\n  border-radius: 24px; }\n  html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n    margin-right: 0;\n    margin-left: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n    border-color: rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n    border-color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z {\n  display: inline-block;\n  vertical-align: middle;\n  color: #666;\n  white-space: normal;\n  margin-right: 24px;\n  word-break: break-word; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z {\n    color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z {\n    color: #666; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo .node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM {\n  opacity: 0.5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search___3fYRa {\n  display: inline-block; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search___3fYRa:focus {\n    outline: none;\n    margin: -1px;\n    border: 1px solid #00CCEB;\n    box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--controlled___3-czc {\n  cursor: pointer; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n  margin-right: 0px;\n  padding: 11px 23px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  outline: none;\n  background-color: transparent;\n  color: inherit;\n  font: inherit;\n  margin: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n    border-width: 2px;\n    border-color: #00CCEB;\n    padding: 10px 22px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n::-moz-focus-inner {\n    border: none;\n    outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n::-webkit-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n::-moz-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:-ms-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n.node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    border-color: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n::-ms-clear {\n    display: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n    border-color: rgba(255, 255, 255, 0.5); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n      border-color: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n    border-color: rgba(0, 0, 0, 0.15); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n      border-color: #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search__drop___3NfTd {\n  font-size: 18px;\n  font-size: 1.125rem;\n  line-height: inherit; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-search__drop___3NfTd {\n      max-width: 100%;\n      width: 100vw; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search__drop___3NfTd input {\n    margin-right: 0px;\n    box-sizing: border-box;\n    width: 100%;\n    padding: 12px; }\n    @media screen and (max-width: 44.9375em) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-search__drop___3NfTd input {\n        width: calc(100vw - 72px); } }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-search__drop___3NfTd input:focus {\n      padding: 11px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search__drop___3NfTd .node_modules-grommet-scss-vanilla-___index__grommetux-search__suggestion___3yHYu {\n    padding: 6px 24px;\n    cursor: pointer;\n    outline: none; }\n    @media screen and (max-width: 44.9375em) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-search__drop___3NfTd .node_modules-grommet-scss-vanilla-___index__grommetux-search__suggestion___3yHYu {\n        width: 100vw; } }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-search__drop___3NfTd .node_modules-grommet-scss-vanilla-___index__grommetux-search__suggestion___3yHYu:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-search__drop___3NfTd .node_modules-grommet-scss-vanilla-___index__grommetux-search__suggestion--active___2IHfS {\n      background-color: rgba(221, 221, 221, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search__drop-control___1ZTDu {\n  vertical-align: top;\n  height: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search__drop--controlled___3qK1x .node_modules-grommet-scss-vanilla-___index__grommetux-search__drop-contents___3iKfZ {\n  display: inline-block; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search__drop--large___3yry- {\n  line-height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m {\n  position: relative; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n    width: 100%;\n    box-sizing: border-box;\n    padding-left: 11px;\n    padding-right: 47px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    border-radius: 0;\n    -webkit-appearance: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n      padding-left: 10px;\n      padding-right: 46px;\n      padding-top: 11px;\n      padding-bottom: 11px; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n      padding-right: 11px;\n      padding-left: 47px; }\n      html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n        padding-right: 11px;\n        padding-left: 46px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-header___F29w4 .node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:not(:focus) {\n      border-color: transparent; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-search___1i7iY {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    pointer-events: none; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-search___1i7iY {\n      right: auto;\n      left: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--small___1hqG5 .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n  font-size: 16px;\n  font-size: 1rem;\n  line-height: normal;\n  padding: 4px 18px;\n  padding-right: 23px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search--small___1hqG5 .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n    padding: 3px 17px;\n    padding-right: 22px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--medium___2yzgR .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n  font-size: 24px;\n  font-size: 1.5rem;\n  line-height: normal; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n  font-size: 54px;\n  font-size: 3.375rem;\n  line-height: normal;\n  padding: 12px 24px;\n  padding-right: 72px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n    padding: 11px 71px;\n    padding-left: 23px; }\n    @media screen and (max-width: 44.9375em) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n        padding: 10px 22px;\n        padding-right: 46px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n      font-size: inherit;\n      padding: 11px 23px;\n      padding-right: 47px;\n      line-height: 1.5; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-search___1i7iY {\n  right: 24px;\n  width: 48px;\n  height: 48px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-search___1i7iY {\n      right: 12px;\n      width: 24px;\n      height: 24px; } }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-search___1i7iY {\n      transition: none; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--icon-align-start___3wqIE.node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n  padding-left: 47px;\n  padding-right: 23px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search--icon-align-start___3wqIE.node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n    padding-left: 46px;\n    padding-right: 23px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--icon-align-start___3wqIE.node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-search___1i7iY {\n  left: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--icon-align-start___3wqIE.node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n  padding-left: 72px;\n  padding-right: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search--icon-align-start___3wqIE.node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n    padding-left: 71px;\n    padding-right: 23px; }\n    @media screen and (max-width: 44.9375em) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-search--icon-align-start___3wqIE.node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n:focus {\n        padding: 10px 22px;\n        padding-left: 46px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-search--icon-align-start___3wqIE.node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n      padding: 11px 23px;\n      padding-left: 47px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--fill___3YChL {\n  max-width: none;\n  flex-grow: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--pad-medium___pfbmt.node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n {\n  padding-left: 23px;\n  padding-right: 23px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search--pad-medium___pfbmt.node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-search___1i7iY {\n  right: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih {\n  position: relative;\n  display: inline-block; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh {\n  padding: 11px 23px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  outline: none;\n  background-color: transparent;\n  color: inherit;\n  font: inherit;\n  margin: 0;\n  padding-right: 60px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh:focus {\n    border-width: 2px;\n    border-color: #00CCEB;\n    padding: 10px 22px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh::-moz-focus-inner {\n    border: none;\n    outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh::-webkit-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh::-moz-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh:-ms-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh.node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    border-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh:focus {\n  padding-right: 58px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh::-ms-clear {\n  display: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search-input__suggestions___rEM5f {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  margin: 0px;\n  list-style-type: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search-input__suggestion___3PgWK {\n  padding: 6px 24px;\n  cursor: pointer; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__suggestion___3PgWK:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__suggestion--active___2fvjw {\n    background-color: rgba(221, 221, 221, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-search-input--active___2pwv1 .node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh {\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px; }\n\nsection:not(.node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD) {\n  padding-top: 24px;\n  padding-bottom: 24px; }\n  section:not(.node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD):first-of-type {\n    margin-top: 0px;\n    padding-top: 0px; }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .node_modules-grommet-scss-vanilla-___index__layer___23Xvt .node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD, .node_modules-grommet-scss-vanilla-___index__layer___23Xvt\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV section {\n    height: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD > img,\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV section > img {\n  margin-top: 24px;\n  margin-bottom: 24px;\n  display: block;\n  height: auto; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD > img,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV section > img {\n      max-width: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD > iframe,\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV section > iframe {\n  width: 100%;\n  max-width: 576px; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD > ol,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD > ul:not([class^=\"grommetux-\"]),\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV section > ol,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV section > ul:not([class^=\"grommetux-\"]) {\n    margin-left: 2rem; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD > dl > dt,\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV section > dl > dt {\n  margin-top: 24px;\n  margin-bottom: 6px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD > dl > dt code,\n  .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV section > dl > dt code {\n    text-transform: none;\n    white-space: pre-wrap; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD > dl > dd,\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV section > dl > dd {\n  margin-left: 0px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD > dl > dd,\n    .node_modules-grommet-scss-vanilla-___index__grommet___1fqKV section > dl > dd {\n      padding-right: 24px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P {\n  position: relative;\n  cursor: pointer;\n  overflow: hidden; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB {\n  padding: 11px 23px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  outline: none;\n  background-color: transparent;\n  color: inherit;\n  font: inherit;\n  margin: 0;\n  width: 100%;\n  padding-right: 60px;\n  cursor: inherit;\n  color: inherit;\n  pointer-events: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB:focus {\n    border-width: 2px;\n    border-color: #00CCEB;\n    padding: 10px 22px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB::-moz-focus-inner {\n    border: none;\n    outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB::-webkit-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB::-moz-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB:-ms-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB.node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    border-color: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB[readonly] {\n    color: #333; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB[readonly], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB[readonly] {\n      color: rgba(255, 255, 255, 0.85); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB[readonly], .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB[readonly] {\n      color: #333; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB:focus {\n  padding-right: 58px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB::-ms-clear {\n  display: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-select__value___1DVAG {\n  padding: 6px 48px 6px 0;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-select__control___3gIT6 {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 6px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-select__control___3gIT6 svg {\n    background-color: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-select__search___1Lja3 {\n  width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-select__options___1kVZk {\n  margin: 0px;\n  list-style-type: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-select__option___3CkFW {\n  min-height: 36px;\n  padding: 6px 0;\n  cursor: pointer; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-select__drop___3ZIrD {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-select__drop___3ZIrD .node_modules-grommet-scss-vanilla-___index__grommetux-select__option___3CkFW {\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 1.375;\n    color: #666;\n    color: #333;\n    padding: 6px 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-select__drop___3ZIrD .node_modules-grommet-scss-vanilla-___index__grommetux-select__option___3CkFW.node_modules-grommet-scss-vanilla-___index__grommetux-select__option--element___2JUeV {\n      padding: 6px 0; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-select__drop___3ZIrD .node_modules-grommet-scss-vanilla-___index__grommetux-select__option___3CkFW:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-select__drop___3ZIrD .node_modules-grommet-scss-vanilla-___index__grommetux-select__option--active___1tCnA {\n      background-color: rgba(221, 221, 221, 0.5); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-select__drop___3ZIrD .node_modules-grommet-scss-vanilla-___index__grommetux-select__option--selected___3sIGY {\n      color: #000;\n      background-color: rgba(221, 221, 221, 0.5); }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sidebar___2SHOE {\n    max-width: 100%;\n    width: 100vw; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sidebar___2SHOE {\n    width: 336px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sidebar--fixed___30r1w {\n  display: flex;\n  flex-direction: column;\n  max-height: 100vh; }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sidebar--xsmall___3IddN {\n    width: 144px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sidebar--small___3RAvx {\n    width: 240px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sidebar--large___uf1Db {\n    width: 480px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sidebar--full____sz-6 {\n  height: 100vh;\n  overflow: auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-split___3u6Hw {\n  position: relative;\n  overflow: visible; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-split___3u6Hw {\n      display: flex;\n      flex-direction: row; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-split__column___2292- {\n  flex: 0 0 auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-split__column--hidden___9NQcg {\n  display: none; }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-split__column--fixed___2RfkQ {\n    position: relative;\n    height: 100vh;\n    overflow: auto;\n    -ms-overflow-style: -ms-autohiding-scrollbar; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-split__column--flex___24LUe {\n    flex: 1 1; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-split__column--separator___wrAbf {\n    border-right: 1px solid #000; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-split__column--separator___wrAbf {\n    border-bottom: 1px solid #000; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-skip-link-anchor___1jzp0 {\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  position: absolute; }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__fade-in___39_Q8 {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__fade-in___39_Q8 {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__draw-arc___4G5xN {\n  0% {\n    stroke-dashoffset: -384px; }\n  100% {\n    stroke-dashoffset: 0; } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__draw-arc___4G5xN {\n  0% {\n    stroke-dashoffset: -384px; }\n  100% {\n    stroke-dashoffset: 0; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst___1Zwvh {\n  position: relative;\n  height: 384px;\n  width: 384px;\n  max-width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__graphic___23DxY {\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__fade-in___39_Q8 2.5s;\n  animation: node_modules-grommet-scss-vanilla-___index__fade-in___39_Q8 2.5s;\n  outline: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__graphic--focus___2GT5q {\n  border-color: #00CCEB;\n  box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__label___23wtx {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q {\n  stroke-linecap: butt;\n  stroke-dasharray: 1536px 1536px;\n  stroke-dashoffset: 0;\n  stroke: rgba(0, 0, 0, 0.1);\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__draw-arc___4G5xN 1.5s linear;\n  animation: node_modules-grommet-scss-vanilla-___index__draw-arc___4G5xN 1.5s linear;\n  transition: opacity 0.3s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n    stroke: #ddd;\n    stroke-dasharray: 1px 10px;\n    stroke-dashoffset: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    stroke: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    stroke: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    stroke: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    stroke: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    stroke: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n    stroke: #ffffff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n    stroke: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice--hot___1i8ss {\n  cursor: pointer;\n  outline: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--active___1R589 .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q {\n  opacity: 0.7; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--active___1R589 .node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice--active___1C0hV {\n  opacity: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--small___1jPGu {\n  height: 192px;\n  width: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--large___1FWBi {\n  height: 576px;\n  width: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--xlarge___2KXk6 {\n  height: 720px;\n  width: 720px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--full___3NuVx {\n  width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tab___h7ruL {\n  padding: 0 12px; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tab___h7ruL {\n      padding: 6px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-start___3AZwl .node_modules-grommet-scss-vanilla-___index__grommetux-tab___h7ruL:first-of-type,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-end___5UW44 .node_modules-grommet-scss-vanilla-___index__grommetux-tab___h7ruL:first-of-type {\n    padding-left: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-start___3AZwl .node_modules-grommet-scss-vanilla-___index__grommetux-tab___h7ruL:last-of-type,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-end___5UW44 .node_modules-grommet-scss-vanilla-___index__grommetux-tab___h7ruL:last-of-type {\n    padding-right: 0; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tabs--responsive___2_JP6 .node_modules-grommet-scss-vanilla-___index__grommetux-tab___h7ruL:first-of-type,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tabs--responsive___2_JP6 .node_modules-grommet-scss-vanilla-___index__grommetux-tab___h7ruL:last-of-type {\n      padding-left: 12px;\n      padding-right: 12px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tab__label___2abQX {\n  display: inline-block;\n  cursor: pointer;\n  padding-bottom: 10px;\n  color: #666;\n  border-bottom: 4px solid transparent; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tab__label___2abQX {\n      padding-bottom: 6px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tab--active___2byGX .node_modules-grommet-scss-vanilla-___index__grommetux-tab__label___2abQX {\n  color: #000;\n  border-color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tab___h7ruL:hover:not(.node_modules-grommet-scss-vanilla-___index__grommetux-tab--active___2byGX) .node_modules-grommet-scss-vanilla-___index__grommetux-tab__label___2abQX {\n  border-color: rgba(0, 0, 0, 0.15); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tabs___15mq5 {\n  margin: 12px 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  list-style: none;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tabs___15mq5 + div:focus {\n    outline: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-center___3wQZ_ {\n  justify-content: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-start___3AZwl {\n  justify-content: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-end___5UW44 {\n  justify-content: flex-end; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-start___3AZwl.node_modules-grommet-scss-vanilla-___index__grommetux-tabs--responsive___2_JP6,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-center___3wQZ_.node_modules-grommet-scss-vanilla-___index__grommetux-tabs--responsive___2_JP6,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-end___5UW44.node_modules-grommet-scss-vanilla-___index__grommetux-tabs--responsive___2_JP6 {\n    flex-direction: column;\n    text-align: center; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ {\n  width: 100%;\n  max-width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ table {\n    max-width: 100%;\n    width: 100%;\n    border-collapse: collapse; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ td,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ th {\n    padding: 11px 12px;\n    text-align: left; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ td:first-child,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ th:first-child {\n      padding-left: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ td:last-child,\n    .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ th:last-child {\n      padding-right: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ th {\n    font-weight: 300;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ th, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ th {\n      border-color: rgba(255, 255, 255, 0.5); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ th, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_ th {\n      border-color: rgba(0, 0, 0, 0.15); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table__mirror___5rL2d {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table__mirror___5rL2d > thead {\n    position: fixed;\n    background-color: rgba(255, 255, 255, 0.9); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table__more___lvIas {\n  margin-top: 24px;\n  text-align: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table--scrollable___aOpoY {\n  position: relative; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table--scrollable___aOpoY .node_modules-grommet-scss-vanilla-___index__grommetux-table__table___h6aQZ thead {\n    visibility: hidden; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table--scrollable___aOpoY .node_modules-grommet-scss-vanilla-___index__grommetux-table__table___h6aQZ th {\n    border-bottom: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U .node_modules-grommet-scss-vanilla-___index__grommetux-table__table___h6aQZ {\n  outline: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U .node_modules-grommet-scss-vanilla-___index__grommetux-table__table--focus___3axUf {\n  border-color: #00CCEB;\n  box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr {\n  cursor: pointer;\n  outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr td {\n    transition: background-color 0.2s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr.node_modules-grommet-scss-vanilla-___index__grommetux-table-row--selected___2gJW9 td {\n    background-color: #ccbaee;\n    color: #333; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr.node_modules-grommet-scss-vanilla-___index__grommetux-table-row--selected___2gJW9 td, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr.node_modules-grommet-scss-vanilla-___index__grommetux-table-row--selected___2gJW9 td {\n      background-color: rgba(0, 0, 0, 0.15);\n      color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr.node_modules-grommet-scss-vanilla-___index__grommetux-table-row--selected___2gJW9 td, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr.node_modules-grommet-scss-vanilla-___index__grommetux-table-row--selected___2gJW9 td {\n      background-color: #ccbaee;\n      color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr.node_modules-grommet-scss-vanilla-___index__grommetux-table-row--active___Jvnt_ td, .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr:hover td {\n    background-color: rgba(221, 221, 221, 0.5);\n    color: #000; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr.node_modules-grommet-scss-vanilla-___index__grommetux-table-row--active___Jvnt_ td, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr.node_modules-grommet-scss-vanilla-___index__grommetux-table-row--active___Jvnt_ td, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr:hover td, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr:hover td {\n      background-color: rgba(0, 0, 0, 0.1);\n      color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr.node_modules-grommet-scss-vanilla-___index__grommetux-table-row--active___Jvnt_ td, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr.node_modules-grommet-scss-vanilla-___index__grommetux-table-row--active___Jvnt_ td, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr:hover td, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U tbody tr:hover td {\n      background-color: rgba(221, 221, 221, 0.5);\n      color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table--small___2d8Ti thead {\n  display: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table--small___2d8Ti td {\n  display: block; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-table--small___2d8Ti td:before {\n    font-weight: 300;\n    font-size: 19px;\n    font-size: 1.1875rem;\n    line-height: 24px;\n    content: attr(data-th);\n    display: block;\n    padding-right: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table--small___2d8Ti tr {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-table--small___2d8Ti td,\n.node_modules-grommet-scss-vanilla-___index__grommetux-table--small___2d8Ti th {\n  padding-left: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tbd___3Epcv {\n  text-align: center;\n  padding: 96px;\n  font-size: 96px;\n  font-size: 6rem;\n  line-height: 1;\n  font-style: italic;\n  background-color: rgba(0, 0, 0, 0.15);\n  color: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-text-input___ZcDLG {\n  padding: 11px 23px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  outline: none;\n  background-color: transparent;\n  color: inherit;\n  font: inherit;\n  margin: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-text-input___ZcDLG:focus {\n    border-width: 2px;\n    border-color: #00CCEB;\n    padding: 10px 22px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-text-input___ZcDLG::-moz-focus-inner {\n    border: none;\n    outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-text-input___ZcDLG::-webkit-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-text-input___ZcDLG::-moz-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-text-input___ZcDLG:-ms-input-placeholder {\n    color: #aaa; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-text-input___ZcDLG.node_modules-grommet-scss-vanilla-___index__error___1IV6T {\n    border-color: #FF324D; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-text-input--active___8RuZa {\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-text-input__suggestions___Mc3o2 {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  margin: 0px;\n  list-style-type: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-text-input__suggestion___L-_Mz {\n  padding: 6px 24px;\n  cursor: pointer; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-text-input__suggestion___L-_Mz:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-text-input__suggestion--active___3wxLi {\n    background-color: rgba(221, 221, 221, 0.5); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw {\n  width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-none___20uWQ {\n    padding: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-small___3u-YG {\n      padding: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-medium___E-hlM {\n      padding: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-large___CihIa {\n      padding: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-xlarge___2l9be {\n      padding: 192px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-small___3u-YG {\n      padding: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-medium___E-hlM {\n      padding: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-large___CihIa {\n      padding: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-xlarge___2l9be {\n      padding: 48px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-none___2mUzW {\n    padding-left: 0px;\n    padding-right: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-small___3bKWD {\n      padding-left: 12px;\n      padding-right: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-medium___2vaIe {\n      padding-left: 24px;\n      padding-right: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-large___1RYOG {\n      padding-left: 48px;\n      padding-right: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-xlarge___1kgco {\n      padding-left: 192px;\n      padding-right: 192px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-small___3bKWD {\n      padding-left: 6px;\n      padding-right: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-medium___2vaIe {\n      padding-left: 12px;\n      padding-right: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-large___1RYOG {\n      padding-left: 24px;\n      padding-right: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-xlarge___1kgco {\n      padding-left: 48px;\n      padding-right: 48px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-none___3WDUM {\n    padding-top: 0px;\n    padding-bottom: 0px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-small___fB-T6 {\n      padding-top: 12px;\n      padding-bottom: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-medium___35hUH {\n      padding-top: 24px;\n      padding-bottom: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-large___3Avgg {\n      padding-top: 48px;\n      padding-bottom: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-xlarge___2l1dk {\n      padding-top: 192px;\n      padding-bottom: 192px; } }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-small___fB-T6 {\n      padding-top: 6px;\n      padding-bottom: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-medium___35hUH {\n      padding-top: 12px;\n      padding-bottom: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-large___3Avgg {\n      padding-top: 24px;\n      padding-bottom: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-xlarge___2l1dk {\n      padding-top: 48px;\n      padding-bottom: 48px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--focus___3tBy8 {\n  border-color: #00CCEB;\n  box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tiles__container___2GJM- {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles__container___2GJM- .node_modules-grommet-scss-vanilla-___index__grommetux-tiles__left___19CLE,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles__container___2GJM- .node_modules-grommet-scss-vanilla-___index__grommetux-tiles__right___I21lW {\n    flex: 0 0 auto; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles__container___2GJM- .node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw {\n    flex: 1;\n    margin: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles__container___2GJM- .node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw.node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40 {\n    width: 100%;\n    overflow: hidden; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe) > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o {\n  margin: 12px; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe) > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o {\n      margin: 24px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe) > .node_modules-grommet-scss-vanilla-___index__grommetux-tile--wide___2Pavn {\n    flex-basis: calc(100% - 24px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe) > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o.node_modules-grommet-scss-vanilla-___index__grommetux-tile--hover-border-medium___PThq1 {\n    margin: 6px; }\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe) > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o.node_modules-grommet-scss-vanilla-___index__grommetux-tile--hover-border-medium___PThq1 {\n        margin: 12px; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe) > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o.node_modules-grommet-scss-vanilla-___index__grommetux-tile--hover-border-large___lenqG {\n    margin: 12px; }\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n      .node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw:not(.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe) > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o.node_modules-grommet-scss-vanilla-___index__grommetux-tile--hover-border-large___lenqG {\n        margin: 24px; } }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--fill___1vWBQ {\n    height: 100%; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--fill___1vWBQ.node_modules-grommet-scss-vanilla-___index__grommetux-box--wrap___yEl4n {\n  justify-content: space-around; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--fill___1vWBQ.node_modules-grommet-scss-vanilla-___index__grommetux-box--wrap___yEl4n > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o {\n    flex-grow: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe {\n  padding: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o {\n    margin: 0px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe > .node_modules-grommet-scss-vanilla-___index__grommetux-tile--wide___2Pavn {\n      flex-basis: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tiles__more___21hhb {\n  flex: 1 1 100%;\n  text-align: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn {\n  outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o {\n    cursor: pointer;\n    outline: none;\n    transition: all 0.2s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile--selected___2k6hl {\n    background-color: #ccbaee;\n    color: #333; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile--selected___2k6hl, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile--selected___2k6hl {\n      background-color: rgba(0, 0, 0, 0.15);\n      color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile--selected___2k6hl, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile--selected___2k6hl {\n      background-color: #ccbaee;\n      color: #333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile--active___2sjgs,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o:hover:not([class*=\"background-hover-color-index-\"]) {\n    background-color: rgba(221, 221, 221, 0.5);\n    color: #000; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile--active___2sjgs, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile--active___2sjgs, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o:hover:not([class*=\"background-hover-color-index-\"]), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o:hover:not([class*=\"background-hover-color-index-\"]) {\n      background-color: rgba(0, 0, 0, 0.1);\n      color: #fff; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile--active___2sjgs, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile--active___2sjgs, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o:hover:not([class*=\"background-hover-color-index-\"]), .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo\n    .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o:hover:not([class*=\"background-hover-color-index-\"]) {\n      background-color: rgba(221, 221, 221, 0.5);\n      color: #000; }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--small___2VfqQ > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--size___vrPE3) {\n    flex-basis: 192px; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tiles--large___1W0F3 > .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o:not(.node_modules-grommet-scss-vanilla-___index__grommetux-box--size___vrPE3) {\n    flex-basis: 576px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o {\n  overflow: hidden;\n  transition: all 0.2s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d {\n    margin-right: 6px; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d {\n      margin-right: 0;\n      margin-left: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tile--selectable___TMYuL {\n  cursor: pointer;\n  transition: background-color 0.2s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tile--eclipsed___38uu6 {\n  opacity: 0.2; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-timestamp--center___2NMH4 {\n  text-align: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-timestamp--end___3G-H0 {\n  text-align: right; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-timestamp__date___1aIBD {\n  white-space: nowrap; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-timestamp__date___1aIBD + .node_modules-grommet-scss-vanilla-___index__grommetux-timestamp__time___3TaKi {\n    margin-left: 0.2em; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-timestamp__time___3TaKi {\n  text-transform: lowercase;\n  white-space: nowrap; }\n\n.node_modules-grommet-scss-vanilla-___index__grommet___1fqKV.node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop___30DEj {\n  overflow: visible;\n  max-width: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop___30DEj:after {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-left: 12px solid transparent;\n  border-right: 12px solid transparent; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--top___1CNCB {\n  transform: translateY(12px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--top___1CNCB:after {\n    content: '';\n    top: -12px;\n    border-bottom: 12px solid rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--top___1CNCB.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-1___2CTOB:after, .node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--top___1CNCB.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-3___2WZ2Y:after {\n    content: '';\n    border-bottom-color: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--top___1CNCB.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-2___2wUp8:after, .node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--top___1CNCB.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-4___1t-Vp:after {\n    content: '';\n    border-bottom-color: #FF7D28; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--bottom___1ZHAz {\n  transform: translateY(-12px); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--bottom___1ZHAz:after {\n    content: '';\n    bottom: -12px;\n    border-top: 12px solid rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--bottom___1ZHAz.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-1___2CTOB:after, .node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--bottom___1ZHAz.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-3___2WZ2Y:after {\n    content: '';\n    border-top-color: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--bottom___1ZHAz.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-2___2wUp8:after, .node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--bottom___1ZHAz.node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-4___1t-Vp:after {\n    content: '';\n    border-top-color: #FF7D28; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--left___WQ_xJ:after {\n  content: '';\n  left: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--right___3bSPu:after {\n  content: '';\n  right: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tip___6lQMN {\n  overflow: hidden; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o {\n  max-height: 100%;\n  font-weight: 300;\n  font-size: 24px;\n  font-size: 1.5rem;\n  line-height: 1;\n  line-height: initial;\n  margin-right: 12px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o {\n      font-weight: 500; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o > *:not(:last-child) {\n    margin-right: 12px; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o > *:not(:last-child) {\n      margin-right: 0px;\n      margin-left: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o a {\n    color: inherit;\n    text-decoration: none; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o a:hover {\n      text-decoration: none; }\n    [class*=\"background-color-index-\"] .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o a:hover {\n      text-decoration: underline; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o span {\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o svg,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o img {\n    max-width: 384px;\n    flex: 0 0 auto; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o svg:not(:last-child),\n    .node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o img:not(:last-child) {\n      margin-right: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-title--interactive___2MNC7 {\n  cursor: pointer; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-title--interactive___2MNC7 {\n      transition: color 0.3s ease-in-out; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-title--interactive___2MNC7:hover {\n    color: #865CD6;\n    cursor: pointer; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-title--interactive___2MNC7:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-title--interactive___2MNC7:hover {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-title--interactive___2MNC7:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-title--interactive___2MNC7:hover {\n    color: #865CD6; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-title--responsive___1l82t svg,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-title--responsive___1l82t img {\n    margin-right: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-title--responsive___1l82t > *:not(:first-child) {\n    display: none; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-title--truncate___12Z0Y {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-toast__container___2qHNe {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100; }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__toast-lower___3U-xX {\n  0% {\n    transform: translateY(-100%); }\n  100% {\n    transform: translateY(0%); } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__toast-lower___3U-xX {\n  0% {\n    transform: translateY(-100%); }\n  100% {\n    transform: translateY(0%); } }\n\n@-webkit-keyframes node_modules-grommet-scss-vanilla-___index__toast-raise___1c4hp {\n  0% {\n    transform: translateY(0%); }\n  100% {\n    transform: translateY(-100%); } }\n\n@keyframes node_modules-grommet-scss-vanilla-___index__toast-raise___1c4hp {\n  0% {\n    transform: translateY(0%); }\n  100% {\n    transform: translateY(-100%); } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-toast___267EQ {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  min-height: 72px;\n  background-color: rgba(238, 238, 238, 0.9);\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__toast-lower___3U-xX 1s;\n  animation: node_modules-grommet-scss-vanilla-___index__toast-lower___3U-xX 1s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-toast--closing___3i3VN {\n  -webkit-animation: node_modules-grommet-scss-vanilla-___index__toast-raise___1c4hp 1s;\n  animation: node_modules-grommet-scss-vanilla-___index__toast-raise___1c4hp 1s;\n  animation-fill-mode: forwards; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-toast__closer___2wDWO {\n  flex: 0 0 auto; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-toast__status___Cknf- {\n  flex: 0 0 auto;\n  margin-left: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-toast__contents___3Na0g {\n  flex: 1;\n  padding: 6px 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-toast--small___2E7xR {\n  min-height: 48px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-toast--medium___3DS1K {\n  min-height: 72px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-toast--large___aSg91 {\n  min-height: 96px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology___uJvZ8 {\n  position: relative;\n  outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology___uJvZ8 .node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d {\n    position: relative;\n    z-index: 2; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology--focus___n7egl {\n  border-color: #00CCEB;\n  box-shadow: 0 0 1px 1px #00CCEB; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__links___2AXaz {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  pointer-events: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6 {\n  stroke-width: 2px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n    stroke: #ddd;\n    stroke-dasharray: 1px 10px;\n    stroke-dashoffset: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    stroke: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    stroke: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    stroke: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    stroke: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    stroke: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n    stroke: #ffffff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n    stroke: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__path--active___Pcioz {\n  stroke-width: 6px; }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__contents___2ASjL\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--direction-row___rwM3O\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J {\n    margin-right: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-topology__contents___2ASjL\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--direction-row___rwM3O\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J:last-child {\n      margin-right: 0; } }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__contents___2ASjL\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--direction-row___rwM3O\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J {\n    margin-bottom: 48px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-topology__contents___2ASjL\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--direction-row___rwM3O\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J:last-child {\n      margin-bottom: 0; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__contents___2ASjL\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--direction-column___1IKbX\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J {\n  margin-bottom: 48px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__contents___2ASjL\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--direction-column___1IKbX\n> .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J:last-child {\n    margin-bottom: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts___vIyTZ {\n  display: flex;\n  align-items: stretch;\n  outline: none; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--direction-row___rwM3O {\n  flex-direction: row;\n  flex-grow: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--direction-column___1IKbX {\n  flex-direction: column;\n  flex-grow: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--align-start___B6dBC {\n  align-items: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--align-center___2MHaE {\n  align-items: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--align-end___5fgNg {\n  align-items: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--align-stretch___YPF-7 {\n  align-items: stretch; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J {\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  overflow: hidden;\n  outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J > .node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts___vIyTZ .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J {\n    flex: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y {\n  border: 1px solid rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y {\n    border-color: rgba(255, 255, 255, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y {\n    border-color: rgba(0, 0, 0, 0.15); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--empty___v8Irk {\n    background-color: #f5f5f5;\n    min-width: 24px;\n    min-height: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--empty___v8Irk, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--empty___v8Irk {\n      background-color: rgba(0, 0, 0, 0.15); }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--empty___v8Irk, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--empty___v8Irk {\n      background-color: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--justify-start___20-w9 {\n  justify-content: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--justify-center___2HEyj {\n  justify-content: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--justify-between___Uu2y4 {\n  justify-content: space-between; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--justify-end___2YLYw {\n  justify-content: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--align-start___1Pq_i {\n  align-items: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--align-center___1WEEB {\n  align-items: center; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--align-end___1CNsx {\n  align-items: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--align-stretch___36Y05 {\n  align-items: stretch; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--direction-row___29zY- {\n  flex-direction: row; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--direction-row___29zY-.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--reverse___HuwlQ {\n    flex-direction: row-reverse; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--direction-row___29zY- > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts___vIyTZ):not(.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J) {\n    margin: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--direction-column___3RHbM {\n  flex-direction: column; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--direction-column___3RHbM.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--reverse___HuwlQ {\n    flex-direction: column-reverse; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--direction-column___3RHbM > *:not(.node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts___vIyTZ):not(.node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J) {\n    margin: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-topology__label___39QEQ {\n  font-size: 14px;\n  margin-left: 12px;\n  margin-right: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value___3pSpv {\n  display: inline-block; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--align-start___OIQJX {\n    text-align: left; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-value--align-start___OIQJX {\n      text-align: right; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--align-center___2JpVV {\n    text-align: center; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--align-end___1saaX {\n    text-align: right; }\n    html.node_modules-grommet-scss-vanilla-___index__rtl___JTk3M .node_modules-grommet-scss-vanilla-___index__grommetux-value--align-end___1saaX {\n      text-align: left; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value--active___2mgO_ {\n  color: #000; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-value--active___2mgO_, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-value--active___2mgO_ {\n    color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-value--active___2mgO_, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-value--active___2mgO_ {\n    color: #000; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  font-size: 36px;\n  font-size: 2.25rem;\n  line-height: 1.33333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:first-child {\n    margin-right: 6px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:last-child {\n    margin-left: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value__label___3Hfrz {\n  display: inline-block;\n  margin-top: 6px;\n  font-size: 19px;\n  font-size: 1.1875rem;\n  line-height: 1.26316; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value__value___3S7Cj {\n  font-weight: 500; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value__units___3smbH {\n  margin-left: 0.5rem;\n  font-weight: 300; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value--align-start___OIQJX .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND {\n  justify-content: flex-start; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value--align-end___1saaX .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND {\n  justify-content: flex-end; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value--xsmall___3XyUc .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND {\n  font-size: 20px;\n  font-size: 1.25rem;\n  line-height: 1.2; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value--xsmall___3XyUc .node_modules-grommet-scss-vanilla-___index__grommetux-value__label___3Hfrz {\n  margin-top: 6px;\n  font-size: 14px;\n  font-size: 0.875rem;\n  line-height: 1.71429; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value--small___vXUNE .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND {\n  font-size: 24px;\n  font-size: 1.5rem;\n  line-height: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value--small___vXUNE .node_modules-grommet-scss-vanilla-___index__grommetux-value__label___3Hfrz {\n  margin-top: 6px;\n  font-size: 14px;\n  font-size: 0.875rem;\n  line-height: 1.71429; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value--large___1AeJu .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND {\n  font-size: 72px;\n  font-size: 4.5rem;\n  line-height: 1; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--large___1AeJu .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:first-child {\n    margin-right: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--large___1AeJu .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:last-child {\n    margin-left: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value--large___1AeJu .node_modules-grommet-scss-vanilla-___index__grommetux-value__label___3Hfrz {\n  margin-top: 12px;\n  font-size: 24px;\n  font-size: 1.5rem;\n  line-height: 1; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-value--align-center___2JpVV {\n  justify-content: center; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--align-center___2JpVV .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND {\n    justify-content: center; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND {\n    font-size: 72px;\n    font-size: 4.5rem;\n    line-height: 1; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:first-child {\n      margin-right: 12px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:last-child {\n      margin-left: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__label___3Hfrz {\n    margin-top: 12px;\n    font-size: 24px;\n    font-size: 1.5rem;\n    line-height: 1; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--responsive___24clx.node_modules-grommet-scss-vanilla-___index__grommetux-value--large___1AeJu .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND, .node_modules-grommet-scss-vanilla-___index__grommetux-value--responsive___24clx.node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND {\n    font-size: 36px;\n    font-size: 2.25rem;\n    line-height: 1.33333; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-value--responsive___24clx.node_modules-grommet-scss-vanilla-___index__grommetux-value--large___1AeJu .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:first-child, .node_modules-grommet-scss-vanilla-___index__grommetux-value--responsive___24clx.node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:first-child {\n      margin-right: 6px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-value--responsive___24clx.node_modules-grommet-scss-vanilla-___index__grommetux-value--large___1AeJu .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:last-child, .node_modules-grommet-scss-vanilla-___index__grommetux-value--responsive___24clx.node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:last-child {\n      margin-left: 6px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--responsive___24clx.node_modules-grommet-scss-vanilla-___index__grommetux-value--large___1AeJu .node_modules-grommet-scss-vanilla-___index__grommetux-value__label___3Hfrz, .node_modules-grommet-scss-vanilla-___index__grommetux-value--responsive___24clx.node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__label___3Hfrz {\n    margin-top: 6px;\n    font-size: 19px;\n    font-size: 1.1875rem;\n    line-height: 1.26316; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND {\n    font-size: 192px;\n    font-size: 12rem;\n    line-height: 1; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:first-child {\n      margin-right: 24px; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND .node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n:last-child {\n      margin-left: 24px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf .node_modules-grommet-scss-vanilla-___index__grommetux-value__label___3Hfrz {\n    margin-top: 24px;\n    font-size: 36px;\n    font-size: 2.25rem;\n    line-height: 1.33333; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video___38nQp {\n  position: relative;\n  max-width: 100%;\n  height: auto; }\n  @media screen and (max-width: 44.9375em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-video___38nQp {\n      max-width: 100%;\n      width: 100vw; } }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video___38nQp video {\n    max-width: 100%;\n    display: block; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--small___33gYA {\n  width: 192px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--small___33gYA video {\n    width: 192px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--medium___1pnm3 {\n  width: 384px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--medium___1pnm3 video {\n    width: 384px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--large___mLq6I {\n  width: 576px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--large___mLq6I video {\n    width: 576px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--full___13lVr {\n  width: 100%;\n  height: 100%;\n  min-width: 100%;\n  min-height: 100%; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--full___13lVr video {\n    width: 100%;\n    height: 100%;\n    min-width: 100%;\n    min-height: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc video {\n  object-position: 0 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd video {\n  object-position: 100% 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd) video {\n  object-position: 50% 0%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc video {\n  object-position: 0 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd video {\n  object-position: 100% 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd) video {\n  object-position: 50% 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl) video {\n  object-position: 0 50%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl) video {\n  object-position: 100% 50%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--cover___3C6SA video {\n  object-fit: cover; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--contain___2IJXy video {\n  object-fit: contain; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__button___1meT4:hover .node_modules-grommet-scss-vanilla-___index__grommetux-video__button__icon___3xOl4 {\n  fill: #865CD6;\n  stroke: #865CD6; }\n\n@media screen and (max-width: 44.9375em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video__timeline___2UvvC {\n    visibility: hidden; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--has-timeline___2gvG6 {\n    bottom: 0px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video__controls___cYj3N,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video__replay___1aGIN {\n    display: none; } }\n\n@media screen and (min-width: 45em) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--has-timeline___2gvG6 {\n    bottom: 72px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--has-played___1o_59:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--small___33gYA):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--ended___Rljb8) .node_modules-grommet-scss-vanilla-___index__grommetux-video__play___1Zewt,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--small___33gYA .node_modules-grommet-scss-vanilla-___index__grommetux-video__controls___cYj3N,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--small___33gYA .node_modules-grommet-scss-vanilla-___index__grommetux-video__replay___1aGIN {\n    display: none; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__overlay___1XHrF {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 24px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__controls___cYj3N {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__controls-primary___hOiNI {\n  height: 72px;\n  background-color: rgba(0, 0, 1, 0.9);\n  color: #fff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video__controls-primary___hOiNI h3 {\n    font-weight: 500; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL {\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  bottom: 72px;\n  height: 6px;\n  background-color: rgba(110, 110, 110, 0.7);\n  transition: height 0.3s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL + .node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-labels___30phc,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL ~ .node_modules-grommet-scss-vanilla-___index__grommetux-video__controls-primary___hOiNI {\n    transition: ease-in-out 0.3s; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL input[type=range] {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    border: none;\n    cursor: pointer;\n    outline: none;\n    z-index: 30; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL:hover {\n  height: 12px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL:hover .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress-bar-fill___30pL3:after {\n    opacity: 1; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL:hover + .node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-labels___30phc {\n    visibility: visible; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__progress-bar-fill___30pL3 {\n  width: 100%;\n  height: 100%;\n  background-color: #865CD6;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  transition: width 0.3s;\n  z-index: 10; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress-bar-fill___30pL3:after {\n    content: '';\n    display: block;\n    position: absolute;\n    right: -12px;\n    top: -6px;\n    width: 24px;\n    height: 24px;\n    background-color: #865CD6;\n    border-radius: 48px;\n    opacity: 0;\n    transition: opacity 0.4s ease-in-out;\n    z-index: 20; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-labels___30phc {\n  position: absolute;\n  bottom: 0px;\n  width: 100%;\n  height: 72px;\n  visibility: hidden;\n  background-color: rgba(0, 0, 1, 0.9);\n  transition: 0.4s ease-in-out; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-labels___30phc span {\n    display: block;\n    color: rgba(255, 255, 255, 0.85); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-label___IbOnh {\n  position: absolute;\n  top: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-label-start___140z5 span {\n  margin-left: 12px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-label-active___3rKev span {\n  color: #fff;\n  transition: ease-in-out 0.3s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker___isxpR {\n  position: absolute;\n  height: 100%;\n  left: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker-track___2bbax {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  transition: ease-in-out 0.3s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker-tick___1s3kH:hover + .node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker-track___2bbax {\n  background-color: rgba(161, 161, 161, 0.7); }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker-tick___1s3kH {\n  position: absolute;\n  right: -3px;\n  width: 3px;\n  height: 100%;\n  z-index: 40;\n  transition: ease-in-out 0.3s;\n  cursor: pointer;\n  background-color: #fff; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker-tick-start___2rNcP {\n  right: auto;\n  left: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker-tickhover___2lZha {\n  width: 8px;\n  right: -8px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--playing___3UcHd:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF) .node_modules-grommet-scss-vanilla-___index__grommetux-video__controls-primary___hOiNI,\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--playing___3UcHd:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF) .node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-labels___30phc,\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--playing___3UcHd:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF) .node_modules-grommet-scss-vanilla-___index__grommetux-video__overlay___1XHrF {\n  opacity: 0;\n  transition: opacity 1s ease-in-out; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--playing___3UcHd:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF) .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL {\n  bottom: 0px;\n  transition: ease-in-out 1s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--ended___Rljb8:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF) .node_modules-grommet-scss-vanilla-___index__grommetux-video__controls-primary___hOiNI,\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--ended___Rljb8:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF) .node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-labels___30phc {\n  opacity: 0;\n  transition: opacity 1s ease-in-out; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--ended___Rljb8:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF) .node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL {\n  bottom: 0px;\n  transition: ease-in-out 1s; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-video--ended___Rljb8 .node_modules-grommet-scss-vanilla-___index__grommetux-video__overlay___1XHrF {\n  background-color: rgba(0, 0, 1, 0.7);\n  color: rgba(255, 255, 255, 0.85); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--ended___Rljb8 .node_modules-grommet-scss-vanilla-___index__grommetux-video__overlay___1XHrF .node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F {\n    width: auto; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--ended___Rljb8 .node_modules-grommet-scss-vanilla-___index__grommetux-video__overlay___1XHrF .node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk {\n    background-color: transparent;\n    border: 2px solid rgba(255, 255, 255, 0.5); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--ended___Rljb8 .node_modules-grommet-scss-vanilla-___index__grommetux-video__overlay___1XHrF .node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz input {\n    font-size: 19px;\n    font-size: 1.1875rem;\n    line-height: 1.26316;\n    color: rgba(255, 255, 255, 0.85);\n    text-align: center; }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--full___13lVr video {\n    width: auto;\n    height: auto;\n    max-width: none;\n    position: relative;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc video {\n    top: 0%;\n    left: 0%;\n    transform: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd video {\n    top: 0%;\n    left: 100%;\n    transform: translate(-100%, 0%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd) video {\n    top: 0%;\n    left: 50%;\n    transform: translateX(-50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc video {\n    top: 100%;\n    left: 0%;\n    transform: translate(0%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd video {\n    top: 100%;\n    left: 100%;\n    transform: translate(-100%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd) video {\n    top: 100%;\n    left: 50%;\n    transform: translate(-50%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl) video {\n    top: 50%;\n    left: 0%;\n    transform: translate(0%, -50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl) video {\n    top: 50%;\n    left: 100%;\n    transform: translate(-100%, -50%); } }\n\n@supports (-ms-ime-align: auto) {\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--full___13lVr video {\n    width: auto;\n    height: auto;\n    max-width: none;\n    position: relative;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc video {\n    top: 0%;\n    left: 0%;\n    transform: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd video {\n    top: 0%;\n    left: 100%;\n    transform: translate(-100%, 0%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd) video {\n    top: 0%;\n    left: 50%;\n    transform: translateX(-50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc video {\n    top: 100%;\n    left: 0%;\n    transform: translate(0%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd video {\n    top: 100%;\n    left: 100%;\n    transform: translate(-100%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd) video {\n    top: 100%;\n    left: 50%;\n    transform: translate(-50%, -100%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl) video {\n    top: 50%;\n    left: 0%;\n    transform: translate(0%, -50%); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd:not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk):not(.node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl) video {\n    top: 50%;\n    left: 100%;\n    transform: translate(-100%, -50%); } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-world-map___aT_Ot {\n  width: 100%; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-world-map___aT_Ot {\n      padding-bottom: 49%;\n      height: 1px; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-world-map__container___1NIu9 {\n  position: relative;\n  width: 100%; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-world-map__flag___q0by7 {\n  position: absolute;\n  top: 0px;\n  left: 0px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty,\n.node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN {\n  stroke-linecap: round;\n  transition: stroke-width 0.3s;\n  outline: none; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG {\n    stroke: #ddd;\n    stroke-dasharray: 1px 10px;\n    stroke-dashoffset: 0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA {\n    stroke: #ddd; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S {\n    stroke: #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M {\n    stroke: #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8 {\n    stroke: #FFD602; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM {\n    stroke: #8CC800; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH {\n    stroke: #a8a8a8; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm {\n    stroke: #000001; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp {\n    stroke: #333333; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf {\n    stroke: #3B3B3B; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR {\n    stroke: #434343; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW {\n    stroke: #666666; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33 {\n    stroke: #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw {\n    stroke: #FF7D28; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP {\n    stroke: #0A64A0; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO {\n    stroke: #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4 {\n    stroke: #501EB4; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB {\n    stroke: #49516F; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F {\n    stroke: #ffffff; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn, .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn,\n  .node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN.node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne {\n    stroke: #f5f5f5; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty {\n  stroke-width: 6px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN {\n  stroke-width: 8px; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent--active___2Ym7K {\n  stroke-width: 8px;\n  cursor: pointer; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place--active___2ZDfw {\n  stroke-width: 20px;\n  cursor: pointer; }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb {\n  border-radius: 5px; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu):hover {\n    box-shadow: 0px 0px 0px 2px #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover {\n    box-shadow: 0px 0px 0px 2px #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--secondary___axUJo:hover {\n    box-shadow: 0px 0px 0px 2px #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--accent___4ZYZJ:hover {\n    box-shadow: 0px 0px 0px 2px #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--critical___Y1RQw:hover {\n    box-shadow: 0px 0px 0px 2px #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu):hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu):hover {\n    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.7); }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover {\n    box-shadow: 0px 0px 0px 2px #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--secondary___axUJo:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--secondary___axUJo:hover {\n    box-shadow: 0px 0px 0px 2px #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--accent___4ZYZJ:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--accent___4ZYZJ:hover {\n    box-shadow: 0px 0px 0px 2px #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--critical___Y1RQw, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--critical___Y1RQw {\n    border-color: #FF324D; }\n    .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--critical___Y1RQw:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--critical___Y1RQw:hover {\n      box-shadow: 0px 0px 0px 2px #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu):hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu):hover {\n    box-shadow: 0px 0px 0px 2px #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb:hover {\n    box-shadow: 0px 0px 0px 2px #865CD6; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--secondary___axUJo:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--secondary___axUJo:hover {\n    box-shadow: 0px 0px 0px 2px #DC2878; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--accent___4ZYZJ:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--accent___4ZYZJ:hover {\n    box-shadow: 0px 0px 0px 2px #00CCEB; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--critical___Y1RQw:hover, .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh .node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo .node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu).node_modules-grommet-scss-vanilla-___index__grommetux-button--critical___Y1RQw:hover {\n    box-shadow: 0px 0px 0px 2px #FF324D; }\n  .node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc):hover {\n    padding: 4px 20px;\n    border-width: 4px; }\n  @media screen and (min-width: 45em) {\n    .node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu:not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h):not(.node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc) {\n      transition: none; } }\n\n.node_modules-grommet-scss-vanilla-___index__grommetux-tab__button___3epIV {\n  border-radius: 0; }\n", ""]);

// exports
exports.locals = {
	"grommet": "node_modules-grommet-scss-vanilla-___index__grommet___1fqKV",
	"brand-font": "node_modules-grommet-scss-vanilla-___index__brand-font___2JXMh",
	"rtl": "node_modules-grommet-scss-vanilla-___index__rtl___JTk3M",
	"large-number-font": "node_modules-grommet-scss-vanilla-___index__large-number-font___kxpuQ",
	"secondary": "node_modules-grommet-scss-vanilla-___index__secondary___231_M",
	"error": "node_modules-grommet-scss-vanilla-___index__error___1IV6T",
	"grommetux-background-color-index--dark": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--dark___182Bh",
	"grommetux-background-color-index--light": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--light___2mObo",
	"grommetux-heading": "node_modules-grommet-scss-vanilla-___index__grommetux-heading___2MWRT",
	"grommetux-anchor": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor___3agmm",
	"grommetux-paragraph": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph___pTOKK",
	"grommetux-button": "node_modules-grommet-scss-vanilla-___index__grommetux-button___3Oeyb",
	"plain": "node_modules-grommet-scss-vanilla-___index__plain___1tQU1",
	"active": "node_modules-grommet-scss-vanilla-___index__active___3wnBd",
	"grommetux-background-color-index--pending": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index--pending___29zju",
	"grommetux-input": "node_modules-grommet-scss-vanilla-___index__grommetux-input___2GiHB",
	"grommetux-check-box__input": "node_modules-grommet-scss-vanilla-___index__grommetux-check-box__input___2hFsA",
	"grommetux-button--box": "node_modules-grommet-scss-vanilla-___index__grommetux-button--box___2mqjv",
	"grommetux-accordion-panel": "node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel___2V06l",
	"grommetux-accordion-panel__header": "node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__header___V7VaW",
	"grommetux-accordion-panel--active": "node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel--active___CAwbw",
	"grommetux-accordion-panel__control": "node_modules-grommet-scss-vanilla-___index__grommetux-accordion-panel__control___2h5eG",
	"grommetux-anchor__icon": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor__icon___2pjpS",
	"grommetux-control-icon": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon___3kW1n",
	"grommetux-anchor--animate-icon": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor--animate-icon___12b0a",
	"grommetux-anchor--icon": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon___19BSv",
	"grommetux-anchor--primary": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor--primary___32gyz",
	"grommetux-anchor--icon-label": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor--icon-label___3k9IB",
	"grommetux-anchor--reverse": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor--reverse___3ilIu",
	"grommetux-anchor--disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor--disabled___3R4i6",
	"grommetux-anchor--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor--align-start___1w3FJ",
	"grommetux-anchor--align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor--align-center___FH67j",
	"grommetux-anchor--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor--align-end___2N2aE",
	"grommetux-animate": "node_modules-grommet-scss-vanilla-___index__grommetux-animate___2kqa3",
	"grommetux-animate__child": "node_modules-grommet-scss-vanilla-___index__grommetux-animate__child___3b_RB",
	"grommetux-animate__child--inactive": "node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--inactive___1BUe8",
	"grommetux-animate__child--fade": "node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--fade___2xKvQ",
	"grommetux-animate__child--leave": "node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--leave___31UBL",
	"grommetux-animate__child--slide-up": "node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-up___37w4G",
	"grommetux-animate__child--slide-down": "node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-down___cOfKS",
	"grommetux-animate__child--slide-left": "node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-left___GqUV-",
	"grommetux-animate__child--slide-right": "node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--slide-right___2EX3Q",
	"grommetux-animate__child--jiggle": "node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--jiggle___1ts35",
	"grommetux-animate__child--enter": "node_modules-grommet-scss-vanilla-___index__grommetux-animate__child--enter___3Vh87",
	"jiggle": "node_modules-grommet-scss-vanilla-___index__jiggle___19nPx",
	"grommetux-app": "node_modules-grommet-scss-vanilla-___index__grommetux-app___1JU9n",
	"grommetux-app--hidden": "node_modules-grommet-scss-vanilla-___index__grommetux-app--hidden___wpWno",
	"grommetux-app--inline": "node_modules-grommet-scss-vanilla-___index__grommetux-app--inline___2Ake7",
	"grommetux-app--centered": "node_modules-grommet-scss-vanilla-___index__grommetux-app--centered___3b8tp",
	"grommetux-app__announcer": "node_modules-grommet-scss-vanilla-___index__grommetux-app__announcer___pUKfb",
	"grommetux-article": "node_modules-grommet-scss-vanilla-___index__grommetux-article___3d3Qx",
	"grommetux-article--scroll-step": "node_modules-grommet-scss-vanilla-___index__grommetux-article--scroll-step___2VT4Z",
	"grommetux-box--direction-column": "node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-column___sSPNY",
	"grommetux-article__control-carousel": "node_modules-grommet-scss-vanilla-___index__grommetux-article__control-carousel___l-VTH",
	"grommetux-box--direction-row": "node_modules-grommet-scss-vanilla-___index__grommetux-box--direction-row___1AG40",
	"grommetux-article__controls": "node_modules-grommet-scss-vanilla-___index__grommetux-article__controls___2SdMd",
	"grommetux-box--responsive": "node_modules-grommet-scss-vanilla-___index__grommetux-box--responsive___3EWqr",
	"grommetux-article__control": "node_modules-grommet-scss-vanilla-___index__grommetux-article__control___31WJu",
	"grommetux-button--plain": "node_modules-grommet-scss-vanilla-___index__grommetux-button--plain___2p0Zc",
	"grommetux-button--icon": "node_modules-grommet-scss-vanilla-___index__grommetux-button--icon___2GeB8",
	"grommetux-button__icon": "node_modules-grommet-scss-vanilla-___index__grommetux-button__icon___2SdLz",
	"grommetux-article__control-up": "node_modules-grommet-scss-vanilla-___index__grommetux-article__control-up___26WDU",
	"grommetux-article__control-down": "node_modules-grommet-scss-vanilla-___index__grommetux-article__control-down___zm35R",
	"grommetux-article__control-left": "node_modules-grommet-scss-vanilla-___index__grommetux-article__control-left___8HVmH",
	"grommetux-article__control-right": "node_modules-grommet-scss-vanilla-___index__grommetux-article__control-right___3YQ5b",
	"grommetux-box": "node_modules-grommet-scss-vanilla-___index__grommetux-box___11xrE",
	"grommetux-box--pad-none": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-none___WhL55",
	"grommetux-box--pad-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-small___9HTrM",
	"grommetux-box--pad-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-medium___2CaW3",
	"grommetux-box--pad-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-large___2H8Sh",
	"grommetux-box--pad-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-xlarge___2gnsW",
	"grommetux-box--pad-horizontal-none": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-none___14Nye",
	"grommetux-box--pad-horizontal-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-small___ZTQox",
	"grommetux-box--pad-horizontal-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-medium___mWDSL",
	"grommetux-box--pad-horizontal-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-large___2noOk",
	"grommetux-box--pad-horizontal-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-horizontal-xlarge___2gs1S",
	"grommetux-box--pad-vertical-none": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-none___2E7q7",
	"grommetux-box--pad-vertical-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-small___1DTEb",
	"grommetux-box--pad-vertical-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-medium___1NShl",
	"grommetux-box--pad-vertical-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-large___3tKMi",
	"grommetux-box--pad-vertical-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-vertical-xlarge___23bDx",
	"grommetux-box--margin-none": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-none___1AP4t",
	"grommetux-box--margin-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-small___nOST6",
	"grommetux-box--margin-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-medium___3XmxR",
	"grommetux-box--margin-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-large___23XVG",
	"grommetux-box--margin-horizontal-none": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-none___18bIB",
	"grommetux-box--margin-horizontal-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-small___YHCWk",
	"grommetux-box--margin-horizontal-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-medium___37i-B",
	"grommetux-box--margin-horizontal-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-horizontal-large___2fh34",
	"grommetux-box--margin-vertical-none": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-none___2JhZL",
	"grommetux-box--margin-vertical-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-small___lqR3W",
	"grommetux-box--margin-vertical-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-medium___26WMX",
	"grommetux-box--margin-vertical-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-vertical-large___3YDnj",
	"grommetux-box--margin-left-none": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-none___1ML-L",
	"grommetux-box--margin-left-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-small___2J3b1",
	"grommetux-box--margin-left-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-medium___oq98D",
	"grommetux-box--margin-left-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-left-large___xTVXM",
	"grommetux-box--margin-right-none": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-none___1j3Fo",
	"grommetux-box--margin-right-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-small___1Tm2-",
	"grommetux-box--margin-right-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-medium___23cjg",
	"grommetux-box--margin-right-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-right-large___2XA-I",
	"grommetux-box--margin-top-none": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-none___c35af",
	"grommetux-box--margin-top-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-small___1WG3y",
	"grommetux-box--margin-top-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-medium___2RPjl",
	"grommetux-box--margin-top-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-top-large___jW4Ay",
	"grommetux-box--margin-bottom-none": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-none___26MBn",
	"grommetux-box--margin-bottom-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-small___3aTRc",
	"grommetux-box--margin-bottom-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-medium___Kx0bE",
	"grommetux-box--margin-bottom-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--margin-bottom-large___221OT",
	"grommetux-box__texture": "node_modules-grommet-scss-vanilla-___index__grommetux-box__texture___2DZRq",
	"grommetux-box--separator-top": "node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-top___2x5Mu",
	"grommetux-box--separator-horizontal": "node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-horizontal___37tvS",
	"grommetux-box--separator-all": "node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-all___MtEFx",
	"grommetux-box--separator-bottom": "node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-bottom___3FHY5",
	"grommetux-box--separator-left": "node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-left____0mVA",
	"grommetux-box--separator-vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-vertical___8kp2H",
	"grommetux-box--separator-right": "node_modules-grommet-scss-vanilla-___index__grommetux-box--separator-right___2U-kl",
	"grommetux-box--clickable": "node_modules-grommet-scss-vanilla-___index__grommetux-box--clickable___1m8TH",
	"grommetux-box--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-box--focus___3EE0K",
	"grommetux-box__container": "node_modules-grommet-scss-vanilla-___index__grommetux-box__container___3Nh2J",
	"grommetux-box__container--full": "node_modules-grommet-scss-vanilla-___index__grommetux-box__container--full___1BGE_",
	"grommetux-box__container--full-horizontal": "node_modules-grommet-scss-vanilla-___index__grommetux-box__container--full-horizontal___wQ2wL",
	"grommetux-box--flex": "node_modules-grommet-scss-vanilla-___index__grommetux-box--flex___EH90-",
	"grommetux-box--flex-off": "node_modules-grommet-scss-vanilla-___index__grommetux-box--flex-off___2I2MH",
	"grommetux-box--flex-grow": "node_modules-grommet-scss-vanilla-___index__grommetux-box--flex-grow___2Y4pf",
	"grommetux-box--flex-shrink": "node_modules-grommet-scss-vanilla-___index__grommetux-box--flex-shrink___O8BcS",
	"grommetux-box--basis-xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-xsmall___37T3t",
	"grommetux-box--basis-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-small___ckFqx",
	"grommetux-box--basis-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-medium___gHBOj",
	"grommetux-box--basis-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-large___uOWk0",
	"grommetux-box--basis-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-xlarge____9d2W",
	"grommetux-box--basis-xxlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-xxlarge___pceEt",
	"grommetux-box--basis-full": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-full___27EVQ",
	"grommetux-box--basis-1-2": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-2___1F1he",
	"grommetux-box--basis-1-3": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-3___nz-NA",
	"grommetux-box--basis-2-3": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-2-3___3aJTP",
	"grommetux-box--basis-1-4": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-1-4___2NQkg",
	"grommetux-box--basis-3-4": "node_modules-grommet-scss-vanilla-___index__grommetux-box--basis-3-4___3Lc2F",
	"grommetux-box--width-xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-xsmall___2XU0e",
	"grommetux-box--width-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-small___2jXug",
	"grommetux-box--width-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-medium___n7d-J",
	"grommetux-box--width-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-large___hNo7P",
	"grommetux-box--width-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-xlarge___39uIL",
	"grommetux-box--width-xxlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-xxlarge___XtiQx",
	"grommetux-box--height-xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-xsmall___1iAyR",
	"grommetux-box--height-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-small___1LXC0",
	"grommetux-box--height-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-medium___1HNxK",
	"grommetux-box--height-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-large___WP-Gi",
	"grommetux-box--height-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-xlarge___PBDCr",
	"grommetux-box--height-xxlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-xxlarge___2C4wn",
	"grommetux-box--width-min-xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-xsmall___2vIXA",
	"grommetux-box--width-min-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-small___Dg5R0",
	"grommetux-box--width-min-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-medium___3m06f",
	"grommetux-box--width-min-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-large___2IZ29",
	"grommetux-box--width-min-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-xlarge___1zbq1",
	"grommetux-box--width-min-xxlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-min-xxlarge___2dE6q",
	"grommetux-box--width-max-xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-xsmall___EsAch",
	"grommetux-box--width-max-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-small___2e_6D",
	"grommetux-box--width-max-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-medium___UPJBO",
	"grommetux-box--width-max-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-large___1vEh8",
	"grommetux-box--width-max-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-xlarge___BGB0s",
	"grommetux-box--width-max-xxlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--width-max-xxlarge___thMwt",
	"grommetux-box--height-max-xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-xsmall___3whiT",
	"grommetux-box--height-max-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-small___2OAIU",
	"grommetux-box--height-max-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-medium___vkySM",
	"grommetux-box--height-max-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-large___tXcwR",
	"grommetux-box--height-max-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-xlarge___1kkLL",
	"grommetux-box--height-max-xxlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-max-xxlarge___3v2-u",
	"grommetux-box--height-min-xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-xsmall___3IL_R",
	"grommetux-box--height-min-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-small___-_4YQ",
	"grommetux-box--height-min-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-medium___2JwUy",
	"grommetux-box--height-min-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-large___1mBY1",
	"grommetux-box--height-min-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-xlarge___2wYHm",
	"grommetux-box--height-min-xxlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--height-min-xxlarge___3P-g-",
	"grommetux-box--full": "node_modules-grommet-scss-vanilla-___index__grommetux-box--full___3HxaS",
	"grommetux-box--full-responsive": "node_modules-grommet-scss-vanilla-___index__grommetux-box--full-responsive___3Hq8D",
	"grommetux-box--full-horizontal": "node_modules-grommet-scss-vanilla-___index__grommetux-box--full-horizontal___jeIRC",
	"grommetux-box--full-vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-box--full-vertical___1Tgo1",
	"grommetux-box--size": "node_modules-grommet-scss-vanilla-___index__grommetux-box--size___vrPE3",
	"grommet-namespaceparagraph": "node_modules-grommet-scss-vanilla-___index__grommet-namespaceparagraph___1e4N0",
	"grommetux-box--size-xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-box--size-xsmall___2nAlv",
	"grommetux-box--size-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--size-small___1_mei",
	"grommetux-box--size-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--size-medium___1hh1W",
	"grommetux-box--size-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--size-large___qpMId",
	"grommetux-box--size-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--size-xlarge___37Hxy",
	"grommetux-box--size-xxlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-box--size-xxlarge___2ZrO_",
	"grommetux-box--size-auto": "node_modules-grommet-scss-vanilla-___index__grommetux-box--size-auto___25Fua",
	"grommetux-box--text-align-left": "node_modules-grommet-scss-vanilla-___index__grommetux-box--text-align-left___2twSb",
	"grommetux-box--text-align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-box--text-align-center___2tJUj",
	"grommetux-box--text-align-right": "node_modules-grommet-scss-vanilla-___index__grommetux-box--text-align-right___WlJ0z",
	"grommetux-box--wrap": "node_modules-grommet-scss-vanilla-___index__grommetux-box--wrap___yEl4n",
	"grommetux-box--reverse": "node_modules-grommet-scss-vanilla-___index__grommetux-box--reverse___Am_kG",
	"grommetux-box--justify-center": "node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-center___2p-7h",
	"grommetux-box--justify-start": "node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-start___1n6Ey",
	"grommetux-box--justify-between": "node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-between___1uom-",
	"grommetux-box--justify-around": "node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-around___2e7zC",
	"grommetux-box--justify-end": "node_modules-grommet-scss-vanilla-___index__grommetux-box--justify-end___2yPeZ",
	"grommetux-box--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-start___S2sIS",
	"grommetux-box--align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-center___3vH0y",
	"grommetux-box--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-end___uF0AX",
	"grommetux-box--align-baseline": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-baseline___28mNd",
	"grommetux-box--align-stretch": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-stretch___2xsGT",
	"grommetux-box--align-content-start": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-start___3Bsx2",
	"grommetux-box--align-content-end": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-end___2xPWh",
	"grommetux-box--align-content-center": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-center___3H-6A",
	"grommetux-box--align-content-between": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-between___1dKMK",
	"grommetux-box--align-content-around": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-around___3tbFj",
	"grommetux-box--align-content-stretch": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-content-stretch___2mZqq",
	"grommetux-box--align-self-start": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-self-start___1vkT-",
	"grommetux-box--align-self-end": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-self-end___fa4Q1",
	"grommetux-box--align-self-center": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-self-center___1eZ6F",
	"grommetux-box--align-self-stretch": "node_modules-grommet-scss-vanilla-___index__grommetux-box--align-self-stretch___WZ8oN",
	"grommetux-box--pad-between-small": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-small___2R1S_",
	"grommetux-box--pad-between-thirds": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-thirds___2bUsi",
	"grommetux-box--pad-between-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-medium___xKTcq",
	"grommetux-box--pad-between-large": "node_modules-grommet-scss-vanilla-___index__grommetux-box--pad-between-large___1gRxZ",
	"grommetux-button--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-button--focus___m2-7z",
	"grommetux-button--hover-background": "node_modules-grommet-scss-vanilla-___index__grommetux-button--hover-background___19o2_",
	"grommetux-button--secondary": "node_modules-grommet-scss-vanilla-___index__grommetux-button--secondary___axUJo",
	"grommetux-button--accent": "node_modules-grommet-scss-vanilla-___index__grommetux-button--accent___4ZYZJ",
	"grommetux-button--critical": "node_modules-grommet-scss-vanilla-___index__grommetux-button--critical___Y1RQw",
	"grommetux-button--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-button--align-start___2jUOL",
	"grommetux-button__label": "node_modules-grommet-scss-vanilla-___index__grommetux-button__label___3JwZq",
	"grommetux-button--primary": "node_modules-grommet-scss-vanilla-___index__grommetux-button--primary___1QZQb",
	"grommetux-button--disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-button--disabled___1Fg_h",
	"grommetux-button--fill": "node_modules-grommet-scss-vanilla-___index__grommetux-button--fill___AGwMu",
	"grommetux-card": "node_modules-grommet-scss-vanilla-___index__grommetux-card___CSqE6",
	"grommetux-card__thumbnail": "node_modules-grommet-scss-vanilla-___index__grommetux-card__thumbnail___33rcB",
	"grommetux-card__content--truncate": "node_modules-grommet-scss-vanilla-___index__grommetux-card__content--truncate___AXNwW",
	"grommetux-paragraph--small": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--small___3NGjw",
	"grommetux-paragraph--large": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--large___1OYzn",
	"grommetux-paragraph--xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--xlarge___3fjzU",
	"grommetux-card--direction-row": "node_modules-grommet-scss-vanilla-___index__grommetux-card--direction-row___3a7Dm",
	"grommetux-card--selectable": "node_modules-grommet-scss-vanilla-___index__grommetux-card--selectable___3fB2R",
	"grommetux-card__content": "node_modules-grommet-scss-vanilla-___index__grommetux-card__content___19dtA",
	"grommetux-carousel": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel___2RTh2",
	"grommetux-tiles": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles___3JnEw",
	"grommetux-tile": "node_modules-grommet-scss-vanilla-___index__grommetux-tile___3S98o",
	"grommetux-carousel__item": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel__item___2SHuf",
	"grommetux-control-icon-next": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-next___2Vb_j",
	"grommetux-control-icon-previous": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-previous___1W2jK",
	"grommetux-carousel-controls__control": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel-controls__control___2c3dH",
	"grommetux-carousel-controls__control--active": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel-controls__control--active___YXzMe",
	"grommetux-carousel__track": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel__track___1r5Kd",
	"grommetux-carousel__track--animate": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel__track--animate___7XgVn",
	"grommetux-carousel__arrow": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel__arrow___2w0Hp",
	"carousel-reveal": "node_modules-grommet-scss-vanilla-___index__carousel-reveal___1lYPu",
	"grommetux-carousel__arrow--next": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel__arrow--next___3Q1_8",
	"grommetux-carousel__arrow--prev": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel__arrow--prev___1xbcc",
	"grommetux-carousel__controls": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel__controls___3S5vw",
	"grommetux-carousel__control": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel__control___Eyr8n",
	"grommetux-carousel__control--active": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel__control--active___Z_imi",
	"grommetux-carousel--hide-controls": "node_modules-grommet-scss-vanilla-___index__grommetux-carousel--hide-controls___2Goza",
	"carousel-hide": "node_modules-grommet-scss-vanilla-___index__carousel-hide___6fxWp",
	"grommetux-layer": "node_modules-grommet-scss-vanilla-___index__grommetux-layer___147u1",
	"grommetux-chart": "node_modules-grommet-scss-vanilla-___index__grommetux-chart___J6xYl",
	"grommetux-chart--full": "node_modules-grommet-scss-vanilla-___index__grommetux-chart--full___3rTwx",
	"grommetux-chart--vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-chart--vertical___1WwUH",
	"grommetux-chart-base": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base___MEHK_",
	"grommetux-chart-base--vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--vertical___jeqOL",
	"grommetux-chart-base--width-small": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-small___1EOmU",
	"grommetux-chart-base--width-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-medium___3qdLQ",
	"grommetux-chart-base--width-large": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-large___hZs0V",
	"grommetux-chart-base--width-full": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-full___1i7oc",
	"grommetux-chart-base--height-xxsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-xxsmall___2hoEj",
	"grommetux-chart-base--height-xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-xsmall___3o-4v",
	"grommetux-chart-base--height-small": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-small___aHEPI",
	"grommetux-chart-base--height-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-medium___2cXoR",
	"grommetux-chart-base--height-large": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-large___GpCcT",
	"grommetux-chart-base--height-sparkline": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--height-sparkline____z01a",
	"grommetux-chart-base--width-xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-base--width-xsmall___3We-J",
	"grommetux-chart-axis": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis___gZ97V",
	"grommetux-chart-axis__slot": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot___3NUKV",
	"grommetux-chart-axis--ticks": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks___2by8r",
	"grommetux-chart-axis--vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--vertical___2y7tB",
	"grommetux-chart-axis--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--align-start___17z7R",
	"grommetux-chart-axis--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--align-end___1-7gj",
	"grommetux-chart-axis__slot--placeholder": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis__slot--placeholder___q4Y3h",
	"grommetux-chart-axis--ticks--start": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks--start___magXf",
	"grommetux-chart-axis--ticks--end": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--ticks--end___2N22i",
	"grommetux-chart-axis--reverse": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-axis--reverse___2CKa_",
	"grommetux-chart-marker-label": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label___2rzO6",
	"grommetux-chart-marker-label__slot": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot___3yvMH",
	"grommetux-chart-marker-label--vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--vertical___10ZEH",
	"grommetux-chart-marker-label__slot--flip": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label__slot--flip___cgAI0",
	"grommetux-chart-marker-label--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--align-start___3rCP0",
	"grommetux-chart-marker-label--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--align-end___BSvIY",
	"grommetux-chart-marker-label--reverse": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker-label--reverse___-5jl8",
	"grommetux-chart-layers": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-layers___6L8gB",
	"fade-in-chart": "node_modules-grommet-scss-vanilla-___index__fade-in-chart___2CndH",
	"grommetux-chart-marker": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-marker___i6hKO",
	"grommetux-chart-grid": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-grid___gxonE",
	"grommetux-chart-graph--line": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--line___3lvTX",
	"grommetux-chart-graph--area": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--area___2UN5g",
	"grommetux-chart-graph--bar": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--bar___3I-8f",
	"grommetux-chart-hot-spots": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-hot-spots___3b-Hw",
	"grommetux-chart-range": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range___2gQ6v",
	"grommetux-chart-loading": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-loading___YdVpQ",
	"grommetux-chart-hot-spots--vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-hot-spots--vertical___1m1T3",
	"grommetux-chart-hot-spots--clickable": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-hot-spots--clickable___1U2MG",
	"grommetux-chart-range__active": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__active___qtDKx",
	"grommetux-chart-range__before": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before___p0M-4",
	"grommetux-chart-range__after": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__after___23v_9",
	"grommetux-chart-range__before--end": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__before--end___3ue0I",
	"grommetux-chart-range__start": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start___2FNBD",
	"grommetux-chart-range__end": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end___2Fc6h",
	"grommetux-chart-range__start--edge": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start--edge___1HvJy",
	"grommetux-chart-range__end--edge": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end--edge___qLGdW",
	"grommetux-chart-range__start--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__start--focus___1hnJr",
	"grommetux-chart-range__end--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range__end--focus___dKTJ5",
	"grommetux-chart-range--vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-range--vertical___3IOle",
	"grommetux-color-index-unset": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unset___lfZVA",
	"grommetux-color-index-brand": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-brand___pxe7S",
	"grommetux-color-index-critical": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-critical___2Ux8O",
	"grommetux-color-index-error": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-error___1xy4M",
	"grommetux-color-index-warning": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-warning___1bCB8",
	"grommetux-color-index-ok": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-ok___ihSKM",
	"grommetux-color-index-unknown": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-unknown___2UqzU",
	"grommetux-color-index-disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-disabled___y13wH",
	"grommetux-color-index-graph-1": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-1___2WGph",
	"grommetux-color-index-graph-5": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-5___2ndfu",
	"grommetux-color-index-graph-2": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-2___1w7SJ",
	"grommetux-color-index-graph-6": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-6___3AKYv",
	"grommetux-color-index-graph-3": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-3___3yvQh",
	"grommetux-color-index-graph-7": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-7___2UyGm",
	"grommetux-color-index-graph-4": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-4___2NNQ0",
	"grommetux-color-index-graph-8": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-graph-8___1r68O",
	"grommetux-color-index-accent-1": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1___2Ph29",
	"grommetux-color-index-accent-3": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3___n7q33",
	"grommetux-color-index-accent-2": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2___th4Xa",
	"grommetux-color-index-accent-4": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4___naytw",
	"color-index-grey-1": "node_modules-grommet-scss-vanilla-___index__color-index-grey-1___1azy4",
	"color-index-grey-6": "node_modules-grommet-scss-vanilla-___index__color-index-grey-6___3BtrI",
	"color-index-grey-2": "node_modules-grommet-scss-vanilla-___index__color-index-grey-2___2c2OE",
	"color-index-grey-7": "node_modules-grommet-scss-vanilla-___index__color-index-grey-7___156LM",
	"color-index-grey-3": "node_modules-grommet-scss-vanilla-___index__color-index-grey-3___4ToJ1",
	"color-index-grey-8": "node_modules-grommet-scss-vanilla-___index__color-index-grey-8___1eZM5",
	"color-index-grey-4": "node_modules-grommet-scss-vanilla-___index__color-index-grey-4___u9D6N",
	"color-index-grey-9": "node_modules-grommet-scss-vanilla-___index__color-index-grey-9___2bYDN",
	"color-index-grey-5": "node_modules-grommet-scss-vanilla-___index__color-index-grey-5___jHYD_",
	"color-index-grey-10": "node_modules-grommet-scss-vanilla-___index__color-index-grey-10___1Dy8F",
	"grommetux-color-index-loading": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-loading___2ScKG",
	"grommetux-color-index-grey-1": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-1___2Tcfc",
	"grommetux-color-index-grey-6": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-6___1Rpwm",
	"grommetux-color-index-grey-2": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-2___3nliQ",
	"grommetux-color-index-grey-7": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-7___1S0sp",
	"grommetux-color-index-grey-3": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-3___K958I",
	"grommetux-color-index-grey-8": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-8___28odf",
	"grommetux-color-index-grey-4": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-4___3LQ3F",
	"grommetux-color-index-grey-9": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-9___1HELR",
	"grommetux-color-index-grey-5": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-5___2oY-1",
	"grommetux-color-index-grey-10": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-grey-10___yIQNW",
	"grommetux-color-index-neutral-1": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1___18r1-",
	"grommetux-color-index-neutral-5": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5___2TsLP",
	"grommetux-color-index-neutral-2": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2___HMmiO",
	"grommetux-color-index-neutral-6": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6____vpiO",
	"grommetux-color-index-neutral-3": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3___1vv80",
	"grommetux-color-index-neutral-7": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7___3Rve4",
	"grommetux-color-index-neutral-4": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4___2jo4w",
	"grommetux-color-index-neutral-8": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8___1-jZB",
	"grommetux-color-index-light-1": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-1___Hi_kQ",
	"grommetux-color-index-light-3": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-3___2kA-F",
	"grommetux-color-index-light-2": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-2___eP6xn",
	"grommetux-color-index-light-4": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-light-4___W8Dne",
	"grommetux-chart-graph--vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph--vertical___1GjDD",
	"stretch-right-chart": "node_modules-grommet-scss-vanilla-___index__stretch-right-chart___3xf_9",
	"stretch-up-chart": "node_modules-grommet-scss-vanilla-___index__stretch-up-chart___2fF_s",
	"grommetux-chart-graph__point": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point___3p74_",
	"grommetux-chart-graph__point--active": "node_modules-grommet-scss-vanilla-___index__grommetux-chart-graph__point--active___20mcv",
	"grommetux-check-box": "node_modules-grommet-scss-vanilla-___index__grommetux-check-box___1DAxT",
	"grommetux-check-box--disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-check-box--disabled___cZwNt",
	"grommetux-check-box__control": "node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control___2ezTK",
	"grommetux-check-box__label": "node_modules-grommet-scss-vanilla-___index__grommetux-check-box__label___1tpck",
	"grommetux-check-box__control-check": "node_modules-grommet-scss-vanilla-___index__grommetux-check-box__control-check___1J67N",
	"grommetux-check-box--reverse": "node_modules-grommet-scss-vanilla-___index__grommetux-check-box--reverse___23DAX",
	"grommetux-check-box--toggle": "node_modules-grommet-scss-vanilla-___index__grommetux-check-box--toggle___3ZNbp",
	"grommetux-collapsible": "node_modules-grommet-scss-vanilla-___index__grommetux-collapsible___3n7Al",
	"grommetux-collapsible__wrapper": "node_modules-grommet-scss-vanilla-___index__grommetux-collapsible__wrapper___3KVxH",
	"animate": "node_modules-grommet-scss-vanilla-___index__animate___1UFGz",
	"grommetux-background-color-index-brand": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-brand___M7atr",
	"grommetux-background-color-index-brand-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-brand-a___lmDRf",
	"grommetux-border-color-index-brand": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-brand___3CXKg",
	"grommetux-border-color-index-brand-a": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-brand-a___2Nu1M",
	"grommetux-background-color-index-neutral-1": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-1____EVmv",
	"grommetux-background-color-index-neutral-5": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-5___nm_Dz",
	"grommetux-background-color-index-neutral-1-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-1-t___1pw7S",
	"grommetux-background-color-index-neutral-5-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-5-t___tEbGp",
	"grommetux-background-color-index-neutral-1-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-1-a___olVOw",
	"grommetux-background-color-index-neutral-5-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-5-a___2f-vS",
	"grommetux-border-color-index-neutral-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-1___smFoS",
	"grommetux-border-color-index-neutral-5": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-5___2eNLC",
	"grommetux-border-color-index-neutral-1-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-1-t___CWieV",
	"grommetux-border-color-index-neutral-5-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-5-t___tsBEs",
	"grommetux-color-index-neutral-1-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-1-t___2MM_1",
	"grommetux-color-index-neutral-5-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-5-t___1TLOC",
	"grommetux-background-hover-color-index-neutral-1": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-1___RbSih",
	"grommetux-background-hover-color-index-neutral-5": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-5___2K19F",
	"grommetux-border-small-hover-color-index-neutral-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-1___183Lb",
	"grommetux-border-small-hover-color-index-neutral-5": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-5___IEs54",
	"grommetux-border-medium-hover-color-index-neutral-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-1___3JGGi",
	"grommetux-border-medium-hover-color-index-neutral-5": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-5___ALJuV",
	"grommetux-border-large-hover-color-index-neutral-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-1___3F8eK",
	"grommetux-border-large-hover-color-index-neutral-5": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-5___1qLTe",
	"grommetux-background-color-index-neutral-2": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-2___gqtzK",
	"grommetux-background-color-index-neutral-6": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-6___3IDfk",
	"grommetux-background-color-index-neutral-2-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-2-t___2J8wX",
	"grommetux-background-color-index-neutral-6-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-6-t___1TamA",
	"grommetux-background-color-index-neutral-2-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-2-a___2i3rg",
	"grommetux-background-color-index-neutral-6-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-6-a___7cMv-",
	"grommetux-border-color-index-neutral-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-2___t5-0Q",
	"grommetux-border-color-index-neutral-6": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-6___1NLvh",
	"grommetux-border-color-index-neutral-2-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-2-t___2EsXm",
	"grommetux-border-color-index-neutral-6-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-6-t___1XS6b",
	"grommetux-color-index-neutral-2-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-2-t___1SV73",
	"grommetux-color-index-neutral-6-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-6-t___3UdnK",
	"grommetux-background-hover-color-index-neutral-2": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-2___1GBzt",
	"grommetux-background-hover-color-index-neutral-6": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-6___e7Qtj",
	"grommetux-border-small-hover-color-index-neutral-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-2___2ZC_t",
	"grommetux-border-small-hover-color-index-neutral-6": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-6___1m_EG",
	"grommetux-border-medium-hover-color-index-neutral-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-2___3jsu9",
	"grommetux-border-medium-hover-color-index-neutral-6": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-6___2W4_n",
	"grommetux-border-large-hover-color-index-neutral-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-2___1Aro3",
	"grommetux-border-large-hover-color-index-neutral-6": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-6___2nIbd",
	"grommetux-background-color-index-neutral-3": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-3___1Gopf",
	"grommetux-background-color-index-neutral-7": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-7___3jToB",
	"grommetux-background-color-index-neutral-3-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-3-t___nJdVi",
	"grommetux-background-color-index-neutral-7-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-7-t___1FClX",
	"grommetux-background-color-index-neutral-3-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-3-a___dqj0T",
	"grommetux-background-color-index-neutral-7-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-7-a___2ccln",
	"grommetux-border-color-index-neutral-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-3___2a5Bh",
	"grommetux-border-color-index-neutral-7": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-7___2nADy",
	"grommetux-border-color-index-neutral-3-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-3-t___2HE8H",
	"grommetux-border-color-index-neutral-7-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-7-t___3G9jq",
	"grommetux-color-index-neutral-3-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-3-t___EoDCT",
	"grommetux-color-index-neutral-7-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-7-t___A_c35",
	"grommetux-background-hover-color-index-neutral-3": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-3___2vjE6",
	"grommetux-background-hover-color-index-neutral-7": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-7___2nJoV",
	"grommetux-border-small-hover-color-index-neutral-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-3___3CQ_F",
	"grommetux-border-small-hover-color-index-neutral-7": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-7___2bo6C",
	"grommetux-border-medium-hover-color-index-neutral-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-3___3JK0-",
	"grommetux-border-medium-hover-color-index-neutral-7": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-7___V0Chy",
	"grommetux-border-large-hover-color-index-neutral-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-3___2eQC6",
	"grommetux-border-large-hover-color-index-neutral-7": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-7___1xIUA",
	"grommetux-background-color-index-neutral-4": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-4___299gj",
	"grommetux-background-color-index-neutral-8": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-8___39Wud",
	"grommetux-background-color-index-neutral-4-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-4-t___QNKDT",
	"grommetux-background-color-index-neutral-8-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-8-t___2G_8n",
	"grommetux-background-color-index-neutral-4-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-4-a___8tnsm",
	"grommetux-background-color-index-neutral-8-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-neutral-8-a___1hnaG",
	"grommetux-border-color-index-neutral-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-4___23Eph",
	"grommetux-border-color-index-neutral-8": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-8___3z8g6",
	"grommetux-border-color-index-neutral-4-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-4-t___2EyVC",
	"grommetux-border-color-index-neutral-8-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-neutral-8-t___1jfBJ",
	"grommetux-color-index-neutral-4-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-4-t___2IB09",
	"grommetux-color-index-neutral-8-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-neutral-8-t___Zpu7H",
	"grommetux-background-hover-color-index-neutral-4": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-4___2tn-B",
	"grommetux-background-hover-color-index-neutral-8": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-neutral-8___1lJPS",
	"grommetux-border-small-hover-color-index-neutral-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-4___YnIoz",
	"grommetux-border-small-hover-color-index-neutral-8": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-neutral-8___3s0my",
	"grommetux-border-medium-hover-color-index-neutral-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-4___3jWmJ",
	"grommetux-border-medium-hover-color-index-neutral-8": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-neutral-8___35qj_",
	"grommetux-border-large-hover-color-index-neutral-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-4___DqRX6",
	"grommetux-border-large-hover-color-index-neutral-8": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-neutral-8___2D4Hs",
	"grommetux-background-color-index-accent-1": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-1___2CTOB",
	"grommetux-background-color-index-accent-3": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-3___2WZ2Y",
	"grommetux-background-color-index-accent-1-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-1-t___1Qsql",
	"grommetux-background-color-index-accent-3-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-3-t___1E3SK",
	"grommetux-background-color-index-accent-1-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-1-a___3JNMr",
	"grommetux-background-color-index-accent-3-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-3-a___3M8Sb",
	"grommetux-border-color-index-accent-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-1___2RmrS",
	"grommetux-border-color-index-accent-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-3___1iF8J",
	"grommetux-border-color-index-accent-1-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-1-t___3CFO8",
	"grommetux-border-color-index-accent-3-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-3-t___p_QT5",
	"grommetux-color-index-accent-1-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-1-t___3MjdI",
	"grommetux-color-index-accent-3-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-3-t___3V6zO",
	"grommetux-background-hover-color-index-accent-1": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-accent-1___3Qp8M",
	"grommetux-background-hover-color-index-accent-3": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-accent-3___2L8aJ",
	"grommetux-border-small-hover-color-index-accent-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-accent-1___uBeNy",
	"grommetux-border-small-hover-color-index-accent-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-accent-3___2bmAB",
	"grommetux-border-medium-hover-color-index-accent-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-accent-1___1fB2v",
	"grommetux-border-medium-hover-color-index-accent-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-accent-3___11ocs",
	"grommetux-border-large-hover-color-index-accent-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-accent-1___DlkqZ",
	"grommetux-border-large-hover-color-index-accent-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-accent-3___qh2NB",
	"grommetux-background-color-index-accent-2": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-2___2wUp8",
	"grommetux-background-color-index-accent-4": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-4___1t-Vp",
	"grommetux-background-color-index-accent-2-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-2-t___YtZqb",
	"grommetux-background-color-index-accent-4-t": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-4-t___1d7UN",
	"grommetux-background-color-index-accent-2-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-2-a___OQZ2m",
	"grommetux-background-color-index-accent-4-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-accent-4-a___2c3l2",
	"grommetux-border-color-index-accent-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-2___3tXgD",
	"grommetux-border-color-index-accent-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-4___3_vFF",
	"grommetux-border-color-index-accent-2-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-2-t___3o5G5",
	"grommetux-border-color-index-accent-4-t": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-accent-4-t___3pf7b",
	"grommetux-color-index-accent-2-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-2-t___3KJjU",
	"grommetux-color-index-accent-4-t": "node_modules-grommet-scss-vanilla-___index__grommetux-color-index-accent-4-t___39yNj",
	"grommetux-background-hover-color-index-accent-2": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-accent-2___1rQKi",
	"grommetux-background-hover-color-index-accent-4": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-accent-4___2f1ec",
	"grommetux-border-small-hover-color-index-accent-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-accent-2___13xNg",
	"grommetux-border-small-hover-color-index-accent-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-accent-4___2uFGc",
	"grommetux-border-medium-hover-color-index-accent-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-accent-2___32p_2",
	"grommetux-border-medium-hover-color-index-accent-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-accent-4___1rHA5",
	"grommetux-border-large-hover-color-index-accent-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-accent-2___3ARc3",
	"grommetux-border-large-hover-color-index-accent-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-accent-4___yBQ0n",
	"grommetux-background-color-index-grey-1": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-1___2jQyI",
	"grommetux-background-color-index-grey-6": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-6___3BwX5",
	"grommetux-background-color-index-grey-1-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-1-a___3Wv6o",
	"grommetux-background-color-index-grey-6-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-6-a___40MyO",
	"grommetux-border-color-index-grey-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-1___309G8",
	"grommetux-border-color-index-grey-6": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-6___jnPzW",
	"grommetux-background-hover-color-index-grey-1": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-1___1KPn_",
	"grommetux-background-hover-color-index-grey-6": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-6___2UHdU",
	"grommetux-border-small-hover-color-index-grey-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-1___1jYAa",
	"grommetux-border-small-hover-color-index-grey-6": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-6___2-UH5",
	"grommetux-border-medium-hover-color-index-grey-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-1___1LHH1",
	"grommetux-border-medium-hover-color-index-grey-6": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-6___1g8iw",
	"grommetux-border-large-hover-color-index-grey-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-1___1N4Qi",
	"grommetux-border-large-hover-color-index-grey-6": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-6___2wrdo",
	"grommetux-background-color-index-grey-2": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-2____L6LH",
	"grommetux-background-color-index-grey-7": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-7___LY0Ui",
	"grommetux-background-color-index-grey-2-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-2-a___3emKz",
	"grommetux-background-color-index-grey-7-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-7-a___L5-Oo",
	"grommetux-border-color-index-grey-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-2___1ADip",
	"grommetux-border-color-index-grey-7": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-7___2v_Jn",
	"grommetux-background-hover-color-index-grey-2": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-2___3g7y1",
	"grommetux-background-hover-color-index-grey-7": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-7___2i3o8",
	"grommetux-border-small-hover-color-index-grey-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-2___1LL4s",
	"grommetux-border-small-hover-color-index-grey-7": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-7___uzKd1",
	"grommetux-border-medium-hover-color-index-grey-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-2___1xBiC",
	"grommetux-border-medium-hover-color-index-grey-7": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-7___2Is0K",
	"grommetux-border-large-hover-color-index-grey-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-2___h7r-V",
	"grommetux-border-large-hover-color-index-grey-7": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-7___1zeZW",
	"grommetux-background-color-index-grey-3": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-3___1uGGn",
	"grommetux-background-color-index-grey-8": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-8___15Y1R",
	"grommetux-background-color-index-grey-3-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-3-a___lpQ8l",
	"grommetux-background-color-index-grey-8-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-8-a___295Z9",
	"grommetux-border-color-index-grey-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-3___2HYdG",
	"grommetux-border-color-index-grey-8": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-8___2y_AZ",
	"grommetux-background-hover-color-index-grey-3": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-3___3D4dI",
	"grommetux-background-hover-color-index-grey-8": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-8___2CljE",
	"grommetux-border-small-hover-color-index-grey-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-3___22pxF",
	"grommetux-border-small-hover-color-index-grey-8": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-8___3goFy",
	"grommetux-border-medium-hover-color-index-grey-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-3___36kFa",
	"grommetux-border-medium-hover-color-index-grey-8": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-8___1hEa4",
	"grommetux-border-large-hover-color-index-grey-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-3___3CvYK",
	"grommetux-border-large-hover-color-index-grey-8": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-8___xX0Lg",
	"grommetux-background-color-index-grey-4": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-4___3JeNA",
	"grommetux-background-color-index-grey-9": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-9___2RvJW",
	"grommetux-background-color-index-grey-4-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-4-a___2IHtt",
	"grommetux-background-color-index-grey-9-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-9-a___boRbr",
	"grommetux-border-color-index-grey-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-4___U685i",
	"grommetux-border-color-index-grey-9": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-9___2ibFN",
	"grommetux-background-hover-color-index-grey-4": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-4___2qUnu",
	"grommetux-background-hover-color-index-grey-9": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-9___28Ioh",
	"grommetux-border-small-hover-color-index-grey-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-4___1WYQb",
	"grommetux-border-small-hover-color-index-grey-9": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-9___2mGpX",
	"grommetux-border-medium-hover-color-index-grey-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-4___1fq0n",
	"grommetux-border-medium-hover-color-index-grey-9": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-9___lq9zL",
	"grommetux-border-large-hover-color-index-grey-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-4___121eW",
	"grommetux-border-large-hover-color-index-grey-9": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-9___Px7oL",
	"grommetux-background-color-index-grey-5": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-5___2ZOjy",
	"grommetux-background-color-index-grey-10": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-10___3eJvZ",
	"grommetux-background-color-index-grey-5-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-5-a___3AEqu",
	"grommetux-background-color-index-grey-10-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-grey-10-a___2G4J_",
	"grommetux-border-color-index-grey-5": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-5___1BomX",
	"grommetux-border-color-index-grey-10": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-grey-10___1y0JJ",
	"grommetux-background-hover-color-index-grey-5": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-5___2Vf57",
	"grommetux-background-hover-color-index-grey-10": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-grey-10___2n4vs",
	"grommetux-border-small-hover-color-index-grey-5": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-5___1kEjl",
	"grommetux-border-small-hover-color-index-grey-10": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-grey-10___2Prxk",
	"grommetux-border-medium-hover-color-index-grey-5": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-5___2kcj1",
	"grommetux-border-medium-hover-color-index-grey-10": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-grey-10___2HGcR",
	"grommetux-border-large-hover-color-index-grey-5": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-5___2LID9",
	"grommetux-border-large-hover-color-index-grey-10": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-grey-10___2bSzN",
	"grommetux-background-color-index-graph-1": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-1___1MD3-",
	"grommetux-background-color-index-graph-5": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-5___2YWV2",
	"grommetux-border-color-index-graph-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-1___rclx6",
	"grommetux-border-color-index-graph-5": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-5___zNILe",
	"grommetux-background-color-index-graph-2": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-2___kQKyc",
	"grommetux-background-color-index-graph-6": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-6___3MFdB",
	"grommetux-border-color-index-graph-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-2___WpAA1",
	"grommetux-border-color-index-graph-6": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-6___2A6t8",
	"grommetux-background-color-index-graph-3": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-3___gtgaO",
	"grommetux-background-color-index-graph-7": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-7___3_xkW",
	"grommetux-border-color-index-graph-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-3___3b4tu",
	"grommetux-border-color-index-graph-7": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-7___arqZH",
	"grommetux-background-color-index-graph-4": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-4___2ENd4",
	"grommetux-background-color-index-graph-8": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-graph-8___3WCEw",
	"grommetux-border-color-index-graph-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-4___2ofd7",
	"grommetux-border-color-index-graph-8": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-graph-8___2iiI_",
	"grommetux-background-color-index-critical": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-critical___4HBBh",
	"grommetux-border-color-index-critical": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-critical___2FMT1",
	"grommetux-background-hover-color-index-critical": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-critical___370Ct",
	"grommetux-border-small-hover-color-index-critical": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-critical___33UZM",
	"grommetux-border-medium-hover-color-index-critical": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-critical___2wMUN",
	"grommetux-border-large-hover-color-index-critical": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-critical___1___F",
	"grommetux-background-color-index-error": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-error___2elT5",
	"grommetux-border-color-index-error": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-error___OfENz",
	"grommetux-background-hover-color-index-error": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-error___3JCaZ",
	"grommetux-border-small-hover-color-index-error": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-error___3Xkex",
	"grommetux-border-medium-hover-color-index-error": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-error___2oRvW",
	"grommetux-border-large-hover-color-index-error": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-error___2KY_x",
	"grommetux-background-color-index-warning": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-warning___3tjiI",
	"grommetux-border-color-index-warning": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-warning___3FQUS",
	"grommetux-background-hover-color-index-warning": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-warning___23woq",
	"grommetux-border-small-hover-color-index-warning": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-warning___2kJ3S",
	"grommetux-border-medium-hover-color-index-warning": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-warning___3VpOF",
	"grommetux-border-large-hover-color-index-warning": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-warning___3M_4-",
	"grommetux-background-color-index-ok": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-ok___JpX0P",
	"grommetux-border-color-index-ok": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-ok___2asDN",
	"grommetux-background-hover-color-index-ok": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-ok___1PCaU",
	"grommetux-border-small-hover-color-index-ok": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-ok___3Q-TK",
	"grommetux-border-medium-hover-color-index-ok": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-ok___73P-6",
	"grommetux-border-large-hover-color-index-ok": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-ok___1eDXx",
	"grommetux-background-color-index-unknown": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-unknown___2DQJ5",
	"grommetux-border-color-index-unknown": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-unknown___1r3a_",
	"grommetux-background-hover-color-index-unknown": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-unknown____fKCh",
	"grommetux-border-small-hover-color-index-unknown": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-unknown___5_hUa",
	"grommetux-border-medium-hover-color-index-unknown": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-unknown___1Rz9A",
	"grommetux-border-large-hover-color-index-unknown": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-unknown___4_2wG",
	"grommetux-background-color-index-disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-disabled___5xXfP",
	"grommetux-border-color-index-disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-disabled___2xT4b",
	"grommetux-background-hover-color-index-disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-disabled___DQaSb",
	"grommetux-border-small-hover-color-index-disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-disabled___1E413",
	"grommetux-border-medium-hover-color-index-disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-disabled___2UOm9",
	"grommetux-border-large-hover-color-index-disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-disabled___3WOSN",
	"grommetux-background-color-index-light-1": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-1___3NBfe",
	"grommetux-background-color-index-light-3": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-3___2ReJ6",
	"grommetux-background-color-index-light-1-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-1-a___1tRDQ",
	"grommetux-background-color-index-light-3-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-3-a___B6zko",
	"grommetux-border-color-index-light-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-light-1___3qCeu",
	"grommetux-border-color-index-light-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-light-3___36BZP",
	"grommetux-background-hover-color-index-light-1": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-light-1___19HPm",
	"grommetux-background-hover-color-index-light-3": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-light-3____SymO",
	"grommetux-border-small-hover-color-index-light-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-light-1___30gZy",
	"grommetux-border-small-hover-color-index-light-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-light-3___yAFj0",
	"grommetux-border-medium-hover-color-index-light-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-light-1___9ZbEn",
	"grommetux-border-medium-hover-color-index-light-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-light-3___AFHEp",
	"grommetux-border-large-hover-color-index-light-1": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-light-1___2eCVZ",
	"grommetux-border-large-hover-color-index-light-3": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-light-3___1_aC0",
	"grommetux-background-color-index-light-2": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-2___1qFCr",
	"grommetux-background-color-index-light-4": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-4___33mft",
	"grommetux-background-color-index-light-2-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-2-a___1mEIo",
	"grommetux-background-color-index-light-4-a": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-light-4-a___1kbSZ",
	"grommetux-border-color-index-light-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-light-2___2XCvD",
	"grommetux-border-color-index-light-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-color-index-light-4___3JCj9",
	"grommetux-background-hover-color-index-light-2": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-light-2___MhZno",
	"grommetux-background-hover-color-index-light-4": "node_modules-grommet-scss-vanilla-___index__grommetux-background-hover-color-index-light-4___3gDS7",
	"grommetux-border-small-hover-color-index-light-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-light-2___37h-4",
	"grommetux-border-small-hover-color-index-light-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-small-hover-color-index-light-4___umaMc",
	"grommetux-border-medium-hover-color-index-light-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-light-2___3SZo4",
	"grommetux-border-medium-hover-color-index-light-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-medium-hover-color-index-light-4___3dze6",
	"grommetux-border-large-hover-color-index-light-2": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-light-2___318u0",
	"grommetux-border-large-hover-color-index-light-4": "node_modules-grommet-scss-vanilla-___index__grommetux-border-large-hover-color-index-light-4___3c-vs",
	"grommetux-background-color-index-unset": "node_modules-grommet-scss-vanilla-___index__grommetux-background-color-index-unset___Eslix",
	"grommetux-columns": "node_modules-grommet-scss-vanilla-___index__grommetux-columns___h1LAl",
	"grommetux-columns__column": "node_modules-grommet-scss-vanilla-___index__grommetux-columns__column___31L6K",
	"grommetux-columns--margin-small": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-small___1D1VR",
	"grommetux-columns--margin-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-medium___37Bbp",
	"grommetux-columns--margin-large": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--margin-large___1-OhB",
	"grommetux-columns--responsive": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--responsive___1QCYd",
	"grommetux-columns--small": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--small___KlzKo",
	"grommetux-columns--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--medium___2aDQp",
	"grommetux-columns--large": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--large___qHWZU",
	"grommetux-columns--justify-start": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--justify-start___27Z7m",
	"grommetux-columns--justify-center": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--justify-center___1L1-O",
	"grommetux-columns--justify-between": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--justify-between___fX6AH",
	"grommetux-columns--justify-end": "node_modules-grommet-scss-vanilla-___index__grommetux-columns--justify-end___1hZIB",
	"grommetux-date-time": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time___Pu5po",
	"grommetux-date-time__input": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time__input___2hWqU",
	"grommetux-date-time__control": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time__control___1Fe7W",
	"grommetux-date-time-drop": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop___34nei",
	"grommetux-date-time-drop__title": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__title___P3CTW",
	"grommetux-date-time-drop__grid": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__grid___j_-k_",
	"grommetux-date-time-drop__grid--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__grid--focus___2CsQN",
	"grommetux-date-time-drop__day": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__day___9IZjZ",
	"grommetux-date-time-drop__day--hover": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__day--hover___1XH4_",
	"grommetux-date-time-drop__day--other-month": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__day--other-month___27Npl",
	"grommetux-date-time-drop__day--active": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__day--active___3t57B",
	"grommetux-date-time-drop__time": "node_modules-grommet-scss-vanilla-___index__grommetux-date-time-drop__time___1kjA-",
	"grommetux-distribution": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution___25g5l",
	"grommetux-distribution__graphic": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__graphic___3P4h-",
	"grommetux-distribution__graphic--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__graphic--focus___2lakM",
	"grommetux-distribution__background": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__background___2YYmG",
	"grommetux-distribution__item--clickable": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item--clickable___yNaxf",
	"grommetux-distribution__item-box": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-box___2su4q",
	"grommetux-distribution__item-icons": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__item-icons___7eiMV",
	"grommetux-distribution__label": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label___3Wqhx",
	"grommetux-distribution__label-value": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-value___2maO1",
	"grommetux-distribution__label-units": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-units___Wfb23",
	"grommetux-distribution__label-label": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label-label___1DHvv",
	"grommetux-distribution__label--active": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--active___3isf9",
	"grommetux-distribution__label--thin": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--thin___HtDiK",
	"grommetux-distribution__label--small": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--small___34lS1",
	"grommetux-distribution__label--icons": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__label--icons___2BINb",
	"label-value": "node_modules-grommet-scss-vanilla-___index__label-value___4zZxr",
	"label-units": "node_modules-grommet-scss-vanilla-___index__label-units___2Pl6h",
	"label-label": "node_modules-grommet-scss-vanilla-___index__label-label___3uvp0",
	"grommetux-distribution__loading-indicator": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution__loading-indicator___3358F",
	"grommetux-distribution--icons": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution--icons___3_K_e",
	"grommetux-distribution--small": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution--small___2SkcS",
	"grommetux-distribution--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution--medium___12c8l",
	"grommetux-distribution--large": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution--large___2NBsx",
	"grommetux-distribution--full": "node_modules-grommet-scss-vanilla-___index__grommetux-distribution--full___3tQpZ",
	"grommetux-drop": "node_modules-grommet-scss-vanilla-___index__grommetux-drop___7sOOe",
	"grommetux-footer": "node_modules-grommet-scss-vanilla-___index__grommetux-footer_____cz1",
	"grommetux-footer--small": "node_modules-grommet-scss-vanilla-___index__grommetux-footer--small___1eTcp",
	"grommetux-footer--large": "node_modules-grommet-scss-vanilla-___index__grommetux-footer--large___Wfnju",
	"grommetux-footer__content": "node_modules-grommet-scss-vanilla-___index__grommetux-footer__content___8nthb",
	"grommetux-footer--primary": "node_modules-grommet-scss-vanilla-___index__grommetux-footer--primary___3jBJD",
	"grommetux-footer--centered": "node_modules-grommet-scss-vanilla-___index__grommetux-footer--centered___2K-8N",
	"grommetux-footer--flush": "node_modules-grommet-scss-vanilla-___index__grommetux-footer--flush___23BSa",
	"grommetux-footer__wrapper": "node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper___1l_ka",
	"grommetux-footer--fixed": "node_modules-grommet-scss-vanilla-___index__grommetux-footer--fixed___21A7S",
	"grommetux-footer__wrapper--fill": "node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper--fill___3VhxL",
	"grommetux-footer__container": "node_modules-grommet-scss-vanilla-___index__grommetux-footer__container___3rrvZ",
	"grommetux-footer__container--float": "node_modules-grommet-scss-vanilla-___index__grommetux-footer__container--float___3f27T",
	"grommetux-footer__container--fill": "node_modules-grommet-scss-vanilla-___index__grommetux-footer__container--fill___oPgyX",
	"grommetux-footer__container--fixed": "node_modules-grommet-scss-vanilla-___index__grommetux-footer__container--fixed___33EOT",
	"grommetux-footer__wrapper--large": "node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper--large___3wuux",
	"grommetux-footer__wrapper--small": "node_modules-grommet-scss-vanilla-___index__grommetux-footer__wrapper--small___2bGk0",
	"grommetux-footer--float": "node_modules-grommet-scss-vanilla-___index__grommetux-footer--float___3XHBn",
	"grommetux-form": "node_modules-grommet-scss-vanilla-___index__grommetux-form___3378F",
	"grommetux-form-field": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field___11SSk",
	"grommetux-tiles__container": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles__container___2GJM-",
	"grommetux-form--pad-none": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-none___3rCam",
	"grommetux-form--pad-small": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-small___1E9mD",
	"grommetux-form--pad-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-medium___3HXQx",
	"grommetux-form--pad-large": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-large___95BWW",
	"grommetux-form--pad-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-xlarge___2644j",
	"grommetux-form--pad-horizontal-none": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-none___fxW_E",
	"grommetux-form--pad-horizontal-small": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-small___AWL-u",
	"grommetux-form--pad-horizontal-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-medium___20BsG",
	"grommetux-form--pad-horizontal-large": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-large___25SUR",
	"grommetux-form--pad-horizontal-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-horizontal-xlarge___3q-7j",
	"grommetux-form--pad-vertical-none": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-none___1Hg2q",
	"grommetux-form--pad-vertical-small": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-small___ZpdM8",
	"grommetux-form--pad-vertical-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-medium___xChdk",
	"grommetux-form--pad-vertical-large": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-large___1ghzn",
	"grommetux-form--pad-vertical-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-form--pad-vertical-xlarge___3kQCl",
	"grommetux-header": "node_modules-grommet-scss-vanilla-___index__grommetux-header___F29w4",
	"grommetux-header__wrapper": "node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper___2YD-k",
	"grommetux-form-fields": "node_modules-grommet-scss-vanilla-___index__grommetux-form-fields___2X8JP",
	"grommetux-form--plain": "node_modules-grommet-scss-vanilla-___index__grommetux-form--plain___3ot7M",
	"grommetux-form--fill": "node_modules-grommet-scss-vanilla-___index__grommetux-form--fill___3NM0Z",
	"grommetux-form--compact": "node_modules-grommet-scss-vanilla-___index__grommetux-form--compact___2jinq",
	"grommetux-form-field__label": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field__label___3HAcp",
	"grommetux-form-field__contents": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents___3GFjz",
	"grommetux-search-input": "node_modules-grommet-scss-vanilla-___index__grommetux-search-input___d-tih",
	"grommetux-calendar": "node_modules-grommet-scss-vanilla-___index__grommetux-calendar___19iKa",
	"grommetux-select": "node_modules-grommet-scss-vanilla-___index__grommetux-select___3gE-P",
	"grommetux-select--inline": "node_modules-grommet-scss-vanilla-___index__grommetux-select--inline___37Maz",
	"grommetux-password-input": "node_modules-grommet-scss-vanilla-___index__grommetux-password-input___WruZF",
	"grommetux-select__value": "node_modules-grommet-scss-vanilla-___index__grommetux-select__value___1DVAG",
	"grommetux-text-input": "node_modules-grommet-scss-vanilla-___index__grommetux-text-input___ZcDLG",
	"grommetux-select__options": "node_modules-grommet-scss-vanilla-___index__grommetux-select__options___1kVZk",
	"grommetux-radio-button": "node_modules-grommet-scss-vanilla-___index__grommetux-radio-button___1Oldo",
	"grommetux-search-input__control": "node_modules-grommet-scss-vanilla-___index__grommetux-search-input__control___2gnBw",
	"grommetux-calendar__control": "node_modules-grommet-scss-vanilla-___index__grommetux-calendar__control___3kHvh",
	"grommetux-number-input": "node_modules-grommet-scss-vanilla-___index__grommetux-number-input___EFZdZ",
	"grommetux-table--selectable": "node_modules-grommet-scss-vanilla-___index__grommetux-table--selectable___-Hf1U",
	"grommetux-form-field__contents--hidden": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field__contents--hidden___OEdNr",
	"grommetux-form-field__help": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field__help___2jbwK",
	"grommetux-form-field__error": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field__error___3Aj2w",
	"grommetux-form-field--text": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field--text___jgHku",
	"grommetux-form-field--hidden": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field--hidden___22zPW",
	"grommetux-form-field--error": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field--error___3bwJc",
	"grommetux-form-field--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field--focus___2_KP1",
	"grommetux-form-field--size-large": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field--size-large___nNmHG",
	"grommetux-form-field--strong": "node_modules-grommet-scss-vanilla-___index__grommetux-form-field--strong___UmACo",
	"grommetux-status-icon": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon___2zm4d",
	"grommetux-header--large": "node_modules-grommet-scss-vanilla-___index__grommetux-header--large___27UBX",
	"grommetux-header--small": "node_modules-grommet-scss-vanilla-___index__grommetux-header--small___1qqdQ",
	"grommetux-header--splash": "node_modules-grommet-scss-vanilla-___index__grommetux-header--splash___1vlO4",
	"grommetux-header__container--float": "node_modules-grommet-scss-vanilla-___index__grommetux-header__container--float___3JhOu",
	"grommetux-header--float": "node_modules-grommet-scss-vanilla-___index__grommetux-header--float___-4Khg",
	"grommetux-header--primary": "node_modules-grommet-scss-vanilla-___index__grommetux-header--primary___39fdg",
	"grommetux-header__container": "node_modules-grommet-scss-vanilla-___index__grommetux-header__container___194aV",
	"grommetux-header__container--fill": "node_modules-grommet-scss-vanilla-___index__grommetux-header__container--fill___1WHxI",
	"grommetux-header__container--fixed": "node_modules-grommet-scss-vanilla-___index__grommetux-header__container--fixed___7UzOL",
	"grommetux-header__wrapper--large": "node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper--large___2L9V4",
	"grommetux-header__wrapper--small": "node_modules-grommet-scss-vanilla-___index__grommetux-header__wrapper--small___26cYH",
	"grommetux-header--fixed": "node_modules-grommet-scss-vanilla-___index__grommetux-header--fixed___3i1i2",
	"grommetux-header__content": "node_modules-grommet-scss-vanilla-___index__grommetux-header__content___35ybf",
	"grommetux-header--flush": "node_modules-grommet-scss-vanilla-___index__grommetux-header--flush___2CbB4",
	"grommetux-heading--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--align-start___IYsMv",
	"grommetux-heading--align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--align-center___32rvm",
	"grommetux-heading--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--align-end___3EW0W",
	"grommetux-heading--margin-none": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--margin-none___l0t28",
	"grommetux-heading--margin-small": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--margin-small___3qe0L",
	"grommetux-heading--margin-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--margin-medium___35-l2",
	"grommetux-heading--margin-large": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--margin-large___1nzBv",
	"grommetux-heading--large": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--large___3bytz",
	"grommetux-heading--small": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--small___3H-B6",
	"grommetux-heading--strong": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--strong___3a6WE",
	"grommetux-heading--truncate": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--truncate___32uam",
	"grommetux-heading--uppercase": "node_modules-grommet-scss-vanilla-___index__grommetux-heading--uppercase___3OXE7",
	"grommetux-headline": "node_modules-grommet-scss-vanilla-___index__grommetux-headline___3pLlj",
	"grommetux-headline--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--align-start___38SEx",
	"grommetux-headline--align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--align-center___35vEN",
	"grommetux-headline--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--align-end___2r1_h",
	"grommetux-headline--margin-none": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--margin-none___3XGED",
	"grommetux-headline--margin-small": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--margin-small___2CIZF",
	"grommetux-headline--margin-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--margin-medium___3M_1l",
	"grommetux-headline--margin-large": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--margin-large___3g9fQ",
	"grommetux-headline--small": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--small___1XIAu",
	"grommetux-headline--large": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--large___7txJD",
	"grommetux-headline--xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--xlarge___8BfrX",
	"grommetux-headline--strong": "node_modules-grommet-scss-vanilla-___index__grommetux-headline--strong___2pnqb",
	"grommetux-hero": "node_modules-grommet-scss-vanilla-___index__grommetux-hero___1S-4S",
	"grommetux-hero--stack": "node_modules-grommet-scss-vanilla-___index__grommetux-hero--stack___2KX6q",
	"grommetux-hero__background": "node_modules-grommet-scss-vanilla-___index__grommetux-hero__background___85MvL",
	"grommetux-hero__foreground": "node_modules-grommet-scss-vanilla-___index__grommetux-hero__foreground___1RmP6",
	"grommetux-hero--small": "node_modules-grommet-scss-vanilla-___index__grommetux-hero--small___2Z0VD",
	"grommetux-hero__overlay": "node_modules-grommet-scss-vanilla-___index__grommetux-hero__overlay___2N-M9",
	"grommetux-hero--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-hero--medium___338vO",
	"grommetux-hero--large": "node_modules-grommet-scss-vanilla-___index__grommetux-hero--large___3UgnU",
	"grommetux-hero__image": "node_modules-grommet-scss-vanilla-___index__grommetux-hero__image___1pABM",
	"grommetux-hero__background-video": "node_modules-grommet-scss-vanilla-___index__grommetux-hero__background-video___1CTDE",
	"grommetux-video": "node_modules-grommet-scss-vanilla-___index__grommetux-video___38nQp",
	"grommetux-hero--bg-left": "node_modules-grommet-scss-vanilla-___index__grommetux-hero--bg-left___18ru6",
	"grommetux-hero--bg-right": "node_modules-grommet-scss-vanilla-___index__grommetux-hero--bg-right___3IaQH",
	"grommetux-hero--mobile-separator": "node_modules-grommet-scss-vanilla-___index__grommetux-hero--mobile-separator___3Q2vl",
	"grommetux-control-icon__badge": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon__badge___WgYB3",
	"grommetux-control-icon--active": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--active___3xE5F",
	"grommetux-control-icon--xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--xsmall___3IpgX",
	"grommetux-control-icon--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--medium___23KgX",
	"grommetux-control-icon--large": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--large___1zw-Q",
	"grommetux-control-icon--xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--xlarge___3xXFU",
	"grommetux-control-icon--huge": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--huge___2vPll",
	"grommetux-control-icon--responsive": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon--responsive___3md8P",
	"grommetux-status-icon__base": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__base___18SmR",
	"grommetux-status-icon__detail": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__detail___1Haos",
	"grommetux-status-icon__small": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__small___3Cda4",
	"grommetux-status-icon-label": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-label___rFSSf",
	"grommetux-status-icon-unknown": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-unknown___1Kd1s",
	"grommetux-status-icon--xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--xsmall___3XqIO",
	"grommetux-status-icon--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--medium___ultiC",
	"grommetux-status-icon--large": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--large___2QMr9",
	"grommetux-status-icon--xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--xlarge___16jaa",
	"grommetux-status-icon--huge": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--huge___8wf_p",
	"grommetux-status-icon--small": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon--small___1kufL",
	"grommetux-status-icon__normal": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon__normal___1g9jn",
	"grommetux-status-icon-critical": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-critical___1cJmz",
	"grommetux-status-icon-error": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-error___39azH",
	"grommetux-status-icon-warning": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-warning___2dBjH",
	"grommetux-status-icon-ok": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-ok___e9-5k",
	"grommetux-status-icon-disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-status-icon-disabled___169fw",
	"grommetux-icon-spinning": "node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning___2isNw",
	"drawAndReverse": "node_modules-grommet-scss-vanilla-___index__drawAndReverse___2I5Cc",
	"fadeOut": "node_modules-grommet-scss-vanilla-___index__fadeOut___2c-WD",
	"grommetux-icon-spinning--xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--xsmall___3Ocep",
	"grommetux-icon-spinning--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--medium___2AYWn",
	"grommetux-icon-spinning--large": "node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--large___2pmkD",
	"grommetux-icon-spinning--xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--xlarge___3jj9y",
	"grommetux-icon-spinning--huge": "node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--huge___1NPFU",
	"grommetux-icon-spinning--responsive": "node_modules-grommet-scss-vanilla-___index__grommetux-icon-spinning--responsive___PNiEm",
	"grommetux-logo-icon": "node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon___1OR6C",
	"draw-logo": "node_modules-grommet-scss-vanilla-___index__draw-logo___2J-FX",
	"grommetux-logo-icon--small": "node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon--small___33SCK",
	"grommetux-logo-icon--large": "node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon--large___2i7_R",
	"grommetux-logo-icon--xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon--xlarge___wRFtW",
	"grommetux-logo-icon--huge": "node_modules-grommet-scss-vanilla-___index__grommetux-logo-icon--huge___1Rf0V",
	"right-left-icon--left": "node_modules-grommet-scss-vanilla-___index__right-left-icon--left___2hCmH",
	"right-left-icon--right": "node_modules-grommet-scss-vanilla-___index__right-left-icon--right___3kNKl",
	"grommetux-image": "node_modules-grommet-scss-vanilla-___index__grommetux-image___1f8vj",
	"grommetux-image--small": "node_modules-grommet-scss-vanilla-___index__grommetux-image--small___PAmYJ",
	"grommetux-image--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-image--medium___1NZgG",
	"grommetux-image--large": "node_modules-grommet-scss-vanilla-___index__grommetux-image--large___3Y0kY",
	"grommetux-image--thumb": "node_modules-grommet-scss-vanilla-___index__grommetux-image--thumb___1qz5n",
	"grommetux-image--mask": "node_modules-grommet-scss-vanilla-___index__grommetux-image--mask___1019u",
	"grommetux-image--cover": "node_modules-grommet-scss-vanilla-___index__grommetux-image--cover___2zU76",
	"grommetux-image--contain": "node_modules-grommet-scss-vanilla-___index__grommetux-image--contain___2vCHM",
	"grommetux-image--full": "node_modules-grommet-scss-vanilla-___index__grommetux-image--full___3bOuo",
	"grommetux-image--align-top": "node_modules-grommet-scss-vanilla-___index__grommetux-image--align-top___3Hrg-",
	"grommetux-image--align-left": "node_modules-grommet-scss-vanilla-___index__grommetux-image--align-left___WmTwx",
	"grommetux-image--align-right": "node_modules-grommet-scss-vanilla-___index__grommetux-image--align-right___19awD",
	"grommetux-image--align-bottom": "node_modules-grommet-scss-vanilla-___index__grommetux-image--align-bottom___3LtaH",
	"grommetux-image--full-horizontal": "node_modules-grommet-scss-vanilla-___index__grommetux-image--full-horizontal___n9QQg",
	"grommetux-image--full-vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-image--full-vertical___DslAF",
	"grommetux-image__container": "node_modules-grommet-scss-vanilla-___index__grommetux-image__container___kadMs",
	"grommetux-image__caption": "node_modules-grommet-scss-vanilla-___index__grommetux-image__caption___7uBOP",
	"grommetux-image__caption--small": "node_modules-grommet-scss-vanilla-___index__grommetux-image__caption--small___3dPin",
	"grommetux-image__caption--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-image__caption--medium___16-3h",
	"grommetux-image__caption--large": "node_modules-grommet-scss-vanilla-___index__grommetux-image__caption--large___8E0jm",
	"grommetux-label": "node_modules-grommet-scss-vanilla-___index__grommetux-label___2stWG",
	"grommetux-label--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-label--align-start___28GV7",
	"grommetux-label--align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-label--align-center___3x1AZ",
	"grommetux-label--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-label--align-end___Smmys",
	"grommetux-label--margin-none": "node_modules-grommet-scss-vanilla-___index__grommetux-label--margin-none___1scLk",
	"grommetux-label--margin-small": "node_modules-grommet-scss-vanilla-___index__grommetux-label--margin-small___kWhb6",
	"grommetux-label--margin-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-label--margin-medium___4P0LZ",
	"grommetux-label--margin-large": "node_modules-grommet-scss-vanilla-___index__grommetux-label--margin-large___2QmVC",
	"grommetux-label--truncate": "node_modules-grommet-scss-vanilla-___index__grommetux-label--truncate___12JAL",
	"grommetux-label--uppercase": "node_modules-grommet-scss-vanilla-___index__grommetux-label--uppercase___vu3Ju",
	"grommetux-label--small": "node_modules-grommet-scss-vanilla-___index__grommetux-label--small___1lMD3",
	"grommetux-label--large": "node_modules-grommet-scss-vanilla-___index__grommetux-label--large___N018x",
	"grommetux-layer--hidden": "node_modules-grommet-scss-vanilla-___index__grommetux-layer--hidden___1jstP",
	"grommetux-layer__container": "node_modules-grommet-scss-vanilla-___index__grommetux-layer__container___2WUWr",
	"grommetux-sidebar": "node_modules-grommet-scss-vanilla-___index__grommetux-sidebar___2SHOE",
	"grommetux-layer__closer": "node_modules-grommet-scss-vanilla-___index__grommetux-layer__closer___Ddlw4",
	"grommetux-layer--flush": "node_modules-grommet-scss-vanilla-___index__grommetux-layer--flush___1EB7i",
	"grommetux-layer--align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-center___2qK1s",
	"grommetux-layer--align-left": "node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-left___8XRVq",
	"slide-right": "node_modules-grommet-scss-vanilla-___index__slide-right___3VEY_",
	"slide-left": "node_modules-grommet-scss-vanilla-___index__slide-left___2XiLT",
	"grommetux-layer--align-right": "node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-right___2wApr",
	"grommetux-layer--align-top": "node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-top___2KGI0",
	"slide-down": "node_modules-grommet-scss-vanilla-___index__slide-down___1vw72",
	"grommetux-layer--align-bottom": "node_modules-grommet-scss-vanilla-___index__grommetux-layer--align-bottom___tmVQ2",
	"grommetux-layer--peek": "node_modules-grommet-scss-vanilla-___index__grommetux-layer--peek___21KBr",
	"peek-right": "node_modules-grommet-scss-vanilla-___index__peek-right___34ej9",
	"grommetux-list": "node_modules-grommet-scss-vanilla-___index__grommetux-list___2Cnvm",
	"grommetux-list--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-list--focus___2zVdA",
	"grommetux-list__more": "node_modules-grommet-scss-vanilla-___index__grommetux-list__more___3Cur2",
	"grommetux-list__empty": "node_modules-grommet-scss-vanilla-___index__grommetux-list__empty___3r0Rp",
	"grommetux-list-item": "node_modules-grommet-scss-vanilla-___index__grommetux-list-item___3Fww8",
	"grommetux-list-item__image": "node_modules-grommet-scss-vanilla-___index__grommetux-list-item__image___365Q6",
	"grommetux-list-item__label": "node_modules-grommet-scss-vanilla-___index__grommetux-list-item__label___1Tn9S",
	"grommetux-list-item__annotation": "node_modules-grommet-scss-vanilla-___index__grommetux-list-item__annotation___1pg7C",
	"grommetux-list-item--selectable": "node_modules-grommet-scss-vanilla-___index__grommetux-list-item--selectable___2n1bZ",
	"grommetux-list-item--selected": "node_modules-grommet-scss-vanilla-___index__grommetux-list-item--selected___1S_oL",
	"grommetux-list-item--row": "node_modules-grommet-scss-vanilla-___index__grommetux-list-item--row___1g7jS",
	"grommetux-list--selectable": "node_modules-grommet-scss-vanilla-___index__grommetux-list--selectable___3VF23",
	"grommetux-list-item--active": "node_modules-grommet-scss-vanilla-___index__grommetux-list-item--active___1JqAJ",
	"grommetux-list--small": "node_modules-grommet-scss-vanilla-___index__grommetux-list--small___Koj0A",
	"grommetux-list__more__image": "node_modules-grommet-scss-vanilla-___index__grommetux-list__more__image___D30RV",
	"grommetux-list--large": "node_modules-grommet-scss-vanilla-___index__grommetux-list--large___3ywuF",
	"grommetux-legend": "node_modules-grommet-scss-vanilla-___index__grommetux-legend___2kLZW",
	"grommetux-legend__item": "node_modules-grommet-scss-vanilla-___index__grommetux-legend__item___3MdJn",
	"grommetux-legend__total": "node_modules-grommet-scss-vanilla-___index__grommetux-legend__total___oKRnf",
	"grommetux-legend__item-label": "node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-label___T3qcj",
	"grommetux-legend__item-units": "node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-units___boNim",
	"grommetux-legend__total-units": "node_modules-grommet-scss-vanilla-___index__grommetux-legend__total-units___2GOMm",
	"grommetux-legend__item-swatch": "node_modules-grommet-scss-vanilla-___index__grommetux-legend__item-swatch___214je",
	"grommetux-legend__item--clickable": "node_modules-grommet-scss-vanilla-___index__grommetux-legend__item--clickable___1Ljvr",
	"grommetux-legend__item--active": "node_modules-grommet-scss-vanilla-___index__grommetux-legend__item--active___eW0wv",
	"grommetux-legend--large": "node_modules-grommet-scss-vanilla-___index__grommetux-legend--large___ZoTSv",
	"grommetux-map": "node_modules-grommet-scss-vanilla-___index__grommetux-map___3zAdz",
	"grommetux-map__links": "node_modules-grommet-scss-vanilla-___index__grommetux-map__links___5-1SW",
	"grommetux-map__path": "node_modules-grommet-scss-vanilla-___index__grommetux-map__path___3G4cG",
	"grommetux-map__path--active": "node_modules-grommet-scss-vanilla-___index__grommetux-map__path--active___3aTFo",
	"grommetux-map__categories": "node_modules-grommet-scss-vanilla-___index__grommetux-map__categories___IlfGJ",
	"grommetux-map__category": "node_modules-grommet-scss-vanilla-___index__grommetux-map__category___lX00n",
	"grommetux-map__category-label": "node_modules-grommet-scss-vanilla-___index__grommetux-map__category-label___2tMug",
	"grommetux-map__category-items": "node_modules-grommet-scss-vanilla-___index__grommetux-map__category-items___13JrM",
	"grommetux-map__item": "node_modules-grommet-scss-vanilla-___index__grommetux-map__item___3x-SF",
	"grommetux-map__item--plain": "node_modules-grommet-scss-vanilla-___index__grommetux-map__item--plain___2gcMI",
	"grommetux-map__item--active": "node_modules-grommet-scss-vanilla-___index__grommetux-map__item--active___QbX6L",
	"grommetux-map--vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-map--vertical___1qq6o",
	"grommetux-menu": "node_modules-grommet-scss-vanilla-___index__grommetux-menu___2rByG",
	"grommetux-menu--controlled": "node_modules-grommet-scss-vanilla-___index__grommetux-menu--controlled___3vAVY",
	"grommetux-menu--fill": "node_modules-grommet-scss-vanilla-___index__grommetux-menu--fill___27KGq",
	"grommetux-menu__control": "node_modules-grommet-scss-vanilla-___index__grommetux-menu__control___3TLvb",
	"grommetux-control-icon-down": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-down___2QH2l",
	"grommetux-menu--labelled": "node_modules-grommet-scss-vanilla-___index__grommetux-menu--labelled___3__-P",
	"grommetux-menu__drop": "node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop___3dFCL",
	"grommetux-menu__label": "node_modules-grommet-scss-vanilla-___index__grommetux-menu__label___Fbm6Z",
	"grommetux-menu__drop--align-right": "node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--align-right___hHDnr",
	"grommetux-menu__contents": "node_modules-grommet-scss-vanilla-___index__grommetux-menu__contents___LZRg5",
	"grommetux-menu__drop--small": "node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--small___3NA3A",
	"grommetux-menu__drop--large": "node_modules-grommet-scss-vanilla-___index__grommetux-menu__drop--large___2Gdek",
	"grommetux-menu--inline": "node_modules-grommet-scss-vanilla-___index__grommetux-menu--inline___3P0_G",
	"grommetux-menu--row": "node_modules-grommet-scss-vanilla-___index__grommetux-menu--row___1BumR",
	"grommetux---direction-row": "node_modules-grommet-scss-vanilla-___index__grommetux---direction-row___1Kepi",
	"grommetux-menu--small": "node_modules-grommet-scss-vanilla-___index__grommetux-menu--small___1L8VH",
	"grommetux-menu--large": "node_modules-grommet-scss-vanilla-___index__grommetux-menu--large___1MG0c",
	"grommetux-menu--primary": "node_modules-grommet-scss-vanilla-___index__grommetux-menu--primary___vDnyj",
	"grommetux-anchor--active": "node_modules-grommet-scss-vanilla-___index__grommetux-anchor--active___3Lb3p",
	"grommetux-menu--down": "node_modules-grommet-scss-vanilla-___index__grommetux-menu--down___1oIXV",
	"grommetux-meter": "node_modules-grommet-scss-vanilla-___index__grommetux-meter___mkt5n",
	"grommetux-meter__slice": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice___3xTzr",
	"grommetux-meter__hot": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__hot___1_MSW",
	"grommetux-meter__threshold": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__threshold___bhb1I",
	"grommetux-meter__value-container": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__value-container___DmiqC",
	"grommetux-meter__graphic-container": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic-container___377TJ",
	"grommetux-meter__graphic": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__graphic___2RKYy",
	"grommetux-meter--vertical": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--vertical___yf2Ez",
	"grommetux-meter--active": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--active___3pGgL",
	"grommetux-meter__values": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__values___2Oal8",
	"grommetux-meter__slice--active": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice--active___uPBc2",
	"grommetux-meter--bar": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--bar___kXXOV",
	"grommetux-meter__slice--clickable": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice--clickable___3-8d9",
	"draw-meter-bar-small": "node_modules-grommet-scss-vanilla-___index__draw-meter-bar-small___1gECh",
	"grommetux-meter__thresholds": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__thresholds___3ywCc",
	"grommetux-meter__tracks": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__tracks___ga7vR",
	"grommetux-meter--stacked": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--stacked___QP2sL",
	"grommetux-meter--count-2": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-2___fDI7u",
	"grommetux-meter--count-3": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-3___2VlcS",
	"grommetux-meter--count-4": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--count-4___16N2_",
	"grommetux-meter__labeled-graphic": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__labeled-graphic___1tiEp",
	"grommetux-meter--xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--xsmall___1eZJz",
	"grommetux-meter--small": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--small___w2MLD",
	"grommetux-meter--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--medium___2MUFq",
	"grommetux-meter--large": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--large___20z-c",
	"grommetux-meter--xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--xlarge___NIQSw",
	"grommetux-meter--single": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--single___15ihN",
	"grommetux-meter--circle": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--circle___wqF04",
	"grommetux-meter--arc": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--arc___XeEbS",
	"grommetux-meter--spiral": "node_modules-grommet-scss-vanilla-___index__grommetux-meter--spiral___1ZpcA",
	"series-pre": "node_modules-grommet-scss-vanilla-___index__series-pre___1HkBv",
	"grommetux-meter__slice-indicator": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__slice-indicator____gsAS",
	"draw-meter-circle": "node_modules-grommet-scss-vanilla-___index__draw-meter-circle___3wnZY",
	"grommetux-meter__label": "node_modules-grommet-scss-vanilla-___index__grommetux-meter__label___3PCo4",
	"grommetux-notification": "node_modules-grommet-scss-vanilla-___index__grommetux-notification____yEc6",
	"grommetux-notification--status-critical": "node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-critical___3IgRe",
	"grommetux-notification__status": "node_modules-grommet-scss-vanilla-___index__grommetux-notification__status___3FHP-",
	"grommetux-notification__close": "node_modules-grommet-scss-vanilla-___index__grommetux-notification__close___1PFu_",
	"grommetux-notification--status-error": "node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-error___13n4G",
	"grommetux-notification--status-warning": "node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-warning___3q47G",
	"grommetux-notification--status-ok": "node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-ok___2D2G6",
	"grommetux-notification--status-unknown": "node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-unknown___3st_f",
	"grommetux-notification--status-disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-notification--status-disabled___3KL04",
	"grommetux-notification__message": "node_modules-grommet-scss-vanilla-___index__grommetux-notification__message___1u00D",
	"grommetux-notification--small": "node_modules-grommet-scss-vanilla-___index__grommetux-notification--small___12Bmo",
	"grommetux-number-input__input": "node_modules-grommet-scss-vanilla-___index__grommetux-number-input__input___2ATdx",
	"grommetux-object": "node_modules-grommet-scss-vanilla-___index__grommetux-object___1cfq5",
	"grommetux-object__container": "node_modules-grommet-scss-vanilla-___index__grommetux-object__container___2faOl",
	"grommetux-object__attribute": "node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute___19UkJ",
	"grommetux-object__attribute-name": "node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-name___2sQ17",
	"grommetux-object__attribute-value": "node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute-value___19qgr",
	"grommetux-object__attribute--container": "node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute--container___1tJqk",
	"grommetux-object__attribute--unset": "node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute--unset___l3-t9",
	"grommetux-object__attribute--array": "node_modules-grommet-scss-vanilla-___index__grommetux-object__attribute--array___3cV6F",
	"grommetux-paragraph--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--align-start___36TW2",
	"grommetux-paragraph--align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--align-center___15so7",
	"grommetux-paragraph--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--align-end___1r0n6",
	"grommetux-paragraph--margin-none": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--margin-none___3h8-c",
	"grommetux-paragraph--margin-small": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--margin-small___2oqWN",
	"grommetux-paragraph--margin-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--margin-medium___3v9v8",
	"grommetux-paragraph--margin-large": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--margin-large___2VdVw",
	"grommetux-paragraph--width-large": "node_modules-grommet-scss-vanilla-___index__grommetux-paragraph--width-large___1Hhd4",
	"grommetux-password-input__input": "node_modules-grommet-scss-vanilla-___index__grommetux-password-input__input___2f8TH",
	"grommetux-password-input__control": "node_modules-grommet-scss-vanilla-___index__grommetux-password-input__control___3wsmQ",
	"grommetux-pulse": "node_modules-grommet-scss-vanilla-___index__grommetux-pulse___1Ad3h",
	"grommetux-pulse__icon-anim": "node_modules-grommet-scss-vanilla-___index__grommetux-pulse__icon-anim___OE2Iz",
	"grommetux-pulse__icon": "node_modules-grommet-scss-vanilla-___index__grommetux-pulse__icon___1nTMn",
	"scale-up-fade-out": "node_modules-grommet-scss-vanilla-___index__scale-up-fade-out___3ypTj",
	"grommetux-quote": "node_modules-grommet-scss-vanilla-___index__grommetux-quote___3DqMn",
	"grommetux-quote--small": "node_modules-grommet-scss-vanilla-___index__grommetux-quote--small___3Dkle",
	"grommetux-radio-button--disabled": "node_modules-grommet-scss-vanilla-___index__grommetux-radio-button--disabled___1XlDo",
	"grommetux-radio-button__control": "node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__control___3ckuM",
	"grommetux-radio-button__input": "node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__input___3Dzan",
	"grommetux-radio-button__label": "node_modules-grommet-scss-vanilla-___index__grommetux-radio-button__label___1AJ9Z",
	"grommetux-search": "node_modules-grommet-scss-vanilla-___index__grommetux-search___3fYRa",
	"grommetux-search--controlled": "node_modules-grommet-scss-vanilla-___index__grommetux-search--controlled___3-czc",
	"grommetux-search__input": "node_modules-grommet-scss-vanilla-___index__grommetux-search__input___Xb7-n",
	"grommetux-search__drop": "node_modules-grommet-scss-vanilla-___index__grommetux-search__drop___3NfTd",
	"grommetux-search__suggestion": "node_modules-grommet-scss-vanilla-___index__grommetux-search__suggestion___3yHYu",
	"grommetux-search__suggestion--active": "node_modules-grommet-scss-vanilla-___index__grommetux-search__suggestion--active___2IHfS",
	"grommetux-search__drop-control": "node_modules-grommet-scss-vanilla-___index__grommetux-search__drop-control___1ZTDu",
	"grommetux-search__drop--controlled": "node_modules-grommet-scss-vanilla-___index__grommetux-search__drop--controlled___3qK1x",
	"grommetux-search__drop-contents": "node_modules-grommet-scss-vanilla-___index__grommetux-search__drop-contents___3iKfZ",
	"grommetux-search__drop--large": "node_modules-grommet-scss-vanilla-___index__grommetux-search__drop--large___3yry-",
	"grommetux-search--inline": "node_modules-grommet-scss-vanilla-___index__grommetux-search--inline___391-m",
	"grommetux-control-icon-search": "node_modules-grommet-scss-vanilla-___index__grommetux-control-icon-search___1i7iY",
	"grommetux-search--small": "node_modules-grommet-scss-vanilla-___index__grommetux-search--small___1hqG5",
	"grommetux-search--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-search--medium___2yzgR",
	"grommetux-search--large": "node_modules-grommet-scss-vanilla-___index__grommetux-search--large___1bg_Q",
	"grommetux-search--icon-align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-search--icon-align-start___3wqIE",
	"grommetux-search--fill": "node_modules-grommet-scss-vanilla-___index__grommetux-search--fill___3YChL",
	"grommetux-search--pad-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-search--pad-medium___pfbmt",
	"grommetux-search-input__input": "node_modules-grommet-scss-vanilla-___index__grommetux-search-input__input___rbKgh",
	"grommetux-search-input__suggestions": "node_modules-grommet-scss-vanilla-___index__grommetux-search-input__suggestions___rEM5f",
	"grommetux-search-input__suggestion": "node_modules-grommet-scss-vanilla-___index__grommetux-search-input__suggestion___3PgWK",
	"grommetux-search-input__suggestion--active": "node_modules-grommet-scss-vanilla-___index__grommetux-search-input__suggestion--active___2fvjw",
	"grommetux-search-input--active": "node_modules-grommet-scss-vanilla-___index__grommetux-search-input--active___2pwv1",
	"grommetux-section": "node_modules-grommet-scss-vanilla-___index__grommetux-section___2VeRD",
	"layer": "node_modules-grommet-scss-vanilla-___index__layer___23Xvt",
	"grommetux-select__input": "node_modules-grommet-scss-vanilla-___index__grommetux-select__input___evVzB",
	"grommetux-select__control": "node_modules-grommet-scss-vanilla-___index__grommetux-select__control___3gIT6",
	"grommetux-select__search": "node_modules-grommet-scss-vanilla-___index__grommetux-select__search___1Lja3",
	"grommetux-select__option": "node_modules-grommet-scss-vanilla-___index__grommetux-select__option___3CkFW",
	"grommetux-select__drop": "node_modules-grommet-scss-vanilla-___index__grommetux-select__drop___3ZIrD",
	"grommetux-select__option--element": "node_modules-grommet-scss-vanilla-___index__grommetux-select__option--element___2JUeV",
	"grommetux-select__option--active": "node_modules-grommet-scss-vanilla-___index__grommetux-select__option--active___1tCnA",
	"grommetux-select__option--selected": "node_modules-grommet-scss-vanilla-___index__grommetux-select__option--selected___3sIGY",
	"grommetux-sidebar--fixed": "node_modules-grommet-scss-vanilla-___index__grommetux-sidebar--fixed___30r1w",
	"grommetux-sidebar--xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-sidebar--xsmall___3IddN",
	"grommetux-sidebar--small": "node_modules-grommet-scss-vanilla-___index__grommetux-sidebar--small___3RAvx",
	"grommetux-sidebar--large": "node_modules-grommet-scss-vanilla-___index__grommetux-sidebar--large___uf1Db",
	"grommetux-sidebar--full": "node_modules-grommet-scss-vanilla-___index__grommetux-sidebar--full____sz-6",
	"grommetux-split": "node_modules-grommet-scss-vanilla-___index__grommetux-split___3u6Hw",
	"grommetux-split__column": "node_modules-grommet-scss-vanilla-___index__grommetux-split__column___2292-",
	"grommetux-split__column--hidden": "node_modules-grommet-scss-vanilla-___index__grommetux-split__column--hidden___9NQcg",
	"grommetux-split__column--fixed": "node_modules-grommet-scss-vanilla-___index__grommetux-split__column--fixed___2RfkQ",
	"grommetux-split__column--flex": "node_modules-grommet-scss-vanilla-___index__grommetux-split__column--flex___24LUe",
	"grommetux-split__column--separator": "node_modules-grommet-scss-vanilla-___index__grommetux-split__column--separator___wrAbf",
	"grommetux-skip-link-anchor": "node_modules-grommet-scss-vanilla-___index__grommetux-skip-link-anchor___1jzp0",
	"grommetux-sun-burst": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst___1Zwvh",
	"grommetux-sun-burst__graphic": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__graphic___23DxY",
	"fade-in": "node_modules-grommet-scss-vanilla-___index__fade-in___39_Q8",
	"grommetux-sun-burst__graphic--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__graphic--focus___2GT5q",
	"grommetux-sun-burst__label": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__label___23wtx",
	"grommetux-sun-burst__slice": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice___13u8q",
	"draw-arc": "node_modules-grommet-scss-vanilla-___index__draw-arc___4G5xN",
	"grommetux-sun-burst__slice--hot": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice--hot___1i8ss",
	"grommetux-sun-burst--active": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--active___1R589",
	"grommetux-sun-burst__slice--active": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst__slice--active___1C0hV",
	"grommetux-sun-burst--small": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--small___1jPGu",
	"grommetux-sun-burst--large": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--large___1FWBi",
	"grommetux-sun-burst--xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--xlarge___2KXk6",
	"grommetux-sun-burst--full": "node_modules-grommet-scss-vanilla-___index__grommetux-sun-burst--full___3NuVx",
	"grommetux-tab": "node_modules-grommet-scss-vanilla-___index__grommetux-tab___h7ruL",
	"grommetux-tabs--justify-start": "node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-start___3AZwl",
	"grommetux-tabs--justify-end": "node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-end___5UW44",
	"grommetux-tabs--responsive": "node_modules-grommet-scss-vanilla-___index__grommetux-tabs--responsive___2_JP6",
	"grommetux-tab__label": "node_modules-grommet-scss-vanilla-___index__grommetux-tab__label___2abQX",
	"grommetux-tab--active": "node_modules-grommet-scss-vanilla-___index__grommetux-tab--active___2byGX",
	"grommetux-tabs": "node_modules-grommet-scss-vanilla-___index__grommetux-tabs___15mq5",
	"grommetux-tabs--justify-center": "node_modules-grommet-scss-vanilla-___index__grommetux-tabs--justify-center___3wQZ_",
	"grommetux-table": "node_modules-grommet-scss-vanilla-___index__grommetux-table___2raG_",
	"grommetux-table__mirror": "node_modules-grommet-scss-vanilla-___index__grommetux-table__mirror___5rL2d",
	"grommetux-table__more": "node_modules-grommet-scss-vanilla-___index__grommetux-table__more___lvIas",
	"grommetux-table--scrollable": "node_modules-grommet-scss-vanilla-___index__grommetux-table--scrollable___aOpoY",
	"grommetux-table__table": "node_modules-grommet-scss-vanilla-___index__grommetux-table__table___h6aQZ",
	"grommetux-table__table--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-table__table--focus___3axUf",
	"grommetux-table-row--selected": "node_modules-grommet-scss-vanilla-___index__grommetux-table-row--selected___2gJW9",
	"grommetux-table-row--active": "node_modules-grommet-scss-vanilla-___index__grommetux-table-row--active___Jvnt_",
	"grommetux-table--small": "node_modules-grommet-scss-vanilla-___index__grommetux-table--small___2d8Ti",
	"grommetux-tbd": "node_modules-grommet-scss-vanilla-___index__grommetux-tbd___3Epcv",
	"grommetux-text-input--active": "node_modules-grommet-scss-vanilla-___index__grommetux-text-input--active___8RuZa",
	"grommetux-text-input__suggestions": "node_modules-grommet-scss-vanilla-___index__grommetux-text-input__suggestions___Mc3o2",
	"grommetux-text-input__suggestion": "node_modules-grommet-scss-vanilla-___index__grommetux-text-input__suggestion___L-_Mz",
	"grommetux-text-input__suggestion--active": "node_modules-grommet-scss-vanilla-___index__grommetux-text-input__suggestion--active___3wxLi",
	"grommetux-tiles--pad-none": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-none___20uWQ",
	"grommetux-tiles--pad-small": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-small___3u-YG",
	"grommetux-tiles--pad-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-medium___E-hlM",
	"grommetux-tiles--pad-large": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-large___CihIa",
	"grommetux-tiles--pad-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-xlarge___2l9be",
	"grommetux-tiles--pad-horizontal-none": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-none___2mUzW",
	"grommetux-tiles--pad-horizontal-small": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-small___3bKWD",
	"grommetux-tiles--pad-horizontal-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-medium___2vaIe",
	"grommetux-tiles--pad-horizontal-large": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-large___1RYOG",
	"grommetux-tiles--pad-horizontal-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-horizontal-xlarge___1kgco",
	"grommetux-tiles--pad-vertical-none": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-none___3WDUM",
	"grommetux-tiles--pad-vertical-small": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-small___fB-T6",
	"grommetux-tiles--pad-vertical-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-medium___35hUH",
	"grommetux-tiles--pad-vertical-large": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-large___3Avgg",
	"grommetux-tiles--pad-vertical-xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--pad-vertical-xlarge___2l1dk",
	"grommetux-tiles--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--focus___3tBy8",
	"grommetux-tiles__left": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles__left___19CLE",
	"grommetux-tiles__right": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles__right___I21lW",
	"grommetux-tiles--flush": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--flush___1JDIe",
	"grommetux-tile--wide": "node_modules-grommet-scss-vanilla-___index__grommetux-tile--wide___2Pavn",
	"grommetux-tile--hover-border-medium": "node_modules-grommet-scss-vanilla-___index__grommetux-tile--hover-border-medium___PThq1",
	"grommetux-tile--hover-border-large": "node_modules-grommet-scss-vanilla-___index__grommetux-tile--hover-border-large___lenqG",
	"grommetux-tiles--fill": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--fill___1vWBQ",
	"grommetux-tiles__more": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles__more___21hhb",
	"grommetux-tiles--selectable": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--selectable___2ATXn",
	"grommetux-tile--selected": "node_modules-grommet-scss-vanilla-___index__grommetux-tile--selected___2k6hl",
	"grommetux-tile--active": "node_modules-grommet-scss-vanilla-___index__grommetux-tile--active___2sjgs",
	"grommetux-tiles--small": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--small___2VfqQ",
	"grommetux-tiles--large": "node_modules-grommet-scss-vanilla-___index__grommetux-tiles--large___1W0F3",
	"grommetux-tile--selectable": "node_modules-grommet-scss-vanilla-___index__grommetux-tile--selectable___TMYuL",
	"grommetux-tile--eclipsed": "node_modules-grommet-scss-vanilla-___index__grommetux-tile--eclipsed___38uu6",
	"grommetux-timestamp--center": "node_modules-grommet-scss-vanilla-___index__grommetux-timestamp--center___2NMH4",
	"grommetux-timestamp--end": "node_modules-grommet-scss-vanilla-___index__grommetux-timestamp--end___3G-H0",
	"grommetux-timestamp__date": "node_modules-grommet-scss-vanilla-___index__grommetux-timestamp__date___1aIBD",
	"grommetux-timestamp__time": "node_modules-grommet-scss-vanilla-___index__grommetux-timestamp__time___3TaKi",
	"grommetux-tip__drop": "node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop___30DEj",
	"grommetux-tip__drop--top": "node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--top___1CNCB",
	"grommetux-tip__drop--bottom": "node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--bottom___1ZHAz",
	"grommetux-tip__drop--left": "node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--left___WQ_xJ",
	"grommetux-tip__drop--right": "node_modules-grommet-scss-vanilla-___index__grommetux-tip__drop--right___3bSPu",
	"grommetux-tip": "node_modules-grommet-scss-vanilla-___index__grommetux-tip___6lQMN",
	"grommetux-title": "node_modules-grommet-scss-vanilla-___index__grommetux-title___1wy_o",
	"grommetux-title--interactive": "node_modules-grommet-scss-vanilla-___index__grommetux-title--interactive___2MNC7",
	"grommetux-title--responsive": "node_modules-grommet-scss-vanilla-___index__grommetux-title--responsive___1l82t",
	"grommetux-title--truncate": "node_modules-grommet-scss-vanilla-___index__grommetux-title--truncate___12Z0Y",
	"grommetux-toast__container": "node_modules-grommet-scss-vanilla-___index__grommetux-toast__container___2qHNe",
	"grommetux-toast": "node_modules-grommet-scss-vanilla-___index__grommetux-toast___267EQ",
	"toast-lower": "node_modules-grommet-scss-vanilla-___index__toast-lower___3U-xX",
	"grommetux-toast--closing": "node_modules-grommet-scss-vanilla-___index__grommetux-toast--closing___3i3VN",
	"toast-raise": "node_modules-grommet-scss-vanilla-___index__toast-raise___1c4hp",
	"grommetux-toast__closer": "node_modules-grommet-scss-vanilla-___index__grommetux-toast__closer___2wDWO",
	"grommetux-toast__status": "node_modules-grommet-scss-vanilla-___index__grommetux-toast__status___Cknf-",
	"grommetux-toast__contents": "node_modules-grommet-scss-vanilla-___index__grommetux-toast__contents___3Na0g",
	"grommetux-toast--small": "node_modules-grommet-scss-vanilla-___index__grommetux-toast--small___2E7xR",
	"grommetux-toast--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-toast--medium___3DS1K",
	"grommetux-toast--large": "node_modules-grommet-scss-vanilla-___index__grommetux-toast--large___aSg91",
	"grommetux-topology": "node_modules-grommet-scss-vanilla-___index__grommetux-topology___uJvZ8",
	"grommetux-topology--focus": "node_modules-grommet-scss-vanilla-___index__grommetux-topology--focus___n7egl",
	"grommetux-topology__links": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__links___2AXaz",
	"grommetux-topology__path": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__path___3Qrn6",
	"grommetux-topology__path--active": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__path--active___Pcioz",
	"grommetux-topology__contents": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__contents___2ASjL",
	"grommetux-topology__parts--direction-row": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--direction-row___rwM3O",
	"grommetux-topology__part": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part___3H-7J",
	"grommetux-topology__parts--direction-column": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--direction-column___1IKbX",
	"grommetux-topology__parts": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts___vIyTZ",
	"grommetux-topology__parts--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--align-start___B6dBC",
	"grommetux-topology__parts--align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--align-center___2MHaE",
	"grommetux-topology__parts--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--align-end___5fgNg",
	"grommetux-topology__parts--align-stretch": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__parts--align-stretch___YPF-7",
	"grommetux-topology__part--demarcate": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--demarcate___34l_y",
	"grommetux-topology__part--empty": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--empty___v8Irk",
	"grommetux-topology__part--justify-start": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--justify-start___20-w9",
	"grommetux-topology__part--justify-center": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--justify-center___2HEyj",
	"grommetux-topology__part--justify-between": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--justify-between___Uu2y4",
	"grommetux-topology__part--justify-end": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--justify-end___2YLYw",
	"grommetux-topology__part--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--align-start___1Pq_i",
	"grommetux-topology__part--align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--align-center___1WEEB",
	"grommetux-topology__part--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--align-end___1CNsx",
	"grommetux-topology__part--align-stretch": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--align-stretch___36Y05",
	"grommetux-topology__part--direction-row": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--direction-row___29zY-",
	"grommetux-topology__part--reverse": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--reverse___HuwlQ",
	"grommetux-topology__part--direction-column": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__part--direction-column___3RHbM",
	"grommetux-topology__label": "node_modules-grommet-scss-vanilla-___index__grommetux-topology__label___39QEQ",
	"grommetux-value": "node_modules-grommet-scss-vanilla-___index__grommetux-value___3pSpv",
	"grommetux-value--align-start": "node_modules-grommet-scss-vanilla-___index__grommetux-value--align-start___OIQJX",
	"grommetux-value--align-center": "node_modules-grommet-scss-vanilla-___index__grommetux-value--align-center___2JpVV",
	"grommetux-value--align-end": "node_modules-grommet-scss-vanilla-___index__grommetux-value--align-end___1saaX",
	"grommetux-value--active": "node_modules-grommet-scss-vanilla-___index__grommetux-value--active___2mgO_",
	"grommetux-value__annotated": "node_modules-grommet-scss-vanilla-___index__grommetux-value__annotated___17DND",
	"grommetux-value__label": "node_modules-grommet-scss-vanilla-___index__grommetux-value__label___3Hfrz",
	"grommetux-value__value": "node_modules-grommet-scss-vanilla-___index__grommetux-value__value___3S7Cj",
	"grommetux-value__units": "node_modules-grommet-scss-vanilla-___index__grommetux-value__units___3smbH",
	"grommetux-value--xsmall": "node_modules-grommet-scss-vanilla-___index__grommetux-value--xsmall___3XyUc",
	"grommetux-value--small": "node_modules-grommet-scss-vanilla-___index__grommetux-value--small___vXUNE",
	"grommetux-value--large": "node_modules-grommet-scss-vanilla-___index__grommetux-value--large___1AeJu",
	"grommetux-value--xlarge": "node_modules-grommet-scss-vanilla-___index__grommetux-value--xlarge___20BKf",
	"grommetux-value--responsive": "node_modules-grommet-scss-vanilla-___index__grommetux-value--responsive___24clx",
	"grommetux-video--small": "node_modules-grommet-scss-vanilla-___index__grommetux-video--small___33gYA",
	"grommetux-video--medium": "node_modules-grommet-scss-vanilla-___index__grommetux-video--medium___1pnm3",
	"grommetux-video--large": "node_modules-grommet-scss-vanilla-___index__grommetux-video--large___mLq6I",
	"grommetux-video--full": "node_modules-grommet-scss-vanilla-___index__grommetux-video--full___13lVr",
	"grommetux-video--align-top": "node_modules-grommet-scss-vanilla-___index__grommetux-video--align-top___20fMk",
	"grommetux-video--align-left": "node_modules-grommet-scss-vanilla-___index__grommetux-video--align-left___1hfvc",
	"grommetux-video--align-right": "node_modules-grommet-scss-vanilla-___index__grommetux-video--align-right___ZkyOd",
	"grommetux-video--align-bottom": "node_modules-grommet-scss-vanilla-___index__grommetux-video--align-bottom___3uQwl",
	"grommetux-video--cover": "node_modules-grommet-scss-vanilla-___index__grommetux-video--cover___3C6SA",
	"grommetux-video--contain": "node_modules-grommet-scss-vanilla-___index__grommetux-video--contain___2IJXy",
	"grommetux-video__button": "node_modules-grommet-scss-vanilla-___index__grommetux-video__button___1meT4",
	"grommetux-video__button__icon": "node_modules-grommet-scss-vanilla-___index__grommetux-video__button__icon___3xOl4",
	"grommetux-video__timeline": "node_modules-grommet-scss-vanilla-___index__grommetux-video__timeline___2UvvC",
	"grommetux-video__progress": "node_modules-grommet-scss-vanilla-___index__grommetux-video__progress___AbFjL",
	"grommetux-video--has-timeline": "node_modules-grommet-scss-vanilla-___index__grommetux-video--has-timeline___2gvG6",
	"grommetux-video__controls": "node_modules-grommet-scss-vanilla-___index__grommetux-video__controls___cYj3N",
	"grommetux-video__replay": "node_modules-grommet-scss-vanilla-___index__grommetux-video__replay___1aGIN",
	"grommetux-video--has-played": "node_modules-grommet-scss-vanilla-___index__grommetux-video--has-played___1o_59",
	"grommetux-video--ended": "node_modules-grommet-scss-vanilla-___index__grommetux-video--ended___Rljb8",
	"grommetux-video__play": "node_modules-grommet-scss-vanilla-___index__grommetux-video__play___1Zewt",
	"grommetux-video__overlay": "node_modules-grommet-scss-vanilla-___index__grommetux-video__overlay___1XHrF",
	"grommetux-video__controls-primary": "node_modules-grommet-scss-vanilla-___index__grommetux-video__controls-primary___hOiNI",
	"grommetux-video__chapter-labels": "node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-labels___30phc",
	"grommetux-video--interacting": "node_modules-grommet-scss-vanilla-___index__grommetux-video--interacting___P_8uF",
	"grommetux-video__progress-bar-fill": "node_modules-grommet-scss-vanilla-___index__grommetux-video__progress-bar-fill___30pL3",
	"grommetux-video__chapter-label": "node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-label___IbOnh",
	"grommetux-video__chapter-label-start": "node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-label-start___140z5",
	"grommetux-video__chapter-label-active": "node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-label-active___3rKev",
	"grommetux-video__chapter-marker": "node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker___isxpR",
	"grommetux-video__chapter-marker-track": "node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker-track___2bbax",
	"grommetux-video__chapter-marker-tick": "node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker-tick___1s3kH",
	"grommetux-video__chapter-marker-tick-start": "node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker-tick-start___2rNcP",
	"grommetux-video__chapter-marker-tickhover": "node_modules-grommet-scss-vanilla-___index__grommetux-video__chapter-marker-tickhover___2lZha",
	"grommetux-video--playing": "node_modules-grommet-scss-vanilla-___index__grommetux-video--playing___3UcHd",
	"grommetux-world-map": "node_modules-grommet-scss-vanilla-___index__grommetux-world-map___aT_Ot",
	"grommetux-world-map__container": "node_modules-grommet-scss-vanilla-___index__grommetux-world-map__container___1NIu9",
	"grommetux-world-map__flag": "node_modules-grommet-scss-vanilla-___index__grommetux-world-map__flag___q0by7",
	"grommetux-world-map__continent": "node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent___EPGty",
	"grommetux-world-map__place": "node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place___34GiN",
	"grommetux-world-map__continent--active": "node_modules-grommet-scss-vanilla-___index__grommetux-world-map__continent--active___2Ym7K",
	"grommetux-world-map__place--active": "node_modules-grommet-scss-vanilla-___index__grommetux-world-map__place--active___2ZDfw",
	"grommetux-tab__button": "node_modules-grommet-scss-vanilla-___index__grommetux-tab__button___3epIV",
	"fadein": "node_modules-grommet-scss-vanilla-___index__fadein___3i-GT"
};

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_messages_List__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_messages_Details__ = __webpack_require__(423);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Messages=function(_Component){_inherits(Messages,_Component);function Messages(){_classCallCheck(this,Messages);return _possibleConstructorReturn(this,(Messages.__proto__||Object.getPrototypeOf(Messages)).apply(this,arguments));}_createClass(Messages,[{key:'render',value:function render(){console.log(this.props.match.params.uuid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messages-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messages-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_messages_List__["a" /* default */],{active:this.props.match.params.uuid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-section'},this.props.match.params.uuid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_messages_Details__["a" /* default */],{uuid:this.props.match.params.uuid}))));}}]);return Messages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Messages);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(227);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_convo__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dropdown__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sofia_ui__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sofia_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sofia_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__New__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_List__ = __webpack_require__(80);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery Messages {\n  conversations(orderBy: "last_message", order: DESC) {\n    id\n    _id\n    name\n    last_message\n    tags\n    messages (first: 1, order: DESC) {\n      id\n      _id\n      body\n    }\n    user_conversations {\n      id\n      user {\n        id\n        _id\n        first_name\n        last_name\n        phone_number\n        email\n      }\n    }\n  }\n}\n'],['\nquery Messages {\n  conversations(orderBy: "last_message", order: DESC) {\n    id\n    _id\n    name\n    last_message\n    tags\n    messages (first: 1, order: DESC) {\n      id\n      _id\n      body\n    }\n    user_conversations {\n      id\n      user {\n        id\n        _id\n        first_name\n        last_name\n        phone_number\n        email\n      }\n    }\n  }\n}\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var QUERY=__WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject);var MessagesList=function(_Component){_inherits(MessagesList,_Component);function MessagesList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MessagesList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MessagesList.__proto__||Object.getPrototypeOf(MessagesList)).call.apply(_ref,[this].concat(args))),_this),_this.state={filter:'Inbox',add:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MessagesList,[{key:'render',value:function render(){var _this2=this;var filter=this.state.filter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:QUERY,variables:{cursor:0,limit:20},pollInterval:7500},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,fetchMore=_ref2.fetchMore;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Loading...');if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Error :(');};var convos=data.conversations.filter(function(_ref3){var tags=_ref3.tags;if(filter==="Inbox")return tags.includes('New')||tags.includes('Urgent')||tags.includes('Need followup');return tags.includes(filter);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__New__["a" /* default */],{hide:_this2.state.add,close:function close(){return _this2.setState({add:true});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_List__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Dropdown__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-filter'}),' ',filter),options:[{label:"Inbox",value:"Inbox"},{label:"New",value:"New"},{label:"Urgent",value:"Urgent"},{label:"Awaiting Data",value:"Awaiting Data"},{label:"Need followup",value:"Need followup"},{label:"Closed",value:"Closed"},{label:"Development",value:"Development"},{label:"Spam",value:"Spam"},{label:"Old",value:"old"}],onSelect:function onSelect(filter){return _this2.setState({filter:filter});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_sofia_ui__["Button"],{small:true,color:'dark',onClick:function onClick(){console.log('OPEN');_this2.setState({add:false});}},'New')),list:convos.map(function(_ref4){var _id=_ref4._id,name=_ref4.name,messages=_ref4.messages,user_conversations=_ref4.user_conversations,tags=_ref4.tags,last_message=_ref4.last_message;return{link:'/messages/'+_id,active:_id===_this2.props.active,title:Object(__WEBPACK_IMPORTED_MODULE_2__utils_convo__["b" /* getConvoName */])(user_conversations),body:messages[0]&&messages[0].body&&messages[0].body.substr(0,90).replace(/(?:\r\n|\r|\n)/g,' ').replace(/(?:\t)/g,' ').replace(/(?:<br\/>)/g,'').replace(/( )+/g,' '),footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.date},__WEBPACK_IMPORTED_MODULE_3_moment___default()(last_message).format("YYYY-MM-DD")),' ',tags.map(function(tag,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.tag,key:i},tag);}))};})}));});}}]);return MessagesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MessagesList);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(230);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-containers-messages-List-___style__container___UlWFs {\n  position: absolute;\n  top: 56px;\n  left: 0px;\n  bottom: 0;\n  width: 320px;\n  background-color: rgba(0, 0, 0, 0.02);\n  overflow: auto; }\n  .src-containers-messages-List-___style__container___UlWFs a {\n    text-decoration: none;\n    color: inherit; }\n\n.src-containers-messages-List-___style__menu___3q0om {\n  padding: 16px 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n  display: flex;\n  align-items: center;\n  justify-content: space-between; }\n\n.src-containers-messages-List-___style__box___1HnLM {\n  font-size: 14px;\n  padding: 16px 20px;\n  overflow: hidden;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n  cursor: pointer;\n  text-decoration: none;\n  color: inherit; }\n  .src-containers-messages-List-___style__box___1HnLM:hover, .src-containers-messages-List-___style__box___1HnLM.src-containers-messages-List-___style__active___AOHHX {\n    background-color: rgba(0, 0, 0, 0.03); }\n  .src-containers-messages-List-___style__box___1HnLM h3 {\n    font-size: 18px;\n    margin: 0;\n    margin-bottom: 4px; }\n  .src-containers-messages-List-___style__box___1HnLM .src-containers-messages-List-___style__tags___1lfUe {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center; }\n    .src-containers-messages-List-___style__box___1HnLM .src-containers-messages-List-___style__tags___1lfUe .src-containers-messages-List-___style__date___v1XF9 {\n      margin-top: 2px;\n      margin-right: 6px; }\n    .src-containers-messages-List-___style__box___1HnLM .src-containers-messages-List-___style__tags___1lfUe .src-containers-messages-List-___style__tag___2e3hg {\n      font-size: 10px;\n      background-color: #ddd;\n      padding: 3px 6px;\n      border-radius: 8px;\n      margin: 4px 3px 2px 0; }\n", ""]);

// exports
exports.locals = {
	"container": "src-containers-messages-List-___style__container___UlWFs",
	"menu": "src-containers-messages-List-___style__menu___3q0om",
	"box": "src-containers-messages-List-___style__box___1HnLM",
	"active": "src-containers-messages-List-___style__active___AOHHX",
	"tags": "src-containers-messages-List-___style__tags___1lfUe",
	"date": "src-containers-messages-List-___style__date___v1XF9",
	"tag": "src-containers-messages-List-___style__tag___2e3hg"
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(232);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-components-Dropdown-___style__container___242Lf {\n  position: relative; }\n  .src-components-Dropdown-___style__container___242Lf .src-components-Dropdown-___style__label___y7fJV {\n    cursor: pointer; }\n\n.src-components-Dropdown-___style__dropdown___3CUom {\n  position: absolute;\n  background-color: #fff;\n  box-shadow: 0 2px 8px -1px rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n  min-width: 180px;\n  max-height: 340px;\n  margin-top: 6px;\n  padding: 6px 0;\n  z-index: 100;\n  overflow-y: auto; }\n  .src-components-Dropdown-___style__dropdown___3CUom.src-components-Dropdown-___style__top___C51u3 {\n    bottom: 30px; }\n\n.src-components-Dropdown-___style__option___eQnP9 {\n  padding: 4px 16px;\n  font-size: 16px; }\n  .src-components-Dropdown-___style__option___eQnP9:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n    cursor: pointer; }\n  .src-components-Dropdown-___style__option___eQnP9.src-components-Dropdown-___style__active___23s3G {\n    background-color: #FFC837;\n    color: white; }\n", ""]);

// exports
exports.locals = {
	"container": "src-components-Dropdown-___style__container___242Lf",
	"label": "src-components-Dropdown-___style__label___y7fJV",
	"dropdown": "src-components-Dropdown-___style__dropdown___3CUom",
	"top": "src-components-Dropdown-___style__top___C51u3",
	"option": "src-components-Dropdown-___style__option___eQnP9",
	"active": "src-components-Dropdown-___style__active___23s3G"
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(234);


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(15);

var ReactBaseClasses = __webpack_require__(103);
var ReactChildren = __webpack_require__(236);
var ReactDOMFactories = __webpack_require__(241);
var ReactElement = __webpack_require__(23);
var ReactPropTypes = __webpack_require__(242);
var ReactVersion = __webpack_require__(246);

var createReactClass = __webpack_require__(247);
var onlyChild = __webpack_require__(249);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(237);
var ReactElement = __webpack_require__(23);

var emptyFunction = __webpack_require__(20);
var traverseAllChildren = __webpack_require__(238);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(43);

var invariant = __webpack_require__(11);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(43);

var ReactCurrentOwner = __webpack_require__(106);
var REACT_ELEMENT_TYPE = __webpack_require__(107);

var getIteratorFn = __webpack_require__(239);
var invariant = __webpack_require__(11);
var KeyEscapeUtils = __webpack_require__(240);
var warning = __webpack_require__(44);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(23);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(23),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(243);

module.exports = factory(isValidElement);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(244);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(20);
var invariant = __webpack_require__(11);
var warning = __webpack_require__(44);
var assign = __webpack_require__(15);

var ReactPropTypesSecret = __webpack_require__(84);
var checkPropTypes = __webpack_require__(245);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(103),
    Component = _require.Component;

var _require2 = __webpack_require__(23),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(104);
var factory = __webpack_require__(248);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(15);

var emptyObject = __webpack_require__(37);
var _invariant = __webpack_require__(11);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(43);

var ReactElement = __webpack_require__(23);

var invariant = __webpack_require__(11);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction2 = __webpack_require__(40);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _extendReactClass = __webpack_require__(251);

var _extendReactClass2 = _interopRequireDefault(_extendReactClass);

var _wrapStatelessFunction = __webpack_require__(343);

var _wrapStatelessFunction2 = _interopRequireDefault(_wrapStatelessFunction);

var _makeConfiguration = __webpack_require__(349);

var _makeConfiguration2 = _interopRequireDefault(_makeConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Determines if the given object has the signature of a class that inherits React.Component.
 */


/**
 * @see https://github.com/gajus/react-css-modules#options
 */
var isReactComponent = function isReactComponent(maybeReactComponent) {
  return 'prototype' in maybeReactComponent && (0, _isFunction3.default)(maybeReactComponent.prototype.render);
};

/**
 * When used as a function.
 */
var functionConstructor = function functionConstructor(Component, defaultStyles, options) {
  var decoratedClass = void 0;

  var configuration = (0, _makeConfiguration2.default)(options);

  if (isReactComponent(Component)) {
    decoratedClass = (0, _extendReactClass2.default)(Component, defaultStyles, configuration);
  } else {
    decoratedClass = (0, _wrapStatelessFunction2.default)(Component, defaultStyles, configuration);
  }

  if (Component.displayName) {
    decoratedClass.displayName = Component.displayName;
  } else {
    decoratedClass.displayName = Component.name;
  }

  return decoratedClass;
};

/**
 * When used as a ES7 decorator.
 */
var decoratorConstructor = function decoratorConstructor(defaultStyles, options) {
  return function (Component) {
    return functionConstructor(Component, defaultStyles, options);
  };
};

exports.default = function () {
  if ((0, _isFunction3.default)(arguments.length <= 0 ? undefined : arguments[0])) {
    return functionConstructor(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
  } else {
    return decoratorConstructor(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]);
  }
};

module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject2 = __webpack_require__(10);

var _isObject3 = _interopRequireDefault(_isObject2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(252);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _linkClass = __webpack_require__(108);

var _linkClass2 = _interopRequireDefault(_linkClass);

var _renderNothing = __webpack_require__(125);

var _renderNothing2 = _interopRequireDefault(_renderNothing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); } /* eslint-disable react/prop-types */

/**
 * @param {ReactClass} Component
 * @param {Object} defaultStyles
 * @param {Object} options
 * @returns {ReactClass}
 */
exports.default = function (Component, defaultStyles, options) {
  var WrappedComponent = function (_Component) {
    _inherits(WrappedComponent, _Component);

    function WrappedComponent() {
      _classCallCheck(this, WrappedComponent);

      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    WrappedComponent.prototype.render = function render() {
      var styles = void 0;

      var hasDefaultstyles = (0, _isObject3.default)(defaultStyles);

      if (this.props.styles || hasDefaultstyles) {
        var props = Object.assign({}, this.props);

        if (props.styles) {
          styles = props.styles;
        } else if (hasDefaultstyles) {
          styles = defaultStyles;
          delete props.styles;
        }

        Object.defineProperty(props, 'styles', {
          configurable: true,
          enumerable: false,
          value: styles,
          writable: false
        });

        this.props = props;
      } else {
        styles = {};
      }

      var renderResult = _Component.prototype.render.call(this);

      if (renderResult) {
        return (0, _linkClass2.default)(renderResult, styles, options);
      }

      return (0, _renderNothing2.default)(_react2.default.version);
    };

    return WrappedComponent;
  }(Component);

  return (0, _hoistNonReactStatics2.default)(WrappedComponent, Component);
};

module.exports = exports['default'];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(255),
    keys = __webpack_require__(31);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(256);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(258),
    isArguments = __webpack_require__(64),
    isArray = __webpack_require__(5),
    isBuffer = __webpack_require__(111),
    isIndex = __webpack_require__(66),
    isTypedArray = __webpack_require__(112);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 258 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(17),
    isLength = __webpack_require__(67),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(94);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)(module)))

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(113),
    nativeKeys = __webpack_require__(264);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(265);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(32);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(41);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

/**
 * Make a shallow copy of the object maintaining the prototype.
 */

exports.default = function (source) {
    var target = void 0;

    if (source.constructor === Array) {
        target = source.map(function (element) {
            return element;
        });
    } else {
        target = {};
        for (var property in source) {
            if (source.hasOwnProperty(property)) {
                target[property] = source[property];
            }
        }
    }

    _defaults(target, Object.getPrototypeOf(source));

    return target;
};

module.exports = exports['default'];
//# sourceMappingURL=objectUnfreeze.js.map


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject2 = __webpack_require__(10);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isFunction2 = __webpack_require__(40);

var _isFunction3 = _interopRequireDefault(_isFunction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ITERATOR_SYMBOL = typeof Symbol !== 'undefined' && (0, _isFunction3.default)(Symbol) && Symbol.iterator;
var OLD_ITERATOR_SYMBOL = '@@iterator';

/**
 * @see https://github.com/lodash/lodash/issues/1668
 * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Iteration_protocols
 */

exports.default = function (maybeIterable) {
  var iterator = void 0;

  if (!(0, _isObject3.default)(maybeIterable)) {
    return false;
  }

  if (ITERATOR_SYMBOL) {
    iterator = maybeIterable[ITERATOR_SYMBOL];
  } else {
    iterator = maybeIterable[OLD_ITERATOR_SYMBOL];
  }

  return (0, _isFunction3.default)(iterator);
};

module.exports = exports['default'];

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = __webpack_require__(271);

var _filter3 = _interopRequireDefault(_filter2);

var _trim2 = __webpack_require__(329);

var _trim3 = _interopRequireDefault(_trim2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleNameIndex = {};

exports.default = function (styleNamePropertyValue, allowMultiple) {
  var styleNames = void 0;

  if (styleNameIndex[styleNamePropertyValue]) {
    styleNames = styleNameIndex[styleNamePropertyValue];
  } else {
    styleNames = (0, _trim3.default)(styleNamePropertyValue).split(/\s+/);
    styleNames = (0, _filter3.default)(styleNames);

    styleNameIndex[styleNamePropertyValue] = styleNames;
  }

  if (allowMultiple === false && styleNames.length > 1) {
    throw new Error('ReactElement styleName property defines multiple module names ("' + styleNamePropertyValue + '").');
  }

  return styleNames;
};

module.exports = exports['default'];

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(114),
    baseFilter = __webpack_require__(272),
    baseIteratee = __webpack_require__(273),
    isArray = __webpack_require__(5);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(110);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(274),
    baseMatchesProperty = __webpack_require__(318),
    identity = __webpack_require__(41),
    isArray = __webpack_require__(5),
    property = __webpack_require__(326);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(275),
    getMatchData = __webpack_require__(317),
    matchesStrictComparable = __webpack_require__(119);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(115),
    baseIsEqual = __webpack_require__(116);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 276 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(46);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(46);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(46);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(46);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(45);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(45),
    Map = __webpack_require__(68),
    MapCache = __webpack_require__(69);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(287),
    ListCache = __webpack_require__(45),
    Map = __webpack_require__(68);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(288),
    hashDelete = __webpack_require__(289),
    hashGet = __webpack_require__(290),
    hashHas = __webpack_require__(291),
    hashSet = __webpack_require__(292);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(48);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(48);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(48);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(48);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(49);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(49);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(49);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(49);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(115),
    equalArrays = __webpack_require__(117),
    equalByTag = __webpack_require__(304),
    equalObjects = __webpack_require__(308),
    getTag = __webpack_require__(313),
    isArray = __webpack_require__(5),
    isBuffer = __webpack_require__(111),
    isTypedArray = __webpack_require__(112);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(69),
    setCacheAdd = __webpack_require__(300),
    setCacheHas = __webpack_require__(301);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 301 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(28),
    Uint8Array = __webpack_require__(305),
    eq = __webpack_require__(47),
    equalArrays = __webpack_require__(117),
    mapToArray = __webpack_require__(306),
    setToArray = __webpack_require__(307);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(13);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(309);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(310),
    getSymbols = __webpack_require__(311),
    keys = __webpack_require__(31);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(93),
    isArray = __webpack_require__(5);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(114),
    stubArray = __webpack_require__(312);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(314),
    Map = __webpack_require__(68),
    Promise = __webpack_require__(315),
    Set = __webpack_require__(316),
    WeakMap = __webpack_require__(100),
    baseGetTag = __webpack_require__(17),
    toSource = __webpack_require__(98);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18),
    root = __webpack_require__(13);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18),
    root = __webpack_require__(13);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18),
    root = __webpack_require__(13);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(118),
    keys = __webpack_require__(31);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(116),
    get = __webpack_require__(319),
    hasIn = __webpack_require__(323),
    isKey = __webpack_require__(70),
    isStrictComparable = __webpack_require__(118),
    matchesStrictComparable = __webpack_require__(119),
    toKey = __webpack_require__(51);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(120);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(321);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(322);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(69);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(324),
    hasPath = __webpack_require__(325);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(121),
    isArguments = __webpack_require__(64),
    isArray = __webpack_require__(5),
    isIndex = __webpack_require__(66),
    isLength = __webpack_require__(67),
    toKey = __webpack_require__(51);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(327),
    basePropertyDeep = __webpack_require__(328),
    isKey = __webpack_require__(70),
    toKey = __webpack_require__(51);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(120);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(123),
    castSlice = __webpack_require__(330),
    charsEndIndex = __webpack_require__(332),
    charsStartIndex = __webpack_require__(336),
    stringToArray = __webpack_require__(337),
    toString = __webpack_require__(122);

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(331);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(71);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 333 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(71);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(338),
    hasUnicode = __webpack_require__(339),
    unicodeToArray = __webpack_require__(340);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleMap = __webpack_require__(342);

var _SimpleMap2 = _interopRequireDefault(_SimpleMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomMap = typeof Map === 'undefined' ? _SimpleMap2.default : Map;

var stylesIndex = new CustomMap();

exports.default = function (styles, styleNames, handleNotFoundStyleName) {
  var appendClassName = void 0;
  var stylesIndexMap = void 0;

  stylesIndexMap = stylesIndex.get(styles);

  if (stylesIndexMap) {
    var styleNameIndex = stylesIndexMap.get(styleNames);

    if (styleNameIndex) {
      return styleNameIndex;
    }
  } else {
    stylesIndexMap = new CustomMap();
    stylesIndex.set(styles, new CustomMap());
  }

  appendClassName = '';

  for (var styleName in styleNames) {
    if (styleNames.hasOwnProperty(styleName)) {
      var className = styles[styleNames[styleName]];

      if (className) {
        appendClassName += ' ' + className;
      } else {
        if (handleNotFoundStyleName === 'throw') {
          throw new Error('"' + styleNames[styleName] + '" CSS module is undefined.');
        }
        if (handleNotFoundStyleName === 'log') {
          // eslint-disable-next-line no-console
          console.warn('"' + styleNames[styleName] + '" CSS module is undefined.');
        }
      }
    }
  }

  appendClassName = appendClassName.trim();

  stylesIndexMap.set(styleNames, appendClassName);

  return appendClassName;
};

module.exports = exports['default'];

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);

    this.size = 0;
    this.keys = [];
    this.values = [];
  }

  _class.prototype.get = function get(key) {
    var index = this.keys.indexOf(key);

    return this.values[index];
  };

  _class.prototype.set = function set(key, value) {
    this.keys.push(key);
    this.values.push(value);
    this.size = this.keys.length;

    return value;
  };

  return _class;
}();

exports.default = _class;
module.exports = exports["default"];

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign2 = __webpack_require__(344);

var _assign3 = _interopRequireDefault(_assign2);

var _isObject2 = __webpack_require__(10);

var _isObject3 = _interopRequireDefault(_isObject2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _linkClass = __webpack_require__(108);

var _linkClass2 = _interopRequireDefault(_linkClass);

var _renderNothing = __webpack_require__(125);

var _renderNothing2 = _interopRequireDefault(_renderNothing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://facebook.github.io/react/blog/2015/09/10/react-v0.14-rc1.html#stateless-function-components
 */
exports.default = function (Component, defaultStyles, options) {
  var WrappedComponent = function WrappedComponent() {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var styles = void 0;
    var useProps = void 0;
    var hasDefaultstyles = (0, _isObject3.default)(defaultStyles);

    if (props.styles || hasDefaultstyles) {
      useProps = Object.assign({}, props);

      if (props.styles) {
        styles = props.styles;
      } else {
        styles = defaultStyles;
      }

      Object.defineProperty(useProps, 'styles', {
        configurable: true,
        enumerable: false,
        value: styles,
        writable: false
      });
    } else {
      useProps = props;
      styles = {};
    }

    var renderResult = Component.apply(undefined, [useProps].concat(args));

    if (renderResult) {
      return (0, _linkClass2.default)(renderResult, styles, options);
    }

    return (0, _renderNothing2.default)(_react2.default.version);
  };

  (0, _assign3.default)(WrappedComponent, Component);

  return WrappedComponent;
}; /* eslint-disable react/prop-types */

module.exports = exports['default'];

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(126),
    copyObject = __webpack_require__(345),
    createAssigner = __webpack_require__(346),
    isArrayLike = __webpack_require__(32),
    isPrototype = __webpack_require__(113),
    keys = __webpack_require__(31);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(126),
    baseAssignValue = __webpack_require__(127);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(347),
    isIterateeCall = __webpack_require__(348);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(41),
    overRest = __webpack_require__(95),
    setToString = __webpack_require__(96);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(47),
    isArrayLike = __webpack_require__(32),
    isIndex = __webpack_require__(66),
    isObject = __webpack_require__(10);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _includes2 = __webpack_require__(350);

var _includes3 = _interopRequireDefault(_includes2);

var _isBoolean2 = __webpack_require__(357);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _isUndefined2 = __webpack_require__(358);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _forEach2 = __webpack_require__(109);

var _forEach3 = _interopRequireDefault(_forEach2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef CSSModules~Options
 * @see {@link https://github.com/gajus/react-css-modules#options}
 * @property {boolean} allowMultiple
 * @property {string} handleNotFoundStyleName
 */

/**
 * @param {CSSModules~Options} userConfiguration
 * @returns {CSSModules~Options}
 */
exports.default = function () {
  var userConfiguration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var configuration = {
    allowMultiple: false,
    handleNotFoundStyleName: 'throw'
  };

  (0, _forEach3.default)(userConfiguration, function (value, name) {
    if ((0, _isUndefined3.default)(configuration[name])) {
      throw new Error('Unknown configuration property "' + name + '".');
    }

    if (name === 'allowMultiple' && !(0, _isBoolean3.default)(value)) {
      throw new Error('"allowMultiple" property value must be a boolean.');
    }

    if (name === 'handleNotFoundStyleName' && !(0, _includes3.default)(['throw', 'log', 'ignore'], value)) {
      throw new Error('"handleNotFoundStyleName" property value must be "throw", "log" or "ignore".');
    }

    configuration[name] = value;
  });

  return configuration;
};

module.exports = exports['default'];

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(71),
    isArrayLike = __webpack_require__(32),
    isString = __webpack_require__(351),
    toInteger = __webpack_require__(352),
    values = __webpack_require__(355);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(17),
    isArray = __webpack_require__(5),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(353);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(354);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10),
    isSymbol = __webpack_require__(50);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(356),
    keys = __webpack_require__(31);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(124);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(17),
    isObjectLike = __webpack_require__(16);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(73);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(129);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(129);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(72);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(73);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(367);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(74);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(371);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(373);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(134);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(375);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(74);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(377);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(75);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(134);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(75);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(381);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(132);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["parse"] = parse;
/* harmony export (immutable) */ __webpack_exports__["parseValue"] = parseValue;
/* harmony export (immutable) */ __webpack_exports__["parseType"] = parseType;
/* harmony export (immutable) */ __webpack_exports__["parseConstValue"] = parseConstValue;
/* harmony export (immutable) */ __webpack_exports__["parseTypeReference"] = parseTypeReference;
/* harmony export (immutable) */ __webpack_exports__["parseNamedType"] = parseNamedType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__source__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lexer__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kinds__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directiveLocation__ = __webpack_require__(390);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */










/**
 * Configuration options to control parser behavior
 */


/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  if (!(sourceObj instanceof __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */])) {
    throw new TypeError('Must provide Source. Received: ' + String(sourceObj));
  }
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  return parseDocument(lexer);
}

/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */
function parseValue(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var value = parseValueLiteral(lexer, false);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF);
  return value;
}

/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */
function parseType(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var type = parseTypeReference(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF);
  return type;
}

/**
 * Converts a name lex token into a name parse node.
 */
function parseName(lexer) {
  var token = expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NAME,
    value: token.value,
    loc: loc(lexer, token)
  };
}

// Implements the parsing rules in the Document section.

/**
 * Document : Definition+
 */
function parseDocument(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var definitions = [];
  do {
    definitions.push(parseDefinition(lexer));
  } while (!skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF));

  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DOCUMENT,
    definitions: definitions,
    loc: loc(lexer, start)
  };
}

/**
 * Definition :
 *   - ExecutableDefinition
 *   - TypeSystemDefinition
 */
function parseDefinition(lexer) {
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
      case 'fragment':
        return parseExecutableDefinition(lexer);
      case 'schema':
      case 'scalar':
      case 'type':
      case 'interface':
      case 'union':
      case 'enum':
      case 'input':
      case 'extend':
      case 'directive':
        // Note: The schema definition language is an experimental addition.
        return parseTypeSystemDefinition(lexer);
    }
  } else if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return parseExecutableDefinition(lexer);
  } else if (peekDescription(lexer)) {
    // Note: The schema definition language is an experimental addition.
    return parseTypeSystemDefinition(lexer);
  }

  throw unexpected(lexer);
}

/**
 * ExecutableDefinition :
 *   - OperationDefinition
 *   - FragmentDefinition
 */
function parseExecutableDefinition(lexer) {
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
        return parseOperationDefinition(lexer);

      case 'fragment':
        return parseFragmentDefinition(lexer);
    }
  } else if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return parseOperationDefinition(lexer);
  }

  throw unexpected(lexer);
}

// Implements the parsing rules in the Operations section.

/**
 * OperationDefinition :
 *  - SelectionSet
 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
 */
function parseOperationDefinition(lexer) {
  var start = lexer.token;
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_DEFINITION,
      operation: 'query',
      name: undefined,
      variableDefinitions: [],
      directives: [],
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }
  var operation = parseOperationType(lexer);
  var name = void 0;
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    name = parseName(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_DEFINITION,
    operation: operation,
    name: name,
    variableDefinitions: parseVariableDefinitions(lexer),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * OperationType : one of query mutation subscription
 */
function parseOperationType(lexer) {
  var operationToken = expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME);
  switch (operationToken.value) {
    case 'query':
      return 'query';
    case 'mutation':
      return 'mutation';
    case 'subscription':
      return 'subscription';
  }

  throw unexpected(lexer, operationToken);
}

/**
 * VariableDefinitions : ( VariableDefinition+ )
 */
function parseVariableDefinitions(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, parseVariableDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R) : [];
}

/**
 * VariableDefinition : Variable : Type DefaultValue?
 */
function parseVariableDefinition(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].VARIABLE_DEFINITION,
    variable: parseVariable(lexer),
    type: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseTypeReference(lexer)),
    defaultValue: skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS) ? parseValueLiteral(lexer, true) : undefined,
    loc: loc(lexer, start)
  };
}

/**
 * Variable : $ Name
 */
function parseVariable(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].DOLLAR);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].VARIABLE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * SelectionSet : { Selection+ }
 */
function parseSelectionSet(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SELECTION_SET,
    selections: many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseSelection, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R),
    loc: loc(lexer, start)
  };
}

/**
 * Selection :
 *   - Field
 *   - FragmentSpread
 *   - InlineFragment
 */
function parseSelection(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SPREAD) ? parseFragment(lexer) : parseField(lexer);
}

/**
 * Field : Alias? Name Arguments? Directives? SelectionSet?
 *
 * Alias : Name :
 */
function parseField(lexer) {
  var start = lexer.token;

  var nameOrAlias = parseName(lexer);
  var alias = void 0;
  var name = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON)) {
    alias = nameOrAlias;
    name = parseName(lexer);
  } else {
    name = nameOrAlias;
  }

  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FIELD,
    alias: alias,
    name: name,
    arguments: parseArguments(lexer, false),
    directives: parseDirectives(lexer, false),
    selectionSet: peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? parseSelectionSet(lexer) : undefined,
    loc: loc(lexer, start)
  };
}

/**
 * Arguments[Const] : ( Argument[?Const]+ )
 */
function parseArguments(lexer, isConst) {
  var item = isConst ? parseConstArgument : parseArgument;
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, item, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R) : [];
}

/**
 * Argument[Const] : Name : Value[?Const]
 */
function parseArgument(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseValueLiteral(lexer, false)),
    loc: loc(lexer, start)
  };
}

function parseConstArgument(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseConstValue(lexer)),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Fragments section.

/**
 * Corresponds to both FragmentSpread and InlineFragment in the spec.
 *
 * FragmentSpread : ... FragmentName Directives?
 *
 * InlineFragment : ... TypeCondition? Directives? SelectionSet
 */
function parseFragment(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SPREAD);
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) && lexer.token.value !== 'on') {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_SPREAD,
      name: parseFragmentName(lexer),
      directives: parseDirectives(lexer, false),
      loc: loc(lexer, start)
    };
  }
  var typeCondition = void 0;
  if (lexer.token.value === 'on') {
    lexer.advance();
    typeCondition = parseNamedType(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INLINE_FRAGMENT,
    typeCondition: typeCondition,
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * FragmentDefinition :
 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
 *
 * TypeCondition : NamedType
 */
function parseFragmentDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'fragment');
  // Experimental support for defining variables within fragments changes
  // the grammar of FragmentDefinition:
  //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
  if (lexer.options.experimentalFragmentVariables) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_DEFINITION,
      name: parseFragmentName(lexer),
      variableDefinitions: parseVariableDefinitions(lexer),
      typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
      directives: parseDirectives(lexer, false),
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_DEFINITION,
    name: parseFragmentName(lexer),
    typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * FragmentName : Name but not `on`
 */
function parseFragmentName(lexer) {
  if (lexer.token.value === 'on') {
    throw unexpected(lexer);
  }
  return parseName(lexer);
}

// Implements the parsing rules in the Values section.

/**
 * Value[Const] :
 *   - [~Const] Variable
 *   - IntValue
 *   - FloatValue
 *   - StringValue
 *   - BooleanValue
 *   - NullValue
 *   - EnumValue
 *   - ListValue[?Const]
 *   - ObjectValue[?Const]
 *
 * BooleanValue : one of `true` `false`
 *
 * NullValue : `null`
 *
 * EnumValue : Name but not `true`, `false` or `null`
 */
function parseValueLiteral(lexer, isConst) {
  var token = lexer.token;
  switch (token.kind) {
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L:
      return parseList(lexer, isConst);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L:
      return parseObject(lexer, isConst);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].INT:
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INT,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].FLOAT:
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FLOAT,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].STRING:
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING:
      return parseStringLiteral(lexer);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME:
      if (token.value === 'true' || token.value === 'false') {
        lexer.advance();
        return {
          kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].BOOLEAN,
          value: token.value === 'true',
          loc: loc(lexer, token)
        };
      } else if (token.value === 'null') {
        lexer.advance();
        return {
          kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NULL,
          loc: loc(lexer, token)
        };
      }
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].DOLLAR:
      if (!isConst) {
        return parseVariable(lexer);
      }
      break;
  }
  throw unexpected(lexer);
}

function parseStringLiteral(lexer) {
  var token = lexer.token;
  lexer.advance();
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].STRING,
    value: token.value,
    block: token.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING,
    loc: loc(lexer, token)
  };
}

function parseConstValue(lexer) {
  return parseValueLiteral(lexer, true);
}

function parseValueValue(lexer) {
  return parseValueLiteral(lexer, false);
}

/**
 * ListValue[Const] :
 *   - [ ]
 *   - [ Value[?Const]+ ]
 */
function parseList(lexer, isConst) {
  var start = lexer.token;
  var item = isConst ? parseConstValue : parseValueValue;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].LIST,
    values: any(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L, item, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_R),
    loc: loc(lexer, start)
  };
}

/**
 * ObjectValue[Const] :
 *   - { }
 *   - { ObjectField[?Const]+ }
 */
function parseObject(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L);
  var fields = [];
  while (!skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R)) {
    fields.push(parseObjectField(lexer, isConst));
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectField[Const] : Name : Value[?Const]
 */
function parseObjectField(lexer, isConst) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_FIELD,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseValueLiteral(lexer, isConst)),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Directives section.

/**
 * Directives[Const] : Directive[?Const]+
 */
function parseDirectives(lexer, isConst) {
  var directives = [];
  while (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT)) {
    directives.push(parseDirective(lexer, isConst));
  }
  return directives;
}

/**
 * Directive[Const] : @ Name Arguments[?Const]?
 */
function parseDirective(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DIRECTIVE,
    name: parseName(lexer),
    arguments: parseArguments(lexer, isConst),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Types section.

/**
 * Type :
 *   - NamedType
 *   - ListType
 *   - NonNullType
 */
function parseTypeReference(lexer) {
  var start = lexer.token;
  var type = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L)) {
    type = parseTypeReference(lexer);
    expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_R);
    type = {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].LIST_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  } else {
    type = parseNamedType(lexer);
  }
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BANG)) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NON_NULL_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  }
  return type;
}

/**
 * NamedType : Name
 */
function parseNamedType(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NAMED_TYPE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Type Definition section.

/**
 * TypeSystemDefinition :
 *   - SchemaDefinition
 *   - TypeDefinition
 *   - TypeExtension
 *   - DirectiveDefinition
 *
 * TypeDefinition :
 *   - ScalarTypeDefinition
 *   - ObjectTypeDefinition
 *   - InterfaceTypeDefinition
 *   - UnionTypeDefinition
 *   - EnumTypeDefinition
 *   - InputObjectTypeDefinition
 */
function parseTypeSystemDefinition(lexer) {
  // Many definitions begin with a description and require a lookahead.
  var keywordToken = peekDescription(lexer) ? lexer.lookahead() : lexer.token;

  if (keywordToken.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) {
    switch (keywordToken.value) {
      case 'schema':
        return parseSchemaDefinition(lexer);
      case 'scalar':
        return parseScalarTypeDefinition(lexer);
      case 'type':
        return parseObjectTypeDefinition(lexer);
      case 'interface':
        return parseInterfaceTypeDefinition(lexer);
      case 'union':
        return parseUnionTypeDefinition(lexer);
      case 'enum':
        return parseEnumTypeDefinition(lexer);
      case 'input':
        return parseInputObjectTypeDefinition(lexer);
      case 'extend':
        return parseTypeExtension(lexer);
      case 'directive':
        return parseDirectiveDefinition(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

function peekDescription(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].STRING) || peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING);
}

/**
 * Description : StringValue
 */
function parseDescription(lexer) {
  if (peekDescription(lexer)) {
    return parseStringLiteral(lexer);
  }
}

/**
 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
 */
function parseSchemaDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'schema');
  var directives = parseDirectives(lexer, true);
  var operationTypes = many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseOperationTypeDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCHEMA_DEFINITION,
    directives: directives,
    operationTypes: operationTypes,
    loc: loc(lexer, start)
  };
}

/**
 * OperationTypeDefinition : OperationType : NamedType
 */
function parseOperationTypeDefinition(lexer) {
  var start = lexer.token;
  var operation = parseOperationType(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseNamedType(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_TYPE_DEFINITION,
    operation: operation,
    type: type,
    loc: loc(lexer, start)
  };
}

/**
 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
 */
function parseScalarTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCALAR_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectTypeDefinition :
 *   Description?
 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
 */
function parseObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * ImplementsInterfaces :
 *   - implements `&`? NamedType
 *   - ImplementsInterfaces & NamedType
 */
function parseImplementsInterfaces(lexer) {
  var types = [];
  if (lexer.token.value === 'implements') {
    lexer.advance();
    // Optional leading ampersand
    skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AMP);
    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AMP) ||
    // Legacy support for the SDL?
    lexer.options.allowLegacySDLImplementsInterfaces && peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME));
  }
  return types;
}

/**
 * FieldsDefinition : { FieldDefinition+ }
 */
function parseFieldsDefinition(lexer) {
  // Legacy support for the SDL?
  if (lexer.options.allowLegacySDLEmptyFields && peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) && lexer.lookahead().kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) {
    lexer.advance();
    lexer.advance();
    return [];
  }
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseFieldDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * FieldDefinition :
 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
 */
function parseFieldDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseTypeReference(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FIELD_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    type: type,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ArgumentsDefinition : ( InputValueDefinition+ )
 */
function parseArgumentDefs(lexer) {
  if (!peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L)) {
    return [];
  }
  return many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, parseInputValueDef, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R);
}

/**
 * InputValueDefinition :
 *   - Description? Name : Type DefaultValue? Directives[Const]?
 */
function parseInputValueDef(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseTypeReference(lexer);
  var defaultValue = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS)) {
    defaultValue = parseConstValue(lexer);
  }
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_VALUE_DEFINITION,
    description: description,
    name: name,
    type: type,
    defaultValue: defaultValue,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * InterfaceTypeDefinition :
 *   - Description? interface Name Directives[Const]? FieldsDefinition?
 */
function parseInterfaceTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INTERFACE_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * UnionTypeDefinition :
 *   - Description? union Name Directives[Const]? UnionMemberTypes?
 */
function parseUnionTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].UNION_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}

/**
 * UnionMemberTypes :
 *   - = `|`? NamedType
 *   - UnionMemberTypes | NamedType
 */
function parseUnionMemberTypes(lexer) {
  var types = [];
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS)) {
    // Optional leading pipe
    skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE);
    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE));
  }
  return types;
}

/**
 * EnumTypeDefinition :
 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
 */
function parseEnumTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}

/**
 * EnumValuesDefinition : { EnumValueDefinition+ }
 */
function parseEnumValuesDefinition(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseEnumValueDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * EnumValueDefinition : Description? EnumValue Directives[Const]?
 *
 * EnumValue : Name
 */
function parseEnumValueDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_VALUE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * InputObjectTypeDefinition :
 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
 */
function parseInputObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * InputFieldsDefinition : { InputValueDefinition+ }
 */
function parseInputFieldsDefinition(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseInputValueDef, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * TypeExtension :
 *   - ScalarTypeExtension
 *   - ObjectTypeExtension
 *   - InterfaceTypeExtension
 *   - UnionTypeExtension
 *   - EnumTypeExtension
 *   - InputObjectTypeDefinition
 */
function parseTypeExtension(lexer) {
  var keywordToken = lexer.lookahead();

  if (keywordToken.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) {
    switch (keywordToken.value) {
      case 'scalar':
        return parseScalarTypeExtension(lexer);
      case 'type':
        return parseObjectTypeExtension(lexer);
      case 'interface':
        return parseInterfaceTypeExtension(lexer);
      case 'union':
        return parseUnionTypeExtension(lexer);
      case 'enum':
        return parseEnumTypeExtension(lexer);
      case 'input':
        return parseInputObjectTypeExtension(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

/**
 * ScalarTypeExtension :
 *   - extend scalar Name Directives[Const]
 */
function parseScalarTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  if (directives.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCALAR_TYPE_EXTENSION,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectTypeExtension :
 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
 *  - extend type Name ImplementsInterfaces? Directives[Const]
 *  - extend type Name ImplementsInterfaces
 */
function parseObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_TYPE_EXTENSION,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * InterfaceTypeExtension :
 *   - extend interface Name Directives[Const]? FieldsDefinition
 *   - extend interface Name Directives[Const]
 */
function parseInterfaceTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INTERFACE_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * UnionTypeExtension :
 *   - extend union Name Directives[Const]? UnionMemberTypes
 *   - extend union Name Directives[Const]
 */
function parseUnionTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  if (directives.length === 0 && types.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].UNION_TYPE_EXTENSION,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}

/**
 * EnumTypeExtension :
 *   - extend enum Name Directives[Const]? EnumValuesDefinition
 *   - extend enum Name Directives[Const]
 */
function parseEnumTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  if (directives.length === 0 && values.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_TYPE_EXTENSION,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}

/**
 * InputObjectTypeExtension :
 *   - extend input Name Directives[Const]? InputFieldsDefinition
 *   - extend input Name Directives[Const]
 */
function parseInputObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * DirectiveDefinition :
 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
 */
function parseDirectiveDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'directive');
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expectKeyword(lexer, 'on');
  var locations = parseDirectiveLocations(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DIRECTIVE_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    locations: locations,
    loc: loc(lexer, start)
  };
}

/**
 * DirectiveLocations :
 *   - `|`? DirectiveLocation
 *   - DirectiveLocations | DirectiveLocation
 */
function parseDirectiveLocations(lexer) {
  // Optional leading pipe
  skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE);
  var locations = [];
  do {
    locations.push(parseDirectiveLocation(lexer));
  } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE));
  return locations;
}

/*
 * DirectiveLocation :
 *   - ExecutableDirectiveLocation
 *   - TypeSystemDirectiveLocation
 *
 * ExecutableDirectiveLocation : one of
 *   `QUERY`
 *   `MUTATION`
 *   `SUBSCRIPTION`
 *   `FIELD`
 *   `FRAGMENT_DEFINITION`
 *   `FRAGMENT_SPREAD`
 *   `INLINE_FRAGMENT`
 *
 * TypeSystemDirectiveLocation : one of
 *   `SCHEMA`
 *   `SCALAR`
 *   `OBJECT`
 *   `FIELD_DEFINITION`
 *   `ARGUMENT_DEFINITION`
 *   `INTERFACE`
 *   `UNION`
 *   `ENUM`
 *   `ENUM_VALUE`
 *   `INPUT_OBJECT`
 *   `INPUT_FIELD_DEFINITION`
 */
function parseDirectiveLocation(lexer) {
  var start = lexer.token;
  var name = parseName(lexer);
  if (__WEBPACK_IMPORTED_MODULE_4__directiveLocation__["a" /* DirectiveLocation */].hasOwnProperty(name.value)) {
    return name;
  }
  throw unexpected(lexer, start);
}

// Core parsing utility functions

/**
 * Returns a location object, used to identify the place in
 * the source that created a given parsed object.
 */
function loc(lexer, startToken) {
  if (!lexer.options.noLocation) {
    return new Loc(startToken, lexer.lastToken, lexer.source);
  }
}

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
}

// Print a simplified form when appearing in JSON/util.inspect.
Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
  return { start: this.start, end: this.end };
};

/**
 * Determines if the next token is of a given kind
 */
function peek(lexer, kind) {
  return lexer.token.kind === kind;
}

/**
 * If the next token is of the given kind, return true after advancing
 * the lexer. Otherwise, do not change the parser state and return false.
 */
function skip(lexer, kind) {
  var match = lexer.token.kind === kind;
  if (match) {
    lexer.advance();
  }
  return match;
}

/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */
function expect(lexer, kind) {
  var token = lexer.token;
  if (token.kind === kind) {
    lexer.advance();
    return token;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_1__error__["a" /* syntaxError */])(lexer.source, token.start, 'Expected ' + kind + ', found ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * If the next token is a keyword with the given value, return that token after
 * advancing the lexer. Otherwise, do not change the parser state and return
 * false.
 */
function expectKeyword(lexer, value) {
  var token = lexer.token;
  if (token.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME && token.value === value) {
    lexer.advance();
    return token;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_1__error__["a" /* syntaxError */])(lexer.source, token.start, 'Expected "' + value + '", found ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * Helper function for creating an error when an unexpected lexed token
 * is encountered.
 */
function unexpected(lexer, atToken) {
  var token = atToken || lexer.token;
  return Object(__WEBPACK_IMPORTED_MODULE_1__error__["a" /* syntaxError */])(lexer.source, token.start, 'Unexpected ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * Returns a possibly empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */
function any(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [];
  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }
  return nodes;
}

/**
 * Returns a non-empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */
function many(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [parseFn(lexer)];
  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }
  return nodes;
}

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Source; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(135);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */



/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  _classCallCheck(this, Source);

  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || { line: 1, column: 1 };
  !(this.locationOffset.line > 0) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'line in locationOffset is 1-indexed and must be positive') : void 0;
  !(this.locationOffset.column > 0) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'column in locationOffset is 1-indexed and must be positive') : void 0;
};

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = syntaxError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(76);



/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function syntaxError(source, position, description) {
  return new __WEBPACK_IMPORTED_MODULE_0__GraphQLError__["a" /* GraphQLError */]('Syntax Error: ' + description, undefined, source, [position]);
}

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export locatedError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(76);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given an arbitrary Error, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */
function locatedError(originalError, nodes, path) {
  // Note: this uses a brand-check to support GraphQL errors originating from
  // other contexts.
  // $FlowFixMe(>=0.68.0)
  if (originalError && Array.isArray(originalError.path)) {
    return originalError;
  }

  return new __WEBPACK_IMPORTED_MODULE_0__GraphQLError__["a" /* GraphQLError */](originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
}

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(135);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */
function formatError(error) {
  !error ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'Received null or undefined error.') : void 0;
  return _extends({}, error.extensions, {
    message: error.message || 'An unknown error occurred.',
    locations: error.locations,
    path: error.path
  });
}

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createLexer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenKind; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getTokenDesc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blockStringValue__ = __webpack_require__(388);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
function createLexer(source, options) {
  var startOfFileToken = new Tok(TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;
  if (token.kind !== TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === TokenKind.COMMENT);
  }
  return token;
}

/**
 * The return type of createLexer.
 */


/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});

/**
 * The enum type representing the token kinds values.
 */


/**
 * A helper function to describe a token as a string for debugging
 */
function getTokenDesc(token) {
  var value = token.value;
  return value ? token.kind + ' "' + value + '"' : token.kind;
}

var charCodeAt = String.prototype.charCodeAt;
var slice = String.prototype.slice;

/**
 * Helper function for constructing the Token object.
 */
function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
}

// Print a simplified form when appearing in JSON/util.inspect.
Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
};

function printCharCode(code) {
  return (
    // NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    '"\\u' + ('00' + code.toString(16).toUpperCase()).slice(-4) + '"'
  );
}

/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace and comments until it finds the next lexable
 * token, then lexes punctuators immediately or calls the appropriate helper
 * function for more complicated tokens.
 */
function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;

  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = charCodeAt.call(body, pos);

  // SourceCharacter
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, pos, 'Cannot contain the invalid character ' + printCharCode(code) + '.');
  }

  switch (code) {
    // !
    case 33:
      return new Tok(TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #
    case 35:
      return readComment(source, pos, line, col, prev);
    // $
    case 36:
      return new Tok(TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &
    case 38:
      return new Tok(TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (
    case 40:
      return new Tok(TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )
    case 41:
      return new Tok(TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .
    case 46:
      if (charCodeAt.call(body, pos + 1) === 46 && charCodeAt.call(body, pos + 2) === 46) {
        return new Tok(TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }
      break;
    // :
    case 58:
      return new Tok(TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =
    case 61:
      return new Tok(TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @
    case 64:
      return new Tok(TokenKind.AT, pos, pos + 1, line, col, prev);
    // [
    case 91:
      return new Tok(TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]
    case 93:
      return new Tok(TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {
    case 123:
      return new Tok(TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |
    case 124:
      return new Tok(TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }
    case 125:
      return new Tok(TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z
    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9
    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "
    case 34:
      if (charCodeAt.call(body, pos + 1) === 34 && charCodeAt.call(body, pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev);
      }
      return readString(source, pos, line, col, prev);
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, pos, unexpectedCharacterMessage(code));
}

/**
 * Report a message that an unexpected character was encountered.
 */
function unexpectedCharacterMessage(code) {
  if (code === 39) {
    // '
    return "Unexpected single quote character ('), did you mean to use " + 'a double quote (")?';
  }

  return 'Cannot parse the unexpected character ' + printCharCode(code) + '.';
}

/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * or commented character, then returns the position of that character for
 * lexing.
 */
function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;
  while (position < bodyLength) {
    var code = charCodeAt.call(body, position);
    // tab | space | comma | BOM
    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (charCodeAt.call(body, position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }
      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }
  return position;
}

/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */
function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code = void 0;
  var position = start;

  do {
    code = charCodeAt.call(body, ++position);
  } while (code !== null && (
  // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(TokenKind.COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
}

/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */
function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = charCodeAt.call(body, ++position);
  }

  if (code === 48) {
    // 0
    code = charCodeAt.call(body, ++position);
    if (code >= 48 && code <= 57) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid number, unexpected digit after 0: ' + printCharCode(code) + '.');
    }
  } else {
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 46) {
    // .
    isFloat = true;

    code = charCodeAt.call(body, ++position);
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;

    code = charCodeAt.call(body, ++position);
    if (code === 43 || code === 45) {
      // + -
      code = charCodeAt.call(body, ++position);
    }
    position = readDigits(source, position, code);
  }

  return new Tok(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, slice.call(body, start, position));
}

/**
 * Returns the new position in the source after reading digits.
 */
function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;
  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = charCodeAt.call(body, ++position);
    } while (code >= 48 && code <= 57); // 0 - 9
    return position;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid number, expected digit but got: ' + printCharCode(code) + '.');
}

/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */
function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null &&
  // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.STRING, start, position + 1, line, col, prev, value);
    }

    // SourceCharacter
    if (code < 0x0020 && code !== 0x0009) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
    }

    ++position;
    if (code === 92) {
      // \
      value += slice.call(body, chunkStart, position - 1);
      code = charCodeAt.call(body, position);
      switch (code) {
        case 34:
          value += '"';
          break;
        case 47:
          value += '/';
          break;
        case 92:
          value += '\\';
          break;
        case 98:
          value += '\b';
          break;
        case 102:
          value += '\f';
          break;
        case 110:
          value += '\n';
          break;
        case 114:
          value += '\r';
          break;
        case 116:
          value += '\t';
          break;
        case 117:
          // u
          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));
          if (charCode < 0) {
            throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character escape sequence: ' + ('\\u' + body.slice(position + 1, position + 5) + '.'));
          }
          value += String.fromCharCode(charCode);
          position += 4;
          break;
        default:
          throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character escape sequence: \\' + String.fromCharCode(code) + '.');
      }
      ++position;
      chunkStart = position;
    }
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Unterminated string.');
}

/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */
function readBlockString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null) {
    // Closing Triple-Quote (""")
    if (code === 34 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34) {
      rawValue += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, Object(__WEBPACK_IMPORTED_MODULE_1__blockStringValue__["a" /* default */])(rawValue));
    }

    // SourceCharacter
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
    }

    // Escape Triple-Quote (\""")
    if (code === 92 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34 && charCodeAt.call(body, position + 3) === 34) {
      rawValue += slice.call(body, chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Unterminated string.');
}

/**
 * Converts four hexidecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */
function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}

/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */
function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}

/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */
function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;
  while (position !== bodyLength && (code = charCodeAt.call(body, position)) !== null && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }
  return new Tok(TokenKind.NAME, start, position, line, col, prev, slice.call(body, start, position));
}

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blockStringValue;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * Coffeescript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */
function blockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g);

  // Remove common indentation from all lines but first.
  var commonIndent = null;
  for (var i = 1; i < lines.length; i++) {
    var line = lines[i];
    var indent = leadingWhitespace(line);
    if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
      commonIndent = indent;
      if (commonIndent === 0) {
        break;
      }
    }
  }

  if (commonIndent) {
    for (var _i = 1; _i < lines.length; _i++) {
      lines[_i] = lines[_i].slice(commonIndent);
    }
  }

  // Remove leading and trailing blank lines.
  while (lines.length > 0 && isBlank(lines[0])) {
    lines.shift();
  }
  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
    lines.pop();
  }

  // Return a string of the lines joined with U+000A.
  return lines.join('\n');
}

function leadingWhitespace(str) {
  var i = 0;
  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
    i++;
  }
  return i;
}

function isBlank(str) {
  return leadingWhitespace(str) === str.length;
}

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Kind; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',

  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  VARIABLE: 'Variable',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',

  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',

  // Values
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',

  // Directives
  DIRECTIVE: 'Directive',

  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',

  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',

  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',

  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension',

  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition'
});

/**
 * The enum type representing the possible kind values of AST nodes.
 */

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DirectiveLocation; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});

/**
 * The enum type representing the directive location values.
 */

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_UserSelection__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sofia_ui__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sofia_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sofia_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_http_axios__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configs_urls__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configs_urls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__configs_urls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sofia_commun__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sofia_commun___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sofia_commun__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery($uuid: String) {\n  user(_id: $uuid) {\n    id\n    _id\n    first_name\n    last_name\n    phone_number\n    email\n    role\n  }\n}\n'],['\nquery($uuid: String) {\n  user(_id: $uuid) {\n    id\n    _id\n    first_name\n    last_name\n    phone_number\n    email\n    role\n  }\n}\n']),_templateObject2=_taggedTemplateLiteral(['\n{\n  admins {\n    id\n    _id\n    first_name\n    last_name\n    email\n  }\n}\n'],['\n{\n  admins {\n    id\n    _id\n    first_name\n    last_name\n    email\n  }\n}\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var QUERY=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject);var ADMINS=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject2);var MessageDetails=function(_Component){_inherits(MessageDetails,_Component);function MessageDetails(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,MessageDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MessageDetails.__proto__||Object.getPrototypeOf(MessageDetails)).call.apply(_ref,[this].concat(args))),_this),_this.state={users:[],message:'',channel:{email:true,sms:false},preview:"EMAIL",admin:{},subject:'Support'},_this.newMessage=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$state,users,message,channel,admin,subject;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$state=_this.state,users=_this$state.users,message=_this$state.message,channel=_this$state.channel,admin=_this$state.admin,subject=_this$state.subject;_context.next=3;return __WEBPACK_IMPORTED_MODULE_9__store_http_axios__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_10__configs_urls___default.a.api+'messaging/new',{admin:admin,users:users,message:message,channel:channel,subject:subject});case 3:_this.props.close();case 4:case'end':return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MessageDetails,[{key:'insertText',value:function insertText(value){var values={title:"{{#title}}Titre{{/title}}",title2:"{{#title2}}Titre 2{{/title2}}",p:"{{#p}}{{/p}}",button:"{{button \"https://sofiatutors.com\" \"Texte\" }}",if:"{{#if condition}}{{/if}}"};var final=this.state.message;if(this.input.selectionStart||this.input.selectionStart==='0'){var startPos=this.input.selectionStart;var endPos=this.input.selectionEnd;final=this.state.message.substring(0,startPos)+values[value]+this.state.message.substring(endPos,this.state.message.length);}else{final=this.state.message+values[value];}this.setState({message:final});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,users=_state.users,message=_state.message,_state$channel=_state.channel,email=_state$channel.email,sms=_state$channel.sms,preview=_state.preview,subject=_state.subject;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Modal__["a" /* default */],{title:'New message',close:this.props.close,hide:this.props.hide,large:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.split},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.left},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.contacts,__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.bb,__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.padding)},users.map(function(_ref3,key){var first_name=_ref3.first_name,last_name=_ref3.last_name,email=_ref3.email,phone_number=_ref3.phone_number;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:key,className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.contact},first_name?first_name+' '+last_name:email||phone_number,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.remove,onClick:function onClick(){console.log('remove',key);_this3.setState({users:[].concat(_toConsumableArray(users.slice(0,key)),_toConsumableArray(users.slice(key+1)))});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fas fa-times'})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_UserSelection__["a" /* default */],{onSelect:function onSelect(user){return _this3.setState({users:[].concat(_toConsumableArray(users),[user])});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('flex','f-space-between',__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.bb,__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.padding)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_sofia_ui__["Button"],{small:true,color:email?'blue':'dark',onClick:function onClick(){return _this3.setState({channel:{email:!email,sms:sms}});},inline:true},'Email'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_sofia_ui__["Button"],{small:true,color:sms?'blue':'dark',onClick:function onClick(){return _this3.setState({channel:{sms:!sms,email:email}});},inline:true},'SMS')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:ADMINS},function(_ref4){var loading=_ref4.loading,error=_ref4.error,data=_ref4.data;return data&&data.admins?data.admins.map(function(admin){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_sofia_ui__["Button"],{small:true,color:admin.email===_this3.state.admin.email?'blue':'dark',onClick:function onClick(){return _this3.setState({admin:admin});},inline:true},admin.first_name);}):null;}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.bb)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.subject,__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.padding),placeholder:'Sujet',value:subject,onChange:function onChange(e){return _this3.setState({subject:e.target.value});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.bb)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.textarea,__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.padding),placeholder:'Message',value:message,onChange:function onChange(e){return _this3.setState({message:e.target.value});},ref:function ref(node){_this3.input=node;}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.padding)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_sofia_ui__["Button"],{small:true,inline:true,color:'dark',onClick:function onClick(){return _this3.insertText('title');}},'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_sofia_ui__["Button"],{small:true,inline:true,color:'dark',onClick:function onClick(){return _this3.insertText('title2');}},'Title 2'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_sofia_ui__["Button"],{small:true,inline:true,color:'dark',onClick:function onClick(){return _this3.insertText('p');}},'Paragraph'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_sofia_ui__["Button"],{small:true,inline:true,color:'dark',onClick:function onClick(){return _this3.insertText('button');}},'Button'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_sofia_ui__["Button"],{small:true,inline:true,color:'dark',onClick:function onClick(){return _this3.insertText('if');}},'if'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.right)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.tabs},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.tab,preview==="EMAIL"&&__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.activeTab),onClick:function onClick(){return _this3.setState({preview:"EMAIL"});}},'Email'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.tab,preview==="SMS"&&__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.activeTab),onClick:function onClick(){return _this3.setState({preview:"SMS"});}},'SMS')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.preview,preview==="SMS"&&__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.padding)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:QUERY,variables:{uuid:users[0]&&users[0]._id}},function(_ref5){var loading=_ref5.loading,error=_ref5.error,data=_ref5.data;var html=Object(__WEBPACK_IMPORTED_MODULE_11_sofia_commun__["Renderer"])(preview,message,{user:data&&data.user},'simple_fr',{to:data&&data.user&&data.user.email});if(preview==="SMS")html=html.replace(/\n/ig,'<br />');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:html}});})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.buttons,__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.padding)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_sofia_ui__["Button"],{color:'green',onClick:this.newMessage,disabled:!users.length||!message.length||!sms&&!email||!this.state.admin.email},'Envoyer'))))));}}]);return MessageDetails;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MessageDetails);

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(393);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(395);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-containers-messages-New-___style__split___1rMST {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  min-height: 100%; }\n  .src-containers-messages-New-___style__split___1rMST .src-containers-messages-New-___style__left___3_Tiu {\n    border-right: 1px solid rgba(0, 0, 0, 0.08);\n    width: 50%;\n    flex: 1; }\n  .src-containers-messages-New-___style__split___1rMST .src-containers-messages-New-___style__right___CrT7O {\n    width: 50%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: space-between; }\n\n.src-containers-messages-New-___style__bb___rb6Jp {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08); }\n\n.src-containers-messages-New-___style__padding___1Nvda {\n  padding: 12px 24px; }\n\n.src-containers-messages-New-___style__contacts___3DlFj {\n  padding-top: 18px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start; }\n  .src-containers-messages-New-___style__contacts___3DlFj .src-containers-messages-New-___style__contact___352UJ {\n    position: relative;\n    font-size: 16px;\n    padding: 4px 12px;\n    padding-right: 32px;\n    background-color: rgba(0, 0, 0, 0.08);\n    border-radius: 14px;\n    margin-right: 6px;\n    margin-bottom: 6px; }\n    .src-containers-messages-New-___style__contacts___3DlFj .src-containers-messages-New-___style__contact___352UJ .src-containers-messages-New-___style__remove___2PBue {\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 26px;\n      height: 26px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: rgba(0, 0, 0, 0.08);\n      border-radius: 13px;\n      cursor: pointer;\n      color: #fff; }\n\n.src-containers-messages-New-___style__textarea___3zHzE {\n  height: 400px;\n  border: none;\n  max-width: 100%;\n  outline: none; }\n  .src-containers-messages-New-___style__textarea___3zHzE:focus {\n    outline: none; }\n\n.src-containers-messages-New-___style__subject___3PXLa {\n  height: 45px;\n  border: none;\n  max-width: 100%;\n  outline: none; }\n  .src-containers-messages-New-___style__subject___3PXLa:focus {\n    outline: none; }\n\n.src-containers-messages-New-___style__buttons___2oTYA {\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n  display: flex;\n  justify-content: flex-end; }\n\n.src-containers-messages-New-___style__preview___AOQGK {\n  height: 512px;\n  overflow: auto; }\n\n.src-containers-messages-New-___style__tabs___hJF1o {\n  display: flex; }\n  .src-containers-messages-New-___style__tabs___hJF1o .src-containers-messages-New-___style__tab___2vzaD {\n    padding: 8px 0;\n    color: #5D5D5D;\n    cursor: pointer;\n    margin: 0 12px; }\n    .src-containers-messages-New-___style__tabs___hJF1o .src-containers-messages-New-___style__tab___2vzaD.src-containers-messages-New-___style__activeTab___DKmda, .src-containers-messages-New-___style__tabs___hJF1o .src-containers-messages-New-___style__tab___2vzaD:hover {\n      font-weight: 800;\n      border-bottom: 2px solid #5D5D5D; }\n", ""]);

// exports
exports.locals = {
	"split": "src-containers-messages-New-___style__split___1rMST",
	"left": "src-containers-messages-New-___style__left___3_Tiu",
	"right": "src-containers-messages-New-___style__right___CrT7O",
	"bb": "src-containers-messages-New-___style__bb___rb6Jp",
	"padding": "src-containers-messages-New-___style__padding___1Nvda",
	"contacts": "src-containers-messages-New-___style__contacts___3DlFj",
	"contact": "src-containers-messages-New-___style__contact___352UJ",
	"remove": "src-containers-messages-New-___style__remove___2PBue",
	"textarea": "src-containers-messages-New-___style__textarea___3zHzE",
	"subject": "src-containers-messages-New-___style__subject___3PXLa",
	"buttons": "src-containers-messages-New-___style__buttons___2oTYA",
	"preview": "src-containers-messages-New-___style__preview___AOQGK",
	"tabs": "src-containers-messages-New-___style__tabs___hJF1o",
	"tab": "src-containers-messages-New-___style__tab___2vzaD",
	"activeTab": "src-containers-messages-New-___style__activeTab___DKmda"
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(397);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-components-Modal-___style__container___3H5k1 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(71, 71, 71, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  z-index: 1000; }\n\n.src-components-Modal-___style__content___1ULzZ {\n  background-color: #fff;\n  width: 92%;\n  max-width: 560px;\n  border-radius: 3px; }\n  .src-components-Modal-___style__content___1ULzZ.src-components-Modal-___style__large___23iGy {\n    max-width: 1200px; }\n\n.src-components-Modal-___style__header___3y-uj {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  padding: 20px 30px;\n  font-size: 18px; }\n  .src-components-Modal-___style__header___3y-uj .src-components-Modal-___style__close___2vYpU {\n    cursor: pointer; }\n\n.src-components-Modal-___style__main___3AJ6s {\n  position: relative;\n  min-height: 100%;\n  height: 100%; }\n", ""]);

// exports
exports.locals = {
	"container": "src-components-Modal-___style__container___3H5k1",
	"content": "src-components-Modal-___style__content___1ULzZ",
	"large": "src-components-Modal-___style__large___23iGy",
	"header": "src-components-Modal-___style__header___3y-uj",
	"close": "src-components-Modal-___style__close___2vYpU",
	"main": "src-components-Modal-___style__main___3AJ6s"
};

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dropdown__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery findUser($input: String) {\n  users(filter: { OR: [\n    { email_contains: $input },\n    { phone_number_contains: $input },\n    { first_name_contains: $input },\n    { last_name_contains: $input }\n  ] }, first: 20) {\n    id\n    _id\n    first_name\n    last_name\n    email\n    phone_number\n    role\n  }\n}\n'],['\nquery findUser($input: String) {\n  users(filter: { OR: [\n    { email_contains: $input },\n    { phone_number_contains: $input },\n    { first_name_contains: $input },\n    { last_name_contains: $input }\n  ] }, first: 20) {\n    id\n    _id\n    first_name\n    last_name\n    email\n    phone_number\n    role\n  }\n}\n']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var QUERY=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject);var UserSelection=function(_Component){_inherits(UserSelection,_Component);function UserSelection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserSelection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserSelection.__proto__||Object.getPrototypeOf(UserSelection)).call.apply(_ref,[this].concat(args))),_this),_this.state={hidden:true,input:''},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserSelection,[{key:'render',value:function render(){var _this2=this;console.log('USER SELECTION');var _state=this.state,hidden=_state.hidden,input=_state.input;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.container)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:QUERY,variables:{input:input}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Error :(');};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Dropdown__["a" /* default */],{options:data.users&&input.length>0?data.users.map(function(_ref3){var user=_objectWithoutProperties(_ref3,[]),id=_ref3.id,_id=_ref3._id,email=_ref3.email,first_name=_ref3.first_name,last_name=_ref3.last_name,phone_number=_ref3.phone_number;return{value:user,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,first_name?first_name+' '+last_name:email||phone_number),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,email,' \u2022 ',phone_number,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,id,' \u2022 ',_id))};}):[],onSelect:function onSelect(value){_this2.setState({hidden:true,input:''});_this2.props.onSelect(value);},hidden:hidden},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Name, email or phone',onFocus:function onFocus(){return _this2.setState({hidden:false});}// onBlur={() => setTimeout(() => this.setState({ hidden: true }), 250)}
,value:input,onChange:function onChange(e){return _this2.setState({input:e.target.value});},className:__WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.input}));}));}}]);return UserSelection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserSelection);

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(400);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-components-UserSelection-___style__container___21wJw {\n  position: relative;\n  min-width: 320px; }\n\n.src-components-UserSelection-___style__input___1d-j4 {\n  border: none;\n  outline: none;\n  padding: 6px 4px; }\n", ""]);

// exports
exports.locals = {
	"container": "src-components-UserSelection-___style__container___21wJw",
	"input": "src-components-UserSelection-___style__input___1d-j4"
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(402);

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var bind = __webpack_require__(139);
var Axios = __webpack_require__(404);
var defaults = __webpack_require__(79);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(143);
axios.CancelToken = __webpack_require__(418);
axios.isCancel = __webpack_require__(142);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(419);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 403 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(79);
var utils = __webpack_require__(9);
var InterceptorManager = __webpack_require__(413);
var dispatchRequest = __webpack_require__(414);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(141);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var transformData = __webpack_require__(415);
var isCancel = __webpack_require__(142);
var defaults = __webpack_require__(79);
var isAbsoluteURL = __webpack_require__(416);
var combineURLs = __webpack_require__(417);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(143);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 32);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&'function'==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?'symbol':typeof a};Object.defineProperty(exports,'__esModule',{value:!0});exports.extend=extend,exports.indexOf=indexOf,exports.escapeExpression=escapeExpression,exports.isEmpty=isEmpty,exports.createFrame=createFrame,exports.blockParams=blockParams,exports.appendContextPath=appendContextPath;var escape={"&":'&amp;',"<":'&lt;',">":'&gt;','"':'&quot;',"'":'&#x27;',"`":'&#x60;',"=":'&#x3D;'},badChars=/[&<>"'`=]/g,possible=/[&<>"'`=]/;function escapeChar(a){return escape[a]}function extend(a){for(var b=1;b<arguments.length;b++)for(var c in arguments[b])Object.prototype.hasOwnProperty.call(arguments[b],c)&&(a[c]=arguments[b][c]);return a}var toString=exports.toString=Object.prototype.toString,isFunction=function(a){return'function'==typeof a};isFunction(/x/)&&(exports.isFunction=isFunction=function(a){return'function'==typeof a&&'[object Function]'===toString.call(a)}),exports.isFunction=isFunction;var isArray=exports.isArray=Array.isArray||function(a){return!!(a&&'object'===('undefined'==typeof a?'undefined':_typeof(a)))&&'[object Array]'===toString.call(a)};function indexOf(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1}function escapeExpression(a){if('string'!=typeof a){if(a&&a.toHTML)return a.toHTML();if(null==a)return'';if(!a)return a+'';a=''+a}return possible.test(a)?a.replace(badChars,escapeChar):a}function isEmpty(a){return!(a||0===a)||!!(isArray(a)&&0===a.length)}function createFrame(a){var b=extend({},a);return b._parent=a,b}function blockParams(a,b){return a.path=b,a}function appendContextPath(a,b){return(a?a+'.':'')+b}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var errorProps=['description','fileName','lineNumber','message','name','number','stack'];function Exception(a,b){var c,d,e=b&&b.loc;e&&(c=e.start.line,d=e.start.column,a+=' - '+c+':'+d);for(var f=Error.prototype.constructor.call(this,a),g=0;g<errorProps.length;g++)this[errorProps[g]]=f[errorProps[g]];Error.captureStackTrace&&Error.captureStackTrace(this,Exception);try{e&&(this.lineNumber=c,Object.defineProperty?Object.defineProperty(this,'column',{value:d,enumerable:!0}):this.column=d)}catch(a){}}Exception.prototype=new Error,exports.default=Exception;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.logger=exports.createFrame=exports.log=exports.REVISION_CHANGES=exports.COMPILER_REVISION=exports.VERSION=void 0,exports.HandlebarsEnvironment=HandlebarsEnvironment;var _utils=__webpack_require__(0),_exception=__webpack_require__(1),_exception2=_interopRequireDefault(_exception),_helpers=__webpack_require__(18),_decorators=__webpack_require__(16),_logger=__webpack_require__(26),_logger2=_interopRequireDefault(_logger);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var VERSION=exports.VERSION='4.0.11',COMPILER_REVISION=exports.COMPILER_REVISION=7,REVISION_CHANGES=exports.REVISION_CHANGES={1:'<= 1.0.rc.2',2:'== 1.0.0-rc.3',3:'== 1.0.0-rc.4',4:'== 1.x.x',5:'== 2.0.0-alpha.x',6:'>= 2.0.0-beta.1',7:'>= 4.0.0'},objectType='[object Object]';function HandlebarsEnvironment(a,b,c){this.helpers=a||{},this.partials=b||{},this.decorators=c||{},(0,_helpers.registerDefaultHelpers)(this),(0,_decorators.registerDefaultDecorators)(this)}HandlebarsEnvironment.prototype={constructor:HandlebarsEnvironment,logger:_logger2.default,log:_logger2.default.log,registerHelper:function c(a,b){if(_utils.toString.call(a)===objectType){if(b)throw new _exception2.default('Arg not supported with multiple helpers');(0,_utils.extend)(this.helpers,a)}else this.helpers[a]=b},unregisterHelper:function b(a){delete this.helpers[a]},registerPartial:function c(a,b){if(_utils.toString.call(a)===objectType)(0,_utils.extend)(this.partials,a);else{if('undefined'==typeof b)throw new _exception2.default('Attempting to register a partial called "'+a+'" as undefined');this.partials[a]=b}},unregisterPartial:function b(a){delete this.partials[a]},registerDecorator:function c(a,b){if(_utils.toString.call(a)===objectType){if(b)throw new _exception2.default('Arg not supported with multiple decorators');(0,_utils.extend)(this.decorators,a)}else this.decorators[a]=b},unregisterDecorator:function b(a){delete this.decorators[a]}};var log=exports.log=_logger2.default.log;exports.createFrame=_utils.createFrame,exports.logger=_logger2.default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _handlebars=__webpack_require__(8),_handlebars2=_interopRequireDefault(_handlebars),_ast=__webpack_require__(4),_ast2=_interopRequireDefault(_ast),_base=__webpack_require__(9),_compiler=__webpack_require__(11),_javascriptCompiler=__webpack_require__(13),_javascriptCompiler2=_interopRequireDefault(_javascriptCompiler),_visitor=__webpack_require__(5),_visitor2=_interopRequireDefault(_visitor),_noConflict=__webpack_require__(6),_noConflict2=_interopRequireDefault(_noConflict);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var _create=_handlebars2.default.create;function create(){var a=_create();return a.compile=function(b,c){return(0,_compiler.compile)(b,c,a)},a.precompile=function(b,c){return(0,_compiler.precompile)(b,c,a)},a.AST=_ast2.default,a.Compiler=_compiler.Compiler,a.JavaScriptCompiler=_javascriptCompiler2.default,a.Parser=_base.parser,a.parse=_base.parse,a}var inst=create();inst.create=create,(0,_noConflict2.default)(inst),inst.Visitor=_visitor2.default,inst['default']=inst,exports.default=inst;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var AST={helpers:{helperExpression:function b(a){return'SubExpression'===a.type||('MustacheStatement'===a.type||'BlockStatement'===a.type)&&!!(a.params&&a.params.length||a.hash)},scopedId:function b(a){return /^\.|this\b/.test(a.original)},simpleId:function b(a){return 1===a.parts.length&&!AST.helpers.scopedId(a)&&!a.depth}}};exports.default=AST;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _exception=__webpack_require__(1),_exception2=_interopRequireDefault(_exception);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function Visitor(){this.parents=[]}Visitor.prototype={constructor:Visitor,mutating:!1,acceptKey:function d(a,b){var c=this.accept(a[b]);if(this.mutating){if(c&&!Visitor.prototype[c.type])throw new _exception2.default('Unexpected node type "'+c.type+'" found when accepting '+b+' on '+a.type);a[b]=c}},acceptRequired:function c(a,b){if(this.acceptKey(a,b),!a[b])throw new _exception2.default(a.type+' requires '+b)},acceptArray:function b(a){for(var c=0,d=a.length;c<d;c++)this.acceptKey(a,c),a[c]||(a.splice(c,1),c--,d--)},accept:function c(a){if(a){if(!this[a.type])throw new _exception2.default('Unknown type: '+a.type,a);this.current&&this.parents.unshift(this.current),this.current=a;var b=this[a.type](a);return(this.current=this.parents.shift(),!this.mutating||b)?b:!1===b?void 0:a}},Program:function b(a){this.acceptArray(a.body)},MustacheStatement:visitSubExpression,Decorator:visitSubExpression,BlockStatement:visitBlock,DecoratorBlock:visitBlock,PartialStatement:visitPartial,PartialBlockStatement:function b(a){visitPartial.call(this,a),this.acceptKey(a,'program')},ContentStatement:function a(){},CommentStatement:function a(){},SubExpression:visitSubExpression,PathExpression:function a(){},StringLiteral:function a(){},NumberLiteral:function a(){},BooleanLiteral:function a(){},UndefinedLiteral:function a(){},NullLiteral:function a(){},Hash:function b(a){this.acceptArray(a.pairs)},HashPair:function b(a){this.acceptRequired(a,'value')}};function visitSubExpression(a){this.acceptRequired(a,'path'),this.acceptArray(a.params),this.acceptKey(a,'hash')}function visitBlock(a){visitSubExpression.call(this,a),this.acceptKey(a,'program'),this.acceptKey(a,'inverse')}function visitPartial(a){this.acceptRequired(a,'name'),this.acceptArray(a.params),this.acceptKey(a,'hash')}exports.default=Visitor;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(a){var b='undefined'==typeof global?window:global,c=b.Handlebars;a.noConflict=function(){return b.Handlebars===a&&(b.Handlebars=c),a}};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _extends=Object.assign||function(a){for(var b,c=1;c<arguments.length;c++)for(var d in b=arguments[c],b)Object.prototype.hasOwnProperty.call(b,d)&&(a[d]=b[d]);return a},_emailHBS=__webpack_require__(29),_emailHBS2=_interopRequireDefault(_emailHBS),_smsHBS=__webpack_require__(30),_smsHBS2=_interopRequireDefault(_smsHBS),_templates=__webpack_require__(31),templates=_interopRequireWildcard(_templates);function _interopRequireWildcard(a){if(a&&a.__esModule)return a;var b={};if(null!=a)for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(b[c]=a[c]);return b.default=a,b}function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}exports.default=function(a,b){var c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:{},d=3<arguments.length&&arguments[3]!==void 0?arguments[3]:'simple_fr',e=4<arguments.length&&arguments[4]!==void 0?arguments[4]:{};try{var f='EMAIL'===a,g=f?_emailHBS2.default:_smsHBS2.default,h=f?b.replace(/(?:\r\n|\r|\n)/g,'<br />'):b,i=g.compile(h),j=i(c);if('EMAIL'===a){var k=g.compile(templates[d]);return k(_extends({},e,{body:j}))}return j}catch(a){return b}};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _base=__webpack_require__(2),base=_interopRequireWildcard(_base),_safeString=__webpack_require__(28),_safeString2=_interopRequireDefault(_safeString),_exception=__webpack_require__(1),_exception2=_interopRequireDefault(_exception),_utils=__webpack_require__(0),Utils=_interopRequireWildcard(_utils),_runtime=__webpack_require__(27),runtime=_interopRequireWildcard(_runtime),_noConflict=__webpack_require__(6),_noConflict2=_interopRequireDefault(_noConflict);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function _interopRequireWildcard(a){if(a&&a.__esModule)return a;var b={};if(null!=a)for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(b[c]=a[c]);return b.default=a,b}function create(){var a=new base.HandlebarsEnvironment;return Utils.extend(a,base),a.SafeString=_safeString2.default,a.Exception=_exception2.default,a.Utils=Utils,a.escapeExpression=Utils.escapeExpression,a.VM=runtime,a.template=function(b){return runtime.template(b,a)},a}var inst=create();inst.create=create,(0,_noConflict2.default)(inst),inst['default']=inst,exports.default=inst;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.parser=void 0,exports.parse=parse;var _parser=__webpack_require__(14),_parser2=_interopRequireDefault(_parser),_whitespaceControl=__webpack_require__(15),_whitespaceControl2=_interopRequireDefault(_whitespaceControl),_helpers=__webpack_require__(12),Helpers=_interopRequireWildcard(_helpers),_utils=__webpack_require__(0);function _interopRequireWildcard(a){if(a&&a.__esModule)return a;var b={};if(null!=a)for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(b[c]=a[c]);return b.default=a,b}function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}exports.parser=_parser2.default;var yy={};(0,_utils.extend)(yy,Helpers);function parse(a,b){if('Program'===a.type)return a;_parser2.default.yy=yy,yy.locInfo=function(a){return new yy.SourceLocation(b&&b.srcName,a)};var c=new _whitespaceControl2.default(b);return c.accept(_parser2.default.parse(a))}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _utils=__webpack_require__(0),SourceNode=void 0;try{if(false){var SourceMap=require('source-map');SourceNode=SourceMap.SourceNode}}catch(a){}SourceNode||(SourceNode=function(a,b,c,d){this.src='',d&&this.add(d)},SourceNode.prototype={add:function b(a){(0,_utils.isArray)(a)&&(a=a.join('')),this.src+=a},prepend:function b(a){(0,_utils.isArray)(a)&&(a=a.join('')),this.src=a+this.src},toStringWithSourceMap:function a(){return{code:this.toString()}},toString:function a(){return this.src}});function castChunk(a,b,c){if((0,_utils.isArray)(a)){for(var d=[],e=0,f=a.length;e<f;e++)d.push(b.wrap(a[e],c));return d}return'boolean'==typeof a||'number'==typeof a?a+'':a}function CodeGen(a){this.srcFile=a,this.source=[]}CodeGen.prototype={isEmpty:function a(){return!this.source.length},prepend:function c(a,b){this.source.unshift(this.wrap(a,b))},push:function c(a,b){this.source.push(this.wrap(a,b))},merge:function b(){var a=this.empty();return this.each(function(b){a.add(['  ',b,'\n'])}),a},each:function b(a){for(var c=0,d=this.source.length;c<d;c++)a(this.source[c])},empty:function b(){var a=this.currentLocation||{start:{}};return new SourceNode(a.start.line,a.start.column,this.srcFile)},wrap:function c(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:this.currentLocation||{start:{}};return a instanceof SourceNode?a:(a=castChunk(a,this,b),new SourceNode(b.start.line,b.start.column,this.srcFile,a))},functionCall:function d(a,b,c){return c=this.generateList(c),this.wrap([a,b?'.'+b+'(':'(',c,')'])},quotedString:function b(a){return'"'+(a+'').replace(/\\/g,'\\\\').replace(/"/g,'\\"').replace(/\n/g,'\\n').replace(/\r/g,'\\r').replace(/\u2028/g,'\\u2028').replace(/\u2029/g,'\\u2029')+'"'},objectLiteral:function d(a){var b=[];for(var e in a)if(a.hasOwnProperty(e)){var f=castChunk(a[e],this);'undefined'!==f&&b.push([this.quotedString(e),':',f])}var c=this.generateList(b);return c.prepend('{'),c.add('}'),c},generateList:function e(a){for(var b=this.empty(),c=0,d=a.length;c<d;c++)c&&b.add(','),b.add(castChunk(a[c],this));return b},generateArray:function c(a){var b=this.generateList(a);return b.prepend('['),b.add(']'),b}},exports.default=CodeGen;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.Compiler=Compiler,exports.precompile=precompile,exports.compile=compile;var _exception=__webpack_require__(1),_exception2=_interopRequireDefault(_exception),_utils=__webpack_require__(0),_ast=__webpack_require__(4),_ast2=_interopRequireDefault(_ast);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var slice=[].slice;function Compiler(){}Compiler.prototype={compiler:Compiler,equals:function c(a){var b=this.opcodes.length;if(a.opcodes.length!==b)return!1;for(var d=0;d<b;d++){var e=this.opcodes[d],f=a.opcodes[d];if(e.opcode!==f.opcode||!argEquals(e.args,f.args))return!1}b=this.children.length;for(var g=0;g<b;g++)if(!this.children[g].equals(a.children[g]))return!1;return!0},guid:0,compile:function(a,b){this.sourceNode=[],this.opcodes=[],this.children=[],this.options=b,this.stringParams=b.stringParams,this.trackIds=b.trackIds,b.blockParams=b.blockParams||[];var c=b.knownHelpers;if(b.knownHelpers={helperMissing:!0,blockHelperMissing:!0,each:!0,if:!0,unless:!0,with:!0,log:!0,lookup:!0},c)for(var d in c)d in c&&(this.options.knownHelpers[d]=c[d]);return this.accept(a)},compileProgram:function e(a){var b=new this.compiler,c=b.compile(a,this.options),d=this.guid++;return this.usePartial=this.usePartial||c.usePartial,this.children[d]=c,this.useDepths=this.useDepths||c.useDepths,d},accept:function c(a){if(!this[a.type])throw new _exception2.default('Unknown type: '+a.type,a);this.sourceNode.unshift(a);var b=this[a.type](a);return this.sourceNode.shift(),b},Program:function e(a){this.options.blockParams.unshift(a.blockParams);for(var b=a.body,c=b.length,d=0;d<c;d++)this.accept(b[d]);return this.options.blockParams.shift(),this.isSimple=1===c,this.blockParams=a.blockParams?a.blockParams.length:0,this},BlockStatement:function e(a){transformLiteralToPath(a);var b=a.program,c=a.inverse;b=b&&this.compileProgram(b),c=c&&this.compileProgram(c);var d=this.classifySexpr(a);'helper'===d?this.helperSexpr(a,b,c):'simple'===d?(this.simpleSexpr(a),this.opcode('pushProgram',b),this.opcode('pushProgram',c),this.opcode('emptyHash'),this.opcode('blockValue',a.path.original)):(this.ambiguousSexpr(a,b,c),this.opcode('pushProgram',b),this.opcode('pushProgram',c),this.opcode('emptyHash'),this.opcode('ambiguousBlockValue')),this.opcode('append')},DecoratorBlock:function e(a){var b=a.program&&this.compileProgram(a.program),c=this.setupFullMustacheParams(a,b,void 0),d=a.path;this.useDecorators=!0,this.opcode('registerDecorator',c.length,d.original)},PartialStatement:function g(a){this.usePartial=!0;var b=a.program;b&&(b=this.compileProgram(a.program));var c=a.params;if(1<c.length)throw new _exception2.default('Unsupported number of partial arguments: '+c.length,a);else c.length||(this.options.explicitPartialContext?this.opcode('pushLiteral','undefined'):c.push({type:'PathExpression',parts:[],depth:0}));var d=a.name.original,e='SubExpression'===a.name.type;e&&this.accept(a.name),this.setupFullMustacheParams(a,b,void 0,!0);var f=a.indent||'';this.options.preventIndent&&f&&(this.opcode('appendContent',f),f=''),this.opcode('invokePartial',e,d,f),this.opcode('append')},PartialBlockStatement:function b(a){this.PartialStatement(a)},MustacheStatement:function b(a){this.SubExpression(a),a.escaped&&!this.options.noEscape?this.opcode('appendEscaped'):this.opcode('append')},Decorator:function b(a){this.DecoratorBlock(a)},ContentStatement:function b(a){a.value&&this.opcode('appendContent',a.value)},CommentStatement:function a(){},SubExpression:function c(a){transformLiteralToPath(a);var b=this.classifySexpr(a);'simple'===b?this.simpleSexpr(a):'helper'===b?this.helperSexpr(a):this.ambiguousSexpr(a)},ambiguousSexpr:function f(a,b,c){var d=a.path,e=d.parts[0];this.opcode('getContext',d.depth),this.opcode('pushProgram',b),this.opcode('pushProgram',c),d.strict=!0,this.accept(d),this.opcode('invokeAmbiguous',e,null!=b||null!=c)},simpleSexpr:function c(a){var b=a.path;b.strict=!0,this.accept(b),this.opcode('resolvePossibleLambda')},helperSexpr:function g(a,b,c){var d=this.setupFullMustacheParams(a,b,c),e=a.path,f=e.parts[0];if(this.options.knownHelpers[f])this.opcode('invokeKnownHelper',d.length,f);else if(this.options.knownHelpersOnly)throw new _exception2.default('You specified knownHelpersOnly, but used the unknown helper '+f,a);else e.strict=!0,e.falsy=!0,this.accept(e),this.opcode('invokeHelper',d.length,e.original,_ast2.default.helpers.simpleId(e))},PathExpression:function e(a){this.addDepth(a.depth),this.opcode('getContext',a.depth);var b=a.parts[0],c=_ast2.default.helpers.scopedId(a),d=!a.depth&&!c&&this.blockParamIndex(b);d?this.opcode('lookupBlockParam',d,a.parts):b?a.data?(this.options.data=!0,this.opcode('lookupData',a.depth,a.parts,a.strict)):this.opcode('lookupOnContext',a.parts,a.falsy,a.strict,c):this.opcode('pushContext')},StringLiteral:function b(a){this.opcode('pushString',a.value)},NumberLiteral:function b(a){this.opcode('pushLiteral',a.value)},BooleanLiteral:function b(a){this.opcode('pushLiteral',a.value)},UndefinedLiteral:function a(){this.opcode('pushLiteral','undefined')},NullLiteral:function a(){this.opcode('pushLiteral','null')},Hash:function e(a){var b=a.pairs,c=0,d=b.length;for(this.opcode('pushHash');c<d;c++)this.pushParam(b[c].value);for(;c--;)this.opcode('assignToHash',b[c].key);this.opcode('popHash')},opcode:function b(a){this.opcodes.push({opcode:a,args:slice.call(arguments,1),loc:this.sourceNode[0].loc})},addDepth:function b(a){a&&(this.useDepths=!0)},classifySexpr:function f(a){var b=_ast2.default.helpers.simpleId(a.path),c=b&&!!this.blockParamIndex(a.path.parts[0]),d=!c&&_ast2.default.helpers.helperExpression(a),e=!c&&(d||b);if(e&&!d){var g=a.path.parts[0],h=this.options;h.knownHelpers[g]?d=!0:h.knownHelpersOnly&&(e=!1)}return d?'helper':e?'ambiguous':'simple'},pushParams:function b(a){for(var c=0,d=a.length;c<d;c++)this.pushParam(a[c])},pushParam:function c(a){var b=null==a.value?a.original||'':a.value;if(this.stringParams)b.replace&&(b=b.replace(/^(\.?\.\/)*/g,'').replace(/\//g,'.')),a.depth&&this.addDepth(a.depth),this.opcode('getContext',a.depth||0),this.opcode('pushStringParam',b,a.type),'SubExpression'===a.type&&this.accept(a);else{if(this.trackIds){var d;if(!a.parts||_ast2.default.helpers.scopedId(a)||a.depth||(d=this.blockParamIndex(a.parts[0])),d){var e=a.parts.slice(1).join('.');this.opcode('pushId','BlockParam',d,e)}else b=a.original||b,b.replace&&(b=b.replace(/^this(?:\.|$)/,'').replace(/^\.\//,'').replace(/^\.$/,'')),this.opcode('pushId',a.type,b)}this.accept(a)}},setupFullMustacheParams:function f(a,b,c,d){var e=a.params;return this.pushParams(e),this.opcode('pushProgram',b),this.opcode('pushProgram',c),a.hash?this.accept(a.hash):this.opcode('emptyHash',d),e},blockParamIndex:function b(a){for(var c=0,d=this.options.blockParams.length;c<d;c++){var e=this.options.blockParams[c],f=e&&(0,_utils.indexOf)(e,a);if(e&&0<=f)return[c,f]}}};function precompile(a,b,c){if(null==a||'string'!=typeof a&&'Program'!==a.type)throw new _exception2.default('You must pass a string or Handlebars AST to Handlebars.precompile. You passed '+a);b=b||{},'data'in b||(b.data=!0),b.compat&&(b.useDepths=!0);var d=c.parse(a,b),e=new c.Compiler().compile(d,b);return new c.JavaScriptCompiler().compile(e,b)}function compile(a){function b(){var b=e.parse(a,d),c=new e.Compiler().compile(b,d),f=new e.JavaScriptCompiler().compile(c,d,void 0,!0);return e.template(f)}function c(a,c){return f||(f=b()),f.call(this,a,c)}var d=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},e=arguments[2];if(null==a||'string'!=typeof a&&'Program'!==a.type)throw new _exception2.default('You must pass a string or Handlebars AST to Handlebars.compile. You passed '+a);d=(0,_utils.extend)({},d),'data'in d||(d.data=!0),d.compat&&(d.useDepths=!0);var f;return c._setup=function(a){return f||(f=b()),f._setup(a)},c._child=function(a,c,d,e){return f||(f=b()),f._child(a,c,d,e)},c}function argEquals(c,a){if(c===a)return!0;if((0,_utils.isArray)(c)&&(0,_utils.isArray)(a)&&c.length===a.length){for(var b=0;b<c.length;b++)if(!argEquals(c[b],a[b]))return!1;return!0}}function transformLiteralToPath(a){if(!a.path.parts){var b=a.path;a.path={type:'PathExpression',data:!1,depth:0,parts:[b.original+''],original:b.original+'',loc:b.loc}}}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.SourceLocation=SourceLocation,exports.id=id,exports.stripFlags=stripFlags,exports.stripComment=stripComment,exports.preparePath=preparePath,exports.prepareMustache=prepareMustache,exports.prepareRawBlock=prepareRawBlock,exports.prepareBlock=prepareBlock,exports.prepareProgram=prepareProgram,exports.preparePartialBlock=preparePartialBlock;var _exception=__webpack_require__(1),_exception2=_interopRequireDefault(_exception);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function validateClose(a,b){if(b=b.path?b.path.original:b,a.path.original!==b){var c={loc:a.path.loc};throw new _exception2.default(a.path.original+' doesn\'t match '+b,c)}}function SourceLocation(a,b){this.source=a,this.start={line:b.first_line,column:b.first_column},this.end={line:b.last_line,column:b.last_column}}function id(a){return /^\[.*\]$/.test(a)?a.substr(1,a.length-2):a}function stripFlags(a,b){return{open:'~'===a.charAt(2),close:'~'===b.charAt(b.length-3)}}function stripComment(a){return a.replace(/^\{\{~?\!-?-?/,'').replace(/-?-?~?\}\}$/,'')}function preparePath(a,b,c){c=this.locInfo(c);for(var d=a?'@':'',e=[],f=0,g='',h=0,j=b.length;h<j;h++){var k=b[h].part,l=b[h].original!==k;if(d+=(b[h].separator||'')+k,l||'..'!==k&&'.'!==k&&'this'!==k)e.push(k);else if(0<e.length)throw new _exception2.default('Invalid path: '+d,{loc:c});else'..'===k&&(f++,g+='../')}return{type:'PathExpression',data:a,depth:f,parts:e,original:d,loc:c}}function prepareMustache(a,b,c,d,e,f){var g=d.charAt(3)||d.charAt(2),h=/\*/.test(d);return{type:h?'Decorator':'MustacheStatement',path:a,params:b,hash:c,escaped:'{'!==g&&'&'!==g,strip:e,loc:this.locInfo(f)}}function prepareRawBlock(a,b,c,d){validateClose(a,c),d=this.locInfo(d);var e={type:'Program',body:b,strip:{},loc:d};return{type:'BlockStatement',path:a.path,params:a.params,hash:a.hash,program:e,openStrip:{},inverseStrip:{},closeStrip:{},loc:d}}function prepareBlock(a,b,c,d,e,f){d&&d.path&&validateClose(a,d);var g=/\*/.test(a.open);b.blockParams=a.blockParams;var h,i;if(c){if(g)throw new _exception2.default('Unexpected inverse block on decorator',c);c.chain&&(c.program.body[0].closeStrip=d.strip),i=c.strip,h=c.program}return e&&(e=h,h=b,b=e),{type:g?'DecoratorBlock':'BlockStatement',path:a.path,params:a.params,hash:a.hash,program:b,inverse:h,openStrip:a.strip,inverseStrip:i,closeStrip:d&&d.strip,loc:this.locInfo(f)}}function prepareProgram(a,b){if(!b&&a.length){var c=a[0].loc,d=a[a.length-1].loc;c&&d&&(b={source:c.source,start:{line:c.start.line,column:c.start.column},end:{line:d.end.line,column:d.end.column}})}return{type:'Program',body:a,strip:{},loc:b}}function preparePartialBlock(a,b,c,d){return validateClose(a,c),{type:'PartialBlockStatement',name:a.path,params:a.params,hash:a.hash,program:b,openStrip:a.strip,closeStrip:c&&c.strip,loc:this.locInfo(d)}}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _base=__webpack_require__(2),_exception=__webpack_require__(1),_exception2=_interopRequireDefault(_exception),_utils=__webpack_require__(0),_codeGen=__webpack_require__(10),_codeGen2=_interopRequireDefault(_codeGen);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function Literal(a){this.value=a}function JavaScriptCompiler(){}JavaScriptCompiler.prototype={nameLookup:function c(a,b){return JavaScriptCompiler.isValidJavaScriptVariableName(b)?[a,'.',b]:[a,'[',JSON.stringify(b),']']},depthedLookup:function b(a){return[this.aliasable('container.lookup'),'(depths, "',a,'")']},compilerInfo:function c(){var a=_base.COMPILER_REVISION,b=_base.REVISION_CHANGES[a];return[a,b]},appendToBuffer:function d(a,b,c){return(0,_utils.isArray)(a)||(a=[a]),a=this.source.wrap(a,b),this.environment.isSimple?['return ',a,';']:c?['buffer += ',a,';']:(a.appendToBuffer=!0,a)},initializeBuffer:function a(){return this.quotedString('')},compile:function p(a,b,c,d){this.environment=a,this.options=b,this.stringParams=this.options.stringParams,this.trackIds=this.options.trackIds,this.precompile=!d,this.name=this.environment.name,this.isChild=!!c,this.context=c||{decorators:[],programs:[],environments:[]},this.preamble(),this.stackSlot=0,this.stackVars=[],this.aliases={},this.registers={list:[]},this.hashes=[],this.compileStack=[],this.inlineStack=[],this.blockParams=[],this.compileChildren(a,b),this.useDepths=this.useDepths||a.useDepths||a.useDecorators||this.options.compat,this.useBlockParams=this.useBlockParams||a.useBlockParams;var e,f,g,h,j=a.opcodes;for(g=0,h=j.length;g<h;g++)e=j[g],this.source.currentLocation=e.loc,f=f||e.loc,this[e.opcode].apply(this,e.args);if(this.source.currentLocation=f,this.pushSource(''),this.stackSlot||this.inlineStack.length||this.compileStack.length)throw new _exception2.default('Compile completed with content left on stack');this.decorators.isEmpty()?this.decorators=void 0:(this.useDecorators=!0,this.decorators.prepend('var decorators = container.decorators;\n'),this.decorators.push('return fn;'),d?this.decorators=Function.apply(this,['fn','props','container','depth0','data','blockParams','depths',this.decorators.merge()]):(this.decorators.prepend('function(fn, props, container, depth0, data, blockParams, depths) {\n'),this.decorators.push('}\n'),this.decorators=this.decorators.merge()));var k=this.createFunctionContext(d);if(!this.isChild){var q={compiler:this.compilerInfo(),main:k};this.decorators&&(q.main_d=this.decorators,q.useDecorators=!0);var m=this.context,n=m.programs,o=m.decorators;for(g=0,h=n.length;g<h;g++)n[g]&&(q[g]=n[g],o[g]&&(q[g+'_d']=o[g],q.useDecorators=!0));return this.environment.usePartial&&(q.usePartial=!0),this.options.data&&(q.useData=!0),this.useDepths&&(q.useDepths=!0),this.useBlockParams&&(q.useBlockParams=!0),this.options.compat&&(q.compat=!0),d?q.compilerOptions=this.options:(q.compiler=JSON.stringify(q.compiler),this.source.currentLocation={start:{line:1,column:0}},q=this.objectLiteral(q),b.srcName?(q=q.toStringWithSourceMap({file:b.destName}),q.map=q.map&&q.map.toString()):q=q.toString()),q}return k},preamble:function a(){this.lastContext=0,this.source=new _codeGen2.default(this.options.srcName),this.decorators=new _codeGen2.default(this.options.srcName)},createFunctionContext:function g(a){var b='',c=this.stackVars.concat(this.registers.list);0<c.length&&(b+=', '+c.join(', '));var d=0;for(var h in this.aliases){var i=this.aliases[h];this.aliases.hasOwnProperty(h)&&i.children&&1<i.referenceCount&&(b+=', alias'+ ++d+'='+h,i.children[0]='alias'+d)}var e=['container','depth0','helpers','partials','data'];(this.useBlockParams||this.useDepths)&&e.push('blockParams'),this.useDepths&&e.push('depths');var f=this.mergeSource(b);return a?(e.push(f),Function.apply(this,e)):this.source.wrap(['function(',e.join(','),') {\n  ',f,'}'])},mergeSource:function h(a){var b,c,d,e,f=this.environment.isSimple,g=!this.forceBuffer;return this.source.each(function(a){a.appendToBuffer?(d?a.prepend('  + '):d=a,e=a):(d&&(c?d.prepend('buffer += '):b=!0,e.add(';'),d=e=void 0),c=!0,!f&&(g=!1))}),g?d?(d.prepend('return '),e.add(';')):!c&&this.source.push('return "";'):(a+=', buffer = '+(b?'':this.initializeBuffer()),d?(d.prepend('return buffer + '),e.add(';')):this.source.push('return buffer;')),a&&this.source.prepend('var '+a.substring(2)+(b?'':';\n')),this.source.merge()},blockValue:function e(a){var b=this.aliasable('helpers.blockHelperMissing'),c=[this.contextName(0)];this.setupHelperArgs(a,0,c);var d=this.popStack();c.splice(1,0,d),this.push(this.source.functionCall(b,'call',c))},ambiguousBlockValue:function d(){var a=this.aliasable('helpers.blockHelperMissing'),b=[this.contextName(0)];this.setupHelperArgs('',0,b,!0),this.flushInline();var c=this.topStack();b.splice(1,0,c),this.pushSource(['if (!',this.lastHelper,') { ',c,' = ',this.source.functionCall(a,'call',b),'}'])},appendContent:function b(a){this.pendingContent?a=this.pendingContent+a:this.pendingLocation=this.source.currentLocation,this.pendingContent=a},append:function a(){if(this.isInline())this.replaceStack(function(a){return[' != null ? ',a,' : ""']}),this.pushSource(this.appendToBuffer(this.popStack()));else{var b=this.popStack();this.pushSource(['if (',b,' != null) { ',this.appendToBuffer(b,void 0,!0),' }']),this.environment.isSimple&&this.pushSource(['else { ',this.appendToBuffer('\'\'',void 0,!0),' }'])}},appendEscaped:function a(){this.pushSource(this.appendToBuffer([this.aliasable('container.escapeExpression'),'(',this.popStack(),')']))},getContext:function b(a){this.lastContext=a},pushContext:function a(){this.pushStackLiteral(this.contextName(this.lastContext))},lookupOnContext:function f(a,b,c,d){var e=0;d||!this.options.compat||this.lastContext?this.pushContext():this.push(this.depthedLookup(a[e++])),this.resolvePath('context',a,e,b,c)},lookupBlockParam:function c(a,b){this.useBlockParams=!0,this.push(['blockParams[',a[0],'][',a[1],']']),this.resolvePath('context',b,1)},lookupData:function d(a,b,c){a?this.pushStackLiteral('container.data(data, '+a+')'):this.pushStackLiteral('data'),this.resolvePath('data',b,0,!0,c)},resolvePath:function g(a,b,c,d,e){var f=this;if(this.options.strict||this.options.assumeObjects)return void this.push(strictLookup(this.options.strict&&e,this,b,a));for(var h=b.length;c<h;c++)this.replaceStack(function(e){var g=f.nameLookup(e,b[c],a);return d?[' && ',g]:[' != null ? ',g,' : ',e]})},resolvePossibleLambda:function a(){this.push([this.aliasable('container.lambda'),'(',this.popStack(),', ',this.contextName(0),')'])},pushStringParam:function c(a,b){this.pushContext(),this.pushString(b),'SubExpression'!==b&&('string'==typeof a?this.pushString(a):this.pushStackLiteral(a))},emptyHash:function b(a){this.trackIds&&this.push('{}'),this.stringParams&&(this.push('{}'),this.push('{}')),this.pushStackLiteral(a?'undefined':'{}')},pushHash:function a(){this.hash&&this.hashes.push(this.hash),this.hash={values:[],types:[],contexts:[],ids:[]}},popHash:function b(){var a=this.hash;this.hash=this.hashes.pop(),this.trackIds&&this.push(this.objectLiteral(a.ids)),this.stringParams&&(this.push(this.objectLiteral(a.contexts)),this.push(this.objectLiteral(a.types))),this.push(this.objectLiteral(a.values))},pushString:function b(a){this.pushStackLiteral(this.quotedString(a))},pushLiteral:function b(a){this.pushStackLiteral(a)},pushProgram:function b(a){null==a?this.pushStackLiteral(null):this.pushStackLiteral(this.programExpression(a))},registerDecorator:function e(a,b){var c=this.nameLookup('decorators',b,'decorator'),d=this.setupHelperArgs(b,a);this.decorators.push(['fn = ',this.decorators.functionCall(c,'',['fn','props','container',d]),' || fn;'])},invokeHelper:function h(a,b,c){var d=this.popStack(),e=this.setupHelper(a,b),f=c?[e.name,' || ']:'',g=['('].concat(f,d);this.options.strict||g.push(' || ',this.aliasable('helpers.helperMissing')),g.push(')'),this.push(this.source.functionCall(g,'call',e.callParams))},invokeKnownHelper:function d(a,b){var c=this.setupHelper(a,b);this.push(this.source.functionCall(c.name,'call',c.callParams))},invokeAmbiguous:function g(a,b){this.useRegister('helper');var c=this.popStack();this.emptyHash();var d=this.setupHelper(0,a,b),e=this.lastHelper=this.nameLookup('helpers',a,'helper'),f=['(','(helper = ',e,' || ',c,')'];this.options.strict||(f[0]='(helper = ',f.push(' != null ? helper : ',this.aliasable('helpers.helperMissing'))),this.push(['(',f,d.paramsInit?['),(',d.paramsInit]:[],'),','(typeof helper === ',this.aliasable('"function"'),' ? ',this.source.functionCall('helper','call',d.callParams),' : helper))'])},invokePartial:function f(a,b,c){var d=[],e=this.setupParams(b,1,d);a&&(b=this.popStack(),delete e.name),c&&(e.indent=JSON.stringify(c)),e.helpers='helpers',e.partials='partials',e.decorators='container.decorators',a?d.unshift(b):d.unshift(this.nameLookup('partials',b,'partial')),this.options.compat&&(e.depths='depths'),e=this.objectLiteral(e),d.push(e),this.push(this.source.functionCall('container.invokePartial','',d))},assignToHash:function g(a){var b,c,d,e=this.popStack();this.trackIds&&(d=this.popStack()),this.stringParams&&(c=this.popStack(),b=this.popStack());var f=this.hash;b&&(f.contexts[a]=b),c&&(f.types[a]=c),d&&(f.ids[a]=d),f.values[a]=e},pushId:function d(a,b,c){'BlockParam'===a?this.pushStackLiteral('blockParams['+b[0]+'].path['+b[1]+']'+(c?' + '+JSON.stringify('.'+c):'')):'PathExpression'===a?this.pushString(b):'SubExpression'===a?this.pushStackLiteral('true'):this.pushStackLiteral('null')},compiler:JavaScriptCompiler,compileChildren:function h(a,b){for(var c=a.children,d=void 0,e=void 0,f=0,g=c.length;f<g;f++){d=c[f],e=new this.compiler;var j=this.matchExistingProgram(d);if(null==j){this.context.programs.push('');var k=this.context.programs.length;d.index=k,d.name='program'+k,this.context.programs[k]=e.compile(d,b,this.context,!this.precompile),this.context.decorators[k]=e.decorators,this.context.environments[k]=d,this.useDepths=this.useDepths||e.useDepths,this.useBlockParams=this.useBlockParams||e.useBlockParams,d.useDepths=this.useDepths,d.useBlockParams=this.useBlockParams}else d.index=j.index,d.name='program'+j.index,this.useDepths=this.useDepths||j.useDepths,this.useBlockParams=this.useBlockParams||j.useBlockParams}},matchExistingProgram:function b(a){for(var c,d=0,e=this.context.environments.length;d<e;d++)if(c=this.context.environments[d],c&&c.equals(a))return c},programExpression:function d(a){var b=this.environment.children[a],c=[b.index,'data',b.blockParams];return(this.useBlockParams||this.useDepths)&&c.push('blockParams'),this.useDepths&&c.push('depths'),'container.program('+c.join(', ')+')'},useRegister:function b(a){this.registers[a]||(this.registers[a]=!0,this.registers.list.push(a))},push:function b(a){return a instanceof Literal||(a=this.source.wrap(a)),this.inlineStack.push(a),a},pushStackLiteral:function b(a){this.push(new Literal(a))},pushSource:function b(a){this.pendingContent&&(this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent),this.pendingLocation)),this.pendingContent=void 0),a&&this.source.push(a)},replaceStack:function h(a){var b,c,d,e=['('];if(!this.isInline())throw new _exception2.default('replaceStack on non-inline');var f=this.popStack(!0);if(f instanceof Literal)b=[f.value],e=['(',b],d=!0;else{c=!0;var i=this.incrStack();e=['((',this.push(i),' = ',f,')'],b=this.topStack()}var g=a.call(this,b);d||this.popStack(),c&&this.stackSlot--,this.push(e.concat(g,')'))},incrStack:function a(){return this.stackSlot++,this.stackSlot>this.stackVars.length&&this.stackVars.push('stack'+this.stackSlot),this.topStackName()},topStackName:function a(){return'stack'+this.stackSlot},flushInline:function b(){var a=this.inlineStack;this.inlineStack=[];for(var c,d=0,e=a.length;d<e;d++)if(c=a[d],c instanceof Literal)this.compileStack.push(c);else{var f=this.incrStack();this.pushSource([f,' = ',c,';']),this.compileStack.push(f)}},isInline:function a(){return this.inlineStack.length},popStack:function d(a){var b=this.isInline(),c=(b?this.inlineStack:this.compileStack).pop();if(!a&&c instanceof Literal)return c.value;if(!b){if(!this.stackSlot)throw new _exception2.default('Invalid stack pop');this.stackSlot--}return c},topStack:function c(){var a=this.isInline()?this.inlineStack:this.compileStack,b=a[a.length-1];return b instanceof Literal?b.value:b},contextName:function b(a){return this.useDepths&&a?'depths['+a+']':'depth'+a},quotedString:function b(a){return this.source.quotedString(a)},objectLiteral:function b(a){return this.source.objectLiteral(a)},aliasable:function c(a){var b=this.aliases[a];return b?(b.referenceCount++,b):(b=this.aliases[a]=this.source.wrap(a),b.aliasable=!0,b.referenceCount=1,b)},setupHelper:function h(a,b,c){var d=[],e=this.setupHelperArgs(b,a,d,c),f=this.nameLookup('helpers',b,'helper'),g=this.aliasable(this.contextName(0)+' != null ? '+this.contextName(0)+' : (container.nullContext || {})');return{params:d,paramsInit:e,name:f,callParams:[g].concat(d)}},setupParams:function m(a,b,c){var d,e={},f=[],g=[],h=[],j=!c;j&&(c=[]),e.name=this.quotedString(a),e.hash=this.popStack(),this.trackIds&&(e.hashIds=this.popStack()),this.stringParams&&(e.hashTypes=this.popStack(),e.hashContexts=this.popStack());var k=this.popStack(),l=this.popStack();(l||k)&&(e.fn=l||'container.noop',e.inverse=k||'container.noop');for(var n=b;n--;)d=this.popStack(),c[n]=d,this.trackIds&&(h[n]=this.popStack()),this.stringParams&&(g[n]=this.popStack(),f[n]=this.popStack());return j&&(e.args=this.source.generateArray(c)),this.trackIds&&(e.ids=this.source.generateArray(h)),this.stringParams&&(e.types=this.source.generateArray(g),e.contexts=this.source.generateArray(f)),this.options.data&&(e.data='data'),this.useBlockParams&&(e.blockParams='blockParams'),e},setupHelperArgs:function f(a,b,c,d){var e=this.setupParams(a,b,c);return e=this.objectLiteral(e),d?(this.useRegister('options'),c.push('options'),['options=',e]):c?(c.push(e),''):e}},function(){for(var a='break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false'.split(' '),b=JavaScriptCompiler.RESERVED_WORDS={},c=0,d=a.length;c<d;c++)b[a[c]]=!0}(),JavaScriptCompiler.isValidJavaScriptVariableName=function(a){return!JavaScriptCompiler.RESERVED_WORDS[a]&&/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(a)};function strictLookup(a,b,c,d){var e=b.popStack(),f=0,g=c.length;for(a&&g--;f<g;f++)e=b.nameLookup(e,c[f],d);return a?[b.aliasable('container.strict'),'(',e,', ',b.quotedString(c[f]),')']:e}exports.default=JavaScriptCompiler;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var handlebars=function(){function a(){this.yy={}}var b={trace:function(){},yy:{},symbols_:{error:2,root:3,program:4,EOF:5,program_repetition0:6,statement:7,mustache:8,block:9,rawBlock:10,partial:11,partialBlock:12,content:13,COMMENT:14,CONTENT:15,openRawBlock:16,rawBlock_repetition_plus0:17,END_RAW_BLOCK:18,OPEN_RAW_BLOCK:19,helperName:20,openRawBlock_repetition0:21,openRawBlock_option0:22,CLOSE_RAW_BLOCK:23,openBlock:24,block_option0:25,closeBlock:26,openInverse:27,block_option1:28,OPEN_BLOCK:29,openBlock_repetition0:30,openBlock_option0:31,openBlock_option1:32,CLOSE:33,OPEN_INVERSE:34,openInverse_repetition0:35,openInverse_option0:36,openInverse_option1:37,openInverseChain:38,OPEN_INVERSE_CHAIN:39,openInverseChain_repetition0:40,openInverseChain_option0:41,openInverseChain_option1:42,inverseAndProgram:43,INVERSE:44,inverseChain:45,inverseChain_option0:46,OPEN_ENDBLOCK:47,OPEN:48,mustache_repetition0:49,mustache_option0:50,OPEN_UNESCAPED:51,mustache_repetition1:52,mustache_option1:53,CLOSE_UNESCAPED:54,OPEN_PARTIAL:55,partialName:56,partial_repetition0:57,partial_option0:58,openPartialBlock:59,OPEN_PARTIAL_BLOCK:60,openPartialBlock_repetition0:61,openPartialBlock_option0:62,param:63,sexpr:64,OPEN_SEXPR:65,sexpr_repetition0:66,sexpr_option0:67,CLOSE_SEXPR:68,hash:69,hash_repetition_plus0:70,hashSegment:71,ID:72,EQUALS:73,blockParams:74,OPEN_BLOCK_PARAMS:75,blockParams_repetition_plus0:76,CLOSE_BLOCK_PARAMS:77,path:78,dataName:79,STRING:80,NUMBER:81,BOOLEAN:82,UNDEFINED:83,NULL:84,DATA:85,pathSegments:86,SEP:87,$accept:0,$end:1},terminals_:{2:"error",5:"EOF",14:"COMMENT",15:"CONTENT",18:"END_RAW_BLOCK",19:"OPEN_RAW_BLOCK",23:"CLOSE_RAW_BLOCK",29:"OPEN_BLOCK",33:"CLOSE",34:"OPEN_INVERSE",39:"OPEN_INVERSE_CHAIN",44:"INVERSE",47:"OPEN_ENDBLOCK",48:"OPEN",51:"OPEN_UNESCAPED",54:"CLOSE_UNESCAPED",55:"OPEN_PARTIAL",60:"OPEN_PARTIAL_BLOCK",65:"OPEN_SEXPR",68:"CLOSE_SEXPR",72:"ID",73:"EQUALS",75:"OPEN_BLOCK_PARAMS",77:"CLOSE_BLOCK_PARAMS",80:"STRING",81:"NUMBER",82:"BOOLEAN",83:"UNDEFINED",84:"NULL",85:"DATA",87:"SEP"},productions_:[0,[3,2],[4,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[13,1],[10,3],[16,5],[9,4],[9,4],[24,6],[27,6],[38,6],[43,2],[45,3],[45,1],[26,3],[8,5],[8,5],[11,5],[12,3],[59,5],[63,1],[63,1],[64,5],[69,1],[71,3],[74,3],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[56,1],[56,1],[79,2],[78,1],[86,3],[86,1],[6,0],[6,2],[17,1],[17,2],[21,0],[21,2],[22,0],[22,1],[25,0],[25,1],[28,0],[28,1],[30,0],[30,2],[31,0],[31,1],[32,0],[32,1],[35,0],[35,2],[36,0],[36,1],[37,0],[37,1],[40,0],[40,2],[41,0],[41,1],[42,0],[42,1],[46,0],[46,1],[49,0],[49,2],[50,0],[50,1],[52,0],[52,2],[53,0],[53,1],[57,0],[57,2],[58,0],[58,1],[61,0],[61,2],[62,0],[62,1],[66,0],[66,2],[67,0],[67,1],[70,1],[70,2],[76,1],[76,2]],performAction:function(a,b,c,d,e,f){var g=f.length-1;switch(e){case 1:return f[g-1];break;case 2:this.$=d.prepareProgram(f[g]);break;case 3:this.$=f[g];break;case 4:this.$=f[g];break;case 5:this.$=f[g];break;case 6:this.$=f[g];break;case 7:this.$=f[g];break;case 8:this.$=f[g];break;case 9:this.$={type:"CommentStatement",value:d.stripComment(f[g]),strip:d.stripFlags(f[g],f[g]),loc:d.locInfo(this._$)};break;case 10:this.$={type:"ContentStatement",original:f[g],value:f[g],loc:d.locInfo(this._$)};break;case 11:this.$=d.prepareRawBlock(f[g-2],f[g-1],f[g],this._$);break;case 12:this.$={path:f[g-3],params:f[g-2],hash:f[g-1]};break;case 13:this.$=d.prepareBlock(f[g-3],f[g-2],f[g-1],f[g],!1,this._$);break;case 14:this.$=d.prepareBlock(f[g-3],f[g-2],f[g-1],f[g],!0,this._$);break;case 15:this.$={open:f[g-5],path:f[g-4],params:f[g-3],hash:f[g-2],blockParams:f[g-1],strip:d.stripFlags(f[g-5],f[g])};break;case 16:this.$={path:f[g-4],params:f[g-3],hash:f[g-2],blockParams:f[g-1],strip:d.stripFlags(f[g-5],f[g])};break;case 17:this.$={path:f[g-4],params:f[g-3],hash:f[g-2],blockParams:f[g-1],strip:d.stripFlags(f[g-5],f[g])};break;case 18:this.$={strip:d.stripFlags(f[g-1],f[g-1]),program:f[g]};break;case 19:var h=d.prepareBlock(f[g-2],f[g-1],f[g],f[g],!1,this._$),i=d.prepareProgram([h],f[g-1].loc);i.chained=!0,this.$={strip:f[g-2].strip,program:i,chain:!0};break;case 20:this.$=f[g];break;case 21:this.$={path:f[g-1],strip:d.stripFlags(f[g-2],f[g])};break;case 22:this.$=d.prepareMustache(f[g-3],f[g-2],f[g-1],f[g-4],d.stripFlags(f[g-4],f[g]),this._$);break;case 23:this.$=d.prepareMustache(f[g-3],f[g-2],f[g-1],f[g-4],d.stripFlags(f[g-4],f[g]),this._$);break;case 24:this.$={type:"PartialStatement",name:f[g-3],params:f[g-2],hash:f[g-1],indent:"",strip:d.stripFlags(f[g-4],f[g]),loc:d.locInfo(this._$)};break;case 25:this.$=d.preparePartialBlock(f[g-2],f[g-1],f[g],this._$);break;case 26:this.$={path:f[g-3],params:f[g-2],hash:f[g-1],strip:d.stripFlags(f[g-4],f[g])};break;case 27:this.$=f[g];break;case 28:this.$=f[g];break;case 29:this.$={type:"SubExpression",path:f[g-3],params:f[g-2],hash:f[g-1],loc:d.locInfo(this._$)};break;case 30:this.$={type:"Hash",pairs:f[g],loc:d.locInfo(this._$)};break;case 31:this.$={type:"HashPair",key:d.id(f[g-2]),value:f[g],loc:d.locInfo(this._$)};break;case 32:this.$=d.id(f[g-1]);break;case 33:this.$=f[g];break;case 34:this.$=f[g];break;case 35:this.$={type:"StringLiteral",value:f[g],original:f[g],loc:d.locInfo(this._$)};break;case 36:this.$={type:"NumberLiteral",value:+f[g],original:+f[g],loc:d.locInfo(this._$)};break;case 37:this.$={type:"BooleanLiteral",value:"true"===f[g],original:"true"===f[g],loc:d.locInfo(this._$)};break;case 38:this.$={type:"UndefinedLiteral",original:void 0,value:void 0,loc:d.locInfo(this._$)};break;case 39:this.$={type:"NullLiteral",original:null,value:null,loc:d.locInfo(this._$)};break;case 40:this.$=f[g];break;case 41:this.$=f[g];break;case 42:this.$=d.preparePath(!0,f[g],this._$);break;case 43:this.$=d.preparePath(!1,f[g],this._$);break;case 44:f[g-2].push({part:d.id(f[g]),original:f[g],separator:f[g-1]}),this.$=f[g-2];break;case 45:this.$=[{part:d.id(f[g]),original:f[g]}];break;case 46:this.$=[];break;case 47:f[g-1].push(f[g]);break;case 48:this.$=[f[g]];break;case 49:f[g-1].push(f[g]);break;case 50:this.$=[];break;case 51:f[g-1].push(f[g]);break;case 58:this.$=[];break;case 59:f[g-1].push(f[g]);break;case 64:this.$=[];break;case 65:f[g-1].push(f[g]);break;case 70:this.$=[];break;case 71:f[g-1].push(f[g]);break;case 78:this.$=[];break;case 79:f[g-1].push(f[g]);break;case 82:this.$=[];break;case 83:f[g-1].push(f[g]);break;case 86:this.$=[];break;case 87:f[g-1].push(f[g]);break;case 90:this.$=[];break;case 91:f[g-1].push(f[g]);break;case 94:this.$=[];break;case 95:f[g-1].push(f[g]);break;case 98:this.$=[f[g]];break;case 99:f[g-1].push(f[g]);break;case 100:this.$=[f[g]];break;case 101:f[g-1].push(f[g]);}},table:[{3:1,4:2,5:[2,46],6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{1:[3]},{5:[1,4]},{5:[2,2],7:5,8:6,9:7,10:8,11:9,12:10,13:11,14:[1,12],15:[1,20],16:17,19:[1,23],24:15,27:16,29:[1,21],34:[1,22],39:[2,2],44:[2,2],47:[2,2],48:[1,13],51:[1,14],55:[1,18],59:19,60:[1,24]},{1:[2,1]},{5:[2,47],14:[2,47],15:[2,47],19:[2,47],29:[2,47],34:[2,47],39:[2,47],44:[2,47],47:[2,47],48:[2,47],51:[2,47],55:[2,47],60:[2,47]},{5:[2,3],14:[2,3],15:[2,3],19:[2,3],29:[2,3],34:[2,3],39:[2,3],44:[2,3],47:[2,3],48:[2,3],51:[2,3],55:[2,3],60:[2,3]},{5:[2,4],14:[2,4],15:[2,4],19:[2,4],29:[2,4],34:[2,4],39:[2,4],44:[2,4],47:[2,4],48:[2,4],51:[2,4],55:[2,4],60:[2,4]},{5:[2,5],14:[2,5],15:[2,5],19:[2,5],29:[2,5],34:[2,5],39:[2,5],44:[2,5],47:[2,5],48:[2,5],51:[2,5],55:[2,5],60:[2,5]},{5:[2,6],14:[2,6],15:[2,6],19:[2,6],29:[2,6],34:[2,6],39:[2,6],44:[2,6],47:[2,6],48:[2,6],51:[2,6],55:[2,6],60:[2,6]},{5:[2,7],14:[2,7],15:[2,7],19:[2,7],29:[2,7],34:[2,7],39:[2,7],44:[2,7],47:[2,7],48:[2,7],51:[2,7],55:[2,7],60:[2,7]},{5:[2,8],14:[2,8],15:[2,8],19:[2,8],29:[2,8],34:[2,8],39:[2,8],44:[2,8],47:[2,8],48:[2,8],51:[2,8],55:[2,8],60:[2,8]},{5:[2,9],14:[2,9],15:[2,9],19:[2,9],29:[2,9],34:[2,9],39:[2,9],44:[2,9],47:[2,9],48:[2,9],51:[2,9],55:[2,9],60:[2,9]},{20:25,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:36,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:37,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],39:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{4:38,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{13:40,15:[1,20],17:39},{20:42,56:41,64:43,65:[1,44],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:45,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{5:[2,10],14:[2,10],15:[2,10],18:[2,10],19:[2,10],29:[2,10],34:[2,10],39:[2,10],44:[2,10],47:[2,10],48:[2,10],51:[2,10],55:[2,10],60:[2,10]},{20:46,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:47,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:48,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:42,56:49,64:43,65:[1,44],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[2,78],49:50,65:[2,78],72:[2,78],80:[2,78],81:[2,78],82:[2,78],83:[2,78],84:[2,78],85:[2,78]},{23:[2,33],33:[2,33],54:[2,33],65:[2,33],68:[2,33],72:[2,33],75:[2,33],80:[2,33],81:[2,33],82:[2,33],83:[2,33],84:[2,33],85:[2,33]},{23:[2,34],33:[2,34],54:[2,34],65:[2,34],68:[2,34],72:[2,34],75:[2,34],80:[2,34],81:[2,34],82:[2,34],83:[2,34],84:[2,34],85:[2,34]},{23:[2,35],33:[2,35],54:[2,35],65:[2,35],68:[2,35],72:[2,35],75:[2,35],80:[2,35],81:[2,35],82:[2,35],83:[2,35],84:[2,35],85:[2,35]},{23:[2,36],33:[2,36],54:[2,36],65:[2,36],68:[2,36],72:[2,36],75:[2,36],80:[2,36],81:[2,36],82:[2,36],83:[2,36],84:[2,36],85:[2,36]},{23:[2,37],33:[2,37],54:[2,37],65:[2,37],68:[2,37],72:[2,37],75:[2,37],80:[2,37],81:[2,37],82:[2,37],83:[2,37],84:[2,37],85:[2,37]},{23:[2,38],33:[2,38],54:[2,38],65:[2,38],68:[2,38],72:[2,38],75:[2,38],80:[2,38],81:[2,38],82:[2,38],83:[2,38],84:[2,38],85:[2,38]},{23:[2,39],33:[2,39],54:[2,39],65:[2,39],68:[2,39],72:[2,39],75:[2,39],80:[2,39],81:[2,39],82:[2,39],83:[2,39],84:[2,39],85:[2,39]},{23:[2,43],33:[2,43],54:[2,43],65:[2,43],68:[2,43],72:[2,43],75:[2,43],80:[2,43],81:[2,43],82:[2,43],83:[2,43],84:[2,43],85:[2,43],87:[1,51]},{72:[1,35],86:52},{23:[2,45],33:[2,45],54:[2,45],65:[2,45],68:[2,45],72:[2,45],75:[2,45],80:[2,45],81:[2,45],82:[2,45],83:[2,45],84:[2,45],85:[2,45],87:[2,45]},{52:53,54:[2,82],65:[2,82],72:[2,82],80:[2,82],81:[2,82],82:[2,82],83:[2,82],84:[2,82],85:[2,82]},{25:54,38:56,39:[1,58],43:57,44:[1,59],45:55,47:[2,54]},{28:60,43:61,44:[1,59],47:[2,56]},{13:63,15:[1,20],18:[1,62]},{15:[2,48],18:[2,48]},{33:[2,86],57:64,65:[2,86],72:[2,86],80:[2,86],81:[2,86],82:[2,86],83:[2,86],84:[2,86],85:[2,86]},{33:[2,40],65:[2,40],72:[2,40],80:[2,40],81:[2,40],82:[2,40],83:[2,40],84:[2,40],85:[2,40]},{33:[2,41],65:[2,41],72:[2,41],80:[2,41],81:[2,41],82:[2,41],83:[2,41],84:[2,41],85:[2,41]},{20:65,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{26:66,47:[1,67]},{30:68,33:[2,58],65:[2,58],72:[2,58],75:[2,58],80:[2,58],81:[2,58],82:[2,58],83:[2,58],84:[2,58],85:[2,58]},{33:[2,64],35:69,65:[2,64],72:[2,64],75:[2,64],80:[2,64],81:[2,64],82:[2,64],83:[2,64],84:[2,64],85:[2,64]},{21:70,23:[2,50],65:[2,50],72:[2,50],80:[2,50],81:[2,50],82:[2,50],83:[2,50],84:[2,50],85:[2,50]},{33:[2,90],61:71,65:[2,90],72:[2,90],80:[2,90],81:[2,90],82:[2,90],83:[2,90],84:[2,90],85:[2,90]},{20:75,33:[2,80],50:72,63:73,64:76,65:[1,44],69:74,70:77,71:78,72:[1,79],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{72:[1,80]},{23:[2,42],33:[2,42],54:[2,42],65:[2,42],68:[2,42],72:[2,42],75:[2,42],80:[2,42],81:[2,42],82:[2,42],83:[2,42],84:[2,42],85:[2,42],87:[1,51]},{20:75,53:81,54:[2,84],63:82,64:76,65:[1,44],69:83,70:77,71:78,72:[1,79],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{26:84,47:[1,67]},{47:[2,55]},{4:85,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],39:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{47:[2,20]},{20:86,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:87,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{26:88,47:[1,67]},{47:[2,57]},{5:[2,11],14:[2,11],15:[2,11],19:[2,11],29:[2,11],34:[2,11],39:[2,11],44:[2,11],47:[2,11],48:[2,11],51:[2,11],55:[2,11],60:[2,11]},{15:[2,49],18:[2,49]},{20:75,33:[2,88],58:89,63:90,64:76,65:[1,44],69:91,70:77,71:78,72:[1,79],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{65:[2,94],66:92,68:[2,94],72:[2,94],80:[2,94],81:[2,94],82:[2,94],83:[2,94],84:[2,94],85:[2,94]},{5:[2,25],14:[2,25],15:[2,25],19:[2,25],29:[2,25],34:[2,25],39:[2,25],44:[2,25],47:[2,25],48:[2,25],51:[2,25],55:[2,25],60:[2,25]},{20:93,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:75,31:94,33:[2,60],63:95,64:76,65:[1,44],69:96,70:77,71:78,72:[1,79],75:[2,60],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:75,33:[2,66],36:97,63:98,64:76,65:[1,44],69:99,70:77,71:78,72:[1,79],75:[2,66],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:75,22:100,23:[2,52],63:101,64:76,65:[1,44],69:102,70:77,71:78,72:[1,79],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:75,33:[2,92],62:103,63:104,64:76,65:[1,44],69:105,70:77,71:78,72:[1,79],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[1,106]},{33:[2,79],65:[2,79],72:[2,79],80:[2,79],81:[2,79],82:[2,79],83:[2,79],84:[2,79],85:[2,79]},{33:[2,81]},{23:[2,27],33:[2,27],54:[2,27],65:[2,27],68:[2,27],72:[2,27],75:[2,27],80:[2,27],81:[2,27],82:[2,27],83:[2,27],84:[2,27],85:[2,27]},{23:[2,28],33:[2,28],54:[2,28],65:[2,28],68:[2,28],72:[2,28],75:[2,28],80:[2,28],81:[2,28],82:[2,28],83:[2,28],84:[2,28],85:[2,28]},{23:[2,30],33:[2,30],54:[2,30],68:[2,30],71:107,72:[1,108],75:[2,30]},{23:[2,98],33:[2,98],54:[2,98],68:[2,98],72:[2,98],75:[2,98]},{23:[2,45],33:[2,45],54:[2,45],65:[2,45],68:[2,45],72:[2,45],73:[1,109],75:[2,45],80:[2,45],81:[2,45],82:[2,45],83:[2,45],84:[2,45],85:[2,45],87:[2,45]},{23:[2,44],33:[2,44],54:[2,44],65:[2,44],68:[2,44],72:[2,44],75:[2,44],80:[2,44],81:[2,44],82:[2,44],83:[2,44],84:[2,44],85:[2,44],87:[2,44]},{54:[1,110]},{54:[2,83],65:[2,83],72:[2,83],80:[2,83],81:[2,83],82:[2,83],83:[2,83],84:[2,83],85:[2,83]},{54:[2,85]},{5:[2,13],14:[2,13],15:[2,13],19:[2,13],29:[2,13],34:[2,13],39:[2,13],44:[2,13],47:[2,13],48:[2,13],51:[2,13],55:[2,13],60:[2,13]},{38:56,39:[1,58],43:57,44:[1,59],45:112,46:111,47:[2,76]},{33:[2,70],40:113,65:[2,70],72:[2,70],75:[2,70],80:[2,70],81:[2,70],82:[2,70],83:[2,70],84:[2,70],85:[2,70]},{47:[2,18]},{5:[2,14],14:[2,14],15:[2,14],19:[2,14],29:[2,14],34:[2,14],39:[2,14],44:[2,14],47:[2,14],48:[2,14],51:[2,14],55:[2,14],60:[2,14]},{33:[1,114]},{33:[2,87],65:[2,87],72:[2,87],80:[2,87],81:[2,87],82:[2,87],83:[2,87],84:[2,87],85:[2,87]},{33:[2,89]},{20:75,63:116,64:76,65:[1,44],67:115,68:[2,96],69:117,70:77,71:78,72:[1,79],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[1,118]},{32:119,33:[2,62],74:120,75:[1,121]},{33:[2,59],65:[2,59],72:[2,59],75:[2,59],80:[2,59],81:[2,59],82:[2,59],83:[2,59],84:[2,59],85:[2,59]},{33:[2,61],75:[2,61]},{33:[2,68],37:122,74:123,75:[1,121]},{33:[2,65],65:[2,65],72:[2,65],75:[2,65],80:[2,65],81:[2,65],82:[2,65],83:[2,65],84:[2,65],85:[2,65]},{33:[2,67],75:[2,67]},{23:[1,124]},{23:[2,51],65:[2,51],72:[2,51],80:[2,51],81:[2,51],82:[2,51],83:[2,51],84:[2,51],85:[2,51]},{23:[2,53]},{33:[1,125]},{33:[2,91],65:[2,91],72:[2,91],80:[2,91],81:[2,91],82:[2,91],83:[2,91],84:[2,91],85:[2,91]},{33:[2,93]},{5:[2,22],14:[2,22],15:[2,22],19:[2,22],29:[2,22],34:[2,22],39:[2,22],44:[2,22],47:[2,22],48:[2,22],51:[2,22],55:[2,22],60:[2,22]},{23:[2,99],33:[2,99],54:[2,99],68:[2,99],72:[2,99],75:[2,99]},{73:[1,109]},{20:75,63:126,64:76,65:[1,44],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{5:[2,23],14:[2,23],15:[2,23],19:[2,23],29:[2,23],34:[2,23],39:[2,23],44:[2,23],47:[2,23],48:[2,23],51:[2,23],55:[2,23],60:[2,23]},{47:[2,19]},{47:[2,77]},{20:75,33:[2,72],41:127,63:128,64:76,65:[1,44],69:129,70:77,71:78,72:[1,79],75:[2,72],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{5:[2,24],14:[2,24],15:[2,24],19:[2,24],29:[2,24],34:[2,24],39:[2,24],44:[2,24],47:[2,24],48:[2,24],51:[2,24],55:[2,24],60:[2,24]},{68:[1,130]},{65:[2,95],68:[2,95],72:[2,95],80:[2,95],81:[2,95],82:[2,95],83:[2,95],84:[2,95],85:[2,95]},{68:[2,97]},{5:[2,21],14:[2,21],15:[2,21],19:[2,21],29:[2,21],34:[2,21],39:[2,21],44:[2,21],47:[2,21],48:[2,21],51:[2,21],55:[2,21],60:[2,21]},{33:[1,131]},{33:[2,63]},{72:[1,133],76:132},{33:[1,134]},{33:[2,69]},{15:[2,12]},{14:[2,26],15:[2,26],19:[2,26],29:[2,26],34:[2,26],47:[2,26],48:[2,26],51:[2,26],55:[2,26],60:[2,26]},{23:[2,31],33:[2,31],54:[2,31],68:[2,31],72:[2,31],75:[2,31]},{33:[2,74],42:135,74:136,75:[1,121]},{33:[2,71],65:[2,71],72:[2,71],75:[2,71],80:[2,71],81:[2,71],82:[2,71],83:[2,71],84:[2,71],85:[2,71]},{33:[2,73],75:[2,73]},{23:[2,29],33:[2,29],54:[2,29],65:[2,29],68:[2,29],72:[2,29],75:[2,29],80:[2,29],81:[2,29],82:[2,29],83:[2,29],84:[2,29],85:[2,29]},{14:[2,15],15:[2,15],19:[2,15],29:[2,15],34:[2,15],39:[2,15],44:[2,15],47:[2,15],48:[2,15],51:[2,15],55:[2,15],60:[2,15]},{72:[1,138],77:[1,137]},{72:[2,100],77:[2,100]},{14:[2,16],15:[2,16],19:[2,16],29:[2,16],34:[2,16],44:[2,16],47:[2,16],48:[2,16],51:[2,16],55:[2,16],60:[2,16]},{33:[1,139]},{33:[2,75]},{33:[2,32]},{72:[2,101],77:[2,101]},{14:[2,17],15:[2,17],19:[2,17],29:[2,17],34:[2,17],39:[2,17],44:[2,17],47:[2,17],48:[2,17],51:[2,17],55:[2,17],60:[2,17]}],defaultActions:{4:[2,1],55:[2,55],57:[2,20],61:[2,57],74:[2,81],83:[2,85],87:[2,18],91:[2,89],102:[2,53],105:[2,93],111:[2,19],112:[2,77],117:[2,97],120:[2,63],123:[2,69],124:[2,12],136:[2,75],137:[2,32]},parseError:function(a){throw new Error(a)},parse:function(a){function b(){var a;return a=c.lexer.lex()||1,"number"!=typeof a&&(a=c.symbols_[a]||a),a}var c=this,d=[0],e=[null],f=[],g=this.table,h="",i=0,j=0,k=0;this.lexer.setInput(a),this.lexer.yy=this.yy,this.yy.lexer=this.lexer,this.yy.parser=this,"undefined"==typeof this.lexer.yylloc&&(this.lexer.yylloc={});var l=this.lexer.yylloc;f.push(l);var m=this.lexer.options&&this.lexer.options.ranges;"function"==typeof this.yy.parseError&&(this.parseError=this.yy.parseError);for(var n,o,q,s,t,u,v,w,x,y={};;){if(q=d[d.length-1],this.defaultActions[q]?s=this.defaultActions[q]:((null===n||"undefined"==typeof n)&&(n=b()),s=g[q]&&g[q][n]),"undefined"==typeof s||!s.length||!s[0]){var z="";if(!k){for(u in x=[],g[q])this.terminals_[u]&&2<u&&x.push("'"+this.terminals_[u]+"'");z=this.lexer.showPosition?"Parse error on line "+(i+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+x.join(", ")+", got '"+(this.terminals_[n]||n)+"'":"Parse error on line "+(i+1)+": Unexpected "+(1==n?"end of input":"'"+(this.terminals_[n]||n)+"'"),this.parseError(z,{text:this.lexer.match,token:this.terminals_[n]||n,line:this.lexer.yylineno,loc:l,expected:x})}}if(s[0]instanceof Array&&1<s.length)throw new Error("Parse Error: multiple actions possible at state: "+q+", token: "+n);switch(s[0]){case 1:d.push(n),e.push(this.lexer.yytext),f.push(this.lexer.yylloc),d.push(s[1]),n=null,o?(n=o,o=null):(j=this.lexer.yyleng,h=this.lexer.yytext,i=this.lexer.yylineno,l=this.lexer.yylloc,0<k&&k--);break;case 2:if(v=this.productions_[s[1]][1],y.$=e[e.length-v],y._$={first_line:f[f.length-(v||1)].first_line,last_line:f[f.length-1].last_line,first_column:f[f.length-(v||1)].first_column,last_column:f[f.length-1].last_column},m&&(y._$.range=[f[f.length-(v||1)].range[0],f[f.length-1].range[1]]),t=this.performAction.call(y,h,j,i,this.yy,s[1],e,f),"undefined"!=typeof t)return t;v&&(d=d.slice(0,2*(-1*v)),e=e.slice(0,-1*v),f=f.slice(0,-1*v)),d.push(this.productions_[s[1]][0]),e.push(y.$),f.push(y._$),w=g[d[d.length-2]][d[d.length-1]],d.push(w);break;case 3:return!0;}}return!0}},c=function(){var a={EOF:1,parseError:function(a,b){if(this.yy.parser)this.yy.parser.parseError(a,b);else throw new Error(a)},setInput:function(a){return this._input=a,this._more=this._less=this.done=!1,this.yylineno=this.yyleng=0,this.yytext=this.matched=this.match="",this.conditionStack=["INITIAL"],this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0},this.options.ranges&&(this.yylloc.range=[0,0]),this.offset=0,this},input:function(){var a=this._input[0];this.yytext+=a,this.yyleng++,this.offset++,this.match+=a,this.matched+=a;var b=a.match(/(?:\r\n?|\n).*/g);return b?(this.yylineno++,this.yylloc.last_line++):this.yylloc.last_column++,this.options.ranges&&this.yylloc.range[1]++,this._input=this._input.slice(1),a},unput:function(a){var b=a.length,c=a.split(/(?:\r\n?|\n)/g);this._input=a+this._input,this.yytext=this.yytext.substr(0,this.yytext.length-b-1),this.offset-=b;var d=this.match.split(/(?:\r\n?|\n)/g);this.match=this.match.substr(0,this.match.length-1),this.matched=this.matched.substr(0,this.matched.length-1),c.length-1&&(this.yylineno-=c.length-1);var e=this.yylloc.range;return this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:c?(c.length===d.length?this.yylloc.first_column:0)+d[d.length-c.length].length-c[0].length:this.yylloc.first_column-b},this.options.ranges&&(this.yylloc.range=[e[0],e[0]+this.yyleng-b]),this},more:function(){return this._more=!0,this},less:function(a){this.unput(this.match.slice(a))},pastInput:function(){var a=this.matched.substr(0,this.matched.length-this.match.length);return(20<a.length?"...":"")+a.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var a=this.match;return 20>a.length&&(a+=this._input.substr(0,20-a.length)),(a.substr(0,20)+(20<a.length?"...":"")).replace(/\n/g,"")},showPosition:function(){var a=this.pastInput(),b=Array(a.length+1).join("-");return a+this.upcomingInput()+"\n"+b+"^"},next:function(){if(this.done)return this.EOF;this._input||(this.done=!0);var a,b,c,d,e;this._more||(this.yytext="",this.match="");for(var f=this._currentRules(),g=0;g<f.length&&(c=this._input.match(this.rules[f[g]]),!(c&&(!b||c[0].length>b[0].length)&&(b=c,d=g,!this.options.flex)));g++);return b?(e=b[0].match(/(?:\r\n?|\n).*/g),e&&(this.yylineno+=e.length),this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:e?e[e.length-1].length-e[e.length-1].match(/\r?\n?/)[0].length:this.yylloc.last_column+b[0].length},this.yytext+=b[0],this.match+=b[0],this.matches=b,this.yyleng=this.yytext.length,this.options.ranges&&(this.yylloc.range=[this.offset,this.offset+=this.yyleng]),this._more=!1,this._input=this._input.slice(b[0].length),this.matched+=b[0],a=this.performAction.call(this,this.yy,this,f[d],this.conditionStack[this.conditionStack.length-1]),this.done&&this._input&&(this.done=!1),a?a:void 0):""===this._input?this.EOF:this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})},lex:function(){var a=this.next();return"undefined"==typeof a?this.lex():a},begin:function(a){this.conditionStack.push(a)},popState:function(){return this.conditionStack.pop()},_currentRules:function(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules},topState:function(){return this.conditionStack[this.conditionStack.length-2]},pushState:function(a){this.begin(a)},options:{},performAction:function(a,b,c,d){function e(a,c){return b.yytext=b.yytext.substr(a,b.yyleng-c)}switch(c){case 0:if("\\\\"===b.yytext.slice(-2)?(e(0,1),this.begin("mu")):"\\"===b.yytext.slice(-1)?(e(0,1),this.begin("emu")):this.begin("mu"),b.yytext)return 15;break;case 1:return 15;break;case 2:return this.popState(),15;break;case 3:return this.begin("raw"),15;break;case 4:return this.popState(),"raw"===this.conditionStack[this.conditionStack.length-1]?15:(b.yytext=b.yytext.substr(5,b.yyleng-9),"END_RAW_BLOCK");break;case 5:return 15;break;case 6:return this.popState(),14;break;case 7:return 65;break;case 8:return 68;break;case 9:return 19;break;case 10:return this.popState(),this.begin("raw"),23;break;case 11:return 55;break;case 12:return 60;break;case 13:return 29;break;case 14:return 47;break;case 15:return this.popState(),44;break;case 16:return this.popState(),44;break;case 17:return 34;break;case 18:return 39;break;case 19:return 51;break;case 20:return 48;break;case 21:this.unput(b.yytext),this.popState(),this.begin("com");break;case 22:return this.popState(),14;break;case 23:return 48;break;case 24:return 73;break;case 25:return 72;break;case 26:return 72;break;case 27:return 87;break;case 28:break;case 29:return this.popState(),54;break;case 30:return this.popState(),33;break;case 31:return b.yytext=e(1,2).replace(/\\"/g,"\""),80;break;case 32:return b.yytext=e(1,2).replace(/\\'/g,"'"),80;break;case 33:return 85;break;case 34:return 82;break;case 35:return 82;break;case 36:return 83;break;case 37:return 84;break;case 38:return 81;break;case 39:return 75;break;case 40:return 77;break;case 41:return 72;break;case 42:return b.yytext=b.yytext.replace(/\\([\\\]])/g,"$1"),72;break;case 43:return"INVALID";break;case 44:return 5;}},rules:[/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:\{\{\{\{(?=[^\/]))/,/^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,/^(?:[^\x00]*?(?=(\{\{\{\{)))/,/^(?:[\s\S]*?--(~)?\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{\{\{)/,/^(?:\}\}\}\})/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#>)/,/^(?:\{\{(~)?#\*?)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^\s*(~)?\}\})/,/^(?:\{\{(~)?\s*else\s*(~)?\}\})/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{(~)?!--)/,/^(?:\{\{(~)?![\s\S]*?\}\})/,/^(?:\{\{(~)?\*?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)|])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:undefined(?=([~}\s)])))/,/^(?:null(?=([~}\s)])))/,/^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,/^(?:as\s+\|)/,/^(?:\|)/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,/^(?:\[(\\\]|[^\]])*\])/,/^(?:.)/,/^(?:$)/],conditions:{mu:{rules:[7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44],inclusive:!1},emu:{rules:[2],inclusive:!1},com:{rules:[6],inclusive:!1},raw:{rules:[3,4,5],inclusive:!1},INITIAL:{rules:[0,1,44],inclusive:!0}}};return a}();return b.lexer=c,a.prototype=b,b.Parser=a,new a}();exports.default=handlebars;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _visitor=__webpack_require__(5),_visitor2=_interopRequireDefault(_visitor);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function WhitespaceControl(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:{};this.options=a}WhitespaceControl.prototype=new _visitor2.default,WhitespaceControl.prototype.Program=function(a){var b=!this.options.ignoreStandalone,c=!this.isRootSeen;this.isRootSeen=!0;for(var d=a.body,e=0,f=d.length;e<f;e++){var m=d[e],n=this.accept(m);if(n){var g=isPrevWhitespace(d,e,c),h=isNextWhitespace(d,e,c),j=n.openStandalone&&g,k=n.closeStandalone&&h,l=n.inlineStandalone&&g&&h;n.close&&omitRight(d,e,!0),n.open&&omitLeft(d,e,!0),b&&l&&(omitRight(d,e),omitLeft(d,e)&&'PartialStatement'===m.type&&(m.indent=/([ \t]+$)/.exec(d[e-1].original)[1])),b&&j&&(omitRight((m.program||m.inverse).body),omitLeft(d,e)),b&&k&&(omitRight(d,e),omitLeft((m.inverse||m.program).body))}}return a},WhitespaceControl.prototype.BlockStatement=WhitespaceControl.prototype.DecoratorBlock=WhitespaceControl.prototype.PartialBlockStatement=function(a){this.accept(a.program),this.accept(a.inverse);var b=a.program||a.inverse,c=a.program&&a.inverse,d=c,e=c;if(c&&c.chained)for(d=c.body[0].program;e.chained;)e=e.body[e.body.length-1].program;var f={open:a.openStrip.open,close:a.closeStrip.close,openStandalone:isNextWhitespace(b.body),closeStandalone:isPrevWhitespace((d||b).body)};if(a.openStrip.close&&omitRight(b.body,null,!0),c){var g=a.inverseStrip;g.open&&omitLeft(b.body,null,!0),g.close&&omitRight(d.body,null,!0),a.closeStrip.open&&omitLeft(e.body,null,!0),!this.options.ignoreStandalone&&isPrevWhitespace(b.body)&&isNextWhitespace(d.body)&&(omitLeft(b.body),omitRight(d.body))}else a.closeStrip.open&&omitLeft(b.body,null,!0);return f},WhitespaceControl.prototype.Decorator=WhitespaceControl.prototype.MustacheStatement=function(a){return a.strip},WhitespaceControl.prototype.PartialStatement=WhitespaceControl.prototype.CommentStatement=function(a){var b=a.strip||{};return{inlineStandalone:!0,open:b.open,close:b.close}};function isPrevWhitespace(a,b,c){b===void 0&&(b=a.length);var d=a[b-1],e=a[b-2];return d?'ContentStatement'===d.type?(e||!c?/\r?\n\s*?$/:/(^|\r?\n)\s*?$/).test(d.original):void 0:c}function isNextWhitespace(a,b,c){b===void 0&&(b=-1);var d=a[b+1],e=a[b+2];return d?'ContentStatement'===d.type?(e||!c?/^\s*?\r?\n/:/^\s*?(\r?\n|$)/).test(d.original):void 0:c}function omitRight(a,b,c){var d=a[null==b?0:b+1];if(d&&'ContentStatement'===d.type&&(c||!d.rightStripped)){var e=d.value;d.value=d.value.replace(c?/^\s+/:/^[ \t]*\r?\n?/,''),d.rightStripped=d.value!==e}}function omitLeft(a,b,c){var d=a[null==b?a.length-1:b-1];if(d&&'ContentStatement'===d.type&&(c||!d.leftStripped)){var e=d.value;return d.value=d.value.replace(c?/\s+$/:/[ \t]+$/,''),d.leftStripped=d.value!==e,d.leftStripped}}exports.default=WhitespaceControl;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.registerDefaultDecorators=registerDefaultDecorators;var _inline=__webpack_require__(17),_inline2=_interopRequireDefault(_inline);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function registerDefaultDecorators(a){(0,_inline2.default)(a)}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(a){a.registerDecorator('inline',function(a,b,c,d){var e=a;return b.partials||(b.partials={},e=function(d,e){var f=c.partials;c.partials=(0,_utils.extend)({},f,b.partials);var g=a(d,e);return c.partials=f,g}),b.partials[d.args[0]]=d.fn,e})};var _utils=__webpack_require__(0);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.registerDefaultHelpers=registerDefaultHelpers;var _blockHelperMissing=__webpack_require__(19),_blockHelperMissing2=_interopRequireDefault(_blockHelperMissing),_each=__webpack_require__(20),_each2=_interopRequireDefault(_each),_helperMissing=__webpack_require__(21),_helperMissing2=_interopRequireDefault(_helperMissing),_if=__webpack_require__(22),_if2=_interopRequireDefault(_if),_log=__webpack_require__(23),_log2=_interopRequireDefault(_log),_lookup=__webpack_require__(24),_lookup2=_interopRequireDefault(_lookup),_with=__webpack_require__(25),_with2=_interopRequireDefault(_with);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function registerDefaultHelpers(a){(0,_blockHelperMissing2.default)(a),(0,_each2.default)(a),(0,_helperMissing2.default)(a),(0,_if2.default)(a),(0,_log2.default)(a),(0,_lookup2.default)(a),(0,_with2.default)(a)}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(a){a.registerHelper('blockHelperMissing',function(b,c){var d=c.inverse,e=c.fn;if(!0===b)return e(this);if(!1===b||null==b)return d(this);if((0,_utils.isArray)(b))return 0<b.length?(c.ids&&(c.ids=[c.name]),a.helpers.each(b,c)):d(this);if(c.data&&c.ids){var f=(0,_utils.createFrame)(c.data);f.contextPath=(0,_utils.appendContextPath)(c.data.contextPath,c.name),c={data:f}}return e(b,c)})};var _utils=__webpack_require__(0);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&'function'==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?'symbol':typeof a};Object.defineProperty(exports,'__esModule',{value:!0});exports.default=function(a){a.registerHelper('each',function(a,b){function c(b,c,g){d&&(d.key=b,d.index=c,d.first=0===c,d.last=!!g,e&&(d.contextPath=e+b)),k+=f(a[b],{data:d,blockParams:(0,_utils.blockParams)([a[b],b],[e+b,null])})}if(!b)throw new _exception2.default('Must pass iterator to #each');var d,e,f=b.fn,g=b.inverse,h=0,k='';if(b.data&&b.ids&&(e=(0,_utils.appendContextPath)(b.data.contextPath,b.ids[0])+'.'),(0,_utils.isFunction)(a)&&(a=a.call(this)),b.data&&(d=(0,_utils.createFrame)(b.data)),a&&'object'===('undefined'==typeof a?'undefined':_typeof(a)))if((0,_utils.isArray)(a))for(var l=a.length;h<l;h++)h in a&&c(h,h,h==a.length-1);else{var j;for(var m in a)a.hasOwnProperty(m)&&(void 0!==j&&c(j,h-1),j=m,h++);void 0!==j&&c(j,h-1,!0)}return 0==h&&(k=g(this)),k})};var _utils=__webpack_require__(0),_exception=__webpack_require__(1),_exception2=_interopRequireDefault(_exception);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(a){a.registerHelper('helperMissing',function(){if(1!==arguments.length)throw new _exception2.default('Missing helper: "'+arguments[arguments.length-1].name+'"')})};var _exception=__webpack_require__(1),_exception2=_interopRequireDefault(_exception);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(a){a.registerHelper('if',function(a,b){return(0,_utils.isFunction)(a)&&(a=a.call(this)),(b.hash.includeZero||a)&&!(0,_utils.isEmpty)(a)?b.fn(this):b.inverse(this)}),a.registerHelper('unless',function(b,c){return a.helpers['if'].call(this,b,{fn:c.inverse,inverse:c.fn,hash:c.hash})})};var _utils=__webpack_require__(0);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(a){a.registerHelper('log',function(){for(var b=[void 0],c=arguments[arguments.length-1],d=0;d<arguments.length-1;d++)b.push(arguments[d]);var e=1;null==c.hash.level?c.data&&null!=c.data.level&&(e=c.data.level):e=c.hash.level,b[0]=e,a.log.apply(a,b)})};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(a){a.registerHelper('lookup',function(a,b){return a&&a[b]})};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(a){a.registerHelper('with',function(a,b){(0,_utils.isFunction)(a)&&(a=a.call(this));var c=b.fn;if(!(0,_utils.isEmpty)(a)){var d=b.data;return b.data&&b.ids&&(d=(0,_utils.createFrame)(b.data),d.contextPath=(0,_utils.appendContextPath)(b.data.contextPath,b.ids[0])),c(a,{data:d,blockParams:(0,_utils.blockParams)([a],[d&&d.contextPath])})}return b.inverse(this)})};var _utils=__webpack_require__(0);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _utils=__webpack_require__(0),logger={methodMap:['debug','info','warn','error'],level:'info',lookupLevel:function b(a){if('string'==typeof a){var c=(0,_utils.indexOf)(logger.methodMap,a.toLowerCase());a=0<=c?c:parseInt(a,10)}return a},log:function g(a){if(a=logger.lookupLevel(a),'undefined'!=typeof console&&logger.lookupLevel(logger.level)<=a){var b,c=logger.methodMap[a];console[c]||(c='log');for(var d=arguments.length,e=Array(1<d?d-1:0),f=1;f<d;f++)e[f-1]=arguments[f];(b=console)[c].apply(b,e)}}};exports.default=logger;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&'function'==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?'symbol':typeof a};Object.defineProperty(exports,'__esModule',{value:!0});exports.checkRevision=checkRevision,exports.template=template,exports.wrapProgram=wrapProgram,exports.resolvePartial=resolvePartial,exports.invokePartial=invokePartial,exports.noop=noop;var _utils=__webpack_require__(0),Utils=_interopRequireWildcard(_utils),_exception=__webpack_require__(1),_exception2=_interopRequireDefault(_exception),_base=__webpack_require__(2);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function _interopRequireWildcard(a){if(a&&a.__esModule)return a;var b={};if(null!=a)for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(b[c]=a[c]);return b.default=a,b}function checkRevision(a){var b=a&&a[0]||1,c=_base.COMPILER_REVISION;if(b!==c)if(b<c){var d=_base.REVISION_CHANGES[c],e=_base.REVISION_CHANGES[b];throw new _exception2.default('Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version ('+d+') or downgrade your runtime to an older version ('+e+').')}else throw new _exception2.default('Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version ('+a[1]+').')}function template(a,b){function c(b){function e(b){return''+a.main(d,b,d.helpers,d.partials,g,i,h)}var f=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},g=f.data;c._setup(f),!f.partial&&a.useData&&(g=initData(b,g));var h,i=a.useBlockParams?[]:void 0;return a.useDepths&&(f.depths?h=b==f.depths[0]?f.depths:[b].concat(f.depths):h=[b]),e=executeDecorators(a.main,e,d,f.depths||[],g,i),e(b,f)}if(!b)throw new _exception2.default('No environment passed to template');if(!a||!a.main)throw new _exception2.default('Unknown template object: '+('undefined'==typeof a?'undefined':_typeof(a)));a.main.decorator=a.main_d,b.VM.checkRevision(a.compiler);var d={strict:function c(a,b){if(!(b in a))throw new _exception2.default('"'+b+'" not defined in '+a);return a[b]},lookup:function e(a,b){for(var c=a.length,d=0;d<c;d++)if(a[d]&&null!=a[d][b])return a[d][b]},lambda:function c(a,b){return'function'==typeof a?a.call(b):a},escapeExpression:Utils.escapeExpression,invokePartial:function(c,d,e){e.hash&&(d=Utils.extend({},d,e.hash),e.ids&&(e.ids[0]=!0)),c=b.VM.resolvePartial.call(this,c,d,e);var f=b.VM.invokePartial.call(this,c,d,e);if(null==f&&b.compile&&(e.partials[e.name]=b.compile(c,a.compilerOptions,b),f=e.partials[e.name](d,e)),null!=f){if(e.indent){for(var g=f.split('\n'),h=0,j=g.length;h<j&&(g[h]||h+1!==j);h++)g[h]=e.indent+g[h];f=g.join('\n')}return f}throw new _exception2.default('The partial '+e.name+' could not be compiled when running in runtime-only mode')},fn:function d(b){var c=a[b];return c.decorator=a[b+'_d'],c},programs:[],program:function h(a,b,c,d,e){var f=this.programs[a],g=this.fn(a);return b||e||d||c?f=wrapProgram(this,a,g,b,c,d,e):!f&&(f=this.programs[a]=wrapProgram(this,a,g)),f},data:function c(a,b){for(;a&&b--;)a=a._parent;return a},merge:function d(a,b){var c=a||b;return a&&b&&a!==b&&(c=Utils.extend({},b,a)),c},nullContext:Object.seal({}),noop:b.VM.noop,compilerInfo:a.compiler};return c.isTop=!0,c._setup=function(c){c.partial?(d.helpers=c.helpers,d.partials=c.partials,d.decorators=c.decorators):(d.helpers=d.merge(c.helpers,b.helpers),a.usePartial&&(d.partials=d.merge(c.partials,b.partials)),(a.usePartial||a.useDecorators)&&(d.decorators=d.merge(c.decorators,b.decorators)))},c._child=function(b,c,e,f){if(a.useBlockParams&&!e)throw new _exception2.default('must pass block params');if(a.useDepths&&!f)throw new _exception2.default('must pass parent depths');return wrapProgram(d,b,a[b],c,0,e,f)},c}function wrapProgram(a,b,c,d,e,f,g){function h(b){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},h=g;return g&&b!=g[0]&&(b!==a.nullContext||null!==g[0])&&(h=[b].concat(g)),c(a,b,a.helpers,a.partials,e.data||d,f&&[e.blockParams].concat(f),h)}return h=executeDecorators(c,h,a,g,d,f),h.program=b,h.depth=g?g.length:0,h.blockParams=e||0,h}function resolvePartial(a,b,c){return a?!a.call&&!c.name&&(c.name=a,a=c.partials[a]):'@partial-block'===c.name?a=c.data['partial-block']:a=c.partials[c.name],a}function invokePartial(a,b,c){var d=c.data&&c.data['partial-block'];c.partial=!0,c.ids&&(c.data.contextPath=c.ids[0]||c.data.contextPath);var e;if(c.fn&&c.fn!==noop){c.data=(0,_base.createFrame)(c.data);var f=c.fn;e=c.data['partial-block']=function(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return b.data=(0,_base.createFrame)(b.data),b.data['partial-block']=d,f(a,b)},f.partials&&(c.partials=Utils.extend({},c.partials,f.partials))}if(void 0===a&&e&&(a=e),void 0===a)throw new _exception2.default('The partial '+c.name+' could not be found');else if(a instanceof Function)return a(b,c)}function noop(){return''}function initData(a,b){return b&&'root'in b||(b=b?(0,_base.createFrame)(b):{},b.root=a),b}function executeDecorators(a,b,c,d,e,f){if(a.decorator){var g={};b=a.decorator(b,g,c,d&&d[0],e,f,d),Utils.extend(b,g)}return b}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});function SafeString(a){this.string=a}SafeString.prototype.toString=SafeString.prototype.toHTML=function(){return''+this.string},exports.default=SafeString;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _handlebars=__webpack_require__(3),_handlebars2=_interopRequireDefault(_handlebars);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var hbs2=_handlebars2.default.create();hbs2.registerHelper('button',function(a,b){var a=hbs2.escapeExpression(a),b=hbs2.escapeExpression(b);return new hbs2.SafeString('<center style=\'font-family: "Avenir Next", "Avenir", "Helvetica", sans-serif !important;\'>\n      <div class="section" style=\'font-family: "Avenir Next", "Avenir", "Helvetica", sans-serif !important; padding: 50px 0;\'>\n        <a class="button" href="'+a+'" target="_blank" style=\'color: white; font-family: "Avenir Next", "Avenir", "Helvetica", sans-serif !important; background-color: #ffc837; border-radius: 3px; padding: 15px 17px; text-decoration: none;\'>'+b+'</a>\n        </div>\n    </center>')}),hbs2.registerHelper('p',function(a){return new hbs2.SafeString('<p style=\'margin: 10px 0 15px; font-family: "Avenir Next", "Avenir", "Helvetica", sans-serif !important; font-weight: 400; font-size: 16px; line-height: 1.5;\'>'+a.fn(this)+'</p>')}),hbs2.registerHelper('title',function(a){return new hbs2.SafeString('<h2 style=\'margin: 0 0 0.5rem 0; line-height: 1.25; font-family: "Avenir Next", "Avenir", "Helvetica", sans-serif !important; color: #3e474c; font-size: 2rem; font-weight: 500; font-style: normal;\'>'+a.fn(this)+'</h2>')}),hbs2.registerHelper('title2',function(a){return new hbs2.SafeString('<h4 style=\'margin: 0; line-height: 1.25; font-family: "Avenir Next", "Avenir", "Helvetica", sans-serif !important; color: #3e474c; font-size: 1.4em; font-weight: 500; font-style: normal;\'>'+a.fn(this)+'</h4>')}),hbs2.registerHelper('ifCond',function(a,b,c){return a===b?c.fn(this):c.inverse(this)}),exports.default=hbs2;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _handlebars=__webpack_require__(3),_handlebars2=_interopRequireDefault(_handlebars);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var hbs1=_handlebars2.default.create();hbs1.registerHelper('button',function(a,b){var a=hbs1.escapeExpression(a),b=hbs1.escapeExpression(b);return new hbs1.SafeString('['+b+']: '+a)}),hbs1.registerHelper('p',function(a){return new hbs1.SafeString(a.fn(this)+'\n        ')}),hbs1.registerHelper('title',function(a){return new hbs1.SafeString(a.fn(this)+'\n        ')}),hbs1.registerHelper('title2',function(a){return new hbs1.SafeString(a.fn(this)+'\n        ')}),hbs1.registerHelper('ifCond',function(a,b,c){return a===b?c.fn(this):c.inverse(this)}),exports.default=hbs1;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var simple_fr=exports.simple_fr="<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Strict//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd\">\n<html xmlns=\"http://www.w3.org/1999/xhtml\">\n\n<head>\n  <meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\">\n  <meta name=\"viewport\" content=\"width=device-width\">\n  <title>{{subject}}</title>\n  <style type=\"text/css\">\n    @media (min-width: 550px) {\n        .hero-image {\n          top: 0 !important;\n        }\n      \n        table[class=\"body\"] {\n          padding-bottom: 50px !important;\n          padding-top: 50px !important;\n        }\n      \n        .email-logo-masthead {\n          display: inline !important;\n          height: 35px !important;\n          margin-left: 0 !important;\n          margin-right: 0 !important;\n        }\n      \n        .email-content {\n          border-left: 1px solid #dadfe1 !important;\n          border-right: 1px solid #dadfe1 !important;\n        }\n      \n        .email-content-block {\n          padding-left: 50px !important;\n          padding-right: 50px !important;\n        }\n      }\n      .email-social-bar-copy p, .email-social-bar-copy a, .email-social-bar-copy .ios-no-link {\n        color: white !important;\n        text-decoration: none !important;\n      }\n  </style>\n</head>\n\n<body style=\"background-color: #f1f1f1; height: 100%; margin: 0; padding: 0;\">\n  <table class=\"body\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"background-color: #f1f1f1; height: 100%; padding-bottom: 25px; padding-left: 0; padding-right: 0; padding-top: 25px;\">\n    <tbody>\n      <tr>\n        <td>\n          <table align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\n            <tbody>\n              <tr>\n                <td width=\"550\">\n                  <table align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n                    <tbody>\n                      <tr>\n                        <td>\n                          <table class=\"\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n                            <tbody>\n                              <td>\n                                <img class=\"email-logo-masthead\" src=\"https://sofiatutors.com/img/logo/logo_black_fr.png\" height=\"60\" style=\"width: auto; max-width: 100% !important; display: block; height: 65px; margin-bottom: 25px; margin-left: auto; margin-right: auto;\">\n                              </td>\n                            </tbody>\n                          </table>\n                        </td>\n                      </tr>\n                      <tr>\n                        <td class=\"email-content-border\" style=\"border-top: 1px solid #dadfe1;\"></td>\n                      </tr>\n                      <tr>\n                        <td class=\"email-content\" style=\"background-color: #FFFFFF;\">\n                          <table class=\"\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n                            <tbody>\n                              <tr>\n                                <td class=\"email-content-block copy\" style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; padding-left: 25px; padding-right: 25px; padding-top: 50px;'>\n                                  \n                                      {{{body}}}\n                                      \n\n                                    \n                                  <p style='margin-bottom: 15px; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-weight: 400; font-size: 16px; line-height: 1.5;'>Bonne journ\xE9e!</p>\n\n                                  {{#if admin_name}}\n\n                                    <p class=\"signout light-type\" style='margin-bottom: 15px; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-weight: 400; font-size: 16px; line-height: 1.5; color: #788991;'>\u2014 {{admin_name}}, co-fondateur</p>\n\n                                  {{else}}\n\n                                    <p class=\"signout light-type\" style='margin-bottom: 15px; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-weight: 400; font-size: 16px; line-height: 1.5; color: #788991;'>\u2014 L'\xE9quipe de Sofia</p>\n\n                                  {{/if}}\n                                  \n                                  <div class=\"padding-break\" style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; margin-top: 50px;'></div>\n                                </td>\n                              </tr>\n                            </tbody>\n                          </table>\n                        </td>\n                      </tr>\n                      <tr>\n                        <td>\n                          <table class=\"email-social-bar\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"padding-left: 50px; padding-right: 50px; background: #ffc837; padding-bottom: 25px; padding-top: 25px;\">\n                            <tbody>\n                              <tr>\n                                <td class=\"email-social-bar-copy copy\" style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important;'>\n                                  <p class=\"ios-no-link\" style='margin-bottom: 15px; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-weight: 400; font-size: 11px; line-height: 1.5; color: white;'>Sofia Tutors Inc.\n                                    <br style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important;'>Glengarry, Dorval\n                                    <br style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important;'>Qu\xE9bec, H9S1J4</p>\n                                </td>\n                                <td class=\"email-social-bar-icons\">\n                                  <table class=\"\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n                                    <tbody>\n                                      <tr>\n                                        <td align=\"right\">\n                                          <a class=\"email-social-bar-social-icon\" href=\"https://twitter.com/sofiatutors\" style=\"-moz-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); -o-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); -webkit-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); color: #4EAACC; padding: 0 5px; text-decoration: none;\">\n                                            <img class=\"auto-width\" src=\"https://simple.com/email-images/icons/social-twitter.png\" style=\"width: auto; max-width: 100% !important; border: 0;\">\n                                          </a>\n                                          <a class=\"email-social-bar-social-icon\" href=\"https://www.facebook.com/sofiatutors\" style=\"-moz-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); -o-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); -webkit-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); color: #4EAACC; padding: 0 5px; text-decoration: none;\">\n                                            <img class=\"auto-width\" src=\"https://simple.com/email-images/icons/social-facebook.png\" style=\"width: auto; max-width: 100% !important; border: 0;\">\n                                          </a>\n                                          </a>\n                                        </td>\n                                      </tr>\n                                    </tbody>\n                                  </table>\n                                </td>\n                              </tr>\n                            </tbody>\n                          </table>\n                        </td>\n                      </tr>\n                    </tbody>\n                  </table>\n                  <table class=\"\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n                    <tbody>\n                      <tr>\n                        <td align=\"center\" class=\"email-disclaimer copy\" style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; padding-left: 50px; padding-right: 50px; padding-top: 15px; padding-bottom: 15px;'>\n                          <p style='margin-bottom: 15px; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-weight: 400; font-size: 11px; line-height: 1.5; color: #788991; margin-top: 0;'>Ce courriel a \xE9t\xE9 envoy\xE9 \xE0 <strong style='font-weight: 500; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-size: 11px; color: #788991; margin-top: 0;'>{{ to }}</strong>.</p>\n                        </td>\n                      </tr>\n                    </tbody>\n                  </table>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</body>\n\n</html>",simple_en=exports.simple_en="<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Strict//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd\">\n<html xmlns=\"http://www.w3.org/1999/xhtml\">\n\n<head>\n  <meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\">\n  <meta name=\"viewport\" content=\"width=device-width\">\n  <title>{{subject}}</title>\n  <style type=\"text/css\">\n    @media (min-width: 550px) {\n        .hero-image {\n          top: 0 !important;\n        }\n      \n        table[class=\"body\"] {\n          padding-bottom: 50px !important;\n          padding-top: 50px !important;\n        }\n      \n        .email-logo-masthead {\n          display: inline !important;\n          height: 35px !important;\n          margin-left: 0 !important;\n          margin-right: 0 !important;\n        }\n      \n        .email-content {\n          border-left: 1px solid #dadfe1 !important;\n          border-right: 1px solid #dadfe1 !important;\n        }\n      \n        .email-content-block {\n          padding-left: 50px !important;\n          padding-right: 50px !important;\n        }\n      }\n      .email-social-bar-copy p, .email-social-bar-copy a, .email-social-bar-copy .ios-no-link {\n        color: white !important;\n        text-decoration: none !important;\n      }\n  </style>\n</head>\n\n<body style=\"background-color: #f1f1f1; height: 100%; margin: 0; padding: 0;\">\n  <table class=\"body\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"background-color: #f1f1f1; height: 100%; padding-bottom: 25px; padding-left: 0; padding-right: 0; padding-top: 25px;\">\n    <tbody>\n      <tr>\n        <td>\n          <table align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\n            <tbody>\n              <tr>\n                <td width=\"550\">\n                  <table align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n                    <tbody>\n                      <tr>\n                        <td>\n                          <table class=\"\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n                            <tbody>\n                              <td>\n                                <img class=\"email-logo-masthead\" src=\"https://sofiatutors.com/img/logo/logo_black_fr.png\" height=\"60\" style=\"width: auto; max-width: 100% !important; display: block; height: 65px; margin-bottom: 25px; margin-left: auto; margin-right: auto;\">\n                              </td>\n                            </tbody>\n                          </table>\n                        </td>\n                      </tr>\n                      <tr>\n                        <td class=\"email-content-border\" style=\"border-top: 1px solid #dadfe1;\"></td>\n                      </tr>\n                      <tr>\n                        <td class=\"email-content\" style=\"background-color: #FFFFFF;\">\n                          <table class=\"\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n                            <tbody>\n                              <tr>\n                                <td class=\"email-content-block copy\" style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; padding-left: 25px; padding-right: 25px; padding-top: 50px;'>\n                                  \n                                      {{{body}}}\n\n                                    \n                                  <p style='margin-bottom: 15px; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-weight: 400; font-size: 16px; line-height: 1.5;'>Have a great day!</p>\n                                  {{#if admin_name}}\n\n                                    <p class=\"signout light-type\" style='margin-bottom: 15px; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-weight: 400; font-size: 16px; line-height: 1.5; color: #788991;'>\u2014 {{admin_name}}, co-founder</p>\n\n                                  {{else}}\n\n                                    <p class=\"signout light-type\" style='margin-bottom: 15px; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-weight: 400; font-size: 16px; line-height: 1.5; color: #788991;'>\u2014 The Sofia team</p>\n\n                                  {{/if}}\n\n                                  <div class=\"padding-break\" style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; margin-top: 50px;'></div>\n                                </td>\n                              </tr>\n                            </tbody>\n                          </table>\n                        </td>\n                      </tr>\n                      <tr>\n                        <td>\n                          <table class=\"email-social-bar\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"padding-left: 50px; padding-right: 50px; background: #ffc837; padding-bottom: 25px; padding-top: 25px;\">\n                            <tbody>\n                              <tr>\n                                <td class=\"email-social-bar-copy copy\" style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important;'>\n                                  <p class=\"ios-no-link\" style='margin-bottom: 15px; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-weight: 400; font-size: 11px; line-height: 1.5; color: white;'>Sofia Tutors Inc.\n                                    <br style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important;'>Glengarry, Dorval\n                                    <br style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important;'>Qu\xE9bec, H9S1J4</p>\n                                </td>\n                                <td class=\"email-social-bar-icons\">\n                                  <table class=\"\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n                                    <tbody>\n                                      <tr>\n                                        <td align=\"right\">\n                                          <a class=\"email-social-bar-social-icon\" href=\"https://twitter.com/sofiatutors\" style=\"-moz-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); -o-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); -webkit-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); color: #4EAACC; padding: 0 5px; text-decoration: none;\">\n                                            <img class=\"auto-width\" src=\"https://simple.com/email-images/icons/social-twitter.png\" style=\"width: auto; max-width: 100% !important; border: 0;\">\n                                          </a>\n                                          <a class=\"email-social-bar-social-icon\" href=\"https://www.facebook.com/sofiatutors\" style=\"-moz-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); -o-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); -webkit-transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); transition: color 0.175s cubic-bezier(0.215, 0.61, 0.355, 1); color: #4EAACC; padding: 0 5px; text-decoration: none;\">\n                                            <img class=\"auto-width\" src=\"https://simple.com/email-images/icons/social-facebook.png\" style=\"width: auto; max-width: 100% !important; border: 0;\">\n                                          </a>\n                                          </a>\n                                        </td>\n                                      </tr>\n                                    </tbody>\n                                  </table>\n                                </td>\n                              </tr>\n                            </tbody>\n                          </table>\n                        </td>\n                      </tr>\n                    </tbody>\n                  </table>\n                  <table class=\"\" align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\">\n                    <tbody>\n                      <tr>\n                        <td align=\"center\" class=\"email-disclaimer copy\" style='font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; padding-left: 50px; padding-right: 50px; padding-top: 15px; padding-bottom: 15px;'>\n                          <p style='margin-bottom: 15px; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-weight: 400; font-size: 11px; line-height: 1.5; color: #788991; margin-top: 0;'>This email was sent to <strong style='font-weight: 500; font-family: \"Avenir Next\", \"Avenir\", \"Helvetica\", sans-serif !important; font-size: 11px; color: #788991; margin-top: 0;'>{{ to }}</strong>.</p>\n                        </td>\n                      </tr>\n                    </tbody>\n                  </table>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</body>\n\n</html>",body_only="{{{body}}}";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _index=__webpack_require__(7);Object.defineProperty(exports,'Renderer',{enumerable:!0,get:function a(){return _interopRequireDefault(_index).default}});function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ })
/******/ ]);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(422);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-components-List-___style__container___a6zfK {\n  position: absolute;\n  top: 56px;\n  left: 0px;\n  bottom: 0;\n  width: 320px;\n  background-color: rgba(0, 0, 0, 0.02);\n  overflow: auto; }\n  .src-components-List-___style__container___a6zfK a {\n    text-decoration: none;\n    color: inherit; }\n\n.src-components-List-___style__menu___oT2ag {\n  padding: 16px 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n  display: flex;\n  align-items: center;\n  justify-content: space-between; }\n\n.src-components-List-___style__box___2UTFb {\n  font-size: 14px;\n  padding: 16px 20px;\n  overflow: hidden;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n  cursor: pointer;\n  text-decoration: none;\n  color: inherit; }\n  .src-components-List-___style__box___2UTFb:hover, .src-components-List-___style__box___2UTFb.src-components-List-___style__active___11WWK {\n    background-color: rgba(0, 0, 0, 0.03); }\n  .src-components-List-___style__box___2UTFb h3 {\n    font-size: 18px;\n    margin: 0;\n    margin-bottom: 4px; }\n  .src-components-List-___style__box___2UTFb .src-components-List-___style__tags___zWZfa {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center; }\n    .src-components-List-___style__box___2UTFb .src-components-List-___style__tags___zWZfa .src-components-List-___style__date___18rhN {\n      margin-top: 2px;\n      margin-right: 6px; }\n    .src-components-List-___style__box___2UTFb .src-components-List-___style__tags___zWZfa .src-components-List-___style__tag___1w_in {\n      font-size: 10px;\n      background-color: #ddd;\n      padding: 3px 6px;\n      border-radius: 8px;\n      margin: 4px 3px 2px 0; }\n", ""]);

// exports
exports.locals = {
	"container": "src-components-List-___style__container___a6zfK",
	"menu": "src-components-List-___style__menu___oT2ag",
	"box": "src-components-List-___style__box___2UTFb",
	"active": "src-components-List-___style__active___11WWK",
	"tags": "src-components-List-___style__tags___zWZfa",
	"date": "src-components-List-___style__date___18rhN",
	"tag": "src-components-List-___style__tag___1w_in"
};

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dropdown__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Modal__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_convo__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sofia_ui__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sofia_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sofia_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_http_axios__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery($uuid: String) {\n  admins {\n    id\n    _id\n    first_name\n    last_name\n    email\n  }\n  conversation(_id:$uuid) {\n    id\n    _id\n    tags\n    assignedTo\n    last_message\n    user_conversations {\n      id\n      user {\n        id\n        _id\n        first_name\n        last_name\n        phone_number\n        email\n        messenger_id\n        clients {\n          id\n          _id\n          state\n          requests {\n            id\n            _id\n            state\n          }\n        }\n        tutors {\n          id\n          _id\n          photo\n          state\n          requests {\n            id\n            _id\n            state\n          }\n        }\n      }\n    }\n    messages(orderBy: "created_at", order: ASC) {\n      id\n      _id\n      user_uuid\n      user {\n        id\n        _id\n        first_name\n        last_name\n        phone_number\n        email\n      }\n      content\n      body\n      detailed_body\n      type\n    \tdetails\n      raw_input\n      provider\n      created_at\n    }\n  }\n}\n'],['\nquery($uuid: String) {\n  admins {\n    id\n    _id\n    first_name\n    last_name\n    email\n  }\n  conversation(_id:$uuid) {\n    id\n    _id\n    tags\n    assignedTo\n    last_message\n    user_conversations {\n      id\n      user {\n        id\n        _id\n        first_name\n        last_name\n        phone_number\n        email\n        messenger_id\n        clients {\n          id\n          _id\n          state\n          requests {\n            id\n            _id\n            state\n          }\n        }\n        tutors {\n          id\n          _id\n          photo\n          state\n          requests {\n            id\n            _id\n            state\n          }\n        }\n      }\n    }\n    messages(orderBy: "created_at", order: ASC) {\n      id\n      _id\n      user_uuid\n      user {\n        id\n        _id\n        first_name\n        last_name\n        phone_number\n        email\n      }\n      content\n      body\n      detailed_body\n      type\n    \tdetails\n      raw_input\n      provider\n      created_at\n    }\n  }\n}\n']),_templateObject2=_taggedTemplateLiteral(['\nmutation updateConversation($input: conversationMutation) {\n  updateConversation(input: $input) {\n    id\n    _id\n    tags\n  }\n}\n'],['\nmutation updateConversation($input: conversationMutation) {\n  updateConversation(input: $input) {\n    id\n    _id\n    tags\n  }\n}\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import { Link } from 'react-router-dom'
var QUERY=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject);var UPDATE_CONVERSATION=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject2);var Tag=function Tag(_ref){var name=_ref.name,tags=_ref.tags,uuid=_ref.uuid;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Mutation"],{mutation:UPDATE_CONVERSATION},function(update,_ref2){var data=_ref2.data;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.tag,tags.includes(name)&&__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.active),onClick:function onClick(e){var newTags=[].concat(_toConsumableArray(tags));tags.includes(name)?newTags.splice(tags.indexOf(name),1):newTags.push(name);update({variables:{input:{_id:uuid,tags:newTags}}});}},name);});};var Wrapper=function Wrapper(_ref3){var props=_objectWithoutProperties(_ref3,[]),uuid=_ref3.uuid;if(!uuid)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:QUERY,variables:{uuid:uuid},pollInterval:5000},function(_ref4){var loading=_ref4.loading,error=_ref4.error,data=_ref4.data,_refetch=_ref4.refetch;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Loading...');if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Error :(');};console.log('DATA',data);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MessageDetails,Object.assign({},props,data,{refetch:function refetch(){return _refetch();}}));});};var MessageDetails=function(_Component){_inherits(MessageDetails,_Component);function MessageDetails(props){var _this2=this;_classCallCheck(this,MessageDetails);var _this=_possibleConstructorReturn(this,(MessageDetails.__proto__||Object.getPrototypeOf(MessageDetails)).call(this,props));_this.newMessage=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(admin,user){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_12__store_http_axios__["a" /* default */].post('messaging',{body:_this.state.body,channel:_this.state.channel,admin_id:admin.id,user:user});case 2:_this.setState({body:''});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref5.apply(this,arguments);};}();_this.state={channel:'EMAIL',body:'',subject:'',detailsModal:true,detailed_body:'',attachments:[]};return _this;}_createClass(MessageDetails,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!Object(__WEBPACK_IMPORTED_MODULE_13_lodash__["isEqual"])(nextProps,this.props)||!Object(__WEBPACK_IMPORTED_MODULE_13_lodash__["isEqual"])(nextState,this.state);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,channel=_state.channel,subject=_state.subject,detailsModal=_state.detailsModal,detailed_body=_state.detailed_body,attachments=_state.attachments;var _props=this.props,_props$conversation=_props.conversation,messages=_props$conversation.messages,tags=_props$conversation.tags,user_conversations=_props$conversation.user_conversations,admins=_props.admins,refetch=_props.refetch;console.log("ATTATCH",attachments);var user=user_conversations[0].user;var channels=[];if(user.email)channels.push({label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_9__utils_convo__["a" /* channelLogo */])("EMAIL"),' Email'),value:"EMAIL"});if(user.phone_number)channels.push({label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_9__utils_convo__["a" /* channelLogo */])("SMS"),' SMS'),value:"SMS"});if(user.messenger_id)channels.push({label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_9__utils_convo__["a" /* channelLogo */])("MESSENGER"),' Messenger'),value:"MESSENGER"});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Modal__["a" /* default */],{title:subject,close:function close(){return _this3.setState({detailsModal:true});},hide:detailsModal},!!attachments&&!!attachments.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.attachments},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Pi\xE8ces jointes'),attachments.map(function(_ref6,key){var url=_ref6.url,name=_ref6.name;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{key:key,href:url,target:'_blank'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,name));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a['danger-zone'],dangerouslySetInnerHTML:{__html:detailed_body}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.split},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.messages},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.scroll},messages.map(function(_ref7){var body=_ref7.body,user=_ref7.user,created_at=_ref7.created_at,provider=_ref7.provider,detailed_body=_ref7.detailed_body,details=_ref7.details,raw_input=_ref7.raw_input;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.message},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.title},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,provider!=="ADMIN"?user.first_name||user.email:"Sofia - Admin"),' \u2022 ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_5_moment___default()(created_at).format("YY-MM-DD hh:mm"),' \xA0',Object(__WEBPACK_IMPORTED_MODULE_9__utils_convo__["a" /* channelLogo */])(provider))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:body.replace(/(?:\r\n|\r|\n)/g,'<br />')}}),provider==="EMAIL"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.view},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_sofia_ui__["Button"],{color:'blue',small:true,onClick:function onClick(){console.log('DETAILS',details);_this3.setState({subject:details?details.subject:raw_input.subject,detailsModal:false,detailed_body:detailed_body,attachments:details.attachments});}},'Voir le message original')));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.new},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{rows:'4',value:this.state.body,onChange:function onChange(e){return _this3.setState({body:e.target.value});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.channel},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Dropdown__["a" /* default */],{top:true,label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_9__utils_convo__["a" /* channelLogo */])(channel)),options:channels,onSelect:function onSelect(channel){return _this3.setState({channel:channel});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.send,onClick:function onClick(){_this3.newMessage(admins[0],user);setTimeout(function(){console.log('REFETCH');refetch();},500);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'far fa-paper-plane'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.details},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'D\xE9tails'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.tags},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag,{name:'New',tags:tags,uuid:this.props.uuid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag,{name:'Awaiting Data',tags:tags,uuid:this.props.uuid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag,{name:'Need followup',tags:tags,uuid:this.props.uuid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag,{name:'Urgent',tags:tags,uuid:this.props.uuid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag,{name:'Closed',tags:tags,uuid:this.props.uuid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag,{name:'Spam',tags:tags,uuid:this.props.uuid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag,{name:'old',tags:tags,uuid:this.props.uuid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag,{name:'Development',tags:tags,uuid:this.props.uuid})),user&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.dbox},user.first_name&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,user.first_name,' ',user.last_name)),user.email&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,user.email,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),user.phone_number&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,user.phone_number,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),user.messenger_id&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,user.messenger_id,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{to:'/users/'+(user.tutors.length?'tutor':'client')+'/'+user._id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_sofia_ui__["Button"],{className:__WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.button,color:'dark',small:true},'Voir le profil'))))));}}]);return MessageDetails;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Wrapper);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(425);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-containers-messages-Details-___style__split___2EP3w {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-start;\n  height: 100%;\n  z-index: 0; }\n\n.src-containers-messages-Details-___style__messages___3UxOO {\n  position: relative;\n  background-color: #fff;\n  width: calc(100% - 280px); }\n  .src-containers-messages-Details-___style__messages___3UxOO .src-containers-messages-Details-___style__scroll___rKQbS {\n    position: relative;\n    overflow: auto;\n    height: 100%;\n    padding: 20px 36px 160px; }\n  .src-containers-messages-Details-___style__messages___3UxOO .src-containers-messages-Details-___style__message___1GOxy {\n    padding: 12px 0; }\n    .src-containers-messages-Details-___style__messages___3UxOO .src-containers-messages-Details-___style__message___1GOxy .src-containers-messages-Details-___style__title___2IFan {\n      margin-bottom: 4px; }\n    .src-containers-messages-Details-___style__messages___3UxOO .src-containers-messages-Details-___style__message___1GOxy b {\n      font-weight: 700; }\n    .src-containers-messages-Details-___style__messages___3UxOO .src-containers-messages-Details-___style__message___1GOxy .src-containers-messages-Details-___style__view___W0Q6H {\n      margin-top: 8px; }\n  .src-containers-messages-Details-___style__messages___3UxOO .src-containers-messages-Details-___style__new___SxYVT {\n    position: absolute;\n    bottom: 20px;\n    left: 36px;\n    right: 36px; }\n    .src-containers-messages-Details-___style__messages___3UxOO .src-containers-messages-Details-___style__new___SxYVT .src-containers-messages-Details-___style__channel___2orY- {\n      position: absolute;\n      top: 14px;\n      left: 18px;\n      font-size: 24px; }\n    .src-containers-messages-Details-___style__messages___3UxOO .src-containers-messages-Details-___style__new___SxYVT .src-containers-messages-Details-___style__send___2y-By {\n      position: absolute;\n      top: 14px;\n      right: 18px;\n      font-size: 24px;\n      cursor: pointer; }\n    .src-containers-messages-Details-___style__messages___3UxOO .src-containers-messages-Details-___style__new___SxYVT textarea {\n      width: 100%;\n      max-width: 100%;\n      padding: 16px 46px; }\n\n.src-containers-messages-Details-___style__danger-zone___1r4vO {\n  padding: 20px 30px;\n  max-height: 620px;\n  overflow: auto; }\n\n.src-containers-messages-Details-___style__details___3fyOi {\n  position: relative;\n  min-width: 280px;\n  padding: 18px 20px; }\n  .src-containers-messages-Details-___style__details___3fyOi h3 {\n    margin-bottom: 15px; }\n  .src-containers-messages-Details-___style__details___3fyOi .src-containers-messages-Details-___style__tags___31e8J {\n    display: flex;\n    flex-wrap: wrap; }\n    .src-containers-messages-Details-___style__details___3fyOi .src-containers-messages-Details-___style__tags___31e8J .src-containers-messages-Details-___style__tag___1SJo1 {\n      background-color: #ddd;\n      padding: 6px 10px;\n      border-radius: 14px;\n      margin-right: 8px;\n      margin-bottom: 6px;\n      font-size: 14px; }\n      .src-containers-messages-Details-___style__details___3fyOi .src-containers-messages-Details-___style__tags___31e8J .src-containers-messages-Details-___style__tag___1SJo1.src-containers-messages-Details-___style__active___2WPjT {\n        background-color: #FFC837;\n        color: #fff; }\n      .src-containers-messages-Details-___style__details___3fyOi .src-containers-messages-Details-___style__tags___31e8J .src-containers-messages-Details-___style__tag___1SJo1:hover {\n        background-color: #bbb;\n        cursor: pointer; }\n  .src-containers-messages-Details-___style__details___3fyOi .src-containers-messages-Details-___style__dbox___s-moL {\n    background-color: #fff;\n    border-radius: 4px;\n    margin: 10px 0 20px;\n    padding: 20px 24px; }\n    .src-containers-messages-Details-___style__details___3fyOi .src-containers-messages-Details-___style__dbox___s-moL .src-containers-messages-Details-___style__button___YPDNj {\n      margin-top: 10px; }\n\n.src-containers-messages-Details-___style__attachments___IqP5N {\n  padding: 20px 30px;\n  border-bottom: 1px solid #ddd; }\n  .src-containers-messages-Details-___style__attachments___IqP5N h5 {\n    margin-bottom: 10px; }\n  .src-containers-messages-Details-___style__attachments___IqP5N ul {\n    margin: 0; }\n  .src-containers-messages-Details-___style__attachments___IqP5N li {\n    list-style: none; }\n  .src-containers-messages-Details-___style__attachments___IqP5N a span {\n    border: 1px solid #ddd;\n    border-radius: 3px;\n    margin-bottom: 6px;\n    margin-right: 4px;\n    padding: 6px 12px; }\n    .src-containers-messages-Details-___style__attachments___IqP5N a span:hover {\n      opacity: 0.6; }\n", ""]);

// exports
exports.locals = {
	"split": "src-containers-messages-Details-___style__split___2EP3w",
	"messages": "src-containers-messages-Details-___style__messages___3UxOO",
	"scroll": "src-containers-messages-Details-___style__scroll___rKQbS",
	"message": "src-containers-messages-Details-___style__message___1GOxy",
	"title": "src-containers-messages-Details-___style__title___2IFan",
	"view": "src-containers-messages-Details-___style__view___W0Q6H",
	"new": "src-containers-messages-Details-___style__new___SxYVT",
	"channel": "src-containers-messages-Details-___style__channel___2orY-",
	"send": "src-containers-messages-Details-___style__send___2y-By",
	"danger-zone": "src-containers-messages-Details-___style__danger-zone___1r4vO",
	"details": "src-containers-messages-Details-___style__details___3fyOi",
	"tags": "src-containers-messages-Details-___style__tags___31e8J",
	"tag": "src-containers-messages-Details-___style__tag___1SJo1",
	"active": "src-containers-messages-Details-___style__active___2WPjT",
	"dbox": "src-containers-messages-Details-___style__dbox___s-moL",
	"button": "src-containers-messages-Details-___style__button___YPDNj",
	"attachments": "src-containers-messages-Details-___style__attachments___IqP5N"
};

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_http_axios__ = __webpack_require__(78);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Auth=function(_Component){_inherits(Auth,_Component);function Auth(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Auth);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Auth.__proto__||Object.getPrototypeOf(Auth)).call.apply(_ref,[this].concat(args))),_this),_this.state={email:"",password:""},_this.login=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var _this$state,email,password;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();_this$state=_this.state,email=_this$state.email,password=_this$state.password;_context.prev=2;_context.next=5;return __WEBPACK_IMPORTED_MODULE_3__store_http_axios__["a" /* default */].post('/auth/admin/login',{email:email,password:password});case 5:window.location.reload();_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](2);console.error(_context.t0);case 11:case'end':return _context.stop();}}},_callee,_this2,[[2,8]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Auth,[{key:'render',value:function render(){var _this3=this;var _state=this.state,email=_state.email,password=_state.password;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'auth-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:this.login},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{name:'email',type:'text',placeholder:'Email',onChange:function onChange(e){return _this3.setState({email:e.target.value});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{name:'password',type:'password',placeholder:'Password',onChange:function onChange(e){return _this3.setState({password:e.target.value});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{disabled:!email.length&&!password.length},'Login'))));}}]);return Auth;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Auth);

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Messages=function(_Component){_inherits(Messages,_Component);function Messages(){_classCallCheck(this,Messages);return _possibleConstructorReturn(this,(Messages.__proto__||Object.getPrototypeOf(Messages)).apply(this,arguments));}_createClass(Messages,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://metabase.stapp.ca',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',null,'Metabase (view statistics)')),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://app.forestadmin.com',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',null,'Forest Admin (edit database)')),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://app.logrocket.com/sofia-tutors/website',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',null,'LogRocket (support + debug)')));}}]);return Messages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Messages);

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Messages=function(_Component){_inherits(Messages,_Component);function Messages(){_classCallCheck(this,Messages);return _possibleConstructorReturn(this,(Messages.__proto__||Object.getPrototypeOf(Messages)).apply(this,arguments));}_createClass(Messages,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Settings'));}}]);return Messages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Messages);

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_requests_List__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_requests_Details__ = __webpack_require__(436);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n{\n  requests(order: DESC, orderBy: "created_at") {\n    id\n    _id\n    state\n    started\n    start_date\n    completed\n    started\n    ended\n    request_students {\n      id\n      student {\n        id\n        _id\n        first_name\n        last_name\n      }\n    }\n    tutor {\n      id\n      _id\n      user {\n        id\n        _id\n        first_name\n        last_name\n      }\n    }\n  }\n}\n'],['\n{\n  requests(order: DESC, orderBy: "created_at") {\n    id\n    _id\n    state\n    started\n    start_date\n    completed\n    started\n    ended\n    request_students {\n      id\n      student {\n        id\n        _id\n        first_name\n        last_name\n      }\n    }\n    tutor {\n      id\n      _id\n      user {\n        id\n        _id\n        first_name\n        last_name\n      }\n    }\n  }\n}\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var QUERY=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject);var Requests=function(_Component){_inherits(Requests,_Component);function Requests(){_classCallCheck(this,Requests);return _possibleConstructorReturn(this,(Requests.__proto__||Object.getPrototypeOf(Requests)).apply(this,arguments));}_createClass(Requests,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messages-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messages-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],{query:QUERY,variables:{cursor:0}},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data,fetchMore=_ref.fetchMore;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Loading...');if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Error :(');};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_requests_List__["a" /* default */],{requests:data.requests,active:_this2.props.match.params.uuid});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_requests_Details__["a" /* default */],{uuid:this.props.match.params.uuid}))));}}]);return Requests;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Requests);

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_List__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dropdown__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RequestsList=function(_Component){_inherits(RequestsList,_Component);function RequestsList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RequestsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RequestsList.__proto__||Object.getPrototypeOf(RequestsList)).call.apply(_ref,[this].concat(args))),_this),_this.state={filter:'Default'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RequestsList,[{key:'render',value:function render(){var _this2=this;var filter=this.state.filter;var requests=this.props.requests.filter(function(_ref2){var state=_ref2.state,ended=_ref2.ended;if(filter==="EN-COURS")return state==="ACCEPTEE"&&!ended;if(filter==="Default")return state==="ENVOYEE"||state==="ACCEPTEE";return filter==="ALL"||state===filter;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_List__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Dropdown__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-filter'}),' ',filter),options:[{label:"Default",value:"Default"},{label:"En cours",value:"EN-COURS"},{label:"All",value:"ALL"},{label:"Envoyée",value:"ENVOYEE"},{label:"Acceptée",value:"ACCEPTEE"},{label:"Annulée",value:"ANNULEE"}],onSelect:function onSelect(filter){return _this2.setState({filter:filter});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,requests.length)),list:requests.map(function(_ref3){var _id=_ref3._id,state=_ref3.state,request_students=_ref3.request_students,tutor=_ref3.tutor;return{link:'/requests/'+_id,active:_id===_this2.props.active,title:request_students.map(function(_ref4,i){var first_name=_ref4.student.first_name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,first_name));}),body:tutor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,tutor.user.first_name,' ',tutor.user.last_name)),footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'state '+state},state)};})}));}}]);return RequestsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RequestsList);

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Tabs___ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabs_general__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabs_sessions__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tabs_payment__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tabs_tutors__ = __webpack_require__(443);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RequestDetails=function(_Component){_inherits(RequestDetails,_Component);function RequestDetails(){_classCallCheck(this,RequestDetails);return _possibleConstructorReturn(this,(RequestDetails.__proto__||Object.getPrototypeOf(RequestDetails)).apply(this,arguments));}_createClass(RequestDetails,[{key:'render',value:function render(){if(!this.props.uuid)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Tabs___["a" /* default */],{tabs:[{name:'General',content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tabs_general__["a" /* default */],{uuid:this.props.uuid})},{name:'Sessions',content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__tabs_sessions__["a" /* default */],{uuid:this.props.uuid})},{name:'Tutors',content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__tabs_tutors__["a" /* default */],{uuid:this.props.uuid})},{name:'Paiments',content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tabs_payment__["a" /* default */],{uuid:this.props.uuid})}]}));}}]);return RequestDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RequestDetails);

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(438);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-components-Tabs-___style__container___3BTtP {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  overflow: hidden; }\n\n.src-components-Tabs-___style__tabs___N3ued {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: #aaa;\n  margin: 0 20px; }\n  .src-components-Tabs-___style__tabs___N3ued .src-components-Tabs-___style__tab___37Knu {\n    padding: 8px 4px;\n    margin: 12px 10px;\n    cursor: pointer;\n    color: #5D5D5D; }\n    .src-components-Tabs-___style__tabs___N3ued .src-components-Tabs-___style__tab___37Knu.src-components-Tabs-___style__active___2XgDr {\n      font-weight: 900;\n      border-bottom: 2px solid #5D5D5D; }\n\n.src-components-Tabs-___style__content___3ntvZ {\n  position: relative;\n  height: calc(100% - 61px);\n  overflow: auto; }\n", ""]);

// exports
exports.locals = {
	"container": "src-components-Tabs-___style__container___3BTtP",
	"tabs": "src-components-Tabs-___style__tabs___N3ued",
	"tab": "src-components-Tabs-___style__tab___37Knu",
	"active": "src-components-Tabs-___style__active___2XgDr",
	"content": "src-components-Tabs-___style__content___3ntvZ"
};

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sofia_ui__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sofia_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sofia_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery Request($uuid: String) {\n  subjects {\n    id\n    _id\n    name\n  }\n  request(_id: $uuid) {\n    id\n    _id\n    state\n    started\n    start_date\n    nbr_sessions\n    nbr_sessions_week\n    tutor_price\n    parent_price\n    sofia_price\n    address\n    precision_location\n    survey\n    show_survey\n    completed\n    submitted\n    validated\n    confirmed\n    started\n    ended\n    canceled\n    admin_notes\n    client_notes\n    tutor_notes\n    description\n    avaibilitys {\n      id\n      day\n      start\n      end\n    }\n    sessions {\n      id\n      _id\n      state\n      number\n      date\n      state\n      time_begin\n      time_end\n    }\n    request_students {\n      id\n      student {\n        id\n        _id\n        first_name\n        last_name\n        sublevel\n        level {\n          id\n          _id\n          name\n        }\n      }\n      subjects_uuids\n    }\n    tutor {\n      id\n      _id\n      user {\n\t\t\t\tid\n\t\t\t\t_id\n        first_name\n        last_name\n      }\n    }\n\t\tclient {\n\t\t\tid\n\t\t\t_id\n\t\t\tuser {\n\t\t\t\tid\n\t\t\t\t_id\n\t\t\t\tfirst_name\n\t\t\t\tlast_name\n\t\t\t\temail\n\t\t\t\tphone_number\n\t\t\t}\n\t\t}\n  }\n}\n'],['\nquery Request($uuid: String) {\n  subjects {\n    id\n    _id\n    name\n  }\n  request(_id: $uuid) {\n    id\n    _id\n    state\n    started\n    start_date\n    nbr_sessions\n    nbr_sessions_week\n    tutor_price\n    parent_price\n    sofia_price\n    address\n    precision_location\n    survey\n    show_survey\n    completed\n    submitted\n    validated\n    confirmed\n    started\n    ended\n    canceled\n    admin_notes\n    client_notes\n    tutor_notes\n    description\n    avaibilitys {\n      id\n      day\n      start\n      end\n    }\n    sessions {\n      id\n      _id\n      state\n      number\n      date\n      state\n      time_begin\n      time_end\n    }\n    request_students {\n      id\n      student {\n        id\n        _id\n        first_name\n        last_name\n        sublevel\n        level {\n          id\n          _id\n          name\n        }\n      }\n      subjects_uuids\n    }\n    tutor {\n      id\n      _id\n      user {\n\t\t\t\tid\n\t\t\t\t_id\n        first_name\n        last_name\n      }\n    }\n\t\tclient {\n\t\t\tid\n\t\t\t_id\n\t\t\tuser {\n\t\t\t\tid\n\t\t\t\t_id\n\t\t\t\tfirst_name\n\t\t\t\tlast_name\n\t\t\t\temail\n\t\t\t\tphone_number\n\t\t\t}\n\t\t}\n  }\n}\n']),_templateObject2=_taggedTemplateLiteral(['\nmutation updateRequest($input: requestMutation) {\n  updateRequest(input: $input) {\n    state\n    id\n    _id\n    admin_notes\n    client_notes\n    description\n    tutor_notes\n  }\n}\n'],['\nmutation updateRequest($input: requestMutation) {\n  updateRequest(input: $input) {\n    state\n    id\n    _id\n    admin_notes\n    client_notes\n    description\n    tutor_notes\n  }\n}\n']),_templateObject3=_taggedTemplateLiteral(['\nmutation updateSession($input: sessionMutation) {\n  updateSession(input: $input) {\n    state\n    id\n    _id\n  }\n}\n'],['\nmutation updateSession($input: sessionMutation) {\n  updateSession(input: $input) {\n    state\n    id\n    _id\n  }\n}\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var QUERY=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject);var UPDATE=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject2);var UPDATE_SESSION=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject3);var dayToString=function dayToString(day){switch(parseInt(day,10)){case 0:return"Sunday";case 1:return"Monday";case 2:return"Tuesday";case 3:return"Wednesday";case 4:return"Thursday";case 5:return"Friday";case 6:return"Saturday";default:return"Invalid";}};var RequestDetails=function(_Component){_inherits(RequestDetails,_Component);function RequestDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RequestDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RequestDetails.__proto__||Object.getPrototypeOf(RequestDetails)).call.apply(_ref,[this].concat(args))),_this),_this.state={modal:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RequestDetails,[{key:'render',value:function render(){var _this2=this;if(!this.props.uuid)return null;var modal=this.state.modal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],{query:QUERY,variables:{uuid:this.props.uuid}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,fetchMore=_ref2.fetchMore;if(loading)return null;if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Error :(');};var _data$request=data.request,request_students=_data$request.request_students,state=_data$request.state,start_date=_data$request.start_date,nbr_sessions=_data$request.nbr_sessions,nbr_sessions_week=_data$request.nbr_sessions_week,tutor=_data$request.tutor,avaibilitys=_data$request.avaibilitys,sessions=_data$request.sessions,tutor_price=_data$request.tutor_price,parent_price=_data$request.parent_price,sofia_price=_data$request.sofia_price,address=_data$request.address,precision_location=_data$request.precision_location,client=_data$request.client,survey=_data$request.survey,show_survey=_data$request.show_survey,completed=_data$request.completed,submitted=_data$request.submitted,validated=_data$request.validated,confirmed=_data$request.confirmed,started=_data$request.started,ended=_data$request.ended,canceled=_data$request.canceled,client_notes=_data$request.client_notes,tutor_notes=_data$request.tutor_notes,description=_data$request.description,admin_notes=_data$request.admin_notes,id=_data$request.id,_id=_data$request._id;var optimisticRes={__typename:"Request",id:id,_id:_id,state:state,admin_notes:admin_notes,client_notes:client_notes,description:description,tutor_notes:tutor_notes};var subjectsByUuid=Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["keyBy"])(data.subjects,'_id');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref3){var data=_ref3.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__styles_scss___default.a.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split-larger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Students'),request_students.map(function(_ref4,key){var student=_ref4.student,subjects_uuids=_ref4.subjects_uuids;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,student.first_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,student.level.name,' \u2022 ',student.sublevel),subjects_uuids.map(function(_id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:_id},subjectsByUuid[_id].name);}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Tutor'),tutor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,tutor.user.first_name,' ',tutor.user.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{to:'/users/tutor/'+tutor.user._id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_sofia_ui__["Button"],{small:true,color:'dark',inline:true},'View profile'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_sofia_ui__["Button"],{small:true,color:'blue',onClick:function onClick(){return _this2.setState({modal:'changeTutor'});}},'Change'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Modal__["a" /* default */],{title:'Select tutor',close:function close(){return _this2.setState({modal:null});},hide:modal!=='changeTutor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref5){var data=_ref5.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'small',defaultValue:tutor?tutor.id:'',placeholder:'ID',onChange:function onChange(e){return updateRequest({variables:{input:{_id:_this2.props.uuid,tutor_id:e.target.value.length?e.target.value:null}}});}});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref6){var data=_ref6.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'small',defaultValue:tutor?tutor._id:'',placeholder:'UUID',onChange:function onChange(e){return updateRequest({variables:{input:{_id:_this2.props.uuid,tutor_uuid:e.target.value.length?e.target.value:null}}});}});}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Client'),client&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,client.user.first_name,' ',client.user.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,client.user.email,' \u2022 ',client.user.phone_number),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{to:'/users/client/'+client.user._id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_sofia_ui__["Button"],{small:true,color:'dark',inline:true},'View profile')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Notes admin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{value:admin_notes&&admin_notes.length?admin_notes:'',rows:10,onChange:function onChange(e){updateRequest({variables:{input:{_id:_this2.props.uuid,admin_notes:e.target.value}},optimisticResponse:{updateRequest:Object.assign({},optimisticRes,{admin_notes:e.target.value})}});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Note pour le client'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{value:client_notes&&client_notes.length?client_notes:'',rows:2,onChange:function onChange(e){return updateRequest({variables:{input:{_id:_this2.props.uuid,client_notes:e.target.value}},optimisticResponse:{updateRequest:Object.assign({},optimisticRes,{client_notes:e.target.value})}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Uniquement visible dans la demande pour client'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Note pour le tuteur'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{value:tutor_notes&&tutor_notes.length?tutor_notes:'',rows:2,onChange:function onChange(e){return updateRequest({variables:{input:{_id:_this2.props.uuid,tutor_notes:e.target.value}},optimisticResponse:{updateRequest:Object.assign({},optimisticRes,{tutor_notes:e.target.value})}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Uniquement visible dans la demande pour tuteur')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'D\xE9tails du parent'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{value:description&&description.length?description:'',rows:2,onBlur:function onBlur(e){return updateRequest({variables:{input:{_id:_this2.props.uuid,description:e.target.value}},optimisticResponse:{updateRequest:Object.assign({},optimisticRes,{description:e.target.value})}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Visible par tout le monde')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Avaibilities'),avaibilitys.map(function(_ref7){var day=_ref7.day,start=_ref7.start,end=_ref7.end;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,dayToString(day)),' ',start.replace(/:00$/,''),' - ',end.replace(/:00$/,''));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'States'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex f-align-center mb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref8){var data=_ref8.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'s1',defaultChecked:completed,onChange:function onChange(e){updateRequest({variables:{input:{_id:_this2.props.uuid,completed:e.target.checked}}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'s1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),' Nous avons re\xE7u la demande'));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref9){var data=_ref9.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'s2',defaultChecked:submitted,onChange:function onChange(e){updateRequest({variables:{input:{_id:_this2.props.uuid,submitted:e.target.checked}}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'s2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),' Demande envoy\xE9e \xE0 des tuteurs'));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref10){var data=_ref10.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'s3',defaultChecked:validated,onChange:function onChange(e){updateRequest({variables:{input:{_id:_this2.props.uuid,validated:e.target.checked}}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'s3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),' Tuteur trouv\xE9'));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref11){var data=_ref11.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'s4',defaultChecked:confirmed,onChange:function onChange(e){updateRequest({variables:{input:{_id:_this2.props.uuid,confirmed:e.target.checked}}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'s4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),' Premi\xE8re s\xE9ance valid\xE9e'));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex f-align-center mb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref12){var data=_ref12.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'s5',defaultChecked:started,onChange:function onChange(e){updateRequest({variables:{input:{_id:_this2.props.uuid,started:e.target.checked}}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'s5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),' S\xE9ances commenc\xE9es'));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref13){var data=_ref13.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'s6',defaultChecked:ended,onChange:function onChange(e){updateRequest({variables:{input:{_id:_this2.props.uuid,ended:e.target.checked}}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'s6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),' S\xE9ances termin\xE9es'));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref14){var data=_ref14.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'s6',defaultChecked:canceled,onChange:function onChange(e){updateRequest({variables:{input:{_id:_this2.props.uuid,canceled:e.target.checked}}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'s6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),' Demande annul\xE9e'));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref15){var data=_ref15.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'State: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'small',defaultValue:state,onChange:function onChange(e){return updateRequest({variables:{input:{_id:_this2.props.uuid,state:e.target.value}}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'ENVOYEE'},'ENVOYEE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'ACCEPTEE'},'ACCEPTEE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'ANNULEE'},'ANNULEE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Nbr sessions: '),' ',nbr_sessions,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Nbr sessions / week: '),' ',nbr_sessions_week,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Start date: '),' ',__WEBPACK_IMPORTED_MODULE_4_moment___default()(start_date).format("DD/MM/YYYY"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));});});}}]);return RequestDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RequestDetails);

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-containers-requests-Details-tabs-___styles__container___wZSOR {\n  margin: 10px 28px;\n  overflow: auto; }\n\n.src-containers-requests-Details-tabs-___styles__map___7EZHO {\n  position: relative;\n  height: 0;\n  padding-bottom: 56.5%; }\n\n.src-containers-requests-Details-tabs-___styles__listBox___1BjRx {\n  width: calc(50% - 20px);\n  margin-right: 20px; }\n  .src-containers-requests-Details-tabs-___styles__listBox___1BjRx:nth-child(2n) {\n    margin-right: 0;\n    width: 50%; }\n\n.src-containers-requests-Details-tabs-___styles__tab___3K3nV {\n  margin-left: 10px;\n  opacity: 0.6;\n  cursor: pointer; }\n  .src-containers-requests-Details-tabs-___styles__tab___3K3nV.src-containers-requests-Details-tabs-___styles__active___3dKbV {\n    opacity: 1; }\n\n.src-containers-requests-Details-tabs-___styles__invalid___2tJ1f {\n  color: var(--red); }\n\n.src-containers-requests-Details-tabs-___styles__sessionList___1UpnH {\n  margin-right: 320px; }\n\n.src-containers-requests-Details-tabs-___styles__sessionDetails___37RDZ {\n  position: fixed;\n  width: 300px;\n  right: 30px;\n  top: 127px;\n  bottom: 0;\n  overflow: auto; }\n", ""]);

// exports
exports.locals = {
	"container": "src-containers-requests-Details-tabs-___styles__container___wZSOR",
	"map": "src-containers-requests-Details-tabs-___styles__map___7EZHO",
	"listBox": "src-containers-requests-Details-tabs-___styles__listBox___1BjRx",
	"tab": "src-containers-requests-Details-tabs-___styles__tab___3K3nV",
	"active": "src-containers-requests-Details-tabs-___styles__active___3dKbV",
	"invalid": "src-containers-requests-Details-tabs-___styles__invalid___2tJ1f",
	"sessionList": "src-containers-requests-Details-tabs-___styles__sessionList___1UpnH",
	"sessionDetails": "src-containers-requests-Details-tabs-___styles__sessionDetails___37RDZ"
};

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery Request($uuid: String) {\n  subjects {\n    id\n    _id\n    name\n  }\n  request(_id: $uuid) {\n    id\n    _id\n    state\n    started\n    start_date\n    nbr_sessions\n    nbr_sessions_week\n    tutor_price\n    parent_price\n    sofia_price\n    address\n    precision_location\n    avaibilitys {\n      id\n      day\n      start\n      end\n    }\n    sessions {\n      ','\n    }\n    request_students {\n      id\n      subjects_uuids\n      student {\n        id\n        _id\n        first_name\n        last_name\n        sublevel\n        level {\n          id\n          _id\n          name\n        }\n      }\n    }\n    tutor {\n      id\n      _id\n      user {\n        id\n        _id\n        first_name\n        last_name\n      }\n    }\n  }\n}\n'],['\nquery Request($uuid: String) {\n  subjects {\n    id\n    _id\n    name\n  }\n  request(_id: $uuid) {\n    id\n    _id\n    state\n    started\n    start_date\n    nbr_sessions\n    nbr_sessions_week\n    tutor_price\n    parent_price\n    sofia_price\n    address\n    precision_location\n    avaibilitys {\n      id\n      day\n      start\n      end\n    }\n    sessions {\n      ','\n    }\n    request_students {\n      id\n      subjects_uuids\n      student {\n        id\n        _id\n        first_name\n        last_name\n        sublevel\n        level {\n          id\n          _id\n          name\n        }\n      }\n    }\n    tutor {\n      id\n      _id\n      user {\n        id\n        _id\n        first_name\n        last_name\n      }\n    }\n  }\n}\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation($input: sessionMutation) {\n    addSession(input: $input) {\n      ','\n    }\n  }\n'],['\n  mutation($input: sessionMutation) {\n    addSession(input: $input) {\n      ','\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\nmutation stopSession($input: sessionMutation!) {\n  stopSession(input: $input) {\n    ','\n  }\n}\n'],['\nmutation stopSession($input: sessionMutation!) {\n  stopSession(input: $input) {\n    ','\n  }\n}\n']),_templateObject4=_taggedTemplateLiteral(['\nmutation updateSession($input: sessionMutation) {\n  updateSession(input: $input) {\n    ','\n  }\n}\n'],['\nmutation updateSession($input: sessionMutation) {\n  updateSession(input: $input) {\n    ','\n  }\n}\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SESSION='\n  id\n  _id\n  state\n  number\n  date\n  state\n  time_begin\n  time_end\n  time_begin_forced\n  time_end_forced\n  payments {\n    id\n    _id\n    amount_tutor\n    amount_parent\n    amount_sofia\n    discount_tutor\n    discount_parent\n  }\n';var QUERY=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject,SESSION);var ADD_SESSION=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject2,SESSION);var STOP_SESSION=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject3,SESSION);var UPDATE_SESSION=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject4,SESSION);var dayToString=function dayToString(day){switch(parseInt(day,10)){case 0:return"Sunday";case 1:return"Monday";case 2:return"Tuesday";case 3:return"Wednesday";case 4:return"Thursday";case 5:return"Friday";case 6:return"Saturday";default:return"Invalid";}};var RequestDetails=function(_Component){_inherits(RequestDetails,_Component);function RequestDetails(props){_classCallCheck(this,RequestDetails);var _this=_possibleConstructorReturn(this,(RequestDetails.__proto__||Object.getPrototypeOf(RequestDetails)).call(this,props));_this.state={};_this.number=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.state=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.date=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.time_begin=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.time_end=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(RequestDetails,[{key:'render',value:function render(){var _this2=this;if(!this.props.uuid)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],{query:QUERY,variables:{uuid:this.props.uuid}},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data,fetchMore=_ref.fetchMore;if(loading)return null;if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Error :(');};var _data$request=data.request,id=_data$request.id,_id=_data$request._id,sessions=_data$request.sessions,tutor_price=_data$request.tutor_price,parent_price=_data$request.parent_price,sofia_price=_data$request.sofia_price,avaibilitys=_data$request.avaibilitys,start_date=_data$request.start_date,nbr_sessions=_data$request.nbr_sessions,nbr_sessions_week=_data$request.nbr_sessions_week,request_students=_data$request.request_students,address=_data$request.address,precision_location=_data$request.precision_location;var lastSession=sessions.length?sessions[sessions.length-1]:{};var subjectsByUuid=Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["keyBy"])(data.subjects,'_id');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__styles_scss___default.a.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__styles_scss___default.a.sessionList},sessions.map(function(_ref2,key){var id=_ref2.id,_id=_ref2._id,number=_ref2.number,date=_ref2.date,state=_ref2.state,time_begin=_ref2.time_begin,time_end=_ref2.time_end,time_begin_forced=_ref2.time_begin_forced,time_end_forced=_ref2.time_end_forced,payments=_ref2.payments;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Num\xE9ro de s\xE9ance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE_SESSION},function(updateSession,_ref3){var data=_ref3.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'small',defaultValue:number,placeholder:'Time begin',onBlur:function onBlur(e){return updateSession({variables:{input:{_id:_id,number:e.target.value}}});}});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'\xC9tat'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE_SESSION},function(updateSession,_ref4){var data=_ref4.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'small',defaultValue:state,onChange:function onChange(e){return updateSession({variables:{input:{_id:_id,state:e.target.value}}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'AVENIR'},'AVENIR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'TERMINEE-ET-A-PAYER'},'TERMINEE-ET-A-PAYER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'TERMINEE-ET-PAYEE'},'TERMINEE-ET-PAYEE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'ANNULEE'},'ANNULEE')));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Date de la s\xE9ance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE_SESSION},function(updateSession,_ref5){var data=_ref5.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'small',defaultValue:__WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format("YYYY-MM-DD"),placeholder:'Date',onBlur:function onBlur(e){var date=__WEBPACK_IMPORTED_MODULE_4_moment___default()(e.target.value);date=date.utcOffset(0);date=date.toISOString();updateSession({variables:{input:{_id:_id,date:date}}});},disabled:state==="ANNULEE"});}),state!=='ANNULEE'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Heure de d\xE9but'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE_SESSION},function(updateSession,_ref6){var data=_ref6.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'small',defaultValue:time_begin,placeholder:'Time begin',onBlur:function onBlur(e){return updateSession({variables:{input:{_id:_id,time_begin:e.target.value}}});},disabled:state==="TERMINEE-ET-PAYEE"});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Heure de fin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE_SESSION},function(updateSession,_ref7){var data=_ref7.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'small',defaultValue:time_end,placeholder:'Time end',onBlur:function onBlur(e){return updateSession({variables:{input:{_id:_id,time_end:e.target.value}}});},disabled:state==="TERMINEE-ET-PAYEE"});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Heure d\xE9but r\xE9elle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE_SESSION},function(updateSession,_ref8){var data=_ref8.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'small',defaultValue:time_begin_forced,placeholder:'Time begin forced',onBlur:function onBlur(e){return updateSession({variables:{input:{_id:_id,time_begin_forced:e.target.value}}});},disabled:state==="TERMINEE-ET-PAYEE"});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Heure de fin r\xE9elle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE_SESSION},function(updateSession,_ref9){var data=_ref9.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'small',defaultValue:time_end_forced,placeholder:'Time end forced',onBlur:function onBlur(e){return updateSession({variables:{input:{_id:_id,time_end_forced:e.target.value}}});},disabled:state==="TERMINEE-ET-PAYEE"});})))),state==="TERMINEE-ET-A-PAYER"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:STOP_SESSION},function(stopSession,_ref10){var data=_ref10.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){stopSession({variables:{input:{_id:_id,time_begin_forced:time_begin_forced,time_end_forced:time_end_forced}}});}},'Payer'));}),state==="TERMINEE-ET-PAYEE"&&payments[0]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Parent:'),' ',payments[0].amount_parent,'$',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Tuteur:'),' ',payments[0].amount_tutor,'$',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Sofia:'),' ',payments[0].amount_sofia,'$',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,id,' - ',_id))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:ADD_SESSION,update:function update(cache,_ref11){var addSession=_ref11.data.addSession;var _cache$readQuery=cache.readQuery({query:QUERY,variables:{uuid:_this2.props.uuid}}),request=_cache$readQuery.request;cache.writeQuery({query:QUERY,data:{request:Object.assign({},request,{sessions:[].concat(_toConsumableArray(request.sessions),[addSession])})}});}},function(addSession){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){e.preventDefault();addSession({variables:{input:{number:_this2.number.current.value,state:_this2.state.current.value,date:__WEBPACK_IMPORTED_MODULE_4_moment___default()(_this2.date.value).format("YYYY-MM-DD"),time_begin:_this2.time_begin.current.value,time_end:_this2.time_end.current.value,request_uuid:_id,request_id:id}}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Ajouter une s\xE9ance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Num\xE9ro de s\xE9ance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'number',type:'text',className:'small',value:lastSession.number+1||1,placeholder:'1',ref:_this2.number})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'\xC9tat'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'state',className:'small',defaultValue:'AVENIR',ref:_this2.state},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'AVENIR'},'AVENIR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'TERMINEE-ET-A-PAYER'},'TERMINEE-ET-A-PAYER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'TERMINEE-ET-PAYEE'},'TERMINEE-ET-PAYEE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'ANNULEE'},'ANNULEE')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Date de la s\xE9ance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'date',type:'date',className:'small',defaultValue:__WEBPACK_IMPORTED_MODULE_4_moment___default()(lastSession.date).add(7,'days').format("YYYY-MM-DD"),placeholder:'Date',ref:_this2.date}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Heure de d\xE9but'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'time_begin',type:'text',className:'small',defaultValue:lastSession.time_begin||'',placeholder:'Time begin',ref:_this2.time_begin})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Heure de fin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'time_end',type:'text',className:'small',defaultValue:lastSession.time_end||'',placeholder:'Time end',ref:_this2.time_end}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit'},'Ajouter'))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__styles_scss___default.a.sessionDetails},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Students'),request_students.map(function(_ref12,key){var student=_ref12.student,subjects_uuids=_ref12.subjects_uuids;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,student.first_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,student.level.name,' \u2022 ',student.sublevel),subjects_uuids.map(function(_id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:_id},subjectsByUuid[_id].name);}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Avaibilities'),avaibilitys.map(function(_ref13){var day=_ref13.day,start=_ref13.start,end=_ref13.end;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,dayToString(day)),' ',start.replace(/:00$/,''),' - ',end.replace(/:00$/,''));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,address),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),precision_location),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Nbr sessions: '),' ',nbr_sessions,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Nbr sessions / week: '),' ',nbr_sessions_week,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Start date: '),' ',__WEBPACK_IMPORTED_MODULE_4_moment___default()(start_date).format("DD/MM/YYYY"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Prix'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Tuteur: '),' ',tutor_price,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Parent: '),' ',parent_price,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Sofia: '),' ',sofia_price)));});}}]);return RequestDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RequestDetails);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery Request($uuid: String) {\n  request(_id: $uuid) {\n    id\n    _id\n    tutor_price\n    parent_price\n    sofia_price\n  }\n}\n'],['\nquery Request($uuid: String) {\n  request(_id: $uuid) {\n    id\n    _id\n    tutor_price\n    parent_price\n    sofia_price\n  }\n}\n']),_templateObject2=_taggedTemplateLiteral(['\nmutation updateRequest($input: requestMutation) {\n  updateRequest(input: $input) {\n    state\n    id\n    _id\n  }\n}\n'],['\nmutation updateRequest($input: requestMutation) {\n  updateRequest(input: $input) {\n    state\n    id\n    _id\n  }\n}\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var QUERY=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject);var UPDATE=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject2);var RequestDetails=function(_Component){_inherits(RequestDetails,_Component);function RequestDetails(){_classCallCheck(this,RequestDetails);return _possibleConstructorReturn(this,(RequestDetails.__proto__||Object.getPrototypeOf(RequestDetails)).apply(this,arguments));}_createClass(RequestDetails,[{key:'render',value:function render(){var _this2=this;if(!this.props.uuid)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],{query:QUERY,variables:{uuid:this.props.uuid}},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data,fetchMore=_ref.fetchMore;if(loading)return null;if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Error :(');};var _data$request=data.request,tutor_price=_data$request.tutor_price,parent_price=_data$request.parent_price,sofia_price=_data$request.sofia_price;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__styles_scss___default.a.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref2){var data=_ref2.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'small',defaultValue:parent_price,placeholder:'parent_price',onChange:function onChange(e){return updateRequest({variables:{input:{_id:_this2.props.uuid,parent_price:e.target.value}}});}});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref3){var data=_ref3.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'small',defaultValue:tutor_price,placeholder:'tutor_price',onChange:function onChange(e){return updateRequest({variables:{input:{_id:_this2.props.uuid,tutor_price:e.target.value}}});}});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Mutation"],{mutation:UPDATE},function(updateRequest,_ref4){var data=_ref4.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'small',defaultValue:sofia_price,placeholder:'tutor_price',onChange:function onChange(e){return updateRequest({variables:{input:{_id:_this2.props.uuid,sofia_price:e.target.value}}});}});})));});}}]);return RequestDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RequestDetails);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Map__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sofia_ui__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sofia_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sofia_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_distance__ = __webpack_require__(448);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery Request($uuid: String) {\n  request(_id: $uuid) {\n    id\n    _id\n    location\n    tutor {\n      id\n      _id\n    }\n    request_students {\n      id\n      subjects_uuids\n      level_uuid\n    }\n    request_tutors {\n      ','\n    }\n  }\n}\n'],['\nquery Request($uuid: String) {\n  request(_id: $uuid) {\n    id\n    _id\n    location\n    tutor {\n      id\n      _id\n    }\n    request_students {\n      id\n      subjects_uuids\n      level_uuid\n    }\n    request_tutors {\n      ','\n    }\n  }\n}\n']),_templateObject2=_taggedTemplateLiteral(['\nquery TutorsQuery($search: Search) {\n  tutors (search: $search, first: 1000) {\n    id\n    _id\n    state\n    location\n    lang\n    user {\n      id\n      _id\n      first_name\n      last_name\n      email\n      phone_number\n    }\n    tutor_subject_levels {\n      id\n      level_uuid\n      subject_uuid\n      valid\n      level {\n        id\n        _id\n        name\n      }\n      subject {\n        id\n        _id\n        name\n      }\n    }\n  }\n}\n'],['\nquery TutorsQuery($search: Search) {\n  tutors (search: $search, first: 1000) {\n    id\n    _id\n    state\n    location\n    lang\n    user {\n      id\n      _id\n      first_name\n      last_name\n      email\n      phone_number\n    }\n    tutor_subject_levels {\n      id\n      level_uuid\n      subject_uuid\n      valid\n      level {\n        id\n        _id\n        name\n      }\n      subject {\n        id\n        _id\n        name\n      }\n    }\n  }\n}\n']),_templateObject3=_taggedTemplateLiteral(['\nmutation AddTutorToRequesr($input: request_tutorMutation) {\n  addRequest_tutor(input: $input) {\n    ','\n  }\n}\n'],['\nmutation AddTutorToRequesr($input: request_tutorMutation) {\n  addRequest_tutor(input: $input) {\n    ','\n  }\n}\n']),_templateObject4=_taggedTemplateLiteral(['\nmutation SendTutorToRequesr($input: request_tutorMutation) {\n  sendAddEmailRequest_tutor(input: $input) {\n    ','\n  }\n}\n'],['\nmutation SendTutorToRequesr($input: request_tutorMutation) {\n  sendAddEmailRequest_tutor(input: $input) {\n    ','\n  }\n}\n']),_templateObject5=_taggedTemplateLiteral(['\nmutation UpdateRequestTutor($input: request_tutorMutation) {\n  updateRequest_tutor(input: $input) {\n    ','\n  }\n}\n'],['\nmutation UpdateRequestTutor($input: request_tutorMutation) {\n  updateRequest_tutor(input: $input) {\n    ','\n  }\n}\n']),_templateObject6=_taggedTemplateLiteral(['\nmutation SelectTutorForRequest($input: request_tutorMutation) {\n  selectRequest_tutor(input: $input) {\n    ','\n  }\n}\n'],['\nmutation SelectTutorForRequest($input: request_tutorMutation) {\n  selectRequest_tutor(input: $input) {\n    ','\n  }\n}\n']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var REQUEST_TUTORS_QUERY='\nid\nrefused_reason\nselection_date\nrefused_date\naccepted_date\nremoved_date\nstate\nanswers\ntutor {\n  id\n  _id\n  state\n  user {\n    id\n    _id\n    first_name\n    last_name\n  }\n}\n';var REQUEST=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject,REQUEST_TUTORS_QUERY);var TUTORS=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject2);var ADD_TUTOR=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject3,REQUEST_TUTORS_QUERY);var RESEND_EMAIL=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject4,REQUEST_TUTORS_QUERY);var UPDATE_STATUS=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject5,REQUEST_TUTORS_QUERY);var SELECT_TUTOR=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject6,REQUEST_TUTORS_QUERY);var RequestDetails=function(_Component){_inherits(RequestDetails,_Component);function RequestDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RequestDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RequestDetails.__proto__||Object.getPrototypeOf(RequestDetails)).call.apply(_ref,[this].concat(args))),_this),_this.state={distance:5,state:['validated','completed'],isMap:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RequestDetails,[{key:'render',value:function render(){var _this2=this;if(!this.props.uuid)return null;var isMap=this.state.isMap;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:REQUEST,variables:{uuid:this.props.uuid}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,fetchMore=_ref2.fetchMore;if(loading)return null;if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Error :(');};var location=data.request?data.request.location:JSON.stringify({coordinates:[0,0]});var selected=data.request?data.request.request_tutors:[];var request=data.request?data.request:{};var requestTutor=data.request?data.request.tutor:{id:0,_id:""};console.log('REQUEST',data.request);var selectedByUuid=Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["keyBy"])(selected,'tutor._id');console.log('selected by uuids',selectedByUuid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:TUTORS,variables:{search:{type:'request',data:JSON.stringify({location:JSON.parse(location).coordinates,distance:_this2.state.distance,state:_this2.state.state})}}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data,fetchMore=_ref3.fetchMore;if(loading)return null;if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Error :(');};var tutors=data.tutors?data.tutors:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex f-space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex f-align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'mr small',value:''+_this2.state.distance,onChange:function onChange(e){return _this2.setState({distance:parseFloat(e.target.value)});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1.5'},'1,5 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2.5'},'2.5 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3.5'},'3.5 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7.5'},'7.5 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'12'},'12 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'16'},'16 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'20'},'20 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'30'},'30 km'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'100'},'100 km')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'c1',checked:_this2.state.state.includes('validated'),onChange:function onChange(e){if(e.target.checked)_this2.setState({state:[].concat(_toConsumableArray(_this2.state.state),['validated'])});else{var index=_this2.state.state.findIndex(function(elm){return elm==='validated';});if(index>-1)_this2.setState({state:[].concat(_toConsumableArray(_this2.state.state.slice(0,index)),_toConsumableArray(_this2.state.state.slice(index+1)))});}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'c1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),' Validated')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'c2',checked:_this2.state.state.includes('completed'),onChange:function onChange(e){if(e.target.checked)_this2.setState({state:[].concat(_toConsumableArray(_this2.state.state),['completed'])});else{var index=_this2.state.state.findIndex(function(elm){return elm==='completed';});if(index>-1)_this2.setState({state:[].concat(_toConsumableArray(_this2.state.state.slice(0,index)),_toConsumableArray(_this2.state.state.slice(index+1)))});}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'c2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),' Completed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'c3',checked:_this2.state.state.includes('in-progress'),onChange:function onChange(e){if(e.target.checked)_this2.setState({state:[].concat(_toConsumableArray(_this2.state.state),['in-progress'])});else{var index=_this2.state.state.findIndex(function(elm){return elm==='in-progress';});if(index>-1)_this2.setState({state:[].concat(_toConsumableArray(_this2.state.state.slice(0,index)),_toConsumableArray(_this2.state.state.slice(index+1)))});}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'c3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),' In progress'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('fas','fa-map',__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.tab,isMap&&__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.active),onClick:function onClick(){return _this2.setState({isMap:true});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('fas','fa-bars',__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.tab,!isMap&&__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.active),onClick:function onClick(){return _this2.setState({isMap:false});}})))),isMap&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.map},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Map__["a" /* default */],{center:JSON.parse(location).coordinates,basePoint:JSON.parse(location),points:tutors.map(function(_ref4){var location=_ref4.location,rest=_objectWithoutProperties(_ref4,['location']);return{geometry:JSON.parse(location),details:Object.assign({},rest,{state:selectedByUuid[rest._id]?'selected':rest.state})};}),hasDetails:true})),!isMap&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('flex','f-wrap','f-stretch',__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.list)},tutors.map(function(_ref5){var id=_ref5.id,_id=_ref5._id,state=_ref5.state,user=_ref5.user,tutor_subject_levels=_ref5.tutor_subject_levels,lang=_ref5.lang,tutor=_objectWithoutProperties(_ref5,['id','_id','state','user','tutor_subject_levels','lang']);return!selectedByUuid[_id]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('box',__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.listBox)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,user.first_name,' ',user.last_name),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,state),' \u2022 ',lang,' \u2022  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,tutor.location?Object(__WEBPACK_IMPORTED_MODULE_9__utils_distance__["a" /* default */])(JSON.parse(tutor.location).coordinates,JSON.parse(location).coordinates).toFixed(2):"0",' km')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex f-align-center f-wrap'},tutor_subject_levels.map(function(_ref6){var level=_ref6.level,subject=_ref6.subject,valid=_ref6.valid;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('tag','small',!valid&&__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.invalid)},subject.name,' \u2022 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,level.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/users/tutor/'+user._id,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_sofia_ui__["Button"],{small:true,inline:true,color:'dark'},'Voir le profil')),!requestTutor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Mutation"],{mutation:ADD_TUTOR,update:function update(cache,_ref7){var addRequest_tutor=_ref7.data.addRequest_tutor;var _cache$readQuery=cache.readQuery({query:REQUEST,variables:{uuid:_this2.props.uuid}}),request=_cache$readQuery.request;console.log('NEW REQUEST',request,addRequest_tutor);cache.writeQuery({query:REQUEST,data:{request:Object.assign({},request,{request_tutors:[].concat(_toConsumableArray(request.request_tutors),[addRequest_tutor])})}});}},function(add,_ref8){var data=_ref8.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_sofia_ui__["Button"],{small:true,color:'green',onClick:function onClick(e){return add({variables:{input:{"request_id":request.id,"request_uuid":request._id,"selection_date":__WEBPACK_IMPORTED_MODULE_5_moment___default()().toISOString(),"tutor_id":id,"tutor_uuid":_id,"state":"SENT"}}});}},'Ajouter');})):null;})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Tuteurs s\xE9lectionn\xE9s'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('flex','f-wrap','f-stretch',__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.list)},selected.map(function(_ref9){var id=_ref9.id,answers=_ref9.answers,user=_ref9.tutor.user,tutor=_ref9.tutor,state=_ref9.state;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('box',__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.listBox)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,user.first_name,' ',user.last_name),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,tutor.state),' ',tutor.location?Object(__WEBPACK_IMPORTED_MODULE_9__utils_distance__["a" /* default */])(JSON.parse(tutor.location).coordinates,JSON.parse(location).coordinates):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'State'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Mutation"],{mutation:UPDATE_STATUS},function(update,_ref10){var data=_ref10.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:state,onChange:function onChange(e){return update({variables:{input:{id:id,state:e.target.value}}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'SENT'},'Envoy\xE9e'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'INTERESTED'},'Int\xE9ress\xE9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'APRROVED'},'Approuv\xE9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'REFUSED'},'Refus\xE9e'));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),answers&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),JSON.stringify(answers,null,2).split('\n').map(function(item,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:key},item,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/users/tutor/'+user._id,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_sofia_ui__["Button"],{small:true,inline:true,color:'dark'},'Voir le profil')),!requestTutor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Mutation"],{mutation:RESEND_EMAIL},function(resend,_ref11){var data=_ref11.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_sofia_ui__["Button"],{small:true,color:'green',inline:true,onClick:function onClick(e){return resend({variables:{input:{id:id,"request_id":request.id,"request_uuid":request._id,"tutor_id":tutor.id,"tutor_uuid":tutor._id}}});}},'Renvoyer SMS et courriel');}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Mutation"],{mutation:SELECT_TUTOR},function(select,_ref12){var data=_ref12.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_sofia_ui__["Button"],{small:true,color:'red',onClick:function onClick(e){return select({variables:{input:{id:id,"request_id":request.id,"request_uuid":request._id,"tutor_id":tutor.id,"tutor_uuid":tutor._id,answers:answers,state:'APRROVED'}}});}},'Choisir');})));})));});});}}]);return RequestDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RequestDetails);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_gl__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mapbox_gl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default.a.accessToken='pk.eyJ1IjoibG9pYzI5NCIsImEiOiJjaW54a3IwcWYxNzhodWFtMzc4eGs2Y2V4In0.IhCIftgKJJBi8gTnI4_8ng';var Map=function(_Component){_inherits(Map,_Component);function Map(){_classCallCheck(this,Map);var _this=_possibleConstructorReturn(this,(Map.__proto__||Object.getPrototypeOf(Map)).call(this));_this.id="map"+Math.round(Math.random()*100000);_this.map={};return _this;}_createClass(Map,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,points=_props.points,hasDetails=_props.hasDetails,basePoint=_props.basePoint;if(!__WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default.a.supported()){console.error("Ce navigateur ne supporte pas Mapbox GL : ",navigator.userAgent);}else{this.map=new __WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default.a.Map({container:this.id,center:this.props.center,zoom:13,style:'mapbox://styles/loic294/cit6lvoss000v2xo4fhduaqvs'});this.map.on('load',function(){for(var i=0;i<points.length;i++){var point=points[i];_this2.map.addSource('single-point-'+i,{"type":"geojson","data":{"type":"FeatureCollection","features":points.map(function(_ref){var geometry=_ref.geometry,details=_ref.details;return{"type":"Feature","geometry":geometry,"properties":{"state":details.state,"description":'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="'+__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.popup+'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h1>'+details.user.first_name+' '+details.user.last_name+'</h1>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<small><i>'+details.user.email+' \u2022 '+details.user.phone_number+'</i></small>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="flex f-align-center f-wrap '+__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.subjects+'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t'+details.tutor_subject_levels.map(function(_ref2){var level=_ref2.level,subject=_ref2.subject;return'<div class="tag small">'+subject.name+' \u2022 <i>'+level.name+'</i></div>';}).join('')+'\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="/users/tutor/'+details.user._id+'" target="_blank">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="small">Voir le profil</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t'}};})}});if(_this2.map.getLayer("points")){_this2.map.removeLayer("points");}_this2.map.addLayer({"id":"points","source":'single-point-'+i,"type":"circle","paint":{"circle-color":{property:'state',type:'categorical',stops:[['validated','#8BC34A'],['completed','#FFC837'],['refused','#e53935'],['in-progress','#cc8924'],['selected','#345995']]},"circle-radius":{'base':12,'stops':[[10,9],[22,360]]},"circle-opacity":0.95}});}// End map loaded
console.log('BASE POINT',basePoint);if(basePoint){_this2.map.addSource('home',{"type":"geojson","data":{"type":"FeatureCollection","features":[{"type":"Feature","geometry":basePoint}]}});if(_this2.map.getLayer("home")){_this2.map.removeLayer("home");}_this2.map.addLayer({"id":"home","source":'home',"type":"circle","paint":{"circle-color":'#222',"circle-radius":{'base':9,'stops':[[10,9],[22,360]]},"circle-opacity":1}});}if(hasDetails){_this2.map.on('click','points',function(e){if(!e.features.length)return;var coordinates=e.features[0].geometry.coordinates.slice();var description=e.features[0].properties.description;while(Math.abs(e.lngLat.lng-coordinates[0])>180){coordinates[0]+=e.lngLat.lng>coordinates[0]?360:-360;}var popup=new __WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default.a.Popup().setLngLat(coordinates).setHTML(description).addTo(_this2.map);console.log('ADD POPUP');});_this2.map.on('mousemove',function(e){var features=_this2.map.queryRenderedFeatures(e.point,{layers:['points']});_this2.map.getCanvas().style.cursor=features.length?'pointer':'';});}});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEqual"])(prevProps.points,this.props.points)){for(var i=0;i<this.props.points.length;i++){var point=this.props.points[i];this.map.getSource('single-point-'+i).setData({"type":"FeatureCollection","features":this.props.points.map(function(_ref3){var geometry=_ref3.geometry;return{"type":"Feature","geometry":geometry};})});if(this.props.basePoint){this.map.getSource('home').setData({"type":"geojson","data":{"type":"FeatureCollection","features":{"type":"Feature","geometry":this.props.basePoint}}});}}}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.map,id:this.id});}}]);return Map;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Map);

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

/* Mapbox GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/mapbox/mapbox-gl-js/blob/v0.48.0/LICENSE.txt */
(function (global, factory) {
 true ? module.exports = factory() :
typeof define === 'function' && define.amd ? define(factory) :
(global.mapboxgl = factory());
}(this, (function () { 'use strict';

/* eslint-disable */

var shared, worker, mapboxgl;
// define gets called three times: one for each chunk. we rely on the order
// they're imported to know which is which
function define(_, chunk) {
if (!shared) {
    shared = chunk;
} else if (!worker) {
    worker = chunk;
} else {
    var workerBundleString = 'var sharedChunk = {}; (' + shared + ')(sharedChunk); (' + worker + ')(sharedChunk);'

    var sharedChunk = {};
    shared(sharedChunk);
    mapboxgl = chunk(sharedChunk);
    mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: 'text/javascript' }));
}
}


define(["exports"],function(t){"use strict";function e(t,e){return t(e={exports:{}},e.exports),e.exports}var r=n;function n(t,e,r,n){this.cx=3*t,this.bx=3*(r-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*e,this.by=3*(n-e)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=n,this.p2x=r,this.p2y=n;}n.prototype.sampleCurveX=function(t){return ((this.ax*t+this.bx)*t+this.cx)*t},n.prototype.sampleCurveY=function(t){return ((this.ay*t+this.by)*t+this.cy)*t},n.prototype.sampleCurveDerivativeX=function(t){return (3*this.ax*t+2*this.bx)*t+this.cx},n.prototype.solveCurveX=function(t,e){var r,n,i,a,o;for(void 0===e&&(e=1e-6),i=t,o=0;o<8;o++){if(a=this.sampleCurveX(i)-t,Math.abs(a)<e)return i;var s=this.sampleCurveDerivativeX(i);if(Math.abs(s)<1e-6)break;i-=a/s;}if((i=t)<(r=0))return r;if(i>(n=1))return n;for(;r<n;){if(a=this.sampleCurveX(i),Math.abs(a-t)<e)return i;t>a?r=i:n=i,i=.5*(n-r)+r;}return i},n.prototype.solve=function(t,e){return this.sampleCurveY(this.solveCurveX(t,e))};var i=function(t,e,r){this.column=t,this.row=e,this.zoom=r;};i.prototype.clone=function(){return new i(this.column,this.row,this.zoom)},i.prototype.zoomTo=function(t){return this.clone()._zoomTo(t)},i.prototype.sub=function(t){return this.clone()._sub(t)},i.prototype._zoomTo=function(t){var e=Math.pow(2,t-this.zoom);return this.column*=e,this.row*=e,this.zoom=t,this},i.prototype._sub=function(t){return t=t.zoomTo(this.zoom),this.column-=t.column,this.row-=t.row,this};var a=o;function o(t,e){this.x=t,this.y=e;}function s(t,e){if(Array.isArray(t)){if(!Array.isArray(e)||t.length!==e.length)return !1;for(var r=0;r<t.length;r++)if(!s(t[r],e[r]))return !1;return !0}if("object"==typeof t&&null!==t&&null!==e){if("object"!=typeof e)return !1;if(Object.keys(t).length!==Object.keys(e).length)return !1;for(var n in t)if(!s(t[n],e[n]))return !1;return !0}return t===e}function u(t,e,n,i){var a=new r(t,e,n,i);return function(t){return a.solve(t)}}o.prototype={clone:function(){return new o(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x,r=t.y-this.y;return e*e+r*r},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[0]*this.x+t[1]*this.y,r=t[2]*this.x+t[3]*this.y;return this.x=e,this.y=r,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),r=Math.sin(t),n=e*this.x-r*this.y,i=r*this.x+e*this.y;return this.x=n,this.y=i,this},_rotateAround:function(t,e){var r=Math.cos(t),n=Math.sin(t),i=e.x+r*(this.x-e.x)-n*(this.y-e.y),a=e.y+n*(this.x-e.x)+r*(this.y-e.y);return this.x=i,this.y=a,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},o.convert=function(t){return t instanceof o?t:Array.isArray(t)?new o(t[0],t[1]):t};var l=u(.25,.1,.25,1);function p(t,e,r){return Math.min(r,Math.max(e,t))}function h(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var a=i[n];for(var o in a)t[o]=a[o];}return t}var c=1;function f(){return c++}function y(t,e){t.forEach(function(t){e[t]&&(e[t]=e[t].bind(e));});}function d(t,e){return -1!==t.indexOf(e,t.length-e.length)}function m(t,e,r){var n={};for(var i in t)n[i]=e.call(r||this,t[i],i,t);return n}function v(t,e,r){var n={};for(var i in t)e.call(r||this,t[i],i,t)&&(n[i]=t[i]);return n}function g(t){return Array.isArray(t)?t.map(g):"object"==typeof t&&t?m(t,g):t}var x={};function b(t){x[t]||("undefined"!=typeof console&&console.warn(t),x[t]=!0);}function w(t,e,r){return (r.y-t.y)*(e.x-t.x)>(e.y-t.y)*(r.x-t.x)}function _(t){for(var e=0,r=0,n=t.length,i=n-1,a=void 0,o=void 0;r<n;i=r++)a=t[r],e+=((o=t[i]).x-a.x)*(a.y+o.y);return e}var A=self.performance&&self.performance.now?self.performance.now.bind(self.performance):Date.now.bind(Date),k=self.requestAnimationFrame||self.mozRequestAnimationFrame||self.webkitRequestAnimationFrame||self.msRequestAnimationFrame,S=self.cancelAnimationFrame||self.mozCancelAnimationFrame||self.webkitCancelAnimationFrame||self.msCancelAnimationFrame,z={now:A,frame:function(t){var e=k(t);return {cancel:function(){return S(e)}}},getImageData:function(t){var e=self.document.createElement("canvas"),r=e.getContext("2d");if(!r)throw new Error("failed to create canvas 2d context");return e.width=t.width,e.height=t.height,r.drawImage(t,0,0,t.width,t.height),r.getImageData(0,0,t.width,t.height)},resolveURL:function(t){var e=self.document.createElement("a");return e.href=t,e.href},hardwareConcurrency:self.navigator.hardwareConcurrency||4,get devicePixelRatio(){return self.devicePixelRatio},supportsWebp:!1};if(self.document){var M=self.document.createElement("img");M.onload=function(){z.supportsWebp=!0;},M.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=";}var B={Unknown:"Unknown",Style:"Style",Source:"Source",Tile:"Tile",Glyphs:"Glyphs",SpriteImage:"SpriteImage",SpriteJSON:"SpriteJSON",Image:"Image"};"function"==typeof Object.freeze&&Object.freeze(B);var I=function(t){function e(e,r,n){t.call(this,e),this.status=r,this.url=n,this.name=this.constructor.name,this.message=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.toString=function(){return this.name+": "+this.message+" ("+this.status+"): "+this.url},e}(Error);function C(t){var e=new self.XMLHttpRequest;for(var r in e.open(t.method||"GET",t.url,!0),t.headers)e.setRequestHeader(r,t.headers[r]);return e.withCredentials="include"===t.credentials,e}var V=function(t,e){var r=C(t);return r.responseType="arraybuffer",r.onerror=function(){e(new Error(r.statusText));},r.onload=function(){var n=r.response;if(0===n.byteLength&&200===r.status)return e(new Error("http status 200 returned without content."));r.status>=200&&r.status<300&&r.response?e(null,{data:n,cacheControl:r.getResponseHeader("Cache-Control"),expires:r.getResponseHeader("Expires")}):e(new I(r.statusText,r.status,t.url));},r.send(),{cancel:function(){return r.abort()}}};function T(t,e,r){r[t]&&-1!==r[t].indexOf(e)||(r[t]=r[t]||[],r[t].push(e));}function E(t,e,r){if(r&&r[t]){var n=r[t].indexOf(e);-1!==n&&r[t].splice(n,1);}}var P=function(t,e){void 0===e&&(e={}),h(this,e),this.type=t;},F=function(t){function e(e,r){void 0===r&&(r={}),t.call(this,"error",h({error:e},r));}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(P),L=function(){};L.prototype.on=function(t,e){return this._listeners=this._listeners||{},T(t,e,this._listeners),this},L.prototype.off=function(t,e){return E(t,e,this._listeners),E(t,e,this._oneTimeListeners),this},L.prototype.once=function(t,e){return this._oneTimeListeners=this._oneTimeListeners||{},T(t,e,this._oneTimeListeners),this},L.prototype.fire=function(t){"string"==typeof t&&(t=new P(t,arguments[1]||{}));var e=t.type;if(this.listens(e)){t.target=this;for(var r=0,n=this._listeners&&this._listeners[e]?this._listeners[e].slice():[];r<n.length;r+=1){n[r].call(this,t);}for(var i=0,a=this._oneTimeListeners&&this._oneTimeListeners[e]?this._oneTimeListeners[e].slice():[];i<a.length;i+=1){var o=a[i];E(e,o,this._oneTimeListeners),o.call(this,t);}var s=this._eventedParent;s&&(h(t,"function"==typeof this._eventedParentData?this._eventedParentData():this._eventedParentData),s.fire(t));}else t instanceof F&&console.error(t.error);return this},L.prototype.listens=function(t){return this._listeners&&this._listeners[t]&&this._listeners[t].length>0||this._oneTimeListeners&&this._oneTimeListeners[t]&&this._oneTimeListeners[t].length>0||this._eventedParent&&this._eventedParent.listens(t)},L.prototype.setEventedParent=function(t,e){return this._eventedParent=t,this._eventedParentData=e,this};var O={$version:8,$root:{version:{required:!0,type:"enum",values:[8]},name:{type:"string"},metadata:{type:"*"},center:{type:"array",value:"number"},zoom:{type:"number"},bearing:{type:"number",default:0,period:360,units:"degrees"},pitch:{type:"number",default:0,units:"degrees"},light:{type:"light"},sources:{required:!0,type:"sources"},sprite:{type:"string"},glyphs:{type:"string"},transition:{type:"transition"},layers:{required:!0,type:"array",value:"layer"}},sources:{"*":{type:"source"}},source:["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],source_vector:{type:{required:!0,type:"enum",values:{vector:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},attribution:{type:"string"},"*":{type:"*"}},source_raster:{type:{required:!0,type:"enum",values:{raster:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},attribution:{type:"string"},"*":{type:"*"}},source_raster_dem:{type:{required:!0,type:"enum",values:{"raster-dem":{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},attribution:{type:"string"},encoding:{type:"enum",values:{terrarium:{},mapbox:{}},default:"mapbox"},"*":{type:"*"}},source_geojson:{type:{required:!0,type:"enum",values:{geojson:{}}},data:{type:"*"},maxzoom:{type:"number",default:18},attribution:{type:"string"},buffer:{type:"number",default:128,maximum:512,minimum:0},tolerance:{type:"number",default:.375},cluster:{type:"boolean",default:!1},clusterRadius:{type:"number",default:50,minimum:0},clusterMaxZoom:{type:"number"},lineMetrics:{type:"boolean",default:!1},generateId:{type:"boolean",default:!1}},source_video:{type:{required:!0,type:"enum",values:{video:{}}},urls:{required:!0,type:"array",value:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},source_image:{type:{required:!0,type:"enum",values:{image:{}}},url:{required:!0,type:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},layer:{id:{type:"string",required:!0},type:{type:"enum",values:{fill:{},line:{},symbol:{},circle:{},heatmap:{},"fill-extrusion":{},raster:{},hillshade:{},background:{}},required:!0},metadata:{type:"*"},source:{type:"string"},"source-layer":{type:"string"},minzoom:{type:"number",minimum:0,maximum:24},maxzoom:{type:"number",minimum:0,maximum:24},filter:{type:"filter"},layout:{type:"layout"},paint:{type:"paint"}},layout:["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background"],layout_background:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_fill:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_circle:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_heatmap:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_line:{"line-cap":{type:"enum",values:{butt:{},round:{},square:{}},default:"butt",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-join":{type:"enum",values:{bevel:{},round:{},miter:{}},default:"miter",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{type:"number",default:2,requires:[{"line-join":"miter"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-round-limit":{type:"number",default:1.05,requires:[{"line-join":"round"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_symbol:{"symbol-placement":{type:"enum",values:{point:{},line:{},"line-center":{}},default:"point",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-spacing":{type:"number",default:250,minimum:1,units:"pixels",requires:[{"symbol-placement":"line"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{type:"boolean",default:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-optional":{type:"boolean",default:!1,requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-size":{type:"number",default:1,minimum:0,units:"factor of the original icon size",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{type:"enum",values:{none:{},width:{},height:{},both:{}},default:"none",requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{type:"array",value:"number",length:4,default:[0,0,0,0],units:"pixels",requires:["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-image":{type:"string",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{type:"boolean",default:!1,requires:["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-offset":{type:"array",value:"number",length:2,default:[0,0],requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-field":{type:"formatted",default:"",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-font":{type:"array",value:"string",default:["Open Sans Regular","Arial Unicode MS Regular"],requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-size":{type:"number",default:16,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{type:"number",default:10,minimum:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{type:"number",default:1.2,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-letter-spacing":{type:"number",default:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-justify":{type:"enum",values:{left:{},center:{},right:{}},default:"center",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{type:"number",default:45,units:"degrees",requires:["text-field",{"symbol-placement":["line","line-center"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-keep-upright":{type:"boolean",default:!0,requires:["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-transform":{type:"enum",values:{none:{},uppercase:{},lowercase:{}},default:"none",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-offset":{type:"array",value:"number",units:"ems",length:2,default:[0,0],requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-optional":{type:"boolean",default:!1,requires:["text-field","icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_raster:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_hillshade:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},filter:{type:"array",value:"*"},filter_operator:{type:"enum",values:{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},in:{},"!in":{},all:{},any:{},none:{},has:{},"!has":{}}},geometry_type:{type:"enum",values:{Point:{},LineString:{},Polygon:{}}},function_stop:{type:"array",minimum:0,maximum:22,value:["number","color"],length:2},expression:{type:"array",value:"*",minimum:1},expression_name:{type:"enum",values:{let:{group:"Variable binding"},var:{group:"Variable binding"},literal:{group:"Types"},array:{group:"Types"},at:{group:"Lookup"},case:{group:"Decision"},match:{group:"Decision"},coalesce:{group:"Decision"},step:{group:"Ramps, scales, curves"},interpolate:{group:"Ramps, scales, curves"},ln2:{group:"Math"},pi:{group:"Math"},e:{group:"Math"},typeof:{group:"Types"},string:{group:"Types"},number:{group:"Types"},boolean:{group:"Types"},object:{group:"Types"},collator:{group:"Types"},format:{group:"Types"},"to-string":{group:"Types"},"to-number":{group:"Types"},"to-boolean":{group:"Types"},"to-rgba":{group:"Color"},"to-color":{group:"Types"},rgb:{group:"Color"},rgba:{group:"Color"},get:{group:"Lookup"},has:{group:"Lookup"},length:{group:"Lookup"},properties:{group:"Feature data"},"feature-state":{group:"Feature data"},"geometry-type":{group:"Feature data"},id:{group:"Feature data"},zoom:{group:"Zoom"},"heatmap-density":{group:"Heatmap"},"line-progress":{group:"Heatmap"},"+":{group:"Math"},"*":{group:"Math"},"-":{group:"Math"},"/":{group:"Math"},"%":{group:"Math"},"^":{group:"Math"},sqrt:{group:"Math"},log10:{group:"Math"},ln:{group:"Math"},log2:{group:"Math"},sin:{group:"Math"},cos:{group:"Math"},tan:{group:"Math"},asin:{group:"Math"},acos:{group:"Math"},atan:{group:"Math"},min:{group:"Math"},max:{group:"Math"},round:{group:"Math"},abs:{group:"Math"},ceil:{group:"Math"},floor:{group:"Math"},"==":{group:"Decision"},"!=":{group:"Decision"},">":{group:"Decision"},"<":{group:"Decision"},">=":{group:"Decision"},"<=":{group:"Decision"},all:{group:"Decision"},any:{group:"Decision"},"!":{group:"Decision"},"is-supported-script":{group:"String"},upcase:{group:"String"},downcase:{group:"String"},concat:{group:"String"},"resolved-locale":{group:"String"}}},light:{anchor:{type:"enum",default:"viewport",values:{map:{},viewport:{}},"property-type":"data-constant",transition:!1,expression:{interpolated:!1,parameters:["zoom"]}},position:{type:"array",default:[1.15,210,30],length:3,value:"number","property-type":"data-constant",transition:!0,expression:{interpolated:!0,parameters:["zoom"]}},color:{type:"color","property-type":"data-constant",default:"#ffffff",expression:{interpolated:!0,parameters:["zoom"]},transition:!0},intensity:{type:"number","property-type":"data-constant",default:.5,minimum:0,maximum:1,expression:{interpolated:!0,parameters:["zoom"]},transition:!0}},paint:["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background"],paint_fill:{"fill-antialias":{type:"boolean",default:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{type:"color",transition:!0,requires:[{"!":"fill-pattern"},{"fill-antialias":!0}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"}},paint_line:{"line-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"line-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["line-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-width":{type:"number",default:1,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{type:"number",default:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{type:"array",value:"number",minimum:0,transition:!0,units:"line widths",requires:[{"!":"line-pattern"}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"line-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"line-gradient":{type:"color",transition:!1,requires:[{"!":"line-dasharray"},{"!":"line-pattern"},{source:"geojson",has:{lineMetrics:!0}}],expression:{interpolated:!0,parameters:["line-progress"]},"property-type":"color-ramp"}},paint_circle:{"circle-radius":{type:"number",default:5,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{type:"number",default:0,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["circle-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{type:"enum",values:{map:{},viewport:{}},default:"map",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"}},paint_heatmap:{"heatmap-radius":{type:"number",default:30,minimum:1,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{type:"number",default:1,minimum:0,transition:!1,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{type:"number",default:1,minimum:0,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"heatmap-color":{type:"color",default:["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",.1,"royalblue",.3,"cyan",.5,"lime",.7,"yellow",1,"red"],transition:!1,expression:{interpolated:!0,parameters:["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_symbol:{"icon-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{type:"color",default:"#000000",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["icon-image","icon-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{type:"color",default:"#000000",transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["text-field","text-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_raster:{"raster-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{type:"number",default:0,period:360,transition:!0,units:"degrees",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{type:"number",default:0,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-saturation":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-contrast":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-resampling":{type:"enum",values:{linear:{},nearest:{}},default:"linear",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{type:"number",default:300,minimum:0,transition:!1,units:"milliseconds",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_hillshade:{"hillshade-illumination-direction":{type:"number",default:335,minimum:0,maximum:359,transition:!1,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{type:"number",default:.5,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{type:"color",default:"#FFFFFF",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_background:{"background-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"background-pattern"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"background-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"background-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},transition:{duration:{type:"number",default:300,minimum:0,units:"milliseconds"},delay:{type:"number",default:0,minimum:0,units:"milliseconds"}},"layout_fill-extrusion":{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},function:{expression:{type:"expression"},stops:{type:"array",value:"function_stop"},base:{type:"number",default:1,minimum:0},property:{type:"string",default:"$zoom"},type:{type:"enum",values:{identity:{},exponential:{},interval:{},categorical:{}},default:"exponential"},colorSpace:{type:"enum",values:{rgb:{},lab:{},hcl:{}},default:"rgb"},default:{type:"*",required:!1}},"paint_fill-extrusion":{"fill-extrusion-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-extrusion-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-extrusion-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"fill-extrusion-height":{type:"number",default:0,minimum:0,units:"meters",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{type:"number",default:0,minimum:0,units:"meters",transition:!0,requires:["fill-extrusion-height"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"}},"property-type":{"data-driven":{type:"property-type"},"cross-faded":{type:"property-type"},"cross-faded-data-driven":{type:"property-type"},"color-ramp":{type:"property-type"},"data-constant":{type:"property-type"},constant:{type:"property-type"}}},D=function(t,e,r,n){this.message=(t?t+": ":"")+r,n&&(this.identifier=n),null!=e&&e.__line__&&(this.line=e.__line__);};function q(t){var e=t.key,r=t.value;return r?[new D(e,r,"constants have been deprecated as of v8")]:[]}function j(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var a=i[n];for(var o in a)t[o]=a[o];}return t}function U(t){return t instanceof Number||t instanceof String||t instanceof Boolean?t.valueOf():t}function R(t){return Array.isArray(t)?t.map(R):U(t)}var N=function(t){function e(e,r){t.call(this,r),this.message=r,this.key=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Error),Z=function(t,e){void 0===e&&(e=[]),this.parent=t,this.bindings={};for(var r=0,n=e;r<n.length;r+=1){var i=n[r],a=i[0],o=i[1];this.bindings[a]=o;}};Z.prototype.concat=function(t){return new Z(this,t)},Z.prototype.get=function(t){if(this.bindings[t])return this.bindings[t];if(this.parent)return this.parent.get(t);throw new Error(t+" not found in scope.")},Z.prototype.has=function(t){return !!this.bindings[t]||!!this.parent&&this.parent.has(t)};var X={kind:"null"},H={kind:"number"},J={kind:"string"},G={kind:"boolean"},K={kind:"color"},Y={kind:"object"},$={kind:"value"},W={kind:"collator"},Q={kind:"formatted"};function tt(t,e){return {kind:"array",itemType:t,N:e}}function et(t){if("array"===t.kind){var e=et(t.itemType);return "number"==typeof t.N?"array<"+e+", "+t.N+">":"value"===t.itemType.kind?"array":"array<"+e+">"}return t.kind}var rt=[X,H,J,G,K,Q,Y,tt($)];function nt(t,e){if("error"===e.kind)return null;if("array"===t.kind){if("array"===e.kind&&!nt(t.itemType,e.itemType)&&("number"!=typeof t.N||t.N===e.N))return null}else{if(t.kind===e.kind)return null;if("value"===t.kind)for(var r=0,n=rt;r<n.length;r+=1){if(!nt(n[r],e))return null}}return "Expected "+et(t)+" but found "+et(e)+" instead."}var it=e(function(t,e){var r={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};function n(t){return (t=Math.round(t))<0?0:t>255?255:t}function i(t){return t<0?0:t>1?1:t}function a(t){return "%"===t[t.length-1]?n(parseFloat(t)/100*255):n(parseInt(t))}function o(t){return "%"===t[t.length-1]?i(parseFloat(t)/100):i(parseFloat(t))}function s(t,e,r){return r<0?r+=1:r>1&&(r-=1),6*r<1?t+(e-t)*r*6:2*r<1?e:3*r<2?t+(e-t)*(2/3-r)*6:t}try{e.parseCSSColor=function(t){var e,i=t.replace(/ /g,"").toLowerCase();if(i in r)return r[i].slice();if("#"===i[0])return 4===i.length?(e=parseInt(i.substr(1),16))>=0&&e<=4095?[(3840&e)>>4|(3840&e)>>8,240&e|(240&e)>>4,15&e|(15&e)<<4,1]:null:7===i.length&&(e=parseInt(i.substr(1),16))>=0&&e<=16777215?[(16711680&e)>>16,(65280&e)>>8,255&e,1]:null;var u=i.indexOf("("),l=i.indexOf(")");if(-1!==u&&l+1===i.length){var p=i.substr(0,u),h=i.substr(u+1,l-(u+1)).split(","),c=1;switch(p){case"rgba":if(4!==h.length)return null;c=o(h.pop());case"rgb":return 3!==h.length?null:[a(h[0]),a(h[1]),a(h[2]),c];case"hsla":if(4!==h.length)return null;c=o(h.pop());case"hsl":if(3!==h.length)return null;var f=(parseFloat(h[0])%360+360)%360/360,y=o(h[1]),d=o(h[2]),m=d<=.5?d*(y+1):d+y-d*y,v=2*d-m;return [n(255*s(v,m,f+1/3)),n(255*s(v,m,f)),n(255*s(v,m,f-1/3)),c];default:return null}}return null};}catch(t){}}).parseCSSColor,at=function(t,e,r,n){void 0===n&&(n=1),this.r=t,this.g=e,this.b=r,this.a=n;};at.parse=function(t){if(t){if(t instanceof at)return t;if("string"==typeof t){var e=it(t);if(e)return new at(e[0]/255*e[3],e[1]/255*e[3],e[2]/255*e[3],e[3])}}},at.prototype.toString=function(){var t=this.toArray(),e=t[0],r=t[1],n=t[2],i=t[3];return "rgba("+Math.round(e)+","+Math.round(r)+","+Math.round(n)+","+i+")"},at.prototype.toArray=function(){var t=this.r,e=this.g,r=this.b,n=this.a;return 0===n?[0,0,0,0]:[255*t/n,255*e/n,255*r/n,n]},at.black=new at(0,0,0,1),at.white=new at(1,1,1,1),at.transparent=new at(0,0,0,0);var ot=function(t,e,r){this.sensitivity=t?e?"variant":"case":e?"accent":"base",this.locale=r,this.collator=new Intl.Collator(this.locale?this.locale:[],{sensitivity:this.sensitivity,usage:"search"});};ot.prototype.compare=function(t,e){return this.collator.compare(t,e)},ot.prototype.resolvedLocale=function(){return new Intl.Collator(this.locale?this.locale:[]).resolvedOptions().locale};var st=function(t,e,r){this.type=W,this.locale=r,this.caseSensitive=t,this.diacriticSensitive=e;};function ut(t,e,r,n){return "number"==typeof t&&t>=0&&t<=255&&"number"==typeof e&&e>=0&&e<=255&&"number"==typeof r&&r>=0&&r<=255?void 0===n||"number"==typeof n&&n>=0&&n<=1?null:"Invalid rgba value ["+[t,e,r,n].join(", ")+"]: 'a' must be between 0 and 1.":"Invalid rgba value ["+("number"==typeof n?[t,e,r,n]:[t,e,r]).join(", ")+"]: 'r', 'g', and 'b' must be between 0 and 255."}function lt(t){if(null===t)return X;if("string"==typeof t)return J;if("boolean"==typeof t)return G;if("number"==typeof t)return H;if(t instanceof at)return K;if(t instanceof ot)return W;if(Array.isArray(t)){for(var e,r=t.length,n=0,i=t;n<i.length;n+=1){var a=lt(i[n]);if(e){if(e===a)continue;e=$;break}e=a;}return tt(e||$,r)}return Y}st.parse=function(t,e){if(2!==t.length)return e.error("Expected one argument.");var r=t[1];if("object"!=typeof r||Array.isArray(r))return e.error("Collator options argument must be an object.");var n=e.parse(void 0!==r["case-sensitive"]&&r["case-sensitive"],1,G);if(!n)return null;var i=e.parse(void 0!==r["diacritic-sensitive"]&&r["diacritic-sensitive"],1,G);if(!i)return null;var a=null;return r.locale&&!(a=e.parse(r.locale,1,J))?null:new st(n,i,a)},st.prototype.evaluate=function(t){return new ot(this.caseSensitive.evaluate(t),this.diacriticSensitive.evaluate(t),this.locale?this.locale.evaluate(t):null)},st.prototype.eachChild=function(t){t(this.caseSensitive),t(this.diacriticSensitive),this.locale&&t(this.locale);},st.prototype.possibleOutputs=function(){return [void 0]},st.prototype.serialize=function(){var t={};return t["case-sensitive"]=this.caseSensitive.serialize(),t["diacritic-sensitive"]=this.diacriticSensitive.serialize(),this.locale&&(t.locale=this.locale.serialize()),["collator",t]};var pt=function(t,e,r){this.text=t,this.scale=e,this.fontStack=r;},ht=function(t){this.sections=t;};ht.prototype.toString=function(){return this.sections.map(function(t){return t.text}).join("")},ht.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t.push(n.text);var i=n.fontStack?["literal",n.fontStack.split(",")]:null;t.push({"text-font":i,"font-scale":n.scale});}return t};var ct=function(t){this.type=Q,this.sections=t;};ct.parse=function(t,e){if(t.length<3)return e.error("Expected at least two arguments.");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");for(var r=[],n=1;n<t.length-1;n+=2){var i=e.parse(t[n],1,$);if(!i)return null;var a=i.type.kind;if("string"!==a&&"value"!==a&&"null"!==a)return e.error("Formatted text type must be 'string', 'value', or 'null'.");var o=t[n+1];if("object"!=typeof o||Array.isArray(o))return e.error("Format options argument must be an object.");var s=null;if(o["font-scale"]&&!(s=e.parse(o["font-scale"],1,H)))return null;var u=null;if(o["text-font"]&&!(u=e.parse(o["text-font"],1,tt(J))))return null;r.push({text:i,scale:s,font:u});}return new ct(r)},ct.prototype.evaluate=function(t){return new ht(this.sections.map(function(e){return new pt(e.text.evaluate(t)||"",e.scale?e.scale.evaluate(t):null,e.font?e.font.evaluate(t).join(","):null)}))},ct.prototype.eachChild=function(t){for(var e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t(n.text),n.scale&&t(n.scale),n.font&&t(n.font);}},ct.prototype.possibleOutputs=function(){return [void 0]},ct.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t.push(n.text.serialize());var i={};n.scale&&(i["font-scale"]=n.scale.serialize()),n.font&&(i["text-font"]=n.font.serialize()),t.push(i);}return t};var ft=function(t,e){this.type=t,this.value=e;};ft.parse=function(t,e){if(2!==t.length)return e.error("'literal' expression requires exactly one argument, but found "+(t.length-1)+" instead.");if(!function t(e){if(null===e)return !0;if("string"==typeof e)return !0;if("boolean"==typeof e)return !0;if("number"==typeof e)return !0;if(e instanceof at)return !0;if(e instanceof ot)return !0;if(Array.isArray(e)){for(var r=0,n=e;r<n.length;r+=1)if(!t(n[r]))return !1;return !0}if("object"==typeof e){for(var i in e)if(!t(e[i]))return !1;return !0}return !1}(t[1]))return e.error("invalid value");var r=t[1],n=lt(r),i=e.expectedType;return "array"!==n.kind||0!==n.N||!i||"array"!==i.kind||"number"==typeof i.N&&0!==i.N||(n=i),new ft(n,r)},ft.prototype.evaluate=function(){return this.value},ft.prototype.eachChild=function(){},ft.prototype.possibleOutputs=function(){return [this.value]},ft.prototype.serialize=function(){return "array"===this.type.kind||"object"===this.type.kind?["literal",this.value]:this.value instanceof at?["rgba"].concat(this.value.toArray()):this.value instanceof ht?this.value.serialize():this.value};var yt=function(t){this.name="ExpressionEvaluationError",this.message=t;};yt.prototype.toJSON=function(){return this.message};var dt={string:J,number:H,boolean:G,object:Y},mt=function(t,e){this.type=t,this.args=e;};mt.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");for(var r=t[0],n=dt[r],i=[],a=1;a<t.length;a++){var o=e.parse(t[a],a,$);if(!o)return null;i.push(o);}return new mt(n,i)},mt.prototype.evaluate=function(t){for(var e=0;e<this.args.length;e++){var r=this.args[e].evaluate(t);if(!nt(this.type,lt(r)))return r;if(e===this.args.length-1)throw new yt("Expected value to be of type "+et(this.type)+", but found "+et(lt(r))+" instead.")}return null},mt.prototype.eachChild=function(t){this.args.forEach(t);},mt.prototype.possibleOutputs=function(){return (t=[]).concat.apply(t,this.args.map(function(t){return t.possibleOutputs()}));var t;},mt.prototype.serialize=function(){return [this.type.kind].concat(this.args.map(function(t){return t.serialize()}))};var vt={string:J,number:H,boolean:G},gt=function(t,e){this.type=t,this.input=e;};gt.parse=function(t,e){if(t.length<2||t.length>4)return e.error("Expected 1, 2, or 3 arguments, but found "+(t.length-1)+" instead.");var r,n;if(t.length>2){var i=t[1];if("string"!=typeof i||!(i in vt))return e.error('The item type argument of "array" must be one of string, number, boolean',1);r=vt[i];}else r=$;if(t.length>3){if("number"!=typeof t[2]||t[2]<0||t[2]!==Math.floor(t[2]))return e.error('The length argument to "array" must be a positive integer literal',2);n=t[2];}var a=tt(r,n),o=e.parse(t[t.length-1],t.length-1,$);return o?new gt(a,o):null},gt.prototype.evaluate=function(t){var e=this.input.evaluate(t);if(nt(this.type,lt(e)))throw new yt("Expected value to be of type "+et(this.type)+", but found "+et(lt(e))+" instead.");return e},gt.prototype.eachChild=function(t){t(this.input);},gt.prototype.possibleOutputs=function(){return this.input.possibleOutputs()},gt.prototype.serialize=function(){var t=["array"],e=this.type.itemType;if("string"===e.kind||"number"===e.kind||"boolean"===e.kind){t.push(e.kind);var r=this.type.N;"number"==typeof r&&t.push(r);}return t.push(this.input.serialize()),t};var xt={"to-number":H,"to-color":K},bt=function(t,e){this.type=t,this.args=e;};bt.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");for(var r=t[0],n=xt[r],i=[],a=1;a<t.length;a++){var o=e.parse(t[a],a,$);if(!o)return null;i.push(o);}return new bt(n,i)},bt.prototype.evaluate=function(t){if("color"===this.type.kind){for(var e,r,n=0,i=this.args;n<i.length;n+=1){if(r=null,"string"==typeof(e=i[n].evaluate(t))){var a=t.parseColor(e);if(a)return a}else if(Array.isArray(e)&&!(r=e.length<3||e.length>4?"Invalid rbga value "+JSON.stringify(e)+": expected an array containing either three or four numeric values.":ut(e[0],e[1],e[2],e[3])))return new at(e[0]/255,e[1]/255,e[2]/255,e[3])}throw new yt(r||"Could not parse color from value '"+("string"==typeof e?e:JSON.stringify(e))+"'")}if("formatted"===this.type.kind){for(var o,s=0,u=this.args;s<u.length;s+=1){if("string"==typeof(o=u[s].evaluate(t)))return new ht([new pt(o,null,null)])}throw new yt("Could not parse formatted text from value '"+("string"==typeof o?o:JSON.stringify(o))+"'")}for(var l=null,p=0,h=this.args;p<h.length;p+=1){if(null!==(l=h[p].evaluate(t))){var c=Number(l);if(!isNaN(c))return c}}throw new yt("Could not convert "+JSON.stringify(l)+" to number.")},bt.prototype.eachChild=function(t){this.args.forEach(t);},bt.prototype.possibleOutputs=function(){return (t=[]).concat.apply(t,this.args.map(function(t){return t.possibleOutputs()}));var t;},bt.prototype.serialize=function(){var t=["to-"+this.type.kind];return this.eachChild(function(e){t.push(e.serialize());}),t};var wt=["Unknown","Point","LineString","Polygon"],_t=function(){this._parseColorCache={};};_t.prototype.id=function(){return this.feature&&"id"in this.feature?this.feature.id:null},_t.prototype.geometryType=function(){return this.feature?"number"==typeof this.feature.type?wt[this.feature.type]:this.feature.type:null},_t.prototype.properties=function(){return this.feature&&this.feature.properties||{}},_t.prototype.parseColor=function(t){var e=this._parseColorCache[t];return e||(e=this._parseColorCache[t]=at.parse(t)),e};var At=function(t,e,r,n){this.name=t,this.type=e,this._evaluate=r,this.args=n;};function kt(t){if(t instanceof At){if("get"===t.name&&1===t.args.length)return !1;if("feature-state"===t.name)return !1;if("has"===t.name&&1===t.args.length)return !1;if("properties"===t.name||"geometry-type"===t.name||"id"===t.name)return !1;if(/^filter-/.test(t.name))return !1}var e=!0;return t.eachChild(function(t){e&&!kt(t)&&(e=!1);}),e}function St(t){if(t instanceof At&&"feature-state"===t.name)return !1;var e=!0;return t.eachChild(function(t){e&&!St(t)&&(e=!1);}),e}function zt(t,e){if(t instanceof At&&e.indexOf(t.name)>=0)return !1;var r=!0;return t.eachChild(function(t){r&&!zt(t,e)&&(r=!1);}),r}At.prototype.evaluate=function(t){return this._evaluate(t,this.args)},At.prototype.eachChild=function(t){this.args.forEach(t);},At.prototype.possibleOutputs=function(){return [void 0]},At.prototype.serialize=function(){return [this.name].concat(this.args.map(function(t){return t.serialize()}))},At.parse=function(t,e){var r=t[0],n=At.definitions[r];if(!n)return e.error('Unknown expression "'+r+'". If you wanted a literal array, use ["literal", [...]].',0);for(var i=Array.isArray(n)?n[0]:n.type,a=Array.isArray(n)?[[n[1],n[2]]]:n.overloads,o=a.filter(function(e){var r=e[0];return !Array.isArray(r)||r.length===t.length-1}),s=null,u=0,l=o;u<l.length;u+=1){var p=l[u],h=p[0],c=p[1];s=new Bt(e.registry,e.path,null,e.scope);for(var f=[],y=!1,d=1;d<t.length;d++){var m=t[d],v=Array.isArray(h)?h[d-1]:h.type,g=s.parse(m,1+f.length,v);if(!g){y=!0;break}f.push(g);}if(!y)if(Array.isArray(h)&&h.length!==f.length)s.error("Expected "+h.length+" arguments, but found "+f.length+" instead.");else{for(var x=0;x<f.length;x++){var b=Array.isArray(h)?h[x]:h.type,w=f[x];s.concat(x+1).checkSubtype(b,w.type);}if(0===s.errors.length)return new At(r,i,c,f)}}if(1===o.length)e.errors.push.apply(e.errors,s.errors);else{for(var _=(o.length?o:a).map(function(t){var e,r=t[0];return e=r,Array.isArray(e)?"("+e.map(et).join(", ")+")":"("+et(e.type)+"...)"}).join(" | "),A=[],k=1;k<t.length;k++){var S=e.parse(t[k],1+A.length);if(!S)return null;A.push(et(S.type));}e.error("Expected arguments of type "+_+", but found ("+A.join(", ")+") instead.");}return null},At.register=function(t,e){for(var r in At.definitions=e,e)t[r]=At;};var Mt=function(t,e){this.type=e.type,this.name=t,this.boundExpression=e;};Mt.parse=function(t,e){if(2!==t.length||"string"!=typeof t[1])return e.error("'var' expression requires exactly one string literal argument.");var r=t[1];return e.scope.has(r)?new Mt(r,e.scope.get(r)):e.error('Unknown variable "'+r+'". Make sure "'+r+'" has been bound in an enclosing "let" expression before using it.',1)},Mt.prototype.evaluate=function(t){return this.boundExpression.evaluate(t)},Mt.prototype.eachChild=function(){},Mt.prototype.possibleOutputs=function(){return [void 0]},Mt.prototype.serialize=function(){return ["var",this.name]};var Bt=function(t,e,r,n,i){void 0===e&&(e=[]),void 0===n&&(n=new Z),void 0===i&&(i=[]),this.registry=t,this.path=e,this.key=e.map(function(t){return "["+t+"]"}).join(""),this.scope=n,this.errors=i,this.expectedType=r;};function It(t,e){for(var r,n,i=0,a=t.length-1,o=0;i<=a;){if(r=t[o=Math.floor((i+a)/2)],n=t[o+1],e===r||e>r&&e<n)return o;if(r<e)i=o+1;else{if(!(r>e))throw new yt("Input is not a number.");a=o-1;}}return Math.max(o-1,0)}Bt.prototype.parse=function(t,e,r,n,i){return void 0===i&&(i={}),e?this.concat(e,r,n)._parse(t,i):this._parse(t,i)},Bt.prototype._parse=function(t,e){if(null!==t&&"string"!=typeof t&&"boolean"!=typeof t&&"number"!=typeof t||(t=["literal",t]),Array.isArray(t)){if(0===t.length)return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');var r=t[0];if("string"!=typeof r)return this.error("Expression name must be a string, but found "+typeof r+' instead. If you wanted a literal array, use ["literal", [...]].',0),null;var n=this.registry[r];if(n){var i=n.parse(t,this);if(!i)return null;if(this.expectedType){var a=this.expectedType,o=i.type;if("string"!==a.kind&&"number"!==a.kind&&"boolean"!==a.kind&&"object"!==a.kind||"value"!==o.kind)if("array"===a.kind&&"value"===o.kind)e.omitTypeAnnotations||(i=new gt(a,i));else if("color"!==a.kind||"value"!==o.kind&&"string"!==o.kind)if("formatted"!==a.kind||"value"!==o.kind&&"string"!==o.kind){if(this.checkSubtype(this.expectedType,i.type))return null}else e.omitTypeAnnotations||(i=new bt(a,[i]));else e.omitTypeAnnotations||(i=new bt(a,[i]));else e.omitTypeAnnotations||(i=new mt(a,[i]));}if(!(i instanceof ft)&&function t(e){if(e instanceof Mt)return t(e.boundExpression);if(e instanceof At&&"error"===e.name)return !1;if(e instanceof st)return !1;var r=e instanceof bt||e instanceof mt||e instanceof gt;var n=!0;e.eachChild(function(e){n=r?n&&t(e):n&&e instanceof ft;});if(!n)return !1;return kt(e)&&zt(e,["zoom","heatmap-density","line-progress","is-supported-script"])}(i)){var s=new _t;try{i=new ft(i.type,i.evaluate(s));}catch(t){return this.error(t.message),null}}return i}return this.error('Unknown expression "'+r+'". If you wanted a literal array, use ["literal", [...]].',0)}return void 0===t?this.error("'undefined' value invalid. Use null instead."):"object"==typeof t?this.error('Bare objects invalid. Use ["literal", {...}] instead.'):this.error("Expected an array, but found "+typeof t+" instead.")},Bt.prototype.concat=function(t,e,r){var n="number"==typeof t?this.path.concat(t):this.path,i=r?this.scope.concat(r):this.scope;return new Bt(this.registry,n,e||null,i,this.errors)},Bt.prototype.error=function(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];var n=""+this.key+e.map(function(t){return "["+t+"]"}).join("");this.errors.push(new N(n,t));},Bt.prototype.checkSubtype=function(t,e){var r=nt(t,e);return r&&this.error(r),r};var Ct=function(t,e,r){this.type=t,this.input=e,this.labels=[],this.outputs=[];for(var n=0,i=r;n<i.length;n+=1){var a=i[n],o=a[0],s=a[1];this.labels.push(o),this.outputs.push(s);}};Ct.parse=function(t,e){var r=t[1],n=t.slice(2);if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(!(r=e.parse(r,1,H)))return null;var i=[],a=null;e.expectedType&&"value"!==e.expectedType.kind&&(a=e.expectedType),n.unshift(-1/0);for(var o=0;o<n.length;o+=2){var s=n[o],u=n[o+1],l=o+1,p=o+2;if("number"!=typeof s)return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.',l);if(i.length&&i[i.length-1][0]>=s)return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.',l);var h=e.parse(u,p,a);if(!h)return null;a=a||h.type,i.push([s,h]);}return new Ct(a,r,i)},Ct.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;return n>=e[i-1]?r[i-1].evaluate(t):r[It(e,n)].evaluate(t)},Ct.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1){t(r[e]);}},Ct.prototype.possibleOutputs=function(){return (t=[]).concat.apply(t,this.outputs.map(function(t){return t.possibleOutputs()}));var t;},Ct.prototype.serialize=function(){for(var t=["step",this.input.serialize()],e=0;e<this.labels.length;e++)e>0&&t.push(this.labels[e]),t.push(this.outputs[e].serialize());return t};var Vt=Tt;function Tt(t,e,r,n){this.cx=3*t,this.bx=3*(r-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*e,this.by=3*(n-e)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=n,this.p2x=r,this.p2y=n;}function Et(t,e,r){return t*(1-r)+e*r}Tt.prototype.sampleCurveX=function(t){return ((this.ax*t+this.bx)*t+this.cx)*t},Tt.prototype.sampleCurveY=function(t){return ((this.ay*t+this.by)*t+this.cy)*t},Tt.prototype.sampleCurveDerivativeX=function(t){return (3*this.ax*t+2*this.bx)*t+this.cx},Tt.prototype.solveCurveX=function(t,e){var r,n,i,a,o;for(void 0===e&&(e=1e-6),i=t,o=0;o<8;o++){if(a=this.sampleCurveX(i)-t,Math.abs(a)<e)return i;var s=this.sampleCurveDerivativeX(i);if(Math.abs(s)<1e-6)break;i-=a/s;}if((i=t)<(r=0))return r;if(i>(n=1))return n;for(;r<n;){if(a=this.sampleCurveX(i),Math.abs(a-t)<e)return i;t>a?r=i:n=i,i=.5*(n-r)+r;}return i},Tt.prototype.solve=function(t,e){return this.sampleCurveY(this.solveCurveX(t,e))};var Pt=Object.freeze({number:Et,color:function(t,e,r){return new at(Et(t.r,e.r,r),Et(t.g,e.g,r),Et(t.b,e.b,r),Et(t.a,e.a,r))},array:function(t,e,r){return t.map(function(t,n){return Et(t,e[n],r)})}}),Ft=function(t,e,r,n){this.type=t,this.interpolation=e,this.input=r,this.labels=[],this.outputs=[];for(var i=0,a=n;i<a.length;i+=1){var o=a[i],s=o[0],u=o[1];this.labels.push(s),this.outputs.push(u);}};function Lt(t,e,r,n){var i=n-r,a=t-r;return 0===i?0:1===e?a/i:(Math.pow(e,a)-1)/(Math.pow(e,i)-1)}Ft.interpolationFactor=function(t,e,r,n){var i=0;if("exponential"===t.name)i=Lt(e,t.base,r,n);else if("linear"===t.name)i=Lt(e,1,r,n);else if("cubic-bezier"===t.name){var a=t.controlPoints;i=new Vt(a[0],a[1],a[2],a[3]).solve(Lt(e,1,r,n));}return i},Ft.parse=function(t,e){var r=t[1],n=t[2],i=t.slice(3);if(!Array.isArray(r)||0===r.length)return e.error("Expected an interpolation type expression.",1);if("linear"===r[0])r={name:"linear"};else if("exponential"===r[0]){var a=r[1];if("number"!=typeof a)return e.error("Exponential interpolation requires a numeric base.",1,1);r={name:"exponential",base:a};}else{if("cubic-bezier"!==r[0])return e.error("Unknown interpolation type "+String(r[0]),1,0);var o=r.slice(1);if(4!==o.length||o.some(function(t){return "number"!=typeof t||t<0||t>1}))return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.",1);r={name:"cubic-bezier",controlPoints:o};}if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(!(n=e.parse(n,2,H)))return null;var s=[],u=null;e.expectedType&&"value"!==e.expectedType.kind&&(u=e.expectedType);for(var l=0;l<i.length;l+=2){var p=i[l],h=i[l+1],c=l+3,f=l+4;if("number"!=typeof p)return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.',c);if(s.length&&s[s.length-1][0]>=p)return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.',c);var y=e.parse(h,f,u);if(!y)return null;u=u||y.type,s.push([p,y]);}return "number"===u.kind||"color"===u.kind||"array"===u.kind&&"number"===u.itemType.kind&&"number"==typeof u.N?new Ft(u,r,n,s):e.error("Type "+et(u)+" is not interpolatable.")},Ft.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;if(n>=e[i-1])return r[i-1].evaluate(t);var a=It(e,n),o=e[a],s=e[a+1],u=Ft.interpolationFactor(this.interpolation,n,o,s),l=r[a].evaluate(t),p=r[a+1].evaluate(t);return Pt[this.type.kind.toLowerCase()](l,p,u)},Ft.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1){t(r[e]);}},Ft.prototype.possibleOutputs=function(){return (t=[]).concat.apply(t,this.outputs.map(function(t){return t.possibleOutputs()}));var t;},Ft.prototype.serialize=function(){for(var t=["interpolate","linear"===this.interpolation.name?["linear"]:"exponential"===this.interpolation.name?1===this.interpolation.base?["linear"]:["exponential",this.interpolation.base]:["cubic-bezier"].concat(this.interpolation.controlPoints),this.input.serialize()],e=0;e<this.labels.length;e++)t.push(this.labels[e],this.outputs[e].serialize());return t};var Ot=function(t,e){this.type=t,this.args=e;};Ot.parse=function(t,e){if(t.length<2)return e.error("Expectected at least one argument.");var r=null,n=e.expectedType;n&&"value"!==n.kind&&(r=n);for(var i=[],a=0,o=t.slice(1);a<o.length;a+=1){var s=o[a],u=e.parse(s,1+i.length,r,void 0,{omitTypeAnnotations:!0});if(!u)return null;r=r||u.type,i.push(u);}var l=n&&i.some(function(t){return nt(n,t.type)});return new Ot(l?$:r,i)},Ot.prototype.evaluate=function(t){for(var e=null,r=0,n=this.args;r<n.length;r+=1){if(null!==(e=n[r].evaluate(t)))break}return e},Ot.prototype.eachChild=function(t){this.args.forEach(t);},Ot.prototype.possibleOutputs=function(){return (t=[]).concat.apply(t,this.args.map(function(t){return t.possibleOutputs()}));var t;},Ot.prototype.serialize=function(){var t=["coalesce"];return this.eachChild(function(e){t.push(e.serialize());}),t};var Dt=function(t,e){this.type=e.type,this.bindings=[].concat(t),this.result=e;};Dt.prototype.evaluate=function(t){return this.result.evaluate(t)},Dt.prototype.eachChild=function(t){for(var e=0,r=this.bindings;e<r.length;e+=1){t(r[e][1]);}t(this.result);},Dt.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found "+(t.length-1)+" instead.");for(var r=[],n=1;n<t.length-1;n+=2){var i=t[n];if("string"!=typeof i)return e.error("Expected string, but found "+typeof i+" instead.",n);if(/[^a-zA-Z0-9_]/.test(i))return e.error("Variable names must contain only alphanumeric characters or '_'.",n);var a=e.parse(t[n+1],n+1);if(!a)return null;r.push([i,a]);}var o=e.parse(t[t.length-1],t.length-1,void 0,r);return o?new Dt(r,o):null},Dt.prototype.possibleOutputs=function(){return this.result.possibleOutputs()},Dt.prototype.serialize=function(){for(var t=["let"],e=0,r=this.bindings;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];t.push(i,a.serialize());}return t.push(this.result.serialize()),t};var qt=function(t,e,r){this.type=t,this.index=e,this.input=r;};qt.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,H),n=e.parse(t[2],2,tt(e.expectedType||$));if(!r||!n)return null;var i=n.type;return new qt(i.itemType,r,n)},qt.prototype.evaluate=function(t){var e=this.index.evaluate(t),r=this.input.evaluate(t);if(e<0)throw new yt("Array index out of bounds: "+e+" < 0.");if(e>=r.length)throw new yt("Array index out of bounds: "+e+" > "+(r.length-1)+".");if(e!==Math.floor(e))throw new yt("Array index must be an integer, but found "+e+" instead.");return r[e]},qt.prototype.eachChild=function(t){t(this.index),t(this.input);},qt.prototype.possibleOutputs=function(){return [void 0]},qt.prototype.serialize=function(){return ["at",this.index.serialize(),this.input.serialize()]};var jt=function(t,e,r,n,i,a){this.inputType=t,this.type=e,this.input=r,this.cases=n,this.outputs=i,this.otherwise=a;};jt.parse=function(t,e){if(t.length<5)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if(t.length%2!=1)return e.error("Expected an even number of arguments.");var r,n;e.expectedType&&"value"!==e.expectedType.kind&&(n=e.expectedType);for(var i={},a=[],o=2;o<t.length-1;o+=2){var s=t[o],u=t[o+1];Array.isArray(s)||(s=[s]);var l=e.concat(o);if(0===s.length)return l.error("Expected at least one branch label.");for(var p=0,h=s;p<h.length;p+=1){var c=h[p];if("number"!=typeof c&&"string"!=typeof c)return l.error("Branch labels must be numbers or strings.");if("number"==typeof c&&Math.abs(c)>Number.MAX_SAFE_INTEGER)return l.error("Branch labels must be integers no larger than "+Number.MAX_SAFE_INTEGER+".");if("number"==typeof c&&Math.floor(c)!==c)return l.error("Numeric branch labels must be integer values.");if(r){if(l.checkSubtype(r,lt(c)))return null}else r=lt(c);if(void 0!==i[String(c)])return l.error("Branch labels must be unique.");i[String(c)]=a.length;}var f=e.parse(u,o,n);if(!f)return null;n=n||f.type,a.push(f);}var y=e.parse(t[1],1,$);if(!y)return null;var d=e.parse(t[t.length-1],t.length-1,n);return d?"value"!==y.type.kind&&e.concat(1).checkSubtype(r,y.type)?null:new jt(r,n,y,i,a,d):null},jt.prototype.evaluate=function(t){var e=this.input.evaluate(t);return (lt(e)===this.inputType&&this.outputs[this.cases[e]]||this.otherwise).evaluate(t)},jt.prototype.eachChild=function(t){t(this.input),this.outputs.forEach(t),t(this.otherwise);},jt.prototype.possibleOutputs=function(){return (t=[]).concat.apply(t,this.outputs.map(function(t){return t.possibleOutputs()})).concat(this.otherwise.possibleOutputs());var t;},jt.prototype.serialize=function(){for(var t=this,e=["match",this.input.serialize()],r=[],n={},i=0,a=Object.keys(this.cases).sort();i<a.length;i+=1){var o=a[i],s=n[t.cases[o]];void 0===s?(n[t.cases[o]]=r.length,r.push([t.cases[o],[o]])):r[s][1].push(o);}for(var u=function(e){return "number"===t.inputType.kind?Number(e):e},l=0,p=r;l<p.length;l+=1){var h=p[l],c=h[0],f=h[1];1===f.length?e.push(u(f[0])):e.push(f.map(u)),e.push(t.outputs[c].serialize());}return e.push(this.otherwise.serialize()),e};var Ut=function(t,e,r){this.type=t,this.branches=e,this.otherwise=r;};function Rt(t,e){return "=="===t||"!="===t?"boolean"===e.kind||"string"===e.kind||"number"===e.kind||"null"===e.kind||"value"===e.kind:"string"===e.kind||"number"===e.kind||"value"===e.kind}function Nt(t,e,r,n){return 0===n.compare(e,r)}function Zt(t,e,r){var n="=="!==t&&"!="!==t;return function(){function i(t,e,r){this.type=G,this.lhs=t,this.rhs=e,this.collator=r,this.hasUntypedArgument="value"===t.type.kind||"value"===e.type.kind;}return i.parse=function(t,e){if(3!==t.length&&4!==t.length)return e.error("Expected two or three arguments.");var r=t[0],a=e.parse(t[1],1,$);if(!a)return null;if(!Rt(r,a.type))return e.concat(1).error('"'+r+"\" comparisons are not supported for type '"+et(a.type)+"'.");var o=e.parse(t[2],2,$);if(!o)return null;if(!Rt(r,o.type))return e.concat(2).error('"'+r+"\" comparisons are not supported for type '"+et(o.type)+"'.");if(a.type.kind!==o.type.kind&&"value"!==a.type.kind&&"value"!==o.type.kind)return e.error("Cannot compare types '"+et(a.type)+"' and '"+et(o.type)+"'.");n&&("value"===a.type.kind&&"value"!==o.type.kind?a=new mt(o.type,[a]):"value"!==a.type.kind&&"value"===o.type.kind&&(o=new mt(a.type,[o])));var s=null;if(4===t.length){if("string"!==a.type.kind&&"string"!==o.type.kind&&"value"!==a.type.kind&&"value"!==o.type.kind)return e.error("Cannot use collator to compare non-string types.");if(!(s=e.parse(t[3],3,W)))return null}return new i(a,o,s)},i.prototype.evaluate=function(i){var a=this.lhs.evaluate(i),o=this.rhs.evaluate(i);if(n&&this.hasUntypedArgument){var s=lt(a),u=lt(o);if(s.kind!==u.kind||"string"!==s.kind&&"number"!==s.kind)throw new yt('Expected arguments for "'+t+'" to be (string, string) or (number, number), but found ('+s.kind+", "+u.kind+") instead.")}if(this.collator&&!n&&this.hasUntypedArgument){var l=lt(a),p=lt(o);if("string"!==l.kind||"string"!==p.kind)return e(i,a,o)}return this.collator?r(i,a,o,this.collator.evaluate(i)):e(i,a,o)},i.prototype.eachChild=function(t){t(this.lhs),t(this.rhs),this.collator&&t(this.collator);},i.prototype.possibleOutputs=function(){return [!0,!1]},i.prototype.serialize=function(){var e=[t];return this.eachChild(function(t){e.push(t.serialize());}),e},i}()}Ut.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found only "+(t.length-1)+".");if(t.length%2!=0)return e.error("Expected an odd number of arguments.");var r;e.expectedType&&"value"!==e.expectedType.kind&&(r=e.expectedType);for(var n=[],i=1;i<t.length-1;i+=2){var a=e.parse(t[i],i,G);if(!a)return null;var o=e.parse(t[i+1],i+1,r);if(!o)return null;n.push([a,o]),r=r||o.type;}var s=e.parse(t[t.length-1],t.length-1,r);return s?new Ut(r,n,s):null},Ut.prototype.evaluate=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];if(i.evaluate(t))return a.evaluate(t)}return this.otherwise.evaluate(t)},Ut.prototype.eachChild=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];t(i),t(a);}t(this.otherwise);},Ut.prototype.possibleOutputs=function(){return (t=[]).concat.apply(t,this.branches.map(function(t){t[0];return t[1].possibleOutputs()})).concat(this.otherwise.possibleOutputs());var t;},Ut.prototype.serialize=function(){var t=["case"];return this.eachChild(function(e){t.push(e.serialize());}),t};var Xt=Zt("==",function(t,e,r){return e===r},Nt),Ht=Zt("!=",function(t,e,r){return e!==r},function(t,e,r,n){return !Nt(0,e,r,n)}),Jt=Zt("<",function(t,e,r){return e<r},function(t,e,r,n){return n.compare(e,r)<0}),Gt=Zt(">",function(t,e,r){return e>r},function(t,e,r,n){return n.compare(e,r)>0}),Kt=Zt("<=",function(t,e,r){return e<=r},function(t,e,r,n){return n.compare(e,r)<=0}),Yt=Zt(">=",function(t,e,r){return e>=r},function(t,e,r,n){return n.compare(e,r)>=0}),$t=function(t){this.type=H,this.input=t;};$t.parse=function(t,e){if(2!==t.length)return e.error("Expected 1 argument, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1);return r?"array"!==r.type.kind&&"string"!==r.type.kind&&"value"!==r.type.kind?e.error("Expected argument of type string or array, but found "+et(r.type)+" instead."):new $t(r):null},$t.prototype.evaluate=function(t){var e=this.input.evaluate(t);if("string"==typeof e)return e.length;if(Array.isArray(e))return e.length;throw new yt("Expected value to be of type string or array, but found "+et(lt(e))+" instead.")},$t.prototype.eachChild=function(t){t(this.input);},$t.prototype.possibleOutputs=function(){return [void 0]},$t.prototype.serialize=function(){var t=["length"];return this.eachChild(function(e){t.push(e.serialize());}),t};var Wt={"==":Xt,"!=":Ht,">":Gt,"<":Jt,">=":Yt,"<=":Kt,array:gt,at:qt,boolean:mt,case:Ut,coalesce:Ot,collator:st,format:ct,interpolate:Ft,length:$t,let:Dt,literal:ft,match:jt,number:mt,object:mt,step:Ct,string:mt,"to-color":bt,"to-number":bt,var:Mt};function Qt(t,e){var r=e[0],n=e[1],i=e[2],a=e[3];r=r.evaluate(t),n=n.evaluate(t),i=i.evaluate(t);var o=a?a.evaluate(t):1,s=ut(r,n,i,o);if(s)throw new yt(s);return new at(r/255*o,n/255*o,i/255*o,o)}function te(t,e){return t in e}function ee(t,e){var r=e[t];return void 0===r?null:r}function re(t){return {type:t}}function ne(t){return {result:"success",value:t}}function ie(t){return {result:"error",value:t}}function ae(t){return "data-driven"===t["property-type"]||"cross-faded-data-driven"===t["property-type"]}function oe(t){return !!t.expression&&t.expression.parameters.indexOf("zoom")>-1}function se(t){return !!t.expression&&t.expression.interpolated}At.register(Wt,{error:[{kind:"error"},[J],function(t,e){var r=e[0];throw new yt(r.evaluate(t))}],typeof:[J,[$],function(t,e){return et(lt(e[0].evaluate(t)))}],"to-string":[J,[$],function(t,e){var r=e[0],n=typeof(r=r.evaluate(t));return null===r?"":"string"===n||"number"===n||"boolean"===n?String(r):r instanceof at||r instanceof ht?r.toString():JSON.stringify(r)}],"to-boolean":[G,[$],function(t,e){var r=e[0];return Boolean(r.evaluate(t))}],"to-rgba":[tt(H,4),[K],function(t,e){return e[0].evaluate(t).toArray()}],rgb:[K,[H,H,H],Qt],rgba:[K,[H,H,H,H],Qt],has:{type:G,overloads:[[[J],function(t,e){return te(e[0].evaluate(t),t.properties())}],[[J,Y],function(t,e){var r=e[0],n=e[1];return te(r.evaluate(t),n.evaluate(t))}]]},get:{type:$,overloads:[[[J],function(t,e){return ee(e[0].evaluate(t),t.properties())}],[[J,Y],function(t,e){var r=e[0],n=e[1];return ee(r.evaluate(t),n.evaluate(t))}]]},"feature-state":[$,[J],function(t,e){return ee(e[0].evaluate(t),t.featureState||{})}],properties:[Y,[],function(t){return t.properties()}],"geometry-type":[J,[],function(t){return t.geometryType()}],id:[$,[],function(t){return t.id()}],zoom:[H,[],function(t){return t.globals.zoom}],"heatmap-density":[H,[],function(t){return t.globals.heatmapDensity||0}],"line-progress":[H,[],function(t){return t.globals.lineProgress||0}],"+":[H,re(H),function(t,e){for(var r=0,n=0,i=e;n<i.length;n+=1){r+=i[n].evaluate(t);}return r}],"*":[H,re(H),function(t,e){for(var r=1,n=0,i=e;n<i.length;n+=1){r*=i[n].evaluate(t);}return r}],"-":{type:H,overloads:[[[H,H],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)-n.evaluate(t)}],[[H],function(t,e){return -e[0].evaluate(t)}]]},"/":[H,[H,H],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)/n.evaluate(t)}],"%":[H,[H,H],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)%n.evaluate(t)}],ln2:[H,[],function(){return Math.LN2}],pi:[H,[],function(){return Math.PI}],e:[H,[],function(){return Math.E}],"^":[H,[H,H],function(t,e){var r=e[0],n=e[1];return Math.pow(r.evaluate(t),n.evaluate(t))}],sqrt:[H,[H],function(t,e){var r=e[0];return Math.sqrt(r.evaluate(t))}],log10:[H,[H],function(t,e){var r=e[0];return Math.log10(r.evaluate(t))}],ln:[H,[H],function(t,e){var r=e[0];return Math.log(r.evaluate(t))}],log2:[H,[H],function(t,e){var r=e[0];return Math.log2(r.evaluate(t))}],sin:[H,[H],function(t,e){var r=e[0];return Math.sin(r.evaluate(t))}],cos:[H,[H],function(t,e){var r=e[0];return Math.cos(r.evaluate(t))}],tan:[H,[H],function(t,e){var r=e[0];return Math.tan(r.evaluate(t))}],asin:[H,[H],function(t,e){var r=e[0];return Math.asin(r.evaluate(t))}],acos:[H,[H],function(t,e){var r=e[0];return Math.acos(r.evaluate(t))}],atan:[H,[H],function(t,e){var r=e[0];return Math.atan(r.evaluate(t))}],min:[H,re(H),function(t,e){return Math.min.apply(Math,e.map(function(e){return e.evaluate(t)}))}],max:[H,re(H),function(t,e){return Math.max.apply(Math,e.map(function(e){return e.evaluate(t)}))}],abs:[H,[H],function(t,e){var r=e[0];return Math.abs(r.evaluate(t))}],round:[H,[H],function(t,e){var r=e[0].evaluate(t);return r<0?-Math.round(-r):Math.round(r)}],floor:[H,[H],function(t,e){var r=e[0];return Math.floor(r.evaluate(t))}],ceil:[H,[H],function(t,e){var r=e[0];return Math.ceil(r.evaluate(t))}],"filter-==":[G,[J,$],function(t,e){var r=e[0],n=e[1];return t.properties()[r.value]===n.value}],"filter-id-==":[G,[$],function(t,e){var r=e[0];return t.id()===r.value}],"filter-type-==":[G,[J],function(t,e){var r=e[0];return t.geometryType()===r.value}],"filter-<":[G,[J,$],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i<a}],"filter-id-<":[G,[$],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<i}],"filter->":[G,[J,$],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i>a}],"filter-id->":[G,[$],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>i}],"filter-<=":[G,[J,$],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i<=a}],"filter-id-<=":[G,[$],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<=i}],"filter->=":[G,[J,$],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i>=a}],"filter-id->=":[G,[$],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>=i}],"filter-has":[G,[$],function(t,e){return e[0].value in t.properties()}],"filter-has-id":[G,[],function(t){return null!==t.id()}],"filter-type-in":[G,[tt(J)],function(t,e){return e[0].value.indexOf(t.geometryType())>=0}],"filter-id-in":[G,[tt($)],function(t,e){return e[0].value.indexOf(t.id())>=0}],"filter-in-small":[G,[J,tt($)],function(t,e){var r=e[0];return e[1].value.indexOf(t.properties()[r.value])>=0}],"filter-in-large":[G,[J,tt($)],function(t,e){var r=e[0],n=e[1];return function(t,e,r,n){for(;r<=n;){var i=r+n>>1;if(e[i]===t)return !0;e[i]>t?n=i-1:r=i+1;}return !1}(t.properties()[r.value],n.value,0,n.value.length-1)}],all:{type:G,overloads:[[[G,G],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)&&n.evaluate(t)}],[re(G),function(t,e){for(var r=0,n=e;r<n.length;r+=1){if(!n[r].evaluate(t))return !1}return !0}]]},any:{type:G,overloads:[[[G,G],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)||n.evaluate(t)}],[re(G),function(t,e){for(var r=0,n=e;r<n.length;r+=1){if(n[r].evaluate(t))return !0}return !1}]]},"!":[G,[G],function(t,e){return !e[0].evaluate(t)}],"is-supported-script":[G,[J],function(t,e){var r=e[0],n=t.globals&&t.globals.isSupportedScript;return !n||n(r.evaluate(t))}],upcase:[J,[J],function(t,e){return e[0].evaluate(t).toUpperCase()}],downcase:[J,[J],function(t,e){return e[0].evaluate(t).toLowerCase()}],concat:[J,re(J),function(t,e){return e.map(function(e){return e.evaluate(t)}).join("")}],"resolved-locale":[J,[W],function(t,e){return e[0].evaluate(t).resolvedLocale()}]});var ue=.95047,le=1,pe=1.08883,he=4/29,ce=6/29,fe=3*ce*ce,ye=ce*ce*ce,de=Math.PI/180,me=180/Math.PI;function ve(t){return t>ye?Math.pow(t,1/3):t/fe+he}function ge(t){return t>ce?t*t*t:fe*(t-he)}function xe(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function be(t){return (t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function we(t){var e=be(t.r),r=be(t.g),n=be(t.b),i=ve((.4124564*e+.3575761*r+.1804375*n)/ue),a=ve((.2126729*e+.7151522*r+.072175*n)/le);return {l:116*a-16,a:500*(i-a),b:200*(a-ve((.0193339*e+.119192*r+.9503041*n)/pe)),alpha:t.a}}function _e(t){var e=(t.l+16)/116,r=isNaN(t.a)?e:e+t.a/500,n=isNaN(t.b)?e:e-t.b/200;return e=le*ge(e),r=ue*ge(r),n=pe*ge(n),new at(xe(3.2404542*r-1.5371385*e-.4985314*n),xe(-.969266*r+1.8760108*e+.041556*n),xe(.0556434*r-.2040259*e+1.0572252*n),t.alpha)}var Ae={forward:we,reverse:_e,interpolate:function(t,e,r){return {l:Et(t.l,e.l,r),a:Et(t.a,e.a,r),b:Et(t.b,e.b,r),alpha:Et(t.alpha,e.alpha,r)}}},ke={forward:function(t){var e=we(t),r=e.l,n=e.a,i=e.b,a=Math.atan2(i,n)*me;return {h:a<0?a+360:a,c:Math.sqrt(n*n+i*i),l:r,alpha:t.a}},reverse:function(t){var e=t.h*de,r=t.c;return _e({l:t.l,a:Math.cos(e)*r,b:Math.sin(e)*r,alpha:t.alpha})},interpolate:function(t,e,r){return {h:function(t,e,r){var n=e-t;return t+r*(n>180||n<-180?n-360*Math.round(n/360):n)}(t.h,e.h,r),c:Et(t.c,e.c,r),l:Et(t.l,e.l,r),alpha:Et(t.alpha,e.alpha,r)}}},Se=Object.freeze({lab:Ae,hcl:ke});function ze(t){return t instanceof Number?"number":t instanceof String?"string":t instanceof Boolean?"boolean":Array.isArray(t)?"array":null===t?"null":typeof t}function Me(t){return "object"==typeof t&&null!==t&&!Array.isArray(t)}function Be(t){return t}function Ie(t,e,r){return void 0!==t?t:void 0!==e?e:void 0!==r?r:void 0}function Ce(t,e,r,n,i){return Ie(typeof r===i?n[r]:void 0,t.default,e.default)}function Ve(t,e,r){if("number"!==ze(r))return Ie(t.default,e.default);var n=t.stops.length;if(1===n)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[n-1][0])return t.stops[n-1][1];var i=Pe(t.stops,r);return t.stops[i][1]}function Te(t,e,r){var n=void 0!==t.base?t.base:1;if("number"!==ze(r))return Ie(t.default,e.default);var i=t.stops.length;if(1===i)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[i-1][0])return t.stops[i-1][1];var a=Pe(t.stops,r),o=function(t,e,r,n){var i=n-r,a=t-r;return 0===i?0:1===e?a/i:(Math.pow(e,a)-1)/(Math.pow(e,i)-1)}(r,n,t.stops[a][0],t.stops[a+1][0]),s=t.stops[a][1],u=t.stops[a+1][1],l=Pt[e.type]||Be;if(t.colorSpace&&"rgb"!==t.colorSpace){var p=Se[t.colorSpace];l=function(t,e){return p.reverse(p.interpolate(p.forward(t),p.forward(e),o))};}return "function"==typeof s.evaluate?{evaluate:function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];var r=s.evaluate.apply(void 0,t),n=u.evaluate.apply(void 0,t);if(void 0!==r&&void 0!==n)return l(r,n,o)}}:l(s,u,o)}function Ee(t,e,r){return "color"===e.type?r=at.parse(r):ze(r)===e.type||"enum"===e.type&&e.values[r]||(r=void 0),Ie(r,t.default,e.default)}function Pe(t,e){for(var r,n,i=0,a=t.length-1,o=0;i<=a;){if(r=t[o=Math.floor((i+a)/2)][0],n=t[o+1][0],e===r||e>r&&e<n)return o;r<e?i=o+1:r>e&&(a=o-1);}return Math.max(o-1,0)}var Fe=function(t,e){var r;this.expression=t,this._warningHistory={},this._defaultValue="color"===(r=e).type&&Me(r.default)?new at(0,0,0,0):"color"===r.type?at.parse(r.default)||null:void 0===r.default?null:r.default,"enum"===e.type&&(this._enumValues=e.values);};function Le(t){return Array.isArray(t)&&t.length>0&&"string"==typeof t[0]&&t[0]in Wt}function Oe(t,e){var r=new Bt(Wt,[],function(t){var e={color:K,string:J,number:H,enum:J,boolean:G};if("array"===t.type)return tt(e[t.value]||$,t.length);return e[t.type]||null}(e)),n=r.parse(t);return n?ne(new Fe(n,e)):ie(r.errors)}Fe.prototype.evaluateWithoutErrorHandling=function(t,e,r){return this._evaluator||(this._evaluator=new _t),this._evaluator.globals=t,this._evaluator.feature=e,this._evaluator.featureState=r,this.expression.evaluate(this._evaluator)},Fe.prototype.evaluate=function(t,e,r){this._evaluator||(this._evaluator=new _t),this._evaluator.globals=t,this._evaluator.feature=e,this._evaluator.featureState=r;try{var n=this.expression.evaluate(this._evaluator);if(null==n)return this._defaultValue;if(this._enumValues&&!(n in this._enumValues))throw new yt("Expected value to be one of "+Object.keys(this._enumValues).map(function(t){return JSON.stringify(t)}).join(", ")+", but found "+JSON.stringify(n)+" instead.");return n}catch(t){return this._warningHistory[t.message]||(this._warningHistory[t.message]=!0,"undefined"!=typeof console&&console.warn(t.message)),this._defaultValue}};var De=function(t,e){this.kind=t,this._styleExpression=e,this.isStateDependent="constant"!==t&&!St(e.expression);};De.prototype.evaluateWithoutErrorHandling=function(t,e,r){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r)},De.prototype.evaluate=function(t,e,r){return this._styleExpression.evaluate(t,e,r)};var qe=function(t,e,r){this.kind=t,this.zoomStops=r.labels,this._styleExpression=e,this.isStateDependent="camera"!==t&&!St(e.expression),r instanceof Ft&&(this._interpolationType=r.interpolation);};function je(t,e){if("error"===(t=Oe(t,e)).result)return t;var r=t.value.expression,n=kt(r);if(!n&&!ae(e))return ie([new N("","data expressions not supported")]);var i=zt(r,["zoom"]);if(!i&&!oe(e))return ie([new N("","zoom expressions not supported")]);var a=function t(e){var r=null;if(e instanceof Dt)r=t(e.result);else if(e instanceof Ot)for(var n=0,i=e.args;n<i.length;n+=1){var a=i[n];if(r=t(a))break}else(e instanceof Ct||e instanceof Ft)&&e.input instanceof At&&"zoom"===e.input.name&&(r=e);if(r instanceof N)return r;e.eachChild(function(e){var n=t(e);n instanceof N?r=n:!r&&n?r=new N("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.'):r&&n&&r!==n&&(r=new N("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));});return r}(r);return a||i?a instanceof N?ie([a]):a instanceof Ft&&!se(e)?ie([new N("",'"interpolate" expressions cannot be used with this property')]):ne(a?new qe(n?"camera":"composite",t.value,a):new De(n?"constant":"source",t.value)):ie([new N("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')])}qe.prototype.evaluateWithoutErrorHandling=function(t,e,r){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r)},qe.prototype.evaluate=function(t,e,r){return this._styleExpression.evaluate(t,e,r)},qe.prototype.interpolationFactor=function(t,e,r){return this._interpolationType?Ft.interpolationFactor(this._interpolationType,t,e,r):0};var Ue=function(t,e){this._parameters=t,this._specification=e,j(this,function t(e,r){var n,i,a,o="color"===r.type,s=e.stops&&"object"==typeof e.stops[0][0],u=s||void 0!==e.property,l=s||!u,p=e.type||(se(r)?"exponential":"interval");if(o&&((e=j({},e)).stops&&(e.stops=e.stops.map(function(t){return [t[0],at.parse(t[1])]})),e.default?e.default=at.parse(e.default):e.default=at.parse(r.default)),e.colorSpace&&"rgb"!==e.colorSpace&&!Se[e.colorSpace])throw new Error("Unknown color space: "+e.colorSpace);if("exponential"===p)n=Te;else if("interval"===p)n=Ve;else if("categorical"===p){n=Ce,i=Object.create(null);for(var h=0,c=e.stops;h<c.length;h+=1){var f=c[h];i[f[0]]=f[1];}a=typeof e.stops[0][0];}else{if("identity"!==p)throw new Error('Unknown function type "'+p+'"');n=Ee;}if(s){for(var y={},d=[],m=0;m<e.stops.length;m++){var v=e.stops[m],g=v[0].zoom;void 0===y[g]&&(y[g]={zoom:g,type:e.type,property:e.property,default:e.default,stops:[]},d.push(g)),y[g].stops.push([v[0].value,v[1]]);}for(var x=[],b=0,w=d;b<w.length;b+=1){var _=w[b];x.push([y[_].zoom,t(y[_],r)]);}return {kind:"composite",interpolationFactor:Ft.interpolationFactor.bind(void 0,{name:"linear"}),zoomStops:x.map(function(t){return t[0]}),evaluate:function(t,n){var i=t.zoom;return Te({stops:x,base:e.base},r,i).evaluate(i,n)}}}return l?{kind:"camera",interpolationFactor:"exponential"===p?Ft.interpolationFactor.bind(void 0,{name:"exponential",base:void 0!==e.base?e.base:1}):function(){return 0},zoomStops:e.stops.map(function(t){return t[0]}),evaluate:function(t){var o=t.zoom;return n(e,r,o,i,a)}}:{kind:"source",evaluate:function(t,o){var s=o&&o.properties?o.properties[e.property]:void 0;return void 0===s?Ie(e.default,r.default):n(e,r,s,i,a)}}}(this._parameters,this._specification));};function Re(t,e){if(Me(t))return new Ue(t,e);if(Le(t)){var r=je(t,e);if("error"===r.result)throw new Error(r.value.map(function(t){return t.key+": "+t.message}).join(", "));return r.value}var n=t;return "string"==typeof t&&"color"===e.type&&(n=at.parse(t)),{kind:"constant",evaluate:function(){return n}}}function Ne(t){var e=t.key,r=t.value,n=t.valueSpec||{},i=t.objectElementValidators||{},a=t.style,o=t.styleSpec,s=[],u=ze(r);if("object"!==u)return [new D(e,r,"object expected, "+u+" found")];for(var l in r){var p=l.split(".")[0],h=n[p]||n["*"],c=void 0;if(i[p])c=i[p];else if(n[p])c=fr;else if(i["*"])c=i["*"];else{if(!n["*"]){s.push(new D(e,r[l],'unknown property "'+l+'"'));continue}c=fr;}s=s.concat(c({key:(e?e+".":e)+l,value:r[l],valueSpec:h,style:a,styleSpec:o,object:r,objectKey:l},r));}for(var f in n)i[f]||n[f].required&&void 0===n[f].default&&void 0===r[f]&&s.push(new D(e,r,'missing required property "'+f+'"'));return s}function Ze(t){var e=t.value,r=t.valueSpec,n=t.style,i=t.styleSpec,a=t.key,o=t.arrayElementValidator||fr;if("array"!==ze(e))return [new D(a,e,"array expected, "+ze(e)+" found")];if(r.length&&e.length!==r.length)return [new D(a,e,"array length "+r.length+" expected, length "+e.length+" found")];if(r["min-length"]&&e.length<r["min-length"])return [new D(a,e,"array length at least "+r["min-length"]+" expected, length "+e.length+" found")];var s={type:r.value};i.$version<7&&(s.function=r.function),"object"===ze(r.value)&&(s=r.value);for(var u=[],l=0;l<e.length;l++)u=u.concat(o({array:e,arrayIndex:l,value:e[l],valueSpec:s,style:n,styleSpec:i,key:a+"["+l+"]"}));return u}function Xe(t){var e=t.key,r=t.value,n=t.valueSpec,i=ze(r);return "number"!==i?[new D(e,r,"number expected, "+i+" found")]:"minimum"in n&&r<n.minimum?[new D(e,r,r+" is less than the minimum value "+n.minimum)]:"maximum"in n&&r>n.maximum?[new D(e,r,r+" is greater than the maximum value "+n.maximum)]:[]}function He(t){var e,r,n,i=t.valueSpec,a=U(t.value.type),o={},s="categorical"!==a&&void 0===t.value.property,u=!s,l="array"===ze(t.value.stops)&&"array"===ze(t.value.stops[0])&&"object"===ze(t.value.stops[0][0]),p=Ne({key:t.key,value:t.value,valueSpec:t.styleSpec.function,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{stops:function(t){if("identity"===a)return [new D(t.key,t.value,'identity function may not have a "stops" property')];var e=[],r=t.value;e=e.concat(Ze({key:t.key,value:r,valueSpec:t.valueSpec,style:t.style,styleSpec:t.styleSpec,arrayElementValidator:h})),"array"===ze(r)&&0===r.length&&e.push(new D(t.key,r,"array must have at least one stop"));return e},default:function(t){return fr({key:t.key,value:t.value,valueSpec:i,style:t.style,styleSpec:t.styleSpec})}}});return "identity"===a&&s&&p.push(new D(t.key,t.value,'missing required property "property"')),"identity"===a||t.value.stops||p.push(new D(t.key,t.value,'missing required property "stops"')),"exponential"===a&&t.valueSpec.expression&&!se(t.valueSpec)&&p.push(new D(t.key,t.value,"exponential functions not supported")),t.styleSpec.$version>=8&&(u&&!ae(t.valueSpec)?p.push(new D(t.key,t.value,"property functions not supported")):s&&!oe(t.valueSpec)&&p.push(new D(t.key,t.value,"zoom functions not supported"))),"categorical"!==a&&!l||void 0!==t.value.property||p.push(new D(t.key,t.value,'"property" property is required')),p;function h(t){var e=[],a=t.value,s=t.key;if("array"!==ze(a))return [new D(s,a,"array expected, "+ze(a)+" found")];if(2!==a.length)return [new D(s,a,"array length 2 expected, length "+a.length+" found")];if(l){if("object"!==ze(a[0]))return [new D(s,a,"object expected, "+ze(a[0])+" found")];if(void 0===a[0].zoom)return [new D(s,a,"object stop key must have zoom")];if(void 0===a[0].value)return [new D(s,a,"object stop key must have value")];if(n&&n>U(a[0].zoom))return [new D(s,a[0].zoom,"stop zoom values must appear in ascending order")];U(a[0].zoom)!==n&&(n=U(a[0].zoom),r=void 0,o={}),e=e.concat(Ne({key:s+"[0]",value:a[0],valueSpec:{zoom:{}},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{zoom:Xe,value:c}}));}else e=e.concat(c({key:s+"[0]",value:a[0],valueSpec:{},style:t.style,styleSpec:t.styleSpec},a));return e.concat(fr({key:s+"[1]",value:a[1],valueSpec:i,style:t.style,styleSpec:t.styleSpec}))}function c(t,n){var s=ze(t.value),u=U(t.value),l=null!==t.value?t.value:n;if(e){if(s!==e)return [new D(t.key,l,s+" stop domain type must match previous stop domain type "+e)]}else e=s;if("number"!==s&&"string"!==s&&"boolean"!==s)return [new D(t.key,l,"stop domain value must be a number, string, or boolean")];if("number"!==s&&"categorical"!==a){var p="number expected, "+s+" found";return ae(i)&&void 0===a&&(p+='\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),[new D(t.key,l,p)]}return "categorical"!==a||"number"!==s||isFinite(u)&&Math.floor(u)===u?"categorical"!==a&&"number"===s&&void 0!==r&&u<r?[new D(t.key,l,"stop domain values must appear in ascending order")]:(r=u,"categorical"===a&&u in o?[new D(t.key,l,"stop domain values must be unique")]:(o[u]=!0,[])):[new D(t.key,l,"integer expected, found "+u)]}}function Je(t){var e=("property"===t.expressionContext?je:Oe)(R(t.value),t.valueSpec);return "error"===e.result?e.value.map(function(e){return new D(""+t.key+e.key,t.value,e.message)}):"property"===t.expressionContext&&"text-font"===t.propertyKey&&-1!==e.value._styleExpression.expression.possibleOutputs().indexOf(void 0)?[new D(t.key,t.value,'Invalid data expression for "text-font". Output values must be contained as literals within the expression.')]:"property"!==t.expressionContext||"layout"!==t.propertyType||St(e.value._styleExpression.expression)?[]:[new D(t.key,t.value,'"feature-state" data expressions are not supported with layout properties.')]}function Ge(t){var e=t.key,r=t.value,n=t.valueSpec,i=[];return Array.isArray(n.values)?-1===n.values.indexOf(U(r))&&i.push(new D(e,r,"expected one of ["+n.values.join(", ")+"], "+JSON.stringify(r)+" found")):-1===Object.keys(n.values).indexOf(U(r))&&i.push(new D(e,r,"expected one of ["+Object.keys(n.values).join(", ")+"], "+JSON.stringify(r)+" found")),i}function Ke(t){if(!Array.isArray(t)||0===t.length)return !1;switch(t[0]){case"has":return t.length>=2&&"$id"!==t[1]&&"$type"!==t[1];case"in":case"!in":case"!has":case"none":return !1;case"==":case"!=":case">":case">=":case"<":case"<=":return 3!==t.length||Array.isArray(t[1])||Array.isArray(t[2]);case"any":case"all":for(var e=0,r=t.slice(1);e<r.length;e+=1){var n=r[e];if(!Ke(n)&&"boolean"!=typeof n)return !1}return !0;default:return !0}}Ue.deserialize=function(t){return new Ue(t._parameters,t._specification)},Ue.serialize=function(t){return {_parameters:t._parameters,_specification:t._specification}};var Ye={type:"boolean",default:!1,transition:!1,"property-type":"data-driven",expression:{interpolated:!1,parameters:["zoom","feature"]}};function $e(t){if(!t)return function(){return !0};Ke(t)||(t=Qe(t));var e=Oe(t,Ye);if("error"===e.result)throw new Error(e.value.map(function(t){return t.key+": "+t.message}).join(", "));return function(t,r){return e.value.evaluate(t,r)}}function We(t,e){return t<e?-1:t>e?1:0}function Qe(t){if(!t)return !0;var e,r=t[0];return t.length<=1?"any"!==r:"=="===r?tr(t[1],t[2],"=="):"!="===r?nr(tr(t[1],t[2],"==")):"<"===r||">"===r||"<="===r||">="===r?tr(t[1],t[2],r):"any"===r?(e=t.slice(1),["any"].concat(e.map(Qe))):"all"===r?["all"].concat(t.slice(1).map(Qe)):"none"===r?["all"].concat(t.slice(1).map(Qe).map(nr)):"in"===r?er(t[1],t.slice(2)):"!in"===r?nr(er(t[1],t.slice(2))):"has"===r?rr(t[1]):"!has"!==r||nr(rr(t[1]))}function tr(t,e,r){switch(t){case"$type":return ["filter-type-"+r,e];case"$id":return ["filter-id-"+r,e];default:return ["filter-"+r,t,e]}}function er(t,e){if(0===e.length)return !1;switch(t){case"$type":return ["filter-type-in",["literal",e]];case"$id":return ["filter-id-in",["literal",e]];default:return e.length>200&&!e.some(function(t){return typeof t!=typeof e[0]})?["filter-in-large",t,["literal",e.sort(We)]]:["filter-in-small",t,["literal",e]]}}function rr(t){switch(t){case"$type":return !0;case"$id":return ["filter-has-id"];default:return ["filter-has",t]}}function nr(t){return ["!",t]}function ir(t){return Ke(R(t.value))?Je(j({},t,{expressionContext:"filter",valueSpec:{value:"boolean"}})):function t(e){var r=e.value;var n=e.key;if("array"!==ze(r))return [new D(n,r,"array expected, "+ze(r)+" found")];var i=e.styleSpec;var a;var o=[];if(r.length<1)return [new D(n,r,"filter array must have at least 1 element")];o=o.concat(Ge({key:n+"[0]",value:r[0],valueSpec:i.filter_operator,style:e.style,styleSpec:e.styleSpec}));switch(U(r[0])){case"<":case"<=":case">":case">=":r.length>=2&&"$type"===U(r[1])&&o.push(new D(n,r,'"$type" cannot be use with operator "'+r[0]+'"'));case"==":case"!=":3!==r.length&&o.push(new D(n,r,'filter array for operator "'+r[0]+'" must have 3 elements'));case"in":case"!in":r.length>=2&&"string"!==(a=ze(r[1]))&&o.push(new D(n+"[1]",r[1],"string expected, "+a+" found"));for(var s=2;s<r.length;s++)a=ze(r[s]),"$type"===U(r[1])?o=o.concat(Ge({key:n+"["+s+"]",value:r[s],valueSpec:i.geometry_type,style:e.style,styleSpec:e.styleSpec})):"string"!==a&&"number"!==a&&"boolean"!==a&&o.push(new D(n+"["+s+"]",r[s],"string, number, or boolean expected, "+a+" found"));break;case"any":case"all":case"none":for(var u=1;u<r.length;u++)o=o.concat(t({key:n+"["+u+"]",value:r[u],style:e.style,styleSpec:e.styleSpec}));break;case"has":case"!has":a=ze(r[1]),2!==r.length?o.push(new D(n,r,'filter array for "'+r[0]+'" operator must have 2 elements')):"string"!==a&&o.push(new D(n+"[1]",r[1],"string expected, "+a+" found"));}return o}(t)}function ar(t,e){var r=t.key,n=t.style,i=t.styleSpec,a=t.value,o=t.objectKey,s=i[e+"_"+t.layerType];if(!s)return [];var u=o.match(/^(.*)-transition$/);if("paint"===e&&u&&s[u[1]]&&s[u[1]].transition)return fr({key:r,value:a,valueSpec:i.transition,style:n,styleSpec:i});var l,p=t.valueSpec||s[o];if(!p)return [new D(r,a,'unknown property "'+o+'"')];if("string"===ze(a)&&ae(p)&&!p.tokens&&(l=/^{([^}]+)}$/.exec(a)))return [new D(r,a,'"'+o+'" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": '+JSON.stringify(l[1])+" }`.")];var h=[];return "symbol"===t.layerType&&("text-field"===o&&n&&!n.glyphs&&h.push(new D(r,a,'use of "text-field" requires a style "glyphs" property')),"text-font"===o&&Me(R(a))&&"identity"===U(a.type)&&h.push(new D(r,a,'"text-font" does not support identity functions'))),h.concat(fr({key:t.key,value:a,valueSpec:p,style:n,styleSpec:i,expressionContext:"property",propertyType:e,propertyKey:o}))}function or(t){return ar(t,"paint")}function sr(t){return ar(t,"layout")}function ur(t){var e=[],r=t.value,n=t.key,i=t.style,a=t.styleSpec;r.type||r.ref||e.push(new D(n,r,'either "type" or "ref" is required'));var o,s=U(r.type),u=U(r.ref);if(r.id)for(var l=U(r.id),p=0;p<t.arrayIndex;p++){var h=i.layers[p];U(h.id)===l&&e.push(new D(n,r.id,'duplicate layer id "'+r.id+'", previously used at line '+h.id.__line__));}if("ref"in r)["type","source","source-layer","filter","layout"].forEach(function(t){t in r&&e.push(new D(n,r[t],'"'+t+'" is prohibited for ref layers'));}),i.layers.forEach(function(t){U(t.id)===u&&(o=t);}),o?o.ref?e.push(new D(n,r.ref,"ref cannot reference another ref layer")):s=U(o.type):e.push(new D(n,r.ref,'ref layer "'+u+'" not found'));else if("background"!==s)if(r.source){var c=i.sources&&i.sources[r.source],f=c&&U(c.type);c?"vector"===f&&"raster"===s?e.push(new D(n,r.source,'layer "'+r.id+'" requires a raster source')):"raster"===f&&"raster"!==s?e.push(new D(n,r.source,'layer "'+r.id+'" requires a vector source')):"vector"!==f||r["source-layer"]?"raster-dem"===f&&"hillshade"!==s?e.push(new D(n,r.source,"raster-dem source can only be used with layer type 'hillshade'.")):"line"!==s||!r.paint||!r.paint["line-gradient"]||"geojson"===f&&c.lineMetrics||e.push(new D(n,r,'layer "'+r.id+'" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')):e.push(new D(n,r,'layer "'+r.id+'" must specify a "source-layer"')):e.push(new D(n,r.source,'source "'+r.source+'" not found'));}else e.push(new D(n,r,'missing required property "source"'));return e=e.concat(Ne({key:n,value:r,valueSpec:a.layer,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(){return []},type:function(){return fr({key:n+".type",value:r.type,valueSpec:a.layer.type,style:t.style,styleSpec:t.styleSpec,object:r,objectKey:"type"})},filter:ir,layout:function(t){return Ne({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return sr(j({layerType:s},t))}}})},paint:function(t){return Ne({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return or(j({layerType:s},t))}}})}}}))}function lr(t){var e=t.value,r=t.key,n=t.styleSpec,i=t.style;if(!e.type)return [new D(r,e,'"type" is required')];var a=U(e.type),o=[];switch(a){case"vector":case"raster":case"raster-dem":if(o=o.concat(Ne({key:r,value:e,valueSpec:n["source_"+a.replace("-","_")],style:t.style,styleSpec:n})),"url"in e)for(var s in e)["type","url","tileSize"].indexOf(s)<0&&o.push(new D(r+"."+s,e[s],'a source with a "url" property may not include a "'+s+'" property'));return o;case"geojson":return Ne({key:r,value:e,valueSpec:n.source_geojson,style:i,styleSpec:n});case"video":return Ne({key:r,value:e,valueSpec:n.source_video,style:i,styleSpec:n});case"image":return Ne({key:r,value:e,valueSpec:n.source_image,style:i,styleSpec:n});case"canvas":return o.push(new D(r,null,"Please use runtime APIs to add canvas sources, rather than including them in stylesheets.","source.canvas")),o;default:return Ge({key:r+".type",value:e.type,valueSpec:{values:["vector","raster","raster-dem","geojson","video","image"]},style:i,styleSpec:n})}}function pr(t){var e=t.value,r=t.styleSpec,n=r.light,i=t.style,a=[],o=ze(e);if(void 0===e)return a;if("object"!==o)return a=a.concat([new D("light",e,"object expected, "+o+" found")]);for(var s in e){var u=s.match(/^(.*)-transition$/);a=u&&n[u[1]]&&n[u[1]].transition?a.concat(fr({key:s,value:e[s],valueSpec:r.transition,style:i,styleSpec:r})):n[s]?a.concat(fr({key:s,value:e[s],valueSpec:n[s],style:i,styleSpec:r})):a.concat([new D(s,e[s],'unknown property "'+s+'"')]);}return a}function hr(t){var e=t.value,r=t.key,n=ze(e);return "string"!==n?[new D(r,e,"string expected, "+n+" found")]:[]}var cr={"*":function(){return []},array:Ze,boolean:function(t){var e=t.value,r=t.key,n=ze(e);return "boolean"!==n?[new D(r,e,"boolean expected, "+n+" found")]:[]},number:Xe,color:function(t){var e=t.key,r=t.value,n=ze(r);return "string"!==n?[new D(e,r,"color expected, "+n+" found")]:null===it(r)?[new D(e,r,'color expected, "'+r+'" found')]:[]},constants:q,enum:Ge,filter:ir,function:He,layer:ur,object:Ne,source:lr,light:pr,string:hr,formatted:function(t){return 0===hr(t).length?[]:Je(t)}};function fr(t){var e=t.value,r=t.valueSpec,n=t.styleSpec;return r.expression&&Me(U(e))?He(t):r.expression&&Le(R(e))?Je(t):r.type&&cr[r.type]?cr[r.type](t):Ne(j({},t,{valueSpec:r.type?n[r.type]:r}))}function yr(t){var e=t.value,r=t.key,n=hr(t);return n.length?n:(-1===e.indexOf("{fontstack}")&&n.push(new D(r,e,'"glyphs" url must include a "{fontstack}" token')),-1===e.indexOf("{range}")&&n.push(new D(r,e,'"glyphs" url must include a "{range}" token')),n)}function dr(t,e){e=e||O;var r=[];return r=r.concat(fr({key:"",value:t,valueSpec:e.$root,styleSpec:e,style:t,objectElementValidators:{glyphs:yr,"*":function(){return []}}})),t.constants&&(r=r.concat(q({key:"constants",value:t.constants,style:t,styleSpec:e}))),mr(r)}function mr(t){return [].concat(t).sort(function(t,e){return t.line-e.line})}function vr(t){return function(){return mr(t.apply(this,arguments))}}dr.source=vr(lr),dr.light=vr(pr),dr.layer=vr(ur),dr.filter=vr(ir),dr.paintProperty=vr(or),dr.layoutProperty=vr(sr);var gr=dr,xr=dr.light,br=dr.paintProperty,wr=dr.layoutProperty;function _r(t,e){var r=!1;if(e&&e.length)for(var n=0,i=e;n<i.length;n+=1){var a=i[n];t.fire(new F(new Error(a.message))),r=!0;}return r}var Ar=Sr,kr=3;function Sr(t,e,r){var n=this.cells=[];if(t instanceof ArrayBuffer){this.arrayBuffer=t;var i=new Int32Array(this.arrayBuffer);t=i[0],e=i[1],r=i[2],this.d=e+2*r;for(var a=0;a<this.d*this.d;a++){var o=i[kr+a],s=i[kr+a+1];n.push(o===s?null:i.subarray(o,s));}var u=i[kr+n.length],l=i[kr+n.length+1];this.keys=i.subarray(u,l),this.bboxes=i.subarray(l),this.insert=this._insertReadonly;}else{this.d=e+2*r;for(var p=0;p<this.d*this.d;p++)n.push([]);this.keys=[],this.bboxes=[];}this.n=e,this.extent=t,this.padding=r,this.scale=e/t,this.uid=0;var h=r/e*t;this.min=-h,this.max=t+h;}Sr.prototype.insert=function(t,e,r,n,i){this._forEachCell(e,r,n,i,this._insertCell,this.uid++),this.keys.push(t),this.bboxes.push(e),this.bboxes.push(r),this.bboxes.push(n),this.bboxes.push(i);},Sr.prototype._insertReadonly=function(){throw"Cannot insert into a GridIndex created from an ArrayBuffer."},Sr.prototype._insertCell=function(t,e,r,n,i,a){this.cells[i].push(a);},Sr.prototype.query=function(t,e,r,n){var i=this.min,a=this.max;if(t<=i&&e<=i&&a<=r&&a<=n)return Array.prototype.slice.call(this.keys);var o=[];return this._forEachCell(t,e,r,n,this._queryCell,o,{}),o},Sr.prototype._queryCell=function(t,e,r,n,i,a,o){var s=this.cells[i];if(null!==s)for(var u=this.keys,l=this.bboxes,p=0;p<s.length;p++){var h=s[p];if(void 0===o[h]){var c=4*h;t<=l[c+2]&&e<=l[c+3]&&r>=l[c+0]&&n>=l[c+1]?(o[h]=!0,a.push(u[h])):o[h]=!1;}}},Sr.prototype._forEachCell=function(t,e,r,n,i,a,o){for(var s=this._convertToCellCoord(t),u=this._convertToCellCoord(e),l=this._convertToCellCoord(r),p=this._convertToCellCoord(n),h=s;h<=l;h++)for(var c=u;c<=p;c++){var f=this.d*c+h;if(i.call(this,t,e,r,n,f,a,o))return}},Sr.prototype._convertToCellCoord=function(t){return Math.max(0,Math.min(this.d-1,Math.floor(t*this.scale)+this.padding))},Sr.prototype.toArrayBuffer=function(){if(this.arrayBuffer)return this.arrayBuffer;for(var t=this.cells,e=kr+this.cells.length+1+1,r=0,n=0;n<this.cells.length;n++)r+=this.cells[n].length;var i=new Int32Array(e+r+this.keys.length+this.bboxes.length);i[0]=this.extent,i[1]=this.n,i[2]=this.padding;for(var a=e,o=0;o<t.length;o++){var s=t[o];i[kr+o]=a,i.set(s,a),a+=s.length;}return i[kr+t.length]=a,i.set(this.keys,a),a+=this.keys.length,i[kr+t.length+1]=a,i.set(this.bboxes,a),a+=this.bboxes.length,i.buffer};var zr=self.ImageData,Mr={};function Br(t,e,r){void 0===r&&(r={}),Object.defineProperty(e,"_classRegistryKey",{value:t,writeable:!1}),Mr[t]={klass:e,omit:r.omit||[],shallow:r.shallow||[]};}for(var Ir in Br("Object",Object),Ar.serialize=function(t,e){var r=t.toArrayBuffer();return e&&e.push(r),r},Ar.deserialize=function(t){return new Ar(t)},Br("Grid",Ar),Br("Color",at),Br("Error",Error),Br("StylePropertyFunction",Ue),Br("StyleExpression",Fe,{omit:["_evaluator"]}),Br("ZoomDependentExpression",qe),Br("ZoomConstantExpression",De),Br("CompoundExpression",At,{omit:["_evaluate"]}),Wt)Wt[Ir]._classRegistryKey||Br("Expression_"+Ir,Wt[Ir]);function Cr(t,e){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp)return t;if(t instanceof ArrayBuffer)return e&&e.push(t),t;if(ArrayBuffer.isView(t)){var r=t;return e&&e.push(r.buffer),r}if(t instanceof zr)return e&&e.push(t.data.buffer),t;if(Array.isArray(t)){for(var n=[],i=0,a=t;i<a.length;i+=1){var o=a[i];n.push(Cr(o,e));}return n}if("object"==typeof t){var s=t.constructor,u=s._classRegistryKey;if(!u)throw new Error("can't serialize object of unregistered class");var l={};if(s.serialize)l._serialized=s.serialize(t,e);else{for(var p in t)if(t.hasOwnProperty(p)&&!(Mr[u].omit.indexOf(p)>=0)){var h=t[p];l[p]=Mr[u].shallow.indexOf(p)>=0?h:Cr(h,e);}t instanceof Error&&(l.message=t.message);}return {name:u,properties:l}}throw new Error("can't serialize object of type "+typeof t)}function Vr(t){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp||t instanceof ArrayBuffer||ArrayBuffer.isView(t)||t instanceof zr)return t;if(Array.isArray(t))return t.map(function(t){return Vr(t)});if("object"==typeof t){var e=t,r=e.name,n=e.properties;if(!r)throw new Error("can't deserialize object of anonymous class");var i=Mr[r].klass;if(!i)throw new Error("can't deserialize unregistered class "+r);if(i.deserialize)return i.deserialize(n._serialized);for(var a=Object.create(i.prototype),o=0,s=Object.keys(n);o<s.length;o+=1){var u=s[o];a[u]=Mr[r].shallow.indexOf(u)>=0?n[u]:Vr(n[u]);}return a}throw new Error("can't deserialize object of type "+typeof t)}var Tr=function(){this.first=!0;};Tr.prototype.update=function(t,e){var r=Math.floor(t);return this.first?(this.first=!1,this.lastIntegerZoom=r,this.lastIntegerZoomTime=0,this.lastZoom=t,this.lastFloorZoom=r,!0):(this.lastFloorZoom>r?(this.lastIntegerZoom=r+1,this.lastIntegerZoomTime=e):this.lastFloorZoom<r&&(this.lastIntegerZoom=r,this.lastIntegerZoomTime=e),t!==this.lastZoom&&(this.lastZoom=t,this.lastFloorZoom=r,!0))};var Er={"Latin-1 Supplement":function(t){return t>=128&&t<=255},Arabic:function(t){return t>=1536&&t<=1791},"Arabic Supplement":function(t){return t>=1872&&t<=1919},"Arabic Extended-A":function(t){return t>=2208&&t<=2303},"Hangul Jamo":function(t){return t>=4352&&t<=4607},"Unified Canadian Aboriginal Syllabics":function(t){return t>=5120&&t<=5759},Khmer:function(t){return t>=6016&&t<=6143},"Unified Canadian Aboriginal Syllabics Extended":function(t){return t>=6320&&t<=6399},"General Punctuation":function(t){return t>=8192&&t<=8303},"Letterlike Symbols":function(t){return t>=8448&&t<=8527},"Number Forms":function(t){return t>=8528&&t<=8591},"Miscellaneous Technical":function(t){return t>=8960&&t<=9215},"Control Pictures":function(t){return t>=9216&&t<=9279},"Optical Character Recognition":function(t){return t>=9280&&t<=9311},"Enclosed Alphanumerics":function(t){return t>=9312&&t<=9471},"Geometric Shapes":function(t){return t>=9632&&t<=9727},"Miscellaneous Symbols":function(t){return t>=9728&&t<=9983},"Miscellaneous Symbols and Arrows":function(t){return t>=11008&&t<=11263},"CJK Radicals Supplement":function(t){return t>=11904&&t<=12031},"Kangxi Radicals":function(t){return t>=12032&&t<=12255},"Ideographic Description Characters":function(t){return t>=12272&&t<=12287},"CJK Symbols and Punctuation":function(t){return t>=12288&&t<=12351},Hiragana:function(t){return t>=12352&&t<=12447},Katakana:function(t){return t>=12448&&t<=12543},Bopomofo:function(t){return t>=12544&&t<=12591},"Hangul Compatibility Jamo":function(t){return t>=12592&&t<=12687},Kanbun:function(t){return t>=12688&&t<=12703},"Bopomofo Extended":function(t){return t>=12704&&t<=12735},"CJK Strokes":function(t){return t>=12736&&t<=12783},"Katakana Phonetic Extensions":function(t){return t>=12784&&t<=12799},"Enclosed CJK Letters and Months":function(t){return t>=12800&&t<=13055},"CJK Compatibility":function(t){return t>=13056&&t<=13311},"CJK Unified Ideographs Extension A":function(t){return t>=13312&&t<=19903},"Yijing Hexagram Symbols":function(t){return t>=19904&&t<=19967},"CJK Unified Ideographs":function(t){return t>=19968&&t<=40959},"Yi Syllables":function(t){return t>=40960&&t<=42127},"Yi Radicals":function(t){return t>=42128&&t<=42191},"Hangul Jamo Extended-A":function(t){return t>=43360&&t<=43391},"Hangul Syllables":function(t){return t>=44032&&t<=55215},"Hangul Jamo Extended-B":function(t){return t>=55216&&t<=55295},"Private Use Area":function(t){return t>=57344&&t<=63743},"CJK Compatibility Ideographs":function(t){return t>=63744&&t<=64255},"Arabic Presentation Forms-A":function(t){return t>=64336&&t<=65023},"Vertical Forms":function(t){return t>=65040&&t<=65055},"CJK Compatibility Forms":function(t){return t>=65072&&t<=65103},"Small Form Variants":function(t){return t>=65104&&t<=65135},"Arabic Presentation Forms-B":function(t){return t>=65136&&t<=65279},"Halfwidth and Fullwidth Forms":function(t){return t>=65280&&t<=65519}};function Pr(t){for(var e=0,r=t;e<r.length;e+=1){if(Lr(r[e].charCodeAt(0)))return !0}return !1}function Fr(t){return !Er.Arabic(t)&&(!Er["Arabic Supplement"](t)&&(!Er["Arabic Extended-A"](t)&&(!Er["Arabic Presentation Forms-A"](t)&&!Er["Arabic Presentation Forms-B"](t))))}function Lr(t){return 746===t||747===t||!(t<4352)&&(!!Er["Bopomofo Extended"](t)||(!!Er.Bopomofo(t)||(!(!Er["CJK Compatibility Forms"](t)||t>=65097&&t<=65103)||(!!Er["CJK Compatibility Ideographs"](t)||(!!Er["CJK Compatibility"](t)||(!!Er["CJK Radicals Supplement"](t)||(!!Er["CJK Strokes"](t)||(!(!Er["CJK Symbols and Punctuation"](t)||t>=12296&&t<=12305||t>=12308&&t<=12319||12336===t)||(!!Er["CJK Unified Ideographs Extension A"](t)||(!!Er["CJK Unified Ideographs"](t)||(!!Er["Enclosed CJK Letters and Months"](t)||(!!Er["Hangul Compatibility Jamo"](t)||(!!Er["Hangul Jamo Extended-A"](t)||(!!Er["Hangul Jamo Extended-B"](t)||(!!Er["Hangul Jamo"](t)||(!!Er["Hangul Syllables"](t)||(!!Er.Hiragana(t)||(!!Er["Ideographic Description Characters"](t)||(!!Er.Kanbun(t)||(!!Er["Kangxi Radicals"](t)||(!!Er["Katakana Phonetic Extensions"](t)||(!(!Er.Katakana(t)||12540===t)||(!(!Er["Halfwidth and Fullwidth Forms"](t)||65288===t||65289===t||65293===t||t>=65306&&t<=65310||65339===t||65341===t||65343===t||t>=65371&&t<=65503||65507===t||t>=65512&&t<=65519)||(!(!Er["Small Form Variants"](t)||t>=65112&&t<=65118||t>=65123&&t<=65126)||(!!Er["Unified Canadian Aboriginal Syllabics"](t)||(!!Er["Unified Canadian Aboriginal Syllabics Extended"](t)||(!!Er["Vertical Forms"](t)||(!!Er["Yijing Hexagram Symbols"](t)||(!!Er["Yi Syllables"](t)||!!Er["Yi Radicals"](t))))))))))))))))))))))))))))))}function Or(t){return !(Lr(t)||function(t){return !!(Er["Latin-1 Supplement"](t)&&(167===t||169===t||174===t||177===t||188===t||189===t||190===t||215===t||247===t)||Er["General Punctuation"](t)&&(8214===t||8224===t||8225===t||8240===t||8241===t||8251===t||8252===t||8258===t||8263===t||8264===t||8265===t||8273===t)||Er["Letterlike Symbols"](t)||Er["Number Forms"](t)||Er["Miscellaneous Technical"](t)&&(t>=8960&&t<=8967||t>=8972&&t<=8991||t>=8996&&t<=9e3||9003===t||t>=9085&&t<=9114||t>=9150&&t<=9165||9167===t||t>=9169&&t<=9179||t>=9186&&t<=9215)||Er["Control Pictures"](t)&&9251!==t||Er["Optical Character Recognition"](t)||Er["Enclosed Alphanumerics"](t)||Er["Geometric Shapes"](t)||Er["Miscellaneous Symbols"](t)&&!(t>=9754&&t<=9759)||Er["Miscellaneous Symbols and Arrows"](t)&&(t>=11026&&t<=11055||t>=11088&&t<=11097||t>=11192&&t<=11243)||Er["CJK Symbols and Punctuation"](t)||Er.Katakana(t)||Er["Private Use Area"](t)||Er["CJK Compatibility Forms"](t)||Er["Small Form Variants"](t)||Er["Halfwidth and Fullwidth Forms"](t)||8734===t||8756===t||8757===t||t>=9984&&t<=10087||t>=10102&&t<=10131||65532===t||65533===t)}(t))}function Dr(t,e){return !(!e&&(t>=1424&&t<=2303||Er["Arabic Presentation Forms-A"](t)||Er["Arabic Presentation Forms-B"](t)))&&!(t>=2304&&t<=3583||t>=3840&&t<=4255||Er.Khmer(t))}var qr,jr=!1,Ur=null,Rr=!1,Nr=new L,Zr={applyArabicShaping:null,processBidirectionalText:null,processStyledBidirectionalText:null,isLoaded:function(){return Rr||null!=Zr.applyArabicShaping}},Xr=function(t,e){this.zoom=t,e?(this.now=e.now,this.fadeDuration=e.fadeDuration,this.zoomHistory=e.zoomHistory,this.transition=e.transition):(this.now=0,this.fadeDuration=0,this.zoomHistory=new Tr,this.transition={});};Xr.prototype.isSupportedScript=function(t){return function(t,e){for(var r=0,n=t;r<n.length;r+=1)if(!Dr(n[r].charCodeAt(0),e))return !1;return !0}(t,Zr.isLoaded())},Xr.prototype.crossFadingFactor=function(){return 0===this.fadeDuration?1:Math.min((this.now-this.zoomHistory.lastIntegerZoomTime)/this.fadeDuration,1)};var Hr=function(t,e){this.property=t,this.value=e,this.expression=Re(void 0===e?t.specification.default:e,t.specification);};Hr.prototype.isDataDriven=function(){return "source"===this.expression.kind||"composite"===this.expression.kind},Hr.prototype.possiblyEvaluate=function(t){return this.property.possiblyEvaluate(this,t)};var Jr=function(t){this.property=t,this.value=new Hr(t,void 0);};Jr.prototype.transitioned=function(t,e){return new Kr(this.property,this.value,e,h({},t.transition,this.transition),t.now)},Jr.prototype.untransitioned=function(){return new Kr(this.property,this.value,null,{},0)};var Gr=function(t){this._properties=t,this._values=Object.create(t.defaultTransitionablePropertyValues);};Gr.prototype.getValue=function(t){return g(this._values[t].value.value)},Gr.prototype.setValue=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new Jr(this._values[t].property)),this._values[t].value=new Hr(this._values[t].property,null===e?void 0:g(e));},Gr.prototype.getTransition=function(t){return g(this._values[t].transition)},Gr.prototype.setTransition=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new Jr(this._values[t].property)),this._values[t].transition=g(e)||void 0;},Gr.prototype.serialize=function(){for(var t={},e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e],i=this.getValue(n);void 0!==i&&(t[n]=i);var a=this.getTransition(n);void 0!==a&&(t[n+"-transition"]=a);}return t},Gr.prototype.transitioned=function(t,e){for(var r=new Yr(this._properties),n=0,i=Object.keys(this._values);n<i.length;n+=1){var a=i[n];r._values[a]=this._values[a].transitioned(t,e._values[a]);}return r},Gr.prototype.untransitioned=function(){for(var t=new Yr(this._properties),e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e];t._values[n]=this._values[n].untransitioned();}return t};var Kr=function(t,e,r,n,i){this.property=t,this.value=e,this.begin=i+n.delay||0,this.end=this.begin+n.duration||0,t.specification.transition&&(n.delay||n.duration)&&(this.prior=r);};Kr.prototype.possiblyEvaluate=function(t){var e=t.now||0,r=this.value.possiblyEvaluate(t),n=this.prior;if(n){if(e>this.end)return this.prior=null,r;if(this.value.isDataDriven())return this.prior=null,r;if(e<this.begin)return n.possiblyEvaluate(t);var i=(e-this.begin)/(this.end-this.begin);return this.property.interpolate(n.possiblyEvaluate(t),r,function(t){if(t<=0)return 0;if(t>=1)return 1;var e=t*t,r=e*t;return 4*(t<.5?r:3*(t-e)+r-.75)}(i))}return r};var Yr=function(t){this._properties=t,this._values=Object.create(t.defaultTransitioningPropertyValues);};Yr.prototype.possiblyEvaluate=function(t){for(var e=new Qr(this._properties),r=0,n=Object.keys(this._values);r<n.length;r+=1){var i=n[r];e._values[i]=this._values[i].possiblyEvaluate(t);}return e},Yr.prototype.hasTransition=function(){for(var t=0,e=Object.keys(this._values);t<e.length;t+=1){var r=e[t];if(this._values[r].prior)return !0}return !1};var $r=function(t){this._properties=t,this._values=Object.create(t.defaultPropertyValues);};$r.prototype.getValue=function(t){return g(this._values[t].value)},$r.prototype.setValue=function(t,e){this._values[t]=new Hr(this._values[t].property,null===e?void 0:g(e));},$r.prototype.serialize=function(){for(var t={},e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e],i=this.getValue(n);void 0!==i&&(t[n]=i);}return t},$r.prototype.possiblyEvaluate=function(t){for(var e=new Qr(this._properties),r=0,n=Object.keys(this._values);r<n.length;r+=1){var i=n[r];e._values[i]=this._values[i].possiblyEvaluate(t);}return e};var Wr=function(t,e,r){this.property=t,this.value=e,this.globals=r;};Wr.prototype.isConstant=function(){return "constant"===this.value.kind},Wr.prototype.constantOr=function(t){return "constant"===this.value.kind?this.value.value:t},Wr.prototype.evaluate=function(t,e){return this.property.evaluate(this.value,this.globals,t,e)};var Qr=function(t){this._properties=t,this._values=Object.create(t.defaultPossiblyEvaluatedValues);};Qr.prototype.get=function(t){return this._values[t]};var tn=function(t){this.specification=t;};tn.prototype.possiblyEvaluate=function(t,e){return t.expression.evaluate(e)},tn.prototype.interpolate=function(t,e,r){var n=Pt[this.specification.type];return n?n(t,e,r):t};var en=function(t){this.specification=t;};en.prototype.possiblyEvaluate=function(t,e){return "constant"===t.expression.kind||"camera"===t.expression.kind?new Wr(this,{kind:"constant",value:t.expression.evaluate(e)},e):new Wr(this,t.expression,e)},en.prototype.interpolate=function(t,e,r){if("constant"!==t.value.kind||"constant"!==e.value.kind)return t;if(void 0===t.value.value||void 0===e.value.value)return new Wr(this,{kind:"constant",value:void 0},t.globals);var n=Pt[this.specification.type];return n?new Wr(this,{kind:"constant",value:n(t.value.value,e.value.value,r)},t.globals):t},en.prototype.evaluate=function(t,e,r,n){return "constant"===t.kind?t.value:t.evaluate(e,r,n)};var rn=function(t){this.specification=t;};rn.prototype.possiblyEvaluate=function(t,e){if(void 0!==t.value){if("constant"===t.expression.kind){var r=t.expression.evaluate(e);return this._calculate(r,r,r,e)}return this._calculate(t.expression.evaluate(new Xr(Math.floor(e.zoom-1),e)),t.expression.evaluate(new Xr(Math.floor(e.zoom),e)),t.expression.evaluate(new Xr(Math.floor(e.zoom+1),e)),e)}},rn.prototype._calculate=function(t,e,r,n){var i=n.zoom,a=i-Math.floor(i),o=n.crossFadingFactor();return i>n.zoomHistory.lastIntegerZoom?{from:t,to:e,fromScale:2,toScale:1,t:a+(1-a)*o}:{from:r,to:e,fromScale:.5,toScale:1,t:1-(1-o)*a}},rn.prototype.interpolate=function(t){return t};var nn=function(t){this.specification=t;};nn.prototype.possiblyEvaluate=function(t,e){return !!t.expression.evaluate(e)},nn.prototype.interpolate=function(){return !1};var an=function(t){for(var e in this.properties=t,this.defaultPropertyValues={},this.defaultTransitionablePropertyValues={},this.defaultTransitioningPropertyValues={},this.defaultPossiblyEvaluatedValues={},t){var r=t[e],n=this.defaultPropertyValues[e]=new Hr(r,void 0),i=this.defaultTransitionablePropertyValues[e]=new Jr(r);this.defaultTransitioningPropertyValues[e]=i.untransitioned(),this.defaultPossiblyEvaluatedValues[e]=n.possiblyEvaluate({});}};Br("DataDrivenProperty",en),Br("DataConstantProperty",tn),Br("CrossFadedProperty",rn),Br("ColorRampProperty",nn);var on=function(t){function e(e,r){for(var n in t.call(this),this.id=e.id,this.metadata=e.metadata,this.type=e.type,this.minzoom=e.minzoom,this.maxzoom=e.maxzoom,this.visibility="visible","background"!==e.type&&(this.source=e.source,this.sourceLayer=e["source-layer"],this.filter=e.filter),this._featureFilter=function(){return !0},r.layout&&(this._unevaluatedLayout=new $r(r.layout)),this._transitionablePaint=new Gr(r.paint),e.paint)this.setPaintProperty(n,e.paint[n],{validate:!1});for(var i in e.layout)this.setLayoutProperty(i,e.layout[i],{validate:!1});this._transitioningPaint=this._transitionablePaint.untransitioned();}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getLayoutProperty=function(t){return "visibility"===t?this.visibility:this._unevaluatedLayout.getValue(t)},e.prototype.setLayoutProperty=function(t,e,r){if(null!=e){var n="layers."+this.id+".layout."+t;if(this._validate(wr,n,t,e,r))return}"visibility"!==t?this._unevaluatedLayout.setValue(t,e):this.visibility="none"===e?e:"visible";},e.prototype.getPaintProperty=function(t){return d(t,"-transition")?this._transitionablePaint.getTransition(t.slice(0,-"-transition".length)):this._transitionablePaint.getValue(t)},e.prototype.setPaintProperty=function(t,e,r){if(null!=e){var n="layers."+this.id+".paint."+t;if(this._validate(br,n,t,e,r))return !1}if(d(t,"-transition"))return this._transitionablePaint.setTransition(t.slice(0,-"-transition".length),e||void 0),!1;var i=this._transitionablePaint._values[t].value.isDataDriven();this._transitionablePaint.setValue(t,e);var a=this._transitionablePaint._values[t].value.isDataDriven();return this._handleSpecialPaintPropertyUpdate(t),a||i},e.prototype._handleSpecialPaintPropertyUpdate=function(t){},e.prototype.isHidden=function(t){return !!(this.minzoom&&t<this.minzoom)||(!!(this.maxzoom&&t>=this.maxzoom)||"none"===this.visibility)},e.prototype.updateTransitions=function(t){this._transitioningPaint=this._transitionablePaint.transitioned(t,this._transitioningPaint);},e.prototype.hasTransition=function(){return this._transitioningPaint.hasTransition()},e.prototype.recalculate=function(t){this._unevaluatedLayout&&(this.layout=this._unevaluatedLayout.possiblyEvaluate(t)),this.paint=this._transitioningPaint.possiblyEvaluate(t);},e.prototype.serialize=function(){var t={id:this.id,type:this.type,source:this.source,"source-layer":this.sourceLayer,metadata:this.metadata,minzoom:this.minzoom,maxzoom:this.maxzoom,filter:this.filter,layout:this._unevaluatedLayout&&this._unevaluatedLayout.serialize(),paint:this._transitionablePaint&&this._transitionablePaint.serialize()};return "none"===this.visibility&&(t.layout=t.layout||{},t.layout.visibility="none"),v(t,function(t,e){return !(void 0===t||"layout"===e&&!Object.keys(t).length||"paint"===e&&!Object.keys(t).length)})},e.prototype._validate=function(t,e,r,n,i){return (!i||!1!==i.validate)&&_r(this,t.call(gr,{key:e,layerType:this.type,objectKey:r,value:n,styleSpec:O,style:{glyphs:!0,sprite:!0}}))},e.prototype.hasOffscreenPass=function(){return !1},e.prototype.resize=function(){},e.prototype.isStateDependent=function(){for(var t in this.paint._values){var e=this.paint.get(t);if(e instanceof Wr&&ae(e.property.specification)&&(("source"===e.value.kind||"composite"===e.value.kind)&&e.value.isStateDependent))return !0}return !1},e}(L),sn={Int8:Int8Array,Uint8:Uint8Array,Int16:Int16Array,Uint16:Uint16Array,Int32:Int32Array,Uint32:Uint32Array,Float32:Float32Array},un=function(t,e){this._structArray=t,this._pos1=e*this.size,this._pos2=this._pos1/2,this._pos4=this._pos1/4,this._pos8=this._pos1/8;},ln=function(){this.isTransferred=!1,this.capacity=-1,this.resize(0);};function pn(t,e){void 0===e&&(e=1);var r=0,n=0;return {members:t.map(function(t){var i,a=(i=t.type,sn[i].BYTES_PER_ELEMENT),o=r=hn(r,Math.max(e,a)),s=t.components||1;return n=Math.max(n,a),r+=a*s,{name:t.name,type:t.type,components:s,offset:o}}),size:hn(r,Math.max(n,e)),alignment:e}}function hn(t,e){return Math.ceil(t/e)*e}ln.serialize=function(t,e){return t._trim(),e&&(t.isTransferred=!0,e.push(t.arrayBuffer)),{length:t.length,arrayBuffer:t.arrayBuffer}},ln.deserialize=function(t){var e=Object.create(this.prototype);return e.arrayBuffer=t.arrayBuffer,e.length=t.length,e.capacity=t.arrayBuffer.byteLength/e.bytesPerElement,e._refreshViews(),e},ln.prototype._trim=function(){this.length!==this.capacity&&(this.capacity=this.length,this.arrayBuffer=this.arrayBuffer.slice(0,this.length*this.bytesPerElement),this._refreshViews());},ln.prototype.clear=function(){this.length=0;},ln.prototype.resize=function(t){this.reserve(t),this.length=t;},ln.prototype.reserve=function(t){if(t>this.capacity){this.capacity=Math.max(t,Math.floor(5*this.capacity),128),this.arrayBuffer=new ArrayBuffer(this.capacity*this.bytesPerElement);var e=this.uint8;this._refreshViews(),e&&this.uint8.set(e);}},ln.prototype._refreshViews=function(){throw new Error("_refreshViews() must be implemented by each concrete StructArray layout")};var cn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;this.resize(r+1);var n=2*r;return this.int16[n+0]=t,this.int16[n+1]=e,r},e.prototype.emplace=function(t,e,r){var n=2*t;return this.int16[n+0]=e,this.int16[n+1]=r,t},e}(ln);cn.prototype.bytesPerElement=4,Br("StructArrayLayout2i4",cn);var fn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;this.resize(i+1);var a=4*i;return this.int16[a+0]=t,this.int16[a+1]=e,this.int16[a+2]=r,this.int16[a+3]=n,i},e.prototype.emplace=function(t,e,r,n,i){var a=4*t;return this.int16[a+0]=e,this.int16[a+1]=r,this.int16[a+2]=n,this.int16[a+3]=i,t},e}(ln);fn.prototype.bytesPerElement=8,Br("StructArrayLayout4i8",fn);var yn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;this.resize(o+1);var s=6*o;return this.int16[s+0]=t,this.int16[s+1]=e,this.int16[s+2]=r,this.int16[s+3]=n,this.int16[s+4]=i,this.int16[s+5]=a,o},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=6*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,this.int16[s+4]=a,this.int16[s+5]=o,t},e}(ln);yn.prototype.bytesPerElement=12,Br("StructArrayLayout2i4i12",yn);var dn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s){var u=this.length;this.resize(u+1);var l=6*u,p=12*u;return this.int16[l+0]=t,this.int16[l+1]=e,this.int16[l+2]=r,this.int16[l+3]=n,this.uint8[p+8]=i,this.uint8[p+9]=a,this.uint8[p+10]=o,this.uint8[p+11]=s,u},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u){var l=6*t,p=12*t;return this.int16[l+0]=e,this.int16[l+1]=r,this.int16[l+2]=n,this.int16[l+3]=i,this.uint8[p+8]=a,this.uint8[p+9]=o,this.uint8[p+10]=s,this.uint8[p+11]=u,t},e}(ln);dn.prototype.bytesPerElement=12,Br("StructArrayLayout4i4ub12",dn);var mn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s){var u=this.length;this.resize(u+1);var l=8*u;return this.int16[l+0]=t,this.int16[l+1]=e,this.int16[l+2]=r,this.int16[l+3]=n,this.uint16[l+4]=i,this.uint16[l+5]=a,this.uint16[l+6]=o,this.uint16[l+7]=s,u},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u){var l=8*t;return this.int16[l+0]=e,this.int16[l+1]=r,this.int16[l+2]=n,this.int16[l+3]=i,this.uint16[l+4]=a,this.uint16[l+5]=o,this.uint16[l+6]=s,this.uint16[l+7]=u,t},e}(ln);mn.prototype.bytesPerElement=16,Br("StructArrayLayout4i4ui16",mn);var vn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;this.resize(n+1);var i=3*n;return this.float32[i+0]=t,this.float32[i+1]=e,this.float32[i+2]=r,n},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.float32[i+0]=e,this.float32[i+1]=r,this.float32[i+2]=n,t},e}(ln);vn.prototype.bytesPerElement=12,Br("StructArrayLayout3f12",vn);var gn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;this.resize(e+1);var r=1*e;return this.uint32[r+0]=t,e},e.prototype.emplace=function(t,e){var r=1*t;return this.uint32[r+0]=e,t},e}(ln);gn.prototype.bytesPerElement=4,Br("StructArrayLayout1ul4",gn);var xn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p){var h=this.length;this.resize(h+1);var c=12*h,f=6*h;return this.int16[c+0]=t,this.int16[c+1]=e,this.int16[c+2]=r,this.int16[c+3]=n,this.int16[c+4]=i,this.int16[c+5]=a,this.uint32[f+3]=o,this.uint16[c+8]=s,this.uint16[c+9]=u,this.int16[c+10]=l,this.int16[c+11]=p,h},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,h){var c=12*t,f=6*t;return this.int16[c+0]=e,this.int16[c+1]=r,this.int16[c+2]=n,this.int16[c+3]=i,this.int16[c+4]=a,this.int16[c+5]=o,this.uint32[f+3]=s,this.uint16[c+8]=u,this.uint16[c+9]=l,this.int16[c+10]=p,this.int16[c+11]=h,t},e}(ln);xn.prototype.bytesPerElement=24,Br("StructArrayLayout6i1ul2ui2i24",xn);var bn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;this.resize(o+1);var s=6*o;return this.int16[s+0]=t,this.int16[s+1]=e,this.int16[s+2]=r,this.int16[s+3]=n,this.int16[s+4]=i,this.int16[s+5]=a,o},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=6*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,this.int16[s+4]=a,this.int16[s+5]=o,t},e}(ln);bn.prototype.bytesPerElement=12,Br("StructArrayLayout2i2i2i12",bn);var wn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;this.resize(r+1);var n=4*r;return this.uint8[n+0]=t,this.uint8[n+1]=e,r},e.prototype.emplace=function(t,e,r){var n=4*t;return this.uint8[n+0]=e,this.uint8[n+1]=r,t},e}(ln);wn.prototype.bytesPerElement=4,Br("StructArrayLayout2ub4",wn);var _n=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,h,c,f){var y=this.length;this.resize(y+1);var d=20*y,m=10*y,v=40*y;return this.int16[d+0]=t,this.int16[d+1]=e,this.uint16[d+2]=r,this.uint16[d+3]=n,this.uint32[m+2]=i,this.uint32[m+3]=a,this.uint32[m+4]=o,this.uint16[d+10]=s,this.uint16[d+11]=u,this.uint16[d+12]=l,this.float32[m+7]=p,this.float32[m+8]=h,this.uint8[v+36]=c,this.uint8[v+37]=f,y},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,h,c,f,y){var d=20*t,m=10*t,v=40*t;return this.int16[d+0]=e,this.int16[d+1]=r,this.uint16[d+2]=n,this.uint16[d+3]=i,this.uint32[m+2]=a,this.uint32[m+3]=o,this.uint32[m+4]=s,this.uint16[d+10]=u,this.uint16[d+11]=l,this.uint16[d+12]=p,this.float32[m+7]=h,this.float32[m+8]=c,this.uint8[v+36]=f,this.uint8[v+37]=y,t},e}(ln);_n.prototype.bytesPerElement=40,Br("StructArrayLayout2i2ui3ul3ui2f2ub40",_n);var An=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;this.resize(e+1);var r=1*e;return this.float32[r+0]=t,e},e.prototype.emplace=function(t,e){var r=1*t;return this.float32[r+0]=e,t},e}(ln);An.prototype.bytesPerElement=4,Br("StructArrayLayout1f4",An);var kn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;this.resize(n+1);var i=3*n;return this.int16[i+0]=t,this.int16[i+1]=e,this.int16[i+2]=r,n},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.int16[i+0]=e,this.int16[i+1]=r,this.int16[i+2]=n,t},e}(ln);kn.prototype.bytesPerElement=6,Br("StructArrayLayout3i6",kn);var Sn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;this.resize(n+1);var i=2*n,a=4*n;return this.uint32[i+0]=t,this.uint16[a+2]=e,this.uint16[a+3]=r,n},e.prototype.emplace=function(t,e,r,n){var i=2*t,a=4*t;return this.uint32[i+0]=e,this.uint16[a+2]=r,this.uint16[a+3]=n,t},e}(ln);Sn.prototype.bytesPerElement=8,Br("StructArrayLayout1ul2ui8",Sn);var zn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;this.resize(n+1);var i=3*n;return this.uint16[i+0]=t,this.uint16[i+1]=e,this.uint16[i+2]=r,n},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.uint16[i+0]=e,this.uint16[i+1]=r,this.uint16[i+2]=n,t},e}(ln);zn.prototype.bytesPerElement=6,Br("StructArrayLayout3ui6",zn);var Mn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;this.resize(r+1);var n=2*r;return this.uint16[n+0]=t,this.uint16[n+1]=e,r},e.prototype.emplace=function(t,e,r){var n=2*t;return this.uint16[n+0]=e,this.uint16[n+1]=r,t},e}(ln);Mn.prototype.bytesPerElement=4,Br("StructArrayLayout2ui4",Mn);var Bn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;this.resize(r+1);var n=2*r;return this.float32[n+0]=t,this.float32[n+1]=e,r},e.prototype.emplace=function(t,e,r){var n=2*t;return this.float32[n+0]=e,this.float32[n+1]=r,t},e}(ln);Bn.prototype.bytesPerElement=8,Br("StructArrayLayout2f8",Bn);var In=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;this.resize(i+1);var a=4*i;return this.float32[a+0]=t,this.float32[a+1]=e,this.float32[a+2]=r,this.float32[a+3]=n,i},e.prototype.emplace=function(t,e,r,n,i){var a=4*t;return this.float32[a+0]=e,this.float32[a+1]=r,this.float32[a+2]=n,this.float32[a+3]=i,t},e}(ln);In.prototype.bytesPerElement=16,Br("StructArrayLayout4f16",In);var Cn=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorPointX:{configurable:!0},anchorPointY:{configurable:!0},x1:{configurable:!0},y1:{configurable:!0},x2:{configurable:!0},y2:{configurable:!0},featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0},radius:{configurable:!0},signedDistanceFromAnchor:{configurable:!0},anchorPoint:{configurable:!0}};return r.anchorPointX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorPointX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorPointY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorPointY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.x1.get=function(){return this._structArray.int16[this._pos2+2]},r.x1.set=function(t){this._structArray.int16[this._pos2+2]=t;},r.y1.get=function(){return this._structArray.int16[this._pos2+3]},r.y1.set=function(t){this._structArray.int16[this._pos2+3]=t;},r.x2.get=function(){return this._structArray.int16[this._pos2+4]},r.x2.set=function(t){this._structArray.int16[this._pos2+4]=t;},r.y2.get=function(){return this._structArray.int16[this._pos2+5]},r.y2.set=function(t){this._structArray.int16[this._pos2+5]=t;},r.featureIndex.get=function(){return this._structArray.uint32[this._pos4+3]},r.featureIndex.set=function(t){this._structArray.uint32[this._pos4+3]=t;},r.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+8]},r.sourceLayerIndex.set=function(t){this._structArray.uint16[this._pos2+8]=t;},r.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+9]},r.bucketIndex.set=function(t){this._structArray.uint16[this._pos2+9]=t;},r.radius.get=function(){return this._structArray.int16[this._pos2+10]},r.radius.set=function(t){this._structArray.int16[this._pos2+10]=t;},r.signedDistanceFromAnchor.get=function(){return this._structArray.int16[this._pos2+11]},r.signedDistanceFromAnchor.set=function(t){this._structArray.int16[this._pos2+11]=t;},r.anchorPoint.get=function(){return new a(this.anchorPointX,this.anchorPointY)},Object.defineProperties(e.prototype,r),e}(un);Cn.prototype.size=24;var Vn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new Cn(this,t)},e}(xn);Br("CollisionBoxArray",Vn);var Tn=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorX:{configurable:!0},anchorY:{configurable:!0},glyphStartIndex:{configurable:!0},numGlyphs:{configurable:!0},vertexStartIndex:{configurable:!0},lineStartIndex:{configurable:!0},lineLength:{configurable:!0},segment:{configurable:!0},lowerSize:{configurable:!0},upperSize:{configurable:!0},lineOffsetX:{configurable:!0},lineOffsetY:{configurable:!0},writingMode:{configurable:!0},hidden:{configurable:!0}};return r.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.glyphStartIndex.get=function(){return this._structArray.uint16[this._pos2+2]},r.glyphStartIndex.set=function(t){this._structArray.uint16[this._pos2+2]=t;},r.numGlyphs.get=function(){return this._structArray.uint16[this._pos2+3]},r.numGlyphs.set=function(t){this._structArray.uint16[this._pos2+3]=t;},r.vertexStartIndex.get=function(){return this._structArray.uint32[this._pos4+2]},r.vertexStartIndex.set=function(t){this._structArray.uint32[this._pos4+2]=t;},r.lineStartIndex.get=function(){return this._structArray.uint32[this._pos4+3]},r.lineStartIndex.set=function(t){this._structArray.uint32[this._pos4+3]=t;},r.lineLength.get=function(){return this._structArray.uint32[this._pos4+4]},r.lineLength.set=function(t){this._structArray.uint32[this._pos4+4]=t;},r.segment.get=function(){return this._structArray.uint16[this._pos2+10]},r.segment.set=function(t){this._structArray.uint16[this._pos2+10]=t;},r.lowerSize.get=function(){return this._structArray.uint16[this._pos2+11]},r.lowerSize.set=function(t){this._structArray.uint16[this._pos2+11]=t;},r.upperSize.get=function(){return this._structArray.uint16[this._pos2+12]},r.upperSize.set=function(t){this._structArray.uint16[this._pos2+12]=t;},r.lineOffsetX.get=function(){return this._structArray.float32[this._pos4+7]},r.lineOffsetX.set=function(t){this._structArray.float32[this._pos4+7]=t;},r.lineOffsetY.get=function(){return this._structArray.float32[this._pos4+8]},r.lineOffsetY.set=function(t){this._structArray.float32[this._pos4+8]=t;},r.writingMode.get=function(){return this._structArray.uint8[this._pos1+36]},r.writingMode.set=function(t){this._structArray.uint8[this._pos1+36]=t;},r.hidden.get=function(){return this._structArray.uint8[this._pos1+37]},r.hidden.set=function(t){this._structArray.uint8[this._pos1+37]=t;},Object.defineProperties(e.prototype,r),e}(un);Tn.prototype.size=40;var En=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new Tn(this,t)},e}(_n);Br("PlacedSymbolArray",En);var Pn=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={offsetX:{configurable:!0}};return r.offsetX.get=function(){return this._structArray.float32[this._pos4+0]},r.offsetX.set=function(t){this._structArray.float32[this._pos4+0]=t;},Object.defineProperties(e.prototype,r),e}(un);Pn.prototype.size=4;var Fn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getoffsetX=function(t){return this.float32[1*t+0]},e.prototype.get=function(t){return new Pn(this,t)},e}(An);Br("GlyphOffsetArray",Fn);var Ln=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={x:{configurable:!0},y:{configurable:!0},tileUnitDistanceFromAnchor:{configurable:!0}};return r.x.get=function(){return this._structArray.int16[this._pos2+0]},r.x.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.y.get=function(){return this._structArray.int16[this._pos2+1]},r.y.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.tileUnitDistanceFromAnchor.get=function(){return this._structArray.int16[this._pos2+2]},r.tileUnitDistanceFromAnchor.set=function(t){this._structArray.int16[this._pos2+2]=t;},Object.defineProperties(e.prototype,r),e}(un);Ln.prototype.size=6;var On=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getx=function(t){return this.int16[3*t+0]},e.prototype.gety=function(t){return this.int16[3*t+1]},e.prototype.gettileUnitDistanceFromAnchor=function(t){return this.int16[3*t+2]},e.prototype.get=function(t){return new Ln(this,t)},e}(kn);Br("SymbolLineVertexArray",On);var Dn=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0}};return r.featureIndex.get=function(){return this._structArray.uint32[this._pos4+0]},r.featureIndex.set=function(t){this._structArray.uint32[this._pos4+0]=t;},r.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+2]},r.sourceLayerIndex.set=function(t){this._structArray.uint16[this._pos2+2]=t;},r.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+3]},r.bucketIndex.set=function(t){this._structArray.uint16[this._pos2+3]=t;},Object.defineProperties(e.prototype,r),e}(un);Dn.prototype.size=8;var qn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new Dn(this,t)},e}(Sn);Br("FeatureIndexArray",qn);var jn=pn([{name:"a_pos",components:2,type:"Int16"}],4),Un=jn.members,Rn=(jn.size,jn.alignment,function(t){void 0===t&&(t=[]),this.segments=t;});Rn.prototype.prepareSegment=function(t,e,r){var n=this.segments[this.segments.length-1];return t>Rn.MAX_VERTEX_ARRAY_LENGTH&&b("Max vertices per segment is "+Rn.MAX_VERTEX_ARRAY_LENGTH+": bucket requested "+t),(!n||n.vertexLength+t>Rn.MAX_VERTEX_ARRAY_LENGTH)&&(n={vertexOffset:e.length,primitiveOffset:r.length,vertexLength:0,primitiveLength:0},this.segments.push(n)),n},Rn.prototype.get=function(){return this.segments},Rn.prototype.destroy=function(){for(var t=0,e=this.segments;t<e.length;t+=1){var r=e[t];for(var n in r.vaos)r.vaos[n].destroy();}},Rn.MAX_VERTEX_ARRAY_LENGTH=Math.pow(2,16)-1,Br("SegmentVector",Rn);var Nn=function(t,e){return 256*(t=p(Math.floor(t),0,255))+(e=p(Math.floor(e),0,255))};function Zn(t){return [Nn(255*t.r,255*t.g),Nn(255*t.b,255*t.a)]}var Xn=function(t,e,r){this.value=t,this.name=e,this.type=r,this.statistics={max:-1/0};};Xn.prototype.defines=function(){return ["#define HAS_UNIFORM_u_"+this.name]},Xn.prototype.populatePaintArray=function(){},Xn.prototype.updatePaintArray=function(){},Xn.prototype.upload=function(){},Xn.prototype.destroy=function(){},Xn.prototype.setUniforms=function(t,e,r,n){var i=n.constantOr(this.value),a=t.gl;"color"===this.type?a.uniform4f(e.uniforms["u_"+this.name],i.r,i.g,i.b,i.a):a.uniform1f(e.uniforms["u_"+this.name],i);};var Hn=function(t,e,r){this.expression=t,this.name=e,this.type=r,this.statistics={max:-1/0};var n="color"===r?Bn:An;this.paintVertexAttributes=[{name:"a_"+e,type:"Float32",components:"color"===r?2:1,offset:0}],this.paintVertexArray=new n;};Hn.prototype.defines=function(){return []},Hn.prototype.populatePaintArray=function(t,e){var r=this.paintVertexArray,n=r.length;r.reserve(t);var i=this.expression.evaluate(new Xr(0),e,{});if("color"===this.type)for(var a=Zn(i),o=n;o<t;o++)r.emplaceBack(a[0],a[1]);else{for(var s=n;s<t;s++)r.emplaceBack(i);this.statistics.max=Math.max(this.statistics.max,i);}},Hn.prototype.updatePaintArray=function(t,e,r,n){var i=this.paintVertexArray,a=this.expression.evaluate({zoom:0},r,n);if("color"===this.type)for(var o=Zn(a),s=t;s<e;s++)i.emplace(s,o[0],o[1]);else{for(var u=t;u<e;u++)i.emplace(u,a);this.statistics.max=Math.max(this.statistics.max,a);}},Hn.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},Hn.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();},Hn.prototype.setUniforms=function(t,e){t.gl.uniform1f(e.uniforms["a_"+this.name+"_t"],0);};var Jn=function(t,e,r,n,i){this.expression=t,this.name=e,this.type=r,this.useIntegerZoom=n,this.zoom=i,this.statistics={max:-1/0};var a="color"===r?In:Bn;this.paintVertexAttributes=[{name:"a_"+e,type:"Float32",components:"color"===r?4:2,offset:0}],this.paintVertexArray=new a;};Jn.prototype.defines=function(){return []},Jn.prototype.populatePaintArray=function(t,e){var r=this.paintVertexArray,n=r.length;r.reserve(t);var i=this.expression.evaluate(new Xr(this.zoom),e,{}),a=this.expression.evaluate(new Xr(this.zoom+1),e,{});if("color"===this.type)for(var o=Zn(i),s=Zn(a),u=n;u<t;u++)r.emplaceBack(o[0],o[1],s[0],s[1]);else{for(var l=n;l<t;l++)r.emplaceBack(i,a);this.statistics.max=Math.max(this.statistics.max,i,a);}},Jn.prototype.updatePaintArray=function(t,e,r,n){var i=this.paintVertexArray,a=this.expression.evaluate({zoom:this.zoom},r,n),o=this.expression.evaluate({zoom:this.zoom+1},r,n);if("color"===this.type)for(var s=Zn(a),u=Zn(o),l=t;l<e;l++)i.emplace(l,s[0],s[1],u[0],u[1]);else{for(var p=t;p<e;p++)i.emplace(p,a,o);this.statistics.max=Math.max(this.statistics.max,a,o);}},Jn.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},Jn.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();},Jn.prototype.interpolationFactor=function(t){return this.useIntegerZoom?this.expression.interpolationFactor(Math.floor(t),this.zoom,this.zoom+1):this.expression.interpolationFactor(t,this.zoom,this.zoom+1)},Jn.prototype.setUniforms=function(t,e,r){t.gl.uniform1f(e.uniforms["a_"+this.name+"_t"],this.interpolationFactor(r.zoom));};var Gn=function(){this.binders={},this.cacheKey="",this._buffers=[],this._idMap={},this._bufferOffset=0;};Gn.createDynamic=function(t,e,r){var n=new Gn,i=[];for(var a in t.paint._values)if(r(a)){var o=t.paint.get(a);if(o instanceof Wr&&ae(o.property.specification)){var s=Yn(a,t.type),u=o.property.specification.type,l=o.property.useIntegerZoom;"constant"===o.value.kind?(n.binders[a]=new Xn(o.value,s,u),i.push("/u_"+s)):"source"===o.value.kind?(n.binders[a]=new Hn(o.value,s,u),i.push("/a_"+s)):(n.binders[a]=new Jn(o.value,s,u,l,e),i.push("/z_"+s));}}return n.cacheKey=i.sort().join(""),n},Gn.prototype.populatePaintArrays=function(t,e,r){for(var n in this.binders)this.binders[n].populatePaintArray(t,e);if(e.id){var i=String(e.id);this._idMap[i]=this._idMap[i]||[],this._idMap[i].push({index:r,start:this._bufferOffset,end:t});}this._bufferOffset=t;},Gn.prototype.updatePaintArrays=function(t,e,r){var n=!1;for(var i in t){var a=this._idMap[i];if(a)for(var o=t[i],s=0,u=a;s<u.length;s+=1){var l=u[s],p=e.feature(l.index);for(var h in this.binders){var c=this.binders[h];if(!(c instanceof Xn)&&!0===c.expression.isStateDependent){var f=r.paint.get(h);c.expression=f.value,c.updatePaintArray(l.start,l.end,p,o),n=!0;}}}}return n},Gn.prototype.defines=function(){var t=[];for(var e in this.binders)t.push.apply(t,this.binders[e].defines());return t},Gn.prototype.setUniforms=function(t,e,r,n){for(var i in this.binders){this.binders[i].setUniforms(t,e,n,r.get(i));}},Gn.prototype.getPaintVertexBuffers=function(){return this._buffers},Gn.prototype.upload=function(t){for(var e in this.binders)this.binders[e].upload(t);var r=[];for(var n in this.binders){var i=this.binders[n];(i instanceof Hn||i instanceof Jn)&&i.paintVertexBuffer&&r.push(i.paintVertexBuffer);}this._buffers=r;},Gn.prototype.destroy=function(){for(var t in this.binders)this.binders[t].destroy();};var Kn=function(t,e,r,n){void 0===n&&(n=function(){return !0}),this.programConfigurations={};for(var i=0,a=e;i<a.length;i+=1){var o=a[i];this.programConfigurations[o.id]=Gn.createDynamic(o,r,n),this.programConfigurations[o.id].layoutAttributes=t;}this.needsUpload=!1;};function Yn(t,e){return {"text-opacity":"opacity","icon-opacity":"opacity","text-color":"fill_color","icon-color":"fill_color","text-halo-color":"halo_color","icon-halo-color":"halo_color","text-halo-blur":"halo_blur","icon-halo-blur":"halo_blur","text-halo-width":"halo_width","icon-halo-width":"halo_width","line-gap-width":"gapwidth"}[t]||t.replace(e+"-","").replace(/-/g,"_")}Kn.prototype.populatePaintArrays=function(t,e,r){for(var n in this.programConfigurations)this.programConfigurations[n].populatePaintArrays(t,e,r);this.needsUpload=!0;},Kn.prototype.updatePaintArrays=function(t,e,r){for(var n=0,i=r;n<i.length;n+=1){var a=i[n];this.needsUpload=this.programConfigurations[a.id].updatePaintArrays(t,e,a)||this.needsUpload;}},Kn.prototype.get=function(t){return this.programConfigurations[t]},Kn.prototype.upload=function(t){if(this.needsUpload){for(var e in this.programConfigurations)this.programConfigurations[e].upload(t);this.needsUpload=!1;}},Kn.prototype.destroy=function(){for(var t in this.programConfigurations)this.programConfigurations[t].destroy();},Br("ConstantBinder",Xn),Br("SourceExpressionBinder",Hn),Br("CompositeExpressionBinder",Jn),Br("ProgramConfiguration",Gn,{omit:["_buffers"]}),Br("ProgramConfigurationSet",Kn);var $n=8192;var Wn,Qn=(Wn=16,{min:-1*Math.pow(2,Wn-1),max:Math.pow(2,Wn-1)-1});function ti(t){for(var e=$n/t.extent,r=t.loadGeometry(),n=0;n<r.length;n++)for(var i=r[n],a=0;a<i.length;a++){var o=i[a];o.x=Math.round(o.x*e),o.y=Math.round(o.y*e),(o.x<Qn.min||o.x>Qn.max||o.y<Qn.min||o.y>Qn.max)&&b("Geometry exceeds allowed extent, reduce your vector tile buffer size");}return r}function ei(t,e,r,n,i){t.emplaceBack(2*e+(n+1)/2,2*r+(i+1)/2);}var ri=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.layoutVertexArray=new cn,this.indexArray=new zn,this.segments=new Rn,this.programConfigurations=new Kn(Un,t.layers,t.zoom);};function ni(t,e,r){for(var n=0;n<t.length;n++){var i=t[n];if(ci(i,e))return !0;if(li(e,i,r))return !0}return !1}function ii(t,e){if(1===t.length&&1===t[0].length)return hi(e,t[0][0]);for(var r=0;r<e.length;r++)for(var n=e[r],i=0;i<n.length;i++)if(hi(t,n[i]))return !0;for(var a=0;a<t.length;a++){for(var o=t[a],s=0;s<o.length;s++)if(hi(e,o[s]))return !0;for(var u=0;u<e.length;u++)if(si(o,e[u]))return !0}return !1}function ai(t,e,r){for(var n=0;n<e.length;n++)for(var i=e[n],a=0;a<t.length;a++){var o=t[a];if(o.length>=3)for(var s=0;s<i.length;s++)if(ci(o,i[s]))return !0;if(oi(o,i,r))return !0}return !1}function oi(t,e,r){if(t.length>1){if(si(t,e))return !0;for(var n=0;n<e.length;n++)if(li(e[n],t,r))return !0}for(var i=0;i<t.length;i++)if(li(t[i],e,r))return !0;return !1}function si(t,e){if(0===t.length||0===e.length)return !1;for(var r=0;r<t.length-1;r++)for(var n=t[r],i=t[r+1],a=0;a<e.length-1;a++){if(ui(n,i,e[a],e[a+1]))return !0}return !1}function ui(t,e,r,n){return w(t,r,n)!==w(e,r,n)&&w(t,e,r)!==w(t,e,n)}function li(t,e,r){var n=r*r;if(1===e.length)return t.distSqr(e[0])<n;for(var i=1;i<e.length;i++){if(pi(t,e[i-1],e[i])<n)return !0}return !1}function pi(t,e,r){var n=e.distSqr(r);if(0===n)return t.distSqr(e);var i=((t.x-e.x)*(r.x-e.x)+(t.y-e.y)*(r.y-e.y))/n;return i<0?t.distSqr(e):i>1?t.distSqr(r):t.distSqr(r.sub(e)._mult(i)._add(e))}function hi(t,e){for(var r,n,i,a=!1,o=0;o<t.length;o++)for(var s=0,u=(r=t[o]).length-1;s<r.length;u=s++)n=r[s],i=r[u],n.y>e.y!=i.y>e.y&&e.x<(i.x-n.x)*(e.y-n.y)/(i.y-n.y)+n.x&&(a=!a);return a}function ci(t,e){for(var r=!1,n=0,i=t.length-1;n<t.length;i=n++){var a=t[n],o=t[i];a.y>e.y!=o.y>e.y&&e.x<(o.x-a.x)*(e.y-a.y)/(o.y-a.y)+a.x&&(r=!r);}return r}function fi(t,e,r){var n=e.paint.get(t).value;return "constant"===n.kind?n.value:r.programConfigurations.get(e.id).binders[t].statistics.max}function yi(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])}function di(t,e,r,n,i){if(!e[0]&&!e[1])return t;var o=a.convert(e);"viewport"===r&&o._rotate(-n);for(var s=[],u=0;u<t.length;u++){for(var l=t[u],p=[],h=0;h<l.length;h++)p.push(l[h].sub(o._mult(i)));s.push(p);}return s}ri.prototype.populate=function(t,e){for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=i.feature,o=i.index,s=i.sourceLayerIndex;if(this.layers[0]._featureFilter(new Xr(this.zoom),a)){var u=ti(a);this.addFeature(a,u,o),e.featureIndex.insert(a,u,o,s,this.index);}}},ri.prototype.update=function(t,e){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers);},ri.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},ri.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},ri.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Un),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},ri.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},ri.prototype.addFeature=function(t,e,r){for(var n=0,i=e;n<i.length;n+=1)for(var a=0,o=i[n];a<o.length;a+=1){var s=o[a],u=s.x,l=s.y;if(!(u<0||u>=$n||l<0||l>=$n)){var p=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray),h=p.vertexLength;ei(this.layoutVertexArray,u,l,-1,-1),ei(this.layoutVertexArray,u,l,1,-1),ei(this.layoutVertexArray,u,l,1,1),ei(this.layoutVertexArray,u,l,-1,1),this.indexArray.emplaceBack(h,h+1,h+2),this.indexArray.emplaceBack(h,h+3,h+2),p.vertexLength+=4,p.primitiveLength+=2;}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r);},Br("CircleBucket",ri,{omit:["layers"]});var mi={paint:new an({"circle-radius":new en(O.paint_circle["circle-radius"]),"circle-color":new en(O.paint_circle["circle-color"]),"circle-blur":new en(O.paint_circle["circle-blur"]),"circle-opacity":new en(O.paint_circle["circle-opacity"]),"circle-translate":new tn(O.paint_circle["circle-translate"]),"circle-translate-anchor":new tn(O.paint_circle["circle-translate-anchor"]),"circle-pitch-scale":new tn(O.paint_circle["circle-pitch-scale"]),"circle-pitch-alignment":new tn(O.paint_circle["circle-pitch-alignment"]),"circle-stroke-width":new en(O.paint_circle["circle-stroke-width"]),"circle-stroke-color":new en(O.paint_circle["circle-stroke-color"]),"circle-stroke-opacity":new en(O.paint_circle["circle-stroke-opacity"])})},vi="undefined"!=typeof Float32Array?Float32Array:Array;Math.PI;function gi(){var t=new vi(9);return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=1,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t}function xi(){var t=new vi(3);return t[0]=0,t[1]=0,t[2]=0,t}function bi(t){var e=t[0],r=t[1],n=t[2];return Math.sqrt(e*e+r*r+n*n)}function wi(t,e,r){var n=new vi(3);return n[0]=t,n[1]=e,n[2]=r,n}function _i(t,e){var r=e[0],n=e[1],i=e[2],a=r*r+n*n+i*i;return a>0&&(a=1/Math.sqrt(a),t[0]=e[0]*a,t[1]=e[1]*a,t[2]=e[2]*a),t}function Ai(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]}function ki(t,e,r){var n=e[0],i=e[1],a=e[2],o=r[0],s=r[1],u=r[2];return t[0]=i*u-a*s,t[1]=a*o-n*u,t[2]=n*s-i*o,t}var Si,zi=bi,Mi=(Si=xi(),function(t,e,r,n,i,a){var o,s;for(e||(e=3),r||(r=0),s=n?Math.min(n*e+r,t.length):t.length,o=r;o<s;o+=e)Si[0]=t[o],Si[1]=t[o+1],Si[2]=t[o+2],i(Si,Si,a),t[o]=Si[0],t[o+1]=Si[1],t[o+2]=Si[2];return t});function Bi(){var t=new vi(4);return t[0]=0,t[1]=0,t[2]=0,t[3]=0,t}function Ii(t,e){var r=e[0],n=e[1],i=e[2],a=e[3],o=r*r+n*n+i*i+a*a;return o>0&&(o=1/Math.sqrt(o),t[0]=r*o,t[1]=n*o,t[2]=i*o,t[3]=a*o),t}function Ci(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3];return t[0]=r[0]*n+r[4]*i+r[8]*a+r[12]*o,t[1]=r[1]*n+r[5]*i+r[9]*a+r[13]*o,t[2]=r[2]*n+r[6]*i+r[10]*a+r[14]*o,t[3]=r[3]*n+r[7]*i+r[11]*a+r[15]*o,t}var Vi=function(){var t=Bi();return function(e,r,n,i,a,o){var s,u;for(r||(r=4),n||(n=0),u=i?Math.min(i*r+n,e.length):e.length,s=n;s<u;s+=r)t[0]=e[s],t[1]=e[s+1],t[2]=e[s+2],t[3]=e[s+3],a(t,t,o),e[s]=t[0],e[s+1]=t[1],e[s+2]=t[2],e[s+3]=t[3];return e}}();function Ti(){var t=new vi(4);return t[0]=0,t[1]=0,t[2]=0,t[3]=1,t}function Ei(t,e,r,n){var i,a,o,s,u,l=e[0],p=e[1],h=e[2],c=e[3],f=r[0],y=r[1],d=r[2],m=r[3];return (a=l*f+p*y+h*d+c*m)<0&&(a=-a,f=-f,y=-y,d=-d,m=-m),1-a>1e-6?(i=Math.acos(a),o=Math.sin(i),s=Math.sin((1-n)*i)/o,u=Math.sin(n*i)/o):(s=1-n,u=n),t[0]=s*l+u*f,t[1]=s*p+u*y,t[2]=s*h+u*d,t[3]=s*c+u*m,t}var Pi,Fi,Li,Oi,Di,qi,ji=Ii;Pi=xi(),Fi=wi(1,0,0),Li=wi(0,1,0),Oi=Ti(),Di=Ti(),qi=gi();!function(){var t,e=((t=new vi(2))[0]=0,t[1]=0,t);}();var Ui=function(t){function e(e){t.call(this,e,mi);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new ri(t)},e.prototype.queryRadius=function(t){var e=t;return fi("circle-radius",this,e)+fi("circle-stroke-width",this,e)+yi(this.paint.get("circle-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o,s){for(var u=di(t,this.paint.get("circle-translate"),this.paint.get("circle-translate-anchor"),a.angle,o),l=this.paint.get("circle-radius").evaluate(e,r)+this.paint.get("circle-stroke-width").evaluate(e,r),p="map"===this.paint.get("circle-pitch-alignment"),h=p?u:function(t,e,r){return t.map(function(t){return t.map(function(t){return Ri(t,e,r)})})}(u,s,a),c=p?l*o:l,f=0,y=n;f<y.length;f+=1)for(var d=0,m=y[f];d<m.length;d+=1){var v=m[d],g=p?v:Ri(v,s,a),x=c,b=Ci([],[v.x,v.y,0,1],s);if("viewport"===this.paint.get("circle-pitch-scale")&&"map"===this.paint.get("circle-pitch-alignment")?x*=b[3]/a.cameraToCenterDistance:"map"===this.paint.get("circle-pitch-scale")&&"viewport"===this.paint.get("circle-pitch-alignment")&&(x*=a.cameraToCenterDistance/b[3]),ni(h,g,x))return !0}return !1},e}(on);function Ri(t,e,r){var n=Ci([],[t.x,t.y,0,1],e);return new a((n[0]/n[3]+1)*r.width*.5,(n[1]/n[3]+1)*r.height*.5)}var Ni=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(ri);function Zi(t,e,r,n){var i=e.width,a=e.height;if(n){if(n.length!==i*a*r)throw new RangeError("mismatched image size")}else n=new Uint8Array(i*a*r);return t.width=i,t.height=a,t.data=n,t}function Xi(t,e,r){var n=e.width,i=e.height;if(n!==t.width||i!==t.height){var a=Zi({},{width:n,height:i},r);Hi(t,a,{x:0,y:0},{x:0,y:0},{width:Math.min(t.width,n),height:Math.min(t.height,i)},r),t.width=n,t.height=i,t.data=a.data;}}function Hi(t,e,r,n,i,a){if(0===i.width||0===i.height)return e;if(i.width>t.width||i.height>t.height||r.x>t.width-i.width||r.y>t.height-i.height)throw new RangeError("out of range source coordinates for image copy");if(i.width>e.width||i.height>e.height||n.x>e.width-i.width||n.y>e.height-i.height)throw new RangeError("out of range destination coordinates for image copy");for(var o=t.data,s=e.data,u=0;u<i.height;u++)for(var l=((r.y+u)*t.width+r.x)*a,p=((n.y+u)*e.width+n.x)*a,h=0;h<i.width*a;h++)s[p+h]=o[l+h];return e}Br("HeatmapBucket",Ni,{omit:["layers"]});var Ji=function(t,e){Zi(this,t,1,e);};Ji.prototype.resize=function(t){Xi(this,t,1);},Ji.prototype.clone=function(){return new Ji({width:this.width,height:this.height},new Uint8Array(this.data))},Ji.copy=function(t,e,r,n,i){Hi(t,e,r,n,i,1);};var Gi=function(t,e){Zi(this,t,4,e);};Gi.prototype.resize=function(t){Xi(this,t,4);},Gi.prototype.clone=function(){return new Gi({width:this.width,height:this.height},new Uint8Array(this.data))},Gi.copy=function(t,e,r,n,i){Hi(t,e,r,n,i,4);},Br("AlphaImage",Ji),Br("RGBAImage",Gi);var Ki={paint:new an({"heatmap-radius":new en(O.paint_heatmap["heatmap-radius"]),"heatmap-weight":new en(O.paint_heatmap["heatmap-weight"]),"heatmap-intensity":new tn(O.paint_heatmap["heatmap-intensity"]),"heatmap-color":new nn(O.paint_heatmap["heatmap-color"]),"heatmap-opacity":new tn(O.paint_heatmap["heatmap-opacity"])})};function Yi(t,e){for(var r=new Uint8Array(1024),n={},i=0,a=0;i<256;i++,a+=4){n[e]=i/255;var o=t.evaluate(n);r[a+0]=Math.floor(255*o.r/o.a),r[a+1]=Math.floor(255*o.g/o.a),r[a+2]=Math.floor(255*o.b/o.a),r[a+3]=Math.floor(255*o.a);}return new Gi({width:256,height:1},r)}var $i=function(t){function e(e){t.call(this,e,Ki),this._updateColorRamp();}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new Ni(t)},e.prototype._handleSpecialPaintPropertyUpdate=function(t){"heatmap-color"===t&&this._updateColorRamp();},e.prototype._updateColorRamp=function(){var t=this._transitionablePaint._values["heatmap-color"].value.expression;this.colorRamp=Yi(t,"heatmapDensity"),this.colorRampTexture=null;},e.prototype.resize=function(){this.heatmapFbo&&(this.heatmapFbo.destroy(),this.heatmapFbo=null);},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return !1},e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("heatmap-opacity")&&"none"!==this.visibility},e}(on),Wi={paint:new an({"hillshade-illumination-direction":new tn(O.paint_hillshade["hillshade-illumination-direction"]),"hillshade-illumination-anchor":new tn(O.paint_hillshade["hillshade-illumination-anchor"]),"hillshade-exaggeration":new tn(O.paint_hillshade["hillshade-exaggeration"]),"hillshade-shadow-color":new tn(O.paint_hillshade["hillshade-shadow-color"]),"hillshade-highlight-color":new tn(O.paint_hillshade["hillshade-highlight-color"]),"hillshade-accent-color":new tn(O.paint_hillshade["hillshade-accent-color"])})},Qi=function(t){function e(e){t.call(this,e,Wi);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("hillshade-exaggeration")&&"none"!==this.visibility},e}(on),ta=pn([{name:"a_pos",components:2,type:"Int16"}],4),ea=ta.members,ra=(ta.size,ta.alignment,ia),na=ia;function ia(t,e,r){r=r||2;var n,i,a,o,s,u,l,p=e&&e.length,h=p?e[0]*r:t.length,c=aa(t,0,h,r,!0),f=[];if(!c)return f;if(p&&(c=function(t,e,r,n){var i,a,o,s,u,l=[];for(i=0,a=e.length;i<a;i++)o=e[i]*n,s=i<a-1?e[i+1]*n:t.length,(u=aa(t,o,s,n,!1))===u.next&&(u.steiner=!0),l.push(da(u));for(l.sort(ca),i=0;i<l.length;i++)fa(l[i],r),r=oa(r,r.next);return r}(t,e,c,r)),t.length>80*r){n=a=t[0],i=o=t[1];for(var y=r;y<h;y+=r)(s=t[y])<n&&(n=s),(u=t[y+1])<i&&(i=u),s>a&&(a=s),u>o&&(o=u);l=0!==(l=Math.max(a-n,o-i))?1/l:0;}return sa(c,f,r,n,i,l),f}function aa(t,e,r,n,i){var a,o;if(i===za(t,e,r,n)>0)for(a=e;a<r;a+=n)o=Aa(a,t[a],t[a+1],o);else for(a=r-n;a>=e;a-=n)o=Aa(a,t[a],t[a+1],o);return o&&xa(o,o.next)&&(ka(o),o=o.next),o}function oa(t,e){if(!t)return t;e||(e=t);var r,n=t;do{if(r=!1,n.steiner||!xa(n,n.next)&&0!==ga(n.prev,n,n.next))n=n.next;else{if(ka(n),(n=e=n.prev)===n.next)break;r=!0;}}while(r||n!==e);return e}function sa(t,e,r,n,i,a,o){if(t){!o&&a&&function(t,e,r,n){var i=t;do{null===i.z&&(i.z=ya(i.x,i.y,e,r,n)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next;}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,function(t){var e,r,n,i,a,o,s,u,l=1;do{for(r=t,t=null,a=null,o=0;r;){for(o++,n=r,s=0,e=0;e<l&&(s++,n=n.nextZ);e++);for(u=l;s>0||u>0&&n;)0!==s&&(0===u||!n||r.z<=n.z)?(i=r,r=r.nextZ,s--):(i=n,n=n.nextZ,u--),a?a.nextZ=i:t=i,i.prevZ=a,a=i;r=n;}a.nextZ=null,l*=2;}while(o>1)}(i);}(t,n,i,a);for(var s,u,l=t;t.prev!==t.next;)if(s=t.prev,u=t.next,a?la(t,n,i,a):ua(t))e.push(s.i/r),e.push(t.i/r),e.push(u.i/r),ka(t),t=u.next,l=u.next;else if((t=u)===l){o?1===o?sa(t=pa(t,e,r),e,r,n,i,a,2):2===o&&ha(t,e,r,n,i,a):sa(oa(t),e,r,n,i,a,1);break}}}function ua(t){var e=t.prev,r=t,n=t.next;if(ga(e,r,n)>=0)return !1;for(var i=t.next.next;i!==t.prev;){if(ma(e.x,e.y,r.x,r.y,n.x,n.y,i.x,i.y)&&ga(i.prev,i,i.next)>=0)return !1;i=i.next;}return !0}function la(t,e,r,n){var i=t.prev,a=t,o=t.next;if(ga(i,a,o)>=0)return !1;for(var s=i.x<a.x?i.x<o.x?i.x:o.x:a.x<o.x?a.x:o.x,u=i.y<a.y?i.y<o.y?i.y:o.y:a.y<o.y?a.y:o.y,l=i.x>a.x?i.x>o.x?i.x:o.x:a.x>o.x?a.x:o.x,p=i.y>a.y?i.y>o.y?i.y:o.y:a.y>o.y?a.y:o.y,h=ya(s,u,e,r,n),c=ya(l,p,e,r,n),f=t.prevZ,y=t.nextZ;f&&f.z>=h&&y&&y.z<=c;){if(f!==t.prev&&f!==t.next&&ma(i.x,i.y,a.x,a.y,o.x,o.y,f.x,f.y)&&ga(f.prev,f,f.next)>=0)return !1;if(f=f.prevZ,y!==t.prev&&y!==t.next&&ma(i.x,i.y,a.x,a.y,o.x,o.y,y.x,y.y)&&ga(y.prev,y,y.next)>=0)return !1;y=y.nextZ;}for(;f&&f.z>=h;){if(f!==t.prev&&f!==t.next&&ma(i.x,i.y,a.x,a.y,o.x,o.y,f.x,f.y)&&ga(f.prev,f,f.next)>=0)return !1;f=f.prevZ;}for(;y&&y.z<=c;){if(y!==t.prev&&y!==t.next&&ma(i.x,i.y,a.x,a.y,o.x,o.y,y.x,y.y)&&ga(y.prev,y,y.next)>=0)return !1;y=y.nextZ;}return !0}function pa(t,e,r){var n=t;do{var i=n.prev,a=n.next.next;!xa(i,a)&&ba(i,n,n.next,a)&&wa(i,a)&&wa(a,i)&&(e.push(i.i/r),e.push(n.i/r),e.push(a.i/r),ka(n),ka(n.next),n=t=a),n=n.next;}while(n!==t);return n}function ha(t,e,r,n,i,a){var o=t;do{for(var s=o.next.next;s!==o.prev;){if(o.i!==s.i&&va(o,s)){var u=_a(o,s);return o=oa(o,o.next),u=oa(u,u.next),sa(o,e,r,n,i,a),void sa(u,e,r,n,i,a)}s=s.next;}o=o.next;}while(o!==t)}function ca(t,e){return t.x-e.x}function fa(t,e){if(e=function(t,e){var r,n=e,i=t.x,a=t.y,o=-1/0;do{if(a<=n.y&&a>=n.next.y&&n.next.y!==n.y){var s=n.x+(a-n.y)*(n.next.x-n.x)/(n.next.y-n.y);if(s<=i&&s>o){if(o=s,s===i){if(a===n.y)return n;if(a===n.next.y)return n.next}r=n.x<n.next.x?n:n.next;}}n=n.next;}while(n!==e);if(!r)return null;if(i===o)return r.prev;var u,l=r,p=r.x,h=r.y,c=1/0;n=r.next;for(;n!==l;)i>=n.x&&n.x>=p&&i!==n.x&&ma(a<h?i:o,a,p,h,a<h?o:i,a,n.x,n.y)&&((u=Math.abs(a-n.y)/(i-n.x))<c||u===c&&n.x>r.x)&&wa(n,t)&&(r=n,c=u),n=n.next;return r}(t,e)){var r=_a(e,t);oa(r,r.next);}}function ya(t,e,r,n,i){return (t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t=32767*(t-r)*i)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e=32767*(e-n)*i)|e<<8))|e<<4))|e<<2))|e<<1))<<1}function da(t){var e=t,r=t;do{e.x<r.x&&(r=e),e=e.next;}while(e!==t);return r}function ma(t,e,r,n,i,a,o,s){return (i-o)*(e-s)-(t-o)*(a-s)>=0&&(t-o)*(n-s)-(r-o)*(e-s)>=0&&(r-o)*(a-s)-(i-o)*(n-s)>=0}function va(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){var r=t;do{if(r.i!==t.i&&r.next.i!==t.i&&r.i!==e.i&&r.next.i!==e.i&&ba(r,r.next,t,e))return !0;r=r.next;}while(r!==t);return !1}(t,e)&&wa(t,e)&&wa(e,t)&&function(t,e){var r=t,n=!1,i=(t.x+e.x)/2,a=(t.y+e.y)/2;do{r.y>a!=r.next.y>a&&r.next.y!==r.y&&i<(r.next.x-r.x)*(a-r.y)/(r.next.y-r.y)+r.x&&(n=!n),r=r.next;}while(r!==t);return n}(t,e)}function ga(t,e,r){return (e.y-t.y)*(r.x-e.x)-(e.x-t.x)*(r.y-e.y)}function xa(t,e){return t.x===e.x&&t.y===e.y}function ba(t,e,r,n){return !!(xa(t,e)&&xa(r,n)||xa(t,n)&&xa(r,e))||ga(t,e,r)>0!=ga(t,e,n)>0&&ga(r,n,t)>0!=ga(r,n,e)>0}function wa(t,e){return ga(t.prev,t,t.next)<0?ga(t,e,t.next)>=0&&ga(t,t.prev,e)>=0:ga(t,e,t.prev)<0||ga(t,t.next,e)<0}function _a(t,e){var r=new Sa(t.i,t.x,t.y),n=new Sa(e.i,e.x,e.y),i=t.next,a=e.prev;return t.next=e,e.prev=t,r.next=i,i.prev=r,n.next=r,r.prev=n,a.next=n,n.prev=a,n}function Aa(t,e,r,n){var i=new Sa(t,e,r);return n?(i.next=n.next,i.prev=n,n.next.prev=i,n.next=i):(i.prev=i,i.next=i),i}function ka(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ);}function Sa(t,e,r){this.i=t,this.x=e,this.y=r,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1;}function za(t,e,r,n){for(var i=0,a=e,o=r-n;a<r;a+=n)i+=(t[o]-t[a])*(t[a+1]+t[o+1]),o=a;return i}ia.deviation=function(t,e,r,n){var i=e&&e.length,a=i?e[0]*r:t.length,o=Math.abs(za(t,0,a,r));if(i)for(var s=0,u=e.length;s<u;s++){var l=e[s]*r,p=s<u-1?e[s+1]*r:t.length;o-=Math.abs(za(t,l,p,r));}var h=0;for(s=0;s<n.length;s+=3){var c=n[s]*r,f=n[s+1]*r,y=n[s+2]*r;h+=Math.abs((t[c]-t[y])*(t[f+1]-t[c+1])-(t[c]-t[f])*(t[y+1]-t[c+1]));}return 0===o&&0===h?0:Math.abs((h-o)/o)},ia.flatten=function(t){for(var e=t[0][0].length,r={vertices:[],holes:[],dimensions:e},n=0,i=0;i<t.length;i++){for(var a=0;a<t[i].length;a++)for(var o=0;o<e;o++)r.vertices.push(t[i][a][o]);i>0&&(n+=t[i-1].length,r.holes.push(n));}return r},ra.default=na;var Ma=Ia,Ba=Ia;function Ia(t,e,r,n,i){!function t(e,r,n,i,a){for(;i>n;){if(i-n>600){var o=i-n+1,s=r-n+1,u=Math.log(o),l=.5*Math.exp(2*u/3),p=.5*Math.sqrt(u*l*(o-l)/o)*(s-o/2<0?-1:1),h=Math.max(n,Math.floor(r-s*l/o+p)),c=Math.min(i,Math.floor(r+(o-s)*l/o+p));t(e,r,h,c,a);}var f=e[r],y=n,d=i;for(Ca(e,n,r),a(e[i],f)>0&&Ca(e,n,i);y<d;){for(Ca(e,y,d),y++,d--;a(e[y],f)<0;)y++;for(;a(e[d],f)>0;)d--;}0===a(e[n],f)?Ca(e,n,d):Ca(e,++d,i),d<=r&&(n=d+1),r<=d&&(i=d-1);}}(t,e,r||0,n||t.length-1,i||Va);}function Ca(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}function Va(t,e){return t<e?-1:t>e?1:0}function Ta(t,e){var r=t.length;if(r<=1)return [t];for(var n,i,a=[],o=0;o<r;o++){var s=_(t[o]);0!==s&&(t[o].area=Math.abs(s),void 0===i&&(i=s<0),i===s<0?(n&&a.push(n),n=[t[o]]):n.push(t[o]));}if(n&&a.push(n),e>1)for(var u=0;u<a.length;u++)a[u].length<=e||(Ma(a[u],e,1,a[u].length-1,Ea),a[u]=a[u].slice(0,e));return a}function Ea(t,e){return e.area-t.area}Ma.default=Ba;var Pa=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.layoutVertexArray=new cn,this.indexArray=new zn,this.indexArray2=new Mn,this.programConfigurations=new Kn(ea,t.layers,t.zoom),this.segments=new Rn,this.segments2=new Rn;};Pa.prototype.populate=function(t,e){for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=i.feature,o=i.index,s=i.sourceLayerIndex;if(this.layers[0]._featureFilter(new Xr(this.zoom),a)){var u=ti(a);this.addFeature(a,u,o),e.featureIndex.insert(a,u,o,s,this.index);}}},Pa.prototype.update=function(t,e){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers);},Pa.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},Pa.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},Pa.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,ea),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.indexBuffer2=t.createIndexBuffer(this.indexArray2)),this.programConfigurations.upload(t),this.uploaded=!0;},Pa.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.indexBuffer2.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.segments2.destroy());},Pa.prototype.addFeature=function(t,e,r){for(var n=0,i=Ta(e,500);n<i.length;n+=1){for(var a=i[n],o=0,s=0,u=a;s<u.length;s+=1){o+=u[s].length;}for(var l=this.segments.prepareSegment(o,this.layoutVertexArray,this.indexArray),p=l.vertexLength,h=[],c=[],f=0,y=a;f<y.length;f+=1){var d=y[f];if(0!==d.length){d!==a[0]&&c.push(h.length/2);var m=this.segments2.prepareSegment(d.length,this.layoutVertexArray,this.indexArray2),v=m.vertexLength;this.layoutVertexArray.emplaceBack(d[0].x,d[0].y),this.indexArray2.emplaceBack(v+d.length-1,v),h.push(d[0].x),h.push(d[0].y);for(var g=1;g<d.length;g++)this.layoutVertexArray.emplaceBack(d[g].x,d[g].y),this.indexArray2.emplaceBack(v+g-1,v+g),h.push(d[g].x),h.push(d[g].y);m.vertexLength+=d.length,m.primitiveLength+=d.length;}}for(var x=ra(h,c),b=0;b<x.length;b+=3)this.indexArray.emplaceBack(p+x[b],p+x[b+1],p+x[b+2]);l.vertexLength+=o,l.primitiveLength+=x.length/3;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r);},Br("FillBucket",Pa,{omit:["layers"]});var Fa={paint:new an({"fill-antialias":new tn(O.paint_fill["fill-antialias"]),"fill-opacity":new en(O.paint_fill["fill-opacity"]),"fill-color":new en(O.paint_fill["fill-color"]),"fill-outline-color":new en(O.paint_fill["fill-outline-color"]),"fill-translate":new tn(O.paint_fill["fill-translate"]),"fill-translate-anchor":new tn(O.paint_fill["fill-translate-anchor"]),"fill-pattern":new rn(O.paint_fill["fill-pattern"])})},La=function(t){function e(e){t.call(this,e,Fa);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(t){this.paint=this._transitioningPaint.possiblyEvaluate(t);var e=this.paint._values["fill-outline-color"];"constant"===e.value.kind&&void 0===e.value.value&&(this.paint._values["fill-outline-color"]=this.paint._values["fill-color"]);},e.prototype.createBucket=function(t){return new Pa(t)},e.prototype.queryRadius=function(){return yi(this.paint.get("fill-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o){return ii(di(t,this.paint.get("fill-translate"),this.paint.get("fill-translate-anchor"),a.angle,o),n)},e}(on),Oa=pn([{name:"a_pos",components:2,type:"Int16"},{name:"a_normal_ed",components:4,type:"Int16"}],4),Da=Oa.members,qa=(Oa.size,Oa.alignment,Math.pow(2,13));function ja(t,e,r,n,i,a,o,s){t.emplaceBack(e,r,2*Math.floor(n*qa)+o,i*qa*2,a*qa*2,Math.round(s));}var Ua=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.layoutVertexArray=new yn,this.indexArray=new zn,this.programConfigurations=new Kn(Da,t.layers,t.zoom),this.segments=new Rn;};function Ra(t,e){return t.x===e.x&&(t.x<0||t.x>$n)||t.y===e.y&&(t.y<0||t.y>$n)}function Na(t){return t.every(function(t){return t.x<0})||t.every(function(t){return t.x>$n})||t.every(function(t){return t.y<0})||t.every(function(t){return t.y>$n})}Ua.prototype.populate=function(t,e){for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=i.feature,o=i.index,s=i.sourceLayerIndex;if(this.layers[0]._featureFilter(new Xr(this.zoom),a)){var u=ti(a);this.addFeature(a,u,o),e.featureIndex.insert(a,u,o,s,this.index);}}},Ua.prototype.update=function(t,e){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers);},Ua.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},Ua.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},Ua.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Da),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},Ua.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},Ua.prototype.addFeature=function(t,e,r){for(var n=0,i=Ta(e,500);n<i.length;n+=1){for(var a=i[n],o=0,s=0,u=a;s<u.length;s+=1){o+=u[s].length;}for(var l=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray),p=0,h=a;p<h.length;p+=1){var c=h[p];if(0!==c.length&&!Na(c))for(var f=0,y=0;y<c.length;y++){var d=c[y];if(y>=1){var m=c[y-1];if(!Ra(d,m)){l.vertexLength+4>Rn.MAX_VERTEX_ARRAY_LENGTH&&(l=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray));var v=d.sub(m)._perp()._unit(),g=m.dist(d);f+g>32768&&(f=0),ja(this.layoutVertexArray,d.x,d.y,v.x,v.y,0,0,f),ja(this.layoutVertexArray,d.x,d.y,v.x,v.y,0,1,f),f+=g,ja(this.layoutVertexArray,m.x,m.y,v.x,v.y,0,0,f),ja(this.layoutVertexArray,m.x,m.y,v.x,v.y,0,1,f);var x=l.vertexLength;this.indexArray.emplaceBack(x,x+1,x+2),this.indexArray.emplaceBack(x+1,x+2,x+3),l.vertexLength+=4,l.primitiveLength+=2;}}}}l.vertexLength+o>Rn.MAX_VERTEX_ARRAY_LENGTH&&(l=this.segments.prepareSegment(o,this.layoutVertexArray,this.indexArray));for(var b=[],w=[],_=l.vertexLength,A=0,k=a;A<k.length;A+=1){var S=k[A];if(0!==S.length){S!==a[0]&&w.push(b.length/2);for(var z=0;z<S.length;z++){var M=S[z];ja(this.layoutVertexArray,M.x,M.y,0,0,1,1,0),b.push(M.x),b.push(M.y);}}}for(var B=ra(b,w),I=0;I<B.length;I+=3)this.indexArray.emplaceBack(_+B[I],_+B[I+1],_+B[I+2]);l.primitiveLength+=B.length/3,l.vertexLength+=o;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r);},Br("FillExtrusionBucket",Ua,{omit:["layers"]});var Za={paint:new an({"fill-extrusion-opacity":new tn(O["paint_fill-extrusion"]["fill-extrusion-opacity"]),"fill-extrusion-color":new en(O["paint_fill-extrusion"]["fill-extrusion-color"]),"fill-extrusion-translate":new tn(O["paint_fill-extrusion"]["fill-extrusion-translate"]),"fill-extrusion-translate-anchor":new tn(O["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),"fill-extrusion-pattern":new rn(O["paint_fill-extrusion"]["fill-extrusion-pattern"]),"fill-extrusion-height":new en(O["paint_fill-extrusion"]["fill-extrusion-height"]),"fill-extrusion-base":new en(O["paint_fill-extrusion"]["fill-extrusion-base"])})},Xa=function(t){function e(e){t.call(this,e,Za);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new Ua(t)},e.prototype.queryRadius=function(){return yi(this.paint.get("fill-extrusion-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o){return ii(di(t,this.paint.get("fill-extrusion-translate"),this.paint.get("fill-extrusion-translate-anchor"),a.angle,o),n)},e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("fill-extrusion-opacity")&&"none"!==this.visibility},e.prototype.resize=function(){this.viewportFrame&&(this.viewportFrame.destroy(),this.viewportFrame=null);},e}(on),Ha=pn([{name:"a_pos_normal",components:4,type:"Int16"},{name:"a_data",components:4,type:"Uint8"}],4),Ja=Ha.members,Ga=(Ha.size,Ha.alignment,Ka);function Ka(t,e,r,n,i){this.properties={},this.extent=r,this.type=0,this._pbf=t,this._geometry=-1,this._keys=n,this._values=i,t.readFields(Ya,this,e);}function Ya(t,e,r){1==t?e.id=r.readVarint():2==t?function(t,e){var r=t.readVarint()+t.pos;for(;t.pos<r;){var n=e._keys[t.readVarint()],i=e._values[t.readVarint()];e.properties[n]=i;}}(r,e):3==t?e.type=r.readVarint():4==t&&(e._geometry=r.pos);}function $a(t){for(var e,r,n=0,i=0,a=t.length,o=a-1;i<a;o=i++)e=t[i],n+=((r=t[o]).x-e.x)*(e.y+r.y);return n}Ka.types=["Unknown","Point","LineString","Polygon"],Ka.prototype.loadGeometry=function(){var t=this._pbf;t.pos=this._geometry;for(var e,r=t.readVarint()+t.pos,n=1,i=0,o=0,s=0,u=[];t.pos<r;){if(i<=0){var l=t.readVarint();n=7&l,i=l>>3;}if(i--,1===n||2===n)o+=t.readSVarint(),s+=t.readSVarint(),1===n&&(e&&u.push(e),e=[]),e.push(new a(o,s));else{if(7!==n)throw new Error("unknown command "+n);e&&e.push(e[0].clone());}}return e&&u.push(e),u},Ka.prototype.bbox=function(){var t=this._pbf;t.pos=this._geometry;for(var e=t.readVarint()+t.pos,r=1,n=0,i=0,a=0,o=1/0,s=-1/0,u=1/0,l=-1/0;t.pos<e;){if(n<=0){var p=t.readVarint();r=7&p,n=p>>3;}if(n--,1===r||2===r)(i+=t.readSVarint())<o&&(o=i),i>s&&(s=i),(a+=t.readSVarint())<u&&(u=a),a>l&&(l=a);else if(7!==r)throw new Error("unknown command "+r)}return [o,u,s,l]},Ka.prototype.toGeoJSON=function(t,e,r){var n,i,a=this.extent*Math.pow(2,r),o=this.extent*t,s=this.extent*e,u=this.loadGeometry(),l=Ka.types[this.type];function p(t){for(var e=0;e<t.length;e++){var r=t[e],n=180-360*(r.y+s)/a;t[e]=[360*(r.x+o)/a-180,360/Math.PI*Math.atan(Math.exp(n*Math.PI/180))-90];}}switch(this.type){case 1:var h=[];for(n=0;n<u.length;n++)h[n]=u[n][0];p(u=h);break;case 2:for(n=0;n<u.length;n++)p(u[n]);break;case 3:for(u=function(t){var e=t.length;if(e<=1)return [t];for(var r,n,i=[],a=0;a<e;a++){var o=$a(t[a]);0!==o&&(void 0===n&&(n=o<0),n===o<0?(r&&i.push(r),r=[t[a]]):r.push(t[a]));}r&&i.push(r);return i}(u),n=0;n<u.length;n++)for(i=0;i<u[n].length;i++)p(u[n][i]);}1===u.length?u=u[0]:l="Multi"+l;var c={type:"Feature",geometry:{type:l,coordinates:u},properties:this.properties};return "id"in this&&(c.id=this.id),c};var Wa=Qa;function Qa(t,e){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=t,this._keys=[],this._values=[],this._features=[],t.readFields(to,this,e),this.length=this._features.length;}function to(t,e,r){15===t?e.version=r.readVarint():1===t?e.name=r.readString():5===t?e.extent=r.readVarint():2===t?e._features.push(r.pos):3===t?e._keys.push(r.readString()):4===t&&e._values.push(function(t){var e=null,r=t.readVarint()+t.pos;for(;t.pos<r;){var n=t.readVarint()>>3;e=1===n?t.readString():2===n?t.readFloat():3===n?t.readDouble():4===n?t.readVarint64():5===n?t.readVarint():6===n?t.readSVarint():7===n?t.readBoolean():null;}return e}(r));}function eo(t,e,r){if(3===t){var n=new Wa(r,r.readVarint()+r.pos);n.length&&(e[n.name]=n);}}Qa.prototype.feature=function(t){if(t<0||t>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[t];var e=this._pbf.readVarint()+this._pbf.pos;return new Ga(this._pbf,e,this.extent,this._keys,this._values)};var ro={VectorTile:function(t,e){this.layers=t.readFields(eo,{},e);},VectorTileFeature:Ga,VectorTileLayer:Wa},no=ro.VectorTileFeature.types,io=63,ao=Math.cos(Math.PI/180*37.5),oo=.5,so=Math.pow(2,14)/oo;function uo(t,e,r,n,i,a,o){t.emplaceBack(e.x,e.y,n?1:0,i?1:-1,Math.round(io*r.x)+128,Math.round(io*r.y)+128,1+(0===a?0:a<0?-1:1)|(o*oo&63)<<2,o*oo>>6);}var lo=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.layoutVertexArray=new dn,this.indexArray=new zn,this.programConfigurations=new Kn(Ja,t.layers,t.zoom),this.segments=new Rn;};function po(t,e){return (t/e.tileTotal*(e.end-e.start)+e.start)*(so-1)}lo.prototype.populate=function(t,e){for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=i.feature,o=i.index,s=i.sourceLayerIndex;if(this.layers[0]._featureFilter(new Xr(this.zoom),a)){var u=ti(a);this.addFeature(a,u,o),e.featureIndex.insert(a,u,o,s,this.index);}}},lo.prototype.update=function(t,e){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers);},lo.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},lo.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},lo.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Ja),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},lo.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},lo.prototype.addFeature=function(t,e,r){for(var n=this.layers[0].layout,i=n.get("line-join").evaluate(t,{}),a=n.get("line-cap"),o=n.get("line-miter-limit"),s=n.get("line-round-limit"),u=0,l=e;u<l.length;u+=1){var p=l[u];this.addLine(p,t,i,a,o,s,r);}},lo.prototype.addLine=function(t,e,r,n,i,a,o){var s=null;e.properties&&e.properties.hasOwnProperty("mapbox_clip_start")&&e.properties.hasOwnProperty("mapbox_clip_end")&&(s={start:e.properties.mapbox_clip_start,end:e.properties.mapbox_clip_end,tileTotal:void 0});for(var u="Polygon"===no[e.type],l=t.length;l>=2&&t[l-1].equals(t[l-2]);)l--;for(var p=0;p<l-1&&t[p].equals(t[p+1]);)p++;if(!(l<(u?3:2))){s&&(s.tileTotal=function(t,e,r){for(var n,i,a=0,o=e;o<r-1;o++)n=t[o],i=t[o+1],a+=n.dist(i);return a}(t,p,l)),"bevel"===r&&(i=1.05);var h=$n/(512*this.overscaling)*15,c=t[p],f=this.segments.prepareSegment(10*l,this.layoutVertexArray,this.indexArray);this.distance=0;var y,d,m,v=n,g=u?"butt":n,x=!0,b=void 0,w=void 0,_=void 0,A=void 0;this.e1=this.e2=this.e3=-1,u&&(y=t[l-2],A=c.sub(y)._unit()._perp());for(var k=p;k<l;k++)if(!(w=u&&k===l-1?t[p+1]:t[k+1])||!t[k].equals(w)){A&&(_=A),y&&(b=y),y=t[k],A=w?w.sub(y)._unit()._perp():_;var S=(_=_||A).add(A);0===S.x&&0===S.y||S._unit();var z=S.x*A.x+S.y*A.y,M=0!==z?1/z:1/0,B=z<ao&&b&&w;if(B&&k>p){var I=y.dist(b);if(I>2*h){var C=y.sub(y.sub(b)._mult(h/I)._round());this.distance+=C.dist(b),this.addCurrentVertex(C,this.distance,_.mult(1),0,0,!1,f,s),b=C;}}var V=b&&w,T=V?r:w?v:g;if(V&&"round"===T&&(M<a?T="miter":M<=2&&(T="fakeround")),"miter"===T&&M>i&&(T="bevel"),"bevel"===T&&(M>2&&(T="flipbevel"),M<i&&(T="miter")),b&&(this.distance+=y.dist(b)),"miter"===T)S._mult(M),this.addCurrentVertex(y,this.distance,S,0,0,!1,f,s);else if("flipbevel"===T){if(M>100)S=A.clone().mult(-1);else{var E=_.x*A.y-_.y*A.x>0?-1:1,P=M*_.add(A).mag()/_.sub(A).mag();S._perp()._mult(P*E);}this.addCurrentVertex(y,this.distance,S,0,0,!1,f,s),this.addCurrentVertex(y,this.distance,S.mult(-1),0,0,!1,f,s);}else if("bevel"===T||"fakeround"===T){var F=_.x*A.y-_.y*A.x>0,L=-Math.sqrt(M*M-1);if(F?(m=0,d=L):(d=0,m=L),x||this.addCurrentVertex(y,this.distance,_,d,m,!1,f,s),"fakeround"===T){for(var O=Math.floor(8*(.5-(z-.5))),D=void 0,q=0;q<O;q++)D=A.mult((q+1)/(O+1))._add(_)._unit(),this.addPieSliceVertex(y,this.distance,D,F,f,s);this.addPieSliceVertex(y,this.distance,S,F,f,s);for(var j=O-1;j>=0;j--)D=_.mult((j+1)/(O+1))._add(A)._unit(),this.addPieSliceVertex(y,this.distance,D,F,f,s);}w&&this.addCurrentVertex(y,this.distance,A,-d,-m,!1,f,s);}else"butt"===T?(x||this.addCurrentVertex(y,this.distance,_,0,0,!1,f,s),w&&this.addCurrentVertex(y,this.distance,A,0,0,!1,f,s)):"square"===T?(x||(this.addCurrentVertex(y,this.distance,_,1,1,!1,f,s),this.e1=this.e2=-1),w&&this.addCurrentVertex(y,this.distance,A,-1,-1,!1,f,s)):"round"===T&&(x||(this.addCurrentVertex(y,this.distance,_,0,0,!1,f,s),this.addCurrentVertex(y,this.distance,_,1,1,!0,f,s),this.e1=this.e2=-1),w&&(this.addCurrentVertex(y,this.distance,A,-1,-1,!0,f,s),this.addCurrentVertex(y,this.distance,A,0,0,!1,f,s)));if(B&&k<l-1){var U=y.dist(w);if(U>2*h){var R=y.add(w.sub(y)._mult(h/U)._round());this.distance+=R.dist(y),this.addCurrentVertex(R,this.distance,A.mult(1),0,0,!1,f,s),y=R;}}x=!1;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,e,o);}},lo.prototype.addCurrentVertex=function(t,e,r,n,i,a,o,s){var u,l=this.layoutVertexArray,p=this.indexArray;s&&(e=po(e,s)),u=r.clone(),n&&u._sub(r.perp()._mult(n)),uo(l,t,u,a,!1,n,e),this.e3=o.vertexLength++,this.e1>=0&&this.e2>=0&&(p.emplaceBack(this.e1,this.e2,this.e3),o.primitiveLength++),this.e1=this.e2,this.e2=this.e3,u=r.mult(-1),i&&u._sub(r.perp()._mult(i)),uo(l,t,u,a,!0,-i,e),this.e3=o.vertexLength++,this.e1>=0&&this.e2>=0&&(p.emplaceBack(this.e1,this.e2,this.e3),o.primitiveLength++),this.e1=this.e2,this.e2=this.e3,e>so/2&&!s&&(this.distance=0,this.addCurrentVertex(t,this.distance,r,n,i,a,o));},lo.prototype.addPieSliceVertex=function(t,e,r,n,i,a){r=r.mult(n?-1:1);var o=this.layoutVertexArray,s=this.indexArray;a&&(e=po(e,a)),uo(o,t,r,!1,n,0,e),this.e3=i.vertexLength++,this.e1>=0&&this.e2>=0&&(s.emplaceBack(this.e1,this.e2,this.e3),i.primitiveLength++),n?this.e2=this.e3:this.e1=this.e3;},Br("LineBucket",lo,{omit:["layers"]});var ho=new an({"line-cap":new tn(O.layout_line["line-cap"]),"line-join":new en(O.layout_line["line-join"]),"line-miter-limit":new tn(O.layout_line["line-miter-limit"]),"line-round-limit":new tn(O.layout_line["line-round-limit"])}),co={paint:new an({"line-opacity":new en(O.paint_line["line-opacity"]),"line-color":new en(O.paint_line["line-color"]),"line-translate":new tn(O.paint_line["line-translate"]),"line-translate-anchor":new tn(O.paint_line["line-translate-anchor"]),"line-width":new en(O.paint_line["line-width"]),"line-gap-width":new en(O.paint_line["line-gap-width"]),"line-offset":new en(O.paint_line["line-offset"]),"line-blur":new en(O.paint_line["line-blur"]),"line-dasharray":new rn(O.paint_line["line-dasharray"]),"line-pattern":new rn(O.paint_line["line-pattern"]),"line-gradient":new nn(O.paint_line["line-gradient"])}),layout:ho},fo=new(function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.possiblyEvaluate=function(e,r){return r=new Xr(Math.floor(r.zoom),{now:r.now,fadeDuration:r.fadeDuration,zoomHistory:r.zoomHistory,transition:r.transition}),t.prototype.possiblyEvaluate.call(this,e,r)},e.prototype.evaluate=function(e,r,n,i){return r=h({},r,{zoom:Math.floor(r.zoom)}),t.prototype.evaluate.call(this,e,r,n,i)},e}(en))(co.paint.properties["line-width"].specification);fo.useIntegerZoom=!0;var yo=function(t){function e(e){t.call(this,e,co);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._handleSpecialPaintPropertyUpdate=function(t){"line-gradient"===t&&this._updateGradient();},e.prototype._updateGradient=function(){var t=this._transitionablePaint._values["line-gradient"].value.expression;this.gradient=Yi(t,"lineProgress"),this.gradientTexture=null;},e.prototype.recalculate=function(e){t.prototype.recalculate.call(this,e),this.paint._values["line-floorwidth"]=fo.possiblyEvaluate(this._transitioningPaint._values["line-width"].value,e);},e.prototype.createBucket=function(t){return new lo(t)},e.prototype.queryRadius=function(t){var e=t,r=mo(fi("line-width",this,e),fi("line-gap-width",this,e)),n=fi("line-offset",this,e);return r/2+Math.abs(n)+yi(this.paint.get("line-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,o,s){var u=di(t,this.paint.get("line-translate"),this.paint.get("line-translate-anchor"),o.angle,s),l=s/2*mo(this.paint.get("line-width").evaluate(e,r),this.paint.get("line-gap-width").evaluate(e,r)),p=this.paint.get("line-offset").evaluate(e,r);return p&&(n=function(t,e){for(var r=[],n=new a(0,0),i=0;i<t.length;i++){for(var o=t[i],s=[],u=0;u<o.length;u++){var l=o[u-1],p=o[u],h=o[u+1],c=0===u?n:p.sub(l)._unit()._perp(),f=u===o.length-1?n:h.sub(p)._unit()._perp(),y=c._add(f)._unit(),d=y.x*f.x+y.y*f.y;y._mult(1/d),s.push(y._mult(e)._add(p));}r.push(s);}return r}(n,p*s)),ai(u,n,l)},e}(on);function mo(t,e){return e>0?e+2*t:t}var vo=pn([{name:"a_pos_offset",components:4,type:"Int16"},{name:"a_data",components:4,type:"Uint16"}]),go=pn([{name:"a_projected_pos",components:3,type:"Float32"}],4),xo=(pn([{name:"a_fade_opacity",components:1,type:"Uint32"}],4),pn([{name:"a_placed",components:2,type:"Uint8"}],4)),bo=(pn([{type:"Int16",name:"anchorPointX"},{type:"Int16",name:"anchorPointY"},{type:"Int16",name:"x1"},{type:"Int16",name:"y1"},{type:"Int16",name:"x2"},{type:"Int16",name:"y2"},{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"},{type:"Int16",name:"radius"},{type:"Int16",name:"signedDistanceFromAnchor"}]),pn([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4)),wo=pn([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4);pn([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Uint16",name:"glyphStartIndex"},{type:"Uint16",name:"numGlyphs"},{type:"Uint32",name:"vertexStartIndex"},{type:"Uint32",name:"lineStartIndex"},{type:"Uint32",name:"lineLength"},{type:"Uint16",name:"segment"},{type:"Uint16",name:"lowerSize"},{type:"Uint16",name:"upperSize"},{type:"Float32",name:"lineOffsetX"},{type:"Float32",name:"lineOffsetY"},{type:"Uint8",name:"writingMode"},{type:"Uint8",name:"hidden"}]),pn([{type:"Float32",name:"offsetX"}]),pn([{type:"Int16",name:"x"},{type:"Int16",name:"y"},{type:"Int16",name:"tileUnitDistanceFromAnchor"}]);function _o(t,e,r){var n=e.layout.get("text-transform").evaluate(r,{});return "uppercase"===n?t=t.toLocaleUpperCase():"lowercase"===n&&(t=t.toLocaleLowerCase()),Zr.applyArabicShaping&&(t=Zr.applyArabicShaping(t)),t}function Ao(t,e,r){return t instanceof ht?(t.sections.forEach(function(t){t.text=_o(t.text,e,r);}),t):_o(t,e,r)}var ko={"!":"︕","#":"＃",$:"＄","%":"％","&":"＆","(":"︵",")":"︶","*":"＊","+":"＋",",":"︐","-":"︲",".":"・","/":"／",":":"︓",";":"︔","<":"︿","=":"＝",">":"﹀","?":"︖","@":"＠","[":"﹇","\\":"＼","]":"﹈","^":"＾",_:"︳","`":"｀","{":"︷","|":"―","}":"︸","~":"～","¢":"￠","£":"￡","¥":"￥","¦":"￤","¬":"￢","¯":"￣","–":"︲","—":"︱","‘":"﹃","’":"﹄","“":"﹁","”":"﹂","…":"︙","‧":"・","₩":"￦","、":"︑","。":"︒","〈":"︿","〉":"﹀","《":"︽","》":"︾","「":"﹁","」":"﹂","『":"﹃","』":"﹄","【":"︻","】":"︼","〔":"︹","〕":"︺","〖":"︗","〗":"︘","！":"︕","（":"︵","）":"︶","，":"︐","－":"︲","．":"・","：":"︓","；":"︔","＜":"︿","＞":"﹀","？":"︖","［":"﹇","］":"﹈","＿":"︳","｛":"︷","｜":"―","｝":"︸","｟":"︵","｠":"︶","｡":"︒","｢":"﹁","｣":"﹂"};var So=function(t){function e(e,r,n,i){t.call(this,e,r),this.angle=n,void 0!==i&&(this.segment=i);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.clone=function(){return new e(this.x,this.y,this.angle,this.segment)},e}(a);function zo(t,e){var r=e.expression;if("constant"===r.kind)return {functionType:"constant",layoutSize:r.evaluate(new Xr(t+1))};if("source"===r.kind)return {functionType:"source"};for(var n=r.zoomStops,i=0;i<n.length&&n[i]<=t;)i++;for(var a=i=Math.max(0,i-1);a<n.length&&n[a]<t+1;)a++;a=Math.min(n.length-1,a);var o={min:n[i],max:n[a]};return "composite"===r.kind?{functionType:"composite",zoomRange:o,propertyValue:e.value}:{functionType:"camera",layoutSize:r.evaluate(new Xr(t+1)),zoomRange:o,sizeRange:{min:r.evaluate(new Xr(o.min)),max:r.evaluate(new Xr(o.max))},propertyValue:e.value}}Br("Anchor",So);var Mo=ro.VectorTileFeature.types,Bo=[{name:"a_fade_opacity",components:1,type:"Uint8",offset:0}];function Io(t,e,r,n,i,a,o,s){t.emplaceBack(e,r,Math.round(32*n),Math.round(32*i),a,o,s?s[0]:0,s?s[1]:0);}function Co(t,e,r){t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r);}var Vo=function(t){this.layoutVertexArray=new mn,this.indexArray=new zn,this.programConfigurations=t,this.segments=new Rn,this.dynamicLayoutVertexArray=new vn,this.opacityVertexArray=new gn,this.placedSymbolArray=new En;};Vo.prototype.upload=function(t,e,r,n){r&&(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,vo.members),this.indexBuffer=t.createIndexBuffer(this.indexArray,e),this.dynamicLayoutVertexBuffer=t.createVertexBuffer(this.dynamicLayoutVertexArray,go.members,!0),this.opacityVertexBuffer=t.createVertexBuffer(this.opacityVertexArray,Bo,!0),this.opacityVertexBuffer.itemSize=1),(r||n)&&this.programConfigurations.upload(t);},Vo.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.dynamicLayoutVertexBuffer.destroy(),this.opacityVertexBuffer.destroy());},Br("SymbolBuffers",Vo);var To=function(t,e,r){this.layoutVertexArray=new t,this.layoutAttributes=e,this.indexArray=new r,this.segments=new Rn,this.collisionVertexArray=new wn;};To.prototype.upload=function(t){this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,this.layoutAttributes),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.collisionVertexBuffer=t.createVertexBuffer(this.collisionVertexArray,xo.members,!0);},To.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.segments.destroy(),this.collisionVertexBuffer.destroy());},Br("CollisionBuffers",To);var Eo=function(t){this.collisionBoxArray=t.collisionBoxArray,this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.pixelRatio=t.pixelRatio,this.sourceLayerIndex=t.sourceLayerIndex;var e=this.layers[0]._unevaluatedLayout._values;this.textSizeData=zo(this.zoom,e["text-size"]),this.iconSizeData=zo(this.zoom,e["icon-size"]);var r=this.layers[0].layout;this.sortFeaturesByY=r.get("text-allow-overlap")||r.get("icon-allow-overlap")||r.get("text-ignore-placement")||r.get("icon-ignore-placement"),this.sourceID=t.sourceID;};Eo.prototype.createArrays=function(){this.text=new Vo(new Kn(vo.members,this.layers,this.zoom,function(t){return /^text/.test(t)})),this.icon=new Vo(new Kn(vo.members,this.layers,this.zoom,function(t){return /^icon/.test(t)})),this.collisionBox=new To(bn,bo.members,Mn),this.collisionCircle=new To(bn,wo.members,zn),this.glyphOffsetArray=new Fn,this.lineVertexArray=new On;},Eo.prototype.calculateGlyphDependencies=function(t,e,r,n){for(var i=0;i<t.length;i++)if(e[t.charCodeAt(i)]=!0,r&&n){var a=ko[t.charAt(i)];a&&(e[a.charCodeAt(0)]=!0);}},Eo.prototype.populate=function(t,e){var r=this.layers[0],n=r.layout,i=n.get("text-font"),a=n.get("text-field"),o=n.get("icon-image"),s=("constant"!==a.value.kind||a.value.value.toString().length>0)&&("constant"!==i.value.kind||i.value.value.length>0),u="constant"!==o.value.kind||o.value.value&&o.value.value.length>0;if(this.features=[],s||u){for(var l=e.iconDependencies,p=e.glyphDependencies,h=new Xr(this.zoom),c=0,f=t;c<f.length;c+=1){var y=f[c],d=y.feature,m=y.index,v=y.sourceLayerIndex;if(r._featureFilter(h,d)){var g=void 0;s&&(g=Ao(g=r.getValueAndResolveTokens("text-field",d),r,d));var x=void 0;if(u&&(x=r.getValueAndResolveTokens("icon-image",d)),g||x){var b={text:g,icon:x,index:m,sourceLayerIndex:v,geometry:ti(d),properties:d.properties,type:Mo[d.type]};if(void 0!==d.id&&(b.id=d.id),this.features.push(b),x&&(l[x]=!0),g){var w=i.evaluate(d,{}).join(","),_=p[w]=p[w]||{},A="map"===n.get("text-rotation-alignment")&&"point"!==n.get("symbol-placement");if(g instanceof ht)for(var k=0,S=g.sections;k<S.length;k+=1){var z=S[k],M=Pr(g.toString()),B=z.fontStack||w,I=p[B]=p[B]||{};this.calculateGlyphDependencies(z.text,I,A,M);}else{var C=Pr(g);this.calculateGlyphDependencies(g,_,A,C);}}}}}"line"===n.get("symbol-placement")&&(this.features=function(t){var e={},r={},n=[],i=0;function a(e){n.push(t[e]),i++;}function o(t,e,i){var a=r[t];return delete r[t],r[e]=a,n[a].geometry[0].pop(),n[a].geometry[0]=n[a].geometry[0].concat(i[0]),a}function s(t,r,i){var a=e[r];return delete e[r],e[t]=a,n[a].geometry[0].shift(),n[a].geometry[0]=i[0].concat(n[a].geometry[0]),a}function u(t,e,r){var n=r?e[0][e[0].length-1]:e[0][0];return t+":"+n.x+":"+n.y}for(var l=0;l<t.length;l++){var p=t[l],h=p.geometry,c=p.text instanceof ht?p.text.toString():p.text;if(c){var f=u(c,h),y=u(c,h,!0);if(f in r&&y in e&&r[f]!==e[y]){var d=s(f,y,h),m=o(f,y,n[d].geometry);delete e[f],delete r[y],r[u(c,n[m].geometry,!0)]=m,n[d].geometry=null;}else f in r?o(f,y,h):y in e?s(f,y,h):(a(l),e[f]=i-1,r[y]=i-1);}else a(l);}return n.filter(function(t){return t.geometry})}(this.features));}},Eo.prototype.update=function(t,e){this.stateDependentLayers.length&&(this.text.programConfigurations.updatePaintArrays(t,e,this.layers),this.icon.programConfigurations.updatePaintArrays(t,e,this.layers));},Eo.prototype.isEmpty=function(){return 0===this.symbolInstances.length},Eo.prototype.uploadPending=function(){return !this.uploaded||this.text.programConfigurations.needsUpload||this.icon.programConfigurations.needsUpload},Eo.prototype.upload=function(t){this.uploaded||(this.collisionBox.upload(t),this.collisionCircle.upload(t)),this.text.upload(t,this.sortFeaturesByY,!this.uploaded,this.text.programConfigurations.needsUpload),this.icon.upload(t,this.sortFeaturesByY,!this.uploaded,this.icon.programConfigurations.needsUpload),this.uploaded=!0;},Eo.prototype.destroy=function(){this.text.destroy(),this.icon.destroy(),this.collisionBox.destroy(),this.collisionCircle.destroy();},Eo.prototype.addToLineVertexArray=function(t,e){var r=this.lineVertexArray.length;if(void 0!==t.segment){for(var n=t.dist(e[t.segment+1]),i=t.dist(e[t.segment]),a={},o=t.segment+1;o<e.length;o++)a[o]={x:e[o].x,y:e[o].y,tileUnitDistanceFromAnchor:n},o<e.length-1&&(n+=e[o+1].dist(e[o]));for(var s=t.segment||0;s>=0;s--)a[s]={x:e[s].x,y:e[s].y,tileUnitDistanceFromAnchor:i},s>0&&(i+=e[s-1].dist(e[s]));for(var u=0;u<e.length;u++){var l=a[u];this.lineVertexArray.emplaceBack(l.x,l.y,l.tileUnitDistanceFromAnchor);}}return {lineStartIndex:r,lineLength:this.lineVertexArray.length-r}},Eo.prototype.addSymbols=function(t,e,r,n,i,a,o,s,u,l){for(var p=t.indexArray,h=t.layoutVertexArray,c=t.dynamicLayoutVertexArray,f=t.segments.prepareSegment(4*e.length,t.layoutVertexArray,t.indexArray),y=this.glyphOffsetArray.length,d=f.vertexLength,m=0,v=e;m<v.length;m+=1){var g=v[m],x=g.tl,b=g.tr,w=g.bl,_=g.br,A=g.tex,k=f.vertexLength,S=g.glyphOffset[1];Io(h,s.x,s.y,x.x,S+x.y,A.x,A.y,r),Io(h,s.x,s.y,b.x,S+b.y,A.x+A.w,A.y,r),Io(h,s.x,s.y,w.x,S+w.y,A.x,A.y+A.h,r),Io(h,s.x,s.y,_.x,S+_.y,A.x+A.w,A.y+A.h,r),Co(c,s,0),p.emplaceBack(k,k+1,k+2),p.emplaceBack(k+1,k+2,k+3),f.vertexLength+=4,f.primitiveLength+=2,this.glyphOffsetArray.emplaceBack(g.glyphOffset[0]);}t.placedSymbolArray.emplaceBack(s.x,s.y,y,this.glyphOffsetArray.length-y,d,u,l,s.segment,r?r[0]:0,r?r[1]:0,n[0],n[1],o,!1),t.programConfigurations.populatePaintArrays(t.layoutVertexArray.length,a,a.index);},Eo.prototype._addCollisionDebugVertex=function(t,e,r,n,i){return e.emplaceBack(0,0),t.emplaceBack(r.x,r.y,n.x,n.y,Math.round(i.x),Math.round(i.y))},Eo.prototype.addCollisionDebugVertices=function(t,e,r,n,i,o,s,u){var l=i.segments.prepareSegment(4,i.layoutVertexArray,i.indexArray),p=l.vertexLength,h=i.layoutVertexArray,c=i.collisionVertexArray;if(this._addCollisionDebugVertex(h,c,o,s.anchor,new a(t,e)),this._addCollisionDebugVertex(h,c,o,s.anchor,new a(r,e)),this._addCollisionDebugVertex(h,c,o,s.anchor,new a(r,n)),this._addCollisionDebugVertex(h,c,o,s.anchor,new a(t,n)),l.vertexLength+=4,u){var f=i.indexArray;f.emplaceBack(p,p+1,p+2),f.emplaceBack(p,p+2,p+3),l.primitiveLength+=2;}else{var y=i.indexArray;y.emplaceBack(p,p+1),y.emplaceBack(p+1,p+2),y.emplaceBack(p+2,p+3),y.emplaceBack(p+3,p),l.primitiveLength+=4;}},Eo.prototype.generateCollisionDebugBuffers=function(){for(var t=0,e=this.symbolInstances;t<e.length;t+=1){var r=e[t];r.textCollisionFeature={boxStartIndex:r.textBoxStartIndex,boxEndIndex:r.textBoxEndIndex},r.iconCollisionFeature={boxStartIndex:r.iconBoxStartIndex,boxEndIndex:r.iconBoxEndIndex};for(var n=0;n<2;n++){var i=r[0===n?"textCollisionFeature":"iconCollisionFeature"];if(i)for(var a=i.boxStartIndex;a<i.boxEndIndex;a++){var o=this.collisionBoxArray.get(a),s=o.x1,u=o.y1,l=o.x2,p=o.y2,h=o.radius>0;this.addCollisionDebugVertices(s,u,l,p,h?this.collisionCircle:this.collisionBox,o.anchorPoint,r,h);}}}},Eo.prototype.deserializeCollisionBoxes=function(t,e,r,n,i){for(var a={},o=e;o<r;o++){var s=t.get(o);if(0===s.radius){a.textBox={x1:s.x1,y1:s.y1,x2:s.x2,y2:s.y2,anchorPointX:s.anchorPointX,anchorPointY:s.anchorPointY},a.textFeatureIndex=s.featureIndex;break}a.textCircles||(a.textCircles=[],a.textFeatureIndex=s.featureIndex);a.textCircles.push(s.anchorPointX,s.anchorPointY,s.radius,s.signedDistanceFromAnchor,1);}for(var u=n;u<i;u++){var l=t.get(u);if(0===l.radius){a.iconBox={x1:l.x1,y1:l.y1,x2:l.x2,y2:l.y2,anchorPointX:l.anchorPointX,anchorPointY:l.anchorPointY},a.iconFeatureIndex=l.featureIndex;break}}return a},Eo.prototype.hasTextData=function(){return this.text.segments.get().length>0},Eo.prototype.hasIconData=function(){return this.icon.segments.get().length>0},Eo.prototype.hasCollisionBoxData=function(){return this.collisionBox.segments.get().length>0},Eo.prototype.hasCollisionCircleData=function(){return this.collisionCircle.segments.get().length>0},Eo.prototype.sortFeatures=function(t){var e=this;if(this.sortFeaturesByY&&this.sortedAngle!==t&&(this.sortedAngle=t,!(this.text.segments.get().length>1||this.icon.segments.get().length>1))){for(var r=[],n=0;n<this.symbolInstances.length;n++)r.push(n);var i=Math.sin(t),a=Math.cos(t);r.sort(function(t,r){var n=e.symbolInstances[t],o=e.symbolInstances[r];return (0|Math.round(i*n.anchor.x+a*n.anchor.y))-(0|Math.round(i*o.anchor.x+a*o.anchor.y))||o.featureIndex-n.featureIndex}),this.text.indexArray.clear(),this.icon.indexArray.clear(),this.featureSortOrder=[];for(var o=0,s=r;o<s.length;o+=1){var u=s[o],l=e.symbolInstances[u];e.featureSortOrder.push(l.featureIndex);for(var p=0,h=l.placedTextSymbolIndices;p<h.length;p+=1)for(var c=h[p],f=e.text.placedSymbolArray.get(c),y=f.vertexStartIndex+4*f.numGlyphs,d=f.vertexStartIndex;d<y;d+=4)e.text.indexArray.emplaceBack(d,d+1,d+2),e.text.indexArray.emplaceBack(d+1,d+2,d+3);var m=e.icon.placedSymbolArray.get(u);if(m.numGlyphs){var v=m.vertexStartIndex;e.icon.indexArray.emplaceBack(v,v+1,v+2),e.icon.indexArray.emplaceBack(v+1,v+2,v+3);}}this.text.indexBuffer&&this.text.indexBuffer.updateData(this.text.indexArray),this.icon.indexBuffer&&this.icon.indexBuffer.updateData(this.icon.indexArray);}},Br("SymbolBucket",Eo,{omit:["layers","collisionBoxArray","features","compareText"],shallow:["symbolInstances"]}),Eo.MAX_GLYPHS=65535,Eo.addDynamicAttributes=Co;var Po=new an({"symbol-placement":new tn(O.layout_symbol["symbol-placement"]),"symbol-spacing":new tn(O.layout_symbol["symbol-spacing"]),"symbol-avoid-edges":new tn(O.layout_symbol["symbol-avoid-edges"]),"icon-allow-overlap":new tn(O.layout_symbol["icon-allow-overlap"]),"icon-ignore-placement":new tn(O.layout_symbol["icon-ignore-placement"]),"icon-optional":new tn(O.layout_symbol["icon-optional"]),"icon-rotation-alignment":new tn(O.layout_symbol["icon-rotation-alignment"]),"icon-size":new en(O.layout_symbol["icon-size"]),"icon-text-fit":new tn(O.layout_symbol["icon-text-fit"]),"icon-text-fit-padding":new tn(O.layout_symbol["icon-text-fit-padding"]),"icon-image":new en(O.layout_symbol["icon-image"]),"icon-rotate":new en(O.layout_symbol["icon-rotate"]),"icon-padding":new tn(O.layout_symbol["icon-padding"]),"icon-keep-upright":new tn(O.layout_symbol["icon-keep-upright"]),"icon-offset":new en(O.layout_symbol["icon-offset"]),"icon-anchor":new en(O.layout_symbol["icon-anchor"]),"icon-pitch-alignment":new tn(O.layout_symbol["icon-pitch-alignment"]),"text-pitch-alignment":new tn(O.layout_symbol["text-pitch-alignment"]),"text-rotation-alignment":new tn(O.layout_symbol["text-rotation-alignment"]),"text-field":new en(O.layout_symbol["text-field"]),"text-font":new en(O.layout_symbol["text-font"]),"text-size":new en(O.layout_symbol["text-size"]),"text-max-width":new en(O.layout_symbol["text-max-width"]),"text-line-height":new tn(O.layout_symbol["text-line-height"]),"text-letter-spacing":new en(O.layout_symbol["text-letter-spacing"]),"text-justify":new en(O.layout_symbol["text-justify"]),"text-anchor":new en(O.layout_symbol["text-anchor"]),"text-max-angle":new tn(O.layout_symbol["text-max-angle"]),"text-rotate":new en(O.layout_symbol["text-rotate"]),"text-padding":new tn(O.layout_symbol["text-padding"]),"text-keep-upright":new tn(O.layout_symbol["text-keep-upright"]),"text-transform":new en(O.layout_symbol["text-transform"]),"text-offset":new en(O.layout_symbol["text-offset"]),"text-allow-overlap":new tn(O.layout_symbol["text-allow-overlap"]),"text-ignore-placement":new tn(O.layout_symbol["text-ignore-placement"]),"text-optional":new tn(O.layout_symbol["text-optional"])}),Fo={paint:new an({"icon-opacity":new en(O.paint_symbol["icon-opacity"]),"icon-color":new en(O.paint_symbol["icon-color"]),"icon-halo-color":new en(O.paint_symbol["icon-halo-color"]),"icon-halo-width":new en(O.paint_symbol["icon-halo-width"]),"icon-halo-blur":new en(O.paint_symbol["icon-halo-blur"]),"icon-translate":new tn(O.paint_symbol["icon-translate"]),"icon-translate-anchor":new tn(O.paint_symbol["icon-translate-anchor"]),"text-opacity":new en(O.paint_symbol["text-opacity"]),"text-color":new en(O.paint_symbol["text-color"]),"text-halo-color":new en(O.paint_symbol["text-halo-color"]),"text-halo-width":new en(O.paint_symbol["text-halo-width"]),"text-halo-blur":new en(O.paint_symbol["text-halo-blur"]),"text-translate":new tn(O.paint_symbol["text-translate"]),"text-translate-anchor":new tn(O.paint_symbol["text-translate-anchor"])}),layout:Po},Lo=function(t){function e(e){t.call(this,e,Fo);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(e){t.prototype.recalculate.call(this,e),"auto"===this.layout.get("icon-rotation-alignment")&&("point"!==this.layout.get("symbol-placement")?this.layout._values["icon-rotation-alignment"]="map":this.layout._values["icon-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-rotation-alignment")&&("point"!==this.layout.get("symbol-placement")?this.layout._values["text-rotation-alignment"]="map":this.layout._values["text-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-pitch-alignment")&&(this.layout._values["text-pitch-alignment"]=this.layout.get("text-rotation-alignment")),"auto"===this.layout.get("icon-pitch-alignment")&&(this.layout._values["icon-pitch-alignment"]=this.layout.get("icon-rotation-alignment"));},e.prototype.getValueAndResolveTokens=function(t,e){var r,n=this.layout.get(t).evaluate(e,{}),i=this._unevaluatedLayout._values[t];return i.isDataDriven()||Le(i.value)?n:(r=e.properties,n.replace(/{([^{}]+)}/g,function(t,e){return e in r?String(r[e]):""}))},e.prototype.createBucket=function(t){return new Eo(t)},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return !1},e}(on),Oo={paint:new an({"background-color":new tn(O.paint_background["background-color"]),"background-pattern":new rn(O.paint_background["background-pattern"]),"background-opacity":new tn(O.paint_background["background-opacity"])})},Do=function(t){function e(e){t.call(this,e,Oo);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(on),qo={paint:new an({"raster-opacity":new tn(O.paint_raster["raster-opacity"]),"raster-hue-rotate":new tn(O.paint_raster["raster-hue-rotate"]),"raster-brightness-min":new tn(O.paint_raster["raster-brightness-min"]),"raster-brightness-max":new tn(O.paint_raster["raster-brightness-max"]),"raster-saturation":new tn(O.paint_raster["raster-saturation"]),"raster-contrast":new tn(O.paint_raster["raster-contrast"]),"raster-resampling":new tn(O.paint_raster["raster-resampling"]),"raster-fade-duration":new tn(O.paint_raster["raster-fade-duration"])})},jo={circle:Ui,heatmap:$i,hillshade:Qi,fill:La,"fill-extrusion":Xa,line:yo,symbol:Lo,background:Do,raster:function(t){function e(e){t.call(this,e,qo);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(on)};function Uo(t,e,r){r=r||{},this.w=t||64,this.h=e||64,this.autoResize=!!r.autoResize,this.shelves=[],this.freebins=[],this.stats={},this.bins={},this.maxId=0;}function Ro(t,e,r){this.x=0,this.y=t,this.w=this.free=e,this.h=r;}Uo.prototype.pack=function(t,e){t=[].concat(t),e=e||{};for(var r,n,i,a,o=[],s=0;s<t.length;s++)if(r=t[s].w||t[s].width,n=t[s].h||t[s].height,i=t[s].id,r&&n){if(!(a=this.packOne(r,n,i)))continue;e.inPlace&&(t[s].x=a.x,t[s].y=a.y,t[s].id=a.id),o.push(a);}return this.shrink(),o},Uo.prototype.packOne=function(t,e,r){var n,i,a,o,s,u,l,p,h={freebin:-1,shelf:-1,waste:1/0},c=0;if("string"==typeof r||"number"==typeof r){if(n=this.getBin(r))return this.ref(n),n;"number"==typeof r&&(this.maxId=Math.max(r,this.maxId));}else r=++this.maxId;for(o=0;o<this.freebins.length;o++){if(e===(n=this.freebins[o]).maxh&&t===n.maxw)return this.allocFreebin(o,t,e,r);e>n.maxh||t>n.maxw||e<=n.maxh&&t<=n.maxw&&(a=n.maxw*n.maxh-t*e)<h.waste&&(h.waste=a,h.freebin=o);}for(o=0;o<this.shelves.length;o++)if(c+=(i=this.shelves[o]).h,!(t>i.free)){if(e===i.h)return this.allocShelf(o,t,e,r);e>i.h||e<i.h&&(a=(i.h-e)*t)<h.waste&&(h.freebin=-1,h.waste=a,h.shelf=o);}return -1!==h.freebin?this.allocFreebin(h.freebin,t,e,r):-1!==h.shelf?this.allocShelf(h.shelf,t,e,r):e<=this.h-c&&t<=this.w?(i=new Ro(c,this.w,e),this.allocShelf(this.shelves.push(i)-1,t,e,r)):this.autoResize?(s=u=this.h,((l=p=this.w)<=s||t>l)&&(p=2*Math.max(t,l)),(s<l||e>s)&&(u=2*Math.max(e,s)),this.resize(p,u),this.packOne(t,e,r)):null},Uo.prototype.allocFreebin=function(t,e,r,n){var i=this.freebins.splice(t,1)[0];return i.id=n,i.w=e,i.h=r,i.refcount=0,this.bins[n]=i,this.ref(i),i},Uo.prototype.allocShelf=function(t,e,r,n){var i=this.shelves[t].alloc(e,r,n);return this.bins[n]=i,this.ref(i),i},Uo.prototype.shrink=function(){if(this.shelves.length>0){for(var t=0,e=0,r=0;r<this.shelves.length;r++){var n=this.shelves[r];e+=n.h,t=Math.max(n.w-n.free,t);}this.resize(t,e);}},Uo.prototype.getBin=function(t){return this.bins[t]},Uo.prototype.ref=function(t){if(1==++t.refcount){var e=t.h;this.stats[e]=1+(0|this.stats[e]);}return t.refcount},Uo.prototype.unref=function(t){return 0===t.refcount?0:(0==--t.refcount&&(this.stats[t.h]--,delete this.bins[t.id],this.freebins.push(t)),t.refcount)},Uo.prototype.clear=function(){this.shelves=[],this.freebins=[],this.stats={},this.bins={},this.maxId=0;},Uo.prototype.resize=function(t,e){this.w=t,this.h=e;for(var r=0;r<this.shelves.length;r++)this.shelves[r].resize(t);return !0},Ro.prototype.alloc=function(t,e,r){if(t>this.free||e>this.h)return null;var n=this.x;return this.x+=t,this.free-=t,new function(t,e,r,n,i,a,o){this.id=t,this.x=e,this.y=r,this.w=n,this.h=i,this.maxw=a||n,this.maxh=o||i,this.refcount=0;}(r,n,this.y,t,e,t,this.h)},Ro.prototype.resize=function(t){return this.free+=t-this.w,this.w=t,!0};var No=function(t,e){var r=e.pixelRatio;this.paddedRect=t,this.pixelRatio=r;},Zo={tl:{configurable:!0},br:{configurable:!0},displaySize:{configurable:!0}};Zo.tl.get=function(){return [this.paddedRect.x+1,this.paddedRect.y+1]},Zo.br.get=function(){return [this.paddedRect.x+this.paddedRect.w-1,this.paddedRect.y+this.paddedRect.h-1]},Zo.displaySize.get=function(){return [(this.paddedRect.w-2)/this.pixelRatio,(this.paddedRect.h-2)/this.pixelRatio]},Object.defineProperties(No.prototype,Zo);var Xo=function(t){var e={},r=new Uo(0,0,{autoResize:!0}),n=[];for(var i in t){var a=t[i],o={x:0,y:0,w:a.data.width+2,h:a.data.height+2};n.push(o),e[i]=new No(o,a);}r.pack(n,{inPlace:!0});var s=new Gi({width:r.w,height:r.h});for(var u in t){var l=t[u],p=e[u].paddedRect;Gi.copy(l.data,s,{x:0,y:0},{x:p.x+1,y:p.y+1},l.data);}this.image=s,this.positions=e;};Br("ImagePosition",No),Br("ImageAtlas",Xo);var Ho=self.HTMLImageElement,Jo=self.HTMLCanvasElement,Go=self.HTMLVideoElement,Ko=self.ImageData,Yo=function(t,e,r,n){this.context=t,this.format=r,this.texture=t.gl.createTexture(),this.update(e,n);};Yo.prototype.update=function(t,e){var r=t.width,n=t.height,i=!this.size||this.size[0]!==r||this.size[1]!==n,a=this.context,o=a.gl;this.useMipmap=Boolean(e&&e.useMipmap),o.bindTexture(o.TEXTURE_2D,this.texture),i?(this.size=[r,n],a.pixelStoreUnpack.set(1),this.format!==o.RGBA||e&&!1===e.premultiply||a.pixelStoreUnpackPremultiplyAlpha.set(!0),t instanceof Ho||t instanceof Jo||t instanceof Go||t instanceof Ko?o.texImage2D(o.TEXTURE_2D,0,this.format,this.format,o.UNSIGNED_BYTE,t):o.texImage2D(o.TEXTURE_2D,0,this.format,r,n,0,this.format,o.UNSIGNED_BYTE,t.data)):t instanceof Ho||t instanceof Jo||t instanceof Go||t instanceof Ko?o.texSubImage2D(o.TEXTURE_2D,0,0,0,o.RGBA,o.UNSIGNED_BYTE,t):o.texSubImage2D(o.TEXTURE_2D,0,0,0,r,n,o.RGBA,o.UNSIGNED_BYTE,t.data),this.useMipmap&&this.isSizePowerOfTwo()&&o.generateMipmap(o.TEXTURE_2D);},Yo.prototype.bind=function(t,e,r){var n=this.context.gl;n.bindTexture(n.TEXTURE_2D,this.texture),r!==n.LINEAR_MIPMAP_NEAREST||this.isSizePowerOfTwo()||(r=n.LINEAR),t!==this.filter&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MAG_FILTER,t),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,r||t),this.filter=t),e!==this.wrap&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,e),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,e),this.wrap=e);},Yo.prototype.isSizePowerOfTwo=function(){return this.size[0]===this.size[1]&&Math.log(this.size[0])/Math.LN2%1==0},Yo.prototype.destroy=function(){this.context.gl.deleteTexture(this.texture),this.texture=null;};var $o=function(t,e,r,n,i){var a,o,s=8*i-n-1,u=(1<<s)-1,l=u>>1,p=-7,h=r?i-1:0,c=r?-1:1,f=t[e+h];for(h+=c,a=f&(1<<-p)-1,f>>=-p,p+=s;p>0;a=256*a+t[e+h],h+=c,p-=8);for(o=a&(1<<-p)-1,a>>=-p,p+=n;p>0;o=256*o+t[e+h],h+=c,p-=8);if(0===a)a=1-l;else{if(a===u)return o?NaN:1/0*(f?-1:1);o+=Math.pow(2,n),a-=l;}return (f?-1:1)*o*Math.pow(2,a-n)},Wo=function(t,e,r,n,i,a){var o,s,u,l=8*a-i-1,p=(1<<l)-1,h=p>>1,c=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,f=n?0:a-1,y=n?1:-1,d=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,o=p):(o=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-o))<1&&(o--,u*=2),(e+=o+h>=1?c/u:c*Math.pow(2,1-h))*u>=2&&(o++,u/=2),o+h>=p?(s=0,o=p):o+h>=1?(s=(e*u-1)*Math.pow(2,i),o+=h):(s=e*Math.pow(2,h-1)*Math.pow(2,i),o=0));i>=8;t[r+f]=255&s,f+=y,s/=256,i-=8);for(o=o<<i|s,l+=i;l>0;t[r+f]=255&o,f+=y,o/=256,l-=8);t[r+f-y]|=128*d;},Qo=ts;function ts(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length;}ts.Varint=0,ts.Fixed64=1,ts.Bytes=2,ts.Fixed32=5;function es(t){return t.type===ts.Bytes?t.readVarint()+t.pos:t.pos+1}function rs(t,e,r){return r?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function ns(t,e,r){var n=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.ceil(Math.log(e)/(7*Math.LN2));r.realloc(n);for(var i=r.pos-1;i>=t;i--)r.buf[i+n]=r.buf[i];}function is(t,e){for(var r=0;r<t.length;r++)e.writeVarint(t[r]);}function as(t,e){for(var r=0;r<t.length;r++)e.writeSVarint(t[r]);}function os(t,e){for(var r=0;r<t.length;r++)e.writeFloat(t[r]);}function ss(t,e){for(var r=0;r<t.length;r++)e.writeDouble(t[r]);}function us(t,e){for(var r=0;r<t.length;r++)e.writeBoolean(t[r]);}function ls(t,e){for(var r=0;r<t.length;r++)e.writeFixed32(t[r]);}function ps(t,e){for(var r=0;r<t.length;r++)e.writeSFixed32(t[r]);}function hs(t,e){for(var r=0;r<t.length;r++)e.writeFixed64(t[r]);}function cs(t,e){for(var r=0;r<t.length;r++)e.writeSFixed64(t[r]);}function fs(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function ys(t,e,r){t[r]=e,t[r+1]=e>>>8,t[r+2]=e>>>16,t[r+3]=e>>>24;}function ds(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}ts.prototype={destroy:function(){this.buf=null;},readFields:function(t,e,r){for(r=r||this.length;this.pos<r;){var n=this.readVarint(),i=n>>3,a=this.pos;this.type=7&n,t(i,e,this),this.pos===a&&this.skip(n);}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=fs(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=ds(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=fs(this.buf,this.pos)+4294967296*fs(this.buf,this.pos+4);return this.pos+=8,t},readSFixed64:function(){var t=fs(this.buf,this.pos)+4294967296*ds(this.buf,this.pos+4);return this.pos+=8,t},readFloat:function(){var t=$o(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=$o(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e,r,n=this.buf;return e=127&(r=n[this.pos++]),r<128?e:(e|=(127&(r=n[this.pos++]))<<7,r<128?e:(e|=(127&(r=n[this.pos++]))<<14,r<128?e:(e|=(127&(r=n[this.pos++]))<<21,r<128?e:function(t,e,r){var n,i,a=r.buf;if(i=a[r.pos++],n=(112&i)>>4,i<128)return rs(t,n,e);if(i=a[r.pos++],n|=(127&i)<<3,i<128)return rs(t,n,e);if(i=a[r.pos++],n|=(127&i)<<10,i<128)return rs(t,n,e);if(i=a[r.pos++],n|=(127&i)<<17,i<128)return rs(t,n,e);if(i=a[r.pos++],n|=(127&i)<<24,i<128)return rs(t,n,e);if(i=a[r.pos++],n|=(1&i)<<31,i<128)return rs(t,n,e);throw new Error("Expected varint not more than 10 bytes")}(e|=(15&(r=n[this.pos]))<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,e=function(t,e,r){var n="",i=e;for(;i<r;){var a,o,s,u=t[i],l=null,p=u>239?4:u>223?3:u>191?2:1;if(i+p>r)break;1===p?u<128&&(l=u):2===p?128==(192&(a=t[i+1]))&&(l=(31&u)<<6|63&a)<=127&&(l=null):3===p?(a=t[i+1],o=t[i+2],128==(192&a)&&128==(192&o)&&((l=(15&u)<<12|(63&a)<<6|63&o)<=2047||l>=55296&&l<=57343)&&(l=null)):4===p&&(a=t[i+1],o=t[i+2],s=t[i+3],128==(192&a)&&128==(192&o)&&128==(192&s)&&((l=(15&u)<<18|(63&a)<<12|(63&o)<<6|63&s)<=65535||l>=1114112)&&(l=null)),null===l?(l=65533,p=1):l>65535&&(l-=65536,n+=String.fromCharCode(l>>>10&1023|55296),l=56320|1023&l),n+=String.fromCharCode(l),i+=p;}return n}(this.buf,this.pos,t);return this.pos=t,e},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){var r=es(this);for(t=t||[];this.pos<r;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){var e=es(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){var e=es(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){var e=es(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){var e=es(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){var e=es(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){var e=es(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){var e=es(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){var e=es(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){var e=7&t;if(e===ts.Varint)for(;this.buf[this.pos++]>127;);else if(e===ts.Bytes)this.pos=this.readVarint()+this.pos;else if(e===ts.Fixed32)this.pos+=4;else{if(e!==ts.Fixed64)throw new Error("Unimplemented type: "+e);this.pos+=8;}},writeTag:function(t,e){this.writeVarint(t<<3|e);},realloc:function(t){for(var e=this.length||16;e<this.pos+t;)e*=2;if(e!==this.length){var r=new Uint8Array(e);r.set(this.buf),this.buf=r,this.length=e;}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),ys(this.buf,t,this.pos),this.pos+=4;},writeSFixed32:function(t){this.realloc(4),ys(this.buf,t,this.pos),this.pos+=4;},writeFixed64:function(t){this.realloc(8),ys(this.buf,-1&t,this.pos),ys(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8;},writeSFixed64:function(t){this.realloc(8),ys(this.buf,-1&t,this.pos),ys(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8;},writeVarint:function(t){(t=+t||0)>268435455||t<0?function(t,e){var r,n;t>=0?(r=t%4294967296|0,n=t/4294967296|0):(n=~(-t/4294967296),4294967295^(r=~(-t%4294967296))?r=r+1|0:(r=0,n=n+1|0));if(t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e,r){r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos]=127&t;}(r,0,e),function(t,e){var r=(7&t)<<4;if(e.buf[e.pos++]|=r|((t>>>=3)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;e.buf[e.pos++]=127&t;}(n,e);}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))));},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t);},writeBoolean:function(t){this.writeVarint(Boolean(t));},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,r){for(var n,i,a=0;a<e.length;a++){if((n=e.charCodeAt(a))>55295&&n<57344){if(!i){n>56319||a+1===e.length?(t[r++]=239,t[r++]=191,t[r++]=189):i=n;continue}if(n<56320){t[r++]=239,t[r++]=191,t[r++]=189,i=n;continue}n=i-55296<<10|n-56320|65536,i=null;}else i&&(t[r++]=239,t[r++]=191,t[r++]=189,i=null);n<128?t[r++]=n:(n<2048?t[r++]=n>>6|192:(n<65536?t[r++]=n>>12|224:(t[r++]=n>>18|240,t[r++]=n>>12&63|128),t[r++]=n>>6&63|128),t[r++]=63&n|128);}return r}(this.buf,t,this.pos);var r=this.pos-e;r>=128&&ns(e,r,this),this.pos=e-1,this.writeVarint(r),this.pos+=r;},writeFloat:function(t){this.realloc(4),Wo(this.buf,t,this.pos,!0,23,4),this.pos+=4;},writeDouble:function(t){this.realloc(8),Wo(this.buf,t,this.pos,!0,52,8),this.pos+=8;},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var r=0;r<e;r++)this.buf[this.pos++]=t[r];},writeRawMessage:function(t,e){this.pos++;var r=this.pos;t(e,this);var n=this.pos-r;n>=128&&ns(r,n,this),this.pos=r-1,this.writeVarint(n),this.pos+=n;},writeMessage:function(t,e,r){this.writeTag(t,ts.Bytes),this.writeRawMessage(e,r);},writePackedVarint:function(t,e){this.writeMessage(t,is,e);},writePackedSVarint:function(t,e){this.writeMessage(t,as,e);},writePackedBoolean:function(t,e){this.writeMessage(t,us,e);},writePackedFloat:function(t,e){this.writeMessage(t,os,e);},writePackedDouble:function(t,e){this.writeMessage(t,ss,e);},writePackedFixed32:function(t,e){this.writeMessage(t,ls,e);},writePackedSFixed32:function(t,e){this.writeMessage(t,ps,e);},writePackedFixed64:function(t,e){this.writeMessage(t,hs,e);},writePackedSFixed64:function(t,e){this.writeMessage(t,cs,e);},writeBytesField:function(t,e){this.writeTag(t,ts.Bytes),this.writeBytes(e);},writeFixed32Field:function(t,e){this.writeTag(t,ts.Fixed32),this.writeFixed32(e);},writeSFixed32Field:function(t,e){this.writeTag(t,ts.Fixed32),this.writeSFixed32(e);},writeFixed64Field:function(t,e){this.writeTag(t,ts.Fixed64),this.writeFixed64(e);},writeSFixed64Field:function(t,e){this.writeTag(t,ts.Fixed64),this.writeSFixed64(e);},writeVarintField:function(t,e){this.writeTag(t,ts.Varint),this.writeVarint(e);},writeSVarintField:function(t,e){this.writeTag(t,ts.Varint),this.writeSVarint(e);},writeStringField:function(t,e){this.writeTag(t,ts.Bytes),this.writeString(e);},writeFloatField:function(t,e){this.writeTag(t,ts.Fixed32),this.writeFloat(e);},writeDoubleField:function(t,e){this.writeTag(t,ts.Fixed64),this.writeDouble(e);},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e));}};var ms=3;function vs(t,e,r){1===t&&r.readMessage(gs,e);}function gs(t,e,r){if(3===t){var n=r.readMessage(xs,{}),i=n.id,a=n.bitmap,o=n.width,s=n.height,u=n.left,l=n.top,p=n.advance;e.push({id:i,bitmap:new Ji({width:o+2*ms,height:s+2*ms},a),metrics:{width:o,height:s,left:u,top:l,advance:p}});}}function xs(t,e,r){1===t?e.id=r.readVarint():2===t?e.bitmap=r.readBytes():3===t?e.width=r.readVarint():4===t?e.height=r.readVarint():5===t?e.left=r.readSVarint():6===t?e.top=r.readSVarint():7===t&&(e.advance=r.readVarint());}var bs=ms,ws=function(t,e,r){this.target=t,this.parent=e,this.mapId=r,this.callbacks={},this.callbackID=0,y(["receive"],this),this.target.addEventListener("message",this.receive,!1);};function _s(t,e,r){var n=2*Math.PI*6378137/256/Math.pow(2,r);return [t*n-2*Math.PI*6378137/2,e*n-2*Math.PI*6378137/2]}ws.prototype.send=function(t,e,r,n){var i=r?this.mapId+":"+this.callbackID++:null;r&&(this.callbacks[i]=r);var a=[];this.target.postMessage({targetMapId:n,sourceMapId:this.mapId,type:t,id:String(i),data:Cr(e,a)},a);},ws.prototype.receive=function(t){var e,r=this,n=t.data,i=n.id;if(!n.targetMapId||this.mapId===n.targetMapId){var a=function(t,e){var n=[];r.target.postMessage({sourceMapId:r.mapId,type:"<response>",id:String(i),error:t?Cr(t):null,data:Cr(e,n)},n);};if("<response>"===n.type)e=this.callbacks[n.id],delete this.callbacks[n.id],e&&n.error?e(Vr(n.error)):e&&e(null,Vr(n.data));else if(void 0!==n.id&&this.parent[n.type])this.parent[n.type](n.sourceMapId,Vr(n.data),a);else if(void 0!==n.id&&this.parent.getWorkerSource){var o=n.type.split("."),s=Vr(n.data);this.parent.getWorkerSource(n.sourceMapId,o[0],s.source)[o[1]](s,a);}else this.parent[n.type](Vr(n.data));}},ws.prototype.remove=function(){this.target.removeEventListener("message",this.receive,!1);};var As=function(t,e,r){this.z=t,this.x=e,this.y=r,this.key=zs(0,t,e,r);};As.prototype.equals=function(t){return this.z===t.z&&this.x===t.x&&this.y===t.y},As.prototype.url=function(t,e){var r,n,i,a,o,s=(r=this.x,n=this.y,i=this.z,a=_s(256*r,256*(n=Math.pow(2,i)-n-1),i),o=_s(256*(r+1),256*(n+1),i),a[0]+","+a[1]+","+o[0]+","+o[1]),u=function(t,e,r){for(var n,i="",a=t;a>0;a--)i+=(e&(n=1<<a-1)?1:0)+(r&n?2:0);return i}(this.z,this.x,this.y);return t[(this.x+this.y)%t.length].replace("{prefix}",(this.x%16).toString(16)+(this.y%16).toString(16)).replace("{z}",String(this.z)).replace("{x}",String(this.x)).replace("{y}",String("tms"===e?Math.pow(2,this.z)-this.y-1:this.y)).replace("{quadkey}",u).replace("{bbox-epsg-3857}",s)};var ks=function(t,e){this.wrap=t,this.canonical=e,this.key=zs(t,e.z,e.x,e.y);},Ss=function(t,e,r,n,i){this.overscaledZ=t,this.wrap=e,this.canonical=new As(r,+n,+i),this.key=zs(e,t,n,i);};function zs(t,e,r,n){(t*=2)<0&&(t=-1*t-1);var i=1<<e;return 32*(i*i*t+i*n+r)+e}Ss.prototype.equals=function(t){return this.overscaledZ===t.overscaledZ&&this.wrap===t.wrap&&this.canonical.equals(t.canonical)},Ss.prototype.scaledTo=function(t){var e=this.canonical.z-t;return t>this.canonical.z?new Ss(t,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y):new Ss(t,this.wrap,t,this.canonical.x>>e,this.canonical.y>>e)},Ss.prototype.isChildOf=function(t){var e=this.canonical.z-t.canonical.z;return 0===t.overscaledZ||t.overscaledZ<this.overscaledZ&&t.canonical.x===this.canonical.x>>e&&t.canonical.y===this.canonical.y>>e},Ss.prototype.children=function(t){if(this.overscaledZ>=t)return [new Ss(this.overscaledZ+1,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y)];var e=this.canonical.z+1,r=2*this.canonical.x,n=2*this.canonical.y;return [new Ss(e,this.wrap,e,r,n),new Ss(e,this.wrap,e,r+1,n),new Ss(e,this.wrap,e,r,n+1),new Ss(e,this.wrap,e,r+1,n+1)]},Ss.prototype.isLessThan=function(t){return this.wrap<t.wrap||!(this.wrap>t.wrap)&&(this.overscaledZ<t.overscaledZ||!(this.overscaledZ>t.overscaledZ)&&(this.canonical.x<t.canonical.x||!(this.canonical.x>t.canonical.x)&&this.canonical.y<t.canonical.y))},Ss.prototype.wrapped=function(){return new Ss(this.overscaledZ,0,this.canonical.z,this.canonical.x,this.canonical.y)},Ss.prototype.unwrapTo=function(t){return new Ss(this.overscaledZ,t,this.canonical.z,this.canonical.x,this.canonical.y)},Ss.prototype.overscaleFactor=function(){return Math.pow(2,this.overscaledZ-this.canonical.z)},Ss.prototype.toUnwrapped=function(){return new ks(this.wrap,this.canonical)},Ss.prototype.toString=function(){return this.overscaledZ+"/"+this.canonical.x+"/"+this.canonical.y},Ss.prototype.toCoordinate=function(){return new i(this.canonical.x+Math.pow(2,this.wrap),this.canonical.y,this.canonical.z)},Br("CanonicalTileID",As),Br("OverscaledTileID",Ss,{omit:["posMatrix"]});var Ms=function(t,e,r){if(this.uid=t,e.height!==e.width)throw new RangeError("DEM tiles must be square");if(r&&"mapbox"!==r&&"terrarium"!==r)return b('"'+r+'" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');var n=this.dim=e.height;this.border=Math.max(Math.ceil(e.height/2),1),this.stride=this.dim+2*this.border,this.data=new Int32Array(this.stride*this.stride);for(var i=e.data,a="terrarium"===r?this._unpackTerrarium:this._unpackMapbox,o=0;o<n;o++)for(var s=0;s<n;s++){var u=4*(o*n+s);this.set(s,o,a(i[u],i[u+1],i[u+2]));}for(var l=0;l<n;l++)this.set(-1,l,this.get(0,l)),this.set(n,l,this.get(n-1,l)),this.set(l,-1,this.get(l,0)),this.set(l,n,this.get(l,n-1));this.set(-1,-1,this.get(0,0)),this.set(n,-1,this.get(n-1,0)),this.set(-1,n,this.get(0,n-1)),this.set(n,n,this.get(n-1,n-1));};Ms.prototype.set=function(t,e,r){this.data[this._idx(t,e)]=r+65536;},Ms.prototype.get=function(t,e){return this.data[this._idx(t,e)]-65536},Ms.prototype._idx=function(t,e){if(t<-this.border||t>=this.dim+this.border||e<-this.border||e>=this.dim+this.border)throw new RangeError("out of range source coordinates for DEM data");return (e+this.border)*this.stride+(t+this.border)},Ms.prototype._unpackMapbox=function(t,e,r){return (256*t*256+256*e+r)/10-1e4},Ms.prototype._unpackTerrarium=function(t,e,r){return 256*t+e+r/256-32768},Ms.prototype.getPixels=function(){return new Gi({width:this.dim+2*this.border,height:this.dim+2*this.border},new Uint8Array(this.data.buffer))},Ms.prototype.backfillBorder=function(t,e,r){if(this.dim!==t.dim)throw new Error("dem dimension mismatch");var n=e*this.dim,i=e*this.dim+this.dim,a=r*this.dim,o=r*this.dim+this.dim;switch(e){case-1:n=i-1;break;case 1:i=n+1;}switch(r){case-1:a=o-1;break;case 1:o=a+1;}for(var s=p(n,-this.border,this.dim+this.border),u=p(i,-this.border,this.dim+this.border),l=p(a,-this.border,this.dim+this.border),h=p(o,-this.border,this.dim+this.border),c=-e*this.dim,f=-r*this.dim,y=l;y<h;y++)for(var d=s;d<u;d++)this.set(d,y,t.get(d+c,y+f));},Br("DEMData",Ms);var Bs=pn([{name:"a_pos",type:"Int16",components:2},{name:"a_texture_pos",type:"Int16",components:2}]);var Is=function(t){this._stringToNumber={},this._numberToString=[];for(var e=0;e<t.length;e++){var r=t[e];this._stringToNumber[r]=e,this._numberToString[e]=r;}};Is.prototype.encode=function(t){return this._stringToNumber[t]},Is.prototype.decode=function(t){return this._numberToString[t]};var Cs=function(t,e,r,n){this.type="Feature",this._vectorTileFeature=t,t._z=e,t._x=r,t._y=n,this.properties=t.properties,null!=t.id&&(this.id=t.id);},Vs={geometry:{configurable:!0}};Vs.geometry.get=function(){return void 0===this._geometry&&(this._geometry=this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x,this._vectorTileFeature._y,this._vectorTileFeature._z).geometry),this._geometry},Vs.geometry.set=function(t){this._geometry=t;},Cs.prototype.toJSON=function(){var t={geometry:this.geometry};for(var e in this)"_geometry"!==e&&"_vectorTileFeature"!==e&&(t[e]=this[e]);return t},Object.defineProperties(Cs.prototype,Vs);var Ts=function(){this.state={},this.stateChanges={};};Ts.prototype.updateState=function(t,e,r){e=String(e),this.stateChanges[t]=this.stateChanges[t]||{},this.stateChanges[t][e]=this.stateChanges[t][e]||{},h(this.stateChanges[t][e],r);},Ts.prototype.getState=function(t,e){e=String(e);var r=this.state[t]||{},n=this.stateChanges[t]||{};return h({},r[e],n[e])},Ts.prototype.initializeTileState=function(t,e){t.setFeatureState(this.state,e);},Ts.prototype.coalesceChanges=function(t,e){var r={};for(var n in this.stateChanges){this.state[n]=this.state[n]||{};var i={};for(var a in this.stateChanges[n])this.state[n][a]||(this.state[n][a]={}),h(this.state[n][a],this.stateChanges[n][a]),i[a]=this.state[n][a];r[n]=i;}if(this.stateChanges={},0!==Object.keys(r).length)for(var o in t){t[o].setFeatureState(r,e);}};var Es=function(t,e,r){this.tileID=t,this.x=t.canonical.x,this.y=t.canonical.y,this.z=t.canonical.z,this.grid=e||new Ar($n,16,0),this.featureIndexArray=r||new qn;};function Ps(t,e){return e-t}Es.prototype.insert=function(t,e,r,n,i){var a=this.featureIndexArray.length;this.featureIndexArray.emplaceBack(r,n,i);for(var o=0;o<e.length;o++){for(var s=e[o],u=[1/0,1/0,-1/0,-1/0],l=0;l<s.length;l++){var p=s[l];u[0]=Math.min(u[0],p.x),u[1]=Math.min(u[1],p.y),u[2]=Math.max(u[2],p.x),u[3]=Math.max(u[3],p.y);}u[0]<$n&&u[1]<$n&&u[2]>=0&&u[3]>=0&&this.grid.insert(a,u[0],u[1],u[2],u[3]);}},Es.prototype.loadVTLayers=function(){return this.vtLayers||(this.vtLayers=new ro.VectorTile(new Qo(this.rawTileData)).layers,this.sourceLayerCoder=new Is(this.vtLayers?Object.keys(this.vtLayers).sort():["_geojsonTileLayer"])),this.vtLayers},Es.prototype.query=function(t,e,r){var n=this;this.loadVTLayers();for(var i=t.params||{},a=$n/t.tileSize/t.scale,o=$e(i.filter),s=t.queryGeometry,u=t.queryPadding*a,l=1/0,p=1/0,h=-1/0,c=-1/0,f=0;f<s.length;f++)for(var y=s[f],d=0;d<y.length;d++){var m=y[d];l=Math.min(l,m.x),p=Math.min(p,m.y),h=Math.max(h,m.x),c=Math.max(c,m.y);}var v=this.grid.query(l-u,p-u,h+u,c+u);v.sort(Ps);for(var g,x={},b=function(u){var l=v[u];if(l!==g){g=l;var p=n.featureIndexArray.get(l),h=null;n.loadMatchingFeature(x,p.bucketIndex,p.sourceLayerIndex,p.featureIndex,o,i.layers,e,function(e,i){h||(h=ti(e));var o={};return e.id&&(o=r.getState(i.sourceLayer||"_geojsonTileLayer",String(e.id))),i.queryIntersectsFeature(s,e,o,h,n.z,t.transform,a,t.posMatrix)});}},w=0;w<v.length;w++)b(w);return x},Es.prototype.loadMatchingFeature=function(t,e,r,n,i,a,o,s){var u=this.bucketLayerIDs[e];if(!a||function(t,e){for(var r=0;r<t.length;r++)if(e.indexOf(t[r])>=0)return !0;return !1}(a,u)){var l=this.sourceLayerCoder.decode(r),p=this.vtLayers[l].feature(n);if(i(new Xr(this.tileID.overscaledZ),p))for(var h=0;h<u.length;h++){var c=u[h];if(!(a&&a.indexOf(c)<0)){var f=o[c];if(f&&(!s||s(p,f))){var y=new Cs(p,this.z,this.x,this.y);y.layer=f.serialize();var d=t[c];void 0===d&&(d=t[c]=[]),d.push({featureIndex:n,feature:y});}}}}},Es.prototype.lookupSymbolFeatures=function(t,e,r,n,i,a){var o={};this.loadVTLayers();for(var s=$e(n),u=0,l=t;u<l.length;u+=1){var p=l[u];this.loadMatchingFeature(o,e,r,p,s,i,a);}return o},Es.prototype.hasLayer=function(t){for(var e=0,r=this.bucketLayerIDs;e<r.length;e+=1)for(var n=0,i=r[e];n<i.length;n+=1){if(t===i[n])return !0}return !1},Br("FeatureIndex",Es,{omit:["rawTileData","sourceLayerCoder"]});var Fs=function(t,e){this.tileID=t,this.uid=f(),this.uses=0,this.tileSize=e,this.buckets={},this.expirationTime=null,this.queryPadding=0,this.hasSymbolBuckets=!1,this.expiredRequestCount=0,this.state="loading";};Fs.prototype.registerFadeDuration=function(t){var e=t+this.timeAdded;e<z.now()||this.fadeEndTime&&e<this.fadeEndTime||(this.fadeEndTime=e);},Fs.prototype.wasRequested=function(){return "errored"===this.state||"loaded"===this.state||"reloading"===this.state},Fs.prototype.loadVectorData=function(t,e,r){if(this.hasData()&&this.unloadVectorData(),this.state="loaded",t){for(var n in t.featureIndex&&(this.latestFeatureIndex=t.featureIndex,t.rawTileData?(this.latestRawTileData=t.rawTileData,this.latestFeatureIndex.rawTileData=t.rawTileData):this.latestRawTileData&&(this.latestFeatureIndex.rawTileData=this.latestRawTileData)),this.collisionBoxArray=t.collisionBoxArray,this.buckets=function(t,e){var r={};if(!e)return r;for(var n=0,i=t;n<i.length;n+=1){var a=i[n],o=a.layerIds.map(function(t){return e.getLayer(t)}).filter(Boolean);if(0!==o.length){a.layers=o,a.stateDependentLayers=o.filter(function(t){return t.isStateDependent()});for(var s=0,u=o;s<u.length;s+=1)r[u[s].id]=a;}}return r}(t.buckets,e.style),this.hasSymbolBuckets=!1,this.buckets){var i=this.buckets[n];if(i instanceof Eo){if(this.hasSymbolBuckets=!0,!r)break;i.justReloaded=!0;}}for(var a in this.queryPadding=0,this.buckets){var o=this.buckets[a];this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(a).queryRadius(o));}t.iconAtlasImage&&(this.iconAtlasImage=t.iconAtlasImage),t.glyphAtlasImage&&(this.glyphAtlasImage=t.glyphAtlasImage);}else this.collisionBoxArray=new Vn;},Fs.prototype.unloadVectorData=function(){for(var t in this.buckets)this.buckets[t].destroy();this.buckets={},this.iconAtlasTexture&&this.iconAtlasTexture.destroy(),this.glyphAtlasTexture&&this.glyphAtlasTexture.destroy(),this.latestFeatureIndex=null,this.state="unloaded";},Fs.prototype.unloadDEMData=function(){this.dem=null,this.neighboringTiles=null,this.state="unloaded";},Fs.prototype.getBucket=function(t){return this.buckets[t.id]},Fs.prototype.upload=function(t){for(var e in this.buckets){var r=this.buckets[e];r.uploadPending()&&r.upload(t);}var n=t.gl;this.iconAtlasImage&&(this.iconAtlasTexture=new Yo(t,this.iconAtlasImage,n.RGBA),this.iconAtlasImage=null),this.glyphAtlasImage&&(this.glyphAtlasTexture=new Yo(t,this.glyphAtlasImage,n.ALPHA),this.glyphAtlasImage=null);},Fs.prototype.queryRenderedFeatures=function(t,e,r,n,i,a,o,s){return this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData?this.latestFeatureIndex.query({queryGeometry:r,scale:n,tileSize:this.tileSize,posMatrix:s,transform:a,params:i,queryPadding:this.queryPadding*o},t,e):{}},Fs.prototype.querySourceFeatures=function(t,e){if(this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData){var r=this.latestFeatureIndex.loadVTLayers(),n=e?e.sourceLayer:"",i=r._geojsonTileLayer||r[n];if(i)for(var a=$e(e&&e.filter),o=this.tileID.canonical,s=o.z,u=o.x,l=o.y,p={z:s,x:u,y:l},h=0;h<i.length;h++){var c=i.feature(h);if(a(new Xr(this.tileID.overscaledZ),c)){var f=new Cs(c,s,u,l);f.tile=p,t.push(f);}}}},Fs.prototype.clearMask=function(){this.segments&&(this.segments.destroy(),delete this.segments),this.maskedBoundsBuffer&&(this.maskedBoundsBuffer.destroy(),delete this.maskedBoundsBuffer),this.maskedIndexBuffer&&(this.maskedIndexBuffer.destroy(),delete this.maskedIndexBuffer);},Fs.prototype.setMask=function(t,e){if(!s(this.mask,t)&&(this.mask=t,this.clearMask(),!s(t,{0:!0}))){var r=new fn,n=new zn;this.segments=new Rn,this.segments.prepareSegment(0,r,n);for(var i=Object.keys(t),o=0;o<i.length;o++){var u=t[i[o]],l=$n>>u.z,p=new a(u.x*l,u.y*l),h=new a(p.x+l,p.y+l),c=this.segments.prepareSegment(4,r,n);r.emplaceBack(p.x,p.y,p.x,p.y),r.emplaceBack(h.x,p.y,h.x,p.y),r.emplaceBack(p.x,h.y,p.x,h.y),r.emplaceBack(h.x,h.y,h.x,h.y);var f=c.vertexLength;n.emplaceBack(f,f+1,f+2),n.emplaceBack(f+1,f+2,f+3),c.vertexLength+=4,c.primitiveLength+=2;}this.maskedBoundsBuffer=e.createVertexBuffer(r,Bs.members),this.maskedIndexBuffer=e.createIndexBuffer(n);}},Fs.prototype.hasData=function(){return "loaded"===this.state||"reloading"===this.state||"expired"===this.state},Fs.prototype.setExpiryData=function(t){var e=this.expirationTime;if(t.cacheControl){var r=function(t){var e={};if(t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g,function(t,r,n,i){var a=n||i;return e[r]=!a||a.toLowerCase(),""}),e["max-age"]){var r=parseInt(e["max-age"],10);isNaN(r)?delete e["max-age"]:e["max-age"]=r;}return e}(t.cacheControl);r["max-age"]&&(this.expirationTime=Date.now()+1e3*r["max-age"]);}else t.expires&&(this.expirationTime=new Date(t.expires).getTime());if(this.expirationTime){var n=Date.now(),i=!1;if(this.expirationTime>n)i=!1;else if(e)if(this.expirationTime<e)i=!0;else{var a=this.expirationTime-e;a?this.expirationTime=n+Math.max(a,3e4):i=!0;}else i=!0;i?(this.expiredRequestCount++,this.state="expired"):this.expiredRequestCount=0;}},Fs.prototype.getExpiryTimeout=function(){if(this.expirationTime)return this.expiredRequestCount?1e3*(1<<Math.min(this.expiredRequestCount-1,31)):Math.min(this.expirationTime-(new Date).getTime(),Math.pow(2,31)-1)},Fs.prototype.setFeatureState=function(t,e){if(this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData&&0!==Object.keys(t).length){var r=this.latestFeatureIndex.loadVTLayers();for(var n in this.buckets){var i=this.buckets[n],a=i.layers[0].sourceLayer||"_geojsonTileLayer",o=r[a],s=t[a];o&&s&&0!==Object.keys(s).length&&(i.update(s,o),e&&e.style&&(this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(n).queryRadius(i))));}}},Fs.prototype.holdingForFade=function(){return void 0!==this.symbolFadeHoldUntil},Fs.prototype.symbolFadeFinished=function(){return !this.symbolFadeHoldUntil||this.symbolFadeHoldUntil<z.now()},Fs.prototype.clearFadeHold=function(){this.symbolFadeHoldUntil=void 0;},Fs.prototype.setHoldDuration=function(t){this.symbolFadeHoldUntil=z.now()+t;};var Ls={horizontal:1,vertical:2,horizontalOnly:3},Os=function(){this.text="",this.sectionIndex=[],this.sections=[];};Os.fromFeature=function(t,e){var r=new Os;if(t instanceof ht)for(var n=0;n<t.sections.length;n++){var i=t.sections[n];r.sections.push({scale:i.scale||1,fontStack:i.fontStack||e}),r.text+=i.text;for(var a=0;a<i.text.length;a++)r.sectionIndex.push(n);}else{r.text=t,r.sections.push({scale:1,fontStack:e});for(var o=0;o<t.length;o++)r.sectionIndex.push(0);}return r},Os.prototype.length=function(){return this.text.length},Os.prototype.getSection=function(t){return this.sections[this.sectionIndex[t]]},Os.prototype.getCharCode=function(t){return this.text.charCodeAt(t)},Os.prototype.verticalizePunctuation=function(){this.text=function(t){for(var e="",r=0;r<t.length;r++){var n=t.charCodeAt(r+1)||null,i=t.charCodeAt(r-1)||null;n&&Or(n)&&!ko[t[r+1]]||i&&Or(i)&&!ko[t[r-1]]||!ko[t[r]]?e+=t[r]:e+=ko[t[r]];}return e}(this.text);},Os.prototype.trim=function(){for(var t=0,e=0;e<this.text.length&&Ds[this.text.charCodeAt(e)];e++)t++;for(var r=this.text.length,n=this.text.length-1;n>=0&&n>=t&&Ds[this.text.charCodeAt(n)];n--)r--;this.text=this.text.substring(t,r),this.sectionIndex=this.sectionIndex.slice(t,r);},Os.prototype.substring=function(t,e){var r=new Os;return r.text=this.text.substring(t,e),r.sectionIndex=this.sectionIndex.slice(t,e),r.sections=this.sections,r},Os.prototype.toString=function(){return this.text},Os.prototype.getMaxScale=function(){var t=this;return this.sectionIndex.reduce(function(e,r){return Math.max(e,t.sections[r].scale)},0)};var Ds={9:!0,10:!0,11:!0,12:!0,13:!0,32:!0},qs={};function js(t,e,r,n){var i=Math.pow(t-e,2);return n?t<e?i/2:2*i:i+Math.abs(r)*r}function Us(t,e){var r=0;return 10===t&&(r-=1e4),40!==t&&65288!==t||(r+=50),41!==e&&65289!==e||(r+=50),r}function Rs(t,e,r,n,i,a){for(var o=null,s=js(e,r,i,a),u=0,l=n;u<l.length;u+=1){var p=l[u],h=js(e-p.x,r,i,a)+p.badness;h<=s&&(o=p,s=h);}return {index:t,x:e,priorBreak:o,badness:s}}function Ns(t,e,r,n){if(!r)return [];if(!t)return [];for(var i,a=[],o=function(t,e,r,n){for(var i=0,a=0;a<t.length();a++){var o=t.getSection(a),s=n[o.fontStack],u=s&&s[t.getCharCode(a)];u&&(i+=u.metrics.advance*o.scale+e);}return i/Math.max(1,Math.ceil(i/r))}(t,e,r,n),s=0,u=0;u<t.length();u++){var l=t.getSection(u),p=t.getCharCode(u),h=n[l.fontStack],c=h&&h[p];c&&!Ds[p]&&(s+=c.metrics.advance*l.scale+e),u<t.length()-1&&(qs[p]||!((i=p)<11904)&&(Er["Bopomofo Extended"](i)||Er.Bopomofo(i)||Er["CJK Compatibility Forms"](i)||Er["CJK Compatibility Ideographs"](i)||Er["CJK Compatibility"](i)||Er["CJK Radicals Supplement"](i)||Er["CJK Strokes"](i)||Er["CJK Symbols and Punctuation"](i)||Er["CJK Unified Ideographs Extension A"](i)||Er["CJK Unified Ideographs"](i)||Er["Enclosed CJK Letters and Months"](i)||Er["Halfwidth and Fullwidth Forms"](i)||Er.Hiragana(i)||Er["Ideographic Description Characters"](i)||Er["Kangxi Radicals"](i)||Er["Katakana Phonetic Extensions"](i)||Er.Katakana(i)||Er["Vertical Forms"](i)||Er["Yi Radicals"](i)||Er["Yi Syllables"](i)))&&a.push(Rs(u+1,s,o,a,Us(p,t.getCharCode(u+1)),!1));}return function t(e){return e?t(e.priorBreak).concat(e.index):[]}(Rs(t.length(),s,o,a,0,!0))}function Zs(t){var e=.5,r=.5;switch(t){case"right":case"top-right":case"bottom-right":e=1;break;case"left":case"top-left":case"bottom-left":e=0;}switch(t){case"bottom":case"bottom-right":case"bottom-left":r=1;break;case"top":case"top-right":case"top-left":r=0;}return {horizontalAlign:e,verticalAlign:r}}function Xs(t,e,r,n,i){if(i){var a=t[n],o=e[a.fontStack],s=o&&o[a.glyph];if(s)for(var u=s.metrics.advance*a.scale,l=(t[n].x+u)*i,p=r;p<=n;p++)t[p].x-=l;}}qs[10]=!0,qs[32]=!0,qs[38]=!0,qs[40]=!0,qs[41]=!0,qs[43]=!0,qs[45]=!0,qs[47]=!0,qs[173]=!0,qs[183]=!0,qs[8203]=!0,qs[8208]=!0,qs[8211]=!0,qs[8231]=!0,t.createCommonjsModule=e,t.Point=a,t.window=self,t.browser=z,t.uuid=function(){return function t(e){return e?(e^16*Math.random()>>e/4).toString(16):([1e7]+-[1e3]+-4e3+-8e3+-1e11).replace(/[018]/g,t)}()},t.validateUuid=function(t){return !!t&&/^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t)},t.storageAvailable=function(t){try{var e=self[t];return e.setItem("_mapbox_test_",1),e.removeItem("_mapbox_test_"),!0}catch(t){return !1}},t.warnOnce=b,t.postData=function(t,e,r){var n=C(h(t,{method:"POST"}));return n.onerror=function(){r(new Error(n.statusText));},n.onload=function(){n.status>=200&&n.status<300?r(null,n.response):r(new I(n.statusText,n.status,t.url));},n.send(e),{cancel:function(){return n.abort()}}},t.getJSON=function(t,e){var r=C(t);return r.setRequestHeader("Accept","application/json"),r.onerror=function(){e(new Error(r.statusText));},r.onload=function(){if(r.status>=200&&r.status<300&&r.response){var n;try{n=JSON.parse(r.response);}catch(t){return e(t)}e(null,n);}else 401===r.status&&t.url.match(/mapbox.com/)?e(new I(r.statusText+": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens",r.status,t.url)):e(new I(r.statusText,r.status,t.url));},r.send(),{cancel:function(){return r.abort()}}},t.getImage=function(t,e){return V(t,function(t,r){if(t)e(t);else if(r){var n=new self.Image,i=self.URL||self.webkitURL;n.onload=function(){e(null,n),i.revokeObjectURL(n.src);};var a=new self.Blob([new Uint8Array(r.data)],{type:"image/png"});n.cacheControl=r.cacheControl,n.expires=r.expires,n.src=r.data.byteLength?i.createObjectURL(a):"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";}})},t.ResourceType=B,t.RGBAImage=Gi,t.ShelfPack=Uo,t.ImagePosition=No,t.Texture=Yo,t.getArrayBuffer=V,t.parseGlyphPBF=function(t){return new Qo(t).readFields(vs,[])},t.isChar=Er,t.asyncAll=function(t,e,r){if(!t.length)return r(null,[]);var n=t.length,i=new Array(t.length),a=null;t.forEach(function(t,o){e(t,function(t,e){t&&(a=t),i[o]=e,0==--n&&r(a,i);});});},t.AlphaImage=Ji,t.styleSpec=O,t.endsWith=d,t.extend=h,t.sphericalToCartesian=function(t){var e=t[0],r=t[1],n=t[2];return r+=90,r*=Math.PI/180,n*=Math.PI/180,{x:e*Math.cos(r)*Math.sin(n),y:e*Math.sin(r)*Math.sin(n),z:e*Math.cos(n)}},t.Evented=L,t.validateStyle=gr,t.validateLight=xr,t.emitValidationErrors=_r,t.Color=at,t.number=Et,t.Properties=an,t.Transitionable=Gr,t.Transitioning=Yr,t.PossiblyEvaluated=Qr,t.DataConstantProperty=tn,t.uniqueId=f,t.Actor=ws,t.pick=function(t,e){for(var r={},n=0;n<e.length;n++){var i=e[n];i in t&&(r[i]=t[i]);}return r},t.wrap=function(t,e,r){var n=r-e,i=((t-e)%n+n)%n+e;return i===e?r:i},t.clamp=p,t.Event=P,t.ErrorEvent=F,t.OverscaledTileID=Ss,t.EXTENT=$n,t.getCoordinatesCenter=function(t){for(var e=1/0,r=1/0,n=-1/0,a=-1/0,o=0;o<t.length;o++)e=Math.min(e,t[o].column),r=Math.min(r,t[o].row),n=Math.max(n,t[o].column),a=Math.max(a,t[o].row);var s=n-e,u=a-r,l=Math.max(s,u),p=Math.max(0,Math.floor(-Math.log(l)/Math.LN2));return new i((e+n)/2,(r+a)/2,0).zoomTo(p)},t.CanonicalTileID=As,t.StructArrayLayout4i8=fn,t.rasterBoundsAttributes=Bs,t.getVideo=function(t,e){var r,n,i=self.document.createElement("video");i.muted=!0,i.onloadstart=function(){e(null,i);};for(var a=0;a<t.length;a++){var o=self.document.createElement("source");r=t[a],n=void 0,(n=self.document.createElement("a")).href=r,(n.protocol!==self.document.location.protocol||n.host!==self.document.location.host)&&(i.crossOrigin="Anonymous"),o.src=t[a],i.appendChild(o);}return {cancel:function(){}}},t.ValidationError=D,t.bindAll=y,t.deepEqual=s,t.Tile=Fs,t.Coordinate=i,t.keysDifference=function(t,e){var r=[];for(var n in t)n in e||r.push(n);return r},t.SourceFeatureState=Ts,t.refProperties=["type","source","source-layer","minzoom","maxzoom","filter","layout"],t.create=function(){var t=new vi(16);return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t},t.identity=function(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t},t.invert=function(t,e){var r=e[0],n=e[1],i=e[2],a=e[3],o=e[4],s=e[5],u=e[6],l=e[7],p=e[8],h=e[9],c=e[10],f=e[11],y=e[12],d=e[13],m=e[14],v=e[15],g=r*s-n*o,x=r*u-i*o,b=r*l-a*o,w=n*u-i*s,_=n*l-a*s,A=i*l-a*u,k=p*d-h*y,S=p*m-c*y,z=p*v-f*y,M=h*m-c*d,B=h*v-f*d,I=c*v-f*m,C=g*I-x*B+b*M+w*z-_*S+A*k;return C?(C=1/C,t[0]=(s*I-u*B+l*M)*C,t[1]=(i*B-n*I-a*M)*C,t[2]=(d*A-m*_+v*w)*C,t[3]=(c*_-h*A-f*w)*C,t[4]=(u*z-o*I-l*S)*C,t[5]=(r*I-i*z+a*S)*C,t[6]=(m*b-y*A-v*x)*C,t[7]=(p*A-c*b+f*x)*C,t[8]=(o*B-s*z+l*k)*C,t[9]=(n*z-r*B-a*k)*C,t[10]=(y*_-d*b+v*g)*C,t[11]=(h*b-p*_-f*g)*C,t[12]=(s*S-o*M-u*k)*C,t[13]=(r*M-n*S+i*k)*C,t[14]=(d*x-y*w-m*g)*C,t[15]=(p*w-h*x+c*g)*C,t):null},t.multiply=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3],s=e[4],u=e[5],l=e[6],p=e[7],h=e[8],c=e[9],f=e[10],y=e[11],d=e[12],m=e[13],v=e[14],g=e[15],x=r[0],b=r[1],w=r[2],_=r[3];return t[0]=x*n+b*s+w*h+_*d,t[1]=x*i+b*u+w*c+_*m,t[2]=x*a+b*l+w*f+_*v,t[3]=x*o+b*p+w*y+_*g,x=r[4],b=r[5],w=r[6],_=r[7],t[4]=x*n+b*s+w*h+_*d,t[5]=x*i+b*u+w*c+_*m,t[6]=x*a+b*l+w*f+_*v,t[7]=x*o+b*p+w*y+_*g,x=r[8],b=r[9],w=r[10],_=r[11],t[8]=x*n+b*s+w*h+_*d,t[9]=x*i+b*u+w*c+_*m,t[10]=x*a+b*l+w*f+_*v,t[11]=x*o+b*p+w*y+_*g,x=r[12],b=r[13],w=r[14],_=r[15],t[12]=x*n+b*s+w*h+_*d,t[13]=x*i+b*u+w*c+_*m,t[14]=x*a+b*l+w*f+_*v,t[15]=x*o+b*p+w*y+_*g,t},t.translate=function(t,e,r){var n,i,a,o,s,u,l,p,h,c,f,y,d=r[0],m=r[1],v=r[2];return e===t?(t[12]=e[0]*d+e[4]*m+e[8]*v+e[12],t[13]=e[1]*d+e[5]*m+e[9]*v+e[13],t[14]=e[2]*d+e[6]*m+e[10]*v+e[14],t[15]=e[3]*d+e[7]*m+e[11]*v+e[15]):(n=e[0],i=e[1],a=e[2],o=e[3],s=e[4],u=e[5],l=e[6],p=e[7],h=e[8],c=e[9],f=e[10],y=e[11],t[0]=n,t[1]=i,t[2]=a,t[3]=o,t[4]=s,t[5]=u,t[6]=l,t[7]=p,t[8]=h,t[9]=c,t[10]=f,t[11]=y,t[12]=n*d+s*m+h*v+e[12],t[13]=i*d+u*m+c*v+e[13],t[14]=a*d+l*m+f*v+e[14],t[15]=o*d+p*m+y*v+e[15]),t},t.scale=function(t,e,r){var n=r[0],i=r[1],a=r[2];return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t[3]=e[3]*n,t[4]=e[4]*i,t[5]=e[5]*i,t[6]=e[6]*i,t[7]=e[7]*i,t[8]=e[8]*a,t[9]=e[9]*a,t[10]=e[10]*a,t[11]=e[11]*a,t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15],t},t.rotateX=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),a=e[4],o=e[5],s=e[6],u=e[7],l=e[8],p=e[9],h=e[10],c=e[11];return e!==t&&(t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[4]=a*i+l*n,t[5]=o*i+p*n,t[6]=s*i+h*n,t[7]=u*i+c*n,t[8]=l*i-a*n,t[9]=p*i-o*n,t[10]=h*i-s*n,t[11]=c*i-u*n,t},t.rotateZ=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),a=e[0],o=e[1],s=e[2],u=e[3],l=e[4],p=e[5],h=e[6],c=e[7];return e!==t&&(t[8]=e[8],t[9]=e[9],t[10]=e[10],t[11]=e[11],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[0]=a*i+l*n,t[1]=o*i+p*n,t[2]=s*i+h*n,t[3]=u*i+c*n,t[4]=l*i-a*n,t[5]=p*i-o*n,t[6]=h*i-s*n,t[7]=c*i-u*n,t},t.perspective=function(t,e,r,n,i){var a=1/Math.tan(e/2),o=1/(n-i);return t[0]=a/r,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=a,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=(i+n)*o,t[11]=-1,t[12]=0,t[13]=0,t[14]=2*i*n*o,t[15]=0,t},t.ortho=function(t,e,r,n,i,a,o){var s=1/(e-r),u=1/(n-i),l=1/(a-o);return t[0]=-2*s,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=-2*u,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=2*l,t[11]=0,t[12]=(e+r)*s,t[13]=(i+n)*u,t[14]=(o+a)*l,t[15]=1,t},t.create$1=Bi,t.normalize=Ii,t.transformMat4=Ci,t.forEach=Vi,t.getSizeData=zo,t.evaluateSizeForFeature=function(t,e,r){var n=e;return "source"===t.functionType?r.lowerSize/10:"composite"===t.functionType?Et(r.lowerSize/10,r.upperSize/10,n.uSizeT):n.uSize},t.evaluateSizeForZoom=function(t,e,r){if("constant"===t.functionType)return {uSizeT:0,uSize:t.layoutSize};if("source"===t.functionType)return {uSizeT:0,uSize:0};if("camera"===t.functionType){var n=t.propertyValue,i=t.zoomRange,a=t.sizeRange,o=p(Re(n,r.specification).interpolationFactor(e,i.min,i.max),0,1);return {uSizeT:0,uSize:a.min+o*(a.max-a.min)}}var s=t.propertyValue,u=t.zoomRange;return {uSizeT:p(Re(s,r.specification).interpolationFactor(e,u.min,u.max),0,1),uSize:0}},t.addDynamicAttributes=Co,t.properties=Fo,t.WritingMode=Ls,t.multiPolygonIntersectsBufferedPoint=ni,t.multiPolygonIntersectsMultiPolygon=ii,t.multiPolygonIntersectsBufferedMultiLine=ai,t.polygonIntersectsPolygon=function(t,e){for(var r=0;r<t.length;r++)if(ci(e,t[r]))return !0;for(var n=0;n<e.length;n++)if(ci(t,e[n]))return !0;return !!si(t,e)},t.distToSegmentSquared=pi,t.StyleLayer=on,t.createStyleLayer=function(t){return new jo[t.type](t)},t.clone=g,t.filterObject=v,t.mapObject=m,t.registerForPluginAvailability=function(t){return Ur?t({pluginURL:Ur,completionCallback:qr}):Nr.once("pluginAvailable",t),t},t.evented=Nr,t.ZoomHistory=Tr,t.createLayout=pn,t.ProgramConfiguration=Gn,t.create$2=gi,t.fromRotation=function(t,e){var r=Math.sin(e),n=Math.cos(e);return t[0]=n,t[1]=r,t[2]=0,t[3]=-r,t[4]=n,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t},t.create$3=xi,t.length=bi,t.fromValues=wi,t.normalize$1=_i,t.dot=Ai,t.cross=ki,t.transformMat3=function(t,e,r){var n=e[0],i=e[1],a=e[2];return t[0]=n*r[0]+i*r[3]+a*r[6],t[1]=n*r[1]+i*r[4]+a*r[7],t[2]=n*r[2]+i*r[5]+a*r[8],t},t.len=zi,t.forEach$1=Mi,t.StructArrayLayout2i4=cn,t.UnwrappedTileID=ks,t.create$4=function(){var t=new vi(4);return t[0]=1,t[1]=0,t[2]=0,t[3]=1,t},t.rotate=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3],s=Math.sin(r),u=Math.cos(r);return t[0]=n*u+a*s,t[1]=i*u+o*s,t[2]=n*-s+a*u,t[3]=i*-s+o*u,t},t.ease=l,t.bezier=u,t.EvaluationParameters=Xr,t.setRTLTextPlugin=function(t,e){if(jr)throw new Error("setRTLTextPlugin cannot be called multiple times.");jr=!0,Ur=z.resolveURL(t),qr=function(t){t?(jr=!1,Ur=null,e&&e(t)):Rr=!0;},Nr.fire(new P("pluginAvailable",{pluginURL:Ur,completionCallback:qr}));},t.values=function(t){var e=[];for(var r in t)e.push(t[r]);return e},t.featureFilter=$e,t.Anchor=So,t.register=Br,t.GLYPH_PBF_BORDER=bs,t.shapeText=function(t,e,r,n,i,a,o,s,u,l,p){var h=Os.fromFeature(t,r);p===Ls.vertical&&h.verticalizePunctuation();var c,f=[],y={positionedGlyphs:f,text:h,top:u[1],bottom:u[1],left:u[0],right:u[0],writingMode:p},d=Zr.processBidirectionalText,m=Zr.processStyledBidirectionalText;if(d&&1===h.sections.length){c=[];for(var v=0,g=d(h.toString(),Ns(h,s,n,e));v<g.length;v+=1){var x=g[v],b=new Os;b.text=x,b.sections=h.sections;for(var w=0;w<x.length;w++)b.sectionIndex.push(0);c.push(b);}}else if(m){c=[];for(var _=0,A=m(h.text,h.sectionIndex,Ns(h,s,n,e));_<A.length;_+=1){var k=A[_],S=new Os;S.text=k[0],S.sectionIndex=k[1],S.sections=h.sections,c.push(S);}}else c=function(t,e){for(var r=[],n=t.text,i=0,a=0,o=e;a<o.length;a+=1){var s=o[a];r.push(t.substring(i,s)),i=s;}return i<n.length&&r.push(t.substring(i,n.length)),r}(h,Ns(h,s,n,e));return function(t,e,r,n,i,a,o,s,u){for(var l=0,p=-17,h=0,c=t.positionedGlyphs,f="right"===a?1:"left"===a?0:.5,y=0,d=r;y<d.length;y+=1){var m=d[y];m.trim();var v=m.getMaxScale();if(m.length()){for(var g=c.length,x=0;x<m.length();x++){var b=m.getSection(x),w=m.getCharCode(x),_=24*(v-b.scale),A=e[b.fontStack],k=A&&A[w];k&&(Lr(w)&&o!==Ls.horizontal?(c.push({glyph:w,x:l,y:_,vertical:!0,scale:b.scale,fontStack:b.fontStack}),l+=u*b.scale+s):(c.push({glyph:w,x:l,y:p+_,vertical:!1,scale:b.scale,fontStack:b.fontStack}),l+=k.metrics.advance*b.scale+s));}if(c.length!==g){var S=l-s;h=Math.max(S,h),Xs(c,e,g,c.length-1,f);}l=0,p+=n*v;}else p+=n;}var z=Zs(i),M=z.horizontalAlign,B=z.verticalAlign;!function(t,e,r,n,i,a,o){for(var s=(e-r)*i,u=(-n*o+.5)*a,l=0;l<t.length;l++)t[l].x+=s,t[l].y+=u;}(c,f,M,B,h,n,r.length);var I=p- -17;t.top+=-B*I,t.bottom=t.top+I,t.left+=-M*h,t.right=t.left+h;}(y,e,c,i,a,o,p,s,l),!!f.length&&(y.text=y.text.toString(),y)},t.shapeIcon=function(t,e,r){var n=Zs(r),i=n.horizontalAlign,a=n.verticalAlign,o=e[0],s=e[1],u=o-t.displaySize[0]*i,l=u+t.displaySize[0],p=s-t.displaySize[1]*a;return {image:t,top:p,bottom:p+t.displaySize[1],left:u,right:l}},t.allowsVerticalWritingMode=Pr,t.allowsLetterSpacing=function(t){for(var e=0,r=t;e<r.length;e+=1)if(!Fr(r[e].charCodeAt(0)))return !1;return !0},t.classifyRings=Ta,t.SymbolBucket=Eo,t.Formatted=ht,t.FeatureIndex=Es,t.CollisionBoxArray=Vn,t.DictionaryCoder=Is,t.ImageAtlas=Xo,t.mvt=ro,t.Protobuf=Qo,t.DEMData=Ms,t.vectorTile=ro,t.Point$1=a,t.pbf=Qo,t.plugin=Zr;});

define(["./shared.js"],function(e){"use strict";function t(e){var r=typeof e;if("number"===r||"boolean"===r||"string"===r||null==e)return JSON.stringify(e);if(Array.isArray(e)){for(var n="[",i=0,o=e;i<o.length;i+=1){n+=t(o[i])+",";}return n+"]"}for(var a=Object.keys(e).sort(),s="{",l=0;l<a.length;l++)s+=JSON.stringify(a[l])+":"+t(e[a[l]])+",";return s+"}"}function r(r){for(var n="",i=0,o=e.refProperties;i<o.length;i+=1){n+="/"+t(r[o[i]]);}return n}var n=function(e){e&&this.replace(e);};function i(e,t,r,n,i){if(void 0===t.segment)return !0;for(var o=t,a=t.segment+1,s=0;s>-r/2;){if(--a<0)return !1;s-=e[a].dist(o),o=e[a];}s+=e[a].dist(e[a+1]),a++;for(var l=[],u=0;s<r/2;){var h=e[a-1],c=e[a],f=e[a+1];if(!f)return !1;var p=h.angleTo(c)-c.angleTo(f);for(p=Math.abs((p+3*Math.PI)%(2*Math.PI)-Math.PI),l.push({distance:s,angleDelta:p}),u+=p;s-l[0].distance>n;)u-=l.shift().angleDelta;if(u>i)return !1;a++,s+=c.dist(f);}return !0}function o(e){for(var t=0,r=0;r<e.length-1;r++)t+=e[r].dist(e[r+1]);return t}function a(e,t,r){return e?.6*t*r:0}function s(e,t){return Math.max(e?e.right-e.left:0,t?t.right-t.left:0)}function l(t,r,n,l,u,h){for(var c=a(n,u,h),f=s(n,l)*h,p=0,d=o(t)/2,g=0;g<t.length-1;g++){var m=t[g],v=t[g+1],y=m.dist(v);if(p+y>d){var x=(d-p)/y,w=e.number(m.x,v.x,x),S=e.number(m.y,v.y,x),M=new e.Anchor(w,S,v.angleTo(m),g);return M._round(),!c||i(t,M,f,c,r)?M:void 0}p+=y;}}function u(t,r,n,l,u,h,c,f,p){var d=a(l,h,c),g=s(l,u),m=g*c,v=0===t[0].x||t[0].x===p||0===t[0].y||t[0].y===p;return r-m<r/4&&(r=m+r/4),function t(r,n,a,s,l,u,h,c,f){var p=u/2;var d=o(r);var g=0,m=n-a;var v=[];for(var y=0;y<r.length-1;y++){for(var x=r[y],w=r[y+1],S=x.dist(w),M=w.angleTo(x);m+a<g+S;){var b=((m+=a)-g)/S,P=e.number(x.x,w.x,b),_=e.number(x.y,w.y,b);if(P>=0&&P<f&&_>=0&&_<f&&m-p>=0&&m+p<=d){var I=new e.Anchor(P,_,M,y);I._round(),s&&!i(r,I,u,s,l)||v.push(I);}}g+=S;}c||v.length||h||(v=t(r,g/2,a,s,l,u,h,!0,f));return v}(t,v?r/2*f%r:(g/2+2*h)*c*f%r,r,d,n,m,v,!1,p)}n.prototype.replace=function(e){this._layerConfigs={},this._layers={},this.update(e,[]);},n.prototype.update=function(t,n){for(var i=this,o=0,a=t;o<a.length;o+=1){var s=a[o];i._layerConfigs[s.id]=s;var l=i._layers[s.id]=e.createStyleLayer(s);l._featureFilter=e.featureFilter(l.filter);}for(var u=0,h=n;u<h.length;u+=1){var c=h[u];delete i._layerConfigs[c],delete i._layers[c];}this.familiesBySource={};for(var f=0,p=function(e){for(var t={},n=0;n<e.length;n++){var i=r(e[n]),o=t[i];o||(o=t[i]=[]),o.push(e[n]);}var a=[];for(var s in t)a.push(t[s]);return a}(e.values(this._layerConfigs));f<p.length;f+=1){var d=p[f].map(function(e){return i._layers[e.id]}),g=d[0];if("none"!==g.visibility){var m=g.source||"",v=i.familiesBySource[m];v||(v=i.familiesBySource[m]={});var y=g.sourceLayer||"_geojsonTileLayer",x=v[y];x||(x=v[y]=[]),x.push(d);}}};var h=function(){this.opacity=0,this.targetOpacity=0,this.time=0;};h.prototype.clone=function(){var e=new h;return e.opacity=this.opacity,e.targetOpacity=this.targetOpacity,e.time=this.time,e},e.register("OpacityState",h);var c=function(t,r,n,i,o,a,s,l,u,h,c,f){var p=s.top*l-u,d=s.bottom*l+u,g=s.left*l-u,m=s.right*l+u;if(this.boxStartIndex=t.length,h){var v=d-p,y=m-g;v>0&&(v=Math.max(10*l,v),this._addLineCollisionCircles(t,r,n,n.segment,y,v,i,o,a,c));}else{if(f){var x=new e.Point(g,p),w=new e.Point(m,p),S=new e.Point(g,d),M=new e.Point(m,d),b=f*Math.PI/180;x._rotate(b),w._rotate(b),S._rotate(b),M._rotate(b),g=Math.min(x.x,w.x,S.x,M.x),m=Math.max(x.x,w.x,S.x,M.x),p=Math.min(x.y,w.y,S.y,M.y),d=Math.max(x.y,w.y,S.y,M.y);}t.emplaceBack(n.x,n.y,g,p,m,d,i,o,a,0,0);}this.boxEndIndex=t.length;};c.prototype._addLineCollisionCircles=function(e,t,r,n,i,o,a,s,l,u){var h=o/2,c=Math.floor(i/h)||1,f=1+.4*Math.log(u)/Math.LN2,p=Math.floor(c*f/2),d=-o/2,g=r,m=n+1,v=d,y=-i/2,x=y-i/4;do{if(--m<0){if(v>y)return;m=0;break}v-=t[m].dist(g),g=t[m];}while(v>x);for(var w=t[m].dist(t[m+1]),S=-p;S<c+p;S++){var M=S*h,b=y+M;if(M<0&&(b+=M),M>i&&(b+=M-i),!(b<v)){for(;v+w<b;){if(v+=w,++m+1>=t.length)return;w=t[m].dist(t[m+1]);}var P=b-v,_=t[m],I=t[m+1].sub(_)._unit()._mult(P)._add(_)._round(),T=Math.abs(b-d)<h?0:.8*(b-d);e.emplaceBack(I.x,I.y,-o/2,-o/2,o/2,o/2,a,s,l,o/2,T);}}};var f=d,p=d;function d(e,t){if(!(this instanceof d))return new d(e,t);if(this.data=e||[],this.length=this.data.length,this.compare=t||g,this.length>0)for(var r=(this.length>>1)-1;r>=0;r--)this._down(r);}function g(e,t){return e<t?-1:e>t?1:0}function m(t,r,n){void 0===r&&(r=1),void 0===n&&(n=!1);for(var i=1/0,o=1/0,a=-1/0,s=-1/0,l=t[0],u=0;u<l.length;u++){var h=l[u];(!u||h.x<i)&&(i=h.x),(!u||h.y<o)&&(o=h.y),(!u||h.x>a)&&(a=h.x),(!u||h.y>s)&&(s=h.y);}var c=a-i,p=s-o,d=Math.min(c,p),g=d/2,m=new f(null,v);if(0===d)return new e.Point(i,o);for(var x=i;x<a;x+=d)for(var w=o;w<s;w+=d)m.push(new y(x+g,w+g,g,t));for(var S=function(e){for(var t=0,r=0,n=0,i=e[0],o=0,a=i.length,s=a-1;o<a;s=o++){var l=i[o],u=i[s],h=l.x*u.y-u.x*l.y;r+=(l.x+u.x)*h,n+=(l.y+u.y)*h,t+=3*h;}return new y(r/t,n/t,0,e)}(t),M=m.length;m.length;){var b=m.pop();(b.d>S.d||!S.d)&&(S=b,n&&console.log("found best %d after %d probes",Math.round(1e4*b.d)/1e4,M)),b.max-S.d<=r||(g=b.h/2,m.push(new y(b.p.x-g,b.p.y-g,g,t)),m.push(new y(b.p.x+g,b.p.y-g,g,t)),m.push(new y(b.p.x-g,b.p.y+g,g,t)),m.push(new y(b.p.x+g,b.p.y+g,g,t)),M+=4);}return n&&(console.log("num probes: "+M),console.log("best distance: "+S.d)),S.p}function v(e,t){return t.max-e.max}function y(t,r,n,i){this.p=new e.Point(t,r),this.h=n,this.d=function(t,r){for(var n=!1,i=1/0,o=0;o<r.length;o++)for(var a=r[o],s=0,l=a.length,u=l-1;s<l;u=s++){var h=a[s],c=a[u];h.y>t.y!=c.y>t.y&&t.x<(c.x-h.x)*(t.y-h.y)/(c.y-h.y)+h.x&&(n=!n),i=Math.min(i,e.distToSegmentSquared(t,h,c));}return (n?1:-1)*Math.sqrt(i)}(this.p,i),this.max=this.d+this.h*Math.SQRT2;}function x(t,r,n,i,o,a){t.createArrays(),t.symbolInstances=[];var s=512*t.overscaling;t.tilePixelRatio=e.EXTENT/s,t.compareText={},t.iconsNeedLinear=!1;var l=t.layers[0].layout,u=t.layers[0]._unevaluatedLayout._values,h={};if("composite"===t.textSizeData.functionType){var c=t.textSizeData.zoomRange,f=c.min,p=c.max;h.compositeTextSizes=[u["text-size"].possiblyEvaluate(new e.EvaluationParameters(f)),u["text-size"].possiblyEvaluate(new e.EvaluationParameters(p))];}if("composite"===t.iconSizeData.functionType){var d=t.iconSizeData.zoomRange,g=d.min,m=d.max;h.compositeIconSizes=[u["icon-size"].possiblyEvaluate(new e.EvaluationParameters(g)),u["icon-size"].possiblyEvaluate(new e.EvaluationParameters(m))];}h.layoutTextSize=u["text-size"].possiblyEvaluate(new e.EvaluationParameters(t.zoom+1)),h.layoutIconSize=u["icon-size"].possiblyEvaluate(new e.EvaluationParameters(t.zoom+1)),h.textMaxSize=u["text-size"].possiblyEvaluate(new e.EvaluationParameters(18));for(var v=24*l.get("text-line-height"),y="map"===l.get("text-rotation-alignment")&&"point"!==l.get("symbol-placement"),x=l.get("text-keep-upright"),S=0,M=t.features;S<M.length;S+=1){var b=M[S],P=l.get("text-font").evaluate(b,{}).join(","),_=n,I={},T=b.text;if(T){var k=T instanceof e.Formatted?T.toString():T,z=l.get("text-offset").evaluate(b,{}).map(function(e){return 24*e}),L=24*l.get("text-letter-spacing").evaluate(b,{}),E=e.allowsLetterSpacing(k)?L:0,D=l.get("text-anchor").evaluate(b,{}),O=l.get("text-justify").evaluate(b,{}),C="point"===l.get("symbol-placement")?24*l.get("text-max-width").evaluate(b,{}):0;I.horizontal=e.shapeText(T,r,P,C,v,D,O,E,z,24,e.WritingMode.horizontal),e.allowsVerticalWritingMode(k)&&y&&x&&(I.vertical=e.shapeText(T,r,P,C,v,D,O,E,z,24,e.WritingMode.vertical));}var N=void 0;if(b.icon){var A=i[b.icon];A&&(N=e.shapeIcon(o[b.icon],l.get("icon-offset").evaluate(b,{}),l.get("icon-anchor").evaluate(b,{})),void 0===t.sdfIcons?t.sdfIcons=A.sdf:t.sdfIcons!==A.sdf&&e.warnOnce("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),A.pixelRatio!==t.pixelRatio?t.iconsNeedLinear=!0:0!==l.get("icon-rotate").constantOr(1)&&(t.iconsNeedLinear=!0));}(I.horizontal||N)&&w(t,b,I,N,_,h);}a&&t.generateCollisionDebugBuffers();}function w(t,r,n,i,o,a){var s=a.layoutTextSize.evaluate(r,{}),f=a.layoutIconSize.evaluate(r,{}),p=a.textMaxSize.evaluate(r,{});void 0===p&&(p=s);var d=t.layers[0].layout,g=d.get("text-offset").evaluate(r,{}),v=d.get("icon-offset").evaluate(r,{}),y=s/24,x=t.tilePixelRatio*y,w=t.tilePixelRatio*p/24,b=t.tilePixelRatio*f,P=t.tilePixelRatio*d.get("symbol-spacing"),_=d.get("text-padding")*t.tilePixelRatio,I=d.get("icon-padding")*t.tilePixelRatio,T=d.get("text-max-angle")/180*Math.PI,k="map"===d.get("text-rotation-alignment")&&"point"!==d.get("symbol-placement"),z="map"===d.get("icon-rotation-alignment")&&"point"!==d.get("symbol-placement"),L=d.get("symbol-placement"),E=P/2,D=function(s,l){l.x<0||l.x>=e.EXTENT||l.y<0||l.y>=e.EXTENT||t.symbolInstances.push(function(t,r,n,i,o,a,s,l,u,f,p,d,g,m,v,y,x,w,M,b,P){var _,I,T=t.addToLineVertexArray(r,n),k=0,z=0,L=0,E=i.horizontal?i.horizontal.text:"",D=[];if(i.horizontal){var O=a.layout.get("text-rotate").evaluate(M,{});_=new c(s,n,r,l,u,f,i.horizontal,p,d,g,t.overscaling,O),z+=S(t,r,i.horizontal,a,g,M,m,T,i.vertical?e.WritingMode.horizontal:e.WritingMode.horizontalOnly,D,b,P),i.vertical&&(L+=S(t,r,i.vertical,a,g,M,m,T,e.WritingMode.vertical,D,b,P));}var C=_?_.boxStartIndex:t.collisionBoxArray.length,N=_?_.boxEndIndex:t.collisionBoxArray.length;if(o){var A=function(t,r,n,i,o,a){var s,l,u,h,c=r.image,f=n.layout,p=r.top-1/c.pixelRatio,d=r.left-1/c.pixelRatio,g=r.bottom+1/c.pixelRatio,m=r.right+1/c.pixelRatio;if("none"!==f.get("icon-text-fit")&&o){var v=m-d,y=g-p,x=f.get("text-size").evaluate(a,{})/24,w=o.left*x,S=o.right*x,M=o.top*x,b=S-w,P=o.bottom*x-M,_=f.get("icon-text-fit-padding")[0],I=f.get("icon-text-fit-padding")[1],T=f.get("icon-text-fit-padding")[2],k=f.get("icon-text-fit-padding")[3],z="width"===f.get("icon-text-fit")?.5*(P-y):0,L="height"===f.get("icon-text-fit")?.5*(b-v):0,E="width"===f.get("icon-text-fit")||"both"===f.get("icon-text-fit")?b:v,D="height"===f.get("icon-text-fit")||"both"===f.get("icon-text-fit")?P:y;s=new e.Point(w+L-k,M+z-_),l=new e.Point(w+L+I+E,M+z-_),u=new e.Point(w+L+I+E,M+z+T+D),h=new e.Point(w+L-k,M+z+T+D);}else s=new e.Point(d,p),l=new e.Point(m,p),u=new e.Point(m,g),h=new e.Point(d,g);var O=n.layout.get("icon-rotate").evaluate(a,{})*Math.PI/180;if(O){var C=Math.sin(O),N=Math.cos(O),A=[N,-C,C,N];s._matMult(A),l._matMult(A),h._matMult(A),u._matMult(A);}return [{tl:s,tr:l,bl:h,br:u,tex:c.paddedRect,writingMode:void 0,glyphOffset:[0,0]}]}(0,o,a,0,i.horizontal,M),B=a.layout.get("icon-rotate").evaluate(M,{});I=new c(s,n,r,l,u,f,o,v,y,!1,t.overscaling,B),k=4*A.length;var R=t.iconSizeData,F=null;"source"===R.functionType?F=[10*a.layout.get("icon-size").evaluate(M,{})]:"composite"===R.functionType&&(F=[10*P.compositeIconSizes[0].evaluate(M,{}),10*P.compositeIconSizes[1].evaluate(M,{})]),t.addSymbols(t.icon,A,F,w,x,M,!1,r,T.lineStartIndex,T.lineLength);}var G=I?I.boxStartIndex:t.collisionBoxArray.length,J=I?I.boxEndIndex:t.collisionBoxArray.length;t.glyphOffsetArray.length>=e.SymbolBucket.MAX_GLYPHS&&e.warnOnce("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907");var X=new h,V=new h;return {key:E,textBoxStartIndex:C,textBoxEndIndex:N,iconBoxStartIndex:G,iconBoxEndIndex:J,textOffset:m,iconOffset:w,anchor:r,line:n,featureIndex:l,numGlyphVertices:z,numVerticalGlyphVertices:L,numIconVertices:k,textOpacityState:X,iconOpacityState:V,isDuplicate:!1,placedTextSymbolIndices:D,crossTileID:0}}(t,l,s,n,i,t.layers[0],t.collisionBoxArray,r.index,r.sourceLayerIndex,t.index,x,_,k,g,b,I,z,v,r,o,a));};if("line"===L)for(var O=0,C=function(t,r,n,i,o){for(var a=[],s=0;s<t.length;s++)for(var l=t[s],u=void 0,h=0;h<l.length-1;h++){var c=l[h],f=l[h+1];c.x<r&&f.x<r||(c.x<r?c=new e.Point(r,c.y+(f.y-c.y)*((r-c.x)/(f.x-c.x)))._round():f.x<r&&(f=new e.Point(r,c.y+(f.y-c.y)*((r-c.x)/(f.x-c.x)))._round()),c.y<n&&f.y<n||(c.y<n?c=new e.Point(c.x+(f.x-c.x)*((n-c.y)/(f.y-c.y)),n)._round():f.y<n&&(f=new e.Point(c.x+(f.x-c.x)*((n-c.y)/(f.y-c.y)),n)._round()),c.x>=i&&f.x>=i||(c.x>=i?c=new e.Point(i,c.y+(f.y-c.y)*((i-c.x)/(f.x-c.x)))._round():f.x>=i&&(f=new e.Point(i,c.y+(f.y-c.y)*((i-c.x)/(f.x-c.x)))._round()),c.y>=o&&f.y>=o||(c.y>=o?c=new e.Point(c.x+(f.x-c.x)*((o-c.y)/(f.y-c.y)),o)._round():f.y>=o&&(f=new e.Point(c.x+(f.x-c.x)*((o-c.y)/(f.y-c.y)),o)._round()),u&&c.equals(u[u.length-1])||(u=[c],a.push(u)),u.push(f)))));}return a}(r.geometry,0,0,e.EXTENT,e.EXTENT);O<C.length;O+=1)for(var N=C[O],A=0,B=u(N,P,T,n.vertical||n.horizontal,i,24,w,t.overscaling,e.EXTENT);A<B.length;A+=1){var R=B[A],F=n.horizontal;F&&M(t,F.text,E,R)||D(N,R);}else if("line-center"===L)for(var G=0,J=r.geometry;G<J.length;G+=1){var X=J[G];if(X.length>1){var V=l(X,T,n.vertical||n.horizontal,i,24,w);V&&D(X,V);}}else if("Polygon"===r.type)for(var Z=0,j=e.classifyRings(r.geometry,0);Z<j.length;Z+=1){var W=j[Z],Y=m(W,16);D(W[0],new e.Anchor(Y.x,Y.y,0));}else if("LineString"===r.type)for(var q=0,U=r.geometry;q<U.length;q+=1){var H=U[q];D(H,new e.Anchor(H[0].x,H[0].y,0));}else if("Point"===r.type)for(var Q=0,$=r.geometry;Q<$.length;Q+=1)for(var K=0,ee=$[Q];K<ee.length;K+=1){var te=ee[K];D([te],new e.Anchor(te.x,te.y,0));}}function S(t,r,n,i,o,a,s,l,u,h,c,f){var p=function(t,r,n,i,o,a){for(var s=n.layout.get("text-rotate").evaluate(o,{})*Math.PI/180,l=n.layout.get("text-offset").evaluate(o,{}).map(function(e){return 24*e}),u=r.positionedGlyphs,h=[],c=0;c<u.length;c++){var f=u[c],p=a[f.fontStack],d=p&&p[f.glyph];if(d){var g=d.rect;if(g){var m=e.GLYPH_PBF_BORDER+1,v=d.metrics.advance*f.scale/2,y=i?[f.x+v,f.y]:[0,0],x=i?[0,0]:[f.x+v+l[0],f.y+l[1]],w=(d.metrics.left-m)*f.scale-v+x[0],S=(-d.metrics.top-m)*f.scale+x[1],M=w+g.w*f.scale,b=S+g.h*f.scale,P=new e.Point(w,S),_=new e.Point(M,S),I=new e.Point(w,b),T=new e.Point(M,b);if(i&&f.vertical){var k=new e.Point(-v,v),z=-Math.PI/2,L=new e.Point(5,0);P._rotateAround(z,k)._add(L),_._rotateAround(z,k)._add(L),I._rotateAround(z,k)._add(L),T._rotateAround(z,k)._add(L);}if(s){var E=Math.sin(s),D=Math.cos(s),O=[D,-E,E,D];P._matMult(O),_._matMult(O),I._matMult(O),T._matMult(O);}h.push({tl:P,tr:_,bl:I,br:T,tex:g,writingMode:r.writingMode,glyphOffset:y});}}}return h}(0,n,i,o,a,c),d=t.textSizeData,g=null;return "source"===d.functionType?g=[10*i.layout.get("text-size").evaluate(a,{})]:"composite"===d.functionType&&(g=[10*f.compositeTextSizes[0].evaluate(a,{}),10*f.compositeTextSizes[1].evaluate(a,{})]),t.addSymbols(t.text,p,g,s,o,a,u,r,l.lineStartIndex,l.lineLength),h.push(t.text.placedSymbolArray.length-1),4*p.length}function M(e,t,r,n){var i=e.compareText;if(t in i){for(var o=i[t],a=o.length-1;a>=0;a--)if(n.dist(o[a])<r)return !0}else i[t]=[];return i[t].push(n),!1}d.prototype={push:function(e){this.data.push(e),this.length++,this._up(this.length-1);},pop:function(){if(0!==this.length){var e=this.data[0];return this.length--,this.length>0&&(this.data[0]=this.data[this.length],this._down(0)),this.data.pop(),e}},peek:function(){return this.data[0]},_up:function(e){for(var t=this.data,r=this.compare,n=t[e];e>0;){var i=e-1>>1,o=t[i];if(r(n,o)>=0)break;t[e]=o,e=i;}t[e]=n;},_down:function(e){for(var t=this.data,r=this.compare,n=this.length>>1,i=t[e];e<n;){var o=1+(e<<1),a=o+1,s=t[o];if(a<this.length&&r(t[a],s)<0&&(o=a,s=t[a]),r(s,i)>=0)break;t[e]=s,e=o;}t[e]=i;}},f.default=p;var b=function(t){var r={},n=new e.ShelfPack(0,0,{autoResize:!0}),i=[];for(var o in t){var a=t[o],s=r[o]={};for(var l in a){var u=a[+l];if(u&&0!==u.bitmap.width&&0!==u.bitmap.height){var h={x:0,y:0,w:u.bitmap.width+2,h:u.bitmap.height+2};i.push(h),s[l]={rect:h,metrics:u.metrics};}}}n.pack(i,{inPlace:!0});var c=new e.AlphaImage({width:n.w,height:n.h});for(var f in t){var p=t[f];for(var d in p){var g=p[+d];if(g&&0!==g.bitmap.width&&0!==g.bitmap.height){var m=r[f][d].rect;e.AlphaImage.copy(g.bitmap,c,{x:0,y:0},{x:m.x+1,y:m.y+1},g.bitmap);}}}this.image=c,this.positions=r;};e.register("GlyphAtlas",b);var P=function(t){this.tileID=new e.OverscaledTileID(t.tileID.overscaledZ,t.tileID.wrap,t.tileID.canonical.z,t.tileID.canonical.x,t.tileID.canonical.y),this.uid=t.uid,this.zoom=t.zoom,this.pixelRatio=t.pixelRatio,this.tileSize=t.tileSize,this.source=t.source,this.overscaling=this.tileID.overscaleFactor(),this.showCollisionBoxes=t.showCollisionBoxes,this.collectResourceTiming=!!t.collectResourceTiming;};function _(t,r){for(var n=new e.EvaluationParameters(r),i=0,o=t;i<o.length;i+=1){o[i].recalculate(n);}}P.prototype.parse=function(t,r,n,i){var o=this;this.status="parsing",this.data=t,this.collisionBoxArray=new e.CollisionBoxArray;var a=new e.DictionaryCoder(Object.keys(t.layers).sort()),s=new e.FeatureIndex(this.tileID);s.bucketLayerIDs=[];var l,u,h,c={},f={featureIndex:s,iconDependencies:{},glyphDependencies:{}},p=r.familiesBySource[this.source];for(var d in p){var g=t.layers[d];if(g){1===g.version&&e.warnOnce('Vector tile source "'+o.source+'" layer "'+d+'" does not use vector tile spec v2 and therefore may have some rendering errors.');for(var m=a.encode(d),v=[],y=0;y<g.length;y++){var w=g.feature(y);v.push({feature:w,index:y,sourceLayerIndex:m});}for(var S=0,M=p[d];S<M.length;S+=1){var P=M[S],I=P[0];if(!(I.minzoom&&o.zoom<Math.floor(I.minzoom)))if(!(I.maxzoom&&o.zoom>=I.maxzoom))if("none"!==I.visibility)_(P,o.zoom),(c[I.id]=I.createBucket({index:s.bucketLayerIDs.length,layers:P,zoom:o.zoom,pixelRatio:o.pixelRatio,overscaling:o.overscaling,collisionBoxArray:o.collisionBoxArray,sourceLayerIndex:m,sourceID:o.source})).populate(v,f),s.bucketLayerIDs.push(P.map(function(e){return e.id}));}}}var T=e.mapObject(f.glyphDependencies,function(e){return Object.keys(e).map(Number)});Object.keys(T).length?n.send("getGlyphs",{uid:this.uid,stacks:T},function(e,t){l||(l=e,u=t,z.call(o));}):u={};var k=Object.keys(f.iconDependencies);function z(){if(l)return i(l);if(u&&h){var t=new b(u),r=new e.ImageAtlas(h);for(var n in c){var o=c[n];o instanceof e.SymbolBucket&&(_(o.layers,this.zoom),x(o,u,t.positions,h,r.positions,this.showCollisionBoxes));}this.status="done",i(null,{buckets:e.values(c).filter(function(e){return !e.isEmpty()}),featureIndex:s,collisionBoxArray:this.collisionBoxArray,glyphAtlasImage:t.image,iconAtlasImage:r.image});}}k.length?n.send("getImages",{icons:k},function(e,t){l||(l=e,h=t,z.call(o));}):h={},z.call(this);};var I="undefined"!=typeof performance,T={getEntriesByName:function(e){return !!(I&&performance&&performance.getEntriesByName)&&performance.getEntriesByName(e)},mark:function(e){return !!(I&&performance&&performance.mark)&&performance.mark(e)},measure:function(e,t,r){return !!(I&&performance&&performance.measure)&&performance.measure(e,t,r)},clearMarks:function(e){return !!(I&&performance&&performance.clearMarks)&&performance.clearMarks(e)},clearMeasures:function(e){return !!(I&&performance&&performance.clearMeasures)&&performance.clearMeasures(e)}},k=function(e){this._marks={start:[e.url,"start"].join("#"),end:[e.url,"end"].join("#"),measure:e.url.toString()},T.mark(this._marks.start);};function z(t,r){var n=e.getArrayBuffer(t.request,function(t,n){t?r(t):n&&r(null,{vectorTile:new e.mvt.VectorTile(new e.Protobuf(n.data)),rawData:n.data,cacheControl:n.cacheControl,expires:n.expires});});return function(){n.cancel(),r();}}k.prototype.finish=function(){T.mark(this._marks.end);var e=T.getEntriesByName(this._marks.measure);return 0===e.length&&(T.measure(this._marks.measure,this._marks.start,this._marks.end),e=T.getEntriesByName(this._marks.measure),T.clearMarks(this._marks.start),T.clearMarks(this._marks.end),T.clearMeasures(this._marks.measure)),e},T.Performance=k;var L=function(e,t,r){this.actor=e,this.layerIndex=t,this.loadVectorData=r||z,this.loading={},this.loaded={};};L.prototype.loadTile=function(t,r){var n=this,i=t.uid;this.loading||(this.loading={});var o=!!(t&&t.request&&t.request.collectResourceTiming)&&new T.Performance(t.request),a=this.loading[i]=new P(t);a.abort=this.loadVectorData(t,function(t,s){if(delete n.loading[i],t||!s)return r(t);var l=s.rawData,u={};s.expires&&(u.expires=s.expires),s.cacheControl&&(u.cacheControl=s.cacheControl);var h={};if(o){var c=o.finish();c&&(h.resourceTiming=JSON.parse(JSON.stringify(c)));}a.vectorTile=s.vectorTile,a.parse(s.vectorTile,n.layerIndex,n.actor,function(t,n){if(t||!n)return r(t);r(null,e.extend({rawTileData:l.slice(0)},n,u,h));}),n.loaded=n.loaded||{},n.loaded[i]=a;});},L.prototype.reloadTile=function(e,t){var r=this.loaded,n=e.uid,i=this;if(r&&r[n]){var o=r[n];o.showCollisionBoxes=e.showCollisionBoxes;var a=function(e,r){var n=o.reloadCallback;n&&(delete o.reloadCallback,o.parse(o.vectorTile,i.layerIndex,i.actor,n)),t(e,r);};"parsing"===o.status?o.reloadCallback=a:"done"===o.status&&o.parse(o.vectorTile,this.layerIndex,this.actor,a);}},L.prototype.abortTile=function(e,t){var r=this.loading,n=e.uid;r&&r[n]&&r[n].abort&&(r[n].abort(),delete r[n]),t();},L.prototype.removeTile=function(e,t){var r=this.loaded,n=e.uid;r&&r[n]&&delete r[n],t();};var E=function(){this.loaded={};};E.prototype.loadTile=function(t,r){var n=t.uid,i=t.encoding,o=t.rawImageData,a=new e.DEMData(n,o,i);this.loaded=this.loaded||{},this.loaded[n]=a,r(null,a);},E.prototype.removeTile=function(e){var t=this.loaded,r=e.uid;t&&t[r]&&delete t[r];};var D={RADIUS:6378137,FLATTENING:1/298.257223563,POLAR_RADIUS:6356752.3142};function O(e){var t=0;if(e&&e.length>0){t+=Math.abs(C(e[0]));for(var r=1;r<e.length;r++)t-=Math.abs(C(e[r]));}return t}function C(e){var t,r,n,i,o,a,s=0,l=e.length;if(l>2){for(a=0;a<l;a++)a===l-2?(n=l-2,i=l-1,o=0):a===l-1?(n=l-1,i=0,o=1):(n=a,i=a+1,o=a+2),t=e[n],r=e[i],s+=(N(e[o][0])-N(t[0]))*Math.sin(N(r[1]));s=s*D.RADIUS*D.RADIUS/2;}return s}function N(e){return e*Math.PI/180}var A={geometry:function e(t){var r,n=0;switch(t.type){case"Polygon":return O(t.coordinates);case"MultiPolygon":for(r=0;r<t.coordinates.length;r++)n+=O(t.coordinates[r]);return n;case"Point":case"MultiPoint":case"LineString":case"MultiLineString":return 0;case"GeometryCollection":for(r=0;r<t.geometries.length;r++)n+=e(t.geometries[r]);return n}},ring:C},B=function e(t,r){switch(t&&t.type||null){case"FeatureCollection":return t.features=t.features.map(R(e,r)),t;case"Feature":return t.geometry=e(t.geometry,r),t;case"Polygon":case"MultiPolygon":return function(e,t){"Polygon"===e.type?e.coordinates=F(e.coordinates,t):"MultiPolygon"===e.type&&(e.coordinates=e.coordinates.map(R(F,t)));return e}(t,r);default:return t}};function R(e,t){return function(r){return e(r,t)}}function F(e,t){t=!!t,e[0]=G(e[0],t);for(var r=1;r<e.length;r++)e[r]=G(e[r],!t);return e}function G(e,t){return function(e){return A.ring(e)>=0}(e)===t?e:e.reverse()}var J=e.mvt.VectorTileFeature.prototype.toGeoJSON,X=function(t){this._feature=t,this.extent=e.EXTENT,this.type=t.type,this.properties=t.tags,"id"in t&&!isNaN(t.id)&&(this.id=parseInt(t.id,10));};X.prototype.loadGeometry=function(){if(1===this._feature.type){for(var t=[],r=0,n=this._feature.geometry;r<n.length;r+=1){var i=n[r];t.push([new e.Point(i[0],i[1])]);}return t}for(var o=[],a=0,s=this._feature.geometry;a<s.length;a+=1){for(var l=[],u=0,h=s[a];u<h.length;u+=1){var c=h[u];l.push(new e.Point(c[0],c[1]));}o.push(l);}return o},X.prototype.toGeoJSON=function(e,t,r){return J.call(this,e,t,r)};var V=function(t){this.layers={_geojsonTileLayer:this},this.name="_geojsonTileLayer",this.extent=e.EXTENT,this.length=t.length,this._features=t;};V.prototype.feature=function(e){return new X(this._features[e])};var Z=e.vectorTile.VectorTileFeature,j=W;function W(e,t){this.options=t||{},this.features=e,this.length=e.length;}function Y(e,t){this.id="number"==typeof e.id?e.id:void 0,this.type=e.type,this.rawGeometry=1===e.type?[e.geometry]:e.geometry,this.properties=e.tags,this.extent=t||4096;}W.prototype.feature=function(e){return new Y(this.features[e],this.options.extent)},Y.prototype.loadGeometry=function(){var t=this.rawGeometry;this.geometry=[];for(var r=0;r<t.length;r++){for(var n=t[r],i=[],o=0;o<n.length;o++)i.push(new e.Point$1(n[o][0],n[o][1]));this.geometry.push(i);}return this.geometry},Y.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var e=this.geometry,t=1/0,r=-1/0,n=1/0,i=-1/0,o=0;o<e.length;o++)for(var a=e[o],s=0;s<a.length;s++){var l=a[s];t=Math.min(t,l.x),r=Math.max(r,l.x),n=Math.min(n,l.y),i=Math.max(i,l.y);}return [t,n,r,i]},Y.prototype.toGeoJSON=Z.prototype.toGeoJSON;var q=$,U=$,H=function(e,t){t=t||{};var r={};for(var n in e)r[n]=new j(e[n].features,t),r[n].name=n,r[n].version=t.version,r[n].extent=t.extent;return $({layers:r})},Q=j;function $(t){var r=new e.pbf;return function(e,t){for(var r in e.layers)t.writeMessage(3,K,e.layers[r]);}(t,r),r.finish()}function K(e,t){var r;t.writeVarintField(15,e.version||1),t.writeStringField(1,e.name||""),t.writeVarintField(5,e.extent||4096);var n={keys:[],values:[],keycache:{},valuecache:{}};for(r=0;r<e.length;r++)n.feature=e.feature(r),t.writeMessage(2,ee,n);var i=n.keys;for(r=0;r<i.length;r++)t.writeStringField(3,i[r]);var o=n.values;for(r=0;r<o.length;r++)t.writeMessage(4,oe,o[r]);}function ee(e,t){var r=e.feature;void 0!==r.id&&t.writeVarintField(1,r.id),t.writeMessage(2,te,e),t.writeVarintField(3,r.type),t.writeMessage(4,ie,r);}function te(e,t){var r=e.feature,n=e.keys,i=e.values,o=e.keycache,a=e.valuecache;for(var s in r.properties){var l=o[s];void 0===l&&(n.push(s),l=n.length-1,o[s]=l),t.writeVarint(l);var u=r.properties[s],h=typeof u;"string"!==h&&"boolean"!==h&&"number"!==h&&(u=JSON.stringify(u));var c=h+":"+u,f=a[c];void 0===f&&(i.push(u),f=i.length-1,a[c]=f),t.writeVarint(f);}}function re(e,t){return (t<<3)+(7&e)}function ne(e){return e<<1^e>>31}function ie(e,t){for(var r=e.loadGeometry(),n=e.type,i=0,o=0,a=r.length,s=0;s<a;s++){var l=r[s],u=1;1===n&&(u=l.length),t.writeVarint(re(1,u));for(var h=3===n?l.length-1:l.length,c=0;c<h;c++){1===c&&1!==n&&t.writeVarint(re(2,h-1));var f=l[c].x-i,p=l[c].y-o;t.writeVarint(ne(f)),t.writeVarint(ne(p)),i+=f,o+=p;}3===n&&t.writeVarint(re(7,0));}}function oe(e,t){var r=typeof e;"string"===r?t.writeStringField(1,e):"boolean"===r?t.writeBooleanField(7,e):"number"===r&&(e%1!=0?t.writeDoubleField(3,e):e<0?t.writeSVarintField(6,e):t.writeVarintField(5,e));}function ae(e,t,r,n,i,o){if(!(i-n<=r)){var a=Math.floor((n+i)/2);!function e(t,r,n,i,o,a){for(;o>i;){if(o-i>600){var s=o-i+1,l=n-i+1,u=Math.log(s),h=.5*Math.exp(2*u/3),c=.5*Math.sqrt(u*h*(s-h)/s)*(l-s/2<0?-1:1),f=Math.max(i,Math.floor(n-l*h/s+c)),p=Math.min(o,Math.floor(n+(s-l)*h/s+c));e(t,r,n,f,p,a);}var d=r[2*n+a],g=i,m=o;for(se(t,r,i,n),r[2*o+a]>d&&se(t,r,i,o);g<m;){for(se(t,r,g,m),g++,m--;r[2*g+a]<d;)g++;for(;r[2*m+a]>d;)m--;}r[2*i+a]===d?se(t,r,i,m):se(t,r,++m,o),m<=n&&(i=m+1),n<=m&&(o=m-1);}}(e,t,a,n,i,o%2),ae(e,t,r,n,a-1,o+1),ae(e,t,r,a+1,i,o+1);}}function se(e,t,r,n){le(e,r,n),le(t,2*r,2*n),le(t,2*r+1,2*n+1);}function le(e,t,r){var n=e[t];e[t]=e[r],e[r]=n;}function ue(e,t,r,n){var i=e-r,o=t-n;return i*i+o*o}function he(e,t,r,n,i){return new ce(e,t,r,n,i)}function ce(e,t,r,n,i){t=t||fe,r=r||pe,i=i||Array,this.nodeSize=n||64,this.points=e,this.ids=new i(e.length),this.coords=new i(2*e.length);for(var o=0;o<e.length;o++)this.ids[o]=o,this.coords[2*o]=t(e[o]),this.coords[2*o+1]=r(e[o]);ae(this.ids,this.coords,this.nodeSize,0,this.ids.length-1,0);}function fe(e){return e[0]}function pe(e){return e[1]}function de(e){this.options=we(Object.create(this.options),e),this.trees=new Array(this.options.maxZoom+1);}function ge(e,t,r,n,i){return {x:e,y:t,zoom:1/0,id:r,parentId:-1,numPoints:n,properties:i}}function me(e){return {type:"Feature",id:e.id,properties:ve(e),geometry:{type:"Point",coordinates:[(n=e.x,360*(n-.5)),(t=e.y,r=(180-360*t)*Math.PI/180,360*Math.atan(Math.exp(r))/Math.PI-90)]}};var t,r,n;}function ve(e){var t=e.numPoints,r=t>=1e4?Math.round(t/1e3)+"k":t>=1e3?Math.round(t/100)/10+"k":t;return we(we({},e.properties),{cluster:!0,cluster_id:e.id,point_count:t,point_count_abbreviated:r})}function ye(e){return e/360+.5}function xe(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function we(e,t){for(var r in t)e[r]=t[r];return e}function Se(e){return e.x}function Me(e){return e.y}function be(e,t,r,n,i,o){var a=i-r,s=o-n;if(0!==a||0!==s){var l=((e-r)*a+(t-n)*s)/(a*a+s*s);l>1?(r=i,n=o):l>0&&(r+=a*l,n+=s*l);}return (a=e-r)*a+(s=t-n)*s}function Pe(e,t,r,n){var i={id:void 0===e?null:e,type:t,geometry:r,tags:n,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0};return function(e){var t=e.geometry,r=e.type;if("Point"===r||"MultiPoint"===r||"LineString"===r)_e(e,t);else if("Polygon"===r||"MultiLineString"===r)for(var n=0;n<t.length;n++)_e(e,t[n]);else if("MultiPolygon"===r)for(n=0;n<t.length;n++)for(var i=0;i<t[n].length;i++)_e(e,t[n][i]);}(i),i}function _e(e,t){for(var r=0;r<t.length;r+=3)e.minX=Math.min(e.minX,t[r]),e.minY=Math.min(e.minY,t[r+1]),e.maxX=Math.max(e.maxX,t[r]),e.maxY=Math.max(e.maxY,t[r+1]);}function Ie(e,t,r,n){if(t.geometry){var i=t.geometry.coordinates,o=t.geometry.type,a=Math.pow(r.tolerance/((1<<r.maxZoom)*r.extent),2),s=[],l=t.id;if(r.promoteId?l=t.properties[r.promoteId]:r.generateId&&(l=n||0),"Point"===o)Te(i,s);else if("MultiPoint"===o)for(var u=0;u<i.length;u++)Te(i[u],s);else if("LineString"===o)ke(i,s,a,!1);else if("MultiLineString"===o){if(r.lineMetrics){for(u=0;u<i.length;u++)s=[],ke(i[u],s,a,!1),e.push(Pe(l,"LineString",s,t.properties));return}ze(i,s,a,!1);}else if("Polygon"===o)ze(i,s,a,!0);else{if("MultiPolygon"!==o){if("GeometryCollection"===o){for(u=0;u<t.geometry.geometries.length;u++)Ie(e,{id:l,geometry:t.geometry.geometries[u],properties:t.properties},r,n);return}throw new Error("Input data is not a valid GeoJSON object.")}for(u=0;u<i.length;u++){var h=[];ze(i[u],h,a,!0),s.push(h);}}e.push(Pe(l,o,s,t.properties));}}function Te(e,t){t.push(Le(e[0])),t.push(Ee(e[1])),t.push(0);}function ke(e,t,r,n){for(var i,o,a=0,s=0;s<e.length;s++){var l=Le(e[s][0]),u=Ee(e[s][1]);t.push(l),t.push(u),t.push(0),s>0&&(a+=n?(i*u-l*o)/2:Math.sqrt(Math.pow(l-i,2)+Math.pow(u-o,2))),i=l,o=u;}var h=t.length-3;t[2]=1,function e(t,r,n,i){for(var o,a=i,s=n-r>>1,l=n-r,u=t[r],h=t[r+1],c=t[n],f=t[n+1],p=r+3;p<n;p+=3){var d=be(t[p],t[p+1],u,h,c,f);if(d>a)o=p,a=d;else if(d===a){var g=Math.abs(p-s);g<l&&(o=p,l=g);}}a>i&&(o-r>3&&e(t,r,o,i),t[o+2]=a,n-o>3&&e(t,o,n,i));}(t,0,h,r),t[h+2]=1,t.size=Math.abs(a),t.start=0,t.end=t.size;}function ze(e,t,r,n){for(var i=0;i<e.length;i++){var o=[];ke(e[i],o,r,n),t.push(o);}}function Le(e){return e/360+.5}function Ee(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function De(e,t,r,n,i,o,a,s){if(n/=t,o>=(r/=t)&&a<n)return e;if(a<r||o>=n)return null;for(var l=[],u=0;u<e.length;u++){var h=e[u],c=h.geometry,f=h.type,p=0===i?h.minX:h.minY,d=0===i?h.maxX:h.maxY;if(p>=r&&d<n)l.push(h);else if(!(d<r||p>=n)){var g=[];if("Point"===f||"MultiPoint"===f)Oe(c,g,r,n,i);else if("LineString"===f)Ce(c,g,r,n,i,!1,s.lineMetrics);else if("MultiLineString"===f)Ae(c,g,r,n,i,!1);else if("Polygon"===f)Ae(c,g,r,n,i,!0);else if("MultiPolygon"===f)for(var m=0;m<c.length;m++){var v=[];Ae(c[m],v,r,n,i,!0),v.length&&g.push(v);}if(g.length){if(s.lineMetrics&&"LineString"===f){for(m=0;m<g.length;m++)l.push(Pe(h.id,f,g[m],h.tags));continue}"LineString"!==f&&"MultiLineString"!==f||(1===g.length?(f="LineString",g=g[0]):f="MultiLineString"),"Point"!==f&&"MultiPoint"!==f||(f=3===g.length?"Point":"MultiPoint"),l.push(Pe(h.id,f,g,h.tags));}}}return l.length?l:null}function Oe(e,t,r,n,i){for(var o=0;o<e.length;o+=3){var a=e[o+i];a>=r&&a<=n&&(t.push(e[o]),t.push(e[o+1]),t.push(e[o+2]));}}function Ce(e,t,r,n,i,o,a){for(var s,l,u=Ne(e),h=0===i?Re:Fe,c=e.start,f=0;f<e.length-3;f+=3){var p=e[f],d=e[f+1],g=e[f+2],m=e[f+3],v=e[f+4],y=0===i?p:d,x=0===i?m:v,w=!1;a&&(s=Math.sqrt(Math.pow(p-m,2)+Math.pow(d-v,2))),y<r?x>=r&&(l=h(u,p,d,m,v,r),a&&(u.start=c+s*l)):y>=n?x<n&&(l=h(u,p,d,m,v,n),a&&(u.start=c+s*l)):Be(u,p,d,g),x<r&&y>=r&&(l=h(u,p,d,m,v,r),w=!0),x>n&&y<=n&&(l=h(u,p,d,m,v,n),w=!0),!o&&w&&(a&&(u.end=c+s*l),t.push(u),u=Ne(e)),a&&(c+=s);}var S=e.length-3;p=e[S],d=e[S+1],g=e[S+2],(y=0===i?p:d)>=r&&y<=n&&Be(u,p,d,g),S=u.length-3,o&&S>=3&&(u[S]!==u[0]||u[S+1]!==u[1])&&Be(u,u[0],u[1],u[2]),u.length&&t.push(u);}function Ne(e){var t=[];return t.size=e.size,t.start=e.start,t.end=e.end,t}function Ae(e,t,r,n,i,o){for(var a=0;a<e.length;a++)Ce(e[a],t,r,n,i,o,!1);}function Be(e,t,r,n){e.push(t),e.push(r),e.push(n);}function Re(e,t,r,n,i,o){var a=(o-t)/(n-t);return e.push(o),e.push(r+(i-r)*a),e.push(1),a}function Fe(e,t,r,n,i,o){var a=(o-r)/(i-r);return e.push(t+(n-t)*a),e.push(o),e.push(1),a}function Ge(e,t){for(var r=[],n=0;n<e.length;n++){var i,o=e[n],a=o.type;if("Point"===a||"MultiPoint"===a||"LineString"===a)i=Je(o.geometry,t);else if("MultiLineString"===a||"Polygon"===a){i=[];for(var s=0;s<o.geometry.length;s++)i.push(Je(o.geometry[s],t));}else if("MultiPolygon"===a)for(i=[],s=0;s<o.geometry.length;s++){for(var l=[],u=0;u<o.geometry[s].length;u++)l.push(Je(o.geometry[s][u],t));i.push(l);}r.push(Pe(o.id,a,i,o.tags));}return r}function Je(e,t){var r=[];r.size=e.size,void 0!==e.start&&(r.start=e.start,r.end=e.end);for(var n=0;n<e.length;n+=3)r.push(e[n]+t,e[n+1],e[n+2]);return r}function Xe(e,t){if(e.transformed)return e;var r,n,i,o=1<<e.z,a=e.x,s=e.y;for(r=0;r<e.features.length;r++){var l=e.features[r],u=l.geometry,h=l.type;if(l.geometry=[],1===h)for(n=0;n<u.length;n+=2)l.geometry.push(Ve(u[n],u[n+1],t,o,a,s));else for(n=0;n<u.length;n++){var c=[];for(i=0;i<u[n].length;i+=2)c.push(Ve(u[n][i],u[n][i+1],t,o,a,s));l.geometry.push(c);}}return e.transformed=!0,e}function Ve(e,t,r,n,i,o){return [Math.round(r*(e*n-i)),Math.round(r*(t*n-o))]}function Ze(e,t,r,n,i){for(var o=t===i.maxZoom?0:i.tolerance/((1<<t)*i.extent),a={features:[],numPoints:0,numSimplified:0,numFeatures:0,source:null,x:r,y:n,z:t,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0},s=0;s<e.length;s++){a.numFeatures++,je(a,e[s],o,i);var l=e[s].minX,u=e[s].minY,h=e[s].maxX,c=e[s].maxY;l<a.minX&&(a.minX=l),u<a.minY&&(a.minY=u),h>a.maxX&&(a.maxX=h),c>a.maxY&&(a.maxY=c);}return a}function je(e,t,r,n){var i=t.geometry,o=t.type,a=[];if("Point"===o||"MultiPoint"===o)for(var s=0;s<i.length;s+=3)a.push(i[s]),a.push(i[s+1]),e.numPoints++,e.numSimplified++;else if("LineString"===o)We(a,i,e,r,!1,!1);else if("MultiLineString"===o||"Polygon"===o)for(s=0;s<i.length;s++)We(a,i[s],e,r,"Polygon"===o,0===s);else if("MultiPolygon"===o)for(var l=0;l<i.length;l++){var u=i[l];for(s=0;s<u.length;s++)We(a,u[s],e,r,!0,0===s);}if(a.length){var h=t.tags||null;if("LineString"===o&&n.lineMetrics){for(var c in h={},t.tags)h[c]=t.tags[c];h.mapbox_clip_start=i.start/i.size,h.mapbox_clip_end=i.end/i.size;}var f={geometry:a,type:"Polygon"===o||"MultiPolygon"===o?3:"LineString"===o||"MultiLineString"===o?2:1,tags:h};null!==t.id&&(f.id=t.id),e.features.push(f);}}function We(e,t,r,n,i,o){var a=n*n;if(n>0&&t.size<(i?a:n))r.numPoints+=t.length/3;else{for(var s=[],l=0;l<t.length;l+=3)(0===n||t[l+2]>a)&&(r.numSimplified++,s.push(t[l]),s.push(t[l+1])),r.numPoints++;i&&function(e,t){for(var r=0,n=0,i=e.length,o=i-2;n<i;o=n,n+=2)r+=(e[n]-e[o])*(e[n+1]+e[o+1]);if(r>0===t)for(n=0,i=e.length;n<i/2;n+=2){var a=e[n],s=e[n+1];e[n]=e[i-2-n],e[n+1]=e[i-1-n],e[i-2-n]=a,e[i-1-n]=s;}}(s,o),e.push(s);}}function Ye(e,t){var r=(t=this.options=function(e,t){for(var r in t)e[r]=t[r];return e}(Object.create(this.options),t)).debug;if(r&&console.time("preprocess data"),t.maxZoom<0||t.maxZoom>24)throw new Error("maxZoom should be in the 0-24 range");if(t.promoteId&&t.generateId)throw new Error("promoteId and generateId cannot be used together.");var n=function(e,t){var r=[];if("FeatureCollection"===e.type)for(var n=0;n<e.features.length;n++)Ie(r,e.features[n],t,n);else"Feature"===e.type?Ie(r,e,t):Ie(r,{geometry:e},t);return r}(e,t);this.tiles={},this.tileCoords=[],r&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",t.indexMaxZoom,t.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),(n=function(e,t){var r=t.buffer/t.extent,n=e,i=De(e,1,-1-r,r,0,-1,2,t),o=De(e,1,1-r,2+r,0,-1,2,t);return (i||o)&&(n=De(e,1,-r,1+r,0,-1,2,t)||[],i&&(n=Ge(i,1).concat(n)),o&&(n=n.concat(Ge(o,-1)))),n}(n,t)).length&&this.splitTile(n,0,0,0),r&&(n.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)));}function qe(e,t,r){return 32*((1<<e)*r+t)+e}function Ue(e,t){var r=e.tileID.canonical;if(!this._geoJSONIndex)return t(null,null);var n=this._geoJSONIndex.getTile(r.z,r.x,r.y);if(!n)return t(null,null);var i=new V(n.features),o=q(i);0===o.byteOffset&&o.byteLength===o.buffer.byteLength||(o=new Uint8Array(o)),t(null,{vectorTile:i,rawData:o.buffer});}q.fromVectorTileJs=U,q.fromGeojsonVt=H,q.GeoJSONWrapper=Q,ce.prototype={range:function(e,t,r,n){return function(e,t,r,n,i,o,a){for(var s,l,u=[0,e.length-1,0],h=[];u.length;){var c=u.pop(),f=u.pop(),p=u.pop();if(f-p<=a)for(var d=p;d<=f;d++)s=t[2*d],l=t[2*d+1],s>=r&&s<=i&&l>=n&&l<=o&&h.push(e[d]);else{var g=Math.floor((p+f)/2);s=t[2*g],l=t[2*g+1],s>=r&&s<=i&&l>=n&&l<=o&&h.push(e[g]);var m=(c+1)%2;(0===c?r<=s:n<=l)&&(u.push(p),u.push(g-1),u.push(m)),(0===c?i>=s:o>=l)&&(u.push(g+1),u.push(f),u.push(m));}}return h}(this.ids,this.coords,e,t,r,n,this.nodeSize)},within:function(e,t,r){return function(e,t,r,n,i,o){for(var a=[0,e.length-1,0],s=[],l=i*i;a.length;){var u=a.pop(),h=a.pop(),c=a.pop();if(h-c<=o)for(var f=c;f<=h;f++)ue(t[2*f],t[2*f+1],r,n)<=l&&s.push(e[f]);else{var p=Math.floor((c+h)/2),d=t[2*p],g=t[2*p+1];ue(d,g,r,n)<=l&&s.push(e[p]);var m=(u+1)%2;(0===u?r-i<=d:n-i<=g)&&(a.push(c),a.push(p-1),a.push(m)),(0===u?r+i>=d:n+i>=g)&&(a.push(p+1),a.push(h),a.push(m));}}return s}(this.ids,this.coords,e,t,r,this.nodeSize)}},de.prototype={options:{minZoom:0,maxZoom:16,radius:40,extent:512,nodeSize:64,log:!1,reduce:null,initial:function(){return {}},map:function(e){return e}},load:function(e){var t=this.options.log;t&&console.time("total time");var r="prepare "+e.length+" points";t&&console.time(r),this.points=e;for(var n,i,o,a=[],s=0;s<e.length;s++)e[s].geometry&&a.push((n=e[s],i=s,void 0,{x:ye((o=n.geometry.coordinates)[0]),y:xe(o[1]),zoom:1/0,index:i,parentId:-1}));this.trees[this.options.maxZoom+1]=he(a,Se,Me,this.options.nodeSize,Float32Array),t&&console.timeEnd(r);for(var l=this.options.maxZoom;l>=this.options.minZoom;l--){var u=+Date.now();a=this._cluster(a,l),this.trees[l]=he(a,Se,Me,this.options.nodeSize,Float32Array),t&&console.log("z%d: %d clusters in %dms",l,a.length,+Date.now()-u);}return t&&console.timeEnd("total time"),this},getClusters:function(e,t){var r=((e[0]+180)%360+360)%360-180,n=Math.max(-90,Math.min(90,e[1])),i=180===e[2]?180:((e[2]+180)%360+360)%360-180,o=Math.max(-90,Math.min(90,e[3]));if(e[2]-e[0]>=360)r=-180,i=180;else if(r>i){var a=this.getClusters([r,n,180,o],t),s=this.getClusters([-180,n,i,o],t);return a.concat(s)}for(var l=this.trees[this._limitZoom(t)],u=l.range(ye(r),xe(o),ye(i),xe(n)),h=[],c=0;c<u.length;c++){var f=l.points[u[c]];h.push(f.numPoints?me(f):this.points[f.index]);}return h},getChildren:function(e){var t=e>>5,r=e%32,n="No cluster with the specified id.",i=this.trees[r];if(!i)throw new Error(n);var o=i.points[t];if(!o)throw new Error(n);for(var a=this.options.radius/(this.options.extent*Math.pow(2,r-1)),s=i.within(o.x,o.y,a),l=[],u=0;u<s.length;u++){var h=i.points[s[u]];h.parentId===e&&l.push(h.numPoints?me(h):this.points[h.index]);}if(0===l.length)throw new Error(n);return l},getLeaves:function(e,t,r){t=t||10,r=r||0;var n=[];return this._appendLeaves(n,e,t,r,0),n},getTile:function(e,t,r){var n=this.trees[this._limitZoom(e)],i=Math.pow(2,e),o=this.options.extent,a=this.options.radius/o,s=(r-a)/i,l=(r+1+a)/i,u={features:[]};return this._addTileFeatures(n.range((t-a)/i,s,(t+1+a)/i,l),n.points,t,r,i,u),0===t&&this._addTileFeatures(n.range(1-a/i,s,1,l),n.points,i,r,i,u),t===i-1&&this._addTileFeatures(n.range(0,s,a/i,l),n.points,-1,r,i,u),u.features.length?u:null},getClusterExpansionZoom:function(e){for(var t=e%32-1;t<this.options.maxZoom;){var r=this.getChildren(e);if(t++,1!==r.length)break;e=r[0].properties.cluster_id;}return t},_appendLeaves:function(e,t,r,n,i){for(var o=this.getChildren(t),a=0;a<o.length;a++){var s=o[a].properties;if(s&&s.cluster?i+s.point_count<=n?i+=s.point_count:i=this._appendLeaves(e,s.cluster_id,r,n,i):i<n?i++:e.push(o[a]),e.length===r)break}return i},_addTileFeatures:function(e,t,r,n,i,o){for(var a=0;a<e.length;a++){var s=t[e[a]],l={type:1,geometry:[[Math.round(this.options.extent*(s.x*i-r)),Math.round(this.options.extent*(s.y*i-n))]],tags:s.numPoints?ve(s):this.points[s.index].properties},u=s.numPoints?s.id:this.points[s.index].id;void 0!==u&&(l.id=u),o.features.push(l);}},_limitZoom:function(e){return Math.max(this.options.minZoom,Math.min(e,this.options.maxZoom+1))},_cluster:function(e,t){for(var r=[],n=this.options.radius/(this.options.extent*Math.pow(2,t)),i=0;i<e.length;i++){var o=e[i];if(!(o.zoom<=t)){o.zoom=t;var a=this.trees[t+1],s=a.within(o.x,o.y,n),l=o.numPoints||1,u=o.x*l,h=o.y*l,c=null;this.options.reduce&&(c=this.options.initial(),this._accumulate(c,o));for(var f=(i<<5)+(t+1),p=0;p<s.length;p++){var d=a.points[s[p]];if(!(d.zoom<=t)){d.zoom=t;var g=d.numPoints||1;u+=d.x*g,h+=d.y*g,l+=g,d.parentId=f,this.options.reduce&&this._accumulate(c,d);}}1===l?r.push(o):(o.parentId=f,r.push(ge(u/l,h/l,f,l,c)));}}return r},_accumulate:function(e,t){var r=t.numPoints?t.properties:this.options.map(this.points[t.index].properties);this.options.reduce(e,r);}},Ye.prototype.options={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,lineMetrics:!1,promoteId:null,generateId:!1,debug:0},Ye.prototype.splitTile=function(e,t,r,n,i,o,a){for(var s=[e,t,r,n],l=this.options,u=l.debug;s.length;){n=s.pop(),r=s.pop(),t=s.pop(),e=s.pop();var h=1<<t,c=qe(t,r,n),f=this.tiles[c];if(!f&&(u>1&&console.time("creation"),f=this.tiles[c]=Ze(e,t,r,n,l),this.tileCoords.push({z:t,x:r,y:n}),u)){u>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",t,r,n,f.numFeatures,f.numPoints,f.numSimplified),console.timeEnd("creation"));var p="z"+t;this.stats[p]=(this.stats[p]||0)+1,this.total++;}if(f.source=e,i){if(t===l.maxZoom||t===i)continue;var d=1<<i-t;if(r!==Math.floor(o/d)||n!==Math.floor(a/d))continue}else if(t===l.indexMaxZoom||f.numPoints<=l.indexMaxPoints)continue;if(f.source=null,0!==e.length){u>1&&console.time("clipping");var g,m,v,y,x,w,S=.5*l.buffer/l.extent,M=.5-S,b=.5+S,P=1+S;g=m=v=y=null,x=De(e,h,r-S,r+b,0,f.minX,f.maxX,l),w=De(e,h,r+M,r+P,0,f.minX,f.maxX,l),e=null,x&&(g=De(x,h,n-S,n+b,1,f.minY,f.maxY,l),m=De(x,h,n+M,n+P,1,f.minY,f.maxY,l),x=null),w&&(v=De(w,h,n-S,n+b,1,f.minY,f.maxY,l),y=De(w,h,n+M,n+P,1,f.minY,f.maxY,l),w=null),u>1&&console.timeEnd("clipping"),s.push(g||[],t+1,2*r,2*n),s.push(m||[],t+1,2*r,2*n+1),s.push(v||[],t+1,2*r+1,2*n),s.push(y||[],t+1,2*r+1,2*n+1);}}},Ye.prototype.getTile=function(e,t,r){var n=this.options,i=n.extent,o=n.debug;if(e<0||e>24)return null;var a=1<<e,s=qe(e,t=(t%a+a)%a,r);if(this.tiles[s])return Xe(this.tiles[s],i);o>1&&console.log("drilling down to z%d-%d-%d",e,t,r);for(var l,u=e,h=t,c=r;!l&&u>0;)u--,h=Math.floor(h/2),c=Math.floor(c/2),l=this.tiles[qe(u,h,c)];return l&&l.source?(o>1&&console.log("found parent tile z%d-%d-%d",u,h,c),o>1&&console.time("drilling down"),this.splitTile(l.source,u,h,c,e,t,r),o>1&&console.timeEnd("drilling down"),this.tiles[s]?Xe(this.tiles[s],i):null):null};var He=function(t){function r(e,r,n){t.call(this,e,r,Ue),n&&(this.loadGeoJSON=n);}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype.loadData=function(e,t){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),this._pendingCallback=t,this._pendingLoadDataParams=e,this._state&&"Idle"!==this._state?this._state="NeedsLoadData":(this._state="Coalescing",this._loadData());},r.prototype._loadData=function(){var e=this;if(this._pendingCallback&&this._pendingLoadDataParams){var t=this._pendingCallback,r=this._pendingLoadDataParams;delete this._pendingCallback,delete this._pendingLoadDataParams;var n=!!(r&&r.request&&r.request.collectResourceTiming)&&new T.Performance(r.request);this.loadGeoJSON(r,function(i,o){if(i||!o)return t(i);if("object"!=typeof o)return t(new Error("Input data is not a valid GeoJSON object."));B(o,!0);try{e._geoJSONIndex=r.cluster?(a=r.superclusterOptions,new de(a)).load(o.features):function(e,t){return new Ye(e,t)}(o,r.geojsonVtOptions);}catch(i){return t(i)}e.loaded={};var a,s={};if(n){var l=n.finish();l&&(s.resourceTiming={},s.resourceTiming[r.source]=JSON.parse(JSON.stringify(l)));}t(null,s);});}},r.prototype.coalesce=function(){"Coalescing"===this._state?this._state="Idle":"NeedsLoadData"===this._state&&(this._state="Coalescing",this._loadData());},r.prototype.reloadTile=function(e,r){var n=this.loaded,i=e.uid;return n&&n[i]?t.prototype.reloadTile.call(this,e,r):this.loadTile(e,r)},r.prototype.loadGeoJSON=function(t,r){if(t.request)e.getJSON(t.request,r);else{if("string"!=typeof t.data)return r(new Error("Input data is not a valid GeoJSON object."));try{return r(null,JSON.parse(t.data))}catch(e){return r(new Error("Input data is not a valid GeoJSON object."))}}},r.prototype.removeSource=function(e,t){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),t();},r.prototype.getClusterExpansionZoom=function(e,t){t(null,this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));},r.prototype.getClusterChildren=function(e,t){t(null,this._geoJSONIndex.getChildren(e.clusterId));},r.prototype.getClusterLeaves=function(e,t){t(null,this._geoJSONIndex.getLeaves(e.clusterId,e.limit,e.offset));},r}(L),Qe=function(t){var r=this;this.self=t,this.actor=new e.Actor(t,this),this.layerIndexes={},this.workerSourceTypes={vector:L,geojson:He},this.workerSources={},this.demWorkerSources={},this.self.registerWorkerSource=function(e,t){if(r.workerSourceTypes[e])throw new Error('Worker source with name "'+e+'" already registered.');r.workerSourceTypes[e]=t;},this.self.registerRTLTextPlugin=function(t){if(e.plugin.isLoaded())throw new Error("RTL text plugin already registered.");e.plugin.applyArabicShaping=t.applyArabicShaping,e.plugin.processBidirectionalText=t.processBidirectionalText,e.plugin.processStyledBidirectionalText=t.processStyledBidirectionalText;};};return Qe.prototype.setLayers=function(e,t,r){this.getLayerIndex(e).replace(t),r();},Qe.prototype.updateLayers=function(e,t,r){this.getLayerIndex(e).update(t.layers,t.removedIds),r();},Qe.prototype.loadTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).loadTile(t,r);},Qe.prototype.loadDEMTile=function(e,t,r){this.getDEMWorkerSource(e,t.source).loadTile(t,r);},Qe.prototype.reloadTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).reloadTile(t,r);},Qe.prototype.abortTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).abortTile(t,r);},Qe.prototype.removeTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).removeTile(t,r);},Qe.prototype.removeDEMTile=function(e,t){this.getDEMWorkerSource(e,t.source).removeTile(t);},Qe.prototype.removeSource=function(e,t,r){if(this.workerSources[e]&&this.workerSources[e][t.type]&&this.workerSources[e][t.type][t.source]){var n=this.workerSources[e][t.type][t.source];delete this.workerSources[e][t.type][t.source],void 0!==n.removeSource?n.removeSource(t,r):r();}},Qe.prototype.loadWorkerSource=function(e,t,r){try{this.self.importScripts(t.url),r();}catch(e){r(e.toString());}},Qe.prototype.loadRTLTextPlugin=function(t,r,n){try{e.plugin.isLoaded()||(this.self.importScripts(r),n(e.plugin.isLoaded()?null:new Error("RTL Text Plugin failed to import scripts from "+r)));}catch(e){n(e.toString());}},Qe.prototype.getLayerIndex=function(e){var t=this.layerIndexes[e];return t||(t=this.layerIndexes[e]=new n),t},Qe.prototype.getWorkerSource=function(e,t,r){var n=this;if(this.workerSources[e]||(this.workerSources[e]={}),this.workerSources[e][t]||(this.workerSources[e][t]={}),!this.workerSources[e][t][r]){var i={send:function(t,r,i){n.actor.send(t,r,i,e);}};this.workerSources[e][t][r]=new this.workerSourceTypes[t](i,this.getLayerIndex(e));}return this.workerSources[e][t][r]},Qe.prototype.getDEMWorkerSource=function(e,t){return this.demWorkerSources[e]||(this.demWorkerSources[e]={}),this.demWorkerSources[e][t]||(this.demWorkerSources[e][t]=new E),this.demWorkerSources[e][t]},"undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope&&new Qe(self),Qe});

define(["./shared.js"],function(t){"use strict";var e=t.createCommonjsModule(function(t){function e(t){return !!("undefined"!=typeof window&&"undefined"!=typeof document&&Array.prototype&&Array.prototype.every&&Array.prototype.filter&&Array.prototype.forEach&&Array.prototype.indexOf&&Array.prototype.lastIndexOf&&Array.prototype.map&&Array.prototype.some&&Array.prototype.reduce&&Array.prototype.reduceRight&&Array.isArray&&Function.prototype&&Function.prototype.bind&&Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions&&"JSON"in window&&"parse"in JSON&&"stringify"in JSON&&function(){if(!("Worker"in window&&"Blob"in window&&"URL"in window))return !1;var t,e,i=new Blob([""],{type:"text/javascript"}),n=URL.createObjectURL(i);try{e=new Worker(n),t=!0;}catch(e){t=!1;}e&&e.terminate();return URL.revokeObjectURL(n),t}()&&"Uint8ClampedArray"in window&&ArrayBuffer.isView&&function(t){void 0===i[t]&&(i[t]=function(t){var i=document.createElement("canvas"),n=Object.create(e.webGLContextAttributes);return n.failIfMajorPerformanceCaveat=t,i.probablySupportsContext?i.probablySupportsContext("webgl",n)||i.probablySupportsContext("experimental-webgl",n):i.supportsContext?i.supportsContext("webgl",n)||i.supportsContext("experimental-webgl",n):i.getContext("webgl",n)||i.getContext("experimental-webgl",n)}(t));return i[t]}(t&&t.failIfMajorPerformanceCaveat))}t.exports?t.exports=e:window&&(window.mapboxgl=window.mapboxgl||{},window.mapboxgl.supported=e);var i={};e.webGLContextAttributes={antialias:!1,alpha:!0,stencil:!0,depth:!0};}),i={create:function(e,i,n){var o=t.window.document.createElement(e);return i&&(o.className=i),n&&n.appendChild(o),o},createNS:function(e,i){return t.window.document.createElementNS(e,i)}},n=t.window.document?t.window.document.documentElement.style:null;function o(t){if(!n)return null;for(var e=0;e<t.length;e++)if(t[e]in n)return t[e];return t[0]}var r,a=o(["userSelect","MozUserSelect","WebkitUserSelect","msUserSelect"]);i.disableDrag=function(){n&&a&&(r=n[a],n[a]="none");},i.enableDrag=function(){n&&a&&(n[a]=r);};var s=o(["transform","WebkitTransform"]);i.setTransform=function(t,e){t.style[s]=e;};var l=!1;try{var c=Object.defineProperty({},"passive",{get:function(){l=!0;}});t.window.addEventListener("test",c,c),t.window.removeEventListener("test",c,c);}catch(t){l=!1;}i.addEventListener=function(t,e,i,n){void 0===n&&(n={}),"passive"in n&&l?t.addEventListener(e,i,n):t.addEventListener(e,i,n.capture);},i.removeEventListener=function(t,e,i,n){void 0===n&&(n={}),"passive"in n&&l?t.removeEventListener(e,i,n):t.removeEventListener(e,i,n.capture);};var h=function(e){e.preventDefault(),e.stopPropagation(),t.window.removeEventListener("click",h,!0);};i.suppressClick=function(){t.window.addEventListener("click",h,!0),t.window.setTimeout(function(){t.window.removeEventListener("click",h,!0);},0);},i.mousePos=function(e,i){var n=e.getBoundingClientRect();return i=i.touches?i.touches[0]:i,new t.Point(i.clientX-n.left-e.clientLeft,i.clientY-n.top-e.clientTop)},i.touchPos=function(e,i){for(var n=e.getBoundingClientRect(),o=[],r="touchend"===i.type?i.changedTouches:i.touches,a=0;a<r.length;a++)o.push(new t.Point(r[a].clientX-n.left-e.clientLeft,r[a].clientY-n.top-e.clientTop));return o},i.mouseButton=function(e){return void 0!==t.window.InstallTrigger&&2===e.button&&e.ctrlKey&&t.window.navigator.platform.toUpperCase().indexOf("MAC")>=0?0:e.button},i.remove=function(t){t.parentNode&&t.parentNode.removeChild(t);};var u={API_URL:"https://api.mapbox.com",EVENTS_URL:"https://events.mapbox.com/events/v2",REQUIRE_ACCESS_TOKEN:!0,ACCESS_TOKEN:null},p="See https://www.mapbox.com/api-documentation/#access-tokens";function d(t,e){var i=b(u.API_URL);if(t.protocol=i.protocol,t.authority=i.authority,"/"!==i.path&&(t.path=""+i.path+t.path),!u.REQUIRE_ACCESS_TOKEN)return w(t);if(!(e=e||u.ACCESS_TOKEN))throw new Error("An API access token is required to use Mapbox GL. "+p);if("s"===e[0])throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). "+p);return t.params.push("access_token="+e),w(t)}function f(t){return 0===t.indexOf("mapbox:")}var m=function(t,e){if(!f(t))return t;var i=b(t);return i.path="/fonts/v1"+i.path,d(i,e)},_=function(t,e){if(!f(t))return t;var i=b(t);return i.path="/v4/"+i.authority+".json",i.params.push("secure"),d(i,e)},g=function(t,e,i,n){var o=b(t);return f(t)?(o.path="/styles/v1"+o.path+"/sprite"+e+i,d(o,n)):(o.path+=""+e+i,w(o))},v=/(\.(png|jpg)\d*)(?=$)/,y=function(e,i,n){if(!i||!f(i))return e;var o=b(e),r=t.browser.devicePixelRatio>=2||512===n?"@2x":"",a=t.browser.supportsWebp?".webp":"$1";return o.path=o.path.replace(v,""+r+a),function(t){for(var e=0;e<t.length;e++)0===t[e].indexOf("access_token=tk.")&&(t[e]="access_token="+(u.ACCESS_TOKEN||""));}(o.params),w(o)};var x=/^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;function b(t){var e=t.match(x);if(!e)throw new Error("Unable to parse URL object");return {protocol:e[1],authority:e[2],path:e[3]||"/",params:e[4]?e[4].split("&"):[]}}function w(t){var e=t.params.length?"?"+t.params.join("&"):"";return t.protocol+"://"+t.authority+t.path+e}var E=function(){this.eventData={anonId:null,lastSuccess:null,accessToken:u.ACCESS_TOKEN},this.queue=[],this.pending=!1,this.pendingRequest=null;};E.prototype.postTurnstileEvent=function(e){u.ACCESS_TOKEN&&Array.isArray(e)&&e.some(function(t){return /(mapbox\.c)(n|om)/i.test(t)})&&this.queueRequest(t.browser.now());},E.prototype.queueRequest=function(t){this.queue.push(t),this.processRequests();},E.prototype.processRequests=function(){var e=this;if(!this.pendingRequest&&0!==this.queue.length){var i="mapbox.turnstileEventData:"+(u.ACCESS_TOKEN||""),n=t.storageAvailable("localStorage"),o=!!this.eventData.accessToken&&this.eventData.accessToken!==u.ACCESS_TOKEN;if(o&&(this.eventData.anonId=this.eventData.lastSuccess=null),(!this.eventData.anonId||!this.eventData.lastSuccess)&&n)try{var r=t.window.localStorage.getItem(i);r&&(this.eventData=JSON.parse(r));}catch(e){t.warnOnce("Unable to read from LocalStorage");}t.validateUuid(this.eventData.anonId)||(this.eventData.anonId=t.uuid(),o=!0);var a=this.queue.shift();if(this.eventData.lastSuccess){var s=new Date(this.eventData.lastSuccess),l=new Date(a),c=(a-this.eventData.lastSuccess)/864e5;o=o||c>=1||c<-1||s.getDate()!==l.getDate();}if(!o)return this.processRequests();var h=b(u.EVENTS_URL);h.params.push("access_token="+(u.ACCESS_TOKEN||""));var p={url:w(h),headers:{"Content-Type":"text/plain"}},d=JSON.stringify([{event:"appUserTurnstile",created:new Date(a).toISOString(),sdkIdentifier:"mapbox-gl-js",sdkVersion:"0.48.0","enabled.telemetry":!1,userId:this.eventData.anonId}]);this.pendingRequest=t.postData(p,d,function(o){if(e.pendingRequest=null,!o){if(e.eventData.lastSuccess=a,e.eventData.accessToken=u.ACCESS_TOKEN,n)try{t.window.localStorage.setItem(i,JSON.stringify(e.eventData));}catch(e){t.warnOnce("Unable to write to LocalStorage");}e.processRequests();}});}};var T=new E,I=T.postTurnstileEvent.bind(T);var S=function(){this.images={},this.loaded=!1,this.requestors=[],this.shelfPack=new t.ShelfPack(64,64,{autoResize:!0}),this.patterns={},this.atlasImage=new t.RGBAImage({width:64,height:64}),this.dirty=!0;};S.prototype.isLoaded=function(){return this.loaded},S.prototype.setLoaded=function(t){if(this.loaded!==t&&(this.loaded=t,t)){for(var e=0,i=this.requestors;e<i.length;e+=1){var n=i[e],o=n.ids,r=n.callback;this._notify(o,r);}this.requestors=[];}},S.prototype.getImage=function(t){return this.images[t]},S.prototype.addImage=function(t,e){this.images[t]=e;},S.prototype.removeImage=function(t){delete this.images[t];var e=this.patterns[t];e&&(this.shelfPack.unref(e.bin),delete this.patterns[t]);},S.prototype.listImages=function(){return Object.keys(this.images)},S.prototype.getImages=function(t,e){var i=!0;if(!this.isLoaded())for(var n=0,o=t;n<o.length;n+=1){var r=o[n];this.images[r]||(i=!1);}this.isLoaded()||i?this._notify(t,e):this.requestors.push({ids:t,callback:e});},S.prototype._notify=function(t,e){for(var i={},n=0,o=t;n<o.length;n+=1){var r=o[n],a=this.images[r];a&&(i[r]={data:a.data.clone(),pixelRatio:a.pixelRatio,sdf:a.sdf});}e(null,i);},S.prototype.getPixelSize=function(){return {width:this.shelfPack.w,height:this.shelfPack.h}},S.prototype.getPattern=function(e){var i=this.patterns[e];if(i)return i.position;var n=this.getImage(e);if(!n)return null;var o=n.data.width+2,r=n.data.height+2,a=this.shelfPack.packOne(o,r);if(!a)return null;this.atlasImage.resize(this.getPixelSize());var s=n.data,l=this.atlasImage,c=a.x+1,h=a.y+1,u=s.width,p=s.height;t.RGBAImage.copy(s,l,{x:0,y:0},{x:c,y:h},{width:u,height:p}),t.RGBAImage.copy(s,l,{x:0,y:p-1},{x:c,y:h-1},{width:u,height:1}),t.RGBAImage.copy(s,l,{x:0,y:0},{x:c,y:h+p},{width:u,height:1}),t.RGBAImage.copy(s,l,{x:u-1,y:0},{x:c-1,y:h},{width:1,height:p}),t.RGBAImage.copy(s,l,{x:0,y:0},{x:c+u,y:h},{width:1,height:p}),this.dirty=!0;var d=new t.ImagePosition(a,n);return this.patterns[e]={bin:a,position:d},d},S.prototype.bind=function(e){var i=e.gl;this.atlasTexture?this.dirty&&(this.atlasTexture.update(this.atlasImage),this.dirty=!1):this.atlasTexture=new t.Texture(e,this.atlasImage,i.RGBA),this.atlasTexture.bind(i.LINEAR,i.CLAMP_TO_EDGE);};var C=P,z=1e20;function P(t,e,i,n,o,r){this.fontSize=t||24,this.buffer=void 0===e?3:e,this.cutoff=n||.25,this.fontFamily=o||"sans-serif",this.fontWeight=r||"normal",this.radius=i||8;var a=this.size=this.fontSize+2*this.buffer;this.canvas=document.createElement("canvas"),this.canvas.width=this.canvas.height=a,this.ctx=this.canvas.getContext("2d"),this.ctx.font=this.fontWeight+" "+this.fontSize+"px "+this.fontFamily,this.ctx.textBaseline="middle",this.ctx.fillStyle="black",this.gridOuter=new Float64Array(a*a),this.gridInner=new Float64Array(a*a),this.f=new Float64Array(a),this.d=new Float64Array(a),this.z=new Float64Array(a+1),this.v=new Int16Array(a),this.middle=Math.round(a/2*(navigator.userAgent.indexOf("Gecko/")>=0?1.2:1));}function A(t,e,i,n,o,r,a){for(var s=0;s<e;s++){for(var l=0;l<i;l++)n[l]=t[l*e+s];for(D(n,o,r,a,i),l=0;l<i;l++)t[l*e+s]=o[l];}for(l=0;l<i;l++){for(s=0;s<e;s++)n[s]=t[l*e+s];for(D(n,o,r,a,e),s=0;s<e;s++)t[l*e+s]=Math.sqrt(o[s]);}}function D(t,e,i,n,o){i[0]=0,n[0]=-z,n[1]=+z;for(var r=1,a=0;r<o;r++){for(var s=(t[r]+r*r-(t[i[a]]+i[a]*i[a]))/(2*r-2*i[a]);s<=n[a];)a--,s=(t[r]+r*r-(t[i[a]]+i[a]*i[a]))/(2*r-2*i[a]);i[++a]=r,n[a]=s,n[a+1]=+z;}for(r=0,a=0;r<o;r++){for(;n[a+1]<r;)a++;e[r]=(r-i[a])*(r-i[a])+t[i[a]];}}P.prototype.draw=function(t){this.ctx.clearRect(0,0,this.size,this.size),this.ctx.fillText(t,this.buffer,this.middle);for(var e=this.ctx.getImageData(0,0,this.size,this.size),i=new Uint8ClampedArray(this.size*this.size),n=0;n<this.size*this.size;n++){var o=e.data[4*n+3]/255;this.gridOuter[n]=1===o?0:0===o?z:Math.pow(Math.max(0,.5-o),2),this.gridInner[n]=1===o?z:0===o?0:Math.pow(Math.max(0,o-.5),2);}for(A(this.gridOuter,this.size,this.size,this.f,this.d,this.v,this.z),A(this.gridInner,this.size,this.size,this.f,this.d,this.v,this.z),n=0;n<this.size*this.size;n++){var r=this.gridOuter[n]-this.gridInner[n];i[n]=Math.max(0,Math.min(255,Math.round(255-255*(r/this.radius+this.cutoff))));}return i};var R=function(t,e){this.requestTransform=t,this.localIdeographFontFamily=e,this.entries={};};R.prototype.setURL=function(t){this.url=t;},R.prototype.getGlyphs=function(e,i){var n=this,o=[];for(var r in e)for(var a=0,s=e[r];a<s.length;a+=1){var l=s[a];o.push({stack:r,id:l});}t.asyncAll(o,function(t,e){var i=t.stack,o=t.id,r=n.entries[i];r||(r=n.entries[i]={glyphs:{},requests:{}});var a=r.glyphs[o];if(void 0===a)if(a=n._tinySDF(r,i,o))e(null,{stack:i,id:o,glyph:a});else{var s=Math.floor(o/256);if(256*s>65535)e(new Error("glyphs > 65535 not supported"));else{var l=r.requests[s];l||(l=r.requests[s]=[],R.loadGlyphRange(i,s,n.url,n.requestTransform,function(t,e){if(e)for(var i in e)r.glyphs[+i]=e[+i];for(var n=0,o=l;n<o.length;n+=1){(0,o[n])(t,e);}delete r.requests[s];})),l.push(function(t,n){t?e(t):n&&e(null,{stack:i,id:o,glyph:n[o]||null});});}}else e(null,{stack:i,id:o,glyph:a});},function(t,e){if(t)i(t);else if(e){for(var n={},o=0,r=e;o<r.length;o+=1){var a=r[o],s=a.stack,l=a.id,c=a.glyph;(n[s]||(n[s]={}))[l]=c&&{id:c.id,bitmap:c.bitmap.clone(),metrics:c.metrics};}i(null,n);}});},R.prototype._tinySDF=function(e,i,n){var o=this.localIdeographFontFamily;if(o&&(t.isChar["CJK Unified Ideographs"](n)||t.isChar["Hangul Syllables"](n))){var r=e.tinySDF;if(!r){var a="400";/bold/i.test(i)?a="900":/medium/i.test(i)?a="500":/light/i.test(i)&&(a="200"),r=e.tinySDF=new R.TinySDF(24,3,8,.25,o,a);}return {id:n,bitmap:new t.AlphaImage({width:30,height:30},r.draw(String.fromCharCode(n))),metrics:{width:24,height:24,left:0,top:-8,advance:24}}}},R.loadGlyphRange=function(e,i,n,o,r){var a=256*i,s=a+255,l=o(m(n).replace("{fontstack}",e).replace("{range}",a+"-"+s),t.ResourceType.Glyphs);t.getArrayBuffer(l,function(e,i){if(e)r(e);else if(i){for(var n={},o=0,a=t.parseGlyphPBF(i.data);o<a.length;o+=1){var s=a[o];n[s.id]=s;}r(null,n);}});},R.TinySDF=C;var M=function(){this.specification=t.styleSpec.light.position;};M.prototype.possiblyEvaluate=function(e,i){return t.sphericalToCartesian(e.expression.evaluate(i))},M.prototype.interpolate=function(e,i,n){return {x:t.number(e.x,i.x,n),y:t.number(e.y,i.y,n),z:t.number(e.z,i.z,n)}};var L=new t.Properties({anchor:new t.DataConstantProperty(t.styleSpec.light.anchor),position:new M,color:new t.DataConstantProperty(t.styleSpec.light.color),intensity:new t.DataConstantProperty(t.styleSpec.light.intensity)}),k=function(e){function i(i){e.call(this),this._transitionable=new t.Transitionable(L),this.setLight(i),this._transitioning=this._transitionable.untransitioned();}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getLight=function(){return this._transitionable.serialize()},i.prototype.setLight=function(e){if(!this._validate(t.validateLight,e))for(var i in e){var n=e[i];t.endsWith(i,"-transition")?this._transitionable.setTransition(i.slice(0,-"-transition".length),n):this._transitionable.setValue(i,n);}},i.prototype.updateTransitions=function(t){this._transitioning=this._transitionable.transitioned(t,this._transitioning);},i.prototype.hasTransition=function(){return this._transitioning.hasTransition()},i.prototype.recalculate=function(t){this.properties=this._transitioning.possiblyEvaluate(t);},i.prototype._validate=function(e,i){return t.emitValidationErrors(this,e.call(t.validateStyle,t.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:t.styleSpec})))},i}(t.Evented),B=function(t,e){this.width=t,this.height=e,this.nextRow=0,this.bytes=4,this.data=new Uint8Array(this.width*this.height*this.bytes),this.positions={};};B.prototype.getDash=function(t,e){var i=t.join(",")+String(e);return this.positions[i]||(this.positions[i]=this.addDash(t,e)),this.positions[i]},B.prototype.addDash=function(e,i){var n=i?7:0,o=2*n+1;if(this.nextRow+o>this.height)return t.warnOnce("LineAtlas out of space"),null;for(var r=0,a=0;a<e.length;a++)r+=e[a];for(var s=this.width/r,l=s/2,c=e.length%2==1,h=-n;h<=n;h++)for(var u=this.nextRow+n+h,p=this.width*u,d=c?-e[e.length-1]:0,f=e[0],m=1,_=0;_<this.width;_++){for(;f<_/s;)d=f,f+=e[m],c&&m===e.length-1&&(f+=e[0]),m++;var g=Math.abs(_-d*s),v=Math.abs(_-f*s),y=Math.min(g,v),x=m%2==1,b=void 0;if(i){var w=n?h/n*(l+1):0;if(x){var E=l-Math.abs(w);b=Math.sqrt(y*y+E*E);}else b=l-Math.sqrt(y*y+w*w);}else b=(x?1:-1)*y;this.data[3+4*(p+_)]=Math.max(0,Math.min(255,b+128));}var T={y:(this.nextRow+n+.5)/this.height,height:2*n/this.height,width:r};return this.nextRow+=o,this.dirty=!0,T},B.prototype.bind=function(t){var e=t.gl;this.texture?(e.bindTexture(e.TEXTURE_2D,this.texture),this.dirty&&(this.dirty=!1,e.texSubImage2D(e.TEXTURE_2D,0,0,0,this.width,this.height,e.RGBA,e.UNSIGNED_BYTE,this.data))):(this.texture=e.createTexture(),e.bindTexture(e.TEXTURE_2D,this.texture),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,e.LINEAR),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,e.LINEAR),e.texImage2D(e.TEXTURE_2D,0,e.RGBA,this.width,this.height,0,e.RGBA,e.UNSIGNED_BYTE,this.data));};var O=function e(i,n){this.workerPool=i,this.actors=[],this.currentActor=0,this.id=t.uniqueId();for(var o=this.workerPool.acquire(this.id),r=0;r<o.length;r++){var a=o[r],s=new e.Actor(a,n,this.id);s.name="Worker "+r,this.actors.push(s);}};function F(e,i,n){var o=function(e,i){if(e)return n(e);if(i){var o=t.pick(i,["tiles","minzoom","maxzoom","attribution","mapbox_logo","bounds"]);i.vector_layers&&(o.vectorLayers=i.vector_layers,o.vectorLayerIds=o.vectorLayers.map(function(t){return t.id})),n(null,o);}};return e.url?t.getJSON(i(_(e.url),t.ResourceType.Source),o):t.browser.frame(function(){return o(null,e)})}O.prototype.broadcast=function(e,i,n){n=n||function(){},t.asyncAll(this.actors,function(t,n){t.send(e,i,n);},n);},O.prototype.send=function(t,e,i,n){return ("number"!=typeof n||isNaN(n))&&(n=this.currentActor=(this.currentActor+1)%this.actors.length),this.actors[n].send(t,e,i),n},O.prototype.remove=function(){this.actors.forEach(function(t){t.remove();}),this.actors=[],this.workerPool.release(this.id);},O.Actor=t.Actor;var N=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid LngLat object: ("+t+", "+e+")");if(this.lng=+t,this.lat=+e,this.lat>90||this.lat<-90)throw new Error("Invalid LngLat latitude value: must be between -90 and 90")};N.prototype.wrap=function(){return new N(t.wrap(this.lng,-180,180),this.lat)},N.prototype.toArray=function(){return [this.lng,this.lat]},N.prototype.toString=function(){return "LngLat("+this.lng+", "+this.lat+")"},N.prototype.toBounds=function(t){var e=360*t/40075017,i=e/Math.cos(Math.PI/180*this.lat);return new U(new N(this.lng-i,this.lat-e),new N(this.lng+i,this.lat+e))},N.convert=function(t){if(t instanceof N)return t;if(Array.isArray(t)&&(2===t.length||3===t.length))return new N(Number(t[0]),Number(t[1]));if(!Array.isArray(t)&&"object"==typeof t&&null!==t)return new N(Number(t.lng),Number(t.lat));throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")};var U=function(t,e){t&&(e?this.setSouthWest(t).setNorthEast(e):4===t.length?this.setSouthWest([t[0],t[1]]).setNorthEast([t[2],t[3]]):this.setSouthWest(t[0]).setNorthEast(t[1]));};U.prototype.setNorthEast=function(t){return this._ne=t instanceof N?new N(t.lng,t.lat):N.convert(t),this},U.prototype.setSouthWest=function(t){return this._sw=t instanceof N?new N(t.lng,t.lat):N.convert(t),this},U.prototype.extend=function(t){var e,i,n=this._sw,o=this._ne;if(t instanceof N)e=t,i=t;else{if(!(t instanceof U))return Array.isArray(t)?t.every(Array.isArray)?this.extend(U.convert(t)):this.extend(N.convert(t)):this;if(e=t._sw,i=t._ne,!e||!i)return this}return n||o?(n.lng=Math.min(e.lng,n.lng),n.lat=Math.min(e.lat,n.lat),o.lng=Math.max(i.lng,o.lng),o.lat=Math.max(i.lat,o.lat)):(this._sw=new N(e.lng,e.lat),this._ne=new N(i.lng,i.lat)),this},U.prototype.getCenter=function(){return new N((this._sw.lng+this._ne.lng)/2,(this._sw.lat+this._ne.lat)/2)},U.prototype.getSouthWest=function(){return this._sw},U.prototype.getNorthEast=function(){return this._ne},U.prototype.getNorthWest=function(){return new N(this.getWest(),this.getNorth())},U.prototype.getSouthEast=function(){return new N(this.getEast(),this.getSouth())},U.prototype.getWest=function(){return this._sw.lng},U.prototype.getSouth=function(){return this._sw.lat},U.prototype.getEast=function(){return this._ne.lng},U.prototype.getNorth=function(){return this._ne.lat},U.prototype.toArray=function(){return [this._sw.toArray(),this._ne.toArray()]},U.prototype.toString=function(){return "LngLatBounds("+this._sw.toString()+", "+this._ne.toString()+")"},U.prototype.isEmpty=function(){return !(this._sw&&this._ne)},U.convert=function(t){return !t||t instanceof U?t:new U(t)};var V=function(t,e,i){this.bounds=U.convert(this.validateBounds(t)),this.minzoom=e||0,this.maxzoom=i||24;};V.prototype.validateBounds=function(t){return Array.isArray(t)&&4===t.length?[Math.max(-180,t[0]),Math.max(-90,t[1]),Math.min(180,t[2]),Math.min(90,t[3])]:[-180,-90,180,90]},V.prototype.contains=function(t){var e=Math.floor(this.lngX(this.bounds.getWest(),t.z)),i=Math.floor(this.latY(this.bounds.getNorth(),t.z)),n=Math.ceil(this.lngX(this.bounds.getEast(),t.z)),o=Math.ceil(this.latY(this.bounds.getSouth(),t.z));return t.x>=e&&t.x<n&&t.y>=i&&t.y<o},V.prototype.lngX=function(t,e){return (t+180)*(Math.pow(2,e)/360)},V.prototype.latY=function(e,i){var n=t.clamp(Math.sin(Math.PI/180*e),-.9999,.9999),o=Math.pow(2,i)/(2*Math.PI);return Math.pow(2,i-1)+.5*Math.log((1+n)/(1-n))*-o};var Z=function(e){function i(i,n,o,r){if(e.call(this),this.id=i,this.dispatcher=o,this.type="vector",this.minzoom=0,this.maxzoom=22,this.scheme="xyz",this.tileSize=512,this.reparseOverscaled=!0,this.isTileClipped=!0,t.extend(this,t.pick(n,["url","scheme","tileSize"])),this._options=t.extend({type:"vector"},n),this._collectResourceTiming=n.collectResourceTiming,512!==this.tileSize)throw new Error("vector tile sources must have a tileSize of 512");this.setEventedParent(r);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=F(this._options,this.map._transformRequest,function(i,n){e._tileJSONRequest=null,i?e.fire(new t.ErrorEvent(i)):n&&(t.extend(e,n),n.bounds&&(e.tileBounds=new V(n.bounds,e.minzoom,e.maxzoom)),I(n.tiles),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})));});},i.prototype.hasTile=function(t){return !this.tileBounds||this.tileBounds.contains(t.canonical)},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);},i.prototype.serialize=function(){return t.extend({},this._options)},i.prototype.loadTile=function(e,i){var n=y(e.tileID.canonical.url(this.tiles,this.scheme),this.url),o={request:this.map._transformRequest(n,t.ResourceType.Tile),uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,tileSize:this.tileSize*e.tileID.overscaleFactor(),type:this.type,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes};function r(t,n){return e.aborted?i(null):t&&404!==t.status?i(t):(n&&n.resourceTiming&&(e.resourceTiming=n.resourceTiming),this.map._refreshExpiredTiles&&n&&e.setExpiryData(n),e.loadVectorData(n,this.map.painter),i(null),void(e.reloadCallback&&(this.loadTile(e,e.reloadCallback),e.reloadCallback=null)))}o.request.collectResourceTiming=this._collectResourceTiming,void 0===e.workerID||"expired"===e.state?e.workerID=this.dispatcher.send("loadTile",o,r.bind(this)):"loading"===e.state?e.reloadCallback=i:this.dispatcher.send("reloadTile",o,r.bind(this),e.workerID);},i.prototype.abortTile=function(t){this.dispatcher.send("abortTile",{uid:t.uid,type:this.type,source:this.id},void 0,t.workerID);},i.prototype.unloadTile=function(t){t.unloadVectorData(),this.dispatcher.send("removeTile",{uid:t.uid,type:this.type,source:this.id},void 0,t.workerID);},i.prototype.hasTransition=function(){return !1},i}(t.Evented),j=function(e){function i(i,n,o,r){e.call(this),this.id=i,this.dispatcher=o,this.setEventedParent(r),this.type="raster",this.minzoom=0,this.maxzoom=22,this.roundZoom=!0,this.scheme="xyz",this.tileSize=512,this._loaded=!1,this._options=t.extend({},n),t.extend(this,t.pick(n,["url","scheme","tileSize"]));}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=F(this._options,this.map._transformRequest,function(i,n){e._tileJSONRequest=null,i?e.fire(new t.ErrorEvent(i)):n&&(t.extend(e,n),n.bounds&&(e.tileBounds=new V(n.bounds,e.minzoom,e.maxzoom)),I(n.tiles),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})));});},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);},i.prototype.serialize=function(){return t.extend({},this._options)},i.prototype.hasTile=function(t){return !this.tileBounds||this.tileBounds.contains(t.canonical)},i.prototype.loadTile=function(e,i){var n=this,o=y(e.tileID.canonical.url(this.tiles,this.scheme),this.url,this.tileSize);e.request=t.getImage(this.map._transformRequest(o,t.ResourceType.Tile),function(o,r){if(delete e.request,e.aborted)e.state="unloaded",i(null);else if(o)e.state="errored",i(o);else if(r){n.map._refreshExpiredTiles&&e.setExpiryData(r),delete r.cacheControl,delete r.expires;var a=n.map.painter.context,s=a.gl;e.texture=n.map.painter.getTileTexture(r.width),e.texture?e.texture.update(r,{useMipmap:!0}):(e.texture=new t.Texture(a,r,s.RGBA,{useMipmap:!0}),e.texture.bind(s.LINEAR,s.CLAMP_TO_EDGE,s.LINEAR_MIPMAP_NEAREST),a.extTextureFilterAnisotropic&&s.texParameterf(s.TEXTURE_2D,a.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,a.extTextureFilterAnisotropicMax)),e.state="loaded",i(null);}});},i.prototype.abortTile=function(t,e){t.request&&(t.request.cancel(),delete t.request),e();},i.prototype.unloadTile=function(t,e){t.texture&&this.map.painter.saveTileTexture(t.texture),e();},i.prototype.hasTransition=function(){return !1},i}(t.Evented),q=function(e){function i(i,n,o,r){e.call(this,i,n,o,r),this.type="raster-dem",this.maxzoom=22,this._options=t.extend({},n),this.encoding=n.encoding||"mapbox";}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.serialize=function(){return {type:"raster-dem",url:this.url,tileSize:this.tileSize,tiles:this.tiles,bounds:this.bounds,encoding:this.encoding}},i.prototype.loadTile=function(e,i){var n=y(e.tileID.canonical.url(this.tiles,this.scheme),this.url,this.tileSize);e.request=t.getImage(this.map._transformRequest(n,t.ResourceType.Tile),function(n,o){if(delete e.request,e.aborted)e.state="unloaded",i(null);else if(n)e.state="errored",i(n);else if(o){this.map._refreshExpiredTiles&&e.setExpiryData(o),delete o.cacheControl,delete o.expires;var r=t.browser.getImageData(o),a={uid:e.uid,coord:e.tileID,source:this.id,rawImageData:r,encoding:this.encoding};e.workerID&&"expired"!==e.state||(e.workerID=this.dispatcher.send("loadDEMTile",a,function(t,n){t&&(e.state="errored",i(t));n&&(e.dem=n,e.needsHillshadePrepare=!0,e.state="loaded",i(null));}.bind(this)));}}.bind(this)),e.neighboringTiles=this._getNeighboringTiles(e.tileID);},i.prototype._getNeighboringTiles=function(e){var i=e.canonical,n=Math.pow(2,i.z),o=(i.x-1+n)%n,r=0===i.x?e.wrap-1:e.wrap,a=(i.x+1+n)%n,s=i.x+1===n?e.wrap+1:e.wrap,l={};return l[new t.OverscaledTileID(e.overscaledZ,r,i.z,o,i.y).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,a,i.y).key]={backfilled:!1},i.y>0&&(l[new t.OverscaledTileID(e.overscaledZ,r,i.z,o,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,a,i.y-1).key]={backfilled:!1}),i.y+1<n&&(l[new t.OverscaledTileID(e.overscaledZ,r,i.z,o,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,a,i.y+1).key]={backfilled:!1}),l},i.prototype.unloadTile=function(t){t.demTexture&&this.map.painter.saveTileTexture(t.demTexture),t.fbo&&(t.fbo.destroy(),delete t.fbo),t.dem&&delete t.dem,delete t.neighboringTiles,t.state="unloaded",this.dispatcher.send("removeDEMTile",{uid:t.uid,source:this.id},void 0,t.workerID);},i}(j),G=function(e){function i(i,n,o,r){e.call(this),this.id=i,this.type="geojson",this.minzoom=0,this.maxzoom=18,this.tileSize=512,this.isTileClipped=!0,this.reparseOverscaled=!0,this._removed=!1,this.dispatcher=o,this.setEventedParent(r),this._data=n.data,this._options=t.extend({},n),this._collectResourceTiming=n.collectResourceTiming,this._resourceTiming=[],void 0!==n.maxzoom&&(this.maxzoom=n.maxzoom),n.type&&(this.type=n.type),n.attribution&&(this.attribution=n.attribution);var a=t.EXTENT/this.tileSize;this.workerOptions=t.extend({source:this.id,cluster:n.cluster||!1,geojsonVtOptions:{buffer:(void 0!==n.buffer?n.buffer:128)*a,tolerance:(void 0!==n.tolerance?n.tolerance:.375)*a,extent:t.EXTENT,maxZoom:this.maxzoom,lineMetrics:n.lineMetrics||!1,generateId:n.generateId||!1},superclusterOptions:{maxZoom:void 0!==n.clusterMaxZoom?Math.min(n.clusterMaxZoom,this.maxzoom-1):this.maxzoom-1,extent:t.EXTENT,radius:(n.clusterRadius||50)*a,log:!1}},n.workerOptions);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData(function(i){if(i)e.fire(new t.ErrorEvent(i));else{var n={dataType:"source",sourceDataType:"metadata"};e._collectResourceTiming&&e._resourceTiming&&e._resourceTiming.length>0&&(n.resourceTiming=e._resourceTiming,e._resourceTiming=[]),e.fire(new t.Event("data",n));}});},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.setData=function(e){var i=this;return this._data=e,this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData(function(e){if(e)i.fire(new t.ErrorEvent(e));else{var n={dataType:"source",sourceDataType:"content"};i._collectResourceTiming&&i._resourceTiming&&i._resourceTiming.length>0&&(n.resourceTiming=i._resourceTiming,i._resourceTiming=[]),i.fire(new t.Event("data",n));}}),this},i.prototype.getClusterExpansionZoom=function(t,e){return this.dispatcher.send("geojson.getClusterExpansionZoom",{clusterId:t,source:this.id},e,this.workerID),this},i.prototype.getClusterChildren=function(t,e){return this.dispatcher.send("geojson.getClusterChildren",{clusterId:t,source:this.id},e,this.workerID),this},i.prototype.getClusterLeaves=function(t,e,i,n){return this.dispatcher.send("geojson.getClusterLeaves",{source:this.id,clusterId:t,limit:e,offset:i},n,this.workerID),this},i.prototype._updateWorkerData=function(e){var i=this,n=t.extend({},this.workerOptions),o=this._data;"string"==typeof o?(n.request=this.map._transformRequest(t.browser.resolveURL(o),t.ResourceType.Source),n.request.collectResourceTiming=this._collectResourceTiming):n.data=JSON.stringify(o),this.workerID=this.dispatcher.send(this.type+".loadData",n,function(t,o){i._removed||o&&o.abandoned||(i._loaded=!0,o&&o.resourceTiming&&o.resourceTiming[i.id]&&(i._resourceTiming=o.resourceTiming[i.id].slice(0)),i.dispatcher.send(i.type+".coalesce",{source:n.source},null,i.workerID),e(t));},this.workerID);},i.prototype.loadTile=function(e,i){var n=this,o=void 0===e.workerID?"loadTile":"reloadTile",r={type:this.type,uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,maxZoom:this.maxzoom,tileSize:this.tileSize,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes};e.workerID=this.dispatcher.send(o,r,function(t,r){return e.unloadVectorData(),e.aborted?i(null):t?i(t):(e.loadVectorData(r,n.map.painter,"reloadTile"===o),i(null))},this.workerID);},i.prototype.abortTile=function(t){t.aborted=!0;},i.prototype.unloadTile=function(t){t.unloadVectorData(),this.dispatcher.send("removeTile",{uid:t.uid,type:this.type,source:this.id},null,t.workerID);},i.prototype.onRemove=function(){this._removed=!0,this.dispatcher.send("removeSource",{type:this.type,source:this.id},null,this.workerID);},i.prototype.serialize=function(){return t.extend({},this._options,{type:this.type,data:this._data})},i.prototype.hasTransition=function(){return !1},i}(t.Evented),W=function(){this.boundProgram=null,this.boundLayoutVertexBuffer=null,this.boundPaintVertexBuffers=[],this.boundIndexBuffer=null,this.boundVertexOffset=null,this.boundDynamicVertexBuffer=null,this.vao=null;};W.prototype.bind=function(t,e,i,n,o,r,a,s){this.context=t;for(var l=this.boundPaintVertexBuffers.length!==n.length,c=0;!l&&c<n.length;c++)this.boundPaintVertexBuffers[c]!==n[c]&&(l=!0);var h=!this.vao||this.boundProgram!==e||this.boundLayoutVertexBuffer!==i||l||this.boundIndexBuffer!==o||this.boundVertexOffset!==r||this.boundDynamicVertexBuffer!==a||this.boundDynamicVertexBuffer2!==s;!t.extVertexArrayObject||h?this.freshBind(e,i,n,o,r,a,s):(t.bindVertexArrayOES.set(this.vao),a&&a.bind(),o&&o.dynamicDraw&&o.bind(),s&&s.bind());},W.prototype.freshBind=function(t,e,i,n,o,r,a){var s,l=t.numAttributes,c=this.context,h=c.gl;if(c.extVertexArrayObject)this.vao&&this.destroy(),this.vao=c.extVertexArrayObject.createVertexArrayOES(),c.bindVertexArrayOES.set(this.vao),s=0,this.boundProgram=t,this.boundLayoutVertexBuffer=e,this.boundPaintVertexBuffers=i,this.boundIndexBuffer=n,this.boundVertexOffset=o,this.boundDynamicVertexBuffer=r,this.boundDynamicVertexBuffer2=a;else{s=c.currentNumAttributes||0;for(var u=l;u<s;u++)h.disableVertexAttribArray(u);}e.enableAttributes(h,t);for(var p=0,d=i;p<d.length;p+=1){d[p].enableAttributes(h,t);}r&&r.enableAttributes(h,t),a&&a.enableAttributes(h,t),e.bind(),e.setVertexAttribPointers(h,t,o);for(var f=0,m=i;f<m.length;f+=1){var _=m[f];_.bind(),_.setVertexAttribPointers(h,t,o);}r&&(r.bind(),r.setVertexAttribPointers(h,t,o)),n&&n.bind(),a&&(a.bind(),a.setVertexAttribPointers(h,t,o)),c.currentNumAttributes=l;},W.prototype.destroy=function(){this.vao&&(this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao),this.vao=null);};var X=function(e){function i(t,i,n,o){e.call(this),this.id=t,this.dispatcher=n,this.coordinates=i.coordinates,this.type="image",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this.tiles={},this.setEventedParent(o),this.options=i;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this.url=this.options.url,t.getImage(this.map._transformRequest(this.url,t.ResourceType.Image),function(i,n){i?e.fire(new t.ErrorEvent(i)):n&&(e.image=t.browser.getImageData(n),e._finishLoading());});},i.prototype._finishLoading=function(){this.map&&(this.setCoordinates(this.coordinates),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})));},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.setCoordinates=function(e){this.coordinates=e;var i=this.map,n=e.map(function(t){return i.transform.locationCoordinate(N.convert(t)).zoomTo(0)}),o=this.centerCoord=t.getCoordinatesCenter(n);o.column=Math.floor(o.column),o.row=Math.floor(o.row),this.tileID=new t.CanonicalTileID(o.zoom,o.column,o.row),this.minzoom=this.maxzoom=o.zoom;var r=n.map(function(e){var i=e.zoomTo(o.zoom);return new t.Point(Math.round((i.column-o.column)*t.EXTENT),Math.round((i.row-o.row)*t.EXTENT))});return this._boundsArray=new t.StructArrayLayout4i8,this._boundsArray.emplaceBack(r[0].x,r[0].y,0,0),this._boundsArray.emplaceBack(r[1].x,r[1].y,t.EXTENT,0),this._boundsArray.emplaceBack(r[3].x,r[3].y,0,t.EXTENT),this._boundsArray.emplaceBack(r[2].x,r[2].y,t.EXTENT,t.EXTENT),this.boundsBuffer&&(this.boundsBuffer.destroy(),delete this.boundsBuffer),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})),this},i.prototype.prepare=function(){if(0!==Object.keys(this.tiles).length&&this.image){var e=this.map.painter.context,i=e.gl;for(var n in this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,t.rasterBoundsAttributes.members)),this.boundsVAO||(this.boundsVAO=new W),this.texture||(this.texture=new t.Texture(e,this.image,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this.tiles){var o=this.tiles[n];"loaded"!==o.state&&(o.state="loaded",o.texture=this.texture);}}},i.prototype.loadTile=function(t,e){this.tileID&&this.tileID.equals(t.tileID.canonical)?(this.tiles[String(t.tileID.wrap)]=t,t.buckets={},e(null)):(t.state="errored",e(null));},i.prototype.serialize=function(){return {type:"image",url:this.options.url,coordinates:this.coordinates}},i.prototype.hasTransition=function(){return !1},i}(t.Evented),H=function(e){function i(t,i,n,o){e.call(this,t,i,n,o),this.roundZoom=!0,this.type="video",this.options=i;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this,i=this.options;this.urls=[];for(var n=0,o=i.urls;n<o.length;n+=1){var r=o[n];e.urls.push(e.map._transformRequest(r,t.ResourceType.Source).url);}t.getVideo(this.urls,function(i,n){i?e.fire(new t.ErrorEvent(i)):n&&(e.video=n,e.video.loop=!0,e.video.addEventListener("playing",function(){e.map._rerender();}),e.map&&e.video.play(),e._finishLoading());});},i.prototype.getVideo=function(){return this.video},i.prototype.onAdd=function(t){this.map||(this.map=t,this.load(),this.video&&(this.video.play(),this.setCoordinates(this.coordinates)));},i.prototype.prepare=function(){if(!(0===Object.keys(this.tiles).length||this.video.readyState<2)){var e=this.map.painter.context,i=e.gl;for(var n in this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,t.rasterBoundsAttributes.members)),this.boundsVAO||(this.boundsVAO=new W),this.texture?this.video.paused||(this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE),i.texSubImage2D(i.TEXTURE_2D,0,0,0,i.RGBA,i.UNSIGNED_BYTE,this.video)):(this.texture=new t.Texture(e,this.video,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this.tiles){var o=this.tiles[n];"loaded"!==o.state&&(o.state="loaded",o.texture=this.texture);}}},i.prototype.serialize=function(){return {type:"video",urls:this.urls,coordinates:this.coordinates}},i.prototype.hasTransition=function(){return this.video&&!this.video.paused},i}(X),K=function(e){function i(i,n,o,r){e.call(this,i,n,o,r),n.coordinates?Array.isArray(n.coordinates)&&4===n.coordinates.length&&!n.coordinates.some(function(t){return !Array.isArray(t)||2!==t.length||t.some(function(t){return "number"!=typeof t})})||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'"coordinates" property must be an array of 4 longitude/latitude array pairs'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'missing required property "coordinates"'))),n.animate&&"boolean"!=typeof n.animate&&this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'optional "animate" property must be a boolean value'))),n.canvas?"string"==typeof n.canvas||n.canvas instanceof t.window.HTMLCanvasElement||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'missing required property "canvas"'))),this.options=n,this.animate=void 0===n.animate||n.animate;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){this.canvas||(this.canvas=this.options.canvas instanceof t.window.HTMLCanvasElement?this.options.canvas:t.window.document.getElementById(this.options.canvas)),this.width=this.canvas.width,this.height=this.canvas.height,this._hasInvalidDimensions()?this.fire(new t.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))):(this.play=function(){this._playing=!0,this.map._rerender();},this.pause=function(){this._playing=!1;},this._finishLoading());},i.prototype.getCanvas=function(){return this.canvas},i.prototype.onAdd=function(t){this.map=t,this.load(),this.canvas&&this.animate&&this.play();},i.prototype.onRemove=function(){this.pause();},i.prototype.prepare=function(){var e=!1;if(this.canvas.width!==this.width&&(this.width=this.canvas.width,e=!0),this.canvas.height!==this.height&&(this.height=this.canvas.height,e=!0),!this._hasInvalidDimensions()&&0!==Object.keys(this.tiles).length){var i=this.map.painter.context,n=i.gl;for(var o in this.boundsBuffer||(this.boundsBuffer=i.createVertexBuffer(this._boundsArray,t.rasterBoundsAttributes.members)),this.boundsVAO||(this.boundsVAO=new W),this.texture?e?this.texture.update(this.canvas):this._playing&&(this.texture.bind(n.LINEAR,n.CLAMP_TO_EDGE),n.texSubImage2D(n.TEXTURE_2D,0,0,0,n.RGBA,n.UNSIGNED_BYTE,this.canvas)):(this.texture=new t.Texture(i,this.canvas,n.RGBA),this.texture.bind(n.LINEAR,n.CLAMP_TO_EDGE)),this.tiles){var r=this.tiles[o];"loaded"!==r.state&&(r.state="loaded",r.texture=this.texture);}}},i.prototype.serialize=function(){return {type:"canvas",coordinates:this.coordinates}},i.prototype.hasTransition=function(){return this._playing},i.prototype._hasInvalidDimensions=function(){for(var t=0,e=[this.canvas.width,this.canvas.height];t<e.length;t+=1){var i=e[t];if(isNaN(i)||i<=0)return !0}return !1},i}(X),Y={vector:Z,raster:j,"raster-dem":q,geojson:G,video:H,image:X,canvas:K},J=function(e,i,n,o){var r=new Y[i.type](e,i,n,o);if(r.id!==e)throw new Error("Expected Source id to be "+e+" instead of "+r.id);return t.bindAll(["load","abort","unload","serialize","prepare"],r),r};function Q(t,e,i,n,o){var r=o.maxPitchScaleFactor(),a=t.tilesIn(i,r);a.sort($);for(var s=[],l=0,c=a;l<c.length;l+=1){var h=c[l];s.push({wrappedTileID:h.tileID.wrapped().key,queryResults:h.tile.queryRenderedFeatures(e,t._state,h.queryGeometry,h.scale,n,o,r,t.transform.calculatePosMatrix(h.tileID.toUnwrapped()))});}var u=function(t){for(var e={},i={},n=0,o=t;n<o.length;n+=1){var r=o[n],a=r.queryResults,s=r.wrappedTileID,l=i[s]=i[s]||{};for(var c in a)for(var h=a[c],u=l[c]=l[c]||{},p=e[c]=e[c]||[],d=0,f=h;d<f.length;d+=1){var m=f[d];u[m.featureIndex]||(u[m.featureIndex]=!0,p.push(m.feature));}}return e}(s);for(var p in u)u[p].forEach(function(e){var i=t.getFeatureState(e.layer["source-layer"],e.id);e.source=e.layer.source,e.layer["source-layer"]&&(e.sourceLayer=e.layer["source-layer"]),e.state=i;});return u}function $(t,e){var i=t.tileID,n=e.tileID;return i.overscaledZ-n.overscaledZ||i.canonical.y-n.canonical.y||i.wrap-n.wrap||i.canonical.x-n.canonical.x}var tt=function(t,e){this.max=t,this.onRemove=e,this.reset();};tt.prototype.reset=function(){for(var t in this.data)for(var e=0,i=this.data[t];e<i.length;e+=1){var n=i[e];n.timeout&&clearTimeout(n.timeout),this.onRemove(n.value);}return this.data={},this.order=[],this},tt.prototype.add=function(t,e,i){var n=this,o=t.wrapped().key;void 0===this.data[o]&&(this.data[o]=[]);var r={value:e,timeout:void 0};if(void 0!==i&&(r.timeout=setTimeout(function(){n.remove(t,r);},i)),this.data[o].push(r),this.order.push(o),this.order.length>this.max){var a=this._getAndRemoveByKey(this.order[0]);a&&this.onRemove(a);}return this},tt.prototype.has=function(t){return t.wrapped().key in this.data},tt.prototype.getAndRemove=function(t){return this.has(t)?this._getAndRemoveByKey(t.wrapped().key):null},tt.prototype._getAndRemoveByKey=function(t){var e=this.data[t].shift();return e.timeout&&clearTimeout(e.timeout),0===this.data[t].length&&delete this.data[t],this.order.splice(this.order.indexOf(t),1),e.value},tt.prototype.get=function(t){return this.has(t)?this.data[t.wrapped().key][0].value:null},tt.prototype.remove=function(t,e){if(!this.has(t))return this;var i=t.wrapped().key,n=void 0===e?0:this.data[i].indexOf(e),o=this.data[i][n];return this.data[i].splice(n,1),o.timeout&&clearTimeout(o.timeout),0===this.data[i].length&&delete this.data[i],this.onRemove(o.value),this.order.splice(this.order.indexOf(i),1),this},tt.prototype.setMaxSize=function(t){for(this.max=t;this.order.length>this.max;){var e=this._getAndRemoveByKey(this.order[0]);e&&this.onRemove(e);}return this};var et=function(t,e,i){this.context=t;var n=t.gl;this.buffer=n.createBuffer(),this.dynamicDraw=Boolean(i),this.unbindVAO(),t.bindElementBuffer.set(this.buffer),n.bufferData(n.ELEMENT_ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?n.DYNAMIC_DRAW:n.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer;};et.prototype.unbindVAO=function(){this.context.extVertexArrayObject&&this.context.bindVertexArrayOES.set(null);},et.prototype.bind=function(){this.context.bindElementBuffer.set(this.buffer);},et.prototype.updateData=function(t){var e=this.context.gl;this.unbindVAO(),this.bind(),e.bufferSubData(e.ELEMENT_ARRAY_BUFFER,0,t.arrayBuffer);},et.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer);};var it={Int8:"BYTE",Uint8:"UNSIGNED_BYTE",Int16:"SHORT",Uint16:"UNSIGNED_SHORT",Int32:"INT",Uint32:"UNSIGNED_INT",Float32:"FLOAT"},nt=function(t,e,i,n){this.length=e.length,this.attributes=i,this.itemSize=e.bytesPerElement,this.dynamicDraw=n,this.context=t;var o=t.gl;this.buffer=o.createBuffer(),t.bindVertexBuffer.set(this.buffer),o.bufferData(o.ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?o.DYNAMIC_DRAW:o.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer;};nt.prototype.bind=function(){this.context.bindVertexBuffer.set(this.buffer);},nt.prototype.updateData=function(t){var e=this.context.gl;this.bind(),e.bufferSubData(e.ARRAY_BUFFER,0,t.arrayBuffer);},nt.prototype.enableAttributes=function(t,e){for(var i=0;i<this.attributes.length;i++){var n=this.attributes[i],o=e.attributes[n.name];void 0!==o&&t.enableVertexAttribArray(o);}},nt.prototype.setVertexAttribPointers=function(t,e,i){for(var n=0;n<this.attributes.length;n++){var o=this.attributes[n],r=e.attributes[o.name];void 0!==r&&t.vertexAttribPointer(r,o.components,t[it[o.type]],!1,this.itemSize,o.offset+this.itemSize*(i||0));}},nt.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer);};var ot=function(e){this.context=e,this.current=t.Color.transparent;};ot.prototype.get=function(){return this.current},ot.prototype.set=function(t){var e=this.current;t.r===e.r&&t.g===e.g&&t.b===e.b&&t.a===e.a||(this.context.gl.clearColor(t.r,t.g,t.b,t.a),this.current=t);};var rt=function(t){this.context=t,this.current=1;};rt.prototype.get=function(){return this.current},rt.prototype.set=function(t){this.current!==t&&(this.context.gl.clearDepth(t),this.current=t);};var at=function(t){this.context=t,this.current=0;};at.prototype.get=function(){return this.current},at.prototype.set=function(t){this.current!==t&&(this.context.gl.clearStencil(t),this.current=t);};var st=function(t){this.context=t,this.current=[!0,!0,!0,!0];};st.prototype.get=function(){return this.current},st.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]&&t[3]===e[3]||(this.context.gl.colorMask(t[0],t[1],t[2],t[3]),this.current=t);};var lt=function(t){this.context=t,this.current=!0;};lt.prototype.get=function(){return this.current},lt.prototype.set=function(t){this.current!==t&&(this.context.gl.depthMask(t),this.current=t);};var ct=function(t){this.context=t,this.current=255;};ct.prototype.get=function(){return this.current},ct.prototype.set=function(t){this.current!==t&&(this.context.gl.stencilMask(t),this.current=t);};var ht=function(t){this.context=t,this.current={func:t.gl.ALWAYS,ref:0,mask:255};};ht.prototype.get=function(){return this.current},ht.prototype.set=function(t){var e=this.current;t.func===e.func&&t.ref===e.ref&&t.mask===e.mask||(this.context.gl.stencilFunc(t.func,t.ref,t.mask),this.current=t);};var ut=function(t){this.context=t;var e=this.context.gl;this.current=[e.KEEP,e.KEEP,e.KEEP];};ut.prototype.get=function(){return this.current},ut.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]||(this.context.gl.stencilOp(t[0],t[1],t[2]),this.current=t);};var pt=function(t){this.context=t,this.current=!1;};pt.prototype.get=function(){return this.current},pt.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;t?e.enable(e.STENCIL_TEST):e.disable(e.STENCIL_TEST),this.current=t;}};var dt=function(t){this.context=t,this.current=[0,1];};dt.prototype.get=function(){return this.current},dt.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]||(this.context.gl.depthRange(t[0],t[1]),this.current=t);};var ft=function(t){this.context=t,this.current=!1;};ft.prototype.get=function(){return this.current},ft.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;t?e.enable(e.DEPTH_TEST):e.disable(e.DEPTH_TEST),this.current=t;}};var mt=function(t){this.context=t,this.current=t.gl.LESS;};mt.prototype.get=function(){return this.current},mt.prototype.set=function(t){this.current!==t&&(this.context.gl.depthFunc(t),this.current=t);};var _t=function(t){this.context=t,this.current=!1;};_t.prototype.get=function(){return this.current},_t.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;t?e.enable(e.BLEND):e.disable(e.BLEND),this.current=t;}};var gt=function(t){this.context=t;var e=this.context.gl;this.current=[e.ONE,e.ZERO];};gt.prototype.get=function(){return this.current},gt.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]||(this.context.gl.blendFunc(t[0],t[1]),this.current=t);};var vt=function(e){this.context=e,this.current=t.Color.transparent;};vt.prototype.get=function(){return this.current},vt.prototype.set=function(t){var e=this.current;t.r===e.r&&t.g===e.g&&t.b===e.b&&t.a===e.a||(this.context.gl.blendColor(t.r,t.g,t.b,t.a),this.current=t);};var yt=function(t){this.context=t,this.current=null;};yt.prototype.get=function(){return this.current},yt.prototype.set=function(t){this.current!==t&&(this.context.gl.useProgram(t),this.current=t);};var xt=function(t){this.context=t,this.current=t.gl.TEXTURE0;};xt.prototype.get=function(){return this.current},xt.prototype.set=function(t){this.current!==t&&(this.context.gl.activeTexture(t),this.current=t);};var bt=function(t){this.context=t;var e=this.context.gl;this.current=[0,0,e.drawingBufferWidth,e.drawingBufferHeight];};bt.prototype.get=function(){return this.current},bt.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]&&t[3]===e[3]||(this.context.gl.viewport(t[0],t[1],t[2],t[3]),this.current=t);};var wt=function(t){this.context=t,this.current=null;};wt.prototype.get=function(){return this.current},wt.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.bindFramebuffer(e.FRAMEBUFFER,t),this.current=t;}};var Et=function(t){this.context=t,this.current=null;};Et.prototype.get=function(){return this.current},Et.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.bindRenderbuffer(e.RENDERBUFFER,t),this.current=t;}};var Tt=function(t){this.context=t,this.current=null;};Tt.prototype.get=function(){return this.current},Tt.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.bindTexture(e.TEXTURE_2D,t),this.current=t;}};var It=function(t){this.context=t,this.current=null;};It.prototype.get=function(){return this.current},It.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.bindBuffer(e.ARRAY_BUFFER,t),this.current=t;}};var St=function(t){this.context=t,this.current=null;};St.prototype.get=function(){return this.current},St.prototype.set=function(t){var e=this.context.gl;e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,t),this.current=t;};var Ct=function(t){this.context=t,this.current=null;};Ct.prototype.get=function(){return this.current},Ct.prototype.set=function(t){this.current!==t&&this.context.extVertexArrayObject&&(this.context.extVertexArrayObject.bindVertexArrayOES(t),this.current=t);};var zt=function(t){this.context=t,this.current=4;};zt.prototype.get=function(){return this.current},zt.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.pixelStorei(e.UNPACK_ALIGNMENT,t),this.current=t;}};var Pt=function(t){this.context=t,this.current=!1;};Pt.prototype.get=function(){return this.current},Pt.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,t),this.current=t;}};var At=function(t,e){this.context=t,this.current=null,this.parent=e;};At.prototype.get=function(){return this.current};var Dt=function(t){function e(e,i){t.call(this,e,i),this.dirty=!1;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){if(this.dirty||this.current!==t){var e=this.context.gl;this.context.bindFramebuffer.set(this.parent),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0),this.current=t,this.dirty=!1;}},e.prototype.setDirty=function(){this.dirty=!0;},e}(At),Rt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;this.context.bindFramebuffer.set(this.parent),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.RENDERBUFFER,t),this.current=t;}},e}(At),Mt=function(t,e,i){this.context=t,this.width=e,this.height=i;var n=t.gl,o=this.framebuffer=n.createFramebuffer();this.colorAttachment=new Dt(t,o),this.depthAttachment=new Rt(t,o);};Mt.prototype.destroy=function(){var t=this.context.gl,e=this.colorAttachment.get();e&&t.deleteTexture(e);var i=this.depthAttachment.get();i&&t.deleteRenderbuffer(i),t.deleteFramebuffer(this.framebuffer);};var Lt=function(t,e,i){this.func=t,this.mask=e,this.range=i;};Lt.ReadOnly=!1,Lt.ReadWrite=!0,Lt.disabled=new Lt(519,Lt.ReadOnly,[0,1]);var kt=function(t,e,i,n,o,r){this.test=t,this.ref=e,this.mask=i,this.fail=n,this.depthFail=o,this.pass=r;};kt.disabled=new kt({func:519,mask:0},0,0,7680,7680,7680);var Bt=function(t,e,i){this.blendFunction=t,this.blendColor=e,this.mask=i;};Bt.Replace=[1,0],Bt.disabled=new Bt(Bt.Replace,t.Color.transparent,[!1,!1,!1,!1]),Bt.unblended=new Bt(Bt.Replace,t.Color.transparent,[!0,!0,!0,!0]),Bt.alphaBlended=new Bt([1,771],t.Color.transparent,[!0,!0,!0,!0]);var Ot=function(t){this.gl=t,this.extVertexArrayObject=this.gl.getExtension("OES_vertex_array_object"),this.clearColor=new ot(this),this.clearDepth=new rt(this),this.clearStencil=new at(this),this.colorMask=new st(this),this.depthMask=new lt(this),this.stencilMask=new ct(this),this.stencilFunc=new ht(this),this.stencilOp=new ut(this),this.stencilTest=new pt(this),this.depthRange=new dt(this),this.depthTest=new ft(this),this.depthFunc=new mt(this),this.blend=new _t(this),this.blendFunc=new gt(this),this.blendColor=new vt(this),this.program=new yt(this),this.activeTexture=new xt(this),this.viewport=new bt(this),this.bindFramebuffer=new wt(this),this.bindRenderbuffer=new Et(this),this.bindTexture=new Tt(this),this.bindVertexBuffer=new It(this),this.bindElementBuffer=new St(this),this.bindVertexArrayOES=this.extVertexArrayObject&&new Ct(this),this.pixelStoreUnpack=new zt(this),this.pixelStoreUnpackPremultiplyAlpha=new Pt(this),this.extTextureFilterAnisotropic=t.getExtension("EXT_texture_filter_anisotropic")||t.getExtension("MOZ_EXT_texture_filter_anisotropic")||t.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.extTextureFilterAnisotropic&&(this.extTextureFilterAnisotropicMax=t.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),this.extTextureHalfFloat=t.getExtension("OES_texture_half_float"),this.extTextureHalfFloat&&t.getExtension("OES_texture_half_float_linear");};Ot.prototype.createIndexBuffer=function(t,e){return new et(this,t,e)},Ot.prototype.createVertexBuffer=function(t,e,i){return new nt(this,t,e,i)},Ot.prototype.createRenderbuffer=function(t,e,i){var n=this.gl,o=n.createRenderbuffer();return this.bindRenderbuffer.set(o),n.renderbufferStorage(n.RENDERBUFFER,t,e,i),this.bindRenderbuffer.set(null),o},Ot.prototype.createFramebuffer=function(t,e){return new Mt(this,t,e)},Ot.prototype.clear=function(t){var e=t.color,i=t.depth,n=this.gl,o=0;e&&(o|=n.COLOR_BUFFER_BIT,this.clearColor.set(e),this.colorMask.set([!0,!0,!0,!0])),void 0!==i&&(o|=n.DEPTH_BUFFER_BIT,this.clearDepth.set(i),this.depthMask.set(!0)),n.clear(o);},Ot.prototype.setDepthMode=function(t){t.func!==this.gl.ALWAYS||t.mask?(this.depthTest.set(!0),this.depthFunc.set(t.func),this.depthMask.set(t.mask),this.depthRange.set(t.range)):this.depthTest.set(!1);},Ot.prototype.setStencilMode=function(t){t.test.func!==this.gl.ALWAYS||t.mask?(this.stencilTest.set(!0),this.stencilMask.set(t.mask),this.stencilOp.set([t.fail,t.depthFail,t.pass]),this.stencilFunc.set({func:t.test.func,ref:t.ref,mask:t.test.mask})):this.stencilTest.set(!1);},Ot.prototype.setColorMode=function(e){t.deepEqual(e.blendFunction,Bt.Replace)?this.blend.set(!1):(this.blend.set(!0),this.blendFunc.set(e.blendFunction),this.blendColor.set(e.blendColor)),this.colorMask.set(e.mask);};var Ft=function(e){function i(i,n,o){var r=this;e.call(this),this.id=i,this.dispatcher=o,this.on("data",function(t){"source"===t.dataType&&"metadata"===t.sourceDataType&&(r._sourceLoaded=!0),r._sourceLoaded&&!r._paused&&"source"===t.dataType&&"content"===t.sourceDataType&&(r.reload(),r.transform&&r.update(r.transform));}),this.on("error",function(){r._sourceErrored=!0;}),this._source=J(i,n,o,this),this._tiles={},this._cache=new tt(0,this._unloadTile.bind(this)),this._timers={},this._cacheTimers={},this._maxTileCacheSize=null,this._coveredTiles={},this._state=new t.SourceFeatureState;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.onAdd=function(t){this.map=t,this._maxTileCacheSize=t?t._maxTileCacheSize:null,this._source&&this._source.onAdd&&this._source.onAdd(t);},i.prototype.onRemove=function(t){this._source&&this._source.onRemove&&this._source.onRemove(t);},i.prototype.loaded=function(){if(this._sourceErrored)return !0;if(!this._sourceLoaded)return !1;for(var t in this._tiles){var e=this._tiles[t];if("loaded"!==e.state&&"errored"!==e.state)return !1}return !0},i.prototype.getSource=function(){return this._source},i.prototype.pause=function(){this._paused=!0;},i.prototype.resume=function(){if(this._paused){var t=this._shouldReloadOnResume;this._paused=!1,this._shouldReloadOnResume=!1,t&&this.reload(),this.transform&&this.update(this.transform);}},i.prototype._loadTile=function(t,e){return this._source.loadTile(t,e)},i.prototype._unloadTile=function(t){if(this._source.unloadTile)return this._source.unloadTile(t,function(){})},i.prototype._abortTile=function(t){if(this._source.abortTile)return this._source.abortTile(t,function(){})},i.prototype.serialize=function(){return this._source.serialize()},i.prototype.prepare=function(t){for(var e in this._source.prepare&&this._source.prepare(),this._state.coalesceChanges(this._tiles,this.map?this.map.painter:null),this._tiles)this._tiles[e].upload(t);},i.prototype.getIds=function(){return Object.keys(this._tiles).map(Number).sort(Ut)},i.prototype.getRenderableIds=function(e){var i=this,n=[];for(var o in i._tiles)i._isIdRenderable(+o,e)&&n.push(+o);return e?n.sort(function(e,n){var o=i._tiles[e].tileID,r=i._tiles[n].tileID,a=new t.Point(o.canonical.x,o.canonical.y)._rotate(i.transform.angle),s=new t.Point(r.canonical.x,r.canonical.y)._rotate(i.transform.angle);return o.overscaledZ-r.overscaledZ||s.y-a.y||s.x-a.x}):n.sort(Ut)},i.prototype.hasRenderableParent=function(t){var e=this.findLoadedParent(t,0);return !!e&&this._isIdRenderable(e.tileID.key)},i.prototype._isIdRenderable=function(t,e){return this._tiles[t]&&this._tiles[t].hasData()&&!this._coveredTiles[t]&&(e||!this._tiles[t].holdingForFade())},i.prototype.reload=function(){if(this._paused)this._shouldReloadOnResume=!0;else for(var t in this._cache.reset(),this._tiles)"errored"!==this._tiles[t].state&&this._reloadTile(t,"reloading");},i.prototype._reloadTile=function(t,e){var i=this._tiles[t];i&&("loading"!==i.state&&(i.state=e),this._loadTile(i,this._tileLoaded.bind(this,i,t,e)));},i.prototype._tileLoaded=function(e,i,n,o){if(o)return e.state="errored",void(404!==o.status?this._source.fire(new t.ErrorEvent(o,{tile:e})):this.update(this.transform));e.timeAdded=t.browser.now(),"expired"===n&&(e.refreshedUponExpiration=!0),this._setTileReloadTimer(i,e),"raster-dem"===this.getSource().type&&e.dem&&this._backfillDEM(e),this._state.initializeTileState(e,this.map?this.map.painter:null),this._source.fire(new t.Event("data",{dataType:"source",tile:e,coord:e.tileID})),this.map&&(this.map.painter.tileExtentVAO.vao=null);},i.prototype._backfillDEM=function(t){for(var e=this.getRenderableIds(),i=0;i<e.length;i++){var n=e[i];if(t.neighboringTiles&&t.neighboringTiles[n]){var o=this.getTileByID(n);r(t,o),r(o,t);}}function r(t,e){t.needsHillshadePrepare=!0;var i=e.tileID.canonical.x-t.tileID.canonical.x,n=e.tileID.canonical.y-t.tileID.canonical.y,o=Math.pow(2,t.tileID.canonical.z),r=e.tileID.key;0===i&&0===n||Math.abs(n)>1||(Math.abs(i)>1&&(1===Math.abs(i+o)?i+=o:1===Math.abs(i-o)&&(i-=o)),e.dem&&t.dem&&(t.dem.backfillBorder(e.dem,i,n),t.neighboringTiles&&t.neighboringTiles[r]&&(t.neighboringTiles[r].backfilled=!0)));}},i.prototype.getTile=function(t){return this.getTileByID(t.key)},i.prototype.getTileByID=function(t){return this._tiles[t]},i.prototype.getZoom=function(t){return t.zoom+t.scaleZoom(t.tileSize/this._source.tileSize)},i.prototype._retainLoadedChildren=function(t,e,i,n){for(var o in this._tiles){var r=this._tiles[o];if(!(n[o]||!r.hasData()||r.tileID.overscaledZ<=e||r.tileID.overscaledZ>i)){for(var a=r.tileID;r&&r.tileID.overscaledZ>e+1;){var s=r.tileID.scaledTo(r.tileID.overscaledZ-1);(r=this._tiles[s.key])&&r.hasData()&&(a=s);}for(var l=a;l.overscaledZ>e;)if(t[(l=l.scaledTo(l.overscaledZ-1)).key]){n[a.key]=a;break}}}},i.prototype.findLoadedParent=function(t,e){for(var i=t.overscaledZ-1;i>=e;i--){var n=t.scaledTo(i);if(!n)return;var o=String(n.key),r=this._tiles[o];if(r&&r.hasData())return r;if(this._cache.has(n))return this._cache.get(n)}},i.prototype.updateCacheSize=function(t){var e=(Math.ceil(t.width/this._source.tileSize)+1)*(Math.ceil(t.height/this._source.tileSize)+1),i=Math.floor(5*e),n="number"==typeof this._maxTileCacheSize?Math.min(this._maxTileCacheSize,i):i;this._cache.setMaxSize(n);},i.prototype.handleWrapJump=function(t){var e=(t-(void 0===this._prevLng?t:this._prevLng))/360,i=Math.round(e);if(this._prevLng=t,i){var n={};for(var o in this._tiles){var r=this._tiles[o];r.tileID=r.tileID.unwrapTo(r.tileID.wrap+i),n[r.tileID.key]=r;}for(var a in this._tiles=n,this._timers)clearTimeout(this._timers[a]),delete this._timers[a];for(var s in this._tiles){var l=this._tiles[s];this._setTileReloadTimer(s,l);}}},i.prototype.update=function(e){var n=this;if(this.transform=e,this._sourceLoaded&&!this._paused){var o;this.updateCacheSize(e),this.handleWrapJump(this.transform.center.lng),this._coveredTiles={},this.used?this._source.tileID?o=e.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(e){return new t.OverscaledTileID(e.canonical.z,e.wrap,e.canonical.z,e.canonical.x,e.canonical.y)}):(o=e.coveringTiles({tileSize:this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom,reparseOverscaled:this._source.reparseOverscaled}),this._source.hasTile&&(o=o.filter(function(t){return n._source.hasTile(t)}))):o=[];var r=(this._source.roundZoom?Math.round:Math.floor)(this.getZoom(e)),a=Math.max(r-i.maxOverzooming,this._source.minzoom),s=Math.max(r+i.maxUnderzooming,this._source.minzoom),l=this._updateRetainedTiles(o,r);if(Vt(this._source.type)){for(var c={},h={},u=0,p=Object.keys(l);u<p.length;u+=1){var d=p[u],f=l[d],m=n._tiles[d];if(m&&!(m.fadeEndTime&&m.fadeEndTime<=t.browser.now())){var _=n.findLoadedParent(f,a);_&&(n._addTile(_.tileID),c[_.tileID.key]=_.tileID),h[d]=f;}}for(var g in this._retainLoadedChildren(h,r,s,l),c)l[g]||(n._coveredTiles[g]=!0,l[g]=c[g]);}for(var v in l)n._tiles[v].clearFadeHold();for(var y=0,x=t.keysDifference(this._tiles,l);y<x.length;y+=1){var b=x[y],w=n._tiles[b];w.hasSymbolBuckets&&!w.holdingForFade()?w.setHoldDuration(n.map._fadeDuration):w.hasSymbolBuckets&&!w.symbolFadeFinished()||n._removeTile(b);}}},i.prototype.releaseSymbolFadeTiles=function(){for(var t in this._tiles)this._tiles[t].holdingForFade()&&this._removeTile(t);},i.prototype._updateRetainedTiles=function(t,e){for(var n={},o={},r=Math.max(e-i.maxOverzooming,this._source.minzoom),a=Math.max(e+i.maxUnderzooming,this._source.minzoom),s={},l=0,c=t;l<c.length;l+=1){var h=c[l],u=this._addTile(h);n[h.key]=h,u.hasData()||e<this._source.maxzoom&&(s[h.key]=h);}this._retainLoadedChildren(s,e,a,n);for(var p=0,d=t;p<d.length;p+=1){var f=d[p],m=this._tiles[f.key];if(!m.hasData()){if(e+1>this._source.maxzoom){var _=f.children(this._source.maxzoom)[0],g=this.getTile(_);if(g&&g.hasData()){n[_.key]=_;continue}}else{var v=f.children(this._source.maxzoom);if(n[v[0].key]&&n[v[1].key]&&n[v[2].key]&&n[v[3].key])continue}for(var y=m.wasRequested(),x=f.overscaledZ-1;x>=r;--x){var b=f.scaledTo(x);if(o[b.key])break;if(o[b.key]=!0,!(m=this.getTile(b))&&y&&(m=this._addTile(b)),m&&(n[b.key]=b,y=m.wasRequested(),m.hasData()))break}}}return n},i.prototype._addTile=function(e){var i=this._tiles[e.key];if(i)return i;(i=this._cache.getAndRemove(e))&&(this._setTileReloadTimer(e.key,i),i.tileID=e,this._state.initializeTileState(i,this.map?this.map.painter:null),this._cacheTimers[e.key]&&(clearTimeout(this._cacheTimers[e.key]),delete this._cacheTimers[e.key],this._setTileReloadTimer(e.key,i)));var n=Boolean(i);return n||(i=new t.Tile(e,this._source.tileSize*e.overscaleFactor()),this._loadTile(i,this._tileLoaded.bind(this,i,e.key,i.state))),i?(i.uses++,this._tiles[e.key]=i,n||this._source.fire(new t.Event("dataloading",{tile:i,coord:i.tileID,dataType:"source"})),i):null},i.prototype._setTileReloadTimer=function(t,e){var i=this;t in this._timers&&(clearTimeout(this._timers[t]),delete this._timers[t]);var n=e.getExpiryTimeout();n&&(this._timers[t]=setTimeout(function(){i._reloadTile(t,"expired"),delete i._timers[t];},n));},i.prototype._removeTile=function(t){var e=this._tiles[t];e&&(e.uses--,delete this._tiles[t],this._timers[t]&&(clearTimeout(this._timers[t]),delete this._timers[t]),e.uses>0||(e.hasData()?this._cache.add(e.tileID,e,e.getExpiryTimeout()):(e.aborted=!0,this._abortTile(e),this._unloadTile(e))));},i.prototype.clearTiles=function(){for(var t in this._shouldReloadOnResume=!1,this._paused=!1,this._tiles)this._removeTile(t);this._cache.reset();},i.prototype.tilesIn=function(e,i){for(var n=[],o=this.getIds(),r=1/0,a=1/0,s=-1/0,l=-1/0,c=e[0].zoom,h=0;h<e.length;h++){var u=e[h];r=Math.min(r,u.column),a=Math.min(a,u.row),s=Math.max(s,u.column),l=Math.max(l,u.row);}for(var p=0;p<o.length;p++){var d=this._tiles[o[p]];if(!d.holdingForFade()){var f=d.tileID,m=Math.pow(2,this.transform.zoom-d.tileID.overscaledZ),_=i*d.queryPadding*t.EXTENT/d.tileSize/m,g=[Nt(f,new t.Coordinate(r,a,c)),Nt(f,new t.Coordinate(s,l,c))];if(g[0].x-_<t.EXTENT&&g[0].y-_<t.EXTENT&&g[1].x+_>=0&&g[1].y+_>=0){for(var v=[],y=0;y<e.length;y++)v.push(Nt(f,e[y]));n.push({tile:d,tileID:f,queryGeometry:[v],scale:m});}}}return n},i.prototype.getVisibleCoordinates=function(t){for(var e=this,i=this.getRenderableIds(t).map(function(t){return e._tiles[t].tileID}),n=0,o=i;n<o.length;n+=1){var r=o[n];r.posMatrix=e.transform.calculatePosMatrix(r.toUnwrapped());}return i},i.prototype.hasTransition=function(){if(this._source.hasTransition())return !0;if(Vt(this._source.type))for(var e in this._tiles){var i=this._tiles[e];if(void 0!==i.fadeEndTime&&i.fadeEndTime>=t.browser.now())return !0}return !1},i.prototype.setFeatureState=function(t,e,i){t=t||"_geojsonTileLayer",this._state.updateState(t,e,i);},i.prototype.getFeatureState=function(t,e){return t=t||"_geojsonTileLayer",this._state.getState(t,e)},i}(t.Evented);function Nt(e,i){var n=i.zoomTo(e.canonical.z);return new t.Point((n.column-(e.canonical.x+e.wrap*Math.pow(2,e.canonical.z)))*t.EXTENT,(n.row-e.canonical.y)*t.EXTENT)}function Ut(t,e){return t%32-e%32||e-t}function Vt(t){return "raster"===t||"image"===t||"video"===t}function Zt(){return new t.window.Worker(_n.workerUrl)}Ft.maxOverzooming=10,Ft.maxUnderzooming=3;var jt,qt=function(){this.active={};};function Gt(e,i){var n={};for(var o in e)"ref"!==o&&(n[o]=e[o]);return t.refProperties.forEach(function(t){t in i&&(n[t]=i[t]);}),n}function Wt(t){t=t.slice();for(var e=Object.create(null),i=0;i<t.length;i++)e[t[i].id]=t[i];for(var n=0;n<t.length;n++)"ref"in t[n]&&(t[n]=Gt(t[n],e[t[n].ref]));return t}qt.prototype.acquire=function(t){if(!this.workers)for(this.workers=[];this.workers.length<qt.workerCount;)this.workers.push(new Zt);return this.active[t]=!0,this.workers.slice()},qt.prototype.release=function(t){delete this.active[t],0===Object.keys(this.active).length&&(this.workers.forEach(function(t){t.terminate();}),this.workers=null);},qt.workerCount=Math.max(Math.floor(t.browser.hardwareConcurrency/2),1);var Xt={setStyle:"setStyle",addLayer:"addLayer",removeLayer:"removeLayer",setPaintProperty:"setPaintProperty",setLayoutProperty:"setLayoutProperty",setFilter:"setFilter",addSource:"addSource",removeSource:"removeSource",setGeoJSONSourceData:"setGeoJSONSourceData",setLayerZoomRange:"setLayerZoomRange",setLayerProperty:"setLayerProperty",setCenter:"setCenter",setZoom:"setZoom",setBearing:"setBearing",setPitch:"setPitch",setSprite:"setSprite",setGlyphs:"setGlyphs",setTransition:"setTransition",setLight:"setLight"};function Ht(t,e,i){i.push({command:Xt.addSource,args:[t,e[t]]});}function Kt(t,e,i){e.push({command:Xt.removeSource,args:[t]}),i[t]=!0;}function Yt(t,e,i,n){Kt(t,i,n),Ht(t,e,i);}function Jt(e,i,n){var o;for(o in e[n])if(e[n].hasOwnProperty(o)&&"data"!==o&&!t.deepEqual(e[n][o],i[n][o]))return !1;for(o in i[n])if(i[n].hasOwnProperty(o)&&"data"!==o&&!t.deepEqual(e[n][o],i[n][o]))return !1;return !0}function Qt(e,i,n,o,r,a){var s;for(s in i=i||{},e=e||{})e.hasOwnProperty(s)&&(t.deepEqual(e[s],i[s])||n.push({command:a,args:[o,s,i[s],r]}));for(s in i)i.hasOwnProperty(s)&&!e.hasOwnProperty(s)&&(t.deepEqual(e[s],i[s])||n.push({command:a,args:[o,s,i[s],r]}));}function $t(t){return t.id}function te(t,e){return t[e.id]=e,t}function ee(e,i){if(!e)return [{command:Xt.setStyle,args:[i]}];var n=[];try{if(!t.deepEqual(e.version,i.version))return [{command:Xt.setStyle,args:[i]}];t.deepEqual(e.center,i.center)||n.push({command:Xt.setCenter,args:[i.center]}),t.deepEqual(e.zoom,i.zoom)||n.push({command:Xt.setZoom,args:[i.zoom]}),t.deepEqual(e.bearing,i.bearing)||n.push({command:Xt.setBearing,args:[i.bearing]}),t.deepEqual(e.pitch,i.pitch)||n.push({command:Xt.setPitch,args:[i.pitch]}),t.deepEqual(e.sprite,i.sprite)||n.push({command:Xt.setSprite,args:[i.sprite]}),t.deepEqual(e.glyphs,i.glyphs)||n.push({command:Xt.setGlyphs,args:[i.glyphs]}),t.deepEqual(e.transition,i.transition)||n.push({command:Xt.setTransition,args:[i.transition]}),t.deepEqual(e.light,i.light)||n.push({command:Xt.setLight,args:[i.light]});var o={},r=[];!function(e,i,n,o){var r;for(r in i=i||{},e=e||{})e.hasOwnProperty(r)&&(i.hasOwnProperty(r)||Kt(r,n,o));for(r in i)i.hasOwnProperty(r)&&(e.hasOwnProperty(r)?t.deepEqual(e[r],i[r])||("geojson"===e[r].type&&"geojson"===i[r].type&&Jt(e,i,r)?n.push({command:Xt.setGeoJSONSourceData,args:[r,i[r].data]}):Yt(r,i,n,o)):Ht(r,i,n));}(e.sources,i.sources,r,o);var a=[];e.layers&&e.layers.forEach(function(t){o[t.source]?n.push({command:Xt.removeLayer,args:[t.id]}):a.push(t);}),n=n.concat(r),function(e,i,n){i=i||[];var o,r,a,s,l,c,h,u=(e=e||[]).map($t),p=i.map($t),d=e.reduce(te,{}),f=i.reduce(te,{}),m=u.slice(),_=Object.create(null);for(o=0,r=0;o<u.length;o++)a=u[o],f.hasOwnProperty(a)?r++:(n.push({command:Xt.removeLayer,args:[a]}),m.splice(m.indexOf(a,r),1));for(o=0,r=0;o<p.length;o++)a=p[p.length-1-o],m[m.length-1-o]!==a&&(d.hasOwnProperty(a)?(n.push({command:Xt.removeLayer,args:[a]}),m.splice(m.lastIndexOf(a,m.length-r),1)):r++,c=m[m.length-o],n.push({command:Xt.addLayer,args:[f[a],c]}),m.splice(m.length-o,0,a),_[a]=!0);for(o=0;o<p.length;o++)if(s=d[a=p[o]],l=f[a],!_[a]&&!t.deepEqual(s,l))if(t.deepEqual(s.source,l.source)&&t.deepEqual(s["source-layer"],l["source-layer"])&&t.deepEqual(s.type,l.type)){for(h in Qt(s.layout,l.layout,n,a,null,Xt.setLayoutProperty),Qt(s.paint,l.paint,n,a,null,Xt.setPaintProperty),t.deepEqual(s.filter,l.filter)||n.push({command:Xt.setFilter,args:[a,l.filter]}),t.deepEqual(s.minzoom,l.minzoom)&&t.deepEqual(s.maxzoom,l.maxzoom)||n.push({command:Xt.setLayerZoomRange,args:[a,l.minzoom,l.maxzoom]}),s)s.hasOwnProperty(h)&&"layout"!==h&&"paint"!==h&&"filter"!==h&&"metadata"!==h&&"minzoom"!==h&&"maxzoom"!==h&&(0===h.indexOf("paint.")?Qt(s[h],l[h],n,a,h.slice(6),Xt.setPaintProperty):t.deepEqual(s[h],l[h])||n.push({command:Xt.setLayerProperty,args:[a,h,l[h]]}));for(h in l)l.hasOwnProperty(h)&&!s.hasOwnProperty(h)&&"layout"!==h&&"paint"!==h&&"filter"!==h&&"metadata"!==h&&"minzoom"!==h&&"maxzoom"!==h&&(0===h.indexOf("paint.")?Qt(s[h],l[h],n,a,h.slice(6),Xt.setPaintProperty):t.deepEqual(s[h],l[h])||n.push({command:Xt.setLayerProperty,args:[a,h,l[h]]}));}else n.push({command:Xt.removeLayer,args:[a]}),c=m[m.lastIndexOf(a)+1],n.push({command:Xt.addLayer,args:[l,c]});}(a,i.layers,n);}catch(t){console.warn("Unable to compute style diff:",t),n=[{command:Xt.setStyle,args:[i]}];}return n}var ie=function(t,e,i){var n=this.boxCells=[],o=this.circleCells=[];this.xCellCount=Math.ceil(t/i),this.yCellCount=Math.ceil(e/i);for(var r=0;r<this.xCellCount*this.yCellCount;r++)n.push([]),o.push([]);this.circleKeys=[],this.boxKeys=[],this.bboxes=[],this.circles=[],this.width=t,this.height=e,this.xScale=this.xCellCount/t,this.yScale=this.yCellCount/e,this.boxUid=0,this.circleUid=0;};ie.prototype.keysLength=function(){return this.boxKeys.length+this.circleKeys.length},ie.prototype.insert=function(t,e,i,n,o){this._forEachCell(e,i,n,o,this._insertBoxCell,this.boxUid++),this.boxKeys.push(t),this.bboxes.push(e),this.bboxes.push(i),this.bboxes.push(n),this.bboxes.push(o);},ie.prototype.insertCircle=function(t,e,i,n){this._forEachCell(e-n,i-n,e+n,i+n,this._insertCircleCell,this.circleUid++),this.circleKeys.push(t),this.circles.push(e),this.circles.push(i),this.circles.push(n);},ie.prototype._insertBoxCell=function(t,e,i,n,o,r){this.boxCells[o].push(r);},ie.prototype._insertCircleCell=function(t,e,i,n,o,r){this.circleCells[o].push(r);},ie.prototype._query=function(t,e,i,n,o,r){if(i<0||t>this.width||n<0||e>this.height)return !o&&[];var a=[];if(t<=0&&e<=0&&this.width<=i&&this.height<=n){if(o)return !0;for(var s=0;s<this.boxKeys.length;s++)a.push({key:this.boxKeys[s],x1:this.bboxes[4*s],y1:this.bboxes[4*s+1],x2:this.bboxes[4*s+2],y2:this.bboxes[4*s+3]});for(var l=0;l<this.circleKeys.length;l++){var c=this.circles[3*l],h=this.circles[3*l+1],u=this.circles[3*l+2];a.push({key:this.circleKeys[l],x1:c-u,y1:h-u,x2:c+u,y2:h+u});}return r?a.filter(r):a}var p={hitTest:o,seenUids:{box:{},circle:{}}};return this._forEachCell(t,e,i,n,this._queryCell,a,p,r),o?a.length>0:a},ie.prototype._queryCircle=function(t,e,i,n,o){var r=t-i,a=t+i,s=e-i,l=e+i;if(a<0||r>this.width||l<0||s>this.height)return !n&&[];var c=[],h={hitTest:n,circle:{x:t,y:e,radius:i},seenUids:{box:{},circle:{}}};return this._forEachCell(r,s,a,l,this._queryCellCircle,c,h,o),n?c.length>0:c},ie.prototype.query=function(t,e,i,n,o){return this._query(t,e,i,n,!1,o)},ie.prototype.hitTest=function(t,e,i,n,o){return this._query(t,e,i,n,!0,o)},ie.prototype.hitTestCircle=function(t,e,i,n){return this._queryCircle(t,e,i,!0,n)},ie.prototype._queryCell=function(t,e,i,n,o,r,a,s){var l=a.seenUids,c=this.boxCells[o];if(null!==c)for(var h=this.bboxes,u=0,p=c;u<p.length;u+=1){var d=p[u];if(!l.box[d]){l.box[d]=!0;var f=4*d;if(t<=h[f+2]&&e<=h[f+3]&&i>=h[f+0]&&n>=h[f+1]&&(!s||s(this.boxKeys[d]))){if(a.hitTest)return r.push(!0),!0;r.push({key:this.boxKeys[d],x1:h[f],y1:h[f+1],x2:h[f+2],y2:h[f+3]});}}}var m=this.circleCells[o];if(null!==m)for(var _=this.circles,g=0,v=m;g<v.length;g+=1){var y=v[g];if(!l.circle[y]){l.circle[y]=!0;var x=3*y;if(this._circleAndRectCollide(_[x],_[x+1],_[x+2],t,e,i,n)&&(!s||s(this.circleKeys[y]))){if(a.hitTest)return r.push(!0),!0;var b=_[x],w=_[x+1],E=_[x+2];r.push({key:this.circleKeys[y],x1:b-E,y1:w-E,x2:b+E,y2:w+E});}}}},ie.prototype._queryCellCircle=function(t,e,i,n,o,r,a,s){var l=a.circle,c=a.seenUids,h=this.boxCells[o];if(null!==h)for(var u=this.bboxes,p=0,d=h;p<d.length;p+=1){var f=d[p];if(!c.box[f]){c.box[f]=!0;var m=4*f;if(this._circleAndRectCollide(l.x,l.y,l.radius,u[m+0],u[m+1],u[m+2],u[m+3])&&(!s||s(this.boxKeys[f])))return r.push(!0),!0}}var _=this.circleCells[o];if(null!==_)for(var g=this.circles,v=0,y=_;v<y.length;v+=1){var x=y[v];if(!c.circle[x]){c.circle[x]=!0;var b=3*x;if(this._circlesCollide(g[b],g[b+1],g[b+2],l.x,l.y,l.radius)&&(!s||s(this.circleKeys[x])))return r.push(!0),!0}}},ie.prototype._forEachCell=function(t,e,i,n,o,r,a,s){for(var l=this._convertToXCellCoord(t),c=this._convertToYCellCoord(e),h=this._convertToXCellCoord(i),u=this._convertToYCellCoord(n),p=l;p<=h;p++)for(var d=c;d<=u;d++){var f=this.xCellCount*d+p;if(o.call(this,t,e,i,n,f,r,a,s))return}},ie.prototype._convertToXCellCoord=function(t){return Math.max(0,Math.min(this.xCellCount-1,Math.floor(t*this.xScale)))},ie.prototype._convertToYCellCoord=function(t){return Math.max(0,Math.min(this.yCellCount-1,Math.floor(t*this.yScale)))},ie.prototype._circlesCollide=function(t,e,i,n,o,r){var a=n-t,s=o-e,l=i+r;return l*l>a*a+s*s},ie.prototype._circleAndRectCollide=function(t,e,i,n,o,r,a){var s=(r-n)/2,l=Math.abs(t-(n+s));if(l>s+i)return !1;var c=(a-o)/2,h=Math.abs(e-(o+c));if(h>c+i)return !1;if(l<=s||h<=c)return !0;var u=l-s,p=h-c;return u*u+p*p<=i*i};var ne=t.properties.layout;function oe(e,i,n,o,r){var a=t.identity(new Float32Array(16));return i?(t.identity(a),t.scale(a,a,[1/r,1/r,1]),n||t.rotateZ(a,a,o.angle)):(t.scale(a,a,[o.width/2,-o.height/2,1]),t.translate(a,a,[1,-1,0]),t.multiply(a,a,e)),a}function re(e,i,n,o,r){var a=t.identity(new Float32Array(16));return i?(t.multiply(a,a,e),t.scale(a,a,[r,r,1]),n||t.rotateZ(a,a,-o.angle)):(t.scale(a,a,[1,-1,1]),t.translate(a,a,[-1,-1,0]),t.scale(a,a,[2/o.width,2/o.height,1])),a}function ae(e,i){var n=[e.x,e.y,0,1];_e(n,n,i);var o=n[3];return {point:new t.Point(n[0]/o,n[1]/o),signedDistanceFromCamera:o}}function se(t,e){var i=t[0]/t[3],n=t[1]/t[3];return i>=-e[0]&&i<=e[0]&&n>=-e[1]&&n<=e[1]}function le(e,i,n,o,r,a,s,l){var c=o?e.textSizeData:e.iconSizeData,h=t.evaluateSizeForZoom(c,n.transform.zoom,ne.properties[o?"text-size":"icon-size"]),u=[256/n.width*2+1,256/n.height*2+1],p=o?e.text.dynamicLayoutVertexArray:e.icon.dynamicLayoutVertexArray;p.clear();for(var d=e.lineVertexArray,f=o?e.text.placedSymbolArray:e.icon.placedSymbolArray,m=n.transform.width/n.transform.height,_=!1,g=0;g<f.length;g++){var v=f.get(g);if(v.hidden||v.writingMode===t.WritingMode.vertical&&!_)me(v.numGlyphs,p);else{_=!1;var y=[v.anchorX,v.anchorY,0,1];if(t.transformMat4(y,y,i),se(y,u)){var x=.5+y[3]/n.transform.cameraToCenterDistance*.5,b=t.evaluateSizeForFeature(c,h,v),w=s?b*x:b/x,E=new t.Point(v.anchorX,v.anchorY),T=ae(E,r).point,I={},S=ue(v,w,!1,l,i,r,a,e.glyphOffsetArray,d,p,T,E,I,m);_=S.useVertical,(S.notEnoughRoom||_||S.needsFlipping&&ue(v,w,!0,l,i,r,a,e.glyphOffsetArray,d,p,T,E,I,m).notEnoughRoom)&&me(v.numGlyphs,p);}else me(v.numGlyphs,p);}}o?e.text.dynamicLayoutVertexBuffer.updateData(p):e.icon.dynamicLayoutVertexBuffer.updateData(p);}function ce(t,e,i,n,o,r,a,s,l,c,h,u){var p=s.glyphStartIndex+s.numGlyphs,d=s.lineStartIndex,f=s.lineStartIndex+s.lineLength,m=e.getoffsetX(s.glyphStartIndex),_=e.getoffsetX(p-1),g=de(t*m,i,n,o,r,a,s.segment,d,f,l,c,h,u);if(!g)return null;var v=de(t*_,i,n,o,r,a,s.segment,d,f,l,c,h,u);return v?{first:g,last:v}:null}function he(e,i,n,o){if(e===t.WritingMode.horizontal&&Math.abs(n.y-i.y)>Math.abs(n.x-i.x)*o)return {useVertical:!0};return (e===t.WritingMode.vertical?i.y<n.y:i.x>n.x)?{needsFlipping:!0}:null}function ue(e,i,n,o,r,a,s,l,c,h,u,p,d,f){var m,_=i/24,g=e.lineOffsetX*i,v=e.lineOffsetY*i;if(e.numGlyphs>1){var y=e.glyphStartIndex+e.numGlyphs,x=e.lineStartIndex,b=e.lineStartIndex+e.lineLength,w=ce(_,l,g,v,n,u,p,e,c,a,d,!1);if(!w)return {notEnoughRoom:!0};var E=ae(w.first.point,s).point,T=ae(w.last.point,s).point;if(o&&!n){var I=he(e.writingMode,E,T,f);if(I)return I}m=[w.first];for(var S=e.glyphStartIndex+1;S<y-1;S++)m.push(de(_*l.getoffsetX(S),g,v,n,u,p,e.segment,x,b,c,a,d,!1));m.push(w.last);}else{if(o&&!n){var C=ae(p,r).point,z=e.lineStartIndex+e.segment+1,P=new t.Point(c.getx(z),c.gety(z)),A=ae(P,r),D=A.signedDistanceFromCamera>0?A.point:pe(p,P,C,1,r),R=he(e.writingMode,C,D,f);if(R)return R}var M=de(_*l.getoffsetX(e.glyphStartIndex),g,v,n,u,p,e.segment,e.lineStartIndex,e.lineStartIndex+e.lineLength,c,a,d,!1);if(!M)return {notEnoughRoom:!0};m=[M];}for(var L=0,k=m;L<k.length;L+=1){var B=k[L];t.addDynamicAttributes(h,B.point,B.angle);}return {}}function pe(t,e,i,n,o){var r=ae(t.add(t.sub(e)._unit()),o).point,a=i.sub(r);return i.add(a._mult(n/a.mag()))}function de(e,i,n,o,r,a,s,l,c,h,u,p,d){var f=o?e-i:e+i,m=f>0?1:-1,_=0;o&&(m*=-1,_=Math.PI),m<0&&(_+=Math.PI);for(var g=m>0?l+s:l+s+1,v=g,y=r,x=r,b=0,w=0,E=Math.abs(f);b+w<=E;){if((g+=m)<l||g>=c)return null;if(x=y,void 0===(y=p[g])){var T=new t.Point(h.getx(g),h.gety(g)),I=ae(T,u);if(I.signedDistanceFromCamera>0)y=p[g]=I.point;else{var S=g-m;y=pe(0===b?a:new t.Point(h.getx(S),h.gety(S)),T,x,E-b+1,u);}}b+=w,w=x.dist(y);}var C=(E-b)/w,z=y.sub(x),P=z.mult(C)._add(x);return P._add(z._unit()._perp()._mult(n*m)),{point:P,angle:_+Math.atan2(y.y-x.y,y.x-x.x),tileDistance:d?{prevTileDistance:g-m===v?0:h.gettileUnitDistanceFromAnchor(g-m),lastSegmentViewportDistance:E-b}:null}}var fe=new Float32Array([-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0]);function me(t,e){for(var i=0;i<t;i++){var n=e.length;e.resize(n+4),e.float32.set(fe,3*n);}}function _e(t,e,i){var n=e[0],o=e[1];return t[0]=i[0]*n+i[4]*o+i[12],t[1]=i[1]*n+i[5]*o+i[13],t[3]=i[3]*n+i[7]*o+i[15],t}var ge=function(t,e,i){void 0===e&&(e=new ie(t.width+200,t.height+200,25)),void 0===i&&(i=new ie(t.width+200,t.height+200,25)),this.transform=t,this.grid=e,this.ignoredGrid=i,this.pitchfactor=Math.cos(t._pitch)*t.cameraToCenterDistance,this.screenRightBoundary=t.width+100,this.screenBottomBoundary=t.height+100,this.gridRightBoundary=t.width+200,this.gridBottomBoundary=t.height+200;};function ve(t,e,i){t[e+4]=i?1:0;}function ye(e,i,n){return i*(t.EXTENT/(e.tileSize*Math.pow(2,n-e.tileID.overscaledZ)))}ge.prototype.placeCollisionBox=function(t,e,i,n,o){var r=this.projectAndGetPerspectiveRatio(n,t.anchorPointX,t.anchorPointY),a=i*r.perspectiveRatio,s=t.x1*a+r.point.x,l=t.y1*a+r.point.y,c=t.x2*a+r.point.x,h=t.y2*a+r.point.y;return !this.isInsideGrid(s,l,c,h)||!e&&this.grid.hitTest(s,l,c,h,o)?{box:[],offscreen:!1}:{box:[s,l,c,h],offscreen:this.isOffscreen(s,l,c,h)}},ge.prototype.approximateTileDistance=function(t,e,i,n,o){var r=o?1:n/this.pitchfactor,a=t.lastSegmentViewportDistance*i;return t.prevTileDistance+a+(r-1)*a*Math.abs(Math.sin(e))},ge.prototype.placeCollisionCircles=function(e,i,n,o,r,a,s,l,c,h,u,p,d,f){var m=[],_=this.projectAnchor(h,a.anchorX,a.anchorY),g=c/24,v=a.lineOffsetX*c,y=a.lineOffsetY*c,x=new t.Point(a.anchorX,a.anchorY),b=ce(g,l,v,y,!1,ae(x,u).point,x,a,s,u,{},!0),w=!1,E=!1,T=!0,I=_.perspectiveRatio*o,S=1/(o*n),C=0,z=0;b&&(C=this.approximateTileDistance(b.first.tileDistance,b.first.angle,S,_.cameraDistance,d),z=this.approximateTileDistance(b.last.tileDistance,b.last.angle,S,_.cameraDistance,d));for(var P=0;P<e.length;P+=5){var A=e[P],D=e[P+1],R=e[P+2],M=e[P+3];if(!b||M<-C||M>z)ve(e,P,!1);else{var L=this.projectPoint(h,A,D),k=R*I;if(m.length>0){var B=L.x-m[m.length-4],O=L.y-m[m.length-3];if(k*k*2>B*B+O*O)if(P+8<e.length){var F=e[P+8];if(F>-C&&F<z){ve(e,P,!1);continue}}}var N=P/5;m.push(L.x,L.y,k,N),ve(e,P,!0);var U=L.x-k,V=L.y-k,Z=L.x+k,j=L.y+k;if(T=T&&this.isOffscreen(U,V,Z,j),E=E||this.isInsideGrid(U,V,Z,j),!i&&this.grid.hitTestCircle(L.x,L.y,k,f)){if(!p)return {circles:[],offscreen:!1};w=!0;}}}return {circles:w||!E?[]:m,offscreen:T}},ge.prototype.queryRenderedSymbols=function(e){if(0===e.length||0===this.grid.keysLength()&&0===this.ignoredGrid.keysLength())return {};for(var i=[],n=1/0,o=1/0,r=-1/0,a=-1/0,s=0,l=e;s<l.length;s+=1){var c=l[s],h=new t.Point(c.x+100,c.y+100);n=Math.min(n,h.x),o=Math.min(o,h.y),r=Math.max(r,h.x),a=Math.max(a,h.y),i.push(h);}for(var u={},p={},d=0,f=this.grid.query(n,o,r,a).concat(this.ignoredGrid.query(n,o,r,a));d<f.length;d+=1){var m=f[d],_=m.key;if(void 0===u[_.bucketInstanceId]&&(u[_.bucketInstanceId]={}),!u[_.bucketInstanceId][_.featureIndex]){var g=[new t.Point(m.x1,m.y1),new t.Point(m.x2,m.y1),new t.Point(m.x2,m.y2),new t.Point(m.x1,m.y2)];t.polygonIntersectsPolygon(i,g)&&(u[_.bucketInstanceId][_.featureIndex]=!0,void 0===p[_.bucketInstanceId]&&(p[_.bucketInstanceId]=[]),p[_.bucketInstanceId].push(_.featureIndex));}}return p},ge.prototype.insertCollisionBox=function(t,e,i,n,o){var r={bucketInstanceId:i,featureIndex:n,collisionGroupID:o};(e?this.ignoredGrid:this.grid).insert(r,t[0],t[1],t[2],t[3]);},ge.prototype.insertCollisionCircles=function(t,e,i,n,o){for(var r=e?this.ignoredGrid:this.grid,a={bucketInstanceId:i,featureIndex:n,collisionGroupID:o},s=0;s<t.length;s+=4)r.insertCircle(a,t[s],t[s+1],t[s+2]);},ge.prototype.projectAnchor=function(t,e,i){var n=[e,i,0,1];return _e(n,n,t),{perspectiveRatio:.5+this.transform.cameraToCenterDistance/n[3]*.5,cameraDistance:n[3]}},ge.prototype.projectPoint=function(e,i,n){var o=[i,n,0,1];return _e(o,o,e),new t.Point((o[0]/o[3]+1)/2*this.transform.width+100,(-o[1]/o[3]+1)/2*this.transform.height+100)},ge.prototype.projectAndGetPerspectiveRatio=function(e,i,n){var o=[i,n,0,1];return _e(o,o,e),{point:new t.Point((o[0]/o[3]+1)/2*this.transform.width+100,(-o[1]/o[3]+1)/2*this.transform.height+100),perspectiveRatio:.5+this.transform.cameraToCenterDistance/o[3]*.5}},ge.prototype.isOffscreen=function(t,e,i,n){return i<100||t>=this.screenRightBoundary||n<100||e>this.screenBottomBoundary},ge.prototype.isInsideGrid=function(t,e,i,n){return i>=0&&t<this.gridRightBoundary&&n>=0&&e<this.gridBottomBoundary};var xe=function(t,e,i,n){this.opacity=t?Math.max(0,Math.min(1,t.opacity+(t.placed?e:-e))):n&&i?1:0,this.placed=i;};xe.prototype.isHidden=function(){return 0===this.opacity&&!this.placed};var be=function(t,e,i,n,o){this.text=new xe(t?t.text:null,e,i,o),this.icon=new xe(t?t.icon:null,e,n,o);};be.prototype.isHidden=function(){return this.text.isHidden()&&this.icon.isHidden()};var we=function(t,e,i){this.text=t,this.icon=e,this.skipFade=i;},Ee=function(t){this.crossSourceCollisions=t,this.maxGroupID=0,this.collisionGroups={};};Ee.prototype.get=function(t){if(this.crossSourceCollisions)return {ID:0,predicate:null};if(!this.collisionGroups[t]){var e=++this.maxGroupID;this.collisionGroups[t]={ID:e,predicate:function(t){return t.collisionGroupID===e}};}return this.collisionGroups[t]};var Te=function(t,e,i){this.transform=t.clone(),this.collisionIndex=new ge(this.transform),this.placements={},this.opacities={},this.stale=!1,this.fadeDuration=e,this.retainedQueryData={},this.collisionGroups=new Ee(i);};function Ie(t,e,i){t.emplaceBack(e?1:0,i?1:0),t.emplaceBack(e?1:0,i?1:0),t.emplaceBack(e?1:0,i?1:0),t.emplaceBack(e?1:0,i?1:0);}Te.prototype.placeLayerTile=function(e,i,n,o){var r=i.getBucket(e),a=i.latestFeatureIndex;if(r&&a&&e.id===r.layerIds[0]){var s=i.collisionBoxArray,l=r.layers[0].layout,c=Math.pow(2,this.transform.zoom-i.tileID.overscaledZ),h=i.tileSize/t.EXTENT,u=this.transform.calculatePosMatrix(i.tileID.toUnwrapped()),p=oe(u,"map"===l.get("text-pitch-alignment"),"map"===l.get("text-rotation-alignment"),this.transform,ye(i,1,this.transform.zoom)),d=oe(u,"map"===l.get("icon-pitch-alignment"),"map"===l.get("icon-rotation-alignment"),this.transform,ye(i,1,this.transform.zoom));this.retainedQueryData[r.bucketInstanceId]=new function(t,e,i,n,o){this.bucketInstanceId=t,this.featureIndex=e,this.sourceLayerIndex=i,this.bucketIndex=n,this.tileID=o;}(r.bucketInstanceId,a,r.sourceLayerIndex,r.index,i.tileID),this.placeLayerBucket(r,u,p,d,c,h,n,i.holdingForFade(),o,s);}},Te.prototype.placeLayerBucket=function(e,i,n,o,r,a,s,l,c,h){for(var u=e.layers[0].layout,p=t.evaluateSizeForZoom(e.textSizeData,this.transform.zoom,t.properties.layout.properties["text-size"]),d=u.get("text-optional"),f=u.get("icon-optional"),m=this.collisionGroups.get(e.sourceID),_=0,g=e.symbolInstances;_<g.length;_+=1){var v=g[_];if(!c[v.crossTileID]){if(l){this.placements[v.crossTileID]=new we(!1,!1,!1);continue}var y=!1,x=!1,b=!0,w=null,E=null,T=null,I=0,S=0;v.collisionArrays||(v.collisionArrays=e.deserializeCollisionBoxes(h,v.textBoxStartIndex,v.textBoxEndIndex,v.iconBoxStartIndex,v.iconBoxEndIndex)),v.collisionArrays.textFeatureIndex&&(I=v.collisionArrays.textFeatureIndex),v.collisionArrays.textBox&&(y=(w=this.collisionIndex.placeCollisionBox(v.collisionArrays.textBox,u.get("text-allow-overlap"),a,i,m.predicate)).box.length>0,b=b&&w.offscreen);var C=v.collisionArrays.textCircles;if(C){var z=e.text.placedSymbolArray.get(v.placedTextSymbolIndices[0]),P=t.evaluateSizeForFeature(e.textSizeData,p,z);E=this.collisionIndex.placeCollisionCircles(C,u.get("text-allow-overlap"),r,a,v.key,z,e.lineVertexArray,e.glyphOffsetArray,P,i,n,s,"map"===u.get("text-pitch-alignment"),m.predicate),y=u.get("text-allow-overlap")||E.circles.length>0,b=b&&E.offscreen;}v.collisionArrays.iconFeatureIndex&&(S=v.collisionArrays.iconFeatureIndex),v.collisionArrays.iconBox&&(x=(T=this.collisionIndex.placeCollisionBox(v.collisionArrays.iconBox,u.get("icon-allow-overlap"),a,i,m.predicate)).box.length>0,b=b&&T.offscreen);var A=d||0===v.numGlyphVertices&&0===v.numVerticalGlyphVertices,D=f||0===v.numIconVertices;A||D?D?A||(x=x&&y):y=x&&y:x=y=x&&y,y&&w&&this.collisionIndex.insertCollisionBox(w.box,u.get("text-ignore-placement"),e.bucketInstanceId,I,m.ID),x&&T&&this.collisionIndex.insertCollisionBox(T.box,u.get("icon-ignore-placement"),e.bucketInstanceId,S,m.ID),y&&E&&this.collisionIndex.insertCollisionCircles(E.circles,u.get("text-ignore-placement"),e.bucketInstanceId,I,m.ID),this.placements[v.crossTileID]=new we(y,x,b||e.justReloaded),c[v.crossTileID]=!0;}}e.justReloaded=!1;},Te.prototype.commit=function(t,e){this.commitTime=e;var i=!1,n=t&&0!==this.fadeDuration?(this.commitTime-t.commitTime)/this.fadeDuration:1,o=t?t.opacities:{};for(var r in this.placements){var a=this.placements[r],s=o[r];s?(this.opacities[r]=new be(s,n,a.text,a.icon),i=i||a.text!==s.text.placed||a.icon!==s.icon.placed):(this.opacities[r]=new be(null,n,a.text,a.icon,a.skipFade),i=i||a.text||a.icon);}for(var l in o){var c=o[l];if(!this.opacities[l]){var h=new be(c,n,!1,!1);h.isHidden()||(this.opacities[l]=h,i=i||c.text.placed||c.icon.placed);}}i?this.lastPlacementChangeTime=e:"number"!=typeof this.lastPlacementChangeTime&&(this.lastPlacementChangeTime=t?t.lastPlacementChangeTime:e);},Te.prototype.updateLayerOpacities=function(t,e){for(var i={},n=0,o=e;n<o.length;n+=1){var r=o[n],a=r.getBucket(t);a&&r.latestFeatureIndex&&t.id===a.layerIds[0]&&this.updateBucketOpacities(a,i,r.collisionBoxArray);}},Te.prototype.updateBucketOpacities=function(t,e,i){t.hasTextData()&&t.text.opacityVertexArray.clear(),t.hasIconData()&&t.icon.opacityVertexArray.clear(),t.hasCollisionBoxData()&&t.collisionBox.collisionVertexArray.clear(),t.hasCollisionCircleData()&&t.collisionCircle.collisionVertexArray.clear();for(var n=t.layers[0].layout,o=new be(null,0,!1,!1,!0),r=new be(null,0,n.get("text-allow-overlap"),n.get("icon-allow-overlap"),!0),a=0;a<t.symbolInstances.length;a++){var s=t.symbolInstances[a],l=e[s.crossTileID],c=this.opacities[s.crossTileID];l?c=o:c||(c=r,this.opacities[s.crossTileID]=c),e[s.crossTileID]=!0;var h=s.numGlyphVertices>0||s.numVerticalGlyphVertices>0,u=s.numIconVertices>0;if(h){for(var p=Me(c.text),d=(s.numGlyphVertices+s.numVerticalGlyphVertices)/4,f=0;f<d;f++)t.text.opacityVertexArray.emplaceBack(p);for(var m=0,_=s.placedTextSymbolIndices;m<_.length;m+=1){var g=_[m];t.text.placedSymbolArray.get(g).hidden=c.text.isHidden();}}if(u){for(var v=Me(c.icon),y=0;y<s.numIconVertices/4;y++)t.icon.opacityVertexArray.emplaceBack(v);t.icon.placedSymbolArray.get(a).hidden=c.icon.isHidden();}s.collisionArrays||(s.collisionArrays=t.deserializeCollisionBoxes(i,s.textBoxStartIndex,s.textBoxEndIndex,s.iconBoxStartIndex,s.iconBoxEndIndex));var x=s.collisionArrays;if(x){x.textBox&&t.hasCollisionBoxData()&&Ie(t.collisionBox.collisionVertexArray,c.text.placed,!1),x.iconBox&&t.hasCollisionBoxData()&&Ie(t.collisionBox.collisionVertexArray,c.icon.placed,!1);var b=x.textCircles;if(b&&t.hasCollisionCircleData())for(var w=0;w<b.length;w+=5){var E=l||0===b[w+4];Ie(t.collisionCircle.collisionVertexArray,c.text.placed,E);}}}t.sortFeatures(this.transform.angle),this.retainedQueryData[t.bucketInstanceId]&&(this.retainedQueryData[t.bucketInstanceId].featureSortOrder=t.featureSortOrder),t.hasTextData()&&t.text.opacityVertexBuffer&&t.text.opacityVertexBuffer.updateData(t.text.opacityVertexArray),t.hasIconData()&&t.icon.opacityVertexBuffer&&t.icon.opacityVertexBuffer.updateData(t.icon.opacityVertexArray),t.hasCollisionBoxData()&&t.collisionBox.collisionVertexBuffer&&t.collisionBox.collisionVertexBuffer.updateData(t.collisionBox.collisionVertexArray),t.hasCollisionCircleData()&&t.collisionCircle.collisionVertexBuffer&&t.collisionCircle.collisionVertexBuffer.updateData(t.collisionCircle.collisionVertexArray);},Te.prototype.symbolFadeChange=function(t){return 0===this.fadeDuration?1:(t-this.commitTime)/this.fadeDuration},Te.prototype.hasTransitions=function(t){return this.stale||t-this.lastPlacementChangeTime<this.fadeDuration},Te.prototype.stillRecent=function(t){return "undefined"!==this.commitTime&&this.commitTime+this.fadeDuration>t},Te.prototype.setStale=function(){this.stale=!0;};var Se=Math.pow(2,25),Ce=Math.pow(2,24),ze=Math.pow(2,17),Pe=Math.pow(2,16),Ae=Math.pow(2,9),De=Math.pow(2,8),Re=Math.pow(2,1);function Me(t){if(0===t.opacity&&!t.placed)return 0;if(1===t.opacity&&t.placed)return 4294967295;var e=t.placed?1:0,i=Math.floor(127*t.opacity);return i*Se+e*Ce+i*ze+e*Pe+i*Ae+e*De+i*Re+e}var Le=function(){this._currentTileIndex=0,this._seenCrossTileIDs={};};Le.prototype.continuePlacement=function(t,e,i,n,o){for(;this._currentTileIndex<t.length;){var r=t[this._currentTileIndex];if(e.placeLayerTile(n,r,i,this._seenCrossTileIDs),this._currentTileIndex++,o())return !0}};var ke=function(t,e,i,n,o,r){this.placement=new Te(t,o,r),this._currentPlacementIndex=e.length-1,this._forceFullPlacement=i,this._showCollisionBoxes=n,this._done=!1;};ke.prototype.isDone=function(){return this._done},ke.prototype.continuePlacement=function(e,i,n){for(var o=this,r=t.browser.now(),a=function(){var e=t.browser.now()-r;return !o._forceFullPlacement&&e>2};this._currentPlacementIndex>=0;){var s=i[e[o._currentPlacementIndex]],l=o.placement.collisionIndex.transform.zoom;if("symbol"===s.type&&(!s.minzoom||s.minzoom<=l)&&(!s.maxzoom||s.maxzoom>l)){if(o._inProgressLayer||(o._inProgressLayer=new Le),o._inProgressLayer.continuePlacement(n[s.source],o.placement,o._showCollisionBoxes,s,a))return;delete o._inProgressLayer;}o._currentPlacementIndex--;}this._done=!0;},ke.prototype.commit=function(t,e){return this.placement.commit(t,e),this.placement};var Be=512/t.EXTENT/2,Oe=function(t,e,i){this.tileID=t,this.indexedSymbolInstances={},this.bucketInstanceId=i;for(var n=0,o=e;n<o.length;n+=1){var r=o[n],a=r.key;this.indexedSymbolInstances[a]||(this.indexedSymbolInstances[a]=[]),this.indexedSymbolInstances[a].push({crossTileID:r.crossTileID,coord:this.getScaledCoordinates(r,t)});}};Oe.prototype.getScaledCoordinates=function(e,i){var n=i.canonical.z-this.tileID.canonical.z,o=Be/Math.pow(2,n),r=e.anchor;return {x:Math.floor((i.canonical.x*t.EXTENT+r.x)*o),y:Math.floor((i.canonical.y*t.EXTENT+r.y)*o)}},Oe.prototype.findMatches=function(t,e,i){for(var n=this.tileID.canonical.z<e.canonical.z?1:Math.pow(2,this.tileID.canonical.z-e.canonical.z),o=0,r=t;o<r.length;o+=1){var a=r[o];if(!a.crossTileID){var s=this.indexedSymbolInstances[a.key];if(s)for(var l=this.getScaledCoordinates(a,e),c=0,h=s;c<h.length;c+=1){var u=h[c];if(Math.abs(u.coord.x-l.x)<=n&&Math.abs(u.coord.y-l.y)<=n&&!i[u.crossTileID]){i[u.crossTileID]=!0,a.crossTileID=u.crossTileID;break}}}}};var Fe=function(){this.maxCrossTileID=0;};Fe.prototype.generate=function(){return ++this.maxCrossTileID};var Ne=function(){this.indexes={},this.usedCrossTileIDs={},this.lng=0;};Ne.prototype.handleWrapJump=function(t){var e=Math.round((t-this.lng)/360);if(0!==e)for(var i in this.indexes){var n=this.indexes[i],o={};for(var r in n){var a=n[r];a.tileID=a.tileID.unwrapTo(a.tileID.wrap+e),o[a.tileID.key]=a;}this.indexes[i]=o;}this.lng=t;},Ne.prototype.addBucket=function(t,e,i){if(this.indexes[t.overscaledZ]&&this.indexes[t.overscaledZ][t.key]){if(this.indexes[t.overscaledZ][t.key].bucketInstanceId===e.bucketInstanceId)return !1;this.removeBucketCrossTileIDs(t.overscaledZ,this.indexes[t.overscaledZ][t.key]);}for(var n=0,o=e.symbolInstances;n<o.length;n+=1){o[n].crossTileID=0;}this.usedCrossTileIDs[t.overscaledZ]||(this.usedCrossTileIDs[t.overscaledZ]={});var r=this.usedCrossTileIDs[t.overscaledZ];for(var a in this.indexes){var s=this.indexes[a];if(Number(a)>t.overscaledZ)for(var l in s){var c=s[l];c.tileID.isChildOf(t)&&c.findMatches(e.symbolInstances,t,r);}else{var h=s[t.scaledTo(Number(a)).key];h&&h.findMatches(e.symbolInstances,t,r);}}for(var u=0,p=e.symbolInstances;u<p.length;u+=1){var d=p[u];d.crossTileID||(d.crossTileID=i.generate(),r[d.crossTileID]=!0);}return void 0===this.indexes[t.overscaledZ]&&(this.indexes[t.overscaledZ]={}),this.indexes[t.overscaledZ][t.key]=new Oe(t,e.symbolInstances,e.bucketInstanceId),!0},Ne.prototype.removeBucketCrossTileIDs=function(t,e){for(var i in e.indexedSymbolInstances)for(var n=0,o=e.indexedSymbolInstances[i];n<o.length;n+=1){var r=o[n];delete this.usedCrossTileIDs[t][r.crossTileID];}},Ne.prototype.removeStaleBuckets=function(t){var e=!1;for(var i in this.indexes){var n=this.indexes[i];for(var o in n)t[n[o].bucketInstanceId]||(this.removeBucketCrossTileIDs(i,n[o]),delete n[o],e=!0);}return e};var Ue=function(){this.layerIndexes={},this.crossTileIDs=new Fe,this.maxBucketInstanceId=0,this.bucketsInCurrentPlacement={};};Ue.prototype.addLayer=function(t,e,i){var n=this.layerIndexes[t.id];void 0===n&&(n=this.layerIndexes[t.id]=new Ne);var o=!1,r={};n.handleWrapJump(i);for(var a=0,s=e;a<s.length;a+=1){var l=s[a],c=l.getBucket(t);c&&t.id===c.layerIds[0]&&(c.bucketInstanceId||(c.bucketInstanceId=++this.maxBucketInstanceId),n.addBucket(l.tileID,c,this.crossTileIDs)&&(o=!0),r[c.bucketInstanceId]=!0);}return n.removeStaleBuckets(r)&&(o=!0),o},Ue.prototype.pruneUnusedLayers=function(t){var e={};for(var i in t.forEach(function(t){e[t]=!0;}),this.layerIndexes)e[i]||delete this.layerIndexes[i];};var Ve=function(e,i){return t.emitValidationErrors(e,i&&i.filter(function(t){return "source.canvas"!==t.identifier}))},Ze=t.pick(Xt,["addLayer","removeLayer","setPaintProperty","setLayoutProperty","setFilter","addSource","removeSource","setLayerZoomRange","setLight","setTransition","setGeoJSONSourceData"]),je=t.pick(Xt,["setCenter","setZoom","setBearing","setPitch"]),qe=function(e){function i(n,o){var r=this;void 0===o&&(o={}),e.call(this),this.map=n,this.dispatcher=new O((jt||(jt=new qt),jt),this),this.imageManager=new S,this.glyphManager=new R(n._transformRequest,o.localIdeographFontFamily),this.lineAtlas=new B(256,512),this.crossTileSymbolIndex=new Ue,this._layers={},this._order=[],this.sourceCaches={},this.zoomHistory=new t.ZoomHistory,this._loaded=!1,this._resetUpdates();var a=this;this._rtlTextPluginCallback=i.registerForPluginAvailability(function(t){for(var e in a.dispatcher.broadcast("loadRTLTextPlugin",t.pluginURL,t.completionCallback),a.sourceCaches)a.sourceCaches[e].reload();}),this.on("data",function(t){if("source"===t.dataType&&"metadata"===t.sourceDataType){var e=r.sourceCaches[t.sourceId];if(e){var i=e.getSource();if(i&&i.vectorLayerIds)for(var n in r._layers){var o=r._layers[n];o.source===i.id&&r._validateLayer(o);}}}});}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.loadURL=function(e,i){var n=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"}));var o="boolean"==typeof i.validate?i.validate:!f(e);e=function(t,e){if(!f(t))return t;var i=b(t);return i.path="/styles/v1"+i.path,d(i,e)}(e,i.accessToken);var r=this.map._transformRequest(e,t.ResourceType.Style);this._request=t.getJSON(r,function(e,i){n._request=null,e?n.fire(new t.ErrorEvent(e)):i&&n._load(i,o);});},i.prototype.loadJSON=function(e,i){var n=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"})),this._request=t.browser.frame(function(){n._request=null,n._load(e,!1!==i.validate);});},i.prototype._load=function(e,i){var n=this;if(!i||!Ve(this,t.validateStyle(e))){for(var o in this._loaded=!0,this.stylesheet=e,e.sources)n.addSource(o,e.sources[o],{validate:!1});e.sprite?this._spriteRequest=function(e,i,n){var o,r,a,s=t.browser.devicePixelRatio>1?"@2x":"",l=t.getJSON(i(g(e,s,".json"),t.ResourceType.SpriteJSON),function(t,e){l=null,a||(a=t,o=e,h());}),c=t.getImage(i(g(e,s,".png"),t.ResourceType.SpriteImage),function(t,e){c=null,a||(a=t,r=e,h());});function h(){if(a)n(a);else if(o&&r){var e=t.browser.getImageData(r),i={};for(var s in o){var l=o[s],c=l.width,h=l.height,u=l.x,p=l.y,d=l.sdf,f=l.pixelRatio,m=new t.RGBAImage({width:c,height:h});t.RGBAImage.copy(e,m,{x:u,y:p},{x:0,y:0},{width:c,height:h}),i[s]={data:m,pixelRatio:f,sdf:d};}n(null,i);}}return {cancel:function(){l&&(l.cancel(),l=null),c&&(c.cancel(),c=null);}}}(e.sprite,this.map._transformRequest,function(e,i){if(n._spriteRequest=null,e)n.fire(new t.ErrorEvent(e));else if(i)for(var o in i)n.imageManager.addImage(o,i[o]);n.imageManager.setLoaded(!0),n.fire(new t.Event("data",{dataType:"style"}));}):this.imageManager.setLoaded(!0),this.glyphManager.setURL(e.glyphs);var r=Wt(this.stylesheet.layers);this._order=r.map(function(t){return t.id}),this._layers={};for(var a=0,s=r;a<s.length;a+=1){var l=s[a];(l=t.createStyleLayer(l)).setEventedParent(n,{layer:{id:l.id}}),n._layers[l.id]=l;}this.dispatcher.broadcast("setLayers",this._serializeLayers(this._order)),this.light=new k(this.stylesheet.light),this.fire(new t.Event("data",{dataType:"style"})),this.fire(new t.Event("style.load"));}},i.prototype._validateLayer=function(e){var i=this.sourceCaches[e.source];if(i){var n=e.sourceLayer;if(n){var o=i.getSource();("geojson"===o.type||o.vectorLayerIds&&-1===o.vectorLayerIds.indexOf(n))&&this.fire(new t.ErrorEvent(new Error('Source layer "'+n+'" does not exist on source "'+o.id+'" as specified by style layer "'+e.id+'"')));}}},i.prototype.loaded=function(){if(!this._loaded)return !1;if(Object.keys(this._updatedSources).length)return !1;for(var t in this.sourceCaches)if(!this.sourceCaches[t].loaded())return !1;return !!this.imageManager.isLoaded()},i.prototype._serializeLayers=function(t){var e=this;return t.map(function(t){return e._layers[t].serialize()})},i.prototype.hasTransitions=function(){if(this.light&&this.light.hasTransition())return !0;for(var t in this.sourceCaches)if(this.sourceCaches[t].hasTransition())return !0;for(var e in this._layers)if(this._layers[e].hasTransition())return !0;return !1},i.prototype._checkLoaded=function(){if(!this._loaded)throw new Error("Style is not done loading")},i.prototype.update=function(e){if(this._loaded){if(this._changed){var i=Object.keys(this._updatedLayers),n=Object.keys(this._removedLayers);for(var o in(i.length||n.length)&&this._updateWorkerLayers(i,n),this._updatedSources){var r=this._updatedSources[o];"reload"===r?this._reloadSource(o):"clear"===r&&this._clearSource(o);}for(var a in this._updatedPaintProps)this._layers[a].updateTransitions(e);this.light.updateTransitions(e),this._resetUpdates(),this.fire(new t.Event("data",{dataType:"style"}));}for(var s in this.sourceCaches)this.sourceCaches[s].used=!1;for(var l=0,c=this._order;l<c.length;l+=1){var h=c[l],u=this._layers[h];u.recalculate(e),!u.isHidden(e.zoom)&&u.source&&(this.sourceCaches[u.source].used=!0);}this.light.recalculate(e),this.z=e.zoom;}},i.prototype._updateWorkerLayers=function(t,e){this.dispatcher.broadcast("updateLayers",{layers:this._serializeLayers(t),removedIds:e});},i.prototype._resetUpdates=function(){this._changed=!1,this._updatedLayers={},this._removedLayers={},this._updatedSources={},this._updatedPaintProps={};},i.prototype.setState=function(e){var i=this;if(this._checkLoaded(),Ve(this,t.validateStyle(e)))return !1;(e=t.clone(e)).layers=Wt(e.layers);var n=ee(this.serialize(),e).filter(function(t){return !(t.command in je)});if(0===n.length)return !1;var o=n.filter(function(t){return !(t.command in Ze)});if(o.length>0)throw new Error("Unimplemented: "+o.map(function(t){return t.command}).join(", ")+".");return n.forEach(function(t){"setTransition"!==t.command&&i[t.command].apply(i,t.args);}),this.stylesheet=e,!0},i.prototype.addImage=function(e,i){if(this.getImage(e))return this.fire(new t.ErrorEvent(new Error("An image with this name already exists.")));this.imageManager.addImage(e,i),this.fire(new t.Event("data",{dataType:"style"}));},i.prototype.getImage=function(t){return this.imageManager.getImage(t)},i.prototype.removeImage=function(e){if(!this.getImage(e))return this.fire(new t.ErrorEvent(new Error("No image with this name exists.")));this.imageManager.removeImage(e),this.fire(new t.Event("data",{dataType:"style"}));},i.prototype.listImages=function(){return this._checkLoaded(),this.imageManager.listImages()},i.prototype.addSource=function(e,i,n){var o=this;if(this._checkLoaded(),void 0!==this.sourceCaches[e])throw new Error("There is already a source with this ID");if(!i.type)throw new Error("The type property must be defined, but the only the following properties were given: "+Object.keys(i).join(", ")+".");if(!(["vector","raster","geojson","video","image"].indexOf(i.type)>=0)||!this._validate(t.validateStyle.source,"sources."+e,i,null,n)){this.map&&this.map._collectResourceTiming&&(i.collectResourceTiming=!0);var r=this.sourceCaches[e]=new Ft(e,i,this.dispatcher);r.style=this,r.setEventedParent(this,function(){return {isSourceLoaded:o.loaded(),source:r.serialize(),sourceId:e}}),r.onAdd(this.map),this._changed=!0;}},i.prototype.removeSource=function(e){if(this._checkLoaded(),void 0===this.sourceCaches[e])throw new Error("There is no source with this ID");for(var i in this._layers)if(this._layers[i].source===e)return this.fire(new t.ErrorEvent(new Error('Source "'+e+'" cannot be removed while layer "'+i+'" is using it.')));var n=this.sourceCaches[e];delete this.sourceCaches[e],delete this._updatedSources[e],n.fire(new t.Event("data",{sourceDataType:"metadata",dataType:"source",sourceId:e})),n.setEventedParent(null),n.clearTiles(),n.onRemove&&n.onRemove(this.map),this._changed=!0;},i.prototype.setGeoJSONSourceData=function(t,e){this._checkLoaded(),this.sourceCaches[t].getSource().setData(e),this._changed=!0;},i.prototype.getSource=function(t){return this.sourceCaches[t]&&this.sourceCaches[t].getSource()},i.prototype.addLayer=function(e,i,n){this._checkLoaded();var o=e.id;if(this.getLayer(o))this.fire(new t.ErrorEvent(new Error('Layer with id "'+o+'" already exists on this map')));else if("object"==typeof e.source&&(this.addSource(o,e.source),e=t.clone(e),e=t.extend(e,{source:o})),!this._validate(t.validateStyle.layer,"layers."+o,e,{arrayIndex:-1},n)){var r=t.createStyleLayer(e);this._validateLayer(r),r.setEventedParent(this,{layer:{id:o}});var a=i?this._order.indexOf(i):this._order.length;if(i&&-1===a)this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.')));else{if(this._order.splice(a,0,o),this._layerOrderChanged=!0,this._layers[o]=r,this._removedLayers[o]&&r.source){var s=this._removedLayers[o];delete this._removedLayers[o],s.type!==r.type?this._updatedSources[r.source]="clear":(this._updatedSources[r.source]="reload",this.sourceCaches[r.source].pause());}this._updateLayer(r);}}},i.prototype.moveLayer=function(e,i){if(this._checkLoaded(),this._changed=!0,this._layers[e]){if(e!==i){var n=this._order.indexOf(e);this._order.splice(n,1);var o=i?this._order.indexOf(i):this._order.length;i&&-1===o?this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.'))):(this._order.splice(o,0,e),this._layerOrderChanged=!0);}}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be moved.")));},i.prototype.removeLayer=function(e){this._checkLoaded();var i=this._layers[e];if(i){i.setEventedParent(null);var n=this._order.indexOf(e);this._order.splice(n,1),this._layerOrderChanged=!0,this._changed=!0,this._removedLayers[e]=i,delete this._layers[e],delete this._updatedLayers[e],delete this._updatedPaintProps[e];}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be removed.")));},i.prototype.getLayer=function(t){return this._layers[t]},i.prototype.setLayerZoomRange=function(e,i,n){this._checkLoaded();var o=this.getLayer(e);o?o.minzoom===i&&o.maxzoom===n||(null!=i&&(o.minzoom=i),null!=n&&(o.maxzoom=n),this._updateLayer(o)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot have zoom extent.")));},i.prototype.setFilter=function(e,i){this._checkLoaded();var n=this.getLayer(e);if(n){if(!t.deepEqual(n.filter,i))return null==i?(n.filter=void 0,void this._updateLayer(n)):void(this._validate(t.validateStyle.filter,"layers."+n.id+".filter",i)||(n.filter=t.clone(i),this._updateLayer(n)))}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be filtered.")));},i.prototype.getFilter=function(e){return t.clone(this.getLayer(e).filter)},i.prototype.setLayoutProperty=function(e,i,n){this._checkLoaded();var o=this.getLayer(e);o?t.deepEqual(o.getLayoutProperty(i),n)||(o.setLayoutProperty(i,n),this._updateLayer(o)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")));},i.prototype.getLayoutProperty=function(t,e){return this.getLayer(t).getLayoutProperty(e)},i.prototype.setPaintProperty=function(e,i,n){this._checkLoaded();var o=this.getLayer(e);o?t.deepEqual(o.getPaintProperty(i),n)||(o.setPaintProperty(i,n)&&this._updateLayer(o),this._changed=!0,this._updatedPaintProps[e]=!0):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")));},i.prototype.getPaintProperty=function(t,e){return this.getLayer(t).getPaintProperty(e)},i.prototype.setFeatureState=function(e,i){this._checkLoaded();var n=e.source,o=e.sourceLayer,r=this.sourceCaches[n];void 0!==r?"vector"!==r.getSource().type||o?null!=e.id&&""!==e.id?r.setFeatureState(o,e.id,i):this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided."))):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types."))):this.fire(new t.ErrorEvent(new Error("The source '"+n+"' does not exist in the map's style.")));},i.prototype.getFeatureState=function(e){this._checkLoaded();var i=e.source,n=e.sourceLayer,o=this.sourceCaches[i];if(void 0!==o){if("vector"!==o.getSource().type||n)return o.getFeatureState(n,e.id);this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+i+"' does not exist in the map's style.")));},i.prototype.getTransition=function(){return t.extend({duration:300,delay:0},this.stylesheet&&this.stylesheet.transition)},i.prototype.serialize=function(){var e=this;return t.filterObject({version:this.stylesheet.version,name:this.stylesheet.name,metadata:this.stylesheet.metadata,light:this.stylesheet.light,center:this.stylesheet.center,zoom:this.stylesheet.zoom,bearing:this.stylesheet.bearing,pitch:this.stylesheet.pitch,sprite:this.stylesheet.sprite,glyphs:this.stylesheet.glyphs,transition:this.stylesheet.transition,sources:t.mapObject(this.sourceCaches,function(t){return t.serialize()}),layers:this._order.map(function(t){return e._layers[t].serialize()})},function(t){return void 0!==t})},i.prototype._updateLayer=function(t){this._updatedLayers[t.id]=!0,t.source&&!this._updatedSources[t.source]&&(this._updatedSources[t.source]="reload",this.sourceCaches[t.source].pause()),this._changed=!0;},i.prototype._flattenRenderedFeatures=function(t){for(var e=[],i=this._order.length-1;i>=0;i--)for(var n=this._order[i],o=0,r=t;o<r.length;o+=1){var a=r[o][n];if(a)for(var s=0,l=a;s<l.length;s+=1){var c=l[s];e.push(c);}}return e},i.prototype.queryRenderedFeatures=function(e,i,n){i&&i.filter&&this._validate(t.validateStyle.filter,"queryRenderedFeatures.filter",i.filter);var o={};if(i&&i.layers){if(!Array.isArray(i.layers))return this.fire(new t.ErrorEvent(new Error("parameters.layers must be an Array."))),[];for(var r=0,a=i.layers;r<a.length;r+=1){var s=a[r],l=this._layers[s];if(!l)return this.fire(new t.ErrorEvent(new Error("The layer '"+s+"' does not exist in the map's style and cannot be queried for features."))),[];o[l.source]=!0;}}var c=[],h=e.map(function(t){return n.pointCoordinate(t)});for(var u in this.sourceCaches)i.layers&&!o[u]||c.push(Q(this.sourceCaches[u],this._layers,h,i,n));return this.placement&&c.push(function(t,e,i,n,o,r){for(var a={},s=o.queryRenderedSymbols(i),l=[],c=0,h=Object.keys(s).map(Number);c<h.length;c+=1){var u=h[c];l.push(r[u]);}l.sort($);for(var p=function(){var e=f[d],i=e.featureIndex.lookupSymbolFeatures(s[e.bucketInstanceId],e.bucketIndex,e.sourceLayerIndex,n.filter,n.layers,t);for(var o in i){var r=a[o]=a[o]||[],l=i[o];l.sort(function(t,i){var n=e.featureSortOrder;if(n){var o=n.indexOf(t.featureIndex);return n.indexOf(i.featureIndex)-o}return i.featureIndex-t.featureIndex});for(var c=0,h=l;c<h.length;c+=1){var u=h[c];r.push(u.feature);}}},d=0,f=l;d<f.length;d+=1)p();var m=function(i){a[i].forEach(function(n){var o=t[i],r=e[o.source].getFeatureState(n.layer["source-layer"],n.id);n.source=n.layer.source,n.layer["source-layer"]&&(n.sourceLayer=n.layer["source-layer"]),n.state=r;});};for(var _ in a)m(_);return a}(this._layers,this.sourceCaches,e,i,this.placement.collisionIndex,this.placement.retainedQueryData)),this._flattenRenderedFeatures(c)},i.prototype.querySourceFeatures=function(e,i){i&&i.filter&&this._validate(t.validateStyle.filter,"querySourceFeatures.filter",i.filter);var n=this.sourceCaches[e];return n?function(t,e){for(var i=t.getRenderableIds().map(function(e){return t.getTileByID(e)}),n=[],o={},r=0;r<i.length;r++){var a=i[r],s=a.tileID.canonical.key;o[s]||(o[s]=!0,a.querySourceFeatures(n,e));}return n}(n,i):[]},i.prototype.addSourceType=function(t,e,n){return i.getSourceType(t)?n(new Error('A source type called "'+t+'" already exists.')):(i.setSourceType(t,e),e.workerSourceURL?void this.dispatcher.broadcast("loadWorkerSource",{name:t,url:e.workerSourceURL},n):n(null,null))},i.prototype.getLight=function(){return this.light.getLight()},i.prototype.setLight=function(e){this._checkLoaded();var i=this.light.getLight(),n=!1;for(var o in e)if(!t.deepEqual(e[o],i[o])){n=!0;break}if(n){var r={now:t.browser.now(),transition:t.extend({duration:300,delay:0},this.stylesheet.transition)};this.light.setLight(e),this.light.updateTransitions(r);}},i.prototype._validate=function(e,i,n,o,r){return (!r||!1!==r.validate)&&Ve(this,e.call(t.validateStyle,t.extend({key:i,style:this.serialize(),value:n,styleSpec:t.styleSpec},o)))},i.prototype._remove=function(){for(var e in this._request&&(this._request.cancel(),this._request=null),this._spriteRequest&&(this._spriteRequest.cancel(),this._spriteRequest=null),t.evented.off("pluginAvailable",this._rtlTextPluginCallback),this.sourceCaches)this.sourceCaches[e].clearTiles();this.dispatcher.remove();},i.prototype._clearSource=function(t){this.sourceCaches[t].clearTiles();},i.prototype._reloadSource=function(t){this.sourceCaches[t].resume(),this.sourceCaches[t].reload();},i.prototype._updateSources=function(t){for(var e in this.sourceCaches)this.sourceCaches[e].update(t);},i.prototype._generateCollisionBoxes=function(){for(var t in this.sourceCaches)this._reloadSource(t);},i.prototype._updatePlacement=function(e,i,n,o){for(var r=!1,a=!1,s={},l=0,c=this._order;l<c.length;l+=1){var h=c[l],u=this._layers[h];if("symbol"===u.type){if(!s[u.source]){var p=this.sourceCaches[u.source];s[u.source]=p.getRenderableIds(!0).map(function(t){return p.getTileByID(t)}).sort(function(t,e){return e.tileID.overscaledZ-t.tileID.overscaledZ||(t.tileID.isLessThan(e.tileID)?-1:1)});}var d=this.crossTileSymbolIndex.addLayer(u,s[u.source],e.center.lng);r=r||d;}}this.crossTileSymbolIndex.pruneUnusedLayers(this._order);var f=this._layerOrderChanged;if((f||!this.pauseablePlacement||this.pauseablePlacement.isDone()&&!this.placement.stillRecent(t.browser.now()))&&(this.pauseablePlacement=new ke(e,this._order,f,i,n,o),this._layerOrderChanged=!1),this.pauseablePlacement.isDone()?this.placement.setStale():(this.pauseablePlacement.continuePlacement(this._order,this._layers,s),this.pauseablePlacement.isDone()&&(this.placement=this.pauseablePlacement.commit(this.placement,t.browser.now()),a=!0),r&&this.pauseablePlacement.placement.setStale()),a||r)for(var m=0,_=this._order;m<_.length;m+=1){var g=_[m],v=this._layers[g];"symbol"===v.type&&this.placement.updateLayerOpacities(v,s[v.source]);}return !this.pauseablePlacement.isDone()||this.placement.hasTransitions(t.browser.now())},i.prototype._releaseSymbolFadeTiles=function(){for(var t in this.sourceCaches)this.sourceCaches[t].releaseSymbolFadeTiles();},i.prototype.getImages=function(t,e,i){this.imageManager.getImages(e.icons,i);},i.prototype.getGlyphs=function(t,e,i){this.glyphManager.getGlyphs(e.stacks,i);},i}(t.Evented);qe.getSourceType=function(t){return Y[t]},qe.setSourceType=function(t,e){Y[t]=e;},qe.registerForPluginAvailability=t.registerForPluginAvailability;var Ge=t.createLayout([{name:"a_pos",type:"Int16",components:2}]),We={prelude:{fragmentSource:"#ifdef GL_ES\nprecision mediump float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif\n",vertexSource:"#ifdef GL_ES\nprecision highp float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif\n\n// Unpack a pair of values that have been packed into a single float.\n// The packed values are assumed to be 8-bit unsigned integers, and are\n// packed like so:\n// packedValue = floor(input[0]) * 256 + input[1],\nvec2 unpack_float(const float packedValue) {\n    int packedIntValue = int(packedValue);\n    int v0 = packedIntValue / 256;\n    return vec2(v0, packedIntValue - v0 * 256);\n}\n\nvec2 unpack_opacity(const float packedOpacity) {\n    int intOpacity = int(packedOpacity) / 2;\n    return vec2(float(intOpacity) / 127.0, mod(packedOpacity, 2.0));\n}\n\n// To minimize the number of attributes needed, we encode a 4-component\n// color into a pair of floats (i.e. a vec2) as follows:\n// [ floor(color.r * 255) * 256 + color.g * 255,\n//   floor(color.b * 255) * 256 + color.g * 255 ]\nvec4 decode_color(const vec2 encodedColor) {\n    return vec4(\n        unpack_float(encodedColor[0]) / 255.0,\n        unpack_float(encodedColor[1]) / 255.0\n    );\n}\n\n// Unpack a pair of paint values and interpolate between them.\nfloat unpack_mix_vec2(const vec2 packedValue, const float t) {\n    return mix(packedValue[0], packedValue[1], t);\n}\n\n// Unpack a pair of paint values and interpolate between them.\nvec4 unpack_mix_vec4(const vec4 packedColors, const float t) {\n    vec4 minColor = decode_color(vec2(packedColors[0], packedColors[1]));\n    vec4 maxColor = decode_color(vec2(packedColors[2], packedColors[3]));\n    return mix(minColor, maxColor, t);\n}\n\n// The offset depends on how many pixels are between the world origin and the edge of the tile:\n// vec2 offset = mod(pixel_coord, size)\n//\n// At high zoom levels there are a ton of pixels between the world origin and the edge of the tile.\n// The glsl spec only guarantees 16 bits of precision for highp floats. We need more than that.\n//\n// The pixel_coord is passed in as two 16 bit values:\n// pixel_coord_upper = floor(pixel_coord / 2^16)\n// pixel_coord_lower = mod(pixel_coord, 2^16)\n//\n// The offset is calculated in a series of steps that should preserve this precision:\nvec2 get_pattern_pos(const vec2 pixel_coord_upper, const vec2 pixel_coord_lower,\n    const vec2 pattern_size, const float tile_units_to_pixels, const vec2 pos) {\n\n    vec2 offset = mod(mod(mod(pixel_coord_upper, pattern_size) * 256.0, pattern_size) * 256.0 + pixel_coord_lower, pattern_size);\n    return (tile_units_to_pixels * pos + offset) / pattern_size;\n}\n"},background:{fragmentSource:"uniform vec4 u_color;\nuniform float u_opacity;\n\nvoid main() {\n    gl_FragColor = u_color * u_opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n}\n"},backgroundPattern:{fragmentSource:"uniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform vec2 u_texsize;\nuniform float u_mix;\nuniform float u_opacity;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\n\nvoid main() {\n    vec2 imagecoord = mod(v_pos_a, 1.0);\n    vec2 pos = mix(u_pattern_tl_a / u_texsize, u_pattern_br_a / u_texsize, imagecoord);\n    vec4 color1 = texture2D(u_image, pos);\n\n    vec2 imagecoord_b = mod(v_pos_b, 1.0);\n    vec2 pos2 = mix(u_pattern_tl_b / u_texsize, u_pattern_br_b / u_texsize, imagecoord_b);\n    vec4 color2 = texture2D(u_image, pos2);\n\n    gl_FragColor = mix(color1, color2, u_mix) * u_opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pixel_coord_upper;\nuniform vec2 u_pixel_coord_lower;\nuniform float u_scale_a;\nuniform float u_scale_b;\nuniform float u_tile_units_to_pixels;\n\nattribute vec2 a_pos;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n\n    v_pos_a = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_a * u_pattern_size_a, u_tile_units_to_pixels, a_pos);\n    v_pos_b = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_b * u_pattern_size_b, u_tile_units_to_pixels, a_pos);\n}\n"},circle:{fragmentSource:"#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\n\nvarying vec3 v_data;\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize mediump float radius\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize highp vec4 stroke_color\n    #pragma mapbox: initialize mediump float stroke_width\n    #pragma mapbox: initialize lowp float stroke_opacity\n\n    vec2 extrude = v_data.xy;\n    float extrude_length = length(extrude);\n\n    lowp float antialiasblur = v_data.z;\n    float antialiased_blur = -max(blur, antialiasblur);\n\n    float opacity_t = smoothstep(0.0, antialiased_blur, extrude_length - 1.0);\n\n    float color_t = stroke_width < 0.01 ? 0.0 : smoothstep(\n        antialiased_blur,\n        0.0,\n        extrude_length - radius / (radius + stroke_width)\n    );\n\n    gl_FragColor = opacity_t * mix(color * opacity, stroke_color * stroke_opacity, color_t);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform bool u_scale_with_map;\nuniform bool u_pitch_with_map;\nuniform vec2 u_extrude_scale;\nuniform highp float u_camera_to_center_distance;\n\nattribute vec2 a_pos;\n\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\n\nvarying vec3 v_data;\n\nvoid main(void) {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize mediump float radius\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize highp vec4 stroke_color\n    #pragma mapbox: initialize mediump float stroke_width\n    #pragma mapbox: initialize lowp float stroke_opacity\n\n    // unencode the extrusion vector that we snuck into the a_pos vector\n    vec2 extrude = vec2(mod(a_pos, 2.0) * 2.0 - 1.0);\n\n    // multiply a_pos by 0.5, since we had it * 2 in order to sneak\n    // in extrusion data\n    vec2 circle_center = floor(a_pos * 0.5);\n    if (u_pitch_with_map) {\n        vec2 corner_position = circle_center;\n        if (u_scale_with_map) {\n            corner_position += extrude * (radius + stroke_width) * u_extrude_scale;\n        } else {\n            // Pitching the circle with the map effectively scales it with the map\n            // To counteract the effect for pitch-scale: viewport, we rescale the\n            // whole circle based on the pitch scaling effect at its central point\n            vec4 projected_center = u_matrix * vec4(circle_center, 0, 1);\n            corner_position += extrude * (radius + stroke_width) * u_extrude_scale * (projected_center.w / u_camera_to_center_distance);\n        }\n\n        gl_Position = u_matrix * vec4(corner_position, 0, 1);\n    } else {\n        gl_Position = u_matrix * vec4(circle_center, 0, 1);\n\n        if (u_scale_with_map) {\n            gl_Position.xy += extrude * (radius + stroke_width) * u_extrude_scale * u_camera_to_center_distance;\n        } else {\n            gl_Position.xy += extrude * (radius + stroke_width) * u_extrude_scale * gl_Position.w;\n        }\n    }\n\n    // This is a minimum blur distance that serves as a faux-antialiasing for\n    // the circle. since blur is a ratio of the circle's size and the intent is\n    // to keep the blur at roughly 1px, the two are inversely related.\n    lowp float antialiasblur = 1.0 / DEVICE_PIXEL_RATIO / (radius + stroke_width);\n\n    v_data = vec3(extrude.x, extrude.y, antialiasblur);\n}\n"},clippingMask:{fragmentSource:"void main() {\n    gl_FragColor = vec4(1.0);\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n}\n"},heatmap:{fragmentSource:"#pragma mapbox: define highp float weight\n\nuniform highp float u_intensity;\nvarying vec2 v_extrude;\n\n// Gaussian kernel coefficient: 1 / sqrt(2 * PI)\n#define GAUSS_COEF 0.3989422804014327\n\nvoid main() {\n    #pragma mapbox: initialize highp float weight\n\n    // Kernel density estimation with a Gaussian kernel of size 5x5\n    float d = -0.5 * 3.0 * 3.0 * dot(v_extrude, v_extrude);\n    float val = weight * u_intensity * GAUSS_COEF * exp(d);\n\n    gl_FragColor = vec4(val, 1.0, 1.0, 1.0);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\n\nuniform mat4 u_matrix;\nuniform float u_extrude_scale;\nuniform float u_opacity;\nuniform float u_intensity;\n\nattribute vec2 a_pos;\n\nvarying vec2 v_extrude;\n\n// Effective \"0\" in the kernel density texture to adjust the kernel size to;\n// this empirically chosen number minimizes artifacts on overlapping kernels\n// for typical heatmap cases (assuming clustered source)\nconst highp float ZERO = 1.0 / 255.0 / 16.0;\n\n// Gaussian kernel coefficient: 1 / sqrt(2 * PI)\n#define GAUSS_COEF 0.3989422804014327\n\nvoid main(void) {\n    #pragma mapbox: initialize highp float weight\n    #pragma mapbox: initialize mediump float radius\n\n    // unencode the extrusion vector that we snuck into the a_pos vector\n    vec2 unscaled_extrude = vec2(mod(a_pos, 2.0) * 2.0 - 1.0);\n\n    // This 'extrude' comes in ranging from [-1, -1], to [1, 1].  We'll use\n    // it to produce the vertices of a square mesh framing the point feature\n    // we're adding to the kernel density texture.  We'll also pass it as\n    // a varying, so that the fragment shader can determine the distance of\n    // each fragment from the point feature.\n    // Before we do so, we need to scale it up sufficiently so that the\n    // kernel falls effectively to zero at the edge of the mesh.\n    // That is, we want to know S such that\n    // weight * u_intensity * GAUSS_COEF * exp(-0.5 * 3.0^2 * S^2) == ZERO\n    // Which solves to:\n    // S = sqrt(-2.0 * log(ZERO / (weight * u_intensity * GAUSS_COEF))) / 3.0\n    float S = sqrt(-2.0 * log(ZERO / weight / u_intensity / GAUSS_COEF)) / 3.0;\n\n    // Pass the varying in units of radius\n    v_extrude = S * unscaled_extrude;\n\n    // Scale by radius and the zoom-based scale factor to produce actual\n    // mesh position\n    vec2 extrude = v_extrude * radius * u_extrude_scale;\n\n    // multiply a_pos by 0.5, since we had it * 2 in order to sneak\n    // in extrusion data\n    vec4 pos = vec4(floor(a_pos * 0.5) + extrude, 0, 1);\n\n    gl_Position = u_matrix * pos;\n}\n"},heatmapTexture:{fragmentSource:"uniform sampler2D u_image;\nuniform sampler2D u_color_ramp;\nuniform float u_opacity;\nvarying vec2 v_pos;\n\nvoid main() {\n    float t = texture2D(u_image, v_pos).r;\n    vec4 color = texture2D(u_color_ramp, vec2(t, 0.5));\n    gl_FragColor = color * u_opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(0.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_world;\nattribute vec2 a_pos;\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos * u_world, 0, 1);\n\n    v_pos.x = a_pos.x;\n    v_pos.y = 1.0 - a_pos.y;\n}\n"},collisionBox:{fragmentSource:"\nvarying float v_placed;\nvarying float v_notUsed;\n\nvoid main() {\n\n    float alpha = 0.5;\n\n    // Red = collision, hide label\n    gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0) * alpha;\n\n    // Blue = no collision, label is showing\n    if (v_placed > 0.5) {\n        gl_FragColor = vec4(0.0, 0.0, 1.0, 0.5) * alpha;\n    }\n\n    if (v_notUsed > 0.5) {\n        // This box not used, fade it out\n        gl_FragColor *= .1;\n    }\n}",vertexSource:"attribute vec2 a_pos;\nattribute vec2 a_anchor_pos;\nattribute vec2 a_extrude;\nattribute vec2 a_placed;\n\nuniform mat4 u_matrix;\nuniform vec2 u_extrude_scale;\nuniform float u_camera_to_center_distance;\n\nvarying float v_placed;\nvarying float v_notUsed;\n\nvoid main() {\n    vec4 projectedPoint = u_matrix * vec4(a_anchor_pos, 0, 1);\n    highp float camera_to_anchor_distance = projectedPoint.w;\n    highp float collision_perspective_ratio = clamp(\n        0.5 + 0.5 * (u_camera_to_center_distance / camera_to_anchor_distance),\n        0.0, // Prevents oversized near-field boxes in pitched/overzoomed tiles\n        4.0);\n\n    gl_Position = u_matrix * vec4(a_pos, 0.0, 1.0);\n    gl_Position.xy += a_extrude * u_extrude_scale * gl_Position.w * collision_perspective_ratio;\n\n    v_placed = a_placed.x;\n    v_notUsed = a_placed.y;\n}\n"},collisionCircle:{fragmentSource:"uniform float u_overscale_factor;\n\nvarying float v_placed;\nvarying float v_notUsed;\nvarying float v_radius;\nvarying vec2 v_extrude;\nvarying vec2 v_extrude_scale;\n\nvoid main() {\n    float alpha = 0.5;\n\n    // Red = collision, hide label\n    vec4 color = vec4(1.0, 0.0, 0.0, 1.0) * alpha;\n\n    // Blue = no collision, label is showing\n    if (v_placed > 0.5) {\n        color = vec4(0.0, 0.0, 1.0, 0.5) * alpha;\n    }\n\n    if (v_notUsed > 0.5) {\n        // This box not used, fade it out\n        color *= .2;\n    }\n\n    float extrude_scale_length = length(v_extrude_scale);\n    float extrude_length = length(v_extrude) * extrude_scale_length;\n    float stroke_width = 15.0 * extrude_scale_length / u_overscale_factor;\n    float radius = v_radius * extrude_scale_length;\n\n    float distance_to_edge = abs(extrude_length - radius);\n    float opacity_t = smoothstep(-stroke_width, 0.0, -distance_to_edge);\n\n    gl_FragColor = opacity_t * color;\n}\n",vertexSource:"attribute vec2 a_pos;\nattribute vec2 a_anchor_pos;\nattribute vec2 a_extrude;\nattribute vec2 a_placed;\n\nuniform mat4 u_matrix;\nuniform vec2 u_extrude_scale;\nuniform float u_camera_to_center_distance;\n\nvarying float v_placed;\nvarying float v_notUsed;\nvarying float v_radius;\n\nvarying vec2 v_extrude;\nvarying vec2 v_extrude_scale;\n\nvoid main() {\n    vec4 projectedPoint = u_matrix * vec4(a_anchor_pos, 0, 1);\n    highp float camera_to_anchor_distance = projectedPoint.w;\n    highp float collision_perspective_ratio = clamp(\n        0.5 + 0.5 * (u_camera_to_center_distance / camera_to_anchor_distance),\n        0.0, // Prevents oversized near-field circles in pitched/overzoomed tiles\n        4.0);\n\n    gl_Position = u_matrix * vec4(a_pos, 0.0, 1.0);\n\n    highp float padding_factor = 1.2; // Pad the vertices slightly to make room for anti-alias blur\n    gl_Position.xy += a_extrude * u_extrude_scale * padding_factor * gl_Position.w * collision_perspective_ratio;\n\n    v_placed = a_placed.x;\n    v_notUsed = a_placed.y;\n    v_radius = abs(a_extrude.y); // We don't pitch the circles, so both units of the extrusion vector are equal in magnitude to the radius\n\n    v_extrude = a_extrude * padding_factor;\n    v_extrude_scale = u_extrude_scale * u_camera_to_center_distance * collision_perspective_ratio;\n}\n"},debug:{fragmentSource:"uniform highp vec4 u_color;\n\nvoid main() {\n    gl_FragColor = u_color;\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n}\n"},fill:{fragmentSource:"#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_FragColor = color * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\n\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n}\n"},fillOutline:{fragmentSource:"#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n\nvarying vec2 v_pos;\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 outline_color\n    #pragma mapbox: initialize lowp float opacity\n\n    float dist = length(v_pos - gl_FragCoord.xy);\n    float alpha = 1.0 - smoothstep(0.0, 1.0, dist);\n    gl_FragColor = outline_color * (alpha * opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\nuniform vec2 u_world;\n\nvarying vec2 v_pos;\n\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 outline_color\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n    v_pos = (gl_Position.xy / gl_Position.w + 1.0) / 2.0 * u_world;\n}\n"},fillOutlinePattern:{fragmentSource:"uniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform vec2 u_texsize;\nuniform float u_mix;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec2 v_pos;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    vec2 imagecoord = mod(v_pos_a, 1.0);\n    vec2 pos = mix(u_pattern_tl_a / u_texsize, u_pattern_br_a / u_texsize, imagecoord);\n    vec4 color1 = texture2D(u_image, pos);\n\n    vec2 imagecoord_b = mod(v_pos_b, 1.0);\n    vec2 pos2 = mix(u_pattern_tl_b / u_texsize, u_pattern_br_b / u_texsize, imagecoord_b);\n    vec4 color2 = texture2D(u_image, pos2);\n\n    // find distance to outline for alpha interpolation\n\n    float dist = length(v_pos - gl_FragCoord.xy);\n    float alpha = 1.0 - smoothstep(0.0, 1.0, dist);\n\n\n    gl_FragColor = mix(color1, color2, u_mix) * alpha * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_world;\nuniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pixel_coord_upper;\nuniform vec2 u_pixel_coord_lower;\nuniform float u_scale_a;\nuniform float u_scale_b;\nuniform float u_tile_units_to_pixels;\n\nattribute vec2 a_pos;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec2 v_pos;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n\n    v_pos_a = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_a * u_pattern_size_a, u_tile_units_to_pixels, a_pos);\n    v_pos_b = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_b * u_pattern_size_b, u_tile_units_to_pixels, a_pos);\n\n    v_pos = (gl_Position.xy / gl_Position.w + 1.0) / 2.0 * u_world;\n}\n"},fillPattern:{fragmentSource:"uniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform vec2 u_texsize;\nuniform float u_mix;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    vec2 imagecoord = mod(v_pos_a, 1.0);\n    vec2 pos = mix(u_pattern_tl_a / u_texsize, u_pattern_br_a / u_texsize, imagecoord);\n    vec4 color1 = texture2D(u_image, pos);\n\n    vec2 imagecoord_b = mod(v_pos_b, 1.0);\n    vec2 pos2 = mix(u_pattern_tl_b / u_texsize, u_pattern_br_b / u_texsize, imagecoord_b);\n    vec4 color2 = texture2D(u_image, pos2);\n\n    gl_FragColor = mix(color1, color2, u_mix) * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pixel_coord_upper;\nuniform vec2 u_pixel_coord_lower;\nuniform float u_scale_a;\nuniform float u_scale_b;\nuniform float u_tile_units_to_pixels;\n\nattribute vec2 a_pos;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n\n    v_pos_a = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_a * u_pattern_size_a, u_tile_units_to_pixels, a_pos);\n    v_pos_b = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_b * u_pattern_size_b, u_tile_units_to_pixels, a_pos);\n}\n"},fillExtrusion:{fragmentSource:"varying vec4 v_color;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define highp vec4 color\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n    #pragma mapbox: initialize highp vec4 color\n\n    gl_FragColor = v_color;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec3 u_lightcolor;\nuniform lowp vec3 u_lightpos;\nuniform lowp float u_lightintensity;\n\nattribute vec2 a_pos;\nattribute vec4 a_normal_ed;\n\nvarying vec4 v_color;\n\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n\n#pragma mapbox: define highp vec4 color\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n    #pragma mapbox: initialize highp vec4 color\n\n    vec3 normal = a_normal_ed.xyz;\n\n    base = max(0.0, base);\n    height = max(0.0, height);\n\n    float t = mod(normal.x, 2.0);\n\n    gl_Position = u_matrix * vec4(a_pos, t > 0.0 ? height : base, 1);\n\n    // Relative luminance (how dark/bright is the surface color?)\n    float colorvalue = color.r * 0.2126 + color.g * 0.7152 + color.b * 0.0722;\n\n    v_color = vec4(0.0, 0.0, 0.0, 1.0);\n\n    // Add slight ambient lighting so no extrusions are totally black\n    vec4 ambientlight = vec4(0.03, 0.03, 0.03, 1.0);\n    color += ambientlight;\n\n    // Calculate cos(theta), where theta is the angle between surface normal and diffuse light ray\n    float directional = clamp(dot(normal / 16384.0, u_lightpos), 0.0, 1.0);\n\n    // Adjust directional so that\n    // the range of values for highlight/shading is narrower\n    // with lower light intensity\n    // and with lighter/brighter surface colors\n    directional = mix((1.0 - u_lightintensity), max((1.0 - colorvalue + u_lightintensity), 1.0), directional);\n\n    // Add gradient along z axis of side surfaces\n    if (normal.y != 0.0) {\n        directional *= clamp((t + base) * pow(height / 150.0, 0.5), mix(0.7, 0.98, 1.0 - u_lightintensity), 1.0);\n    }\n\n    // Assign final color based on surface + ambient light color, diffuse light directional, and light color\n    // with lower bounds adjusted to hue of light\n    // so that shading is tinted with the complementary (opposite) color to the light color\n    v_color.r += clamp(color.r * directional * u_lightcolor.r, mix(0.0, 0.3, 1.0 - u_lightcolor.r), 1.0);\n    v_color.g += clamp(color.g * directional * u_lightcolor.g, mix(0.0, 0.3, 1.0 - u_lightcolor.g), 1.0);\n    v_color.b += clamp(color.b * directional * u_lightcolor.b, mix(0.0, 0.3, 1.0 - u_lightcolor.b), 1.0);\n}\n"},fillExtrusionPattern:{fragmentSource:"uniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform vec2 u_texsize;\nuniform float u_mix;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec4 v_lighting;\n\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n\n    vec2 imagecoord = mod(v_pos_a, 1.0);\n    vec2 pos = mix(u_pattern_tl_a / u_texsize, u_pattern_br_a / u_texsize, imagecoord);\n    vec4 color1 = texture2D(u_image, pos);\n\n    vec2 imagecoord_b = mod(v_pos_b, 1.0);\n    vec2 pos2 = mix(u_pattern_tl_b / u_texsize, u_pattern_br_b / u_texsize, imagecoord_b);\n    vec4 color2 = texture2D(u_image, pos2);\n\n    vec4 mixedColor = mix(color1, color2, u_mix);\n\n    gl_FragColor = mixedColor * v_lighting;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pixel_coord_upper;\nuniform vec2 u_pixel_coord_lower;\nuniform float u_scale_a;\nuniform float u_scale_b;\nuniform float u_tile_units_to_pixels;\nuniform float u_height_factor;\n\nuniform vec3 u_lightcolor;\nuniform lowp vec3 u_lightpos;\nuniform lowp float u_lightintensity;\n\nattribute vec2 a_pos;\nattribute vec4 a_normal_ed;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec4 v_lighting;\nvarying float v_directional;\n\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n\n    vec3 normal = a_normal_ed.xyz;\n    float edgedistance = a_normal_ed.w;\n\n    base = max(0.0, base);\n    height = max(0.0, height);\n\n    float t = mod(normal.x, 2.0);\n    float z = t > 0.0 ? height : base;\n\n    gl_Position = u_matrix * vec4(a_pos, z, 1);\n\n    vec2 pos = normal.x == 1.0 && normal.y == 0.0 && normal.z == 16384.0\n        ? a_pos // extrusion top\n        : vec2(edgedistance, z * u_height_factor); // extrusion side\n\n    v_pos_a = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_a * u_pattern_size_a, u_tile_units_to_pixels, pos);\n    v_pos_b = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_b * u_pattern_size_b, u_tile_units_to_pixels, pos);\n\n    v_lighting = vec4(0.0, 0.0, 0.0, 1.0);\n    float directional = clamp(dot(normal / 16383.0, u_lightpos), 0.0, 1.0);\n    directional = mix((1.0 - u_lightintensity), max((0.5 + u_lightintensity), 1.0), directional);\n\n    if (normal.y != 0.0) {\n        directional *= clamp((t + base) * pow(height / 150.0, 0.5), mix(0.7, 0.98, 1.0 - u_lightintensity), 1.0);\n    }\n\n    v_lighting.rgb += clamp(directional * u_lightcolor, mix(vec3(0.0), vec3(0.3), 1.0 - u_lightcolor), vec3(1.0));\n}\n"},extrusionTexture:{fragmentSource:"uniform sampler2D u_image;\nuniform float u_opacity;\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_FragColor = texture2D(u_image, v_pos) * u_opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(0.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_world;\nattribute vec2 a_pos;\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos * u_world, 0, 1);\n\n    v_pos.x = a_pos.x;\n    v_pos.y = 1.0 - a_pos.y;\n}\n"},hillshadePrepare:{fragmentSource:"#ifdef GL_ES\nprecision highp float;\n#endif\n\nuniform sampler2D u_image;\nvarying vec2 v_pos;\nuniform vec2 u_dimension;\nuniform float u_zoom;\nuniform float u_maxzoom;\n\nfloat getElevation(vec2 coord, float bias) {\n    // Convert encoded elevation value to meters\n    vec4 data = texture2D(u_image, coord) * 255.0;\n    return (data.r + data.g * 256.0 + data.b * 256.0 * 256.0) / 4.0;\n}\n\nvoid main() {\n    vec2 epsilon = 1.0 / u_dimension;\n\n    // queried pixels:\n    // +-----------+\n    // |   |   |   |\n    // | a | b | c |\n    // |   |   |   |\n    // +-----------+\n    // |   |   |   |\n    // | d | e | f |\n    // |   |   |   |\n    // +-----------+\n    // |   |   |   |\n    // | g | h | i |\n    // |   |   |   |\n    // +-----------+\n\n    float a = getElevation(v_pos + vec2(-epsilon.x, -epsilon.y), 0.0);\n    float b = getElevation(v_pos + vec2(0, -epsilon.y), 0.0);\n    float c = getElevation(v_pos + vec2(epsilon.x, -epsilon.y), 0.0);\n    float d = getElevation(v_pos + vec2(-epsilon.x, 0), 0.0);\n    float e = getElevation(v_pos, 0.0);\n    float f = getElevation(v_pos + vec2(epsilon.x, 0), 0.0);\n    float g = getElevation(v_pos + vec2(-epsilon.x, epsilon.y), 0.0);\n    float h = getElevation(v_pos + vec2(0, epsilon.y), 0.0);\n    float i = getElevation(v_pos + vec2(epsilon.x, epsilon.y), 0.0);\n\n    // here we divide the x and y slopes by 8 * pixel size\n    // where pixel size (aka meters/pixel) is:\n    // circumference of the world / (pixels per tile * number of tiles)\n    // which is equivalent to: 8 * 40075016.6855785 / (512 * pow(2, u_zoom))\n    // which can be reduced to: pow(2, 19.25619978527 - u_zoom)\n    // we want to vertically exaggerate the hillshading though, because otherwise\n    // it is barely noticeable at low zooms. to do this, we multiply this by some\n    // scale factor pow(2, (u_zoom - u_maxzoom) * a) where a is an arbitrary value\n    // Here we use a=0.3 which works out to the expression below. see \n    // nickidlugash's awesome breakdown for more info\n    // https://github.com/mapbox/mapbox-gl-js/pull/5286#discussion_r148419556\n    float exaggeration = u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;\n\n    vec2 deriv = vec2(\n        (c + f + f + i) - (a + d + d + g),\n        (g + h + h + i) - (a + b + b + c)\n    ) /  pow(2.0, (u_zoom - u_maxzoom) * exaggeration + 19.2562 - u_zoom);\n\n    gl_FragColor = clamp(vec4(\n        deriv.x / 2.0 + 0.5,\n        deriv.y / 2.0 + 0.5,\n        1.0,\n        1.0), 0.0, 1.0);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\n\nattribute vec2 a_pos;\nattribute vec2 a_texture_pos;\n\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n    v_pos = (a_texture_pos / 8192.0) / 2.0 + 0.25;\n}\n"},hillshade:{fragmentSource:"uniform sampler2D u_image;\nvarying vec2 v_pos;\n\nuniform vec2 u_latrange;\nuniform vec2 u_light;\nuniform vec4 u_shadow;\nuniform vec4 u_highlight;\nuniform vec4 u_accent;\n\n#define PI 3.141592653589793\n\nvoid main() {\n    vec4 pixel = texture2D(u_image, v_pos);\n\n    vec2 deriv = ((pixel.rg * 2.0) - 1.0);\n\n    // We divide the slope by a scale factor based on the cosin of the pixel's approximate latitude\n    // to account for mercator projection distortion. see #4807 for details\n    float scaleFactor = cos(radians((u_latrange[0] - u_latrange[1]) * (1.0 - v_pos.y) + u_latrange[1]));\n    // We also multiply the slope by an arbitrary z-factor of 1.25\n    float slope = atan(1.25 * length(deriv) / scaleFactor);\n    float aspect = deriv.x != 0.0 ? atan(deriv.y, -deriv.x) : PI / 2.0 * (deriv.y > 0.0 ? 1.0 : -1.0);\n\n    float intensity = u_light.x;\n    // We add PI to make this property match the global light object, which adds PI/2 to the light's azimuthal\n    // position property to account for 0deg corresponding to north/the top of the viewport in the style spec\n    // and the original shader was written to accept (-illuminationDirection - 90) as the azimuthal.\n    float azimuth = u_light.y + PI;\n\n    // We scale the slope exponentially based on intensity, using a calculation similar to\n    // the exponential interpolation function in the style spec:\n    // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/expression/definitions/interpolate.js#L217-L228\n    // so that higher intensity values create more opaque hillshading.\n    float base = 1.875 - intensity * 1.75;\n    float maxValue = 0.5 * PI;\n    float scaledSlope = intensity != 0.5 ? ((pow(base, slope) - 1.0) / (pow(base, maxValue) - 1.0)) * maxValue : slope;\n\n    // The accent color is calculated with the cosine of the slope while the shade color is calculated with the sine\n    // so that the accent color's rate of change eases in while the shade color's eases out.\n    float accent = cos(scaledSlope);\n    // We multiply both the accent and shade color by a clamped intensity value\n    // so that intensities >= 0.5 do not additionally affect the color values\n    // while intensity values < 0.5 make the overall color more transparent.\n    vec4 accent_color = (1.0 - accent) * u_accent * clamp(intensity * 2.0, 0.0, 1.0);\n    float shade = abs(mod((aspect + azimuth) / PI + 0.5, 2.0) - 1.0);\n    vec4 shade_color = mix(u_shadow, u_highlight, shade) * sin(scaledSlope) * clamp(intensity * 2.0, 0.0, 1.0);\n    gl_FragColor = accent_color * (1.0 - shade_color.a) + shade_color;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\n\nattribute vec2 a_pos;\nattribute vec2 a_texture_pos;\n\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n    v_pos = a_texture_pos / 8192.0;\n}\n"},line:{fragmentSource:"#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n\nvarying vec2 v_width2;\nvarying vec2 v_normal;\nvarying float v_gamma_scale;\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n\n    // Calculate the distance of the pixel from the line in pixels.\n    float dist = length(v_normal) * v_width2.s;\n\n    // Calculate the antialiasing fade factor. This is either when fading in\n    // the line in case of an offset line (v_width2.t) or when fading out\n    // (v_width2.s)\n    float blur2 = (blur + 1.0 / DEVICE_PIXEL_RATIO) * v_gamma_scale;\n    float alpha = clamp(min(dist - (v_width2.t - blur2), v_width2.s - dist) / blur2, 0.0, 1.0);\n\n    gl_FragColor = color * (alpha * opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"\n\n// the distance over which the line edge fades out.\n// Retina devices need a smaller distance to avoid aliasing.\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n\n// floor(127 / 2) == 63.0\n// the maximum allowed miter limit is 2.0 at the moment. the extrude normal is\n// stored in a byte (-128..127). we scale regular normals up to length 63, but\n// there are also \"special\" normals that have a bigger length (of up to 126 in\n// this case).\n// #define scale 63.0\n#define scale 0.015873016\n\nattribute vec4 a_pos_normal;\nattribute vec4 a_data;\n\nuniform mat4 u_matrix;\nuniform mediump float u_ratio;\nuniform vec2 u_gl_units_to_pixels;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying float v_gamma_scale;\nvarying highp float v_linesofar;\n\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize mediump float gapwidth\n    #pragma mapbox: initialize lowp float offset\n    #pragma mapbox: initialize mediump float width\n\n    vec2 a_extrude = a_data.xy - 128.0;\n    float a_direction = mod(a_data.z, 4.0) - 1.0;\n\n    v_linesofar = (floor(a_data.z / 4.0) + a_data.w * 64.0) * 2.0;\n\n    vec2 pos = a_pos_normal.xy;\n\n    // x is 1 if it's a round cap, 0 otherwise\n    // y is 1 if the normal points up, and -1 if it points down\n    mediump vec2 normal = a_pos_normal.zw;\n    v_normal = normal;\n\n    // these transformations used to be applied in the JS and native code bases.\n    // moved them into the shader for clarity and simplicity.\n    gapwidth = gapwidth / 2.0;\n    float halfwidth = width / 2.0;\n    offset = -1.0 * offset;\n\n    float inset = gapwidth + (gapwidth > 0.0 ? ANTIALIASING : 0.0);\n    float outset = gapwidth + halfwidth * (gapwidth > 0.0 ? 2.0 : 1.0) + (halfwidth == 0.0 ? 0.0 : ANTIALIASING);\n\n    // Scale the extrusion vector down to a normal and then up by the line width\n    // of this vertex.\n    mediump vec2 dist = outset * a_extrude * scale;\n\n    // Calculate the offset when drawing a line that is to the side of the actual line.\n    // We do this by creating a vector that points towards the extrude, but rotate\n    // it when we're drawing round end points (a_direction = -1 or 1) since their\n    // extrude vector points in another direction.\n    mediump float u = 0.5 * a_direction;\n    mediump float t = 1.0 - abs(u);\n    mediump vec2 offset2 = offset * a_extrude * scale * normal.y * mat2(t, -u, u, t);\n\n    vec4 projected_extrude = u_matrix * vec4(dist / u_ratio, 0.0, 0.0);\n    gl_Position = u_matrix * vec4(pos + offset2 / u_ratio, 0.0, 1.0) + projected_extrude;\n\n    // calculate how much the perspective view squishes or stretches the extrude\n    float extrude_length_without_perspective = length(dist);\n    float extrude_length_with_perspective = length(projected_extrude.xy / gl_Position.w * u_gl_units_to_pixels);\n    v_gamma_scale = extrude_length_without_perspective / extrude_length_with_perspective;\n\n    v_width2 = vec2(outset, inset);\n}\n"},lineGradient:{fragmentSource:"\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n\nuniform sampler2D u_image;\n\nvarying vec2 v_width2;\nvarying vec2 v_normal;\nvarying float v_gamma_scale;\nvarying highp float v_lineprogress;\n\nvoid main() {\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n\n    // Calculate the distance of the pixel from the line in pixels.\n    float dist = length(v_normal) * v_width2.s;\n\n    // Calculate the antialiasing fade factor. This is either when fading in\n    // the line in case of an offset line (v_width2.t) or when fading out\n    // (v_width2.s)\n    float blur2 = (blur + 1.0 / DEVICE_PIXEL_RATIO) * v_gamma_scale;\n    float alpha = clamp(min(dist - (v_width2.t - blur2), v_width2.s - dist) / blur2, 0.0, 1.0);\n\n    // For gradient lines, v_lineprogress is the ratio along the entire line,\n    // scaled to [0, 2^15), and the gradient ramp is stored in a texture.\n    vec4 color = texture2D(u_image, vec2(v_lineprogress, 0.5));\n\n    gl_FragColor = color * (alpha * opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"\n// the attribute conveying progress along a line is scaled to [0, 2^15)\n#define MAX_LINE_DISTANCE 32767.0\n\n// the distance over which the line edge fades out.\n// Retina devices need a smaller distance to avoid aliasing.\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n\n// floor(127 / 2) == 63.0\n// the maximum allowed miter limit is 2.0 at the moment. the extrude normal is\n// stored in a byte (-128..127). we scale regular normals up to length 63, but\n// there are also \"special\" normals that have a bigger length (of up to 126 in\n// this case).\n// #define scale 63.0\n#define scale 0.015873016\n\nattribute vec4 a_pos_normal;\nattribute vec4 a_data;\n\nuniform mat4 u_matrix;\nuniform mediump float u_ratio;\nuniform vec2 u_gl_units_to_pixels;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying float v_gamma_scale;\nvarying highp float v_lineprogress;\n\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n\nvoid main() {\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize mediump float gapwidth\n    #pragma mapbox: initialize lowp float offset\n    #pragma mapbox: initialize mediump float width\n\n    vec2 a_extrude = a_data.xy - 128.0;\n    float a_direction = mod(a_data.z, 4.0) - 1.0;\n\n    v_lineprogress = (floor(a_data.z / 4.0) + a_data.w * 64.0) * 2.0 / MAX_LINE_DISTANCE;\n\n    vec2 pos = a_pos_normal.xy;\n\n    // x is 1 if it's a round cap, 0 otherwise\n    // y is 1 if the normal points up, and -1 if it points down\n    mediump vec2 normal = a_pos_normal.zw;\n    v_normal = normal;\n\n    // these transformations used to be applied in the JS and native code bases.\n    // moved them into the shader for clarity and simplicity.\n    gapwidth = gapwidth / 2.0;\n    float halfwidth = width / 2.0;\n    offset = -1.0 * offset;\n\n    float inset = gapwidth + (gapwidth > 0.0 ? ANTIALIASING : 0.0);\n    float outset = gapwidth + halfwidth * (gapwidth > 0.0 ? 2.0 : 1.0) + (halfwidth == 0.0 ? 0.0 : ANTIALIASING);\n\n    // Scale the extrusion vector down to a normal and then up by the line width\n    // of this vertex.\n    mediump vec2 dist = outset * a_extrude * scale;\n\n    // Calculate the offset when drawing a line that is to the side of the actual line.\n    // We do this by creating a vector that points towards the extrude, but rotate\n    // it when we're drawing round end points (a_direction = -1 or 1) since their\n    // extrude vector points in another direction.\n    mediump float u = 0.5 * a_direction;\n    mediump float t = 1.0 - abs(u);\n    mediump vec2 offset2 = offset * a_extrude * scale * normal.y * mat2(t, -u, u, t);\n\n    vec4 projected_extrude = u_matrix * vec4(dist / u_ratio, 0.0, 0.0);\n    gl_Position = u_matrix * vec4(pos + offset2 / u_ratio, 0.0, 1.0) + projected_extrude;\n\n    // calculate how much the perspective view squishes or stretches the extrude\n    float extrude_length_without_perspective = length(dist);\n    float extrude_length_with_perspective = length(projected_extrude.xy / gl_Position.w * u_gl_units_to_pixels);\n    v_gamma_scale = extrude_length_without_perspective / extrude_length_with_perspective;\n\n    v_width2 = vec2(outset, inset);\n}\n"},linePattern:{fragmentSource:"uniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform vec2 u_texsize;\nuniform float u_fade;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying float v_linesofar;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n\n    // Calculate the distance of the pixel from the line in pixels.\n    float dist = length(v_normal) * v_width2.s;\n\n    // Calculate the antialiasing fade factor. This is either when fading in\n    // the line in case of an offset line (v_width2.t) or when fading out\n    // (v_width2.s)\n    float blur2 = (blur + 1.0 / DEVICE_PIXEL_RATIO) * v_gamma_scale;\n    float alpha = clamp(min(dist - (v_width2.t - blur2), v_width2.s - dist) / blur2, 0.0, 1.0);\n\n    float x_a = mod(v_linesofar / u_pattern_size_a.x, 1.0);\n    float x_b = mod(v_linesofar / u_pattern_size_b.x, 1.0);\n\n    // v_normal.y is 0 at the midpoint of the line, -1 at the lower edge, 1 at the upper edge\n    // we clamp the line width outset to be between 0 and half the pattern height plus padding (2.0)\n    // to ensure we don't sample outside the designated symbol on the sprite sheet.\n    // 0.5 is added to shift the component to be bounded between 0 and 1 for interpolation of\n    // the texture coordinate\n    float y_a = 0.5 + (v_normal.y * clamp(v_width2.s, 0.0, (u_pattern_size_a.y + 2.0) / 2.0) / u_pattern_size_a.y);\n    float y_b = 0.5 + (v_normal.y * clamp(v_width2.s, 0.0, (u_pattern_size_b.y + 2.0) / 2.0) / u_pattern_size_b.y);\n    vec2 pos_a = mix(u_pattern_tl_a / u_texsize, u_pattern_br_a / u_texsize, vec2(x_a, y_a));\n    vec2 pos_b = mix(u_pattern_tl_b / u_texsize, u_pattern_br_b / u_texsize, vec2(x_b, y_b));\n\n    vec4 color = mix(texture2D(u_image, pos_a), texture2D(u_image, pos_b), u_fade);\n\n    gl_FragColor = color * alpha * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"// floor(127 / 2) == 63.0\n// the maximum allowed miter limit is 2.0 at the moment. the extrude normal is\n// stored in a byte (-128..127). we scale regular normals up to length 63, but\n// there are also \"special\" normals that have a bigger length (of up to 126 in\n// this case).\n// #define scale 63.0\n#define scale 0.015873016\n\n// We scale the distance before adding it to the buffers so that we can store\n// long distances for long segments. Use this value to unscale the distance.\n#define LINE_DISTANCE_SCALE 2.0\n\n// the distance over which the line edge fades out.\n// Retina devices need a smaller distance to avoid aliasing.\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n\nattribute vec4 a_pos_normal;\nattribute vec4 a_data;\n\nuniform mat4 u_matrix;\nuniform mediump float u_ratio;\nuniform vec2 u_gl_units_to_pixels;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying float v_linesofar;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n\nvoid main() {\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize lowp float offset\n    #pragma mapbox: initialize mediump float gapwidth\n    #pragma mapbox: initialize mediump float width\n\n    vec2 a_extrude = a_data.xy - 128.0;\n    float a_direction = mod(a_data.z, 4.0) - 1.0;\n    float a_linesofar = (floor(a_data.z / 4.0) + a_data.w * 64.0) * LINE_DISTANCE_SCALE;\n\n    vec2 pos = a_pos_normal.xy;\n\n    // x is 1 if it's a round cap, 0 otherwise\n    // y is 1 if the normal points up, and -1 if it points down\n    mediump vec2 normal = a_pos_normal.zw;\n    v_normal = normal;\n\n    // these transformations used to be applied in the JS and native code bases.\n    // moved them into the shader for clarity and simplicity.\n    gapwidth = gapwidth / 2.0;\n    float halfwidth = width / 2.0;\n    offset = -1.0 * offset;\n\n    float inset = gapwidth + (gapwidth > 0.0 ? ANTIALIASING : 0.0);\n    float outset = gapwidth + halfwidth * (gapwidth > 0.0 ? 2.0 : 1.0) + (halfwidth == 0.0 ? 0.0 : ANTIALIASING);\n\n    // Scale the extrusion vector down to a normal and then up by the line width\n    // of this vertex.\n    mediump vec2 dist = outset * a_extrude * scale;\n\n    // Calculate the offset when drawing a line that is to the side of the actual line.\n    // We do this by creating a vector that points towards the extrude, but rotate\n    // it when we're drawing round end points (a_direction = -1 or 1) since their\n    // extrude vector points in another direction.\n    mediump float u = 0.5 * a_direction;\n    mediump float t = 1.0 - abs(u);\n    mediump vec2 offset2 = offset * a_extrude * scale * normal.y * mat2(t, -u, u, t);\n\n    vec4 projected_extrude = u_matrix * vec4(dist / u_ratio, 0.0, 0.0);\n    gl_Position = u_matrix * vec4(pos + offset2 / u_ratio, 0.0, 1.0) + projected_extrude;\n\n    // calculate how much the perspective view squishes or stretches the extrude\n    float extrude_length_without_perspective = length(dist);\n    float extrude_length_with_perspective = length(projected_extrude.xy / gl_Position.w * u_gl_units_to_pixels);\n    v_gamma_scale = extrude_length_without_perspective / extrude_length_with_perspective;\n\n    v_linesofar = a_linesofar;\n    v_width2 = vec2(outset, inset);\n}\n"},lineSDF:{fragmentSource:"\nuniform sampler2D u_image;\nuniform float u_sdfgamma;\nuniform float u_mix;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying vec2 v_tex_a;\nvarying vec2 v_tex_b;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize mediump float width\n    #pragma mapbox: initialize lowp float floorwidth\n\n    // Calculate the distance of the pixel from the line in pixels.\n    float dist = length(v_normal) * v_width2.s;\n\n    // Calculate the antialiasing fade factor. This is either when fading in\n    // the line in case of an offset line (v_width2.t) or when fading out\n    // (v_width2.s)\n    float blur2 = (blur + 1.0 / DEVICE_PIXEL_RATIO) * v_gamma_scale;\n    float alpha = clamp(min(dist - (v_width2.t - blur2), v_width2.s - dist) / blur2, 0.0, 1.0);\n\n    float sdfdist_a = texture2D(u_image, v_tex_a).a;\n    float sdfdist_b = texture2D(u_image, v_tex_b).a;\n    float sdfdist = mix(sdfdist_a, sdfdist_b, u_mix);\n    alpha *= smoothstep(0.5 - u_sdfgamma / floorwidth, 0.5 + u_sdfgamma / floorwidth, sdfdist);\n\n    gl_FragColor = color * (alpha * opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"// floor(127 / 2) == 63.0\n// the maximum allowed miter limit is 2.0 at the moment. the extrude normal is\n// stored in a byte (-128..127). we scale regular normals up to length 63, but\n// there are also \"special\" normals that have a bigger length (of up to 126 in\n// this case).\n// #define scale 63.0\n#define scale 0.015873016\n\n// We scale the distance before adding it to the buffers so that we can store\n// long distances for long segments. Use this value to unscale the distance.\n#define LINE_DISTANCE_SCALE 2.0\n\n// the distance over which the line edge fades out.\n// Retina devices need a smaller distance to avoid aliasing.\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n\nattribute vec4 a_pos_normal;\nattribute vec4 a_data;\n\nuniform mat4 u_matrix;\nuniform mediump float u_ratio;\nuniform vec2 u_patternscale_a;\nuniform float u_tex_y_a;\nuniform vec2 u_patternscale_b;\nuniform float u_tex_y_b;\nuniform vec2 u_gl_units_to_pixels;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying vec2 v_tex_a;\nvarying vec2 v_tex_b;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize mediump float gapwidth\n    #pragma mapbox: initialize lowp float offset\n    #pragma mapbox: initialize mediump float width\n    #pragma mapbox: initialize lowp float floorwidth\n\n    vec2 a_extrude = a_data.xy - 128.0;\n    float a_direction = mod(a_data.z, 4.0) - 1.0;\n    float a_linesofar = (floor(a_data.z / 4.0) + a_data.w * 64.0) * LINE_DISTANCE_SCALE;\n\n    vec2 pos = a_pos_normal.xy;\n\n    // x is 1 if it's a round cap, 0 otherwise\n    // y is 1 if the normal points up, and -1 if it points down\n    mediump vec2 normal = a_pos_normal.zw;\n    v_normal = normal;\n\n    // these transformations used to be applied in the JS and native code bases.\n    // moved them into the shader for clarity and simplicity.\n    gapwidth = gapwidth / 2.0;\n    float halfwidth = width / 2.0;\n    offset = -1.0 * offset;\n\n    float inset = gapwidth + (gapwidth > 0.0 ? ANTIALIASING : 0.0);\n    float outset = gapwidth + halfwidth * (gapwidth > 0.0 ? 2.0 : 1.0) + (halfwidth == 0.0 ? 0.0 : ANTIALIASING);\n\n    // Scale the extrusion vector down to a normal and then up by the line width\n    // of this vertex.\n    mediump vec2 dist =outset * a_extrude * scale;\n\n    // Calculate the offset when drawing a line that is to the side of the actual line.\n    // We do this by creating a vector that points towards the extrude, but rotate\n    // it when we're drawing round end points (a_direction = -1 or 1) since their\n    // extrude vector points in another direction.\n    mediump float u = 0.5 * a_direction;\n    mediump float t = 1.0 - abs(u);\n    mediump vec2 offset2 = offset * a_extrude * scale * normal.y * mat2(t, -u, u, t);\n\n    vec4 projected_extrude = u_matrix * vec4(dist / u_ratio, 0.0, 0.0);\n    gl_Position = u_matrix * vec4(pos + offset2 / u_ratio, 0.0, 1.0) + projected_extrude;\n\n    // calculate how much the perspective view squishes or stretches the extrude\n    float extrude_length_without_perspective = length(dist);\n    float extrude_length_with_perspective = length(projected_extrude.xy / gl_Position.w * u_gl_units_to_pixels);\n    v_gamma_scale = extrude_length_without_perspective / extrude_length_with_perspective;\n\n    v_tex_a = vec2(a_linesofar * u_patternscale_a.x / floorwidth, normal.y * u_patternscale_a.y + u_tex_y_a);\n    v_tex_b = vec2(a_linesofar * u_patternscale_b.x / floorwidth, normal.y * u_patternscale_b.y + u_tex_y_b);\n\n    v_width2 = vec2(outset, inset);\n}\n"},raster:{fragmentSource:"uniform float u_fade_t;\nuniform float u_opacity;\nuniform sampler2D u_image0;\nuniform sampler2D u_image1;\nvarying vec2 v_pos0;\nvarying vec2 v_pos1;\n\nuniform float u_brightness_low;\nuniform float u_brightness_high;\n\nuniform float u_saturation_factor;\nuniform float u_contrast_factor;\nuniform vec3 u_spin_weights;\n\nvoid main() {\n\n    // read and cross-fade colors from the main and parent tiles\n    vec4 color0 = texture2D(u_image0, v_pos0);\n    vec4 color1 = texture2D(u_image1, v_pos1);\n    if (color0.a > 0.0) {\n        color0.rgb = color0.rgb / color0.a;\n    }\n    if (color1.a > 0.0) {\n        color1.rgb = color1.rgb / color1.a;\n    }\n    vec4 color = mix(color0, color1, u_fade_t);\n    color.a *= u_opacity;\n    vec3 rgb = color.rgb;\n\n    // spin\n    rgb = vec3(\n        dot(rgb, u_spin_weights.xyz),\n        dot(rgb, u_spin_weights.zxy),\n        dot(rgb, u_spin_weights.yzx));\n\n    // saturation\n    float average = (color.r + color.g + color.b) / 3.0;\n    rgb += (average - rgb) * u_saturation_factor;\n\n    // contrast\n    rgb = (rgb - 0.5) * u_contrast_factor + 0.5;\n\n    // brightness\n    vec3 u_high_vec = vec3(u_brightness_low, u_brightness_low, u_brightness_low);\n    vec3 u_low_vec = vec3(u_brightness_high, u_brightness_high, u_brightness_high);\n\n    gl_FragColor = vec4(mix(u_high_vec, u_low_vec, rgb) * color.a, color.a);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_tl_parent;\nuniform float u_scale_parent;\nuniform float u_buffer_scale;\n\nattribute vec2 a_pos;\nattribute vec2 a_texture_pos;\n\nvarying vec2 v_pos0;\nvarying vec2 v_pos1;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n    // We are using Int16 for texture position coordinates to give us enough precision for\n    // fractional coordinates. We use 8192 to scale the texture coordinates in the buffer\n    // as an arbitrarily high number to preserve adequate precision when rendering.\n    // This is also the same value as the EXTENT we are using for our tile buffer pos coordinates,\n    // so math for modifying either is consistent.\n    v_pos0 = (((a_texture_pos / 8192.0) - 0.5) / u_buffer_scale ) + 0.5;\n    v_pos1 = (v_pos0 * u_scale_parent) + u_tl_parent;\n}\n"},symbolIcon:{fragmentSource:"uniform sampler2D u_texture;\n\n#pragma mapbox: define lowp float opacity\n\nvarying vec2 v_tex;\nvarying float v_fade_opacity;\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    lowp float alpha = opacity * v_fade_opacity;\n    gl_FragColor = texture2D(u_texture, v_tex) * alpha;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"const float PI = 3.141592653589793;\n\nattribute vec4 a_pos_offset;\nattribute vec4 a_data;\nattribute vec3 a_projected_pos;\nattribute float a_fade_opacity;\n\nuniform bool u_is_size_zoom_constant;\nuniform bool u_is_size_feature_constant;\nuniform highp float u_size_t; // used to interpolate between zoom stops when size is a composite function\nuniform highp float u_size; // used when size is both zoom and feature constant\nuniform highp float u_camera_to_center_distance;\nuniform highp float u_pitch;\nuniform bool u_rotate_symbol;\nuniform highp float u_aspect_ratio;\nuniform float u_fade_change;\n\n#pragma mapbox: define lowp float opacity\n\nuniform mat4 u_matrix;\nuniform mat4 u_label_plane_matrix;\nuniform mat4 u_gl_coord_matrix;\n\nuniform bool u_is_text;\nuniform bool u_pitch_with_map;\n\nuniform vec2 u_texsize;\n\nvarying vec2 v_tex;\nvarying float v_fade_opacity;\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    vec2 a_pos = a_pos_offset.xy;\n    vec2 a_offset = a_pos_offset.zw;\n\n    vec2 a_tex = a_data.xy;\n    vec2 a_size = a_data.zw;\n\n    highp float segment_angle = -a_projected_pos[2];\n\n    float size;\n    if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {\n        size = mix(a_size[0], a_size[1], u_size_t) / 10.0;\n    } else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {\n        size = a_size[0] / 10.0;\n    } else if (!u_is_size_zoom_constant && u_is_size_feature_constant) {\n        size = u_size;\n    } else {\n        size = u_size;\n    }\n\n    vec4 projectedPoint = u_matrix * vec4(a_pos, 0, 1);\n    highp float camera_to_anchor_distance = projectedPoint.w;\n    // See comments in symbol_sdf.vertex\n    highp float distance_ratio = u_pitch_with_map ?\n        camera_to_anchor_distance / u_camera_to_center_distance :\n        u_camera_to_center_distance / camera_to_anchor_distance;\n    highp float perspective_ratio = clamp(\n            0.5 + 0.5 * distance_ratio,\n            0.0, // Prevents oversized near-field symbols in pitched/overzoomed tiles\n            4.0);\n\n    size *= perspective_ratio;\n\n    float fontScale = u_is_text ? size / 24.0 : size;\n\n    highp float symbol_rotation = 0.0;\n    if (u_rotate_symbol) {\n        // See comments in symbol_sdf.vertex\n        vec4 offsetProjectedPoint = u_matrix * vec4(a_pos + vec2(1, 0), 0, 1);\n\n        vec2 a = projectedPoint.xy / projectedPoint.w;\n        vec2 b = offsetProjectedPoint.xy / offsetProjectedPoint.w;\n\n        symbol_rotation = atan((b.y - a.y) / u_aspect_ratio, b.x - a.x);\n    }\n\n    highp float angle_sin = sin(segment_angle + symbol_rotation);\n    highp float angle_cos = cos(segment_angle + symbol_rotation);\n    mat2 rotation_matrix = mat2(angle_cos, -1.0 * angle_sin, angle_sin, angle_cos);\n\n    vec4 projected_pos = u_label_plane_matrix * vec4(a_projected_pos.xy, 0.0, 1.0);\n    gl_Position = u_gl_coord_matrix * vec4(projected_pos.xy / projected_pos.w + rotation_matrix * (a_offset / 32.0 * fontScale), 0.0, 1.0);\n\n    v_tex = a_tex / u_texsize;\n    vec2 fade_opacity = unpack_opacity(a_fade_opacity);\n    float fade_change = fade_opacity[1] > 0.5 ? u_fade_change : -u_fade_change;\n    v_fade_opacity = max(0.0, min(1.0, fade_opacity[0] + fade_change));\n}\n"},symbolSDF:{fragmentSource:"#define SDF_PX 8.0\n#define EDGE_GAMMA 0.105/DEVICE_PIXEL_RATIO\n\nuniform bool u_is_halo;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n\nuniform sampler2D u_texture;\nuniform highp float u_gamma_scale;\nuniform bool u_is_text;\n\nvarying vec2 v_data0;\nvarying vec3 v_data1;\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 fill_color\n    #pragma mapbox: initialize highp vec4 halo_color\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize lowp float halo_width\n    #pragma mapbox: initialize lowp float halo_blur\n\n    vec2 tex = v_data0.xy;\n    float gamma_scale = v_data1.x;\n    float size = v_data1.y;\n    float fade_opacity = v_data1[2];\n\n    float fontScale = u_is_text ? size / 24.0 : size;\n\n    lowp vec4 color = fill_color;\n    highp float gamma = EDGE_GAMMA / (fontScale * u_gamma_scale);\n    lowp float buff = (256.0 - 64.0) / 256.0;\n    if (u_is_halo) {\n        color = halo_color;\n        gamma = (halo_blur * 1.19 / SDF_PX + EDGE_GAMMA) / (fontScale * u_gamma_scale);\n        buff = (6.0 - halo_width / fontScale) / SDF_PX;\n    }\n\n    lowp float dist = texture2D(u_texture, tex).a;\n    highp float gamma_scaled = gamma * gamma_scale;\n    highp float alpha = smoothstep(buff - gamma_scaled, buff + gamma_scaled, dist);\n\n    gl_FragColor = color * (alpha * opacity * fade_opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"const float PI = 3.141592653589793;\n\nattribute vec4 a_pos_offset;\nattribute vec4 a_data;\nattribute vec3 a_projected_pos;\nattribute float a_fade_opacity;\n\n// contents of a_size vary based on the type of property value\n// used for {text,icon}-size.\n// For constants, a_size is disabled.\n// For source functions, we bind only one value per vertex: the value of {text,icon}-size evaluated for the current feature.\n// For composite functions:\n// [ text-size(lowerZoomStop, feature),\n//   text-size(upperZoomStop, feature) ]\nuniform bool u_is_size_zoom_constant;\nuniform bool u_is_size_feature_constant;\nuniform highp float u_size_t; // used to interpolate between zoom stops when size is a composite function\nuniform highp float u_size; // used when size is both zoom and feature constant\n\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n\nuniform mat4 u_matrix;\nuniform mat4 u_label_plane_matrix;\nuniform mat4 u_gl_coord_matrix;\n\nuniform bool u_is_text;\nuniform bool u_pitch_with_map;\nuniform highp float u_pitch;\nuniform bool u_rotate_symbol;\nuniform highp float u_aspect_ratio;\nuniform highp float u_camera_to_center_distance;\nuniform float u_fade_change;\n\nuniform vec2 u_texsize;\n\nvarying vec2 v_data0;\nvarying vec3 v_data1;\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 fill_color\n    #pragma mapbox: initialize highp vec4 halo_color\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize lowp float halo_width\n    #pragma mapbox: initialize lowp float halo_blur\n\n    vec2 a_pos = a_pos_offset.xy;\n    vec2 a_offset = a_pos_offset.zw;\n\n    vec2 a_tex = a_data.xy;\n    vec2 a_size = a_data.zw;\n\n    highp float segment_angle = -a_projected_pos[2];\n    float size;\n\n    if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {\n        size = mix(a_size[0], a_size[1], u_size_t) / 10.0;\n    } else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {\n        size = a_size[0] / 10.0;\n    } else if (!u_is_size_zoom_constant && u_is_size_feature_constant) {\n        size = u_size;\n    } else {\n        size = u_size;\n    }\n\n    vec4 projectedPoint = u_matrix * vec4(a_pos, 0, 1);\n    highp float camera_to_anchor_distance = projectedPoint.w;\n    // If the label is pitched with the map, layout is done in pitched space,\n    // which makes labels in the distance smaller relative to viewport space.\n    // We counteract part of that effect by multiplying by the perspective ratio.\n    // If the label isn't pitched with the map, we do layout in viewport space,\n    // which makes labels in the distance larger relative to the features around\n    // them. We counteract part of that effect by dividing by the perspective ratio.\n    highp float distance_ratio = u_pitch_with_map ?\n        camera_to_anchor_distance / u_camera_to_center_distance :\n        u_camera_to_center_distance / camera_to_anchor_distance;\n    highp float perspective_ratio = clamp(\n        0.5 + 0.5 * distance_ratio,\n        0.0, // Prevents oversized near-field symbols in pitched/overzoomed tiles\n        4.0);\n\n    size *= perspective_ratio;\n\n    float fontScale = u_is_text ? size / 24.0 : size;\n\n    highp float symbol_rotation = 0.0;\n    if (u_rotate_symbol) {\n        // Point labels with 'rotation-alignment: map' are horizontal with respect to tile units\n        // To figure out that angle in projected space, we draw a short horizontal line in tile\n        // space, project it, and measure its angle in projected space.\n        vec4 offsetProjectedPoint = u_matrix * vec4(a_pos + vec2(1, 0), 0, 1);\n\n        vec2 a = projectedPoint.xy / projectedPoint.w;\n        vec2 b = offsetProjectedPoint.xy / offsetProjectedPoint.w;\n\n        symbol_rotation = atan((b.y - a.y) / u_aspect_ratio, b.x - a.x);\n    }\n\n    highp float angle_sin = sin(segment_angle + symbol_rotation);\n    highp float angle_cos = cos(segment_angle + symbol_rotation);\n    mat2 rotation_matrix = mat2(angle_cos, -1.0 * angle_sin, angle_sin, angle_cos);\n\n    vec4 projected_pos = u_label_plane_matrix * vec4(a_projected_pos.xy, 0.0, 1.0);\n    gl_Position = u_gl_coord_matrix * vec4(projected_pos.xy / projected_pos.w + rotation_matrix * (a_offset / 32.0 * fontScale), 0.0, 1.0);\n    float gamma_scale = gl_Position.w;\n\n    vec2 tex = a_tex / u_texsize;\n    vec2 fade_opacity = unpack_opacity(a_fade_opacity);\n    float fade_change = fade_opacity[1] > 0.5 ? u_fade_change : -u_fade_change;\n    float interpolated_fade_opacity = max(0.0, min(1.0, fade_opacity[0] + fade_change));\n\n    v_data0 = vec2(tex.x, tex.y);\n    v_data1 = vec3(gamma_scale, size, interpolated_fade_opacity);\n}\n"}},Xe=/#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,He=function(t){var e=We[t],i={};e.fragmentSource=e.fragmentSource.replace(Xe,function(t,e,n,o,r){return i[r]=!0,"define"===e?"\n#ifndef HAS_UNIFORM_u_"+r+"\nvarying "+n+" "+o+" "+r+";\n#else\nuniform "+n+" "+o+" u_"+r+";\n#endif\n":"\n#ifdef HAS_UNIFORM_u_"+r+"\n    "+n+" "+o+" "+r+" = u_"+r+";\n#endif\n"}),e.vertexSource=e.vertexSource.replace(Xe,function(t,e,n,o,r){var a="float"===o?"vec2":"vec4";return i[r]?"define"===e?"\n#ifndef HAS_UNIFORM_u_"+r+"\nuniform lowp float a_"+r+"_t;\nattribute "+n+" "+a+" a_"+r+";\nvarying "+n+" "+o+" "+r+";\n#else\nuniform "+n+" "+o+" u_"+r+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+r+"\n    "+r+" = unpack_mix_"+a+"(a_"+r+", a_"+r+"_t);\n#else\n    "+n+" "+o+" "+r+" = u_"+r+";\n#endif\n":"define"===e?"\n#ifndef HAS_UNIFORM_u_"+r+"\nuniform lowp float a_"+r+"_t;\nattribute "+n+" "+a+" a_"+r+";\n#else\nuniform "+n+" "+o+" u_"+r+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+r+"\n    "+n+" "+o+" "+r+" = unpack_mix_"+a+"(a_"+r+", a_"+r+"_t);\n#else\n    "+n+" "+o+" "+r+" = u_"+r+";\n#endif\n"});};for(var Ke in We)He(Ke);var Ye=We,Je=function(e,i,n,o){var r=e.gl;this.program=r.createProgram();var a=n.defines().concat("#define DEVICE_PIXEL_RATIO "+t.browser.devicePixelRatio.toFixed(1));o&&a.push("#define OVERDRAW_INSPECTOR;");var s=a.concat(Ye.prelude.fragmentSource,i.fragmentSource).join("\n"),l=a.concat(Ye.prelude.vertexSource,i.vertexSource).join("\n"),c=r.createShader(r.FRAGMENT_SHADER);r.shaderSource(c,s),r.compileShader(c),r.attachShader(this.program,c);var h=r.createShader(r.VERTEX_SHADER);r.shaderSource(h,l),r.compileShader(h),r.attachShader(this.program,h);for(var u=n.layoutAttributes||[],p=0;p<u.length;p++)r.bindAttribLocation(this.program,p,u[p].name);r.linkProgram(this.program),this.numAttributes=r.getProgramParameter(this.program,r.ACTIVE_ATTRIBUTES),this.attributes={},this.uniforms={};for(var d=0;d<this.numAttributes;d++){var f=r.getActiveAttrib(this.program,d);f&&(this.attributes[f.name]=r.getAttribLocation(this.program,f.name));}for(var m=r.getProgramParameter(this.program,r.ACTIVE_UNIFORMS),_=0;_<m;_++){var g=r.getActiveUniform(this.program,_);g&&(this.uniforms[g.name]=r.getUniformLocation(this.program,g.name));}};function Qe(e,i){for(var n=e.sort(function(t,e){return t.tileID.isLessThan(e.tileID)?-1:e.tileID.isLessThan(t.tileID)?1:0}),o=0;o<n.length;o++){var r={},a=n[o],s=n.slice(o+1);$e(a.tileID.wrapped(),a.tileID,s,new t.OverscaledTileID(0,a.tileID.wrap+1,0,0,0),r),a.setMask(r,i);}}function $e(e,i,n,o,r){for(var a=0;a<n.length;a++){var s=n[a];if(o.isLessThan(s.tileID))break;if(i.key===s.tileID.key)return;if(s.tileID.isChildOf(i)){for(var l=i.children(1/0),c=0;c<l.length;c++){$e(e,l[c],n.slice(a),o,r);}return}}var h=i.overscaledZ-e.overscaledZ,u=new t.CanonicalTileID(h,i.canonical.x-(e.canonical.x<<h),i.canonical.y-(e.canonical.y<<h));r[u.key]=r[u.key]||u;}function ti(t,e,i,n,o){var r=t.context,a=r.gl,s=o?t.useProgram("collisionCircle"):t.useProgram("collisionBox");r.setDepthMode(Lt.disabled),r.setStencilMode(kt.disabled),r.setColorMode(t.colorModeForRenderPass());for(var l=0;l<n.length;l++){var c=n[l],h=e.getTile(c),u=h.getBucket(i);if(u){var p=o?u.collisionCircle:u.collisionBox;if(p){a.uniformMatrix4fv(s.uniforms.u_matrix,!1,c.posMatrix),a.uniform1f(s.uniforms.u_camera_to_center_distance,t.transform.cameraToCenterDistance);var d=ye(h,1,t.transform.zoom),f=Math.pow(2,t.transform.zoom-h.tileID.overscaledZ);a.uniform1f(s.uniforms.u_pixels_to_tile_units,d),a.uniform2f(s.uniforms.u_extrude_scale,t.transform.pixelsToGLUnits[0]/(d*f),t.transform.pixelsToGLUnits[1]/(d*f)),a.uniform1f(s.uniforms.u_overscale_factor,h.tileID.overscaleFactor()),s.draw(r,o?a.TRIANGLES:a.LINES,i.id,p.layoutVertexBuffer,p.indexBuffer,p.segments,null,p.collisionVertexBuffer,null);}}}}Je.prototype.draw=function(t,e,i,n,o,r,a,s,l){for(var c,h=t.gl,u=(c={},c[h.LINES]=2,c[h.TRIANGLES]=3,c)[e],p=0,d=r.get();p<d.length;p+=1){var f=d[p],m=f.vaos||(f.vaos={});(m[i]||(m[i]=new W)).bind(t,this,n,a?a.getPaintVertexBuffers():[],o,f.vertexOffset,s,l),h.drawElements(e,f.primitiveLength*u,h.UNSIGNED_SHORT,f.primitiveOffset*u*2);}};var ei=t.identity(new Float32Array(16)),ii=t.properties.layout;function ni(t,e,i,n,o,r,a,s,l,c){var h,u=t.context,p=u.gl,d=t.transform,f="map"===s,m="map"===l,_=f&&"point"!==i.layout.get("symbol-placement"),g=f&&!m&&!_,v=m;u.setDepthMode(v?t.depthModeForSublayer(0,Lt.ReadOnly):Lt.disabled);for(var y=0,x=n;y<x.length;y+=1){var b=x[y],w=e.getTile(b),E=w.getBucket(i);if(E){var T=o?E.text:E.icon;if(T&&T.segments.get().length){var I=T.programConfigurations.get(i.id),S=o||E.sdfIcons,C=o?E.textSizeData:E.iconSizeData;if(h||(h=t.useProgram(S?"symbolSDF":"symbolIcon",I),I.setUniforms(t.context,h,i.paint,{zoom:t.transform.zoom}),oi(h,t,i,o,g,m,C)),u.activeTexture.set(p.TEXTURE0),p.uniform1i(h.uniforms.u_texture,0),o)w.glyphAtlasTexture.bind(p.LINEAR,p.CLAMP_TO_EDGE),p.uniform2fv(h.uniforms.u_texsize,w.glyphAtlasTexture.size);else{var z=1!==i.layout.get("icon-size").constantOr(0)||E.iconsNeedLinear,P=m||0!==d.pitch;w.iconAtlasTexture.bind(S||t.options.rotating||t.options.zooming||z||P?p.LINEAR:p.NEAREST,p.CLAMP_TO_EDGE),p.uniform2fv(h.uniforms.u_texsize,w.iconAtlasTexture.size);}p.uniformMatrix4fv(h.uniforms.u_matrix,!1,t.translatePosMatrix(b.posMatrix,w,r,a));var A=ye(w,1,t.transform.zoom),D=oe(b.posMatrix,m,f,t.transform,A),R=re(b.posMatrix,m,f,t.transform,A);p.uniformMatrix4fv(h.uniforms.u_gl_coord_matrix,!1,t.translatePosMatrix(R,w,r,a,!0)),_?(p.uniformMatrix4fv(h.uniforms.u_label_plane_matrix,!1,ei),le(E,b.posMatrix,t,o,D,R,m,c)):p.uniformMatrix4fv(h.uniforms.u_label_plane_matrix,!1,D),p.uniform1f(h.uniforms.u_fade_change,t.options.fadeDuration?t.symbolFadeChange:1),ri(h,I,t,i,w,T,o,S,m);}}}}function oi(e,i,n,o,r,a,s){var l=i.context.gl,c=i.transform;l.uniform1i(e.uniforms.u_pitch_with_map,a?1:0),l.uniform1f(e.uniforms.u_is_text,o?1:0),l.uniform1f(e.uniforms.u_pitch,c.pitch/360*2*Math.PI);var h="constant"===s.functionType||"source"===s.functionType,u="constant"===s.functionType||"camera"===s.functionType;l.uniform1i(e.uniforms.u_is_size_zoom_constant,h?1:0),l.uniform1i(e.uniforms.u_is_size_feature_constant,u?1:0),l.uniform1f(e.uniforms.u_camera_to_center_distance,c.cameraToCenterDistance);var p=t.evaluateSizeForZoom(s,c.zoom,ii.properties[o?"text-size":"icon-size"]);void 0!==p.uSizeT&&l.uniform1f(e.uniforms.u_size_t,p.uSizeT),void 0!==p.uSize&&l.uniform1f(e.uniforms.u_size,p.uSize),l.uniform1f(e.uniforms.u_aspect_ratio,c.width/c.height),l.uniform1i(e.uniforms.u_rotate_symbol,r?1:0);}function ri(t,e,i,n,o,r,a,s,l){var c=i.context,h=c.gl,u=i.transform;if(s){var p=0!==n.paint.get(a?"text-halo-width":"icon-halo-width").constantOr(1),d=l?Math.cos(u._pitch)*u.cameraToCenterDistance:1;h.uniform1f(t.uniforms.u_gamma_scale,d),p&&(h.uniform1f(t.uniforms.u_is_halo,1),ai(r,n,c,t)),h.uniform1f(t.uniforms.u_is_halo,0);}ai(r,n,c,t);}function ai(t,e,i,n){n.draw(i,i.gl.TRIANGLES,e.id,t.layoutVertexBuffer,t.indexBuffer,t.segments,t.programConfigurations.get(e.id),t.dynamicLayoutVertexBuffer,t.opacityVertexBuffer);}function si(e,i,n,o,r,a,s,l,c){var h,u,p,d,f=i.context,m=f.gl,_=r.paint.get("line-dasharray"),g=r.paint.get("line-pattern");if(l||c){var v=1/ye(n,1,i.transform.tileZoom);if(_){h=i.lineAtlas.getDash(_.from,"round"===r.layout.get("line-cap")),u=i.lineAtlas.getDash(_.to,"round"===r.layout.get("line-cap"));var y=h.width*_.fromScale,x=u.width*_.toScale;m.uniform2f(e.uniforms.u_patternscale_a,v/y,-h.height/2),m.uniform2f(e.uniforms.u_patternscale_b,v/x,-u.height/2),m.uniform1f(e.uniforms.u_sdfgamma,i.lineAtlas.width/(256*Math.min(y,x)*t.browser.devicePixelRatio)/2);}else if(g){if(p=i.imageManager.getPattern(g.from),d=i.imageManager.getPattern(g.to),!p||!d)return;m.uniform2f(e.uniforms.u_pattern_size_a,p.displaySize[0]*g.fromScale/v,p.displaySize[1]),m.uniform2f(e.uniforms.u_pattern_size_b,d.displaySize[0]*g.toScale/v,d.displaySize[1]);var b=i.imageManager.getPixelSize(),w=b.width,E=b.height;m.uniform2fv(e.uniforms.u_texsize,[w,E]);}m.uniform2f(e.uniforms.u_gl_units_to_pixels,1/i.transform.pixelsToGLUnits[0],1/i.transform.pixelsToGLUnits[1]);}l&&(_?(m.uniform1i(e.uniforms.u_image,0),f.activeTexture.set(m.TEXTURE0),i.lineAtlas.bind(f),m.uniform1f(e.uniforms.u_tex_y_a,h.y),m.uniform1f(e.uniforms.u_tex_y_b,u.y),m.uniform1f(e.uniforms.u_mix,_.t)):g&&(m.uniform1i(e.uniforms.u_image,0),f.activeTexture.set(m.TEXTURE0),i.imageManager.bind(f),m.uniform2fv(e.uniforms.u_pattern_tl_a,p.tl),m.uniform2fv(e.uniforms.u_pattern_br_a,p.br),m.uniform2fv(e.uniforms.u_pattern_tl_b,d.tl),m.uniform2fv(e.uniforms.u_pattern_br_b,d.br),m.uniform1f(e.uniforms.u_fade,g.t))),f.setStencilMode(i.stencilModeForClipping(a));var T=i.translatePosMatrix(a.posMatrix,n,r.paint.get("line-translate"),r.paint.get("line-translate-anchor"));if(m.uniformMatrix4fv(e.uniforms.u_matrix,!1,T),m.uniform1f(e.uniforms.u_ratio,1/ye(n,1,i.transform.zoom)),r.paint.get("line-gradient")){f.activeTexture.set(m.TEXTURE0);var I=r.gradientTexture;if(!r.gradient)return;I||(I=r.gradientTexture=new t.Texture(f,r.gradient,m.RGBA)),I.bind(m.LINEAR,m.CLAMP_TO_EDGE),m.uniform1i(e.uniforms.u_image,0);}e.draw(f,m.TRIANGLES,r.id,o.layoutVertexBuffer,o.indexBuffer,o.segments,s);}var li=function(t,e){if(!t)return !1;var i=e.imageManager.getPattern(t.from),n=e.imageManager.getPattern(t.to);return !i||!n},ci=function(t,e,i){var n=e.context,o=n.gl,r=e.imageManager.getPattern(t.from),a=e.imageManager.getPattern(t.to);o.uniform1i(i.uniforms.u_image,0),o.uniform2fv(i.uniforms.u_pattern_tl_a,r.tl),o.uniform2fv(i.uniforms.u_pattern_br_a,r.br),o.uniform2fv(i.uniforms.u_pattern_tl_b,a.tl),o.uniform2fv(i.uniforms.u_pattern_br_b,a.br);var s=e.imageManager.getPixelSize(),l=s.width,c=s.height;o.uniform2fv(i.uniforms.u_texsize,[l,c]),o.uniform1f(i.uniforms.u_mix,t.t),o.uniform2fv(i.uniforms.u_pattern_size_a,r.displaySize),o.uniform2fv(i.uniforms.u_pattern_size_b,a.displaySize),o.uniform1f(i.uniforms.u_scale_a,t.fromScale),o.uniform1f(i.uniforms.u_scale_b,t.toScale),n.activeTexture.set(o.TEXTURE0),e.imageManager.bind(e.context);},hi=function(t,e,i){var n=e.context.gl;n.uniform1f(i.uniforms.u_tile_units_to_pixels,1/ye(t,1,e.transform.tileZoom));var o=Math.pow(2,t.tileID.overscaledZ),r=t.tileSize*Math.pow(2,e.transform.tileZoom)/o,a=r*(t.tileID.canonical.x+t.tileID.wrap*o),s=r*t.tileID.canonical.y;n.uniform2f(i.uniforms.u_pixel_coord_upper,a>>16,s>>16),n.uniform2f(i.uniforms.u_pixel_coord_lower,65535&a,65535&s);};function ui(t,e,i,n,o){if(!li(i.paint.get("fill-pattern"),t))for(var r=!0,a=0,s=n;a<s.length;a+=1){var l=s[a],c=e.getTile(l),h=c.getBucket(i);h&&(t.context.setStencilMode(t.stencilModeForClipping(l)),o(t,e,i,c,l,h,r),r=!1);}}function pi(t,e,i,n,o,r,a){var s=t.context.gl,l=r.programConfigurations.get(i.id);fi("fill",i.paint.get("fill-pattern"),t,l,i,n,o,a).draw(t.context,s.TRIANGLES,i.id,r.layoutVertexBuffer,r.indexBuffer,r.segments,l);}function di(t,e,i,n,o,r,a){var s=t.context.gl,l=r.programConfigurations.get(i.id),c=fi("fillOutline",i.getPaintProperty("fill-outline-color")?null:i.paint.get("fill-pattern"),t,l,i,n,o,a);s.uniform2f(c.uniforms.u_world,s.drawingBufferWidth,s.drawingBufferHeight),c.draw(t.context,s.LINES,i.id,r.layoutVertexBuffer,r.indexBuffer2,r.segments2,l);}function fi(t,e,i,n,o,r,a,s){var l,c=i.context.program.get();return e?(l=i.useProgram(t+"Pattern",n),(s||l.program!==c)&&(n.setUniforms(i.context,l,o.paint,{zoom:i.transform.zoom}),ci(e,i,l)),hi(r,i,l)):(l=i.useProgram(t,n),(s||l.program!==c)&&n.setUniforms(i.context,l,o.paint,{zoom:i.transform.zoom})),i.context.gl.uniformMatrix4fv(l.uniforms.u_matrix,!1,i.translatePosMatrix(a.posMatrix,r,o.paint.get("fill-translate"),o.paint.get("fill-translate-anchor"))),l}function mi(e,i,n,o,r,a,s){var l=e.context,c=l.gl,h=n.paint.get("fill-extrusion-pattern"),u=e.context.program.get(),p=a.programConfigurations.get(n.id),d=e.useProgram(h?"fillExtrusionPattern":"fillExtrusion",p);if((s||d.program!==u)&&p.setUniforms(l,d,n.paint,{zoom:e.transform.zoom}),h){if(li(h,e))return;ci(h,e,d),hi(o,e,d),c.uniform1f(d.uniforms.u_height_factor,-Math.pow(2,r.overscaledZ)/o.tileSize/8);}e.context.gl.uniformMatrix4fv(d.uniforms.u_matrix,!1,e.translatePosMatrix(r.posMatrix,o,n.paint.get("fill-extrusion-translate"),n.paint.get("fill-extrusion-translate-anchor"))),function(e,i){var n=i.context.gl,o=i.style.light,r=o.properties.get("position"),a=[r.x,r.y,r.z],s=t.create$2();"viewport"===o.properties.get("anchor")&&t.fromRotation(s,-i.transform.angle);t.transformMat3(a,a,s);var l=o.properties.get("color");n.uniform3fv(e.uniforms.u_lightpos,a),n.uniform1f(e.uniforms.u_lightintensity,o.properties.get("intensity")),n.uniform3f(e.uniforms.u_lightcolor,l.r,l.g,l.b);}(d,e),d.draw(l,c.TRIANGLES,n.id,a.layoutVertexBuffer,a.indexBuffer,a.segments,p);}function _i(e,i,n){var o=e.context,r=o.gl,a=i.fbo;if(a){var s=e.useProgram("hillshade"),l=e.transform.calculatePosMatrix(i.tileID.toUnwrapped(),!0);!function(t,e,i){var n=i.paint.get("hillshade-illumination-direction")*(Math.PI/180);"viewport"===i.paint.get("hillshade-illumination-anchor")&&(n-=e.transform.angle),e.context.gl.uniform2f(t.uniforms.u_light,i.paint.get("hillshade-exaggeration"),n);}(s,e,n);var c=function(e,i){var n=i.toCoordinate(),o=new t.Coordinate(n.column,n.row+1,n.zoom);return [e.transform.coordinateLocation(n).lat,e.transform.coordinateLocation(o).lat]}(e,i.tileID);o.activeTexture.set(r.TEXTURE0),r.bindTexture(r.TEXTURE_2D,a.colorAttachment.get()),r.uniformMatrix4fv(s.uniforms.u_matrix,!1,l),r.uniform2fv(s.uniforms.u_latrange,c),r.uniform1i(s.uniforms.u_image,0);var h=n.paint.get("hillshade-shadow-color");r.uniform4f(s.uniforms.u_shadow,h.r,h.g,h.b,h.a);var u=n.paint.get("hillshade-highlight-color");r.uniform4f(s.uniforms.u_highlight,u.r,u.g,u.b,u.a);var p=n.paint.get("hillshade-accent-color");if(r.uniform4f(s.uniforms.u_accent,p.r,p.g,p.b,p.a),i.maskedBoundsBuffer&&i.maskedIndexBuffer&&i.segments)s.draw(o,r.TRIANGLES,n.id,i.maskedBoundsBuffer,i.maskedIndexBuffer,i.segments);else{var d=e.rasterBoundsBuffer;e.rasterBoundsVAO.bind(o,s,d,[]),r.drawArrays(r.TRIANGLE_STRIP,0,d.length);}}}function gi(e,i,n){var o=e.context,r=o.gl;if(i.dem&&i.dem.data){var a=i.dem.dim,s=i.dem.getPixels();if(o.activeTexture.set(r.TEXTURE1),o.pixelStoreUnpackPremultiplyAlpha.set(!1),i.demTexture=i.demTexture||e.getTileTexture(i.tileSize),i.demTexture){var l=i.demTexture;l.update(s,{premultiply:!1}),l.bind(r.NEAREST,r.CLAMP_TO_EDGE);}else i.demTexture=new t.Texture(o,s,r.RGBA,{premultiply:!1}),i.demTexture.bind(r.NEAREST,r.CLAMP_TO_EDGE);o.activeTexture.set(r.TEXTURE0);var c=i.fbo;if(!c){var h=new t.Texture(o,{width:a,height:a,data:null},r.RGBA);h.bind(r.LINEAR,r.CLAMP_TO_EDGE),(c=i.fbo=o.createFramebuffer(a,a)).colorAttachment.set(h.texture);}o.bindFramebuffer.set(c.framebuffer),o.viewport.set([0,0,a,a]);var u=t.create();t.ortho(u,0,t.EXTENT,-t.EXTENT,0,0,1),t.translate(u,u,[0,-t.EXTENT,0]);var p=e.useProgram("hillshadePrepare");r.uniformMatrix4fv(p.uniforms.u_matrix,!1,u),r.uniform1f(p.uniforms.u_zoom,i.tileID.overscaledZ),r.uniform2fv(p.uniforms.u_dimension,[2*a,2*a]),r.uniform1i(p.uniforms.u_image,1),r.uniform1f(p.uniforms.u_maxzoom,n);var d=e.rasterBoundsBuffer;e.rasterBoundsVAO.bind(o,p,d,[]),r.drawArrays(r.TRIANGLE_STRIP,0,d.length),i.needsHillshadePrepare=!1;}}function vi(e,i,n,o,r){var a=o.paint.get("raster-fade-duration");if(a>0){var s=t.browser.now(),l=(s-e.timeAdded)/a,c=i?(s-i.timeAdded)/a:-1,h=n.getSource(),u=r.coveringZoomLevel({tileSize:h.tileSize,roundZoom:h.roundZoom}),p=!i||Math.abs(i.tileID.overscaledZ-u)>Math.abs(e.tileID.overscaledZ-u),d=p&&e.refreshedUponExpiration?1:t.clamp(p?l:1-c,0,1);return e.refreshedUponExpiration&&l>=1&&(e.refreshedUponExpiration=!1),i?{opacity:1,mix:1-d}:{opacity:d,mix:0}}return {opacity:1,mix:0}}function yi(e,i,n){var o=e.context,r=o.gl,a=n.posMatrix,s=e.useProgram("debug");o.setDepthMode(Lt.disabled),o.setStencilMode(kt.disabled),o.setColorMode(e.colorModeForRenderPass()),r.uniformMatrix4fv(s.uniforms.u_matrix,!1,a),r.uniform4f(s.uniforms.u_color,1,0,0,1),e.debugVAO.bind(o,s,e.debugBuffer,[]),r.drawArrays(r.LINE_STRIP,0,e.debugBuffer.length);for(var l=function(t,e,i,n){n=n||1;var o,r,a,s,l,c,h,u,p=[];for(o=0,r=t.length;o<r;o++)if(l=xi[t[o]]){for(u=null,a=0,s=l[1].length;a<s;a+=2)-1===l[1][a]&&-1===l[1][a+1]?u=null:(c=e+l[1][a]*n,h=i-l[1][a+1]*n,u&&p.push(u.x,u.y,c,h),u={x:c,y:h});e+=l[0]*n;}return p}(n.toString(),50,200,5),c=new t.StructArrayLayout2i4,h=0;h<l.length;h+=2)c.emplaceBack(l[h],l[h+1]);var u=o.createVertexBuffer(c,Ge.members);(new W).bind(o,s,u,[]),r.uniform4f(s.uniforms.u_color,1,1,1,1);for(var p=i.getTile(n).tileSize,d=t.EXTENT/(Math.pow(2,e.transform.zoom-n.overscaledZ)*p),f=[[-1,-1],[-1,1],[1,-1],[1,1]],m=0;m<f.length;m++){var _=f[m];r.uniformMatrix4fv(s.uniforms.u_matrix,!1,t.translate([],a,[d*_[0],d*_[1],0])),r.drawArrays(r.LINES,0,u.length);}r.uniform4f(s.uniforms.u_color,0,0,0,1),r.uniformMatrix4fv(s.uniforms.u_matrix,!1,a),r.drawArrays(r.LINES,0,u.length);}var xi={" ":[16,[]],"!":[10,[5,21,5,7,-1,-1,5,2,4,1,5,0,6,1,5,2]],'"':[16,[4,21,4,14,-1,-1,12,21,12,14]],"#":[21,[11,25,4,-7,-1,-1,17,25,10,-7,-1,-1,4,12,18,12,-1,-1,3,6,17,6]],$:[20,[8,25,8,-4,-1,-1,12,25,12,-4,-1,-1,17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],"%":[24,[21,21,3,0,-1,-1,8,21,10,19,10,17,9,15,7,14,5,14,3,16,3,18,4,20,6,21,8,21,10,20,13,19,16,19,19,20,21,21,-1,-1,17,7,15,6,14,4,14,2,16,0,18,0,20,1,21,3,21,5,19,7,17,7]],"&":[26,[23,12,23,13,22,14,21,14,20,13,19,11,17,6,15,3,13,1,11,0,7,0,5,1,4,2,3,4,3,6,4,8,5,9,12,13,13,14,14,16,14,18,13,20,11,21,9,20,8,18,8,16,9,13,11,10,16,3,18,1,20,0,22,0,23,1,23,2]],"'":[10,[5,19,4,20,5,21,6,20,6,18,5,16,4,15]],"(":[14,[11,25,9,23,7,20,5,16,4,11,4,7,5,2,7,-2,9,-5,11,-7]],")":[14,[3,25,5,23,7,20,9,16,10,11,10,7,9,2,7,-2,5,-5,3,-7]],"*":[16,[8,21,8,9,-1,-1,3,18,13,12,-1,-1,13,18,3,12]],"+":[26,[13,18,13,0,-1,-1,4,9,22,9]],",":[10,[6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"-":[26,[4,9,22,9]],".":[10,[5,2,4,1,5,0,6,1,5,2]],"/":[22,[20,25,2,-7]],0:[20,[9,21,6,20,4,17,3,12,3,9,4,4,6,1,9,0,11,0,14,1,16,4,17,9,17,12,16,17,14,20,11,21,9,21]],1:[20,[6,17,8,18,11,21,11,0]],2:[20,[4,16,4,17,5,19,6,20,8,21,12,21,14,20,15,19,16,17,16,15,15,13,13,10,3,0,17,0]],3:[20,[5,21,16,21,10,13,13,13,15,12,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],4:[20,[13,21,3,7,18,7,-1,-1,13,21,13,0]],5:[20,[15,21,5,21,4,12,5,13,8,14,11,14,14,13,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],6:[20,[16,18,15,20,12,21,10,21,7,20,5,17,4,12,4,7,5,3,7,1,10,0,11,0,14,1,16,3,17,6,17,7,16,10,14,12,11,13,10,13,7,12,5,10,4,7]],7:[20,[17,21,7,0,-1,-1,3,21,17,21]],8:[20,[8,21,5,20,4,18,4,16,5,14,7,13,11,12,14,11,16,9,17,7,17,4,16,2,15,1,12,0,8,0,5,1,4,2,3,4,3,7,4,9,6,11,9,12,13,13,15,14,16,16,16,18,15,20,12,21,8,21]],9:[20,[16,14,15,11,13,9,10,8,9,8,6,9,4,11,3,14,3,15,4,18,6,20,9,21,10,21,13,20,15,18,16,14,16,9,15,4,13,1,10,0,8,0,5,1,4,3]],":":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,5,2,4,1,5,0,6,1,5,2]],";":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"<":[24,[20,18,4,9,20,0]],"=":[26,[4,12,22,12,-1,-1,4,6,22,6]],">":[24,[4,18,20,9,4,0]],"?":[18,[3,16,3,17,4,19,5,20,7,21,11,21,13,20,14,19,15,17,15,15,14,13,13,12,9,10,9,7,-1,-1,9,2,8,1,9,0,10,1,9,2]],"@":[27,[18,13,17,15,15,16,12,16,10,15,9,14,8,11,8,8,9,6,11,5,14,5,16,6,17,8,-1,-1,12,16,10,14,9,11,9,8,10,6,11,5,-1,-1,18,16,17,8,17,6,19,5,21,5,23,7,24,10,24,12,23,15,22,17,20,19,18,20,15,21,12,21,9,20,7,19,5,17,4,15,3,12,3,9,4,6,5,4,7,2,9,1,12,0,15,0,18,1,20,2,21,3,-1,-1,19,16,18,8,18,6,19,5]],A:[18,[9,21,1,0,-1,-1,9,21,17,0,-1,-1,4,7,14,7]],B:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,-1,-1,4,11,13,11,16,10,17,9,18,7,18,4,17,2,16,1,13,0,4,0]],C:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5]],D:[21,[4,21,4,0,-1,-1,4,21,11,21,14,20,16,18,17,16,18,13,18,8,17,5,16,3,14,1,11,0,4,0]],E:[19,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11,-1,-1,4,0,17,0]],F:[18,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11]],G:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,18,8,-1,-1,13,8,18,8]],H:[22,[4,21,4,0,-1,-1,18,21,18,0,-1,-1,4,11,18,11]],I:[8,[4,21,4,0]],J:[16,[12,21,12,5,11,2,10,1,8,0,6,0,4,1,3,2,2,5,2,7]],K:[21,[4,21,4,0,-1,-1,18,21,4,7,-1,-1,9,12,18,0]],L:[17,[4,21,4,0,-1,-1,4,0,16,0]],M:[24,[4,21,4,0,-1,-1,4,21,12,0,-1,-1,20,21,12,0,-1,-1,20,21,20,0]],N:[22,[4,21,4,0,-1,-1,4,21,18,0,-1,-1,18,21,18,0]],O:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21]],P:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,14,17,12,16,11,13,10,4,10]],Q:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21,-1,-1,12,4,18,-2]],R:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,4,11,-1,-1,11,11,18,0]],S:[20,[17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],T:[16,[8,21,8,0,-1,-1,1,21,15,21]],U:[22,[4,21,4,6,5,3,7,1,10,0,12,0,15,1,17,3,18,6,18,21]],V:[18,[1,21,9,0,-1,-1,17,21,9,0]],W:[24,[2,21,7,0,-1,-1,12,21,7,0,-1,-1,12,21,17,0,-1,-1,22,21,17,0]],X:[20,[3,21,17,0,-1,-1,17,21,3,0]],Y:[18,[1,21,9,11,9,0,-1,-1,17,21,9,11]],Z:[20,[17,21,3,0,-1,-1,3,21,17,21,-1,-1,3,0,17,0]],"[":[14,[4,25,4,-7,-1,-1,5,25,5,-7,-1,-1,4,25,11,25,-1,-1,4,-7,11,-7]],"\\":[14,[0,21,14,-3]],"]":[14,[9,25,9,-7,-1,-1,10,25,10,-7,-1,-1,3,25,10,25,-1,-1,3,-7,10,-7]],"^":[16,[6,15,8,18,10,15,-1,-1,3,12,8,17,13,12,-1,-1,8,17,8,0]],_:[16,[0,-2,16,-2]],"`":[10,[6,21,5,20,4,18,4,16,5,15,6,16,5,17]],a:[19,[15,14,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],b:[19,[4,21,4,0,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],c:[18,[15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],d:[19,[15,21,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],e:[18,[3,8,15,8,15,10,14,12,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],f:[12,[10,21,8,21,6,20,5,17,5,0,-1,-1,2,14,9,14]],g:[19,[15,14,15,-2,14,-5,13,-6,11,-7,8,-7,6,-6,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],h:[19,[4,21,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],i:[8,[3,21,4,20,5,21,4,22,3,21,-1,-1,4,14,4,0]],j:[10,[5,21,6,20,7,21,6,22,5,21,-1,-1,6,14,6,-3,5,-6,3,-7,1,-7]],k:[17,[4,21,4,0,-1,-1,14,14,4,4,-1,-1,8,8,15,0]],l:[8,[4,21,4,0]],m:[30,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0,-1,-1,15,10,18,13,20,14,23,14,25,13,26,10,26,0]],n:[19,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],o:[19,[8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3,16,6,16,8,15,11,13,13,11,14,8,14]],p:[19,[4,14,4,-7,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],q:[19,[15,14,15,-7,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],r:[13,[4,14,4,0,-1,-1,4,8,5,11,7,13,9,14,12,14]],s:[17,[14,11,13,13,10,14,7,14,4,13,3,11,4,9,6,8,11,7,13,6,14,4,14,3,13,1,10,0,7,0,4,1,3,3]],t:[12,[5,21,5,4,6,1,8,0,10,0,-1,-1,2,14,9,14]],u:[19,[4,14,4,4,5,1,7,0,10,0,12,1,15,4,-1,-1,15,14,15,0]],v:[16,[2,14,8,0,-1,-1,14,14,8,0]],w:[22,[3,14,7,0,-1,-1,11,14,7,0,-1,-1,11,14,15,0,-1,-1,19,14,15,0]],x:[17,[3,14,14,0,-1,-1,14,14,3,0]],y:[16,[2,14,8,0,-1,-1,14,14,8,0,6,-4,4,-6,2,-7,1,-7]],z:[17,[14,14,3,0,-1,-1,3,14,14,14,-1,-1,3,0,14,0]],"{":[14,[9,25,7,24,6,23,5,21,5,19,6,17,7,16,8,14,8,12,6,10,-1,-1,7,24,6,22,6,20,7,18,8,17,9,15,9,13,8,11,4,9,8,7,9,5,9,3,8,1,7,0,6,-2,6,-4,7,-6,-1,-1,6,8,8,6,8,4,7,2,6,1,5,-1,5,-3,6,-5,7,-6,9,-7]],"|":[8,[4,25,4,-7]],"}":[14,[5,25,7,24,8,23,9,21,9,19,8,17,7,16,6,14,6,12,8,10,-1,-1,7,24,8,22,8,20,7,18,6,17,5,15,5,13,6,11,10,9,6,7,5,5,5,3,6,1,7,0,8,-2,8,-4,7,-6,-1,-1,8,8,6,6,6,4,7,2,8,1,9,-1,9,-3,8,-5,7,-6,5,-7]],"~":[24,[3,6,3,8,4,11,6,12,8,12,10,11,14,8,16,7,18,7,20,8,21,10,-1,-1,3,8,4,10,6,11,8,11,10,10,14,7,16,6,18,6,20,7,21,10,21,12]]};var bi={symbol:function(t,e,i,n){if("translucent"===t.renderPass){var o=t.context;o.setStencilMode(kt.disabled),o.setColorMode(t.colorModeForRenderPass()),0!==i.paint.get("icon-opacity").constantOr(1)&&ni(t,e,i,n,!1,i.paint.get("icon-translate"),i.paint.get("icon-translate-anchor"),i.layout.get("icon-rotation-alignment"),i.layout.get("icon-pitch-alignment"),i.layout.get("icon-keep-upright")),0!==i.paint.get("text-opacity").constantOr(1)&&ni(t,e,i,n,!0,i.paint.get("text-translate"),i.paint.get("text-translate-anchor"),i.layout.get("text-rotation-alignment"),i.layout.get("text-pitch-alignment"),i.layout.get("text-keep-upright")),e.map.showCollisionBoxes&&function(t,e,i,n){ti(t,e,i,n,!1),ti(t,e,i,n,!0);}(t,e,i,n);}},circle:function(t,e,i,n){if("translucent"===t.renderPass){var o=i.paint.get("circle-opacity"),r=i.paint.get("circle-stroke-width"),a=i.paint.get("circle-stroke-opacity");if(0!==o.constantOr(1)||0!==r.constantOr(1)&&0!==a.constantOr(1)){var s=t.context,l=s.gl;s.setDepthMode(t.depthModeForSublayer(0,Lt.ReadOnly)),s.setStencilMode(kt.disabled),s.setColorMode(t.colorModeForRenderPass());for(var c=!0,h=0;h<n.length;h++){var u=n[h],p=e.getTile(u),d=p.getBucket(i);if(d){var f=t.context.program.get(),m=d.programConfigurations.get(i.id),_=t.useProgram("circle",m);if((c||_.program!==f)&&(m.setUniforms(s,_,i.paint,{zoom:t.transform.zoom}),c=!1),l.uniform1f(_.uniforms.u_camera_to_center_distance,t.transform.cameraToCenterDistance),l.uniform1i(_.uniforms.u_scale_with_map,"map"===i.paint.get("circle-pitch-scale")?1:0),"map"===i.paint.get("circle-pitch-alignment")){l.uniform1i(_.uniforms.u_pitch_with_map,1);var g=ye(p,1,t.transform.zoom);l.uniform2f(_.uniforms.u_extrude_scale,g,g);}else l.uniform1i(_.uniforms.u_pitch_with_map,0),l.uniform2fv(_.uniforms.u_extrude_scale,t.transform.pixelsToGLUnits);l.uniformMatrix4fv(_.uniforms.u_matrix,!1,t.translatePosMatrix(u.posMatrix,p,i.paint.get("circle-translate"),i.paint.get("circle-translate-anchor"))),_.draw(s,l.TRIANGLES,i.id,d.layoutVertexBuffer,d.indexBuffer,d.segments,m);}}}}},heatmap:function(e,i,n,o){if(0!==n.paint.get("heatmap-opacity"))if("offscreen"===e.renderPass){var r=e.context,a=r.gl;r.setDepthMode(e.depthModeForSublayer(0,Lt.ReadOnly)),r.setStencilMode(kt.disabled),function(t,e,i){var n=t.gl;t.activeTexture.set(n.TEXTURE1),t.viewport.set([0,0,e.width/4,e.height/4]);var o=i.heatmapFbo;if(o)n.bindTexture(n.TEXTURE_2D,o.colorAttachment.get()),t.bindFramebuffer.set(o.framebuffer);else{var r=n.createTexture();n.bindTexture(n.TEXTURE_2D,r),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,n.CLAMP_TO_EDGE),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,n.CLAMP_TO_EDGE),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,n.LINEAR),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MAG_FILTER,n.LINEAR),o=i.heatmapFbo=t.createFramebuffer(e.width/4,e.height/4),function t(e,i,n,o){var r=e.gl;r.texImage2D(r.TEXTURE_2D,0,r.RGBA,i.width/4,i.height/4,0,r.RGBA,e.extTextureHalfFloat?e.extTextureHalfFloat.HALF_FLOAT_OES:r.UNSIGNED_BYTE,null),o.colorAttachment.set(n),e.extTextureHalfFloat&&r.checkFramebufferStatus(r.FRAMEBUFFER)!==r.FRAMEBUFFER_COMPLETE&&(e.extTextureHalfFloat=null,o.colorAttachment.setDirty(),t(e,i,n,o));}(t,e,r,o);}}(r,e,n),r.clear({color:t.Color.transparent}),r.setColorMode(new Bt([a.ONE,a.ONE],t.Color.transparent,[!0,!0,!0,!0]));for(var s=!0,l=0;l<o.length;l++){var c=o[l];if(!i.hasRenderableParent(c)){var h=i.getTile(c),u=h.getBucket(n);if(u){var p=e.context.program.get(),d=u.programConfigurations.get(n.id),f=e.useProgram("heatmap",d),m=e.transform.zoom;(s||f.program!==p)&&(d.setUniforms(e.context,f,n.paint,{zoom:m}),s=!1),a.uniform1f(f.uniforms.u_extrude_scale,ye(h,1,m)),a.uniform1f(f.uniforms.u_intensity,n.paint.get("heatmap-intensity")),a.uniformMatrix4fv(f.uniforms.u_matrix,!1,c.posMatrix),f.draw(r,a.TRIANGLES,n.id,u.layoutVertexBuffer,u.indexBuffer,u.segments,d);}}}r.viewport.set([0,0,e.width,e.height]);}else"translucent"===e.renderPass&&(e.context.setColorMode(e.colorModeForRenderPass()),function(e,i){var n=e.context,o=n.gl,r=i.heatmapFbo;if(r){n.activeTexture.set(o.TEXTURE0),o.bindTexture(o.TEXTURE_2D,r.colorAttachment.get()),n.activeTexture.set(o.TEXTURE1);var a=i.colorRampTexture;a||(a=i.colorRampTexture=new t.Texture(n,i.colorRamp,o.RGBA)),a.bind(o.LINEAR,o.CLAMP_TO_EDGE),n.setDepthMode(Lt.disabled),n.setStencilMode(kt.disabled);var s=e.useProgram("heatmapTexture"),l=i.paint.get("heatmap-opacity");o.uniform1f(s.uniforms.u_opacity,l),o.uniform1i(s.uniforms.u_image,0),o.uniform1i(s.uniforms.u_color_ramp,1);var c=t.create();t.ortho(c,0,e.width,e.height,0,0,1),o.uniformMatrix4fv(s.uniforms.u_matrix,!1,c),o.uniform2f(s.uniforms.u_world,o.drawingBufferWidth,o.drawingBufferHeight),e.viewportVAO.bind(e.context,s,e.viewportBuffer,[]),o.drawArrays(o.TRIANGLE_STRIP,0,4);}}(e,n));},line:function(t,e,i,n){if("translucent"===t.renderPass){var o=i.paint.get("line-opacity"),r=i.paint.get("line-width");if(0!==o.constantOr(1)&&0!==r.constantOr(1)){var a=t.context;a.setDepthMode(t.depthModeForSublayer(0,Lt.ReadOnly)),a.setColorMode(t.colorModeForRenderPass());for(var s,l=i.paint.get("line-dasharray")?"lineSDF":i.paint.get("line-pattern")?"linePattern":i.paint.get("line-gradient")?"lineGradient":"line",c=!0,h=0,u=n;h<u.length;h+=1){var p=u[h],d=e.getTile(p),f=d.getBucket(i);if(f){var m=f.programConfigurations.get(i.id),_=t.context.program.get(),g=t.useProgram(l,m),v=c||g.program!==_,y=s!==d.tileID.overscaledZ;v&&m.setUniforms(t.context,g,i.paint,{zoom:t.transform.zoom}),si(g,t,d,f,i,p,m,v,y),s=d.tileID.overscaledZ,c=!1;}}}}},fill:function(e,i,n,o){var r=n.paint.get("fill-color"),a=n.paint.get("fill-opacity");if(0!==a.constantOr(1)){var s=e.context;s.setColorMode(e.colorModeForRenderPass());var l=n.paint.get("fill-pattern")||1!==r.constantOr(t.Color.transparent).a||1!==a.constantOr(0)?"translucent":"opaque";e.renderPass===l&&(s.setDepthMode(e.depthModeForSublayer(1,"opaque"===e.renderPass?Lt.ReadWrite:Lt.ReadOnly)),ui(e,i,n,o,pi)),"translucent"===e.renderPass&&n.paint.get("fill-antialias")&&(s.setDepthMode(e.depthModeForSublayer(n.getPaintProperty("fill-outline-color")?2:0,Lt.ReadOnly)),ui(e,i,n,o,di));}},"fill-extrusion":function(e,i,n,o){if(0!==n.paint.get("fill-extrusion-opacity"))if("offscreen"===e.renderPass){!function(e,i){var n=e.context,o=n.gl,r=i.viewportFrame;if(e.depthRboNeedsClear&&e.setupOffscreenDepthRenderbuffer(),!r){var a=new t.Texture(n,{width:e.width,height:e.height,data:null},o.RGBA);a.bind(o.LINEAR,o.CLAMP_TO_EDGE),(r=i.viewportFrame=n.createFramebuffer(e.width,e.height)).colorAttachment.set(a.texture);}n.bindFramebuffer.set(r.framebuffer),r.depthAttachment.set(e.depthRbo),e.depthRboNeedsClear&&(n.clear({depth:1}),e.depthRboNeedsClear=!1),n.clear({color:t.Color.transparent}),n.setStencilMode(kt.disabled),n.setDepthMode(new Lt(o.LEQUAL,Lt.ReadWrite,[0,1])),n.setColorMode(e.colorModeForRenderPass());}(e,n);for(var r=!0,a=0,s=o;a<s.length;a+=1){var l=s[a],c=i.getTile(l),h=c.getBucket(n);h&&(mi(e,0,n,c,l,h,r),r=!1);}}else"translucent"===e.renderPass&&function(e,i){var n=i.viewportFrame;if(n){var o=e.context,r=o.gl,a=e.useProgram("extrusionTexture");o.setStencilMode(kt.disabled),o.setDepthMode(Lt.disabled),o.setColorMode(e.colorModeForRenderPass()),o.activeTexture.set(r.TEXTURE0),r.bindTexture(r.TEXTURE_2D,n.colorAttachment.get()),r.uniform1f(a.uniforms.u_opacity,i.paint.get("fill-extrusion-opacity")),r.uniform1i(a.uniforms.u_image,0);var s=t.create();t.ortho(s,0,e.width,e.height,0,0,1),r.uniformMatrix4fv(a.uniforms.u_matrix,!1,s),r.uniform2f(a.uniforms.u_world,r.drawingBufferWidth,r.drawingBufferHeight),e.viewportVAO.bind(o,a,e.viewportBuffer,[]),r.drawArrays(r.TRIANGLE_STRIP,0,4);}}(e,n);},hillshade:function(t,e,i,n){if("offscreen"===t.renderPass||"translucent"===t.renderPass){var o=t.context,r=e.getSource().maxzoom;o.setDepthMode(t.depthModeForSublayer(0,Lt.ReadOnly)),o.setStencilMode(kt.disabled),o.setColorMode(t.colorModeForRenderPass());for(var a=0,s=n;a<s.length;a+=1){var l=s[a],c=e.getTile(l);c.needsHillshadePrepare&&"offscreen"===t.renderPass?gi(t,c,r):"translucent"===t.renderPass&&_i(t,c,i);}o.viewport.set([0,0,t.width,t.height]);}},raster:function(t,e,i,n){if("translucent"===t.renderPass&&0!==i.paint.get("raster-opacity")){var o,r,a=t.context,s=a.gl,l=e.getSource(),c=t.useProgram("raster");a.setStencilMode(kt.disabled),a.setColorMode(t.colorModeForRenderPass()),s.uniform1f(c.uniforms.u_brightness_low,i.paint.get("raster-brightness-min")),s.uniform1f(c.uniforms.u_brightness_high,i.paint.get("raster-brightness-max")),s.uniform1f(c.uniforms.u_saturation_factor,(o=i.paint.get("raster-saturation"))>0?1-1/(1.001-o):-o),s.uniform1f(c.uniforms.u_contrast_factor,(r=i.paint.get("raster-contrast"))>0?1/(1-r):1+r),s.uniform3fv(c.uniforms.u_spin_weights,function(t){t*=Math.PI/180;var e=Math.sin(t),i=Math.cos(t);return [(2*i+1)/3,(-Math.sqrt(3)*e-i+1)/3,(Math.sqrt(3)*e-i+1)/3]}(i.paint.get("raster-hue-rotate"))),s.uniform1f(c.uniforms.u_buffer_scale,1),s.uniform1i(c.uniforms.u_image0,0),s.uniform1i(c.uniforms.u_image1,1);for(var h=n.length&&n[0].overscaledZ,u=0,p=n;u<p.length;u+=1){var d=p[u];a.setDepthMode(t.depthModeForSublayer(d.overscaledZ-h,1===i.paint.get("raster-opacity")?Lt.ReadWrite:Lt.ReadOnly,s.LESS));var f=e.getTile(d),m=t.transform.calculatePosMatrix(d.toUnwrapped(),!0);f.registerFadeDuration(i.paint.get("raster-fade-duration")),s.uniformMatrix4fv(c.uniforms.u_matrix,!1,m);var _=e.findLoadedParent(d,0),g=vi(f,_,e,i,t.transform),v=void 0,y=void 0,x="nearest"===i.paint.get("raster-resampling")?s.NEAREST:s.LINEAR;if(a.activeTexture.set(s.TEXTURE0),f.texture.bind(x,s.CLAMP_TO_EDGE,s.LINEAR_MIPMAP_NEAREST),a.activeTexture.set(s.TEXTURE1),_?(_.texture.bind(x,s.CLAMP_TO_EDGE,s.LINEAR_MIPMAP_NEAREST),v=Math.pow(2,_.tileID.overscaledZ-f.tileID.overscaledZ),y=[f.tileID.canonical.x*v%1,f.tileID.canonical.y*v%1]):f.texture.bind(x,s.CLAMP_TO_EDGE,s.LINEAR_MIPMAP_NEAREST),s.uniform2fv(c.uniforms.u_tl_parent,y||[0,0]),s.uniform1f(c.uniforms.u_scale_parent,v||1),s.uniform1f(c.uniforms.u_fade_t,g.mix),s.uniform1f(c.uniforms.u_opacity,g.opacity*i.paint.get("raster-opacity")),l instanceof X){var b=l.boundsBuffer;l.boundsVAO.bind(a,c,b,[]),s.drawArrays(s.TRIANGLE_STRIP,0,b.length);}else if(f.maskedBoundsBuffer&&f.maskedIndexBuffer&&f.segments)c.draw(a,s.TRIANGLES,i.id,f.maskedBoundsBuffer,f.maskedIndexBuffer,f.segments);else{var w=t.rasterBoundsBuffer;t.rasterBoundsVAO.bind(a,c,w,[]),s.drawArrays(s.TRIANGLE_STRIP,0,w.length);}}}},background:function(t,e,i){var n=i.paint.get("background-color"),o=i.paint.get("background-opacity");if(0!==o){var r=t.context,a=r.gl,s=t.transform,l=s.tileSize,c=i.paint.get("background-pattern"),h=c||1!==n.a||1!==o?"translucent":"opaque";if(t.renderPass===h){var u;if(r.setStencilMode(kt.disabled),r.setDepthMode(t.depthModeForSublayer(0,"opaque"===h?Lt.ReadWrite:Lt.ReadOnly)),r.setColorMode(t.colorModeForRenderPass()),c){if(li(c,t))return;u=t.useProgram("backgroundPattern"),ci(c,t,u),t.tileExtentPatternVAO.bind(r,u,t.tileExtentBuffer,[]);}else u=t.useProgram("background"),a.uniform4f(u.uniforms.u_color,n.r,n.g,n.b,n.a),t.tileExtentVAO.bind(r,u,t.tileExtentBuffer,[]);a.uniform1f(u.uniforms.u_opacity,o);for(var p=0,d=s.coveringTiles({tileSize:l});p<d.length;p+=1){var f=d[p];c&&hi({tileID:f,tileSize:l},t,u),a.uniformMatrix4fv(u.uniforms.u_matrix,!1,t.transform.calculatePosMatrix(f.toUnwrapped())),a.drawArrays(a.TRIANGLE_STRIP,0,t.tileExtentBuffer.length);}}}},debug:function(t,e,i){for(var n=0;n<i.length;n++)yi(t,e,i[n]);}},wi=function(e,i){this.context=new Ot(e),this.transform=i,this._tileTextures={},this.setup(),this.numSublayers=Ft.maxUnderzooming+Ft.maxOverzooming+1,this.depthEpsilon=1/Math.pow(2,16),this.depthRboNeedsClear=!0,this.emptyProgramConfiguration=new t.ProgramConfiguration,this.crossTileSymbolIndex=new Ue;};function Ei(t,e){if(t.row>e.row){var i=t;t=e,e=i;}return {x0:t.column,y0:t.row,x1:e.column,y1:e.row,dx:e.column-t.column,dy:e.row-t.row}}function Ti(t,e,i,n,o){var r=Math.max(i,Math.floor(e.y0)),a=Math.min(n,Math.ceil(e.y1));if(t.x0===e.x0&&t.y0===e.y0?t.x0+e.dy/t.dy*t.dx<e.x1:t.x1-e.dy/t.dy*t.dx<e.x0){var s=t;t=e,e=s;}for(var l=t.dx/t.dy,c=e.dx/e.dy,h=t.dx>0,u=e.dx<0,p=r;p<a;p++){var d=l*Math.max(0,Math.min(t.dy,p+h-t.y0))+t.x0,f=c*Math.max(0,Math.min(e.dy,p+u-e.y0))+e.x0;o(Math.floor(f),Math.ceil(d),p);}}function Ii(t,e,i,n,o,r){var a,s=Ei(t,e),l=Ei(e,i),c=Ei(i,t);s.dy>l.dy&&(a=s,s=l,l=a),s.dy>c.dy&&(a=s,s=c,c=a),l.dy>c.dy&&(a=l,l=c,c=a),s.dy&&Ti(c,s,n,o,r),l.dy&&Ti(c,l,n,o,r);}wi.prototype.resize=function(e,i){var n=this.context.gl;if(this.width=e*t.browser.devicePixelRatio,this.height=i*t.browser.devicePixelRatio,this.context.viewport.set([0,0,this.width,this.height]),this.style)for(var o=0,r=this.style._order;o<r.length;o+=1){var a=r[o];this.style._layers[a].resize();}this.depthRbo&&(n.deleteRenderbuffer(this.depthRbo),this.depthRbo=null);},wi.prototype.setup=function(){var e=this.context,i=new t.StructArrayLayout2i4;i.emplaceBack(0,0),i.emplaceBack(t.EXTENT,0),i.emplaceBack(0,t.EXTENT),i.emplaceBack(t.EXTENT,t.EXTENT),this.tileExtentBuffer=e.createVertexBuffer(i,Ge.members),this.tileExtentVAO=new W,this.tileExtentPatternVAO=new W;var n=new t.StructArrayLayout2i4;n.emplaceBack(0,0),n.emplaceBack(t.EXTENT,0),n.emplaceBack(t.EXTENT,t.EXTENT),n.emplaceBack(0,t.EXTENT),n.emplaceBack(0,0),this.debugBuffer=e.createVertexBuffer(n,Ge.members),this.debugVAO=new W;var o=new t.StructArrayLayout4i8;o.emplaceBack(0,0,0,0),o.emplaceBack(t.EXTENT,0,t.EXTENT,0),o.emplaceBack(0,t.EXTENT,0,t.EXTENT),o.emplaceBack(t.EXTENT,t.EXTENT,t.EXTENT,t.EXTENT),this.rasterBoundsBuffer=e.createVertexBuffer(o,t.rasterBoundsAttributes.members),this.rasterBoundsVAO=new W;var r=new t.StructArrayLayout2i4;r.emplaceBack(0,0),r.emplaceBack(1,0),r.emplaceBack(0,1),r.emplaceBack(1,1),this.viewportBuffer=e.createVertexBuffer(r,Ge.members),this.viewportVAO=new W;},wi.prototype.clearStencil=function(){var e=this.context,i=e.gl;e.setColorMode(Bt.disabled),e.setDepthMode(Lt.disabled),e.setStencilMode(new kt({func:i.ALWAYS,mask:0},0,255,i.ZERO,i.ZERO,i.ZERO));var n=t.create();t.ortho(n,0,this.width,this.height,0,0,1),t.scale(n,n,[i.drawingBufferWidth,i.drawingBufferHeight,0]);var o=this.useProgram("clippingMask");i.uniformMatrix4fv(o.uniforms.u_matrix,!1,n),this.viewportVAO.bind(e,o,this.viewportBuffer,[]),i.drawArrays(i.TRIANGLE_STRIP,0,4);},wi.prototype._renderTileClippingMasks=function(t){var e=this.context,i=e.gl;e.setColorMode(Bt.disabled),e.setDepthMode(Lt.disabled);var n=1;this._tileClippingMaskIDs={};for(var o=0,r=t;o<r.length;o+=1){var a=r[o],s=this._tileClippingMaskIDs[a.key]=n++;e.setStencilMode(new kt({func:i.ALWAYS,mask:0},s,255,i.KEEP,i.KEEP,i.REPLACE));var l=this.useProgram("clippingMask");i.uniformMatrix4fv(l.uniforms.u_matrix,!1,a.posMatrix),this.tileExtentVAO.bind(this.context,l,this.tileExtentBuffer,[]),i.drawArrays(i.TRIANGLE_STRIP,0,this.tileExtentBuffer.length);}},wi.prototype.stencilModeForClipping=function(t){var e=this.context.gl;return new kt({func:e.EQUAL,mask:255},this._tileClippingMaskIDs[t.key],0,e.KEEP,e.KEEP,e.REPLACE)},wi.prototype.colorModeForRenderPass=function(){var e=this.context.gl;if(this._showOverdrawInspector){return new Bt([e.CONSTANT_COLOR,e.ONE],new t.Color(1/8,1/8,1/8,0),[!0,!0,!0,!0])}return "opaque"===this.renderPass?Bt.unblended:Bt.alphaBlended},wi.prototype.depthModeForSublayer=function(t,e,i){var n=1-((1+this.currentLayer)*this.numSublayers+t)*this.depthEpsilon,o=n-1+this.depthRange;return new Lt(i||this.context.gl.LEQUAL,e,[o,n])},wi.prototype.render=function(e,i){this.style=e,this.options=i,this.lineAtlas=e.lineAtlas,this.imageManager=e.imageManager,this.glyphManager=e.glyphManager,this.symbolFadeChange=e.placement.symbolFadeChange(t.browser.now());var n=this.style._order,o=this.style.sourceCaches;for(var r in o){var a=o[r];a.used&&a.prepare(this.context);}var s,l={},c={},h={};for(var u in o){var p=o[u];l[u]=p.getVisibleCoordinates(),c[u]=l[u].slice().reverse(),h[u]=p.getVisibleCoordinates(!0).reverse();}for(var d in o){var f=o[d],m=f.getSource();if("raster"===m.type||"raster-dem"===m.type){for(var _=[],g=0,v=l[d];g<v.length;g+=1){var y=v[g];_.push(f.getTile(y));}Qe(_,this.context);}}this.renderPass="offscreen",this.depthRboNeedsClear=!0;for(var x=0,b=n;x<b.length;x+=1){var w=b[x],E=this.style._layers[w];if(E.hasOffscreenPass()&&!E.isHidden(this.transform.zoom)){var T=c[E.source];T.length&&this.renderLayer(this,o[E.source],E,T);}}for(this.context.bindFramebuffer.set(null),this.context.clear({color:i.showOverdrawInspector?t.Color.black:t.Color.transparent,depth:1}),this._showOverdrawInspector=i.showOverdrawInspector,this.depthRange=(e._order.length+2)*this.numSublayers*this.depthEpsilon,this.renderPass="opaque",this.currentLayer=n.length-1;this.currentLayer>=0;this.currentLayer--){var I=this.style._layers[n[this.currentLayer]],S=o[I.source],C=l[I.source];I.source!==s&&S&&(this.clearStencil(),S.getSource().isTileClipped&&this._renderTileClippingMasks(C)),this.renderLayer(this,S,I,C),s=I.source;}for(this.renderPass="translucent",this.currentLayer=0,s=null;this.currentLayer<n.length;this.currentLayer++){var z=this.style._layers[n[this.currentLayer]],P=o[z.source],A=("symbol"===z.type?h:c)[z.source];z.source!==s&&P&&(this.clearStencil(),P.getSource().isTileClipped&&this._renderTileClippingMasks(l[z.source])),this.renderLayer(this,P,z,A),s=z.source;}if(this.options.showTileBoundaries)for(var D in o){bi.debug(this,o[D],l[D]);break}},wi.prototype.setupOffscreenDepthRenderbuffer=function(){var t=this.context;this.depthRbo||(this.depthRbo=t.createRenderbuffer(t.gl.DEPTH_COMPONENT16,this.width,this.height));},wi.prototype.renderLayer=function(t,e,i,n){i.isHidden(this.transform.zoom)||("background"===i.type||n.length)&&(this.id=i.id,bi[i.type](t,e,i,n));},wi.prototype.translatePosMatrix=function(e,i,n,o,r){if(!n[0]&&!n[1])return e;var a=r?"map"===o?this.transform.angle:0:"viewport"===o?-this.transform.angle:0;if(a){var s=Math.sin(a),l=Math.cos(a);n=[n[0]*l-n[1]*s,n[0]*s+n[1]*l];}var c=[r?n[0]:ye(i,n[0],this.transform.zoom),r?n[1]:ye(i,n[1],this.transform.zoom),0],h=new Float32Array(16);return t.translate(h,e,c),h},wi.prototype.saveTileTexture=function(t){var e=this._tileTextures[t.size[0]];e?e.push(t):this._tileTextures[t.size[0]]=[t];},wi.prototype.getTileTexture=function(t){var e=this._tileTextures[t];return e&&e.length>0?e.pop():null},wi.prototype._createProgramCached=function(t,e){this.cache=this.cache||{};var i=""+t+(e.cacheKey||"")+(this._showOverdrawInspector?"/overdraw":"");return this.cache[i]||(this.cache[i]=new Je(this.context,Ye[t],e,this._showOverdrawInspector)),this.cache[i]},wi.prototype.useProgram=function(t,e){var i=this._createProgramCached(t,e||this.emptyProgramConfiguration);return this.context.program.set(i.program),i};var Si=function(t,e,i){this.tileSize=512,this.maxValidLatitude=85.051129,this._renderWorldCopies=void 0===i||i,this._minZoom=t||0,this._maxZoom=e||22,this.setMaxBounds(),this.width=0,this.height=0,this._center=new N(0,0),this.zoom=0,this.angle=0,this._fov=.6435011087932844,this._pitch=0,this._unmodified=!0,this._posMatrixCache={},this._alignedPosMatrixCache={};},Ci={minZoom:{configurable:!0},maxZoom:{configurable:!0},renderWorldCopies:{configurable:!0},worldSize:{configurable:!0},centerPoint:{configurable:!0},size:{configurable:!0},bearing:{configurable:!0},pitch:{configurable:!0},fov:{configurable:!0},zoom:{configurable:!0},center:{configurable:!0},unmodified:{configurable:!0},x:{configurable:!0},y:{configurable:!0},point:{configurable:!0}};Si.prototype.clone=function(){var t=new Si(this._minZoom,this._maxZoom,this._renderWorldCopies);return t.tileSize=this.tileSize,t.latRange=this.latRange,t.width=this.width,t.height=this.height,t._center=this._center,t.zoom=this.zoom,t.angle=this.angle,t._fov=this._fov,t._pitch=this._pitch,t._unmodified=this._unmodified,t._calcMatrices(),t},Ci.minZoom.get=function(){return this._minZoom},Ci.minZoom.set=function(t){this._minZoom!==t&&(this._minZoom=t,this.zoom=Math.max(this.zoom,t));},Ci.maxZoom.get=function(){return this._maxZoom},Ci.maxZoom.set=function(t){this._maxZoom!==t&&(this._maxZoom=t,this.zoom=Math.min(this.zoom,t));},Ci.renderWorldCopies.get=function(){return this._renderWorldCopies},Ci.renderWorldCopies.set=function(t){void 0===t?t=!0:null===t&&(t=!1),this._renderWorldCopies=t;},Ci.worldSize.get=function(){return this.tileSize*this.scale},Ci.centerPoint.get=function(){return this.size._div(2)},Ci.size.get=function(){return new t.Point(this.width,this.height)},Ci.bearing.get=function(){return -this.angle/Math.PI*180},Ci.bearing.set=function(e){var i=-t.wrap(e,-180,180)*Math.PI/180;this.angle!==i&&(this._unmodified=!1,this.angle=i,this._calcMatrices(),this.rotationMatrix=t.create$4(),t.rotate(this.rotationMatrix,this.rotationMatrix,this.angle));},Ci.pitch.get=function(){return this._pitch/Math.PI*180},Ci.pitch.set=function(e){var i=t.clamp(e,0,60)/180*Math.PI;this._pitch!==i&&(this._unmodified=!1,this._pitch=i,this._calcMatrices());},Ci.fov.get=function(){return this._fov/Math.PI*180},Ci.fov.set=function(t){t=Math.max(.01,Math.min(60,t)),this._fov!==t&&(this._unmodified=!1,this._fov=t/180*Math.PI,this._calcMatrices());},Ci.zoom.get=function(){return this._zoom},Ci.zoom.set=function(t){var e=Math.min(Math.max(t,this.minZoom),this.maxZoom);this._zoom!==e&&(this._unmodified=!1,this._zoom=e,this.scale=this.zoomScale(e),this.tileZoom=Math.floor(e),this.zoomFraction=e-this.tileZoom,this._constrain(),this._calcMatrices());},Ci.center.get=function(){return this._center},Ci.center.set=function(t){t.lat===this._center.lat&&t.lng===this._center.lng||(this._unmodified=!1,this._center=t,this._constrain(),this._calcMatrices());},Si.prototype.coveringZoomLevel=function(t){return (t.roundZoom?Math.round:Math.floor)(this.zoom+this.scaleZoom(this.tileSize/t.tileSize))},Si.prototype.getVisibleUnwrappedCoordinates=function(e){var i=this.pointCoordinate(new t.Point(0,0),0),n=this.pointCoordinate(new t.Point(this.width,0),0),o=Math.floor(i.column),r=Math.floor(n.column),a=[new t.UnwrappedTileID(0,e)];if(this._renderWorldCopies)for(var s=o;s<=r;s++)0!==s&&a.push(new t.UnwrappedTileID(s,e));return a},Si.prototype.coveringTiles=function(e){var i=this.coveringZoomLevel(e),n=i;if(void 0!==e.minzoom&&i<e.minzoom)return [];void 0!==e.maxzoom&&i>e.maxzoom&&(i=e.maxzoom);var o=this.pointCoordinate(this.centerPoint,i),r=new t.Point(o.column-.5,o.row-.5);return function(e,i,n,o){void 0===o&&(o=!0);var r=1<<e,a={};function s(i,s,l){var c,h,u,p;if(l>=0&&l<=r)for(c=i;c<s;c++)h=Math.floor(c/r),u=(c%r+r)%r,0!==h&&!0!==o||(p=new t.OverscaledTileID(n,h,e,u,l),a[p.key]=p);}return Ii(i[0],i[1],i[2],0,r,s),Ii(i[2],i[3],i[0],0,r,s),Object.keys(a).map(function(t){return a[t]})}(i,[this.pointCoordinate(new t.Point(0,0),i),this.pointCoordinate(new t.Point(this.width,0),i),this.pointCoordinate(new t.Point(this.width,this.height),i),this.pointCoordinate(new t.Point(0,this.height),i)],e.reparseOverscaled?n:i,this._renderWorldCopies).sort(function(t,e){return r.dist(t.canonical)-r.dist(e.canonical)})},Si.prototype.resize=function(t,e){this.width=t,this.height=e,this.pixelsToGLUnits=[2/t,-2/e],this._constrain(),this._calcMatrices();},Ci.unmodified.get=function(){return this._unmodified},Si.prototype.zoomScale=function(t){return Math.pow(2,t)},Si.prototype.scaleZoom=function(t){return Math.log(t)/Math.LN2},Si.prototype.project=function(e){return new t.Point(this.lngX(e.lng),this.latY(e.lat))},Si.prototype.unproject=function(t){return new N(this.xLng(t.x),this.yLat(t.y))},Ci.x.get=function(){return this.lngX(this.center.lng)},Ci.y.get=function(){return this.latY(this.center.lat)},Ci.point.get=function(){return new t.Point(this.x,this.y)},Si.prototype.lngX=function(t){return (180+t)*this.worldSize/360},Si.prototype.latY=function(e){return e=t.clamp(e,-this.maxValidLatitude,this.maxValidLatitude),(180-180/Math.PI*Math.log(Math.tan(Math.PI/4+e*Math.PI/360)))*this.worldSize/360},Si.prototype.xLng=function(t){return 360*t/this.worldSize-180},Si.prototype.yLat=function(t){var e=180-360*t/this.worldSize;return 360/Math.PI*Math.atan(Math.exp(e*Math.PI/180))-90},Si.prototype.setLocationAtPoint=function(t,e){var i=this.pointCoordinate(e)._sub(this.pointCoordinate(this.centerPoint));this.center=this.coordinateLocation(this.locationCoordinate(t)._sub(i)),this._renderWorldCopies&&(this.center=this.center.wrap());},Si.prototype.locationPoint=function(t){return this.coordinatePoint(this.locationCoordinate(t))},Si.prototype.pointLocation=function(t){return this.coordinateLocation(this.pointCoordinate(t))},Si.prototype.locationCoordinate=function(e){return new t.Coordinate(this.lngX(e.lng)/this.tileSize,this.latY(e.lat)/this.tileSize,this.zoom).zoomTo(this.tileZoom)},Si.prototype.coordinateLocation=function(t){var e=t.zoomTo(this.zoom);return new N(this.xLng(e.column*this.tileSize),this.yLat(e.row*this.tileSize))},Si.prototype.pointCoordinate=function(e,i){void 0===i&&(i=this.tileZoom);var n=[e.x,e.y,0,1],o=[e.x,e.y,1,1];t.transformMat4(n,n,this.pixelMatrixInverse),t.transformMat4(o,o,this.pixelMatrixInverse);var r=n[3],a=o[3],s=n[0]/r,l=o[0]/a,c=n[1]/r,h=o[1]/a,u=n[2]/r,p=o[2]/a,d=u===p?0:(0-u)/(p-u);return new t.Coordinate(t.number(s,l,d)/this.tileSize,t.number(c,h,d)/this.tileSize,this.zoom)._zoomTo(i)},Si.prototype.coordinatePoint=function(e){var i=e.zoomTo(this.zoom),n=[i.column*this.tileSize,i.row*this.tileSize,0,1];return t.transformMat4(n,n,this.pixelMatrix),new t.Point(n[0]/n[3],n[1]/n[3])},Si.prototype.getBounds=function(){return (new U).extend(this.pointLocation(new t.Point(0,0))).extend(this.pointLocation(new t.Point(this.width,0))).extend(this.pointLocation(new t.Point(this.width,this.height))).extend(this.pointLocation(new t.Point(0,this.height)))},Si.prototype.getMaxBounds=function(){return this.latRange&&2===this.latRange.length&&this.lngRange&&2===this.lngRange.length?new U([this.lngRange[0],this.latRange[0]],[this.lngRange[1],this.latRange[1]]):null},Si.prototype.setMaxBounds=function(t){t?(this.lngRange=[t.getWest(),t.getEast()],this.latRange=[t.getSouth(),t.getNorth()],this._constrain()):(this.lngRange=null,this.latRange=[-this.maxValidLatitude,this.maxValidLatitude]);},Si.prototype.calculatePosMatrix=function(e,i){void 0===i&&(i=!1);var n=e.key,o=i?this._alignedPosMatrixCache:this._posMatrixCache;if(o[n])return o[n];var r=e.canonical,a=this.worldSize/this.zoomScale(r.z),s=r.x+Math.pow(2,r.z)*e.wrap,l=t.identity(new Float64Array(16));return t.translate(l,l,[s*a,r.y*a,0]),t.scale(l,l,[a/t.EXTENT,a/t.EXTENT,1]),t.multiply(l,i?this.alignedProjMatrix:this.projMatrix,l),o[n]=new Float32Array(l),o[n]},Si.prototype._constrain=function(){if(this.center&&this.width&&this.height&&!this._constraining){this._constraining=!0;var e,i,n,o,r=-90,a=90,s=-180,l=180,c=this.size,h=this._unmodified;if(this.latRange){var u=this.latRange;r=this.latY(u[1]),e=(a=this.latY(u[0]))-r<c.y?c.y/(a-r):0;}if(this.lngRange){var p=this.lngRange;s=this.lngX(p[0]),i=(l=this.lngX(p[1]))-s<c.x?c.x/(l-s):0;}var d=Math.max(i||0,e||0);if(d)return this.center=this.unproject(new t.Point(i?(l+s)/2:this.x,e?(a+r)/2:this.y)),this.zoom+=this.scaleZoom(d),this._unmodified=h,void(this._constraining=!1);if(this.latRange){var f=this.y,m=c.y/2;f-m<r&&(o=r+m),f+m>a&&(o=a-m);}if(this.lngRange){var _=this.x,g=c.x/2;_-g<s&&(n=s+g),_+g>l&&(n=l-g);}void 0===n&&void 0===o||(this.center=this.unproject(new t.Point(void 0!==n?n:this.x,void 0!==o?o:this.y))),this._unmodified=h,this._constraining=!1;}},Si.prototype._calcMatrices=function(){if(this.height){this.cameraToCenterDistance=.5/Math.tan(this._fov/2)*this.height;var e=this._fov/2,i=Math.PI/2+this._pitch,n=Math.sin(e)*this.cameraToCenterDistance/Math.sin(Math.PI-i-e),o=this.x,r=this.y,a=1.01*(Math.cos(Math.PI/2-this._pitch)*n+this.cameraToCenterDistance),s=new Float64Array(16);t.perspective(s,this._fov,this.width/this.height,1,a),t.scale(s,s,[1,-1,1]),t.translate(s,s,[0,0,-this.cameraToCenterDistance]),t.rotateX(s,s,this._pitch),t.rotateZ(s,s,this.angle),t.translate(s,s,[-o,-r,0]);var l=this.worldSize/(2*Math.PI*6378137*Math.abs(Math.cos(this.center.lat*(Math.PI/180))));t.scale(s,s,[1,1,l,1]),this.projMatrix=s;var c=this.width%2/2,h=this.height%2/2,u=Math.cos(this.angle),p=Math.sin(this.angle),d=o-Math.round(o)+u*c+p*h,f=r-Math.round(r)+u*h+p*c,m=new Float64Array(s);if(t.translate(m,m,[d>.5?d-1:d,f>.5?f-1:f,0]),this.alignedProjMatrix=m,s=t.create(),t.scale(s,s,[this.width/2,-this.height/2,1]),t.translate(s,s,[1,-1,0]),this.pixelMatrix=t.multiply(new Float64Array(16),s,this.projMatrix),!(s=t.invert(new Float64Array(16),this.pixelMatrix)))throw new Error("failed to invert matrix");this.pixelMatrixInverse=s,this._posMatrixCache={},this._alignedPosMatrixCache={};}},Si.prototype.maxPitchScaleFactor=function(){if(!this.pixelMatrixInverse)return 1;var e=this.pointCoordinate(new t.Point(0,0)).zoomTo(this.zoom),i=[e.column*this.tileSize,e.row*this.tileSize,0,1];return t.transformMat4(i,i,this.pixelMatrix)[3]/this.cameraToCenterDistance},Object.defineProperties(Si.prototype,Ci);var zi=function(){var e,i,n,o,r;t.bindAll(["_onHashChange","_updateHash"],this),this._updateHash=(e=this._updateHashUnthrottled.bind(this),i=300,n=!1,o=0,r=function(){o=0,n&&(e(),o=setTimeout(r,i),n=!1);},function(){return n=!0,o||r(),o});};zi.prototype.addTo=function(e){return this._map=e,t.window.addEventListener("hashchange",this._onHashChange,!1),this._map.on("moveend",this._updateHash),this},zi.prototype.remove=function(){return t.window.removeEventListener("hashchange",this._onHashChange,!1),this._map.off("moveend",this._updateHash),clearTimeout(this._updateHash()),delete this._map,this},zi.prototype.getHashString=function(t){var e=this._map.getCenter(),i=Math.round(100*this._map.getZoom())/100,n=Math.ceil((i*Math.LN2+Math.log(512/360/.5))/Math.LN10),o=Math.pow(10,n),r=Math.round(e.lng*o)/o,a=Math.round(e.lat*o)/o,s=this._map.getBearing(),l=this._map.getPitch(),c="";return c+=t?"#/"+r+"/"+a+"/"+i:"#"+i+"/"+a+"/"+r,(s||l)&&(c+="/"+Math.round(10*s)/10),l&&(c+="/"+Math.round(l)),c},zi.prototype._onHashChange=function(){var e=t.window.location.hash.replace("#","").split("/");return e.length>=3&&(this._map.jumpTo({center:[+e[2],+e[1]],zoom:+e[0],bearing:+(e[3]||0),pitch:+(e[4]||0)}),!0)},zi.prototype._updateHashUnthrottled=function(){var e=this.getHashString();t.window.history.replaceState(t.window.history.state,"",e);};var Pi=function(e){function n(n,o,r,a){void 0===a&&(a={});var s=i.mousePos(o.getCanvasContainer(),r),l=o.unproject(s);e.call(this,n,t.extend({point:s,lngLat:l,originalEvent:r},a)),this._defaultPrevented=!1,this.target=o;}e&&(n.__proto__=e),n.prototype=Object.create(e&&e.prototype),n.prototype.constructor=n;var o={defaultPrevented:{configurable:!0}};return n.prototype.preventDefault=function(){this._defaultPrevented=!0;},o.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(n.prototype,o),n}(t.Event),Ai=function(e){function n(n,o,r){var a=i.touchPos(o.getCanvasContainer(),r),s=a.map(function(t){return o.unproject(t)}),l=a.reduce(function(t,e,i,n){return t.add(e.div(n.length))},new t.Point(0,0)),c=o.unproject(l);e.call(this,n,{points:a,point:l,lngLats:s,lngLat:c,originalEvent:r}),this._defaultPrevented=!1;}e&&(n.__proto__=e),n.prototype=Object.create(e&&e.prototype),n.prototype.constructor=n;var o={defaultPrevented:{configurable:!0}};return n.prototype.preventDefault=function(){this._defaultPrevented=!0;},o.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(n.prototype,o),n}(t.Event),Di=function(t){function e(e,i,n){t.call(this,e,{originalEvent:n}),this._defaultPrevented=!1;}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var i={defaultPrevented:{configurable:!0}};return e.prototype.preventDefault=function(){this._defaultPrevented=!0;},i.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(e.prototype,i),e}(t.Event),Ri=function(e){this._map=e,this._el=e.getCanvasContainer(),this._delta=0,t.bindAll(["_onWheel","_onTimeout","_onScrollFrame","_onScrollFinished"],this);};Ri.prototype.isEnabled=function(){return !!this._enabled},Ri.prototype.isActive=function(){return !!this._active},Ri.prototype.enable=function(t){this.isEnabled()||(this._enabled=!0,this._aroundCenter=t&&"center"===t.around);},Ri.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},Ri.prototype.onWheel=function(e){if(this.isEnabled()){var i=e.deltaMode===t.window.WheelEvent.DOM_DELTA_LINE?40*e.deltaY:e.deltaY,n=t.browser.now(),o=n-(this._lastWheelEventTime||0);this._lastWheelEventTime=n,0!==i&&i%4.000244140625==0?this._type="wheel":0!==i&&Math.abs(i)<4?this._type="trackpad":o>400?(this._type=null,this._lastValue=i,this._timeout=setTimeout(this._onTimeout,40,e)):this._type||(this._type=Math.abs(o*i)<200?"trackpad":"wheel",this._timeout&&(clearTimeout(this._timeout),this._timeout=null,i+=this._lastValue)),e.shiftKey&&i&&(i/=4),this._type&&(this._lastWheelEvent=e,this._delta-=i,this.isActive()||this._start(e)),e.preventDefault();}},Ri.prototype._onTimeout=function(t){this._type="wheel",this._delta-=this._lastValue,this.isActive()||this._start(t);},Ri.prototype._start=function(e){if(this._delta){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),this._active=!0,this._map.fire(new t.Event("movestart",{originalEvent:e})),this._map.fire(new t.Event("zoomstart",{originalEvent:e})),this._finishTimeout&&clearTimeout(this._finishTimeout);var n=i.mousePos(this._el,e);this._around=N.convert(this._aroundCenter?this._map.getCenter():this._map.unproject(n)),this._aroundPoint=this._map.transform.locationPoint(this._around),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onScrollFrame));}},Ri.prototype._onScrollFrame=function(){var e=this;if(this._frameId=null,this.isActive()){var i=this._map.transform;if(0!==this._delta){var n="wheel"===this._type&&Math.abs(this._delta)>4.000244140625?1/450:.01,o=2/(1+Math.exp(-Math.abs(this._delta*n)));this._delta<0&&0!==o&&(o=1/o);var r="number"==typeof this._targetZoom?i.zoomScale(this._targetZoom):i.scale;this._targetZoom=Math.min(i.maxZoom,Math.max(i.minZoom,i.scaleZoom(r*o))),"wheel"===this._type&&(this._startZoom=i.zoom,this._easing=this._smoothOutEasing(200)),this._delta=0;}var a="number"==typeof this._targetZoom?this._targetZoom:i.zoom,s=this._startZoom,l=this._easing,c=!1;if("wheel"===this._type&&s&&l){var h=Math.min((t.browser.now()-this._lastWheelEventTime)/200,1),u=l(h);i.zoom=t.number(s,a,u),h<1?this._frameId||(this._frameId=this._map._requestRenderFrame(this._onScrollFrame)):c=!0;}else i.zoom=a,c=!0;i.setLocationAtPoint(this._around,this._aroundPoint),this._map.fire(new t.Event("move",{originalEvent:this._lastWheelEvent})),this._map.fire(new t.Event("zoom",{originalEvent:this._lastWheelEvent})),c&&(this._active=!1,this._finishTimeout=setTimeout(function(){e._map.fire(new t.Event("zoomend",{originalEvent:e._lastWheelEvent})),e._map.fire(new t.Event("moveend",{originalEvent:e._lastWheelEvent})),delete e._targetZoom;},200));}},Ri.prototype._smoothOutEasing=function(e){var i=t.ease;if(this._prevEase){var n=this._prevEase,o=(t.browser.now()-n.start)/n.duration,r=n.easing(o+.01)-n.easing(o),a=.27/Math.sqrt(r*r+1e-4)*.01,s=Math.sqrt(.0729-a*a);i=t.bezier(a,s,.25,1);}return this._prevEase={start:t.browser.now(),duration:e,easing:i},i};var Mi=function(e,i){this._map=e,this._el=e.getCanvasContainer(),this._container=e.getContainer(),this._clickTolerance=i.clickTolerance||1,t.bindAll(["_onMouseMove","_onMouseUp","_onKeyDown"],this);};Mi.prototype.isEnabled=function(){return !!this._enabled},Mi.prototype.isActive=function(){return !!this._active},Mi.prototype.enable=function(){this.isEnabled()||(this._enabled=!0);},Mi.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},Mi.prototype.onMouseDown=function(e){this.isEnabled()&&e.shiftKey&&0===e.button&&(t.window.document.addEventListener("mousemove",this._onMouseMove,!1),t.window.document.addEventListener("keydown",this._onKeyDown,!1),t.window.document.addEventListener("mouseup",this._onMouseUp,!1),i.disableDrag(),this._startPos=this._lastPos=i.mousePos(this._el,e),this._active=!0);},Mi.prototype._onMouseMove=function(t){var e=i.mousePos(this._el,t);if(!(this._lastPos.equals(e)||!this._box&&e.dist(this._startPos)<this._clickTolerance)){var n=this._startPos;this._lastPos=e,this._box||(this._box=i.create("div","mapboxgl-boxzoom",this._container),this._container.classList.add("mapboxgl-crosshair"),this._fireEvent("boxzoomstart",t));var o=Math.min(n.x,e.x),r=Math.max(n.x,e.x),a=Math.min(n.y,e.y),s=Math.max(n.y,e.y);i.setTransform(this._box,"translate("+o+"px,"+a+"px)"),this._box.style.width=r-o+"px",this._box.style.height=s-a+"px";}},Mi.prototype._onMouseUp=function(e){if(0===e.button){var n=this._startPos,o=i.mousePos(this._el,e),r=(new U).extend(this._map.unproject(n)).extend(this._map.unproject(o));this._finish(),i.suppressClick(),n.x===o.x&&n.y===o.y?this._fireEvent("boxzoomcancel",e):this._map.fitBounds(r,{linear:!0}).fire(new t.Event("boxzoomend",{originalEvent:e,boxZoomBounds:r}));}},Mi.prototype._onKeyDown=function(t){27===t.keyCode&&(this._finish(),this._fireEvent("boxzoomcancel",t));},Mi.prototype._finish=function(){this._active=!1,t.window.document.removeEventListener("mousemove",this._onMouseMove,!1),t.window.document.removeEventListener("keydown",this._onKeyDown,!1),t.window.document.removeEventListener("mouseup",this._onMouseUp,!1),this._container.classList.remove("mapboxgl-crosshair"),this._box&&(i.remove(this._box),this._box=null),i.enableDrag(),delete this._startPos,delete this._lastPos;},Mi.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,{originalEvent:i}))};var Li=t.bezier(0,0,.25,1),ki=function(e,i){this._map=e,this._el=i.element||e.getCanvasContainer(),this._state="disabled",this._button=i.button||"right",this._bearingSnap=i.bearingSnap||0,this._pitchWithRotate=!1!==i.pitchWithRotate,t.bindAll(["onMouseDown","_onMouseMove","_onMouseUp","_onBlur","_onDragFrame"],this);};ki.prototype.isEnabled=function(){return "disabled"!==this._state},ki.prototype.isActive=function(){return "active"===this._state},ki.prototype.enable=function(){this.isEnabled()||(this._state="enabled");},ki.prototype.disable=function(){if(this.isEnabled())switch(this._state){case"active":this._state="disabled",this._unbind(),this._deactivate(),this._fireEvent("rotateend"),this._pitchWithRotate&&this._fireEvent("pitchend"),this._fireEvent("moveend");break;case"pending":this._state="disabled",this._unbind();break;default:this._state="disabled";}},ki.prototype.onMouseDown=function(e){if("enabled"===this._state){if("right"===this._button){if(this._eventButton=i.mouseButton(e),this._eventButton!==(e.ctrlKey?0:2))return}else{if(e.ctrlKey||0!==i.mouseButton(e))return;this._eventButton=0;}i.disableDrag(),t.window.document.addEventListener("mousemove",this._onMouseMove,{capture:!0}),t.window.document.addEventListener("mouseup",this._onMouseUp),t.window.addEventListener("blur",this._onBlur),this._state="pending",this._inertia=[[t.browser.now(),this._map.getBearing()]],this._startPos=this._lastPos=i.mousePos(this._el,e),this._center=this._map.transform.centerPoint,e.preventDefault();}},ki.prototype._onMouseMove=function(t){var e=i.mousePos(this._el,t);this._lastPos.equals(e)||(this._lastMoveEvent=t,this._lastPos=e,"pending"===this._state&&(this._state="active",this._fireEvent("rotatestart",t),this._fireEvent("movestart",t),this._pitchWithRotate&&this._fireEvent("pitchstart",t)),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onDragFrame)));},ki.prototype._onDragFrame=function(){this._frameId=null;var e=this._lastMoveEvent;if(e){var i=this._map.transform,n=this._startPos,o=this._lastPos,r=.8*(n.x-o.x),a=-.5*(n.y-o.y),s=i.bearing-r,l=i.pitch-a,c=this._inertia,h=c[c.length-1];this._drainInertiaBuffer(),c.push([t.browser.now(),this._map._normalizeBearing(s,h[1])]),i.bearing=s,this._pitchWithRotate&&(this._fireEvent("pitch",e),i.pitch=l),this._fireEvent("rotate",e),this._fireEvent("move",e),delete this._lastMoveEvent,this._startPos=this._lastPos;}},ki.prototype._onMouseUp=function(t){if(i.mouseButton(t)===this._eventButton)switch(this._state){case"active":this._state="enabled",i.suppressClick(),this._unbind(),this._deactivate(),this._inertialRotate(t);break;case"pending":this._state="enabled",this._unbind();}},ki.prototype._onBlur=function(t){switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._fireEvent("rotateend",t),this._pitchWithRotate&&this._fireEvent("pitchend",t),this._fireEvent("moveend",t);break;case"pending":this._state="enabled",this._unbind();}},ki.prototype._unbind=function(){t.window.document.removeEventListener("mousemove",this._onMouseMove,{capture:!0}),t.window.document.removeEventListener("mouseup",this._onMouseUp),t.window.removeEventListener("blur",this._onBlur),i.enableDrag();},ki.prototype._deactivate=function(){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._lastMoveEvent,delete this._startPos,delete this._lastPos;},ki.prototype._inertialRotate=function(t){var e=this;this._fireEvent("rotateend",t),this._drainInertiaBuffer();var i=this._map,n=i.getBearing(),o=this._inertia,r=function(){Math.abs(n)<e._bearingSnap?i.resetNorth({noMoveStart:!0},{originalEvent:t}):e._fireEvent("moveend",t),e._pitchWithRotate&&e._fireEvent("pitchend",t);};if(o.length<2)r();else{var a=o[0],s=o[o.length-1],l=o[o.length-2],c=i._normalizeBearing(n,l[1]),h=s[1]-a[1],u=h<0?-1:1,p=(s[0]-a[0])/1e3;if(0!==h&&0!==p){var d=Math.abs(h*(.25/p));d>180&&(d=180);var f=d/180;c+=u*d*(f/2),Math.abs(i._normalizeBearing(c,0))<this._bearingSnap&&(c=i._normalizeBearing(0,c)),i.rotateTo(c,{duration:1e3*f,easing:Li,noMoveStart:!0},{originalEvent:t});}else r();}},ki.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,i?{originalEvent:i}:{}))},ki.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>0&&i-e[0][0]>160;)e.shift();};var Bi=t.bezier(0,0,.3,1),Oi=function(e,i){this._map=e,this._el=e.getCanvasContainer(),this._state="disabled",this._clickTolerance=i.clickTolerance||1,t.bindAll(["_onMove","_onMouseUp","_onTouchEnd","_onBlur","_onDragFrame"],this);};Oi.prototype.isEnabled=function(){return "disabled"!==this._state},Oi.prototype.isActive=function(){return "active"===this._state},Oi.prototype.enable=function(){this.isEnabled()||(this._el.classList.add("mapboxgl-touch-drag-pan"),this._state="enabled");},Oi.prototype.disable=function(){if(this.isEnabled())switch(this._el.classList.remove("mapboxgl-touch-drag-pan"),this._state){case"active":this._state="disabled",this._unbind(),this._deactivate(),this._fireEvent("dragend"),this._fireEvent("moveend");break;case"pending":this._state="disabled",this._unbind();break;default:this._state="disabled";}},Oi.prototype.onMouseDown=function(e){"enabled"===this._state&&(e.ctrlKey||0!==i.mouseButton(e)||(i.addEventListener(t.window.document,"mousemove",this._onMove,{capture:!0}),i.addEventListener(t.window.document,"mouseup",this._onMouseUp),this._start(e)));},Oi.prototype.onTouchStart=function(e){"enabled"===this._state&&(e.touches.length>1||(i.addEventListener(t.window.document,"touchmove",this._onMove,{capture:!0,passive:!1}),i.addEventListener(t.window.document,"touchend",this._onTouchEnd),this._start(e)));},Oi.prototype._start=function(e){t.window.addEventListener("blur",this._onBlur),this._state="pending",this._startPos=this._mouseDownPos=this._lastPos=i.mousePos(this._el,e),this._inertia=[[t.browser.now(),this._startPos]];},Oi.prototype._onMove=function(e){e.preventDefault();var n=i.mousePos(this._el,e);this._lastPos.equals(n)||"pending"===this._state&&n.dist(this._mouseDownPos)<this._clickTolerance||(this._lastMoveEvent=e,this._lastPos=n,this._drainInertiaBuffer(),this._inertia.push([t.browser.now(),this._lastPos]),"pending"===this._state&&(this._state="active",this._fireEvent("dragstart",e),this._fireEvent("movestart",e)),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onDragFrame)));},Oi.prototype._onDragFrame=function(){this._frameId=null;var t=this._lastMoveEvent;if(t){var e=this._map.transform;e.setLocationAtPoint(e.pointLocation(this._startPos),this._lastPos),this._fireEvent("drag",t),this._fireEvent("move",t),this._startPos=this._lastPos,delete this._lastMoveEvent;}},Oi.prototype._onMouseUp=function(t){if(0===i.mouseButton(t))switch(this._state){case"active":this._state="enabled",i.suppressClick(),this._unbind(),this._deactivate(),this._inertialPan(t);break;case"pending":this._state="enabled",this._unbind();}},Oi.prototype._onTouchEnd=function(t){switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._inertialPan(t);break;case"pending":this._state="enabled",this._unbind();}},Oi.prototype._onBlur=function(t){switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._fireEvent("dragend",t),this._fireEvent("moveend",t);break;case"pending":this._state="enabled",this._unbind();}},Oi.prototype._unbind=function(){i.removeEventListener(t.window.document,"touchmove",this._onMove,{capture:!0,passive:!1}),i.removeEventListener(t.window.document,"touchend",this._onTouchEnd),i.removeEventListener(t.window.document,"mousemove",this._onMove,{capture:!0}),i.removeEventListener(t.window.document,"mouseup",this._onMouseUp),i.removeEventListener(t.window,"blur",this._onBlur);},Oi.prototype._deactivate=function(){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._lastMoveEvent,delete this._startPos,delete this._mouseDownPos,delete this._lastPos;},Oi.prototype._inertialPan=function(t){this._fireEvent("dragend",t),this._drainInertiaBuffer();var e=this._inertia;if(e.length<2)this._fireEvent("moveend",t);else{var i=e[e.length-1],n=e[0],o=i[1].sub(n[1]),r=(i[0]-n[0])/1e3;if(0===r||i[1].equals(n[1]))this._fireEvent("moveend",t);else{var a=o.mult(.3/r),s=a.mag();s>1400&&(s=1400,a._unit()._mult(s));var l=s/750,c=a.mult(-l/2);this._map.panBy(c,{duration:1e3*l,easing:Bi,noMoveStart:!0},{originalEvent:t});}}},Oi.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,i?{originalEvent:i}:{}))},Oi.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>0&&i-e[0][0]>160;)e.shift();};var Fi=function(e){this._map=e,this._el=e.getCanvasContainer(),t.bindAll(["_onKeyDown"],this);};function Ni(t){return t*(2-t)}Fi.prototype.isEnabled=function(){return !!this._enabled},Fi.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("keydown",this._onKeyDown,!1),this._enabled=!0);},Fi.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("keydown",this._onKeyDown),this._enabled=!1);},Fi.prototype._onKeyDown=function(t){if(!(t.altKey||t.ctrlKey||t.metaKey)){var e=0,i=0,n=0,o=0,r=0;switch(t.keyCode){case 61:case 107:case 171:case 187:e=1;break;case 189:case 109:case 173:e=-1;break;case 37:t.shiftKey?i=-1:(t.preventDefault(),o=-1);break;case 39:t.shiftKey?i=1:(t.preventDefault(),o=1);break;case 38:t.shiftKey?n=1:(t.preventDefault(),r=-1);break;case 40:t.shiftKey?n=-1:(r=1,t.preventDefault());break;default:return}var a=this._map,s=a.getZoom(),l={duration:300,delayEndEvents:500,easing:Ni,zoom:e?Math.round(s)+e*(t.shiftKey?2:1):s,bearing:a.getBearing()+15*i,pitch:a.getPitch()+10*n,offset:[100*-o,100*-r],center:a.getCenter()};a.easeTo(l,{originalEvent:t});}};var Ui=function(e){this._map=e,t.bindAll(["_onDblClick","_onZoomEnd"],this);};Ui.prototype.isEnabled=function(){return !!this._enabled},Ui.prototype.isActive=function(){return !!this._active},Ui.prototype.enable=function(){this.isEnabled()||(this._enabled=!0);},Ui.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},Ui.prototype.onTouchStart=function(t){var e=this;this.isEnabled()&&(t.points.length>1||(this._tapped?(clearTimeout(this._tapped),this._tapped=null,this._zoom(t)):this._tapped=setTimeout(function(){e._tapped=null;},300)));},Ui.prototype.onDblClick=function(t){this.isEnabled()&&(t.originalEvent.preventDefault(),this._zoom(t));},Ui.prototype._zoom=function(t){this._active=!0,this._map.on("zoomend",this._onZoomEnd),this._map.zoomTo(this._map.getZoom()+(t.originalEvent.shiftKey?-1:1),{around:t.lngLat},t);},Ui.prototype._onZoomEnd=function(){this._active=!1,this._map.off("zoomend",this._onZoomEnd);};var Vi=t.bezier(0,0,.15,1),Zi=function(e){this._map=e,this._el=e.getCanvasContainer(),t.bindAll(["_onMove","_onEnd","_onTouchFrame"],this);};Zi.prototype.isEnabled=function(){return !!this._enabled},Zi.prototype.enable=function(t){this.isEnabled()||(this._el.classList.add("mapboxgl-touch-zoom-rotate"),this._enabled=!0,this._aroundCenter=!!t&&"center"===t.around);},Zi.prototype.disable=function(){this.isEnabled()&&(this._el.classList.remove("mapboxgl-touch-zoom-rotate"),this._enabled=!1);},Zi.prototype.disableRotation=function(){this._rotationDisabled=!0;},Zi.prototype.enableRotation=function(){this._rotationDisabled=!1;},Zi.prototype.onStart=function(e){if(this.isEnabled()&&2===e.touches.length){var n=i.mousePos(this._el,e.touches[0]),o=i.mousePos(this._el,e.touches[1]);this._startVec=n.sub(o),this._gestureIntent=void 0,this._inertia=[],i.addEventListener(t.window.document,"touchmove",this._onMove,{passive:!1}),i.addEventListener(t.window.document,"touchend",this._onEnd);}},Zi.prototype._getTouchEventData=function(t){var e=i.mousePos(this._el,t.touches[0]),n=i.mousePos(this._el,t.touches[1]),o=e.sub(n);return {vec:o,center:e.add(n).div(2),scale:o.mag()/this._startVec.mag(),bearing:this._rotationDisabled?0:180*o.angleWith(this._startVec)/Math.PI}},Zi.prototype._onMove=function(e){if(2===e.touches.length){var i=this._getTouchEventData(e),n=i.vec,o=i.scale,r=i.bearing;if(!this._gestureIntent){var a=Math.abs(1-o)>.15;Math.abs(r)>10?this._gestureIntent="rotate":a&&(this._gestureIntent="zoom"),this._gestureIntent&&(this._map.fire(new t.Event(this._gestureIntent+"start",{originalEvent:e})),this._map.fire(new t.Event("movestart",{originalEvent:e})),this._startVec=n);}this._lastTouchEvent=e,this._frameId||(this._frameId=this._map._requestRenderFrame(this._onTouchFrame)),e.preventDefault();}},Zi.prototype._onTouchFrame=function(){this._frameId=null;var e=this._gestureIntent;if(e){var i=this._map.transform;this._startScale||(this._startScale=i.scale,this._startBearing=i.bearing);var n=this._getTouchEventData(this._lastTouchEvent),o=n.center,r=n.bearing,a=n.scale,s=i.pointLocation(o),l=i.locationPoint(s);"rotate"===e&&(i.bearing=this._startBearing+r),i.zoom=i.scaleZoom(this._startScale*a),i.setLocationAtPoint(s,l),this._map.fire(new t.Event(e,{originalEvent:this._lastTouchEvent})),this._map.fire(new t.Event("move",{originalEvent:this._lastTouchEvent})),this._drainInertiaBuffer(),this._inertia.push([t.browser.now(),a,o]);}},Zi.prototype._onEnd=function(e){i.removeEventListener(t.window.document,"touchmove",this._onMove,{passive:!1}),i.removeEventListener(t.window.document,"touchend",this._onEnd);var n=this._gestureIntent,o=this._startScale;if(this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._gestureIntent,delete this._startScale,delete this._startBearing,delete this._lastTouchEvent,n){this._map.fire(new t.Event(n+"end",{originalEvent:e})),this._drainInertiaBuffer();var r=this._inertia,a=this._map;if(r.length<2)a.snapToNorth({},{originalEvent:e});else{var s=r[r.length-1],l=r[0],c=a.transform.scaleZoom(o*s[1]),h=a.transform.scaleZoom(o*l[1]),u=c-h,p=(s[0]-l[0])/1e3,d=s[2];if(0!==p&&c!==h){var f=.15*u/p;Math.abs(f)>2.5&&(f=f>0?2.5:-2.5);var m=1e3*Math.abs(f/(12*.15)),_=c+f*m/2e3;_<0&&(_=0),a.easeTo({zoom:_,duration:m,easing:Vi,around:this._aroundCenter?a.getCenter():a.unproject(d),noMoveStart:!0},{originalEvent:e});}else a.snapToNorth({},{originalEvent:e});}}},Zi.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>2&&i-e[0][0]>160;)e.shift();};var ji={scrollZoom:Ri,boxZoom:Mi,dragRotate:ki,dragPan:Oi,keyboard:Fi,doubleClickZoom:Ui,touchZoomRotate:Zi};var qi=function(e){function i(i,n){e.call(this),this._moving=!1,this._zooming=!1,this.transform=i,this._bearingSnap=n.bearingSnap,t.bindAll(["_renderFrameCallback"],this);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getCenter=function(){return this.transform.center},i.prototype.setCenter=function(t,e){return this.jumpTo({center:t},e)},i.prototype.panBy=function(e,i,n){return e=t.Point.convert(e).mult(-1),this.panTo(this.transform.center,t.extend({offset:e},i),n)},i.prototype.panTo=function(e,i,n){return this.easeTo(t.extend({center:e},i),n)},i.prototype.getZoom=function(){return this.transform.zoom},i.prototype.setZoom=function(t,e){return this.jumpTo({zoom:t},e),this},i.prototype.zoomTo=function(e,i,n){return this.easeTo(t.extend({zoom:e},i),n)},i.prototype.zoomIn=function(t,e){return this.zoomTo(this.getZoom()+1,t,e),this},i.prototype.zoomOut=function(t,e){return this.zoomTo(this.getZoom()-1,t,e),this},i.prototype.getBearing=function(){return this.transform.bearing},i.prototype.setBearing=function(t,e){return this.jumpTo({bearing:t},e),this},i.prototype.rotateTo=function(e,i,n){return this.easeTo(t.extend({bearing:e},i),n)},i.prototype.resetNorth=function(e,i){return this.rotateTo(0,t.extend({duration:1e3},e),i),this},i.prototype.snapToNorth=function(t,e){return Math.abs(this.getBearing())<this._bearingSnap?this.resetNorth(t,e):this},i.prototype.getPitch=function(){return this.transform.pitch},i.prototype.setPitch=function(t,e){return this.jumpTo({pitch:t},e),this},i.prototype.cameraForBounds=function(e,i){if("number"==typeof(i=t.extend({padding:{top:0,bottom:0,right:0,left:0},offset:[0,0],maxZoom:this.transform.maxZoom},i)).padding){var n=i.padding;i.padding={top:n,bottom:n,right:n,left:n};}if(t.deepEqual(Object.keys(i.padding).sort(function(t,e){return t<e?-1:t>e?1:0}),["bottom","left","right","top"])){e=U.convert(e);var o=[(i.padding.left-i.padding.right)/2,(i.padding.top-i.padding.bottom)/2],r=Math.min(i.padding.right,i.padding.left),a=Math.min(i.padding.top,i.padding.bottom);i.offset=[i.offset[0]+o[0],i.offset[1]+o[1]];var s=t.Point.convert(i.offset),l=this.transform,c=l.project(e.getNorthWest()),h=l.project(e.getSouthEast()),u=h.sub(c),p=(l.width-2*r-2*Math.abs(s.x))/u.x,d=(l.height-2*a-2*Math.abs(s.y))/u.y;if(!(d<0||p<0))return i.center=l.unproject(c.add(h).div(2)),i.zoom=Math.min(l.scaleZoom(l.scale*Math.min(p,d)),i.maxZoom),i.bearing=0,i;t.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");}else t.warnOnce("options.padding must be a positive number, or an Object with keys 'bottom', 'left', 'right', 'top'");},i.prototype.fitBounds=function(e,i,n){var o=this.cameraForBounds(e,i);return o?(i=t.extend(o,i)).linear?this.easeTo(i,n):this.flyTo(i,n):this},i.prototype.jumpTo=function(e,i){this.stop();var n=this.transform,o=!1,r=!1,a=!1;return "zoom"in e&&n.zoom!==+e.zoom&&(o=!0,n.zoom=+e.zoom),void 0!==e.center&&(n.center=N.convert(e.center)),"bearing"in e&&n.bearing!==+e.bearing&&(r=!0,n.bearing=+e.bearing),"pitch"in e&&n.pitch!==+e.pitch&&(a=!0,n.pitch=+e.pitch),this.fire(new t.Event("movestart",i)).fire(new t.Event("move",i)),o&&this.fire(new t.Event("zoomstart",i)).fire(new t.Event("zoom",i)).fire(new t.Event("zoomend",i)),r&&this.fire(new t.Event("rotatestart",i)).fire(new t.Event("rotate",i)).fire(new t.Event("rotateend",i)),a&&this.fire(new t.Event("pitchstart",i)).fire(new t.Event("pitch",i)).fire(new t.Event("pitchend",i)),this.fire(new t.Event("moveend",i))},i.prototype.easeTo=function(e,i){var n=this;this.stop(),!1===(e=t.extend({offset:[0,0],duration:500,easing:t.ease},e)).animate&&(e.duration=0);var o=this.transform,r=this.getZoom(),a=this.getBearing(),s=this.getPitch(),l="zoom"in e?+e.zoom:r,c="bearing"in e?this._normalizeBearing(e.bearing,a):a,h="pitch"in e?+e.pitch:s,u=o.centerPoint.add(t.Point.convert(e.offset)),p=o.pointLocation(u),d=N.convert(e.center||p);this._normalizeCenter(d);var f,m,_=o.project(p),g=o.project(d).sub(_),v=o.zoomScale(l-r);return e.around&&(f=N.convert(e.around),m=o.locationPoint(f)),this._zooming=l!==r,this._rotating=a!==c,this._pitching=h!==s,this._prepareEase(i,e.noMoveStart),clearTimeout(this._easeEndTimeoutID),this._ease(function(e){if(n._zooming&&(o.zoom=t.number(r,l,e)),n._rotating&&(o.bearing=t.number(a,c,e)),n._pitching&&(o.pitch=t.number(s,h,e)),f)o.setLocationAtPoint(f,m);else{var p=o.zoomScale(o.zoom-r),d=l>r?Math.min(2,v):Math.max(.5,v),y=Math.pow(d,1-e),x=o.unproject(_.add(g.mult(e*y)).mult(p));o.setLocationAtPoint(o.renderWorldCopies?x.wrap():x,u);}n._fireMoveEvents(i);},function(){e.delayEndEvents?n._easeEndTimeoutID=setTimeout(function(){return n._afterEase(i)},e.delayEndEvents):n._afterEase(i);},e),this},i.prototype._prepareEase=function(e,i){this._moving=!0,i||this.fire(new t.Event("movestart",e)),this._zooming&&this.fire(new t.Event("zoomstart",e)),this._rotating&&this.fire(new t.Event("rotatestart",e)),this._pitching&&this.fire(new t.Event("pitchstart",e));},i.prototype._fireMoveEvents=function(e){this.fire(new t.Event("move",e)),this._zooming&&this.fire(new t.Event("zoom",e)),this._rotating&&this.fire(new t.Event("rotate",e)),this._pitching&&this.fire(new t.Event("pitch",e));},i.prototype._afterEase=function(e){var i=this._zooming,n=this._rotating,o=this._pitching;this._moving=!1,this._zooming=!1,this._rotating=!1,this._pitching=!1,i&&this.fire(new t.Event("zoomend",e)),n&&this.fire(new t.Event("rotateend",e)),o&&this.fire(new t.Event("pitchend",e)),this.fire(new t.Event("moveend",e));},i.prototype.flyTo=function(e,i){var n=this;this.stop(),e=t.extend({offset:[0,0],speed:1.2,curve:1.42,easing:t.ease},e);var o=this.transform,r=this.getZoom(),a=this.getBearing(),s=this.getPitch(),l="zoom"in e?t.clamp(+e.zoom,o.minZoom,o.maxZoom):r,c="bearing"in e?this._normalizeBearing(e.bearing,a):a,h="pitch"in e?+e.pitch:s,u=o.zoomScale(l-r),p=o.centerPoint.add(t.Point.convert(e.offset)),d=o.pointLocation(p),f=N.convert(e.center||d);this._normalizeCenter(f);var m=o.project(d),_=o.project(f).sub(m),g=e.curve,v=Math.max(o.width,o.height),y=v/u,x=_.mag();if("minZoom"in e){var b=t.clamp(Math.min(e.minZoom,r,l),o.minZoom,o.maxZoom),w=v/o.zoomScale(b-r);g=Math.sqrt(w/x*2);}var E=g*g;function T(t){var e=(y*y-v*v+(t?-1:1)*E*E*x*x)/(2*(t?y:v)*E*x);return Math.log(Math.sqrt(e*e+1)-e)}function I(t){return (Math.exp(t)-Math.exp(-t))/2}function S(t){return (Math.exp(t)+Math.exp(-t))/2}var C=T(0),z=function(t){return S(C)/S(C+g*t)},P=function(t){return v*((S(C)*(I(e=C+g*t)/S(e))-I(C))/E)/x;var e;},A=(T(1)-C)/g;if(Math.abs(x)<1e-6||!isFinite(A)){if(Math.abs(v-y)<1e-6)return this.easeTo(e,i);var D=y<v?-1:1;A=Math.abs(Math.log(y/v))/g,P=function(){return 0},z=function(t){return Math.exp(D*g*t)};}if("duration"in e)e.duration=+e.duration;else{var R="screenSpeed"in e?+e.screenSpeed/g:+e.speed;e.duration=1e3*A/R;}return e.maxDuration&&e.duration>e.maxDuration&&(e.duration=0),this._zooming=!0,this._rotating=a!==c,this._pitching=h!==s,this._prepareEase(i,!1),this._ease(function(e){var u=e*A,d=1/z(u);o.zoom=1===e?l:r+o.scaleZoom(d),n._rotating&&(o.bearing=t.number(a,c,e)),n._pitching&&(o.pitch=t.number(s,h,e));var f=o.unproject(m.add(_.mult(P(u))).mult(d));o.setLocationAtPoint(o.renderWorldCopies?f.wrap():f,p),n._fireMoveEvents(i);},function(){return n._afterEase(i)},e),this},i.prototype.isEasing=function(){return !!this._easeFrameId},i.prototype.stop=function(){if(this._easeFrameId&&(this._cancelRenderFrame(this._easeFrameId),delete this._easeFrameId,delete this._onEaseFrame),this._onEaseEnd){var t=this._onEaseEnd;delete this._onEaseEnd,t.call(this);}return this},i.prototype._ease=function(e,i,n){!1===n.animate||0===n.duration?(e(1),i()):(this._easeStart=t.browser.now(),this._easeOptions=n,this._onEaseFrame=e,this._onEaseEnd=i,this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback));},i.prototype._renderFrameCallback=function(){var e=Math.min((t.browser.now()-this._easeStart)/this._easeOptions.duration,1);this._onEaseFrame(this._easeOptions.easing(e)),e<1?this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback):this.stop();},i.prototype._normalizeBearing=function(e,i){e=t.wrap(e,-180,180);var n=Math.abs(e-i);return Math.abs(e-360-i)<n&&(e-=360),Math.abs(e+360-i)<n&&(e+=360),e},i.prototype._normalizeCenter=function(t){var e=this.transform;if(e.renderWorldCopies&&!e.lngRange){var i=t.lng-e.center.lng;t.lng+=i>180?-360:i<-180?360:0;}},i}(t.Evented),Gi=function(e){void 0===e&&(e={}),this.options=e,t.bindAll(["_updateEditLink","_updateData","_updateCompact"],this);};Gi.prototype.getDefaultPosition=function(){return "bottom-right"},Gi.prototype.onAdd=function(t){var e=this.options&&this.options.compact;return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-attrib"),e&&this._container.classList.add("mapboxgl-compact"),this._updateAttributions(),this._updateEditLink(),this._map.on("sourcedata",this._updateData),this._map.on("moveend",this._updateEditLink),void 0===e&&(this._map.on("resize",this._updateCompact),this._updateCompact()),this._container},Gi.prototype.onRemove=function(){i.remove(this._container),this._map.off("sourcedata",this._updateData),this._map.off("moveend",this._updateEditLink),this._map.off("resize",this._updateCompact),this._map=void 0;},Gi.prototype._updateEditLink=function(){var t=this._editLink;t||(t=this._editLink=this._container.querySelector(".mapbox-improve-map"));var e=[{key:"owner",value:this.styleOwner},{key:"id",value:this.styleId},{key:"access_token",value:u.ACCESS_TOKEN}];if(t){var i=e.reduce(function(t,i,n){return i.value&&(t+=i.key+"="+i.value+(n<e.length-1?"&":"")),t},"?");t.href="https://www.mapbox.com/feedback/"+i+(this._map._hash?this._map._hash.getHashString(!0):"");}},Gi.prototype._updateData=function(t){t&&"metadata"===t.sourceDataType&&(this._updateAttributions(),this._updateEditLink());},Gi.prototype._updateAttributions=function(){if(this._map.style){var t=[];if(this.options.customAttribution&&(Array.isArray(this.options.customAttribution)?t=t.concat(this.options.customAttribution):"string"==typeof this.options.customAttribution&&t.push(this.options.customAttribution)),this._map.style.stylesheet){var e=this._map.style.stylesheet;this.styleOwner=e.owner,this.styleId=e.id;}var i=this._map.style.sourceCaches;for(var n in i){var o=i[n].getSource();o.attribution&&t.indexOf(o.attribution)<0&&t.push(o.attribution);}t.sort(function(t,e){return t.length-e.length}),(t=t.filter(function(e,i){for(var n=i+1;n<t.length;n++)if(t[n].indexOf(e)>=0)return !1;return !0})).length?(this._container.innerHTML=t.join(" | "),this._container.classList.remove("mapboxgl-attrib-empty")):this._container.classList.add("mapboxgl-attrib-empty"),this._editLink=null;}},Gi.prototype._updateCompact=function(){this._map.getCanvasContainer().offsetWidth<=640?this._container.classList.add("mapboxgl-compact"):this._container.classList.remove("mapboxgl-compact");};var Wi=function(){t.bindAll(["_updateLogo"],this),t.bindAll(["_updateCompact"],this);};Wi.prototype.onAdd=function(t){this._map=t,this._container=i.create("div","mapboxgl-ctrl");var e=i.create("a","mapboxgl-ctrl-logo");return e.target="_blank",e.href="https://www.mapbox.com/",e.setAttribute("aria-label","Mapbox logo"),e.setAttribute("rel","noopener"),this._container.appendChild(e),this._container.style.display="none",this._map.on("sourcedata",this._updateLogo),this._updateLogo(),this._map.on("resize",this._updateCompact),this._updateCompact(),this._container},Wi.prototype.onRemove=function(){i.remove(this._container),this._map.off("sourcedata",this._updateLogo),this._map.off("resize",this._updateCompact);},Wi.prototype.getDefaultPosition=function(){return "bottom-left"},Wi.prototype._updateLogo=function(t){t&&"metadata"!==t.sourceDataType||(this._container.style.display=this._logoRequired()?"block":"none");},Wi.prototype._logoRequired=function(){if(this._map.style){var t=this._map.style.sourceCaches;for(var e in t){if(t[e].getSource().mapbox_logo)return !0}return !1}},Wi.prototype._updateCompact=function(){var t=this._container.children;if(t.length){var e=t[0];this._map.getCanvasContainer().offsetWidth<250?e.classList.add("mapboxgl-compact"):e.classList.remove("mapboxgl-compact");}};var Xi=function(){this._queue=[],this._id=0,this._cleared=!1,this._currentlyRunning=!1;};Xi.prototype.add=function(t){var e=++this._id;return this._queue.push({callback:t,id:e,cancelled:!1}),e},Xi.prototype.remove=function(t){for(var e=this._currentlyRunning,i=0,n=e?this._queue.concat(e):this._queue;i<n.length;i+=1){var o=n[i];if(o.id===t)return void(o.cancelled=!0)}},Xi.prototype.run=function(){var t=this._currentlyRunning=this._queue;this._queue=[];for(var e=0,i=t;e<i.length;e+=1){var n=i[e];if(!n.cancelled&&(n.callback(),this._cleared))break}this._cleared=!1,this._currentlyRunning=!1;},Xi.prototype.clear=function(){this._currentlyRunning&&(this._cleared=!0),this._queue=[];};var Hi=t.window.HTMLImageElement,Ki=t.window.HTMLElement,Yi={center:[0,0],zoom:0,bearing:0,pitch:0,minZoom:0,maxZoom:22,interactive:!0,scrollZoom:!0,boxZoom:!0,dragRotate:!0,dragPan:!0,keyboard:!0,doubleClickZoom:!0,touchZoomRotate:!0,bearingSnap:7,clickTolerance:3,hash:!1,attributionControl:!0,failIfMajorPerformanceCaveat:!1,preserveDrawingBuffer:!1,trackResize:!0,renderWorldCopies:!0,refreshExpiredTiles:!0,maxTileCacheSize:null,transformRequest:null,fadeDuration:300,crossSourceCollisions:!0},Ji=function(n){function o(e){var o=this;if(null!=(e=t.extend({},Yi,e)).minZoom&&null!=e.maxZoom&&e.minZoom>e.maxZoom)throw new Error("maxZoom must be greater than minZoom");var r=new Si(e.minZoom,e.maxZoom,e.renderWorldCopies);n.call(this,r,e),this._interactive=e.interactive,this._maxTileCacheSize=e.maxTileCacheSize,this._failIfMajorPerformanceCaveat=e.failIfMajorPerformanceCaveat,this._preserveDrawingBuffer=e.preserveDrawingBuffer,this._trackResize=e.trackResize,this._bearingSnap=e.bearingSnap,this._refreshExpiredTiles=e.refreshExpiredTiles,this._fadeDuration=e.fadeDuration,this._crossSourceCollisions=e.crossSourceCollisions,this._crossFadingFactor=1,this._collectResourceTiming=e.collectResourceTiming,this._renderTaskQueue=new Xi,this._controls=[];var a=e.transformRequest;if(this._transformRequest=a?function(t,e){return a(t,e)||{url:t}}:function(t){return {url:t}},"string"==typeof e.container){if(this._container=t.window.document.getElementById(e.container),!this._container)throw new Error("Container '"+e.container+"' not found.")}else{if(!(e.container instanceof Ki))throw new Error("Invalid type: 'container' must be a String or HTMLElement.");this._container=e.container;}if(e.maxBounds&&this.setMaxBounds(e.maxBounds),t.bindAll(["_onWindowOnline","_onWindowResize","_contextLost","_contextRestored"],this),this._setupContainer(),this._setupPainter(),void 0===this.painter)throw new Error("Failed to initialize WebGL.");this.on("move",function(){return o._update(!1)}),this.on("zoom",function(){return o._update(!0)}),void 0!==t.window&&(t.window.addEventListener("online",this._onWindowOnline,!1),t.window.addEventListener("resize",this._onWindowResize,!1)),function(t,e){var n=t.getCanvasContainer(),o=null,r=!1,a=null;for(var s in ji)t[s]=new ji[s](t,e),e.interactive&&e[s]&&t[s].enable(e[s]);i.addEventListener(n,"mouseout",function(e){t.fire(new Pi("mouseout",t,e));}),i.addEventListener(n,"mousedown",function(o){r=!0,a=i.mousePos(n,o);var s=new Pi("mousedown",t,o);t.fire(s),s.defaultPrevented||(e.interactive&&!t.doubleClickZoom.isActive()&&t.stop(),t.boxZoom.onMouseDown(o),t.boxZoom.isActive()||t.dragPan.isActive()||t.dragRotate.onMouseDown(o),t.boxZoom.isActive()||t.dragRotate.isActive()||t.dragPan.onMouseDown(o));}),i.addEventListener(n,"mouseup",function(e){var i=t.dragRotate.isActive();o&&!i&&t.fire(new Pi("contextmenu",t,o)),o=null,r=!1,t.fire(new Pi("mouseup",t,e));}),i.addEventListener(n,"mousemove",function(e){if(!t.dragPan.isActive()&&!t.dragRotate.isActive()){for(var i=e.target;i&&i!==n;)i=i.parentNode;i===n&&t.fire(new Pi("mousemove",t,e));}}),i.addEventListener(n,"mouseover",function(e){for(var i=e.target;i&&i!==n;)i=i.parentNode;i===n&&t.fire(new Pi("mouseover",t,e));}),i.addEventListener(n,"touchstart",function(i){var n=new Ai("touchstart",t,i);t.fire(n),n.defaultPrevented||(e.interactive&&t.stop(),t.boxZoom.isActive()||t.dragRotate.isActive()||t.dragPan.onTouchStart(i),t.touchZoomRotate.onStart(i),t.doubleClickZoom.onTouchStart(n));},{passive:!1}),i.addEventListener(n,"touchmove",function(e){t.fire(new Ai("touchmove",t,e));},{passive:!1}),i.addEventListener(n,"touchend",function(e){t.fire(new Ai("touchend",t,e));}),i.addEventListener(n,"touchcancel",function(e){t.fire(new Ai("touchcancel",t,e));}),i.addEventListener(n,"click",function(o){var r=i.mousePos(n,o);(r.equals(a)||r.dist(a)<e.clickTolerance)&&t.fire(new Pi("click",t,o));}),i.addEventListener(n,"dblclick",function(e){var i=new Pi("dblclick",t,e);t.fire(i),i.defaultPrevented||t.doubleClickZoom.onDblClick(i);}),i.addEventListener(n,"contextmenu",function(e){var i=t.dragRotate.isActive();r||i?r&&(o=e):t.fire(new Pi("contextmenu",t,e)),e.preventDefault();}),i.addEventListener(n,"wheel",function(i){e.interactive&&t.stop();var n=new Di("wheel",t,i);t.fire(n),n.defaultPrevented||t.scrollZoom.onWheel(i);},{passive:!1});}(this,e),this._hash=e.hash&&(new zi).addTo(this),this._hash&&this._hash._onHashChange()||this.jumpTo({center:e.center,zoom:e.zoom,bearing:e.bearing,pitch:e.pitch}),this.resize(),e.style&&this.setStyle(e.style,{localIdeographFontFamily:e.localIdeographFontFamily}),e.attributionControl&&this.addControl(new Gi({customAttribution:e.customAttribution})),this.addControl(new Wi,e.logoPosition),this.on("style.load",function(){o.transform.unmodified&&o.jumpTo(o.style.stylesheet);}),this.on("data",function(e){o._update("style"===e.dataType),o.fire(new t.Event(e.dataType+"data",e));}),this.on("dataloading",function(e){o.fire(new t.Event(e.dataType+"dataloading",e));});}n&&(o.__proto__=n),o.prototype=Object.create(n&&n.prototype),o.prototype.constructor=o;var r={showTileBoundaries:{configurable:!0},showCollisionBoxes:{configurable:!0},showOverdrawInspector:{configurable:!0},repaint:{configurable:!0},vertices:{configurable:!0}};return o.prototype.addControl=function(e,i){if(void 0===i&&e.getDefaultPosition&&(i=e.getDefaultPosition()),void 0===i&&(i="top-right"),!e||!e.onAdd)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));var n=e.onAdd(this);this._controls.push(e);var o=this._controlPositions[i];return -1!==i.indexOf("bottom")?o.insertBefore(n,o.firstChild):o.appendChild(n),this},o.prototype.removeControl=function(e){if(!e||!e.onRemove)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));var i=this._controls.indexOf(e);return i>-1&&this._controls.splice(i,1),e.onRemove(this),this},o.prototype.resize=function(e){var i=this._containerDimensions(),n=i[0],o=i[1];return this._resizeCanvas(n,o),this.transform.resize(n,o),this.painter.resize(n,o),this.fire(new t.Event("movestart",e)).fire(new t.Event("move",e)).fire(new t.Event("resize",e)).fire(new t.Event("moveend",e)),this},o.prototype.getBounds=function(){return this.transform.getBounds()},o.prototype.getMaxBounds=function(){return this.transform.getMaxBounds()},o.prototype.setMaxBounds=function(t){return this.transform.setMaxBounds(U.convert(t)),this._update()},o.prototype.setMinZoom=function(t){if((t=null==t?0:t)>=0&&t<=this.transform.maxZoom)return this.transform.minZoom=t,this._update(),this.getZoom()<t&&this.setZoom(t),this;throw new Error("minZoom must be between 0 and the current maxZoom, inclusive")},o.prototype.getMinZoom=function(){return this.transform.minZoom},o.prototype.setMaxZoom=function(t){if((t=null==t?22:t)>=this.transform.minZoom)return this.transform.maxZoom=t,this._update(),this.getZoom()>t&&this.setZoom(t),this;throw new Error("maxZoom must be greater than the current minZoom")},o.prototype.getRenderWorldCopies=function(){return this.transform.renderWorldCopies},o.prototype.setRenderWorldCopies=function(t){return this.transform.renderWorldCopies=t,this._update()},o.prototype.getMaxZoom=function(){return this.transform.maxZoom},o.prototype.project=function(t){return this.transform.locationPoint(N.convert(t))},o.prototype.unproject=function(e){return this.transform.pointLocation(t.Point.convert(e))},o.prototype.isMoving=function(){return this._moving||this.dragPan.isActive()||this.dragRotate.isActive()||this.scrollZoom.isActive()},o.prototype.isZooming=function(){return this._zooming||this.scrollZoom.isActive()},o.prototype.isRotating=function(){return this._rotating||this.dragRotate.isActive()},o.prototype.on=function(t,e,i){var o,r=this;if(void 0===i)return n.prototype.on.call(this,t,e);var a=function(){if("mouseenter"===t||"mouseover"===t){var n=!1;return {layer:e,listener:i,delegates:{mousemove:function(o){var a=r.getLayer(e)?r.queryRenderedFeatures(o.point,{layers:[e]}):[];a.length?n||(n=!0,i.call(r,new Pi(t,r,o.originalEvent,{features:a}))):n=!1;},mouseout:function(){n=!1;}}}}if("mouseleave"===t||"mouseout"===t){var a=!1;return {layer:e,listener:i,delegates:{mousemove:function(n){(r.getLayer(e)?r.queryRenderedFeatures(n.point,{layers:[e]}):[]).length?a=!0:a&&(a=!1,i.call(r,new Pi(t,r,n.originalEvent)));},mouseout:function(e){a&&(a=!1,i.call(r,new Pi(t,r,e.originalEvent)));}}}}return {layer:e,listener:i,delegates:(o={},o[t]=function(t){var n=r.getLayer(e)?r.queryRenderedFeatures(t.point,{layers:[e]}):[];n.length&&(t.features=n,i.call(r,t),delete t.features);},o)}}();for(var s in this._delegatedListeners=this._delegatedListeners||{},this._delegatedListeners[t]=this._delegatedListeners[t]||[],this._delegatedListeners[t].push(a),a.delegates)r.on(s,a.delegates[s]);return this},o.prototype.off=function(t,e,i){if(void 0===i)return n.prototype.off.call(this,t,e);if(this._delegatedListeners&&this._delegatedListeners[t])for(var o=this._delegatedListeners[t],r=0;r<o.length;r++){var a=o[r];if(a.layer===e&&a.listener===i){for(var s in a.delegates)this.off(s,a.delegates[s]);return o.splice(r,1),this}}return this},o.prototype.queryRenderedFeatures=function(e,i){if(!this.style)return [];var n;if(void 0!==i||void 0===e||e instanceof t.Point||Array.isArray(e)||(i=e,e=void 0),i=i||{},(e=e||[[0,0],[this.transform.width,this.transform.height]])instanceof t.Point||"number"==typeof e[0])n=[t.Point.convert(e)];else{var o=t.Point.convert(e[0]),r=t.Point.convert(e[1]);n=[o,new t.Point(r.x,o.y),r,new t.Point(o.x,r.y),o];}return this.style.queryRenderedFeatures(n,i,this.transform)},o.prototype.querySourceFeatures=function(t,e){return this.style.querySourceFeatures(t,e)},o.prototype.setStyle=function(e,i){if((!i||!1!==i.diff&&!i.localIdeographFontFamily)&&this.style&&e&&"object"==typeof e)try{return this.style.setState(e)&&this._update(!0),this}catch(e){t.warnOnce("Unable to perform style diff: "+(e.message||e.error||e)+".  Rebuilding the style from scratch.");}return this.style&&(this.style.setEventedParent(null),this.style._remove()),e?(this.style=new qe(this,i||{}),this.style.setEventedParent(this,{style:this.style}),"string"==typeof e?this.style.loadURL(e):this.style.loadJSON(e),this):(delete this.style,this)},o.prototype.getStyle=function(){if(this.style)return this.style.serialize()},o.prototype.isStyleLoaded=function(){return this.style?this.style.loaded():t.warnOnce("There is no style added to the map.")},o.prototype.addSource=function(t,e){return this.style.addSource(t,e),this._update(!0)},o.prototype.isSourceLoaded=function(e){var i=this.style&&this.style.sourceCaches[e];if(void 0!==i)return i.loaded();this.fire(new t.ErrorEvent(new Error("There is no source with ID '"+e+"'")));},o.prototype.areTilesLoaded=function(){var t=this.style&&this.style.sourceCaches;for(var e in t){var i=t[e]._tiles;for(var n in i){var o=i[n];if("loaded"!==o.state&&"errored"!==o.state)return !1}}return !0},o.prototype.addSourceType=function(t,e,i){return this.style.addSourceType(t,e,i)},o.prototype.removeSource=function(t){return this.style.removeSource(t),this._update(!0)},o.prototype.getSource=function(t){return this.style.getSource(t)},o.prototype.addImage=function(e,i,n){void 0===n&&(n={});var o=n.pixelRatio;void 0===o&&(o=1);var r=n.sdf;if(void 0===r&&(r=!1),i instanceof Hi){var a=t.browser.getImageData(i),s=a.width,l=a.height,c=a.data;this.style.addImage(e,{data:new t.RGBAImage({width:s,height:l},c),pixelRatio:o,sdf:r});}else{if(void 0===i.width||void 0===i.height)return this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));var h=i.width,u=i.height,p=i.data;this.style.addImage(e,{data:new t.RGBAImage({width:h,height:u},new Uint8Array(p)),pixelRatio:o,sdf:r});}},o.prototype.hasImage=function(e){return e?!!this.style.getImage(e):(this.fire(new t.ErrorEvent(new Error("Missing required image id"))),!1)},o.prototype.removeImage=function(t){this.style.removeImage(t);},o.prototype.loadImage=function(e,i){t.getImage(this._transformRequest(e,t.ResourceType.Image),i);},o.prototype.listImages=function(){return this.style.listImages()},o.prototype.addLayer=function(t,e){return this.style.addLayer(t,e),this._update(!0)},o.prototype.moveLayer=function(t,e){return this.style.moveLayer(t,e),this._update(!0)},o.prototype.removeLayer=function(t){return this.style.removeLayer(t),this._update(!0)},o.prototype.getLayer=function(t){return this.style.getLayer(t)},o.prototype.setFilter=function(t,e){return this.style.setFilter(t,e),this._update(!0)},o.prototype.setLayerZoomRange=function(t,e,i){return this.style.setLayerZoomRange(t,e,i),this._update(!0)},o.prototype.getFilter=function(t){return this.style.getFilter(t)},o.prototype.setPaintProperty=function(t,e,i){return this.style.setPaintProperty(t,e,i),this._update(!0)},o.prototype.getPaintProperty=function(t,e){return this.style.getPaintProperty(t,e)},o.prototype.setLayoutProperty=function(t,e,i){return this.style.setLayoutProperty(t,e,i),this._update(!0)},o.prototype.getLayoutProperty=function(t,e){return this.style.getLayoutProperty(t,e)},o.prototype.setLight=function(t){return this.style.setLight(t),this._update(!0)},o.prototype.getLight=function(){return this.style.getLight()},o.prototype.setFeatureState=function(t,e){return this.style.setFeatureState(t,e),this._update()},o.prototype.getFeatureState=function(t){return this.style.getFeatureState(t)},o.prototype.getContainer=function(){return this._container},o.prototype.getCanvasContainer=function(){return this._canvasContainer},o.prototype.getCanvas=function(){return this._canvas},o.prototype._containerDimensions=function(){var t=0,e=0;return this._container&&(t=this._container.offsetWidth||400,e=this._container.offsetHeight||300),[t,e]},o.prototype._detectMissingCSS=function(){"rgb(250, 128, 114)"!==t.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color")&&t.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");},o.prototype._setupContainer=function(){var t=this._container;t.classList.add("mapboxgl-map"),(this._missingCSSCanary=i.create("div","mapboxgl-canary",t)).style.visibility="hidden",this._detectMissingCSS();var e=this._canvasContainer=i.create("div","mapboxgl-canvas-container",t);this._interactive&&e.classList.add("mapboxgl-interactive"),this._canvas=i.create("canvas","mapboxgl-canvas",e),this._canvas.style.position="absolute",this._canvas.addEventListener("webglcontextlost",this._contextLost,!1),this._canvas.addEventListener("webglcontextrestored",this._contextRestored,!1),this._canvas.setAttribute("tabindex","0"),this._canvas.setAttribute("aria-label","Map");var n=this._containerDimensions();this._resizeCanvas(n[0],n[1]);var o=this._controlContainer=i.create("div","mapboxgl-control-container",t),r=this._controlPositions={};["top-left","top-right","bottom-left","bottom-right"].forEach(function(t){r[t]=i.create("div","mapboxgl-ctrl-"+t,o);});},o.prototype._resizeCanvas=function(e,i){var n=t.window.devicePixelRatio||1;this._canvas.width=n*e,this._canvas.height=n*i,this._canvas.style.width=e+"px",this._canvas.style.height=i+"px";},o.prototype._setupPainter=function(){var i=t.extend({failIfMajorPerformanceCaveat:this._failIfMajorPerformanceCaveat,preserveDrawingBuffer:this._preserveDrawingBuffer},e.webGLContextAttributes),n=this._canvas.getContext("webgl",i)||this._canvas.getContext("experimental-webgl",i);n?this.painter=new wi(n,this.transform):this.fire(new t.ErrorEvent(new Error("Failed to initialize WebGL")));},o.prototype._contextLost=function(e){e.preventDefault(),this._frame&&(this._frame.cancel(),this._frame=null),this.fire(new t.Event("webglcontextlost",{originalEvent:e}));},o.prototype._contextRestored=function(e){this._setupPainter(),this.resize(),this._update(),this.fire(new t.Event("webglcontextrestored",{originalEvent:e}));},o.prototype.loaded=function(){return !this._styleDirty&&!this._sourcesDirty&&!!this.style&&this.style.loaded()},o.prototype._update=function(t){return this.style?(this._styleDirty=this._styleDirty||t,this._sourcesDirty=!0,this._rerender(),this):this},o.prototype._requestRenderFrame=function(t){return this._update(),this._renderTaskQueue.add(t)},o.prototype._cancelRenderFrame=function(t){this._renderTaskQueue.remove(t);},o.prototype._render=function(){this._renderTaskQueue.run();var e=!1;if(this.style&&this._styleDirty){this._styleDirty=!1;var i=this.transform.zoom,n=t.browser.now();this.style.zoomHistory.update(i,n);var o=new t.EvaluationParameters(i,{now:n,fadeDuration:this._fadeDuration,zoomHistory:this.style.zoomHistory,transition:this.style.getTransition()}),r=o.crossFadingFactor();1===r&&r===this._crossFadingFactor||(e=!0,this._crossFadingFactor=r),this.style.update(o);}return this.style&&this._sourcesDirty&&(this._sourcesDirty=!1,this.style._updateSources(this.transform)),this._placementDirty=this.style&&this.style._updatePlacement(this.painter.transform,this.showCollisionBoxes,this._fadeDuration,this._crossSourceCollisions),this.painter.render(this.style,{showTileBoundaries:this.showTileBoundaries,showOverdrawInspector:this._showOverdrawInspector,rotating:this.isRotating(),zooming:this.isZooming(),fadeDuration:this._fadeDuration}),this.fire(new t.Event("render")),this.loaded()&&!this._loaded&&(this._loaded=!0,this.fire(new t.Event("load"))),this.style&&(this.style.hasTransitions()||e)&&(this._styleDirty=!0),this.style&&!this._placementDirty&&this.style._releaseSymbolFadeTiles(),(this._sourcesDirty||this._repaint||this._styleDirty||this._placementDirty)&&this._rerender(),this},o.prototype.remove=function(){this._hash&&this._hash.remove(),this._frame&&(this._frame.cancel(),this._frame=null),this._renderTaskQueue.clear(),this.setStyle(null),void 0!==t.window&&(t.window.removeEventListener("resize",this._onWindowResize,!1),t.window.removeEventListener("online",this._onWindowOnline,!1));for(var e=0,i=this._controls;e<i.length;e+=1){i[e].onRemove(this);}this._controls=[];var n=this.painter.context.gl.getExtension("WEBGL_lose_context");n&&n.loseContext(),Qi(this._canvasContainer),Qi(this._controlContainer),Qi(this._missingCSSCanary),this._container.classList.remove("mapboxgl-map"),this.fire(new t.Event("remove"));},o.prototype._rerender=function(){var e=this;this.style&&!this._frame&&(this._frame=t.browser.frame(function(){e._frame=null,e._render();}));},o.prototype._onWindowOnline=function(){this._update();},o.prototype._onWindowResize=function(){this._trackResize&&this.resize()._update();},r.showTileBoundaries.get=function(){return !!this._showTileBoundaries},r.showTileBoundaries.set=function(t){this._showTileBoundaries!==t&&(this._showTileBoundaries=t,this._update());},r.showCollisionBoxes.get=function(){return !!this._showCollisionBoxes},r.showCollisionBoxes.set=function(t){this._showCollisionBoxes!==t&&(this._showCollisionBoxes=t,t?this.style._generateCollisionBoxes():this._update());},r.showOverdrawInspector.get=function(){return !!this._showOverdrawInspector},r.showOverdrawInspector.set=function(t){this._showOverdrawInspector!==t&&(this._showOverdrawInspector=t,this._update());},r.repaint.get=function(){return !!this._repaint},r.repaint.set=function(t){this._repaint=t,this._update();},r.vertices.get=function(){return !!this._vertices},r.vertices.set=function(t){this._vertices=t,this._update();},Object.defineProperties(o.prototype,r),o}(qi);function Qi(t){t.parentNode&&t.parentNode.removeChild(t);}var $i={showCompass:!0,showZoom:!0},tn=function(e){var n=this;this.options=t.extend({},$i,e),this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._container.addEventListener("contextmenu",function(t){return t.preventDefault()}),this.options.showZoom&&(this._zoomInButton=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in","Zoom In",function(){return n._map.zoomIn()}),this._zoomOutButton=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out","Zoom Out",function(){return n._map.zoomOut()})),this.options.showCompass&&(t.bindAll(["_rotateCompassArrow"],this),this._compass=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-compass","Reset North",function(){return n._map.resetNorth()}),this._compassArrow=i.create("span","mapboxgl-ctrl-compass-arrow",this._compass));};function en(t,e,i){if(t=new N(t.lng,t.lat),e){var n=new N(t.lng-360,t.lat),o=new N(t.lng+360,t.lat),r=i.locationPoint(t).distSqr(e);i.locationPoint(n).distSqr(e)<r?t=n:i.locationPoint(o).distSqr(e)<r&&(t=o);}for(;Math.abs(t.lng-i.center.lng)>180;){var a=i.locationPoint(t);if(a.x>=0&&a.y>=0&&a.x<=i.width&&a.y<=i.height)break;t.lng>i.center.lng?t.lng-=360:t.lng+=360;}return t}tn.prototype._rotateCompassArrow=function(){var t="rotate("+this._map.transform.angle*(180/Math.PI)+"deg)";this._compassArrow.style.transform=t;},tn.prototype.onAdd=function(t){return this._map=t,this.options.showCompass&&(this._map.on("rotate",this._rotateCompassArrow),this._rotateCompassArrow(),this._handler=new ki(t,{button:"left",element:this._compass}),i.addEventListener(this._compass,"mousedown",this._handler.onMouseDown),this._handler.enable()),this._container},tn.prototype.onRemove=function(){i.remove(this._container),this.options.showCompass&&(this._map.off("rotate",this._rotateCompassArrow),i.removeEventListener(this._compass,"mousedown",this._handler.onMouseDown),this._handler.disable(),delete this._handler),delete this._map;},tn.prototype._createButton=function(t,e,n){var o=i.create("button",t,this._container);return o.type="button",o.setAttribute("aria-label",e),o.addEventListener("click",n),o};var nn={center:"translate(-50%,-50%)",top:"translate(-50%,0)","top-left":"translate(0,0)","top-right":"translate(-100%,0)",bottom:"translate(-50%,-100%)","bottom-left":"translate(0,-100%)","bottom-right":"translate(-100%,-100%)",left:"translate(0,-50%)",right:"translate(-100%,-50%)"};function on(t,e,i){var n=t.classList;for(var o in nn)n.remove("mapboxgl-"+i+"-anchor-"+o);n.add("mapboxgl-"+i+"-anchor-"+e);}var rn,an=function(e){function n(n){if(e.call(this),(arguments[0]instanceof t.window.HTMLElement||2===arguments.length)&&(n=t.extend({element:n},arguments[1])),t.bindAll(["_update","_onMove","_onUp","_addDragHandler","_onMapClick"],this),this._anchor=n&&n.anchor||"center",this._color=n&&n.color||"#3FB1CE",this._draggable=n&&n.draggable||!1,this._state="inactive",n&&n.element)this._element=n.element,this._offset=t.Point.convert(n&&n.offset||[0,0]);else{this._defaultMarker=!0,this._element=i.create("div");var o=i.createNS("http://www.w3.org/2000/svg","svg");o.setAttributeNS(null,"height","41px"),o.setAttributeNS(null,"width","27px"),o.setAttributeNS(null,"viewBox","0 0 27 41");var r=i.createNS("http://www.w3.org/2000/svg","g");r.setAttributeNS(null,"stroke","none"),r.setAttributeNS(null,"stroke-width","1"),r.setAttributeNS(null,"fill","none"),r.setAttributeNS(null,"fill-rule","evenodd");var a=i.createNS("http://www.w3.org/2000/svg","g");a.setAttributeNS(null,"fill-rule","nonzero");var s=i.createNS("http://www.w3.org/2000/svg","g");s.setAttributeNS(null,"transform","translate(3.0, 29.0)"),s.setAttributeNS(null,"fill","#000000");for(var l=0,c=[{rx:"10.5",ry:"5.25002273"},{rx:"10.5",ry:"5.25002273"},{rx:"9.5",ry:"4.77275007"},{rx:"8.5",ry:"4.29549936"},{rx:"7.5",ry:"3.81822308"},{rx:"6.5",ry:"3.34094679"},{rx:"5.5",ry:"2.86367051"},{rx:"4.5",ry:"2.38636864"}];l<c.length;l+=1){var h=c[l],u=i.createNS("http://www.w3.org/2000/svg","ellipse");u.setAttributeNS(null,"opacity","0.04"),u.setAttributeNS(null,"cx","10.5"),u.setAttributeNS(null,"cy","5.80029008"),u.setAttributeNS(null,"rx",h.rx),u.setAttributeNS(null,"ry",h.ry),s.appendChild(u);}var p=i.createNS("http://www.w3.org/2000/svg","g");p.setAttributeNS(null,"fill",this._color);var d=i.createNS("http://www.w3.org/2000/svg","path");d.setAttributeNS(null,"d","M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"),p.appendChild(d);var f=i.createNS("http://www.w3.org/2000/svg","g");f.setAttributeNS(null,"opacity","0.25"),f.setAttributeNS(null,"fill","#000000");var m=i.createNS("http://www.w3.org/2000/svg","path");m.setAttributeNS(null,"d","M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"),f.appendChild(m);var _=i.createNS("http://www.w3.org/2000/svg","g");_.setAttributeNS(null,"transform","translate(6.0, 7.0)"),_.setAttributeNS(null,"fill","#FFFFFF");var g=i.createNS("http://www.w3.org/2000/svg","g");g.setAttributeNS(null,"transform","translate(8.0, 8.0)");var v=i.createNS("http://www.w3.org/2000/svg","circle");v.setAttributeNS(null,"fill","#000000"),v.setAttributeNS(null,"opacity","0.25"),v.setAttributeNS(null,"cx","5.5"),v.setAttributeNS(null,"cy","5.5"),v.setAttributeNS(null,"r","5.4999962");var y=i.createNS("http://www.w3.org/2000/svg","circle");y.setAttributeNS(null,"fill","#FFFFFF"),y.setAttributeNS(null,"cx","5.5"),y.setAttributeNS(null,"cy","5.5"),y.setAttributeNS(null,"r","5.4999962"),g.appendChild(v),g.appendChild(y),a.appendChild(s),a.appendChild(p),a.appendChild(f),a.appendChild(_),a.appendChild(g),o.appendChild(a),this._element.appendChild(o),this._offset=t.Point.convert(n&&n.offset||[0,-14]);}this._element.classList.add("mapboxgl-marker"),this._popup=null;}return e&&(n.__proto__=e),n.prototype=Object.create(e&&e.prototype),n.prototype.constructor=n,n.prototype.addTo=function(t){return this.remove(),this._map=t,t.getCanvasContainer().appendChild(this._element),t.on("move",this._update),t.on("moveend",this._update),this.setDraggable(this._draggable),this._update(),this._map.on("click",this._onMapClick),this},n.prototype.remove=function(){return this._map&&(this._map.off("click",this._onMapClick),this._map.off("move",this._update),this._map.off("moveend",this._update),this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler),delete this._map),i.remove(this._element),this._popup&&this._popup.remove(),this},n.prototype.getLngLat=function(){return this._lngLat},n.prototype.setLngLat=function(t){return this._lngLat=N.convert(t),this._pos=null,this._popup&&this._popup.setLngLat(this._lngLat),this._update(),this},n.prototype.getElement=function(){return this._element},n.prototype.setPopup=function(t){if(this._popup&&(this._popup.remove(),this._popup=null),t){if(!("offset"in t.options)){var e=Math.sqrt(Math.pow(13.5,2)/2);t.options.offset=this._defaultMarker?{top:[0,0],"top-left":[0,0],"top-right":[0,0],bottom:[0,-38.1],"bottom-left":[e,-1*(24.6+e)],"bottom-right":[-e,-1*(24.6+e)],left:[13.5,-24.6],right:[-13.5,-24.6]}:this._offset;}this._popup=t,this._lngLat&&this._popup.setLngLat(this._lngLat);}return this},n.prototype._onMapClick=function(t){var e=t.originalEvent.target,i=this._element;this._popup&&(e===i||i.contains(e))&&this.togglePopup();},n.prototype.getPopup=function(){return this._popup},n.prototype.togglePopup=function(){var t=this._popup;return t?(t.isOpen()?t.remove():t.addTo(this._map),this):this},n.prototype._update=function(t){this._map&&(this._map.transform.renderWorldCopies&&(this._lngLat=en(this._lngLat,this._pos,this._map.transform)),this._pos=this._map.project(this._lngLat)._add(this._offset),t&&"moveend"!==t.type||(this._pos=this._pos.round()),i.setTransform(this._element,nn[this._anchor]+" translate("+this._pos.x+"px, "+this._pos.y+"px)"),on(this._element,this._anchor,"marker"));},n.prototype.getOffset=function(){return this._offset},n.prototype.setOffset=function(e){return this._offset=t.Point.convert(e),this._update(),this},n.prototype._onMove=function(e){this._pos=e.point.sub(this._positionDelta),this._lngLat=this._map.unproject(this._pos),this.setLngLat(this._lngLat),this._element.style.pointerEvents="none","pending"===this._state&&(this._state="active",this.fire(new t.Event("dragstart"))),this.fire(new t.Event("drag"));},n.prototype._onUp=function(){this._element.style.pointerEvents="auto",this._positionDelta=null,this._map.off("mousemove",this._onMove),this._map.off("touchmove",this._onMove),"active"===this._state&&this.fire(new t.Event("dragend")),this._state="inactive";},n.prototype._addDragHandler=function(t){this._element.contains(t.originalEvent.target)&&(t.preventDefault(),this._positionDelta=t.point.sub(this._pos).add(this._offset),this._state="pending",this._map.on("mousemove",this._onMove),this._map.on("touchmove",this._onMove),this._map.once("mouseup",this._onUp),this._map.once("touchend",this._onUp));},n.prototype.setDraggable=function(t){return this._draggable=!!t,this._map&&(t?(this._map.on("mousedown",this._addDragHandler),this._map.on("touchstart",this._addDragHandler)):(this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler))),this},n.prototype.isDraggable=function(){return this._draggable},n}(t.Evented),sn={positionOptions:{enableHighAccuracy:!1,maximumAge:0,timeout:6e3},fitBoundsOptions:{maxZoom:15},trackUserLocation:!1,showUserLocation:!0};var ln=function(e){function n(i){e.call(this),this.options=t.extend({},sn,i),t.bindAll(["_onSuccess","_onError","_finish","_setupUI","_updateCamera","_updateMarker"],this);}return e&&(n.__proto__=e),n.prototype=Object.create(e&&e.prototype),n.prototype.constructor=n,n.prototype.onAdd=function(e){var n;return this._map=e,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),n=this._setupUI,void 0!==rn?n(rn):void 0!==t.window.navigator.permissions?t.window.navigator.permissions.query({name:"geolocation"}).then(function(t){rn="denied"!==t.state,n(rn);}):(rn=!!t.window.navigator.geolocation,n(rn)),this._container},n.prototype.onRemove=function(){void 0!==this._geolocationWatchID&&(t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0),this.options.showUserLocation&&this._userLocationDotMarker&&this._userLocationDotMarker.remove(),i.remove(this._container),this._map=void 0;},n.prototype._onSuccess=function(e){if(this.options.trackUserLocation)switch(this._lastKnownPosition=e,this._watchState){case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"BACKGROUND":case"BACKGROUND_ERROR":this._watchState="BACKGROUND",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");}this.options.showUserLocation&&"OFF"!==this._watchState&&this._updateMarker(e),this.options.trackUserLocation&&"ACTIVE_LOCK"!==this._watchState||this._updateCamera(e),this.options.showUserLocation&&this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("geolocate",e)),this._finish();},n.prototype._updateCamera=function(t){var e=new N(t.coords.longitude,t.coords.latitude),i=t.coords.accuracy;this._map.fitBounds(e.toBounds(i),this.options.fitBoundsOptions,{geolocateSource:!0});},n.prototype._updateMarker=function(t){t?this._userLocationDotMarker.setLngLat([t.coords.longitude,t.coords.latitude]).addTo(this._map):this._userLocationDotMarker.remove();},n.prototype._onError=function(e){if(this.options.trackUserLocation)if(1===e.code)this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),void 0!==this._geolocationWatchID&&this._clearWatch();else switch(this._watchState){case"WAITING_ACTIVE":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"ACTIVE_LOCK":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");break;case"BACKGROUND":this._watchState="BACKGROUND_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");}"OFF"!==this._watchState&&this.options.showUserLocation&&this._dotElement.classList.add("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("error",e)),this._finish();},n.prototype._finish=function(){this._timeoutId&&clearTimeout(this._timeoutId),this._timeoutId=void 0;},n.prototype._setupUI=function(e){var n=this;!1!==e?(this._container.addEventListener("contextmenu",function(t){return t.preventDefault()}),this._geolocateButton=i.create("button","mapboxgl-ctrl-icon mapboxgl-ctrl-geolocate",this._container),this._geolocateButton.type="button",this._geolocateButton.setAttribute("aria-label","Geolocate"),this.options.trackUserLocation&&(this._geolocateButton.setAttribute("aria-pressed","false"),this._watchState="OFF"),this.options.showUserLocation&&(this._dotElement=i.create("div","mapboxgl-user-location-dot"),this._userLocationDotMarker=new an(this._dotElement),this.options.trackUserLocation&&(this._watchState="OFF")),this._geolocateButton.addEventListener("click",this.trigger.bind(this)),this._setup=!0,this.options.trackUserLocation&&this._map.on("movestart",function(e){e.geolocateSource||"ACTIVE_LOCK"!==n._watchState||(n._watchState="BACKGROUND",n._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"),n._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),n.fire(new t.Event("trackuserlocationend")));})):t.warnOnce("Geolocation support is not available, the GeolocateControl will not be visible.");},n.prototype.trigger=function(){if(!this._setup)return t.warnOnce("Geolocate control triggered before added to a map"),!1;if(this.options.trackUserLocation){switch(this._watchState){case"OFF":this._watchState="WAITING_ACTIVE",this.fire(new t.Event("trackuserlocationstart"));break;case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":case"BACKGROUND_ERROR":this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this.fire(new t.Event("trackuserlocationend"));break;case"BACKGROUND":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._lastKnownPosition&&this._updateCamera(this._lastKnownPosition),this.fire(new t.Event("trackuserlocationstart"));}switch(this._watchState){case"WAITING_ACTIVE":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_LOCK":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"BACKGROUND":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");break;case"BACKGROUND_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");}"OFF"===this._watchState&&void 0!==this._geolocationWatchID?this._clearWatch():void 0===this._geolocationWatchID&&(this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","true"),this._geolocationWatchID=t.window.navigator.geolocation.watchPosition(this._onSuccess,this._onError,this.options.positionOptions));}else t.window.navigator.geolocation.getCurrentPosition(this._onSuccess,this._onError,this.options.positionOptions),this._timeoutId=setTimeout(this._finish,1e4);return !0},n.prototype._clearWatch=function(){t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0,this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","false"),this.options.showUserLocation&&this._updateMarker(null);},n}(t.Evented),cn={maxWidth:100,unit:"metric"},hn=function(e){this.options=t.extend({},cn,e),t.bindAll(["_onMove","setUnit"],this);};function un(t,e,i){var n,o,r,a,s,l,c=i&&i.maxWidth||100,h=t._container.clientHeight/2,u=(n=t.unproject([0,h]),o=t.unproject([c,h]),r=Math.PI/180,a=n.lat*r,s=o.lat*r,l=Math.sin(a)*Math.sin(s)+Math.cos(a)*Math.cos(s)*Math.cos((o.lng-n.lng)*r),6371e3*Math.acos(Math.min(l,1)));if(i&&"imperial"===i.unit){var p=3.2808*u;if(p>5280)pn(e,c,p/5280,"mi");else pn(e,c,p,"ft");}else if(i&&"nautical"===i.unit){pn(e,c,u/1852,"nm");}else pn(e,c,u,"m");}function pn(t,e,i,n){var o,r,a,s=(o=i,(r=Math.pow(10,(""+Math.floor(o)).length-1))*(a=(a=o/r)>=10?10:a>=5?5:a>=3?3:a>=2?2:1)),l=s/i;"m"===n&&s>=1e3&&(s/=1e3,n="km"),t.style.width=e*l+"px",t.innerHTML=s+n;}hn.prototype.getDefaultPosition=function(){return "bottom-left"},hn.prototype._onMove=function(){un(this._map,this._container,this.options);},hn.prototype.onAdd=function(t){return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-scale",t.getContainer()),this._map.on("move",this._onMove),this._onMove(),this._container},hn.prototype.onRemove=function(){i.remove(this._container),this._map.off("move",this._onMove),this._map=void 0;},hn.prototype.setUnit=function(t){this.options.unit=t,un(this._map,this._container,this.options);};var dn=function(){this._fullscreen=!1,t.bindAll(["_onClickFullscreen","_changeIcon"],this),"onfullscreenchange"in t.window.document?this._fullscreenchange="fullscreenchange":"onmozfullscreenchange"in t.window.document?this._fullscreenchange="mozfullscreenchange":"onwebkitfullscreenchange"in t.window.document?this._fullscreenchange="webkitfullscreenchange":"onmsfullscreenchange"in t.window.document&&(this._fullscreenchange="MSFullscreenChange"),this._className="mapboxgl-ctrl";};dn.prototype.onAdd=function(e){return this._map=e,this._mapContainer=this._map.getContainer(),this._container=i.create("div",this._className+" mapboxgl-ctrl-group"),this._checkFullscreenSupport()?this._setupUI():(this._container.style.display="none",t.warnOnce("This device does not support fullscreen mode.")),this._container},dn.prototype.onRemove=function(){i.remove(this._container),this._map=null,t.window.document.removeEventListener(this._fullscreenchange,this._changeIcon);},dn.prototype._checkFullscreenSupport=function(){return !!(t.window.document.fullscreenEnabled||t.window.document.mozFullScreenEnabled||t.window.document.msFullscreenEnabled||t.window.document.webkitFullscreenEnabled)},dn.prototype._setupUI=function(){var e=this._fullscreenButton=i.create("button",this._className+"-icon "+this._className+"-fullscreen",this._container);e.setAttribute("aria-label","Toggle fullscreen"),e.type="button",this._fullscreenButton.addEventListener("click",this._onClickFullscreen),t.window.document.addEventListener(this._fullscreenchange,this._changeIcon);},dn.prototype._isFullscreen=function(){return this._fullscreen},dn.prototype._changeIcon=function(){(t.window.document.fullscreenElement||t.window.document.mozFullScreenElement||t.window.document.webkitFullscreenElement||t.window.document.msFullscreenElement)===this._mapContainer!==this._fullscreen&&(this._fullscreen=!this._fullscreen,this._fullscreenButton.classList.toggle(this._className+"-shrink"),this._fullscreenButton.classList.toggle(this._className+"-fullscreen"));},dn.prototype._onClickFullscreen=function(){this._isFullscreen()?t.window.document.exitFullscreen?t.window.document.exitFullscreen():t.window.document.mozCancelFullScreen?t.window.document.mozCancelFullScreen():t.window.document.msExitFullscreen?t.window.document.msExitFullscreen():t.window.document.webkitCancelFullScreen&&t.window.document.webkitCancelFullScreen():this._mapContainer.requestFullscreen?this._mapContainer.requestFullscreen():this._mapContainer.mozRequestFullScreen?this._mapContainer.mozRequestFullScreen():this._mapContainer.msRequestFullscreen?this._mapContainer.msRequestFullscreen():this._mapContainer.webkitRequestFullscreen&&this._mapContainer.webkitRequestFullscreen();};var fn={closeButton:!0,closeOnClick:!0,className:""},mn=function(e){function n(i){e.call(this),this.options=t.extend(Object.create(fn),i),t.bindAll(["_update","_onClickClose"],this);}return e&&(n.__proto__=e),n.prototype=Object.create(e&&e.prototype),n.prototype.constructor=n,n.prototype.addTo=function(e){return this._map=e,this._map.on("move",this._update),this.options.closeOnClick&&this._map.on("click",this._onClickClose),this._update(),this.fire(new t.Event("open")),this},n.prototype.isOpen=function(){return !!this._map},n.prototype.remove=function(){return this._content&&i.remove(this._content),this._container&&(i.remove(this._container),delete this._container),this._map&&(this._map.off("move",this._update),this._map.off("click",this._onClickClose),delete this._map),this.fire(new t.Event("close")),this},n.prototype.getLngLat=function(){return this._lngLat},n.prototype.setLngLat=function(t){return this._lngLat=N.convert(t),this._pos=null,this._update(),this},n.prototype.setText=function(e){return this.setDOMContent(t.window.document.createTextNode(e))},n.prototype.setHTML=function(e){var i,n=t.window.document.createDocumentFragment(),o=t.window.document.createElement("body");for(o.innerHTML=e;i=o.firstChild;)n.appendChild(i);return this.setDOMContent(n)},n.prototype.setDOMContent=function(t){return this._createContent(),this._content.appendChild(t),this._update(),this},n.prototype._createContent=function(){this._content&&i.remove(this._content),this._content=i.create("div","mapboxgl-popup-content",this._container),this.options.closeButton&&(this._closeButton=i.create("button","mapboxgl-popup-close-button",this._content),this._closeButton.type="button",this._closeButton.setAttribute("aria-label","Close popup"),this._closeButton.innerHTML="&#215;",this._closeButton.addEventListener("click",this._onClickClose));},n.prototype._update=function(){var e=this;if(this._map&&this._lngLat&&this._content){this._container||(this._container=i.create("div","mapboxgl-popup",this._map.getContainer()),this._tip=i.create("div","mapboxgl-popup-tip",this._container),this._container.appendChild(this._content),this.options.className&&this.options.className.split(" ").forEach(function(t){return e._container.classList.add(t)})),this._map.transform.renderWorldCopies&&(this._lngLat=en(this._lngLat,this._pos,this._map.transform));var n=this._pos=this._map.project(this._lngLat),o=this.options.anchor,r=function e(i){if(i){if("number"==typeof i){var n=Math.round(Math.sqrt(.5*Math.pow(i,2)));return {center:new t.Point(0,0),top:new t.Point(0,i),"top-left":new t.Point(n,n),"top-right":new t.Point(-n,n),bottom:new t.Point(0,-i),"bottom-left":new t.Point(n,-n),"bottom-right":new t.Point(-n,-n),left:new t.Point(i,0),right:new t.Point(-i,0)}}if(i instanceof t.Point||Array.isArray(i)){var o=t.Point.convert(i);return {center:o,top:o,"top-left":o,"top-right":o,bottom:o,"bottom-left":o,"bottom-right":o,left:o,right:o}}return {center:t.Point.convert(i.center||[0,0]),top:t.Point.convert(i.top||[0,0]),"top-left":t.Point.convert(i["top-left"]||[0,0]),"top-right":t.Point.convert(i["top-right"]||[0,0]),bottom:t.Point.convert(i.bottom||[0,0]),"bottom-left":t.Point.convert(i["bottom-left"]||[0,0]),"bottom-right":t.Point.convert(i["bottom-right"]||[0,0]),left:t.Point.convert(i.left||[0,0]),right:t.Point.convert(i.right||[0,0])}}return e(new t.Point(0,0))}(this.options.offset);if(!o){var a,s=this._container.offsetWidth,l=this._container.offsetHeight;a=n.y+r.bottom.y<l?["top"]:n.y>this._map.transform.height-l?["bottom"]:[],n.x<s/2?a.push("left"):n.x>this._map.transform.width-s/2&&a.push("right"),o=0===a.length?"bottom":a.join("-");}var c=n.add(r[o]).round();i.setTransform(this._container,nn[o]+" translate("+c.x+"px,"+c.y+"px)"),on(this._container,o,"popup");}},n.prototype._onClickClose=function(){this.remove();},n}(t.Evented);var _n={version:"0.48.0",supported:e,setRTLTextPlugin:t.setRTLTextPlugin,Map:Ji,NavigationControl:tn,GeolocateControl:ln,AttributionControl:Gi,ScaleControl:hn,FullscreenControl:dn,Popup:mn,Marker:an,Style:qe,LngLat:N,LngLatBounds:U,Point:t.Point,Evented:t.Evented,config:u,get accessToken(){return u.ACCESS_TOKEN},set accessToken(t){u.ACCESS_TOKEN=t;},get workerCount(){return qt.workerCount},set workerCount(t){qt.workerCount=t;},workerUrl:""};return _n});

//

return mapboxgl;

})));
//# sourceMappingURL=mapbox-gl.js.map


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(447);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-components-Map-___styles__map___2pgSP {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0; }\n\n.src-components-Map-___styles__popup___2Uadr {\n  max-width: 480px; }\n  .src-components-Map-___styles__popup___2Uadr h1 {\n    font-size: 18px;\n    margin: 0 0 4px; }\n  .src-components-Map-___styles__popup___2Uadr .src-components-Map-___styles__subjects___1bG2- {\n    margin-bottom: 8px; }\n", ""]);

// exports
exports.locals = {
	"map": "src-components-Map-___styles__map___2pgSP",
	"popup": "src-components-Map-___styles__popup___2Uadr",
	"subjects": "src-components-Map-___styles__subjects___1bG2-"
};

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function getDistanceFromLatLonInKm(p1,p2){var _p=_slicedToArray(p1,2),lat1=_p[0],lon1=_p[1];var _p2=_slicedToArray(p2,2),lat2=_p2[0],lon2=_p2[1];var R=6371;// Radius of the earth in km
var dLat=deg2rad(lat2-lat1);// deg2rad below
var dLon=deg2rad(lon2-lon1);var a=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(deg2rad(lat1))*Math.cos(deg2rad(lat2))*Math.sin(dLon/2)*Math.sin(dLon/2);var c=2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));var d=R*c;// Distance in km
return d;}function deg2rad(deg){return deg*(Math.PI/180);}/* harmony default export */ __webpack_exports__["a"] = (getDistanceFromLatLonInKm);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_users_List__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_users_Details__ = __webpack_require__(454);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery getUsers($filter: userFilter) {\n  users (filter: $filter) {\n    id\n    _id\n    first_name\n    last_name\n    email\n    phone_number\n    unique_id\n    role\n    tutors {\n      id\n      _id\n      state\n    }\n    clients {\n      id\n      _id\n      state\n    }\n  }\n}\n'],['\nquery getUsers($filter: userFilter) {\n  users (filter: $filter) {\n    id\n    _id\n    first_name\n    last_name\n    email\n    phone_number\n    unique_id\n    role\n    tutors {\n      id\n      _id\n      state\n    }\n    clients {\n      id\n      _id\n      state\n    }\n  }\n}\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var QUERY=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject);var Users=function(_Component){_inherits(Users,_Component);function Users(){_classCallCheck(this,Users);return _possibleConstructorReturn(this,(Users.__proto__||Object.getPrototypeOf(Users)).apply(this,arguments));}_createClass(Users,[{key:'render',value:function render(){var _this2=this;console.log(this.props);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messages-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messages-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],{query:QUERY,variables:{filter:{role:this.props.match.params.role}}},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data,fetchMore=_ref.fetchMore;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Loading...');if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Error :(');};if(!data||!data.users)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_users_List__["a" /* default */],{users:data.users,active:_this2.props.match.params.uuid});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_users_Details__["a" /* default */],{uuid:this.props.match.params.uuid}))));}}]);return Users;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Users);

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_List__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dropdown__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_params__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_params__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersList=function(_Component){_inherits(UsersList,_Component);function UsersList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UsersList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UsersList.__proto__||Object.getPrototypeOf(UsersList)).call.apply(_ref,[this].concat(args))),_this),_this.state={filter:'all'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UsersList,[{key:'render',value:function render(){var _this2=this;var filter=this.state.filter;var users=filter&&filter!=="all"?this.props.users.filter(function(_ref2){var tutors=_ref2.tutors,clients=_ref2.clients;var state=tutors.length?tutors[0]&&tutors[0].state:clients[0]&&clients[0].state;return state===filter;}):this.props.users;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_List__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Dropdown__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-filter'}),' ',filter),options:[{label:"All",value:"all"},{label:"Validated",value:"validated"},{label:"Completed",value:"completed"},{label:"In progress",value:"in-progress"},{label:"Blocked",value:"blocked"},{label:"Disabled",value:"disabled"}],onSelect:function onSelect(filter){return _this2.setState({filter:filter});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,users.length)),list:users.map(function(_ref3){var _id=_ref3._id,first_name=_ref3.first_name,last_name=_ref3.last_name,email=_ref3.email,phone_number=_ref3.phone_number,role=_ref3.role,tutors=_ref3.tutors,clients=_ref3.clients;return{link:'/users/'+role+'/'+_id,active:_id===_this2.props.active,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,first_name,' ',last_name),body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,email,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',phone_number,' '),footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'state '+(tutors.length?tutors[0]&&tutors[0].state:clients[0]&&clients[0].state)},tutors.length?tutors[0]&&tutors[0].state:clients[0]&&clients[0].state)};})}));}}]);return UsersList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UsersList);

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

function encode (o, sep) {
    var list = [];
    var key;
    for (key in o) {
        if (o[key] != null && typeof o[key] != 'object' &&
                typeof o[key] != 'function') {
            list.push(encodeURIComponent(key) + '=' + encodeURIComponent(o[key]));
        }
    }
    return list.join(sep || '&');
}

var REXP_SPLIT = /&amp;|&|;/gmi;
function decode (str, sep) {
    sep = sep||REXP_SPLIT;
    var result = {};
    var expr = str.split(sep);
    var key, val, index;
    for (var i = 0, len = expr.length; i < len; i++) {
        index = expr[i].indexOf('=');
        key = expr[i].substring(0, index);
        val = expr[i].substring(index+1);
        if (val) {
            result[decodeURIComponent(key)] = decodeURIComponent(val);
        }
    }
    return result;
};

module.exports = {
    encode: encode,
    decode: decode
};

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_urls__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_urls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__configs_urls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Tabs___ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tabs_general__ = __webpack_require__(457);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { Link } from 'react-router-dom'
var UsersDetails=function(_Component){_inherits(UsersDetails,_Component);function UsersDetails(){_classCallCheck(this,UsersDetails);return _possibleConstructorReturn(this,(UsersDetails.__proto__||Object.getPrototypeOf(UsersDetails)).apply(this,arguments));}_createClass(UsersDetails,[{key:'render',value:function render(){if(!this.props.uuid)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Tabs___["a" /* default */],{tabs:[{name:'General',content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__tabs_general__["a" /* default */],{uuid:this.props.uuid})}]}));}}]);return UsersDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UsersDetails);

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(456);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-containers-users-Details-___style__image___77Q5Q {\n  max-height: 320px; }\n", ""]);

// exports
exports.locals = {
	"image": "src-containers-users-Details-___style__image___77Q5Q"
};

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_urls__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_urls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__configs_urls__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery User($uuid: String) {\n  user(_id: $uuid) {\n    id\n    _id\n    first_name\n    last_name\n    email\n    phone_number\n    unique_id\n    role\n    files {\n      name\n      url\n      minetype\n    }\n    tutors {\n      id\n      _id\n      tutor_validations {\n        proofs\n        proofs_state\n        proofs_reasons\n        profile_picture\n        profile_picture_state\n        profile_picture_reasons\n        location\n        location_state\n        location_reasons\n        \n      }\n      tutor_subject_levels {\n        level {\n          name\n        }\n        subject {\n          name\n        }\n        valid\n        validation_state\n        justification\n        has_report_card\n      } \n      photo\n      biography\n      experience\n      schools {\n        name\n        level\n      }\n    }\n  }\n}\n'],['\nquery User($uuid: String) {\n  user(_id: $uuid) {\n    id\n    _id\n    first_name\n    last_name\n    email\n    phone_number\n    unique_id\n    role\n    files {\n      name\n      url\n      minetype\n    }\n    tutors {\n      id\n      _id\n      tutor_validations {\n        proofs\n        proofs_state\n        proofs_reasons\n        profile_picture\n        profile_picture_state\n        profile_picture_reasons\n        location\n        location_state\n        location_reasons\n        \n      }\n      tutor_subject_levels {\n        level {\n          name\n        }\n        subject {\n          name\n        }\n        valid\n        validation_state\n        justification\n        has_report_card\n      } \n      photo\n      biography\n      experience\n      schools {\n        name\n        level\n      }\n    }\n  }\n}\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import { Link } from 'react-router-dom'
var QUERY=__WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject);var UsersDetails=function(_Component){_inherits(UsersDetails,_Component);function UsersDetails(){_classCallCheck(this,UsersDetails);return _possibleConstructorReturn(this,(UsersDetails.__proto__||Object.getPrototypeOf(UsersDetails)).apply(this,arguments));}_createClass(UsersDetails,[{key:'render',value:function render(){var _this2=this;if(!this.props.uuid)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],{query:QUERY,variables:{uuid:this.props.uuid}},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data,fetchMore=_ref.fetchMore;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Loading...');if(error){console.error(error);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Error :(');};if(!data.user)return null;console.log('NEW USER',data,_this2.props.uuid);var _data$user=data.user,id=_data$user.id,_id=_data$user._id,first_name=_data$user.first_name,last_name=_data$user.last_name,email=_data$user.email,phone_number=_data$user.phone_number,role=_data$user.role,tutors=_data$user.tutors,files=_data$user.files,unique_id=_data$user.unique_id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__styles_scss___default.a.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,first_name,' ',last_name),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,unique_id),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,email),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,phone_number),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,role),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'ID: ',id),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'UUID: ',_id),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{method:'post',action:__WEBPACK_IMPORTED_MODULE_4__configs_urls___default.a.api+'auth/loginas'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'uuid',value:_id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit'},'View user profile'))),tutors.length&&tutors[0]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Tutor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,tutors[0].biography),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,tutors[0].experience),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'ID: ',tutors[0].id),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'UUID: ',tutors[0]._id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:tutors[0].photo,className:__WEBPACK_IMPORTED_MODULE_1__styles_scss___default.a.image}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Mati\xE8res'),tutors[0].tutor_subject_levels&&tutors[0].tutor_subject_levels.map(function(_ref2,key){var level=_ref2.level,subject=_ref2.subject,valid=_ref2.valid,validation_state=_ref2.validation_state,justification=_ref2.justification;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,subject.name,' - ',level.name),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,valid?"Validated":"To validate"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,validation_state),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,justification));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Files'),files.map(function(_ref3,key){var name=_ref3.name,url=_ref3.url,minetype=_ref3.minetype;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,name,' - ',minetype),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url,target:'_blank'},url)));}))));});}}]);return UsersDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UsersDetails);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(459);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".src-containers-users-Details-tabs-___styles__container___3-3By {\n  margin: 10px 28px;\n  overflow: auto; }\n", ""]);

// exports
exports.locals = {
	"container": "src-containers-users-Details-tabs-___styles__container___3-3By"
};

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_boost__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_boost___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_apollo_boost__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs_urls__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs_urls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__configs_urls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_cache_inmemory__ = __webpack_require__(81);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_apollo_boost___default.a({cache:new __WEBPACK_IMPORTED_MODULE_3_apollo_cache_inmemory__["InMemoryCache"](),uri:__WEBPACK_IMPORTED_MODULE_2__configs_urls___default.a.api+"graphql",request:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(operation){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:operation.setContext({fetchOptions:{credentials:'include'}});case 1:case"end":return _context.stop();}}},_callee,_this);}));function request(_x){return _ref.apply(this,arguments);}return request;}()}));

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(56));
__export(__webpack_require__(12));
__export(__webpack_require__(81));
var apollo_link_1 = __webpack_require__(12);
var apollo_link_http_1 = __webpack_require__(470);
exports.HttpLink = apollo_link_http_1.HttpLink;
var apollo_link_state_1 = __webpack_require__(473);
var apollo_link_error_1 = __webpack_require__(476);
var apollo_cache_inmemory_1 = __webpack_require__(81);
exports.InMemoryCache = apollo_cache_inmemory_1.InMemoryCache;
var graphql_tag_1 = __webpack_require__(8);
exports.gql = graphql_tag_1.default;
var apollo_client_1 = __webpack_require__(56);
var PRESET_CONFIG_KEYS = [
    'request',
    'uri',
    'credentials',
    'headers',
    'fetch',
    'fetchOptions',
    'clientState',
    'onError',
    'cacheRedirects',
    'cache',
];
var DefaultClient = (function (_super) {
    __extends(DefaultClient, _super);
    function DefaultClient(config) {
        if (config === void 0) { config = {}; }
        var _this = this;
        if (config) {
            var diff = Object.keys(config).filter(function (key) { return PRESET_CONFIG_KEYS.indexOf(key) === -1; });
            if (diff.length > 0) {
                console.warn('ApolloBoost was initialized with unsupported options: ' +
                    ("" + diff.join(' ')));
            }
        }
        var request = config.request, uri = config.uri, credentials = config.credentials, headers = config.headers, fetch = config.fetch, fetchOptions = config.fetchOptions, clientState = config.clientState, cacheRedirects = config.cacheRedirects, errorCallback = config.onError;
        var cache = config.cache;
        if (cache && cacheRedirects) {
            throw new Error('Incompatible cache configuration. If providing `cache` then ' +
                'configure the provided instance with `cacheRedirects` instead.');
        }
        if (!cache) {
            cache = cacheRedirects
                ? new apollo_cache_inmemory_1.InMemoryCache({ cacheRedirects: cacheRedirects })
                : new apollo_cache_inmemory_1.InMemoryCache();
        }
        var stateLink = clientState
            ? apollo_link_state_1.withClientState(__assign({}, clientState, { cache: cache }))
            : false;
        var errorLink = errorCallback
            ? apollo_link_error_1.onError(errorCallback)
            : apollo_link_error_1.onError(function (_a) {
                var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
                if (graphQLErrors) {
                    graphQLErrors.map(function (_a) {
                        var message = _a.message, locations = _a.locations, path = _a.path;
                        return console.log("[GraphQL error]: Message: " + message + ", Location: " +
                            (locations + ", Path: " + path));
                    });
                }
                if (networkError) {
                    console.log("[Network error]: " + networkError);
                }
            });
        var requestHandler = request
            ? new apollo_link_1.ApolloLink(function (operation, forward) {
                return new apollo_link_1.Observable(function (observer) {
                    var handle;
                    Promise.resolve(operation)
                        .then(function (oper) { return request(oper); })
                        .then(function () {
                        handle = forward(operation).subscribe({
                            next: observer.next.bind(observer),
                            error: observer.error.bind(observer),
                            complete: observer.complete.bind(observer),
                        });
                    })
                        .catch(observer.error.bind(observer));
                    return function () {
                        if (handle) {
                            handle.unsubscribe();
                        }
                    };
                });
            })
            : false;
        var httpLink = new apollo_link_http_1.HttpLink({
            uri: uri || '/graphql',
            fetch: fetch,
            fetchOptions: fetchOptions || {},
            credentials: credentials || 'same-origin',
            headers: headers || {},
        });
        var link = apollo_link_1.ApolloLink.from([
            errorLink,
            requestHandler,
            stateLink,
            httpLink,
        ].filter(function (x) { return !!x; }));
        _this = _super.call(this, { cache: cache, link: link }) || this;
        return _this;
    }
    return DefaultClient;
}(apollo_client_1.default));
exports.default = DefaultClient;
//# sourceMappingURL=index.js.map

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultDataIdFromObject;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InMemoryCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_cache__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fragmentMatcher__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__writeToStore__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__readFromStore__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objectCache__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__recordingCache__ = __webpack_require__(149);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var defaultConfig = {
    fragmentMatcher: new __WEBPACK_IMPORTED_MODULE_2__fragmentMatcher__["a" /* HeuristicFragmentMatcher */](),
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    storeFactory: __WEBPACK_IMPORTED_MODULE_5__objectCache__["b" /* defaultNormalizedCacheFactory */],
};
function defaultDataIdFromObject(result) {
    if (result.__typename) {
        if (result.id !== undefined) {
            return result.__typename + ":" + result.id;
        }
        if (result._id !== undefined) {
            return result.__typename + ":" + result._id;
        }
    }
    return null;
}
var InMemoryCache = /** @class */ (function (_super) {
    __extends(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.optimistic = [];
        _this.watches = [];
        _this.typenameDocumentCache = new WeakMap();
        // Set this while in a transaction to prevent broadcasts...
        // don't forget to turn it back on!
        _this.silenceBroadcast = false;
        _this.config = __assign({}, defaultConfig, config);
        // backwards compat
        if (_this.config.customResolvers) {
            console.warn('customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.customResolvers;
        }
        if (_this.config.cacheResolvers) {
            console.warn('cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.cacheResolvers;
        }
        _this.addTypename = _this.config.addTypename;
        _this.data = _this.config.storeFactory();
        return _this;
    }
    InMemoryCache.prototype.restore = function (data) {
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        if (optimistic && this.optimistic.length > 0) {
            var patches = this.optimistic.map(function (opt) { return opt.data; });
            return Object.assign.apply(Object, [{}, this.data.toObject()].concat(patches));
        }
        return this.data.toObject();
    };
    InMemoryCache.prototype.read = function (query) {
        if (query.rootId && this.data.get(query.rootId) === undefined) {
            return null;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_4__readFromStore__["d" /* readQueryFromStore */])({
            store: this.config.storeFactory(this.extract(query.optimistic)),
            query: this.transformDocument(query.query),
            variables: query.variables,
            rootId: query.rootId,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            previousResult: query.previousResult,
            config: this.config,
        });
    };
    InMemoryCache.prototype.write = function (write) {
        Object(__WEBPACK_IMPORTED_MODULE_3__writeToStore__["d" /* writeResultToStore */])({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function (query) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__readFromStore__["c" /* diffQueryAgainstStore */])({
            store: this.config.storeFactory(this.extract(query.optimistic)),
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            config: this.config,
        });
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        this.watches.push(watch);
        return function () {
            _this.watches = _this.watches.filter(function (c) { return c !== watch; });
        };
    };
    InMemoryCache.prototype.evict = function (query) {
        throw new Error("eviction is not implemented on InMemory Cache");
    };
    InMemoryCache.prototype.reset = function () {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (id) {
        var _this = this;
        // Throw away optimistic changes of that particular mutation
        var toPerform = this.optimistic.filter(function (item) { return item.id !== id; });
        this.optimistic = [];
        // Re-run all of our optimistic data actions on top of one another.
        toPerform.forEach(function (change) {
            _this.recordOptimisticTransaction(change.transaction, change.id);
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.performTransaction = function (transaction) {
        // TODO: does this need to be different, or is this okay for an in-memory cache?
        var alreadySilenced = this.silenceBroadcast;
        this.silenceBroadcast = true;
        transaction(this);
        if (!alreadySilenced) {
            // Don't un-silence since this is a nested transaction
            // (for example, a transaction inside an optimistic record)
            this.silenceBroadcast = false;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
        var _this = this;
        this.silenceBroadcast = true;
        var patch = Object(__WEBPACK_IMPORTED_MODULE_6__recordingCache__["b" /* record */])(this.extract(true), function (recordingCache) {
            // swapping data instance on 'this' is currently necessary
            // because of the current architecture
            var dataCache = _this.data;
            _this.data = recordingCache;
            _this.performTransaction(transaction);
            _this.data = dataCache;
        });
        this.optimistic.push({
            id: id,
            transaction: transaction,
            data: patch,
        });
        this.silenceBroadcast = false;
        this.broadcastWatches();
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                this.typenameDocumentCache.set(document, (result = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["addTypenameToDocument"])(document)));
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    InMemoryCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: this.transformDocument(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getFragmentQueryDocument"])(options.fragment, options.fragmentName)),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    InMemoryCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
        });
    };
    InMemoryCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            query: this.transformDocument(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getFragmentQueryDocument"])(options.fragment, options.fragmentName)),
            variables: options.variables,
        });
    };
    InMemoryCache.prototype.broadcastWatches = function () {
        var _this = this;
        // Skip this when silenced (like inside a transaction)
        if (this.silenceBroadcast)
            return;
        // right now, we invalidate all queries whenever anything changes
        this.watches.forEach(function (c) {
            var newData = _this.diff({
                query: c.query,
                variables: c.variables,
                // TODO: previousResult isn't in the types - this will only work
                // with ObservableQuery which is in a different package
                previousResult: c.previousResult && c.previousResult(),
                optimistic: c.optimistic,
            });
            c.callback(newData);
        });
    };
    return InMemoryCache;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_cache__["a" /* ApolloCache */]));

//# sourceMappingURL=inMemoryCache.js.map

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cache__ = __webpack_require__(464);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__cache__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(466);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(465);


var ApolloCache = /** @class */ (function () {
    function ApolloCache() {
    }
    // optional API
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    // experimental
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    // DataProxy API
    /**
     *
     * @param options
     * @param optimistic
     */
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["getFragmentQueryDocument"])(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["getFragmentQueryDocument"])(options.fragment, options.fragmentName),
        });
    };
    ApolloCache.prototype.writeData = function (_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            // Since we can't use fragments without having a typename in the store,
            // we need to make sure we have one.
            // To avoid overwriting an existing typename, we need to read it out first
            // and generate a fake one if none exists.
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* justTypenameQuery */],
                });
            }
            catch (e) {
                // Do nothing, since an error just means no typename exists
            }
            // tslint:disable-next-line
            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
            // Add a type here to satisfy the inmemory cache
            var dataToWrite = Object.assign({ __typename: __typename }, data);
            this.writeFragment({
                id: id,
                fragment: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* fragmentFromPojo */])(dataToWrite, __typename),
                data: dataToWrite,
            });
        }
        else {
            this.writeQuery({ query: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* queryFromPojo */])(data), data: data });
        }
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = queryFromPojo;
/* harmony export (immutable) */ __webpack_exports__["a"] = fragmentFromPojo;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return justTypenameQuery; });
function queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [op],
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType',
            },
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [frag],
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === 'number' ||
        typeof obj === 'boolean' ||
        typeof obj === 'string' ||
        typeof obj === 'undefined' ||
        obj === null) {
        // No selection set here
        return null;
    }
    if (Array.isArray(obj)) {
        // GraphQL queries don't include arrays
        return selectionSetFromObj(obj[0]);
    }
    // Now we know it's an object
    var selections = [];
    Object.keys(obj).forEach(function (key) {
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key,
            },
        };
        // Recurse
        var nestedSelSet = selectionSetFromObj(obj[key]);
        if (nestedSelSet) {
            field.selectionSet = nestedSelSet;
        }
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections,
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename',
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null,
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cache__ = __webpack_require__(467);
/* unused harmony namespace reexport */

//# sourceMappingURL=index.js.map

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cache */
var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(469);
/* unused harmony reexport filter */
/* unused harmony reexport check */
/* unused harmony reexport propType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql__ = __webpack_require__(148);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* graphql */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filter */
/* unused harmony export check */
/* unused harmony export propType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(148);

function filter(doc, data) {
    var resolver = function (fieldName, root, args, context, info) {
        return root[info.resultKey];
    };
    return Array.isArray(data)
        ? data.map(function (dataObj) { return Object(__WEBPACK_IMPORTED_MODULE_0__graphql__["a" /* graphql */])(resolver, doc, dataObj); })
        : Object(__WEBPACK_IMPORTED_MODULE_0__graphql__["a" /* graphql */])(resolver, doc, data);
}
// TODO: we should probably make check call propType and then throw,
// rather than the other way round, to avoid constructing stack traces
// for things like oneOf uses in React. At this stage I doubt many people
// are using this like that, but in the future, who knows?
function check(doc, data) {
    var resolver = function (fieldName, root, args, context, info) {
        if (!{}.hasOwnProperty.call(root, info.resultKey)) {
            throw new Error(info.resultKey + " missing on " + JSON.stringify(root));
        }
        return root[info.resultKey];
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__graphql__["a" /* graphql */])(resolver, doc, data, {}, {}, {
        fragmentMatcher: function () { return false; },
    });
}
// Lifted/adapted from
//   https://github.com/facebook/react/blob/master/src/isomorphic/classic/types/ReactPropTypes.js
var ANONYMOUS = '<<anonymous>>';
function PropTypeError(message) {
    this.message = message;
    this.stack = '';
}
// Make `instanceof Error` still work for returned errors.
PropTypeError.prototype = Error.prototype;
var reactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context',
};
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (props[propName] == null) {
            var locationName = reactPropTypeLocationNames[location];
            if (isRequired) {
                if (props[propName] === null) {
                    return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required " +
                        ("in `" + componentName + "`, but its value is `null`."));
                }
                return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required in " +
                    ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
        }
        else {
            return validate(props, propName, componentName, location, propFullName);
        }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
function propType(doc) {
    return createChainableTypeChecker(function (props, propName) {
        var prop = props[propName];
        try {
            if (!prop.loading) {
                check(doc, prop);
            }
            return null;
        }
        catch (e) {
            // Need a much better error.
            // Also we aren't checking for extra fields
            return e;
        }
    });
}
//# sourceMappingURL=utilities.js.map

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpLink__ = __webpack_require__(471);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createHttpLink", function() { return __WEBPACK_IMPORTED_MODULE_0__httpLink__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "HttpLink", function() { return __WEBPACK_IMPORTED_MODULE_0__httpLink__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHttpLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__ = __webpack_require__(472);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, 
    // use default global fetch is nothing passed in
    fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = __rest(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
    // dev warnings to ensure fetch is present
    Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["a" /* checkFetcher */])(fetcher);
    //fetcher is set here rather than the destructuring to ensure fetch is
    //declared before referencing it. Reference in the destructuring would cause
    //a ReferenceError
    if (!fetcher) {
        fetcher = fetch;
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"](function (operation) {
        var chosenURI = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["f" /* selectURI */])(operation, uri);
        var context = operation.getContext();
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: context.headers,
        };
        //uses fallback, link, and then context to build options
        var _a = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["e" /* selectHttpOptionsAndBody */])(operation, __WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["c" /* fallbackHttpConfig */], linkConfig, contextConfig), options = _a.options, body = _a.body;
        var controller;
        if (!options.signal) {
            var _b = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["b" /* createSignalIfSupported */])(), _controller = _b.controller, signal = _b.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (options.method === 'GET') {
            var _c = rewriteURIForGET(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["fromError"])(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["g" /* serializeFetchParameter */])(body, 'Payload');
            }
            catch (parseError) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["fromError"])(parseError);
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"](function (observer) {
            fetcher(chosenURI, options)
                .then(function (response) {
                operation.setContext({ response: response });
                return response;
            })
                .then(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["d" /* parseAndCheckHttpResponse */])(operation))
                .then(function (result) {
                // we have data and can send it to back up the link chain
                observer.next(result);
                observer.complete();
                return result;
            })
                .catch(function (err) {
                // fetch was cancelled so its already been cleaned up in the unsubscribe
                if (err.name === 'AbortError')
                    return;
                // if it is a network error, BUT there is graphql result info
                // fire the next observer before calling error
                // this gives apollo-client (and react-apollo) the `graphqlErrors` and `networErrors`
                // to pass to UI
                // this should only happen if we *also* have data as part of the response key per
                // the spec
                if (err.result && err.result.errors && err.result.data) {
                    // if we dont' call next, the UI can only show networkError because AC didn't
                    // get andy graphqlErrors
                    // this is graphql execution result info (i.e errors and possibly data)
                    // this is because there is no formal spec how errors should translate to
                    // http status codes. So an auth error (401) could have both data
                    // from a public field, errors from a private field, and a status of 401
                    // {
                    //  user { // this will have errors
                    //    firstName
                    //  }
                    //  products { // this is public so will have data
                    //    cost
                    //  }
                    // }
                    //
                    // the result of above *could* look like this:
                    // {
                    //   data: { products: [{ cost: "$10" }] },
                    //   errors: [{
                    //      message: 'your session has timed out',
                    //      path: []
                    //   }]
                    // }
                    // status code of above would be a 401
                    // in the UI you want to show data where you can, errors as data where you can
                    // and use correct http status codes
                    observer.next(err.result);
                }
                observer.error(err);
            });
            return function () {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller)
                    controller.abort();
            };
        });
    });
};
// For GET operations, returns the given URI rewritten with parameters, or a
// parse error.
function rewriteURIForGET(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["g" /* serializeFetchParameter */])(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["g" /* serializeFetchParameter */])(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
var HttpLink = /** @class */ (function (_super) {
    __extends(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, createHttpLink(opts).request) || this;
    }
    return HttpLink;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"]));

//# sourceMappingURL=httpLink.js.map

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fallbackHttpConfig; });
/* unused harmony export throwServerError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseAndCheckHttpResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkFetcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createSignalIfSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectHttpOptionsAndBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return serializeFetchParameter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectURI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(21);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//TODO: when conditional types come in ts 2.8, operations should be a generic type that extends Operation | Array<Operation>
var parseAndCheckHttpResponse = function (operations) { return function (response) {
    return (response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            return Promise.reject(parseError);
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            //Network error
            throwServerError(response, result, "Response not successful: Received status code " + response.status);
        }
        //TODO should really error per response in a Batch based on properties
        //    - could be done in a validation link
        if (!Array.isArray(result) &&
            !result.hasOwnProperty('data') &&
            !result.hasOwnProperty('errors')) {
            //Data error
            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }));
}; };
var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined')
            library = 'node-fetch';
        throw new Error("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
    }
};
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = __assign({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http;
    /*
     * use the rest of the configs to populate the options
     * configs later in the list will overwrite earlier fields
     */
    configs.forEach(function (config) {
        options = __assign({}, options, config.options, { headers: __assign({}, options.headers, config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = __assign({}, http, config.http);
    });
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery)
        body.query = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(query);
    return {
        options: options,
        body: body,
    };
};
var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = new Error("Network request failed. " + label + " is not serializable: " + e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//selects "/graphql" by default
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withClientState", function() { return withClientState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_anywhere_lib_async__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_anywhere_lib_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_anywhere_lib_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(475);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var capitalizeFirstLetter = function (str) { return str.charAt(0).toUpperCase() + str.slice(1); };
var withClientState = function (clientStateConfig) {
    if (clientStateConfig === void 0) { clientStateConfig = { resolvers: {}, defaults: {} }; }
    var resolvers = clientStateConfig.resolvers, defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs;
    if (cache && defaults) {
        cache.writeData({ data: defaults });
    }
    return new (function (_super) {
        __extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function () {
            if (cache && defaults) {
                cache.writeData({ data: defaults });
            }
        };
        StateLink.prototype.request = function (operation, forward) {
            if (forward === void 0) { forward = function () { return __WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"].of({ data: {} }); }; }
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = typeof typeDefs === 'string'
                    ? typeDefs
                    : typeDefs.map(function (typeDef) { return typeDef.trim(); }).join('\n');
                operation.setContext(function (_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return ({
                        schemas: schemas.concat([{ definition: definition_1, directives: directives_1 }]),
                    });
                });
            }
            var isClient = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["hasDirectives"])(['client'], operation.query);
            if (!isClient)
                return forward(operation);
            var server = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* removeClientSetsFromDocument */])(operation.query);
            var query = operation.query;
            var type = capitalizeFirstLetter((Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["getMainDefinition"])(query) || {}).operation) || 'Query';
            var resolver = function (fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) { rootValue = {}; }
                var fieldValue = rootValue[info.resultKey];
                if (fieldValue !== undefined)
                    return fieldValue;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve)
                        return resolve(rootValue, args, context, info);
                }
                return defaults[fieldName];
            };
            return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"](function (observer) {
                if (server)
                    operation.query = server;
                var obs = server && forward
                    ? forward(operation)
                    : __WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"].of({
                        data: {},
                    });
                var observerErrorHandler = observer.error.bind(observer);
                var sub = obs.subscribe({
                    next: function (_a) {
                        var data = _a.data, errors = _a.errors;
                        var context = operation.getContext();
                        Object(__WEBPACK_IMPORTED_MODULE_2_graphql_anywhere_lib_async__["graphql"])(resolver, query, data, context, operation.variables)
                            .then(function (nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors,
                            });
                            observer.complete();
                        })
                            .catch(observerErrorHandler);
                    },
                    error: observerErrorHandler,
                });
                return function () {
                    if (sub)
                        sub.unsubscribe();
                };
            });
        };
        return StateLink;
    }(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"]))();
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports, __webpack_require__(4)) :
    typeof define === 'function' && define.amd ? define(['exports', 'apollo-utilities'], factory) :
    (factory((global.graphqlAnywhereAsync = {}),global.apollo.utilities));
}(this, (function (exports,apolloUtilities) { 'use strict';

    var hasOwn = Object.prototype.hasOwnProperty;
    function merge(dest, src) {
        if (src !== null && typeof src === 'object') {
            Object.keys(src).forEach(function (key) {
                var srcVal = src[key];
                if (!hasOwn.call(dest, key)) {
                    dest[key] = srcVal;
                }
                else {
                    merge(dest[key], srcVal);
                }
            });
        }
    }

    var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
    /* Based on graphql function from graphql-js:
     *
     * graphql(
     *   schema: GraphQLSchema,
     *   requestString: string,
     *   rootValue?: ?any,
     *   contextValue?: ?any,
     *   variableValues?: ?{[key: string]: any},
     *   operationName?: ?string
     * ): Promise<GraphQLResult>
     *
     * The default export as of graphql-anywhere is sync as of 4.0,
     * but below is an exported alternative that is async.
     * In the 5.0 version, this will be the only export again
     * and it will be async
     *
     */
    function graphql$1(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (execOptions === void 0) { execOptions = {}; }
        var mainDefinition = apolloUtilities.getMainDefinition(document);
        var fragments = apolloUtilities.getFragmentDefinitions(document);
        var fragmentMap = apolloUtilities.createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        // Default matcher always matches all fragments
        var fragmentMatcher = execOptions.fragmentMatcher || (function () { return true; });
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher,
        };
        return executeSelectionSet$1(mainDefinition.selectionSet, rootValue, execContext);
    }
    function executeSelectionSet$1(selectionSet, rootValue, execContext) {
        return __awaiter(this, void 0, void 0, function () {
            var fragmentMap, contextValue, variables, result, execute;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                        result = {};
                        execute = function (selection) { return __awaiter(_this, void 0, void 0, function () {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!apolloUtilities.shouldInclude(selection, variables)) {
                                            // Skip this entirely
                                            return [2 /*return*/];
                                        }
                                        if (!apolloUtilities.isField(selection)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, executeField$1(selection, rootValue, execContext)];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = apolloUtilities.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) {
                                                result[resultFieldKey] = fieldResult;
                                            }
                                            else {
                                                merge(result[resultFieldKey], fieldResult);
                                            }
                                        }
                                        return [2 /*return*/];
                                    case 2:
                                        if (apolloUtilities.isInlineFragment(selection)) {
                                            fragment = selection;
                                        }
                                        else {
                                            // This is a named fragment
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) {
                                                throw new Error("No fragment named " + selection.name.value);
                                            }
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [3 /*break*/, 4];
                                        return [4 /*yield*/, executeSelectionSet$1(fragment.selectionSet, rootValue, execContext)];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); };
                        return [4 /*yield*/, Promise.all(selectionSet.selections.map(execute))];
                    case 1:
                        _a.sent();
                        if (execContext.resultMapper) {
                            return [2 /*return*/, execContext.resultMapper(result, rootValue)];
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    }
    function executeField$1(field, rootValue, execContext) {
        return __awaiter(this, void 0, void 0, function () {
            var variables, contextValue, resolver, fieldName, args, info, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                        fieldName = field.name.value;
                        args = apolloUtilities.argumentsObjectFromField(field, variables);
                        info = {
                            isLeaf: !field.selectionSet,
                            resultKey: apolloUtilities.resultKeyNameFromField(field),
                            directives: apolloUtilities.getDirectiveInfoFromField(field, variables),
                        };
                        return [4 /*yield*/, resolver(fieldName, rootValue, args, contextValue, info)];
                    case 1:
                        result = _a.sent();
                        // Handle all scalar types here
                        if (!field.selectionSet) {
                            return [2 /*return*/, result];
                        }
                        // From here down, the field has a selection set, which means it's trying to
                        // query a GraphQLObjectType
                        if (result == null) {
                            // Basically any field in a GraphQL response can be null, or missing
                            return [2 /*return*/, result];
                        }
                        if (Array.isArray(result)) {
                            return [2 /*return*/, executeSubSelectedArray$1(field, result, execContext)];
                        }
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        return [2 /*return*/, executeSelectionSet$1(field.selectionSet, result, execContext)];
                }
            });
        });
    }
    function executeSubSelectedArray$1(field, result, execContext) {
        return Promise.all(result.map(function (item) {
            // null value in array
            if (item === null) {
                return null;
            }
            // This is a nested array, recurse
            if (Array.isArray(item)) {
                return executeSubSelectedArray$1(field, item, execContext);
            }
            // This is an object, run the selection set on it
            return executeSelectionSet$1(field.selectionSet, item, execContext);
        }));
    }

    exports.graphql = graphql$1;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=async.js.map


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeClientSetsFromDocument;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(4);

var connectionRemoveConfig = {
    test: function (directive) { return directive.name.value === 'client'; },
    remove: true,
};
var removed = new Map();
function removeClientSetsFromDocument(query) {
    var cached = removed.get(query);
    if (cached)
        return cached;
    Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["checkDocument"])(query);
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["removeDirectivesFromDocument"])([connectionRemoveConfig], query);
    removed.set(query, docClone);
    return docClone;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onError", function() { return onError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorLink", function() { return ErrorLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var onError = function (errorHandler) {
    return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"](function (operation, forward) {
        return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"](function (observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function (result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward,
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer),
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function (networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            //Network errors can return GraphQL errors on for example a 403
                            graphQLErrors: networkError.result && networkError.result.errors,
                            forward: forward,
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer),
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function () {
                        // disable the previous sub from calling complete on observable
                        // if retry is in flight.
                        if (!retriedResult) {
                            observer.complete.bind(observer)();
                        }
                    },
                });
            }
            catch (e) {
                errorHandler({ networkError: e, operation: operation, forward: forward });
                observer.error(e);
            }
            return function () {
                if (sub)
                    sub.unsubscribe();
                if (retriedSub)
                    sub.unsubscribe();
            };
        });
    });
};
var ErrorLink = /** @class */ (function (_super) {
    __extends(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = onError(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function (operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.2d7e5bfd.js